import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  Date: { input: any; output: any; }
  DateTime: { input: any; output: any; }
  JSON: { input: any; output: any; }
  Long: { input: any; output: any; }
};

export type ActivateClipInput = {
  action: Scalars['String']['input'];
  aspect_ratio_format?: InputMaybe<Scalars['String']['input']>;
  brand_kit_id?: InputMaybe<Scalars['ID']['input']>;
  preset?: InputMaybe<Scalars['String']['input']>;
};

export type AdminActiveCoupon = {
  __typename?: 'AdminActiveCoupon';
  code: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  month_cycles?: Maybe<Scalars['Int']['output']>;
  month_discount?: Maybe<Scalars['Int']['output']>;
  type: Scalars['String']['output'];
  year_cycles?: Maybe<Scalars['Int']['output']>;
  year_discount?: Maybe<Scalars['Int']['output']>;
};

export type AdminAddToLibraryInput = {
  format: Scalars['String']['input'];
  language: Scalars['String']['input'];
  prompt: Scalars['String']['input'];
  videos: Array<AdminLibraryVideoInput>;
};

export type AdminAffiliateBlockResult = {
  __typename?: 'AdminAffiliateBlockResult';
  affiliate_blocked: Scalars['Boolean']['output'];
  affiliate_blocked_at?: Maybe<Scalars['String']['output']>;
  affiliate_blocked_reason?: Maybe<Scalars['String']['output']>;
  forfeited_cents: Scalars['Int']['output'];
  forfeited_earnings: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
};

export type AdminAffiliateEarning = {
  __typename?: 'AdminAffiliateEarning';
  amount_cents: Scalars['Int']['output'];
  commission_rate: Scalars['Int']['output'];
  course_id?: Maybe<Scalars['ID']['output']>;
  course_title?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  kind: Scalars['String']['output'];
  payment_amount_cents: Scalars['Int']['output'];
  payment_date?: Maybe<Scalars['String']['output']>;
  payment_provider?: Maybe<Scalars['String']['output']>;
  referred_user_email?: Maybe<Scalars['String']['output']>;
  referred_user_name?: Maybe<Scalars['String']['output']>;
  reversal_note?: Maybe<Scalars['String']['output']>;
  source: Scalars['String']['output'];
  status: Scalars['String']['output'];
  user_email?: Maybe<Scalars['String']['output']>;
  user_id: Scalars['ID']['output'];
  user_name?: Maybe<Scalars['String']['output']>;
};

export type AdminAffiliateEarningsResponse = {
  __typename?: 'AdminAffiliateEarningsResponse';
  data: Array<AdminAffiliateEarning>;
  total: Scalars['Int']['output'];
};

export type AdminAffiliateRatesInput = {
  affiliate_rate_course?: InputMaybe<Scalars['Int']['input']>;
  affiliate_rate_cpm?: InputMaybe<Scalars['Int']['input']>;
  affiliate_rate_note?: InputMaybe<Scalars['String']['input']>;
  affiliate_rate_payment?: InputMaybe<Scalars['Int']['input']>;
};

export type AdminAffiliateRatesResult = {
  __typename?: 'AdminAffiliateRatesResult';
  affiliate_rate_course?: Maybe<Scalars['Int']['output']>;
  affiliate_rate_cpm?: Maybe<Scalars['Int']['output']>;
  affiliate_rate_note?: Maybe<Scalars['String']['output']>;
  affiliate_rate_payment?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
};

export type AdminBotChatConversation = {
  __typename?: 'AdminBotChatConversation';
  channel: Scalars['String']['output'];
  channel_user_id: Scalars['String']['output'];
  error_count?: Maybe<Scalars['Int']['output']>;
  first_seen_at?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  last_seen_at?: Maybe<Scalars['String']['output']>;
  memory_summary?: Maybe<Scalars['String']['output']>;
  memory_updated_at?: Maybe<Scalars['String']['output']>;
  message_count?: Maybe<Scalars['Int']['output']>;
  user?: Maybe<AdminBotChatConversationUser>;
};

export type AdminBotChatConversationUser = {
  __typename?: 'AdminBotChatConversationUser';
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  phone_number?: Maybe<Scalars['String']['output']>;
};

export type AdminBotChatConversationsResponse = {
  __typename?: 'AdminBotChatConversationsResponse';
  data: Array<AdminBotChatConversation>;
  page: Scalars['Int']['output'];
  pageCount: Scalars['Int']['output'];
  pageSize: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type AdminBotChatMessage = {
  __typename?: 'AdminBotChatMessage';
  createdAt: Scalars['String']['output'];
  current_flow?: Maybe<Scalars['String']['output']>;
  direction: Scalars['String']['output'];
  error?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  intent_kind?: Maybe<Scalars['String']['output']>;
  intent_source?: Maybe<Scalars['String']['output']>;
  llm_model?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
};

export type AdminBotChatMessagesResponse = {
  __typename?: 'AdminBotChatMessagesResponse';
  data: Array<AdminBotChatMessage>;
  page: Scalars['Int']['output'];
  pageCount: Scalars['Int']['output'];
  pageSize: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type AdminBrandLead = {
  __typename?: 'AdminBrandLead';
  budget: Scalars['String']['output'];
  company?: Maybe<Scalars['String']['output']>;
  contentType?: Maybe<Scalars['JSON']['output']>;
  createdAt: Scalars['String']['output'];
  demandType?: Maybe<Scalars['String']['output']>;
  documentId: Scalars['String']['output'];
  email: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  objective?: Maybe<Scalars['String']['output']>;
  phone: Scalars['String']['output'];
  phoneE164?: Maybe<Scalars['String']['output']>;
  platforms?: Maybe<Scalars['String']['output']>;
  social?: Maybe<Scalars['String']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['String']['output'];
  utm?: Maybe<Scalars['JSON']['output']>;
  website?: Maybe<Scalars['String']['output']>;
};

export type AdminBrandLeadOriginCounts = {
  __typename?: 'AdminBrandLeadOriginCounts';
  app: Scalars['Int']['output'];
  marcas: Scalars['Int']['output'];
  other: Scalars['Int']['output'];
  site: Scalars['Int']['output'];
};

export type AdminBrandLeadSubmission = {
  __typename?: 'AdminBrandLeadSubmission';
  documentId: Scalars['ID']['output'];
  isDuplicate: Scalars['Boolean']['output'];
  lead: AdminBrandLead;
  submittedAt: Scalars['String']['output'];
};

export type AdminBrandLeadSubmissionsResponse = {
  __typename?: 'AdminBrandLeadSubmissionsResponse';
  data: Array<AdminBrandLeadSubmission>;
  originCounts: AdminBrandLeadOriginCounts;
  page: Scalars['Int']['output'];
  pageCount: Scalars['Int']['output'];
  pageSize: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type AdminBrandLeadsResponse = {
  __typename?: 'AdminBrandLeadsResponse';
  data: Array<AdminBrandLead>;
  page: Scalars['Int']['output'];
  pageCount: Scalars['Int']['output'];
  pageSize: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type AdminBulkReviewResult = {
  __typename?: 'AdminBulkReviewResult';
  approved: Scalars['Int']['output'];
  skipped: Array<AdminBulkReviewSkip>;
};

export type AdminBulkReviewSkip = {
  __typename?: 'AdminBulkReviewSkip';
  code: Scalars['String']['output'];
  id: Scalars['ID']['output'];
};

export type AdminCampaignLiveImport = {
  __typename?: 'AdminCampaignLiveImport';
  campaign_id: Scalars['ID']['output'];
  channel_id?: Maybe<Scalars['String']['output']>;
  channel_name?: Maybe<Scalars['String']['output']>;
  channel_thumbnail?: Maybe<Scalars['String']['output']>;
  enabled: Scalars['Boolean']['output'];
  enabled_at?: Maybe<Scalars['String']['output']>;
  format: Scalars['String']['output'];
  items: Array<AdminCampaignLiveImportItem>;
  keywords: Array<Scalars['String']['output']>;
  language: Scalars['String']['output'];
  last_checked_at?: Maybe<Scalars['String']['output']>;
  last_error?: Maybe<Scalars['String']['output']>;
  next_check_at?: Maybe<Scalars['String']['output']>;
  notify_participants: Scalars['Boolean']['output'];
  prompt?: Maybe<Scalars['String']['output']>;
};

export type AdminCampaignLiveImportInput = {
  channel?: InputMaybe<Scalars['String']['input']>;
  enabled: Scalars['Boolean']['input'];
  format?: InputMaybe<Scalars['String']['input']>;
  keywords: Array<Scalars['String']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
  notify_participants?: InputMaybe<Scalars['Boolean']['input']>;
  prompt?: InputMaybe<Scalars['String']['input']>;
};

export type AdminCampaignLiveImportItem = {
  __typename?: 'AdminCampaignLiveImportItem';
  aired_at?: Maybe<Scalars['String']['output']>;
  email_recipients?: Maybe<Scalars['Int']['output']>;
  email_sent_at?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  status: Scalars['String']['output'];
  title?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['String']['output']>;
  video_id: Scalars['String']['output'];
};

export type AdminChallenge = {
  __typename?: 'AdminChallenge';
  caption_examples?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  end_date?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  is_accepting_participants?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  participants?: Maybe<Array<AdminChallengeParticipant>>;
  prize_data?: Maybe<Scalars['String']['output']>;
  prize_pool: Scalars['Float']['output'];
  rankings?: Maybe<Array<AdminChallengeRanking>>;
  required_hashtags?: Maybe<Scalars['String']['output']>;
  rules_allowed?: Maybe<Scalars['String']['output']>;
  rules_attention?: Maybe<Scalars['String']['output']>;
  rules_forbidden?: Maybe<Scalars['String']['output']>;
  start_date?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['String']['output'];
  warning_message?: Maybe<Scalars['String']['output']>;
};

export type AdminChallengeApplication = {
  __typename?: 'AdminChallengeApplication';
  city: Scalars['String']['output'];
  clip_experience_duration?: Maybe<Scalars['String']['output']>;
  competition_experience: Scalars['String']['output'];
  content_creation_experience: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  editing_device: Scalars['String']['output'];
  email?: Maybe<Scalars['String']['output']>;
  full_name: Scalars['String']['output'];
  has_clip_channel: Scalars['String']['output'];
  has_monetized_channel: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  motivation: Scalars['String']['output'];
  state: Scalars['String']['output'];
  utm_campaign?: Maybe<Scalars['String']['output']>;
  utm_content?: Maybe<Scalars['String']['output']>;
  utm_medium?: Maybe<Scalars['String']['output']>;
  utm_source?: Maybe<Scalars['String']['output']>;
  utm_term?: Maybe<Scalars['String']['output']>;
  whatsapp: Scalars['String']['output'];
};

export type AdminChallengeApplicationsResponse = {
  __typename?: 'AdminChallengeApplicationsResponse';
  data: Array<AdminChallengeApplication>;
  page: Scalars['Int']['output'];
  pageCount: Scalars['Int']['output'];
  pageSize: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type AdminChallengeClip = {
  __typename?: 'AdminChallengeClip';
  admin_approval: Scalars['String']['output'];
  approval_reason?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  platform: Scalars['String']['output'];
  total_views?: Maybe<Scalars['String']['output']>;
  url: Scalars['String']['output'];
  validated_hashtags: Scalars['String']['output'];
};

export type AdminChallengeClipDetail = {
  __typename?: 'AdminChallengeClipDetail';
  admin_approval: Scalars['String']['output'];
  approval_reason?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  participant_id: Scalars['ID']['output'];
  participant_user_email?: Maybe<Scalars['String']['output']>;
  participant_user_name?: Maybe<Scalars['String']['output']>;
  platform: Scalars['String']['output'];
  total_views?: Maybe<Scalars['String']['output']>;
  url: Scalars['String']['output'];
  validated_hashtags: Scalars['String']['output'];
};

export type AdminChallengeClipsResponse = {
  __typename?: 'AdminChallengeClipsResponse';
  data: Array<AdminChallengeClipDetail>;
  page: Scalars['Int']['output'];
  pageCount: Scalars['Int']['output'];
  pageSize: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type AdminChallengeCreateInput = {
  caption_examples?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  is_accepting_participants?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  prize_data?: InputMaybe<Scalars['String']['input']>;
  prize_pool: Scalars['Float']['input'];
  required_hashtags?: InputMaybe<Scalars['String']['input']>;
  rules_allowed?: InputMaybe<Scalars['String']['input']>;
  rules_attention?: InputMaybe<Scalars['String']['input']>;
  rules_forbidden?: InputMaybe<Scalars['String']['input']>;
  warning_message?: InputMaybe<Scalars['String']['input']>;
};

export type AdminChallengeParticipant = {
  __typename?: 'AdminChallengeParticipant';
  challenge_clips?: Maybe<Array<AdminChallengeClip>>;
  clip_count?: Maybe<Scalars['Int']['output']>;
  createdAt: Scalars['String']['output'];
  disqualification_reason?: Maybe<Scalars['String']['output']>;
  disqualified?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  subscription?: Maybe<AdminSubscription>;
  total_views?: Maybe<Scalars['String']['output']>;
  user_email?: Maybe<Scalars['String']['output']>;
  user_id?: Maybe<Scalars['ID']['output']>;
  user_name?: Maybe<Scalars['String']['output']>;
  was_created?: Maybe<Scalars['Boolean']['output']>;
};

export type AdminChallengeRanking = {
  __typename?: 'AdminChallengeRanking';
  admin_validated: Scalars['Boolean']['output'];
  consolidated_at?: Maybe<Scalars['String']['output']>;
  end_date?: Maybe<Scalars['String']['output']>;
  end_snapshotted_at?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  is_consolidated: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  partial_ranking?: Maybe<Array<ChallengeRankingEntry>>;
  ranking_data?: Maybe<Scalars['JSON']['output']>;
  start_date?: Maybe<Scalars['String']['output']>;
  start_snapshotted_at?: Maybe<Scalars['String']['output']>;
  time_until_end_seconds?: Maybe<Scalars['Int']['output']>;
  time_until_start_seconds?: Maybe<Scalars['Int']['output']>;
  timezone: Scalars['String']['output'];
};

export type AdminChallengeRankingCreateInput = {
  name: Scalars['String']['input'];
  timezone?: InputMaybe<Scalars['String']['input']>;
};

export type AdminChallengeRankingUpdateInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
};

export type AdminChallengeUpdateInput = {
  caption_examples?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  is_accepting_participants?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  prize_data?: InputMaybe<Scalars['String']['input']>;
  prize_pool?: InputMaybe<Scalars['Float']['input']>;
  required_hashtags?: InputMaybe<Scalars['String']['input']>;
  rules_allowed?: InputMaybe<Scalars['String']['input']>;
  rules_attention?: InputMaybe<Scalars['String']['input']>;
  rules_forbidden?: InputMaybe<Scalars['String']['input']>;
  warning_message?: InputMaybe<Scalars['String']['input']>;
};

export type AdminChallengesResponse = {
  __typename?: 'AdminChallengesResponse';
  data: Array<AdminChallenge>;
  page: Scalars['Int']['output'];
  pageCount: Scalars['Int']['output'];
  pageSize: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type AdminClip = {
  __typename?: 'AdminClip';
  clipped_video_url?: Maybe<Scalars['String']['output']>;
  clipping_status?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['String']['output'];
  created_by_user?: Maybe<AdminUserBasic>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  duration_seconds?: Maybe<Scalars['Float']['output']>;
  finished_video_url?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  preparing_status?: Maybe<Scalars['String']['output']>;
  project?: Maybe<AdminProjectBasic>;
  rendering_status?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['String']['output'];
  watermark?: Maybe<Scalars['Boolean']['output']>;
};

export type AdminClipsResponse = {
  __typename?: 'AdminClipsResponse';
  data: Array<AdminClip>;
  page: Scalars['Int']['output'];
  pageCount: Scalars['Int']['output'];
  pageSize: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type AdminCommunityCurationCurator = {
  __typename?: 'AdminCommunityCurationCurator';
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type AdminCommunityCurationNiche = {
  __typename?: 'AdminCommunityCurationNiche';
  created_at?: Maybe<Scalars['String']['output']>;
  daily_limit: Scalars['Int']['output'];
  enabled: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  keywords: Array<Scalars['String']['output']>;
  lookback_hours: Scalars['Int']['output'];
  max_duration_minutes: Scalars['Int']['output'];
  min_duration_minutes: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  region: Scalars['String']['output'];
  seed_channels: Array<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['String']['output']>;
};

export type AdminCommunityCurationNicheInput = {
  dailyLimit?: InputMaybe<Scalars['Int']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  lookbackHours?: InputMaybe<Scalars['Int']['input']>;
  maxDurationMinutes?: InputMaybe<Scalars['Int']['input']>;
  minDurationMinutes?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
  seedChannels?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type AdminCommunityCurationNicheResult = {
  __typename?: 'AdminCommunityCurationNicheResult';
  added: Scalars['Int']['output'];
  candidates: Scalars['Int']['output'];
  errors: Array<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  niche_id: Scalars['ID']['output'];
  note?: Maybe<Scalars['String']['output']>;
  searches: Scalars['Int']['output'];
};

export type AdminCommunityCurationPick = {
  __typename?: 'AdminCommunityCurationPick';
  channel_title?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  library?: Maybe<AdminCommunityCurationPickLibrary>;
  niche?: Maybe<AdminCommunityCurationPickNiche>;
  published_at?: Maybe<Scalars['String']['output']>;
  reason?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  title?: Maybe<Scalars['String']['output']>;
  velocity?: Maybe<Scalars['Float']['output']>;
  video_id: Scalars['String']['output'];
  view_count?: Maybe<Scalars['Float']['output']>;
};

export type AdminCommunityCurationPickLibrary = {
  __typename?: 'AdminCommunityCurationPickLibrary';
  curation_status?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
};

export type AdminCommunityCurationPickNiche = {
  __typename?: 'AdminCommunityCurationPickNiche';
  id?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type AdminCommunityCurationPicksResponse = {
  __typename?: 'AdminCommunityCurationPicksResponse';
  data: Array<AdminCommunityCurationPick>;
  total: Scalars['Int']['output'];
};

export type AdminCommunityCurationRun = {
  __typename?: 'AdminCommunityCurationRun';
  added_count: Scalars['Int']['output'];
  budget_units?: Maybe<Scalars['Int']['output']>;
  candidates_count: Scalars['Int']['output'];
  dry_run: Scalars['Boolean']['output'];
  error?: Maybe<Scalars['String']['output']>;
  estimated_units?: Maybe<Scalars['Int']['output']>;
  failed_count: Scalars['Int']['output'];
  finished_at?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  niche_results: Array<AdminCommunityCurationNicheResult>;
  skipped_count: Scalars['Int']['output'];
  started_at?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  trigger: Scalars['String']['output'];
  youtube_units_used: Scalars['Int']['output'];
};

export type AdminCommunityCurationRunsResponse = {
  __typename?: 'AdminCommunityCurationRunsResponse';
  data: Array<AdminCommunityCurationRun>;
  total: Scalars['Int']['output'];
};

export type AdminCommunityCurationSettings = {
  __typename?: 'AdminCommunityCurationSettings';
  added_today: Scalars['Int']['output'];
  curator?: Maybe<AdminCommunityCurationCurator>;
  enabled: Scalars['Boolean']['output'];
  estimated_units_per_run: Scalars['Int']['output'];
  global_daily_cap: Scalars['Int']['output'];
  youtube_quota_budget: Scalars['Int']['output'];
};

export type AdminCommunityCurationSettingsInput = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  globalDailyCap?: InputMaybe<Scalars['Int']['input']>;
  youtubeQuotaBudget?: InputMaybe<Scalars['Int']['input']>;
};

export type AdminCoupon = {
  __typename?: 'AdminCoupon';
  assigned_user?: Maybe<AdminCouponAssignedUser>;
  code: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  documentId: Scalars['String']['output'];
  expiry_date?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  month_cycles: Scalars['Int']['output'];
  month_discount?: Maybe<Scalars['Int']['output']>;
  quantity: Scalars['Int']['output'];
  type: Scalars['String']['output'];
  updatedAt: Scalars['String']['output'];
  year_cycles?: Maybe<Scalars['Int']['output']>;
  year_discount?: Maybe<Scalars['Int']['output']>;
};

export type AdminCouponAssignedUser = {
  __typename?: 'AdminCouponAssignedUser';
  email: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type AdminCouponCreateInput = {
  assignedUserId?: InputMaybe<Scalars['ID']['input']>;
  code: Scalars['String']['input'];
  expiry_date?: InputMaybe<Scalars['String']['input']>;
  month_cycles: Scalars['Int']['input'];
  month_discount?: InputMaybe<Scalars['Int']['input']>;
  quantity: Scalars['Int']['input'];
  type: Scalars['String']['input'];
  year_cycles?: InputMaybe<Scalars['Int']['input']>;
  year_discount?: InputMaybe<Scalars['Int']['input']>;
};

export type AdminCouponUpdateInput = {
  assignedUserId?: InputMaybe<Scalars['ID']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  expiry_date?: InputMaybe<Scalars['String']['input']>;
  month_cycles?: InputMaybe<Scalars['Int']['input']>;
  month_discount?: InputMaybe<Scalars['Int']['input']>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  year_cycles?: InputMaybe<Scalars['Int']['input']>;
  year_discount?: InputMaybe<Scalars['Int']['input']>;
};

export type AdminCouponsResponse = {
  __typename?: 'AdminCouponsResponse';
  data: Array<AdminCoupon>;
  page: Scalars['Int']['output'];
  pageCount: Scalars['Int']['output'];
  pageSize: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type AdminCourseRevenueShare = {
  __typename?: 'AdminCourseRevenueShare';
  active: Scalars['Boolean']['output'];
  course_id: Scalars['ID']['output'];
  course_title: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  note?: Maybe<Scalars['String']['output']>;
  rate_percent: Scalars['Int']['output'];
  totals: CourseRevenueShareTotals;
  updatedAt: Scalars['String']['output'];
  user_email: Scalars['String']['output'];
  user_id: Scalars['ID']['output'];
  user_name?: Maybe<Scalars['String']['output']>;
};

export type AdminCourseRevenueShareInput = {
  active: Scalars['Boolean']['input'];
  courseId?: InputMaybe<Scalars['ID']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  ratePercent: Scalars['Int']['input'];
  userId?: InputMaybe<Scalars['ID']['input']>;
};

export type AdminCpmCampaign = {
  __typename?: 'AdminCpmCampaign';
  allow_cpm_override: Scalars['Boolean']['output'];
  allowed_platforms?: Maybe<Array<Scalars['String']['output']>>;
  approved_submissions_count: Scalars['Int']['output'];
  banner_url?: Maybe<Scalars['String']['output']>;
  budget_pending_cents: Scalars['Int']['output'];
  budget_remaining_cents: Scalars['Int']['output'];
  budget_spend_drift_cents: Scalars['Int']['output'];
  budget_spent_cents: Scalars['Int']['output'];
  budget_stored_spent_cents: Scalars['Int']['output'];
  budget_total_cents: Scalars['Int']['output'];
  campaign_admins: Array<AdminUser>;
  campaign_type?: Maybe<Scalars['String']['output']>;
  caption_examples?: Maybe<Scalars['String']['output']>;
  categories: Array<Scalars['String']['output']>;
  cpm_override_max_cents?: Maybe<Scalars['Int']['output']>;
  cpm_override_min_cents?: Maybe<Scalars['Int']['output']>;
  cpm_override_mode: Scalars['String']['output'];
  cpm_override_presets_cents?: Maybe<Array<Scalars['Int']['output']>>;
  cpm_rate_cents: Scalars['Int']['output'];
  cpm_platform_rates: Array<CpmPlatformRate>;
  createdAt: Scalars['String']['output'];
  currency: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  disapproved_submissions_count: Scalars['Int']['output'];
  editing_assets?: Maybe<Scalars['JSON']['output']>;
  end_date?: Maybe<Scalars['String']['output']>;
  enforced_post_layout?: Maybe<Scalars['JSON']['output']>;
  enforced_subtitle_position?: Maybe<Scalars['JSON']['output']>;
  id: Scalars['ID']['output'];
  invite_only: Scalars['Boolean']['output'];
  library_projects: Array<MyLibrary>;
  logo_url?: Maybe<Scalars['String']['output']>;
  max_payout_per_clip_cents?: Maybe<Scalars['Int']['output']>;
  max_payout_per_clipper_cents?: Maybe<Scalars['Int']['output']>;
  min_clip_duration_seconds?: Maybe<Scalars['Int']['output']>;
  min_payout_per_clipper_cents?: Maybe<Scalars['Int']['output']>;
  min_views_threshold?: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  pending_appeals_count: Scalars['Int']['output'];
  pending_channel_requests_count: Scalars['Int']['output'];
  pending_submissions_count: Scalars['Int']['output'];
  pre_approval_enabled: Scalars['Boolean']['output'];
  pre_approval_min_score?: Maybe<Scalars['Int']['output']>;
  rank_min_finished_renders?: Maybe<Scalars['Int']['output']>;
  ranking_config?: Maybe<Scalars['JSON']['output']>;
  required_hashtags?: Maybe<Scalars['String']['output']>;
  required_mention?: Maybe<Scalars['String']['output']>;
  requires_channel_approval: Scalars['Boolean']['output'];
  restrict_to_listed_videos: Scalars['Boolean']['output'];
  rules_allowed?: Maybe<Scalars['String']['output']>;
  rules_attention?: Maybe<Scalars['String']['output']>;
  rules_forbidden?: Maybe<Scalars['String']['output']>;
  rules_warning?: Maybe<Scalars['String']['output']>;
  scheduled_activation_at?: Maybe<Scalars['DateTime']['output']>;
  selected_only: Scalars['Boolean']['output'];
  selected_users: Array<AdminUser>;
  start_date?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  submissions_count: Scalars['Int']['output'];
  updatedAt: Scalars['String']['output'];
  view_accrual_window_hours?: Maybe<Scalars['Int']['output']>;
  watermark_anchor?: Maybe<Scalars['String']['output']>;
  watermark_image_url?: Maybe<Scalars['String']['output']>;
  watermark_margin_x_percent?: Maybe<Scalars['Float']['output']>;
  watermark_margin_y_percent?: Maybe<Scalars['Float']['output']>;
  watermark_opacity_percent?: Maybe<Scalars['Float']['output']>;
  watermark_size_percent?: Maybe<Scalars['Float']['output']>;
  youtube_channels: Array<MyYoutubeChannel>;
  youtube_downloads: Array<CpmCampaignVideo>;
};

export type AdminCpmCampaignChannelRequest = {
  __typename?: 'AdminCpmCampaignChannelRequest';
  createdAt: Scalars['String']['output'];
  handle?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  platform: Scalars['String']['output'];
  review_reason?: Maybe<Scalars['String']['output']>;
  reviewed_at?: Maybe<Scalars['String']['output']>;
  reviewed_by_id?: Maybe<Scalars['ID']['output']>;
  reviewed_by_name?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  submitted_url: Scalars['String']['output'];
  user_email?: Maybe<Scalars['String']['output']>;
  user_id: Scalars['ID']['output'];
  user_name?: Maybe<Scalars['String']['output']>;
  youtube_channel?: Maybe<MyYoutubeChannel>;
};

export type AdminCpmCampaignChannelRequestsResponse = {
  __typename?: 'AdminCpmCampaignChannelRequestsResponse';
  data: Array<AdminCpmCampaignChannelRequest>;
  pageCount: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type AdminCpmCampaignInput = {
  allow_cpm_override?: InputMaybe<Scalars['Boolean']['input']>;
  allowed_platforms?: InputMaybe<Array<Scalars['String']['input']>>;
  banner_url?: InputMaybe<Scalars['String']['input']>;
  budget_total_cents: Scalars['Int']['input'];
  campaign_admin_user_ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  campaign_type?: InputMaybe<Scalars['String']['input']>;
  caption_examples?: InputMaybe<Scalars['String']['input']>;
  categories?: InputMaybe<Array<Scalars['String']['input']>>;
  cpm_override_max_cents?: InputMaybe<Scalars['Int']['input']>;
  cpm_override_min_cents?: InputMaybe<Scalars['Int']['input']>;
  cpm_override_mode?: InputMaybe<Scalars['String']['input']>;
  cpm_override_presets_cents?: InputMaybe<Array<Scalars['Int']['input']>>;
  cpm_rate_cents: Scalars['Int']['input'];
  cpm_platform_rates?: InputMaybe<Array<CpmPlatformRateInput>>;
  currency: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  editing_assets?: InputMaybe<Scalars['JSON']['input']>;
  end_date?: InputMaybe<Scalars['String']['input']>;
  enforced_post_layout?: InputMaybe<Scalars['JSON']['input']>;
  enforced_subtitle_position?: InputMaybe<Scalars['JSON']['input']>;
  invite_only?: InputMaybe<Scalars['Boolean']['input']>;
  library_project_ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  logo_url?: InputMaybe<Scalars['String']['input']>;
  max_payout_per_clip_cents?: InputMaybe<Scalars['Int']['input']>;
  max_payout_per_clipper_cents?: InputMaybe<Scalars['Int']['input']>;
  min_clip_duration_seconds?: InputMaybe<Scalars['Int']['input']>;
  min_payout_per_clipper_cents?: InputMaybe<Scalars['Int']['input']>;
  min_views_threshold?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  pre_approval_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  pre_approval_min_score?: InputMaybe<Scalars['Int']['input']>;
  rank_min_finished_renders?: InputMaybe<Scalars['Int']['input']>;
  ranking_config?: InputMaybe<Scalars['JSON']['input']>;
  required_hashtags?: InputMaybe<Scalars['String']['input']>;
  required_mention?: InputMaybe<Scalars['String']['input']>;
  requires_channel_approval?: InputMaybe<Scalars['Boolean']['input']>;
  restrict_to_listed_videos?: InputMaybe<Scalars['Boolean']['input']>;
  rules_allowed?: InputMaybe<Scalars['String']['input']>;
  rules_attention?: InputMaybe<Scalars['String']['input']>;
  rules_forbidden?: InputMaybe<Scalars['String']['input']>;
  rules_warning?: InputMaybe<Scalars['String']['input']>;
  scheduled_activation_at?: InputMaybe<Scalars['DateTime']['input']>;
  selected_only?: InputMaybe<Scalars['Boolean']['input']>;
  selected_user_ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  start_date?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  view_accrual_window_hours?: InputMaybe<Scalars['Int']['input']>;
  watermark_anchor?: InputMaybe<Scalars['String']['input']>;
  watermark_image_url?: InputMaybe<Scalars['String']['input']>;
  watermark_margin_x_percent?: InputMaybe<Scalars['Float']['input']>;
  watermark_margin_y_percent?: InputMaybe<Scalars['Float']['input']>;
  watermark_opacity_percent?: InputMaybe<Scalars['Float']['input']>;
  watermark_size_percent?: InputMaybe<Scalars['Float']['input']>;
  youtube_channel_ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  youtube_download_ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  youtube_download_ids_base?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type AdminCpmCampaignRecomputeResult = {
  __typename?: 'AdminCpmCampaignRecomputeResult';
  changed_count: Scalars['Int']['output'];
  recomputed_count: Scalars['Int']['output'];
  total_delta_cents: Scalars['Int']['output'];
};

export type AdminCpmCampaignSubmission = {
  __typename?: 'AdminCpmCampaignSubmission';
  account_reliability: CpmAccountReliability;
  accrual_window_ends_at?: Maybe<Scalars['String']['output']>;
  accumulated_payout_cents: Scalars['Int']['output'];
  admin_approval: Scalars['String']['output'];
  admin_observation?: Maybe<Scalars['String']['output']>;
  approval_reason?: Maybe<Scalars['String']['output']>;
  canonical_url?: Maybe<Scalars['String']['output']>;
  content_review_group_decision?: Maybe<Scalars['String']['output']>;
  content_review_group_id?: Maybe<Scalars['ID']['output']>;
  cpm_rate_override_cents?: Maybe<Scalars['Int']['output']>;
  createdAt: Scalars['String']['output'];
  daily_views: Array<CpmSubmissionViewSnapshot>;
  disapproved_at?: Maybe<Scalars['String']['output']>;
  disqualification_reason?: Maybe<Scalars['String']['output']>;
  disqualified: Scalars['Boolean']['output'];
  estimated_payout_cents?: Maybe<Scalars['Int']['output']>;
  final_accrual_captured_at?: Maybe<Scalars['String']['output']>;
  final_accrual_source?: Maybe<Scalars['String']['output']>;
  final_accrual_views?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  last_counted_views: Scalars['String']['output'];
  last_view_sync_at?: Maybe<Scalars['String']['output']>;
  latest_views?: Maybe<Scalars['String']['output']>;
  media_duration_seconds?: Maybe<Scalars['Float']['output']>;
  metrics_error?: Maybe<Scalars['String']['output']>;
  metrics_status?: Maybe<Scalars['String']['output']>;
  pending_appeal_id?: Maybe<Scalars['ID']['output']>;
  platform: Scalars['String']['output'];
  pre_approval: Scalars['String']['output'];
  pre_approval_at?: Maybe<Scalars['String']['output']>;
  pre_approval_gates?: Maybe<Scalars['JSON']['output']>;
  pre_approval_score?: Maybe<Scalars['Int']['output']>;
  rejection_images: Array<CpmReviewImage>;
  rules_check?: Maybe<Scalars['JSON']['output']>;
  rules_check_failures: Array<Scalars['String']['output']>;
  suspected_duplicate: Scalars['Boolean']['output'];
  suspected_duplicate_reason?: Maybe<Scalars['String']['output']>;
  url: Scalars['String']['output'];
  user_disqualified: Scalars['Boolean']['output'];
  user_email?: Maybe<Scalars['String']['output']>;
  user_id: Scalars['ID']['output'];
  user_name?: Maybe<Scalars['String']['output']>;
  validated_hashtags: Scalars['String']['output'];
  video_hash?: Maybe<Scalars['String']['output']>;
};

export type AdminCpmCampaignSubmissionsResponse = {
  __typename?: 'AdminCpmCampaignSubmissionsResponse';
  data: Array<AdminCpmCampaignSubmission>;
  pageCount: Scalars['Int']['output'];
  stats: CpmSubmissionsAggregateStats;
  total: Scalars['Int']['output'];
};

export type AdminCpmCampaignsResponse = {
  __typename?: 'AdminCpmCampaignsResponse';
  data: Array<AdminCpmCampaign>;
  total: Scalars['Int']['output'];
};

export type AdminCpmLead = {
  __typename?: 'AdminCpmLead';
  brief?: Maybe<Scalars['JSON']['output']>;
  budget: Scalars['String']['output'];
  company?: Maybe<Scalars['String']['output']>;
  contentType?: Maybe<Scalars['JSON']['output']>;
  demandType?: Maybe<Scalars['String']['output']>;
  documentId: Scalars['String']['output'];
  email: Scalars['String']['output'];
  iago?: Maybe<Scalars['JSON']['output']>;
  messages: Array<AdminCpmLeadMessage>;
  name: Scalars['String']['output'];
  objective?: Maybe<Scalars['String']['output']>;
  phone: Scalars['String']['output'];
  phoneE164?: Maybe<Scalars['String']['output']>;
  platforms?: Maybe<Scalars['String']['output']>;
  social?: Maybe<Scalars['String']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  website?: Maybe<Scalars['String']['output']>;
};

export type AdminCpmLeadMessage = {
  __typename?: 'AdminCpmLeadMessage';
  actor?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['String']['output'];
  direction: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  text: Scalars['String']['output'];
};

export type AdminCpmLeaderboardExclusionResult = {
  __typename?: 'AdminCpmLeaderboardExclusionResult';
  cpm_leaderboard_excluded: Scalars['Boolean']['output'];
  cpm_leaderboard_excluded_reason?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
};

export type AdminCpmPayout = {
  __typename?: 'AdminCpmPayout';
  amount_cents: Scalars['Int']['output'];
  bank_data?: Maybe<Scalars['JSON']['output']>;
  breakdown?: Maybe<Scalars['JSON']['output']>;
  createdAt: Scalars['String']['output'];
  created_by_email?: Maybe<Scalars['String']['output']>;
  currency: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  kind?: Maybe<Scalars['String']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  paid_at?: Maybe<Scalars['String']['output']>;
  pix_verification_review_reason?: Maybe<Scalars['String']['output']>;
  /** Latest PIX verification of the payout's user: unverified | pending | verified | rejected */
  pix_verification_status?: Maybe<Scalars['String']['output']>;
  redemption_data?: Maybe<Scalars['JSON']['output']>;
  requested_at?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  user_email?: Maybe<Scalars['String']['output']>;
  user_id: Scalars['ID']['output'];
  user_name?: Maybe<Scalars['String']['output']>;
};

export type AdminCpmPayoutsResponse = {
  __typename?: 'AdminCpmPayoutsResponse';
  data: Array<AdminCpmPayout>;
  total: Scalars['Int']['output'];
};

export type AdminCpmSubmissionMediaDownload = {
  __typename?: 'AdminCpmSubmissionMediaDownload';
  error?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  provider?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  submission_id: Scalars['ID']['output'];
  video_url?: Maybe<Scalars['String']['output']>;
};

export type AdminCreateCpmPayoutInput = {
  amount_cents: Scalars['Int']['input'];
  currency?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  paid_at?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['ID']['input'];
};

export type AdminCreateLiveWatchInput = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  kind: LiveWatchKind;
  overlap_seconds?: InputMaybe<Scalars['Int']['input']>;
  platform: LiveWatchPlatform;
  platform_channel_id?: InputMaybe<Scalars['String']['input']>;
  platform_login?: InputMaybe<Scalars['String']['input']>;
  retention_days?: InputMaybe<Scalars['Int']['input']>;
  source_url?: InputMaybe<Scalars['String']['input']>;
  window_minutes?: InputMaybe<Scalars['Int']['input']>;
  youtube_channel_id?: InputMaybe<Scalars['ID']['input']>;
};

export type AdminDateRange = {
  __typename?: 'AdminDateRange';
  endDate: Scalars['String']['output'];
  startDate: Scalars['String']['output'];
};

export type AdminDriveImportResult = {
  __typename?: 'AdminDriveImportResult';
  downloadId?: Maybe<Scalars['ID']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  fileId?: Maybe<Scalars['String']['output']>;
  fileName?: Maybe<Scalars['String']['output']>;
  input: Scalars['String']['output'];
  status: AdminDriveImportStatus;
};

export enum AdminDriveImportStatus {
  AlreadyLinked = 'already_linked',
  Error = 'error',
  LinkedExisting = 'linked_existing',
  Queued = 'queued'
}

export type AdminEmailFlow = {
  __typename?: 'AdminEmailFlow';
  audience: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  is_active: Scalars['Boolean']['output'];
  is_editable: Scalars['Boolean']['output'];
  is_transactional: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  slug: Scalars['String']['output'];
  steps: Array<AdminEmailFlowStep>;
  stepsCount: Scalars['Int']['output'];
  trigger: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type AdminEmailFlowInput = {
  audience?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  is_editable?: InputMaybe<Scalars['Boolean']['input']>;
  is_transactional?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  slug?: InputMaybe<Scalars['String']['input']>;
  trigger: Scalars['String']['input'];
};

export type AdminEmailFlowRun = {
  __typename?: 'AdminEmailFlowRun';
  completed_at?: Maybe<Scalars['DateTime']['output']>;
  current_step_order?: Maybe<Scalars['Int']['output']>;
  flow?: Maybe<AdminEmailFlow>;
  id: Scalars['ID']['output'];
  sendsCount: Scalars['Int']['output'];
  started_at?: Maybe<Scalars['DateTime']['output']>;
  status: Scalars['String']['output'];
  user_email?: Maybe<Scalars['String']['output']>;
  user_id?: Maybe<Scalars['ID']['output']>;
};

export type AdminEmailFlowRunsResponse = {
  __typename?: 'AdminEmailFlowRunsResponse';
  data: Array<AdminEmailFlowRun>;
  page: Scalars['Int']['output'];
  pageSize: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type AdminEmailFlowSend = {
  __typename?: 'AdminEmailFlowSend';
  error?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  is_test: Scalars['Boolean']['output'];
  language_used?: Maybe<Scalars['String']['output']>;
  sent_at: Scalars['DateTime']['output'];
  step_id?: Maybe<Scalars['ID']['output']>;
  step_order?: Maybe<Scalars['Int']['output']>;
  subject_used?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type AdminEmailFlowStep = {
  __typename?: 'AdminEmailFlowStep';
  body_en?: Maybe<Scalars['String']['output']>;
  body_pt: Scalars['String']['output'];
  delay_minutes: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  is_active: Scalars['Boolean']['output'];
  order: Scalars['Int']['output'];
  subject_en?: Maybe<Scalars['String']['output']>;
  subject_pt: Scalars['String']['output'];
};

export type AdminEmailFlowStepInput = {
  body_en?: InputMaybe<Scalars['String']['input']>;
  body_pt: Scalars['String']['input'];
  delay_minutes: Scalars['Int']['input'];
  flow: Scalars['ID']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  order: Scalars['Int']['input'];
  subject_en?: InputMaybe<Scalars['String']['input']>;
  subject_pt: Scalars['String']['input'];
};

export type AdminEmailFlowUpdateInput = {
  audience?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  is_editable?: InputMaybe<Scalars['Boolean']['input']>;
  is_transactional?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  trigger?: InputMaybe<Scalars['String']['input']>;
};

export type AdminEmailFlowsResponse = {
  __typename?: 'AdminEmailFlowsResponse';
  data: Array<AdminEmailFlow>;
  page: Scalars['Int']['output'];
  pageSize: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type AdminEntityStats = {
  __typename?: 'AdminEntityStats';
  failure: Scalars['Int']['output'];
  processing: Scalars['Int']['output'];
  queued: Scalars['Int']['output'];
  success: Scalars['Int']['output'];
  timeSeries: Array<AdminTimeSeriesPoint>;
  total: Scalars['Int']['output'];
};

export type AdminFunnelData = {
  __typename?: 'AdminFunnelData';
  other_channels: Array<AdminFunnelStep>;
  own_brand: Array<AdminFunnelStep>;
};

export type AdminFunnelStep = {
  __typename?: 'AdminFunnelStep';
  count: Scalars['Int']['output'];
  label: Scalars['String']['output'];
};

export type AdminImpersonationResponse = {
  __typename?: 'AdminImpersonationResponse';
  jwt: Scalars['String']['output'];
};

export type AdminLibrariesResponse = {
  __typename?: 'AdminLibrariesResponse';
  data: Array<AdminLibraryItem>;
  page: Scalars['Int']['output'];
  pageCount: Scalars['Int']['output'];
  pageSize: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type AdminLibraryItem = {
  __typename?: 'AdminLibraryItem';
  base_video_url?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['String']['output'];
  created_by_user?: Maybe<AdminUserBasic>;
  curation_status?: Maybe<Scalars['String']['output']>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  duration_seconds?: Maybe<Scalars['Float']['output']>;
  format?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  language?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  prompt?: Maybe<Scalars['String']['output']>;
  thumbnail_url?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['String']['output'];
};

export type AdminLibraryVideoInput = {
  duration_seconds?: InputMaybe<Scalars['Float']['input']>;
  thumbnail?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
  url: Scalars['String']['input'];
};

export type AdminLiveSession = {
  __typename?: 'AdminLiveSession';
  ended_at?: Maybe<Scalars['DateTime']['output']>;
  heartbeat_at?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  ingest_status: LiveIngestStatus;
  last_error?: Maybe<Scalars['String']['output']>;
  live_url?: Maybe<Scalars['String']['output']>;
  platform_live_id?: Maybe<Scalars['String']['output']>;
  r2_prefix?: Maybe<Scalars['String']['output']>;
  retention_expires_at?: Maybe<Scalars['DateTime']['output']>;
  started_at?: Maybe<Scalars['DateTime']['output']>;
  status: LiveSessionStatus;
};

export type AdminLiveSessionPage = {
  __typename?: 'AdminLiveSessionPage';
  data: Array<AdminLiveSession>;
  page: Scalars['Int']['output'];
  pageCount: Scalars['Int']['output'];
  pageSize: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type AdminLiveWatch = {
  __typename?: 'AdminLiveWatch';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  current_session?: Maybe<AdminLiveSession>;
  enabled: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  kind: LiveWatchKind;
  overlap_seconds: Scalars['Int']['output'];
  platform: LiveWatchPlatform;
  platform_channel_id?: Maybe<Scalars['String']['output']>;
  platform_login?: Maybe<Scalars['String']['output']>;
  retention_days: Scalars['Int']['output'];
  source_url?: Maybe<Scalars['String']['output']>;
  window_minutes: Scalars['Int']['output'];
  youtube_channel?: Maybe<AdminLiveWatchChannel>;
};

export type AdminLiveWatchChannel = {
  __typename?: 'AdminLiveWatchChannel';
  channel_id?: Maybe<Scalars['String']['output']>;
  handle?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  thumbnail?: Maybe<Scalars['String']['output']>;
};

export type AdminLiveWatchPage = {
  __typename?: 'AdminLiveWatchPage';
  data: Array<AdminLiveWatch>;
  page: Scalars['Int']['output'];
  pageCount: Scalars['Int']['output'];
  pageSize: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type AdminLiveWindow = {
  __typename?: 'AdminLiveWindow';
  attempt_count: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  last_error?: Maybe<Scalars['String']['output']>;
  library_document_id?: Maybe<Scalars['String']['output']>;
  status: LiveWindowStatus;
  window_end: Scalars['Int']['output'];
  window_start: Scalars['Int']['output'];
};

export type AdminLiveWindowPage = {
  __typename?: 'AdminLiveWindowPage';
  data: Array<AdminLiveWindow>;
  page: Scalars['Int']['output'];
  pageCount: Scalars['Int']['output'];
  pageSize: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type AdminPixVerification = {
  __typename?: 'AdminPixVerification';
  cpf: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  document_back_url?: Maybe<Scalars['String']['output']>;
  document_url: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  review_reason?: Maybe<Scalars['String']['output']>;
  reviewed_at?: Maybe<Scalars['String']['output']>;
  reviewed_by_id?: Maybe<Scalars['ID']['output']>;
  reviewed_by_name?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  submitted_at?: Maybe<Scalars['String']['output']>;
  user_email?: Maybe<Scalars['String']['output']>;
  user_id?: Maybe<Scalars['ID']['output']>;
  user_name?: Maybe<Scalars['String']['output']>;
};

export type AdminPixVerificationsResponse = {
  __typename?: 'AdminPixVerificationsResponse';
  data: Array<AdminPixVerification>;
  pageCount: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type AdminPlan = {
  __typename?: 'AdminPlan';
  id: Scalars['ID']['output'];
  max_clips?: Maybe<Scalars['Int']['output']>;
  max_library_curations?: Maybe<Scalars['Int']['output']>;
  max_library_exports?: Maybe<Scalars['Int']['output']>;
  max_library_video_seconds?: Maybe<Scalars['Int']['output']>;
  max_users?: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  processing_seconds?: Maybe<Scalars['Int']['output']>;
  slug: Scalars['String']['output'];
  value?: Maybe<Scalars['Float']['output']>;
};

export type AdminPlanCustomerCount = {
  __typename?: 'AdminPlanCustomerCount';
  customer_count: Scalars['Int']['output'];
  plan_document_id: Scalars['String']['output'];
  plan_id: Scalars['ID']['output'];
  plan_name?: Maybe<Scalars['String']['output']>;
  plan_slug?: Maybe<Scalars['String']['output']>;
};

export type AdminPlanFull = {
  __typename?: 'AdminPlanFull';
  color?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['String']['output'];
  description_items?: Maybe<Scalars['JSON']['output']>;
  discount_label?: Maybe<Scalars['String']['output']>;
  eduzz_code?: Maybe<Scalars['String']['output']>;
  eduzz_code_yearly?: Maybe<Scalars['String']['output']>;
  features?: Maybe<Scalars['JSON']['output']>;
  hidden?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  max_brand_kits?: Maybe<Scalars['Int']['output']>;
  max_clips?: Maybe<Scalars['Int']['output']>;
  max_expiry_days?: Maybe<Scalars['Int']['output']>;
  max_library_curations?: Maybe<Scalars['Int']['output']>;
  max_library_exports?: Maybe<Scalars['Int']['output']>;
  max_library_video_seconds?: Maybe<Scalars['Int']['output']>;
  max_users?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  order?: Maybe<Scalars['Int']['output']>;
  payment_link?: Maybe<Scalars['String']['output']>;
  payment_link_yearly?: Maybe<Scalars['String']['output']>;
  priority?: Maybe<Scalars['Int']['output']>;
  processing_seconds?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  stripe_monthly_price_id?: Maybe<Scalars['String']['output']>;
  stripe_monthly_price_id_usd?: Maybe<Scalars['String']['output']>;
  stripe_product_id?: Maybe<Scalars['String']['output']>;
  stripe_yearly_price_id?: Maybe<Scalars['String']['output']>;
  stripe_yearly_price_id_usd?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['String']['output'];
  value?: Maybe<Scalars['Float']['output']>;
  value_usd?: Maybe<Scalars['Float']['output']>;
  value_yearly?: Maybe<Scalars['Float']['output']>;
  value_yearly_usd?: Maybe<Scalars['Float']['output']>;
};

export type AdminProject = {
  __typename?: 'AdminProject';
  createdAt: Scalars['String']['output'];
  created_by_user?: Maybe<AdminUserBasic>;
  curation_status?: Maybe<Scalars['String']['output']>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  duration_seconds?: Maybe<Scalars['Float']['output']>;
  favorite?: Maybe<Scalars['Boolean']['output']>;
  format?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  language?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  public?: Maybe<Scalars['Boolean']['output']>;
  updatedAt: Scalars['String']['output'];
};

export type AdminProjectBasic = {
  __typename?: 'AdminProjectBasic';
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type AdminProjectsResponse = {
  __typename?: 'AdminProjectsResponse';
  data: Array<AdminProject>;
  page: Scalars['Int']['output'];
  pageCount: Scalars['Int']['output'];
  pageSize: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type AdminRankingSnapshots = {
  __typename?: 'AdminRankingSnapshots';
  end_views: Array<RankingSnapshotClip>;
  ranking_id: Scalars['ID']['output'];
  ranking_name: Scalars['String']['output'];
  start_views: Array<RankingSnapshotClip>;
};

export type AdminRestoreExpiredItemsResponse = {
  __typename?: 'AdminRestoreExpiredItemsResponse';
  restoredClips: Scalars['Int']['output'];
  restoredProjects: Scalars['Int']['output'];
};

export type AdminResultsActivityPoint = {
  __typename?: 'AdminResultsActivityPoint';
  clips: Scalars['Int']['output'];
  date: Scalars['String']['output'];
  users: Scalars['Int']['output'];
};

export type AdminResultsCampaignSummary = {
  __typename?: 'AdminResultsCampaignSummary';
  approved: Scalars['Int']['output'];
  clipperToPaidPct: Scalars['Float']['output'];
  earningsCents: Scalars['Int']['output'];
  enrolled: Scalars['Int']['output'];
  submitted: Scalars['Int']['output'];
  subscriberToCampaignPct: Scalars['Float']['output'];
};

export type AdminResultsConversion = {
  __typename?: 'AdminResultsConversion';
  rate: Scalars['Float']['output'];
  totalFree: Scalars['Int']['output'];
  totalPaid: Scalars['Int']['output'];
};

export type AdminResultsDashboard = {
  __typename?: 'AdminResultsDashboard';
  activity: Array<AdminResultsActivityPoint>;
  campaigns: AdminResultsCampaignSummary;
  conversion: AdminResultsConversion;
  dateRange: AdminResultsDateRange;
  funnelClipper: Array<AdminResultsFunnelStep>;
  funnelCreator: Array<AdminResultsFunnelStep>;
  nwc: AdminResultsNwcSummary;
  retentionClipper: Array<AdminResultsRetentionPoint>;
  retentionCreator: Array<AdminResultsRetentionPoint>;
  sourcesClipper: Array<AdminResultsSource>;
  sourcesCreator: Array<AdminResultsSource>;
};

export type AdminResultsDateRange = {
  __typename?: 'AdminResultsDateRange';
  capped: Scalars['Boolean']['output'];
  days: Scalars['Int']['output'];
  endDate: Scalars['String']['output'];
  startDate: Scalars['String']['output'];
};

export type AdminResultsFunnelStep = {
  __typename?: 'AdminResultsFunnelStep';
  count: Scalars['Int']['output'];
  label: Scalars['String']['output'];
  pct: Scalars['Int']['output'];
};

export type AdminResultsNwcSummary = {
  __typename?: 'AdminResultsNwcSummary';
  campaignPct: Scalars['Float']['output'];
  organicRetentionD1: Scalars['Int']['output'];
  organicRetentionD7: Scalars['Int']['output'];
  organicRetentionD30: Scalars['Int']['output'];
  paidPct: Scalars['Float']['output'];
  retentionD1: Scalars['Int']['output'];
  retentionD7: Scalars['Int']['output'];
  retentionD30: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type AdminResultsRetentionPoint = {
  __typename?: 'AdminResultsRetentionPoint';
  cohort: Scalars['Int']['output'];
  pct: Scalars['Int']['output'];
  period: Scalars['String']['output'];
  retained: Scalars['Int']['output'];
};

export type AdminResultsSource = {
  __typename?: 'AdminResultsSource';
  count: Scalars['Int']['output'];
  key: Scalars['String']['output'];
  label: Scalars['String']['output'];
  pct: Scalars['Int']['output'];
};

export type AdminStatsResponse = {
  __typename?: 'AdminStatsResponse';
  clips: AdminEntityStats;
  dateRange: AdminDateRange;
  libraryProjects: AdminEntityStats;
  planCustomerCounts: Array<AdminPlanCustomerCount>;
  projects: AdminEntityStats;
  users: AdminUserStats;
  youtubeDownloads: AdminEntityStats;
};

export type AdminSubscription = {
  __typename?: 'AdminSubscription';
  active_coupon?: Maybe<AdminActiveCoupon>;
  ai_assistant_granted?: Maybe<Scalars['Boolean']['output']>;
  cancellation_at?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['String']['output'];
  current_month_clips?: Maybe<Scalars['Int']['output']>;
  current_month_library_curations?: Maybe<Scalars['Int']['output']>;
  current_month_library_exports?: Maybe<Scalars['Int']['output']>;
  current_month_library_video_seconds?: Maybe<Scalars['Float']['output']>;
  current_month_processing_seconds?: Maybe<Scalars['Float']['output']>;
  discount_amount?: Maybe<Scalars['Float']['output']>;
  discounted_price?: Maybe<Scalars['Float']['output']>;
  extra_clips?: Maybe<Scalars['Int']['output']>;
  extra_seconds?: Maybe<Scalars['Int']['output']>;
  facebook_connections_granted?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  is_partner?: Maybe<Scalars['Boolean']['output']>;
  next_payment_at?: Maybe<Scalars['String']['output']>;
  original_price?: Maybe<Scalars['Float']['output']>;
  partner_expires_at?: Maybe<Scalars['String']['output']>;
  partner_note?: Maybe<Scalars['String']['output']>;
  payment_count?: Maybe<Scalars['Int']['output']>;
  payment_provider?: Maybe<Scalars['String']['output']>;
  payment_recurrency?: Maybe<Scalars['String']['output']>;
  plan?: Maybe<AdminPlan>;
  total_payment_value?: Maybe<Scalars['Float']['output']>;
  updatedAt: Scalars['String']['output'];
};

export type AdminTemplateSuggestion = {
  __typename?: 'AdminTemplateSuggestion';
  author_name?: Maybe<Scalars['String']['output']>;
  brand_kit_id?: Maybe<Scalars['ID']['output']>;
  createdAt: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  note?: Maybe<Scalars['String']['output']>;
  platform: Scalars['String']['output'];
  promoted_at?: Maybe<Scalars['String']['output']>;
  review_reason?: Maybe<Scalars['String']['output']>;
  reviewed_at?: Maybe<Scalars['String']['output']>;
  reviewed_by_id?: Maybe<Scalars['ID']['output']>;
  reviewed_by_name?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  submitted_by_name?: Maybe<Scalars['String']['output']>;
  submitted_url: Scalars['String']['output'];
  thumbnail_url?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  use_case: Scalars['String']['output'];
  user_email?: Maybe<Scalars['String']['output']>;
  user_id?: Maybe<Scalars['ID']['output']>;
  user_name?: Maybe<Scalars['String']['output']>;
  vote_count: Scalars['Int']['output'];
};

export type AdminTemplateSuggestionsResponse = {
  __typename?: 'AdminTemplateSuggestionsResponse';
  data: Array<AdminTemplateSuggestion>;
  pageCount: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type AdminTimeSeriesPoint = {
  __typename?: 'AdminTimeSeriesPoint';
  date: Scalars['String']['output'];
  failure: Scalars['Int']['output'];
  success: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type AdminUpdateUserSubscriptionInput = {
  current_month_clips?: InputMaybe<Scalars['Int']['input']>;
  current_month_library_curations?: InputMaybe<Scalars['Int']['input']>;
  current_month_library_exports?: InputMaybe<Scalars['Int']['input']>;
  current_month_library_video_seconds?: InputMaybe<Scalars['Float']['input']>;
  current_month_processing_seconds?: InputMaybe<Scalars['Float']['input']>;
  extra_clips?: InputMaybe<Scalars['Int']['input']>;
  extra_seconds?: InputMaybe<Scalars['Int']['input']>;
  is_partner?: InputMaybe<Scalars['Boolean']['input']>;
  onboarding_objective?: InputMaybe<Scalars['String']['input']>;
  partner_expires_at?: InputMaybe<Scalars['String']['input']>;
  partner_note?: InputMaybe<Scalars['String']['input']>;
  plan_id?: InputMaybe<Scalars['ID']['input']>;
};

export type AdminUser = {
  __typename?: 'AdminUser';
  account_reliabilities: Array<CpmAccountReliability>;
  affiliate_blocked?: Maybe<Scalars['Boolean']['output']>;
  affiliate_blocked_at?: Maybe<Scalars['String']['output']>;
  affiliate_blocked_reason?: Maybe<Scalars['String']['output']>;
  affiliate_rate_course?: Maybe<Scalars['Int']['output']>;
  affiliate_rate_cpm?: Maybe<Scalars['Int']['output']>;
  affiliate_rate_note?: Maybe<Scalars['String']['output']>;
  affiliate_rate_payment?: Maybe<Scalars['Int']['output']>;
  blocked: Scalars['Boolean']['output'];
  confirmed: Scalars['Boolean']['output'];
  cpm_leaderboard_excluded?: Maybe<Scalars['Boolean']['output']>;
  cpm_leaderboard_excluded_reason?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['String']['output'];
  email: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  is_admin?: Maybe<Scalars['Boolean']['output']>;
  job_title?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  onboarding_objective?: Maybe<Scalars['String']['output']>;
  phone_number?: Maybe<Scalars['String']['output']>;
  profile_picture?: Maybe<Scalars['String']['output']>;
  provider?: Maybe<Scalars['String']['output']>;
  subscription?: Maybe<AdminSubscription>;
  updatedAt: Scalars['String']['output'];
  utm_campaign?: Maybe<Scalars['String']['output']>;
  utm_content?: Maybe<Scalars['String']['output']>;
  utm_medium?: Maybe<Scalars['String']['output']>;
  utm_source?: Maybe<Scalars['String']['output']>;
  utm_term?: Maybe<Scalars['String']['output']>;
};

export type AdminUserBasic = {
  __typename?: 'AdminUserBasic';
  email: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type AdminUserCpmWallet = {
  __typename?: 'AdminUserCpmWallet';
  available_cents: Scalars['Int']['output'];
  currency: Scalars['String']['output'];
  payouts: Array<AdminCpmPayout>;
  pending_cents: Scalars['Int']['output'];
  total_earned_cents: Scalars['Int']['output'];
  total_paid_out_cents: Scalars['Int']['output'];
  user_id: Scalars['ID']['output'];
};

export type AdminUserStats = {
  __typename?: 'AdminUserStats';
  admins: Scalars['Int']['output'];
  blocked: Scalars['Int']['output'];
  confirmed: Scalars['Int']['output'];
  timeSeries: Array<AdminTimeSeriesPoint>;
  total: Scalars['Int']['output'];
  utmTimeSeries: Array<AdminUtmTimeSeriesPoint>;
};

export type AdminUsersResponse = {
  __typename?: 'AdminUsersResponse';
  data: Array<AdminUser>;
  page: Scalars['Int']['output'];
  pageCount: Scalars['Int']['output'];
  pageSize: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type AdminUtmTimeSeriesPoint = {
  __typename?: 'AdminUtmTimeSeriesPoint';
  count: Scalars['Int']['output'];
  date: Scalars['String']['output'];
  utm_source: Scalars['String']['output'];
};

export type AdminYouTubeDownload = {
  __typename?: 'AdminYouTubeDownload';
  createdAt: Scalars['String']['output'];
  download_status: Scalars['String']['output'];
  hash?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  language?: Maybe<Scalars['String']['output']>;
  linked_projects_count: Scalars['Int']['output'];
  priority?: Maybe<Scalars['Int']['output']>;
  provider?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['String']['output'];
  video_id: Scalars['String']['output'];
};

export type AdminYouTubeDownloadsResponse = {
  __typename?: 'AdminYouTubeDownloadsResponse';
  data: Array<AdminYouTubeDownload>;
  page: Scalars['Int']['output'];
  pageCount: Scalars['Int']['output'];
  pageSize: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type AdminYoutubeChannel = {
  __typename?: 'AdminYoutubeChannel';
  category?: Maybe<Scalars['String']['output']>;
  channel_id: Scalars['String']['output'];
  handle?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  is_autoclipper_partner: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  subscriber_count?: Maybe<Scalars['Int']['output']>;
  thumbnail?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type AdminYoutubeChannelsResponse = {
  __typename?: 'AdminYoutubeChannelsResponse';
  data: Array<AdminYoutubeChannel>;
  page: Scalars['Int']['output'];
  pageCount: Scalars['Int']['output'];
  pageSize: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type Affiliate = {
  __typename?: 'Affiliate';
  Name?: Maybe<Scalars['String']['output']>;
  code: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  documentId: Scalars['ID']['output'];
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  slug: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  users: Array<Maybe<UsersPermissionsUser>>;
  users_connection?: Maybe<UsersPermissionsUserRelationResponseCollection>;
};


export type AffiliateUsersArgs = {
  filters?: InputMaybe<UsersPermissionsUserFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type AffiliateUsers_ConnectionArgs = {
  filters?: InputMaybe<UsersPermissionsUserFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type AffiliateEarningEntry = {
  __typename?: 'AffiliateEarningEntry';
  amount_cents: Scalars['Int']['output'];
  commission_rate: Scalars['Int']['output'];
  createdAt: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  payment_amount_cents: Scalars['Int']['output'];
  payment_date?: Maybe<Scalars['String']['output']>;
  referred_user_name?: Maybe<Scalars['String']['output']>;
  releases_at?: Maybe<Scalars['String']['output']>;
  source: Scalars['String']['output'];
  status: Scalars['String']['output'];
};

export type AffiliateEntityResponseCollection = {
  __typename?: 'AffiliateEntityResponseCollection';
  nodes: Array<Affiliate>;
  pageInfo: Pagination;
};

export type AffiliateFiltersInput = {
  Name?: InputMaybe<StringFilterInput>;
  and?: InputMaybe<Array<InputMaybe<AffiliateFiltersInput>>>;
  code?: InputMaybe<StringFilterInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  documentId?: InputMaybe<IdFilterInput>;
  not?: InputMaybe<AffiliateFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<AffiliateFiltersInput>>>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  slug?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
  users?: InputMaybe<UsersPermissionsUserFiltersInput>;
};

export type AffiliateInput = {
  Name?: InputMaybe<Scalars['String']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  users?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};

export type AffiliateRates = {
  __typename?: 'AffiliateRates';
  course: Scalars['Int']['output'];
  cpm: Scalars['Int']['output'];
  payment: Scalars['Int']['output'];
};

export type AffiliateReferredUser = {
  __typename?: 'AffiliateReferredUser';
  createdAt: Scalars['String']['output'];
  has_paid: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  total_commission_cents: Scalars['Int']['output'];
};

export type AffiliateReferredUserEarning = {
  __typename?: 'AffiliateReferredUserEarning';
  commission_cents: Scalars['Int']['output'];
  commission_rate: Scalars['Int']['output'];
  date: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  payment_amount_cents: Scalars['Int']['output'];
  source: Scalars['String']['output'];
  status: Scalars['String']['output'];
};

export type AffiliateTotals = {
  __typename?: 'AffiliateTotals';
  course_cents: Scalars['Int']['output'];
  cpm_cents: Scalars['Int']['output'];
  payment_cents: Scalars['Int']['output'];
  pending_cents: Scalars['Int']['output'];
  released_cents: Scalars['Int']['output'];
  total_earned_cents: Scalars['Int']['output'];
};

export type AiCoverGeneration = {
  __typename?: 'AiCoverGeneration';
  aspect: CoverAspect;
  createdAt?: Maybe<Scalars['String']['output']>;
  error_code?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  processing_status: Scalars['String']['output'];
  result_url?: Maybe<Scalars['String']['output']>;
};

export type AiCoverQuota = {
  __typename?: 'AiCoverQuota';
  limit: Scalars['Int']['output'];
  resets_at: Scalars['String']['output'];
  used: Scalars['Int']['output'];
};

export type ApiIdempotency = {
  __typename?: 'ApiIdempotency';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  documentId: Scalars['ID']['output'];
  endpoint?: Maybe<Scalars['String']['output']>;
  key?: Maybe<Scalars['String']['output']>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  response_json?: Maybe<Scalars['JSON']['output']>;
  status_code?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type ApiIdempotencyEntityResponseCollection = {
  __typename?: 'ApiIdempotencyEntityResponseCollection';
  nodes: Array<ApiIdempotency>;
  pageInfo: Pagination;
};

export type ApiIdempotencyFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ApiIdempotencyFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  documentId?: InputMaybe<IdFilterInput>;
  endpoint?: InputMaybe<StringFilterInput>;
  key?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ApiIdempotencyFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ApiIdempotencyFiltersInput>>>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  response_json?: InputMaybe<JsonFilterInput>;
  status_code?: InputMaybe<IntFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type ApiIdempotencyInput = {
  endpoint?: InputMaybe<Scalars['String']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  response_json?: InputMaybe<Scalars['JSON']['input']>;
  status_code?: InputMaybe<Scalars['Int']['input']>;
};

export type AssistantAction = {
  __typename?: 'AssistantAction';
  args?: Maybe<Scalars['JSON']['output']>;
  id: Scalars['ID']['output'];
  preview?: Maybe<AssistantActionPreview>;
  status: Scalars['String']['output'];
  title: Scalars['String']['output'];
  tool_name: Scalars['String']['output'];
};

export type AssistantActionPreview = {
  __typename?: 'AssistantActionPreview';
  image_url?: Maybe<Scalars['String']['output']>;
  kind?: Maybe<Scalars['String']['output']>;
  subtitle?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type AssistantAttachment = {
  __typename?: 'AssistantAttachment';
  kind: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
  url: Scalars['String']['output'];
};

export type AssistantAttachmentInput = {
  kind: Scalars['String']['input'];
  mime?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<Scalars['Float']['input']>;
  url: Scalars['String']['input'];
};

export type AssistantClientCall = {
  __typename?: 'AssistantClientCall';
  args?: Maybe<Scalars['JSON']['output']>;
  id: Scalars['ID']['output'];
  tool_name: Scalars['String']['output'];
};

export type AssistantClientResultInput = {
  error?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  images?: InputMaybe<Array<Scalars['String']['input']>>;
  message?: InputMaybe<Scalars['String']['input']>;
  ok: Scalars['Boolean']['input'];
  result?: InputMaybe<Scalars['JSON']['input']>;
};

export type AssistantConversation = {
  __typename?: 'AssistantConversation';
  error?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  messages: Array<AssistantMessage>;
  pending_client_calls: Array<AssistantClientCall>;
  status: Scalars['String']['output'];
  title?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['String']['output']>;
};

export type AssistantConversationSummary = {
  __typename?: 'AssistantConversationSummary';
  id: Scalars['ID']['output'];
  title?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['String']['output']>;
};

export type AssistantEffect = {
  __typename?: 'AssistantEffect';
  path?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
};

export type AssistantMessage = {
  __typename?: 'AssistantMessage';
  action?: Maybe<AssistantAction>;
  attachments: Array<AssistantAttachment>;
  created_at?: Maybe<Scalars['String']['output']>;
  effects: Array<AssistantEffect>;
  id: Scalars['ID']['output'];
  role: Scalars['String']['output'];
  text?: Maybe<Scalars['String']['output']>;
  tool_name?: Maybe<Scalars['String']['output']>;
  tool_status?: Maybe<Scalars['String']['output']>;
  tool_title?: Maybe<Scalars['String']['output']>;
};

export type AssistantUsageByDay = {
  __typename?: 'AssistantUsageByDay';
  cost_usd: Scalars['Float']['output'];
  day: Scalars['String']['output'];
  messages: Scalars['Int']['output'];
  model_calls: Scalars['Int']['output'];
};

export type AssistantUsageByModel = {
  __typename?: 'AssistantUsageByModel';
  completion_tokens: Scalars['Float']['output'];
  cost_usd: Scalars['Float']['output'];
  failed_calls: Scalars['Int']['output'];
  llm_model: Scalars['String']['output'];
  model_calls: Scalars['Int']['output'];
  prompt_tokens: Scalars['Float']['output'];
  purpose: Scalars['String']['output'];
  unpriced_calls: Scalars['Int']['output'];
};

export type AssistantUsageReport = {
  __typename?: 'AssistantUsageReport';
  by_day: Array<AssistantUsageByDay>;
  by_model: Array<AssistantUsageByModel>;
  from: Scalars['String']['output'];
  rows: Array<AssistantUsageRow>;
  to: Scalars['String']['output'];
  total_rows: Scalars['Int']['output'];
  totals: AssistantUsageTotals;
};

export type AssistantUsageRow = {
  __typename?: 'AssistantUsageRow';
  cached_tokens: Scalars['Float']['output'];
  completion_tokens: Scalars['Float']['output'];
  cost_usd: Scalars['Float']['output'];
  is_paid: Scalars['Boolean']['output'];
  last_used_at?: Maybe<Scalars['String']['output']>;
  messages: Scalars['Int']['output'];
  model_calls: Scalars['Int']['output'];
  plan_name?: Maybe<Scalars['String']['output']>;
  prompt_tokens: Scalars['Float']['output'];
  user: AssistantUsageUser;
};

export type AssistantUsageTotals = {
  __typename?: 'AssistantUsageTotals';
  active_users: Scalars['Int']['output'];
  cached_tokens: Scalars['Float']['output'];
  completion_tokens: Scalars['Float']['output'];
  cost_usd: Scalars['Float']['output'];
  failed_calls: Scalars['Int']['output'];
  messages: Scalars['Int']['output'];
  model_calls: Scalars['Int']['output'];
  prompt_tokens: Scalars['Float']['output'];
  unpriced_calls: Scalars['Int']['output'];
};

export type AssistantUsageUser = {
  __typename?: 'AssistantUsageUser';
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type BlogAuthor = {
  __typename?: 'BlogAuthor';
  avatar?: Maybe<UploadFile>;
  bio?: Maybe<Scalars['String']['output']>;
  documentId: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  social_media?: Maybe<Scalars['String']['output']>;
};

export type BlogPost = {
  __typename?: 'BlogPost';
  author?: Maybe<BlogAuthor>;
  content?: Maybe<Scalars['String']['output']>;
  cover_image?: Maybe<UploadFile>;
  documentId: Scalars['ID']['output'];
  highlight?: Maybe<Scalars['Boolean']['output']>;
  publish_date?: Maybe<Scalars['Date']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  subtitle?: Maybe<Scalars['String']['output']>;
  tags: Array<Maybe<BlogTag>>;
  title?: Maybe<Scalars['String']['output']>;
  views?: Maybe<Scalars['Long']['output']>;
};

export type BlogPostFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<BlogPostFiltersInput>>>;
  highlight?: InputMaybe<BooleanFilterInput>;
  not?: InputMaybe<BlogPostFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<BlogPostFiltersInput>>>;
  slug?: InputMaybe<StringFilterInput>;
  subtitle?: InputMaybe<StringFilterInput>;
  tags?: InputMaybe<BlogTagFiltersInput>;
  title?: InputMaybe<StringFilterInput>;
};

export type BlogSetting = {
  __typename?: 'BlogSetting';
  about_us_content?: Maybe<Scalars['String']['output']>;
  documentId: Scalars['ID']['output'];
  menu_tags?: Maybe<Array<Maybe<BlogSettingMenuTagsDynamicZone>>>;
};

export type BlogSettingMenuTagsDynamicZone = ComponentBlogBlogMenuTags | Error;

export type BlogTag = {
  __typename?: 'BlogTag';
  documentId: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
};

export type BlogTagFiltersInput = {
  name?: InputMaybe<StringFilterInput>;
};

export type BooleanFilterInput = {
  and?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  between?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  contains?: InputMaybe<Scalars['Boolean']['input']>;
  containsi?: InputMaybe<Scalars['Boolean']['input']>;
  endsWith?: InputMaybe<Scalars['Boolean']['input']>;
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  eqi?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Boolean']['input']>;
  gte?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  lt?: InputMaybe<Scalars['Boolean']['input']>;
  lte?: InputMaybe<Scalars['Boolean']['input']>;
  ne?: InputMaybe<Scalars['Boolean']['input']>;
  nei?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<BooleanFilterInput>;
  notContains?: InputMaybe<Scalars['Boolean']['input']>;
  notContainsi?: InputMaybe<Scalars['Boolean']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  notNull?: InputMaybe<Scalars['Boolean']['input']>;
  null?: InputMaybe<Scalars['Boolean']['input']>;
  or?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  startsWith?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BrandKitData = {
  __typename?: 'BrandKitData';
  body_font: BrandKitFontSettings;
  colors: Array<Scalars['String']['output']>;
  logo?: Maybe<BrandKitLogoSettings>;
  post_layout?: Maybe<Scalars['JSON']['output']>;
  subtitle: BrandKitSubtitleSettings;
  title_font: BrandKitFontSettings;
};

export type BrandKitDataInput = {
  body_font: BrandKitFontSettingsInput;
  colors: Array<Scalars['String']['input']>;
  logo?: InputMaybe<BrandKitLogoSettingsInput>;
  post_layout?: InputMaybe<Scalars['JSON']['input']>;
  subtitle: BrandKitSubtitleSettingsInput;
  title_font: BrandKitFontSettingsInput;
};

export type BrandKitFontSettings = {
  __typename?: 'BrandKitFontSettings';
  font_id: Scalars['ID']['output'];
  font_size: Scalars['Float']['output'];
};

export type BrandKitFontSettingsInput = {
  font_id: Scalars['ID']['input'];
  font_size: Scalars['Float']['input'];
};

export type BrandKitLogoSettings = {
  __typename?: 'BrandKitLogoSettings';
  logo_horizontal_margin: Scalars['Float']['output'];
  logo_image_url?: Maybe<Scalars['String']['output']>;
  logo_opacity: Scalars['Float']['output'];
  logo_position: Scalars['String']['output'];
  logo_size: Scalars['Float']['output'];
  logo_vertical_margin: Scalars['Float']['output'];
};

export type BrandKitLogoSettingsInput = {
  logo_horizontal_margin: Scalars['Float']['input'];
  logo_image_url?: InputMaybe<Scalars['String']['input']>;
  logo_opacity: Scalars['Float']['input'];
  logo_position: Scalars['String']['input'];
  logo_size: Scalars['Float']['input'];
  logo_vertical_margin: Scalars['Float']['input'];
};

export type BrandKitSubtitleSettings = {
  __typename?: 'BrandKitSubtitleSettings';
  align_items: Scalars['String']['output'];
  animation: Scalars['String']['output'];
  background_color: Scalars['String']['output'];
  background_enabled: Scalars['Boolean']['output'];
  background_height: Scalars['Float']['output'];
  background_opacity: Scalars['Float']['output'];
  background_width: Scalars['Float']['output'];
  highlight_box_background_color?: Maybe<Scalars['String']['output']>;
  highlight_box_border_radius?: Maybe<Scalars['Float']['output']>;
  highlight_box_enabled?: Maybe<Scalars['Boolean']['output']>;
  highlight_box_padding_x?: Maybe<Scalars['Float']['output']>;
  highlight_box_padding_y?: Maybe<Scalars['Float']['output']>;
  horizontal_margin_percentage: Scalars['Float']['output'];
  justify_content: Scalars['String']['output'];
  max_words_per_line: Scalars['Int']['output'];
  remove_punctuation?: Maybe<Scalars['Boolean']['output']>;
  shadow_color: Scalars['String']['output'];
  shadow_enabled: Scalars['Boolean']['output'];
  shadow_offset_x?: Maybe<Scalars['Float']['output']>;
  shadow_offset_y?: Maybe<Scalars['Float']['output']>;
  shadow_size: Scalars['Float']['output'];
  shadow_spread?: Maybe<Scalars['Float']['output']>;
  shadow_style?: Maybe<Scalars['String']['output']>;
  stroke_color?: Maybe<Scalars['String']['output']>;
  stroke_enabled?: Maybe<Scalars['Boolean']['output']>;
  stroke_width?: Maybe<Scalars['Float']['output']>;
  subtitle_color: Scalars['String']['output'];
  subtitle_font_id: Scalars['ID']['output'];
  subtitle_font_size: Scalars['Float']['output'];
  subtitle_highlight_color?: Maybe<Scalars['String']['output']>;
  subtitle_highlight_enabled: Scalars['Boolean']['output'];
  text_align?: Maybe<Scalars['String']['output']>;
  text_transform?: Maybe<Scalars['String']['output']>;
  vertical_margin_percentage: Scalars['Float']['output'];
};

export type BrandKitSubtitleSettingsInput = {
  align_items: Scalars['String']['input'];
  animation: Scalars['String']['input'];
  background_color: Scalars['String']['input'];
  background_enabled: Scalars['Boolean']['input'];
  background_height: Scalars['Float']['input'];
  background_opacity: Scalars['Float']['input'];
  background_width: Scalars['Float']['input'];
  highlight_box_background_color: Scalars['String']['input'];
  highlight_box_border_radius: Scalars['Float']['input'];
  highlight_box_enabled: Scalars['Boolean']['input'];
  highlight_box_padding_x: Scalars['Float']['input'];
  highlight_box_padding_y: Scalars['Float']['input'];
  horizontal_margin_percentage: Scalars['Float']['input'];
  justify_content: Scalars['String']['input'];
  max_words_per_line: Scalars['Int']['input'];
  remove_punctuation?: InputMaybe<Scalars['Boolean']['input']>;
  shadow_color: Scalars['String']['input'];
  shadow_enabled: Scalars['Boolean']['input'];
  shadow_offset_x?: InputMaybe<Scalars['Float']['input']>;
  shadow_offset_y?: InputMaybe<Scalars['Float']['input']>;
  shadow_size: Scalars['Float']['input'];
  shadow_spread?: InputMaybe<Scalars['Float']['input']>;
  shadow_style?: InputMaybe<Scalars['String']['input']>;
  stroke_color?: InputMaybe<Scalars['String']['input']>;
  stroke_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  stroke_width?: InputMaybe<Scalars['Float']['input']>;
  subtitle_color: Scalars['String']['input'];
  subtitle_font_id: Scalars['ID']['input'];
  subtitle_font_size: Scalars['Float']['input'];
  subtitle_highlight_color?: InputMaybe<Scalars['String']['input']>;
  subtitle_highlight_enabled: Scalars['Boolean']['input'];
  text_align?: InputMaybe<Scalars['String']['input']>;
  text_transform?: InputMaybe<Scalars['String']['input']>;
  vertical_margin_percentage: Scalars['Float']['input'];
};

export type BrandLead = {
  __typename?: 'BrandLead';
  assigned_to?: Maybe<Scalars['String']['output']>;
  brief?: Maybe<Scalars['JSON']['output']>;
  budget: Enum_Brandlead_Budget;
  calendly_event_uri?: Maybe<Scalars['String']['output']>;
  company?: Maybe<Scalars['String']['output']>;
  consent_at?: Maybe<Scalars['DateTime']['output']>;
  content_type?: Maybe<Scalars['JSON']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  demand_type?: Maybe<Scalars['String']['output']>;
  documentId: Scalars['ID']['output'];
  email: Scalars['String']['output'];
  events: Array<Maybe<BrandLeadEvent>>;
  events_connection?: Maybe<BrandLeadEventRelationResponseCollection>;
  iago?: Maybe<Scalars['JSON']['output']>;
  lead_token?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  objective?: Maybe<Scalars['String']['output']>;
  opted_out_at?: Maybe<Scalars['DateTime']['output']>;
  phone: Scalars['String']['output'];
  phone_country?: Maybe<Scalars['String']['output']>;
  phone_e164?: Maybe<Scalars['String']['output']>;
  platforms?: Maybe<Scalars['String']['output']>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  social?: Maybe<Scalars['String']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  state: Enum_Brandlead_State;
  state_updated_at?: Maybe<Scalars['DateTime']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  utm?: Maybe<Scalars['JSON']['output']>;
  website?: Maybe<Scalars['String']['output']>;
  whatsapp_window_opens_at?: Maybe<Scalars['DateTime']['output']>;
};


export type BrandLeadEventsArgs = {
  filters?: InputMaybe<BrandLeadEventFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type BrandLeadEvents_ConnectionArgs = {
  filters?: InputMaybe<BrandLeadEventFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type BrandLeadEntityResponseCollection = {
  __typename?: 'BrandLeadEntityResponseCollection';
  nodes: Array<BrandLead>;
  pageInfo: Pagination;
};

export type BrandLeadEvent = {
  __typename?: 'BrandLeadEvent';
  actor: Enum_Brandleadevent_Actor;
  brand_lead?: Maybe<BrandLead>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  documentId: Scalars['ID']['output'];
  error_code?: Maybe<Scalars['String']['output']>;
  event_id: Scalars['String']['output'];
  latency_ms?: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  payload?: Maybe<Scalars['JSON']['output']>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  state_after?: Maybe<Scalars['String']['output']>;
  state_before?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type BrandLeadEventEntityResponseCollection = {
  __typename?: 'BrandLeadEventEntityResponseCollection';
  nodes: Array<BrandLeadEvent>;
  pageInfo: Pagination;
};

export type BrandLeadEventFiltersInput = {
  actor?: InputMaybe<StringFilterInput>;
  and?: InputMaybe<Array<InputMaybe<BrandLeadEventFiltersInput>>>;
  brand_lead?: InputMaybe<BrandLeadFiltersInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  documentId?: InputMaybe<IdFilterInput>;
  error_code?: InputMaybe<StringFilterInput>;
  event_id?: InputMaybe<StringFilterInput>;
  latency_ms?: InputMaybe<IntFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<BrandLeadEventFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<BrandLeadEventFiltersInput>>>;
  payload?: InputMaybe<JsonFilterInput>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  state_after?: InputMaybe<StringFilterInput>;
  state_before?: InputMaybe<StringFilterInput>;
  success?: InputMaybe<BooleanFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type BrandLeadEventInput = {
  actor?: InputMaybe<Enum_Brandleadevent_Actor>;
  brand_lead?: InputMaybe<Scalars['ID']['input']>;
  error_code?: InputMaybe<Scalars['String']['input']>;
  event_id?: InputMaybe<Scalars['String']['input']>;
  latency_ms?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  payload?: InputMaybe<Scalars['JSON']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  state_after?: InputMaybe<Scalars['String']['input']>;
  state_before?: InputMaybe<Scalars['String']['input']>;
  success?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BrandLeadEventRelationResponseCollection = {
  __typename?: 'BrandLeadEventRelationResponseCollection';
  nodes: Array<BrandLeadEvent>;
};

export type BrandLeadFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<BrandLeadFiltersInput>>>;
  assigned_to?: InputMaybe<StringFilterInput>;
  brief?: InputMaybe<JsonFilterInput>;
  budget?: InputMaybe<StringFilterInput>;
  calendly_event_uri?: InputMaybe<StringFilterInput>;
  company?: InputMaybe<StringFilterInput>;
  consent_at?: InputMaybe<DateTimeFilterInput>;
  content_type?: InputMaybe<JsonFilterInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  demand_type?: InputMaybe<StringFilterInput>;
  documentId?: InputMaybe<IdFilterInput>;
  email?: InputMaybe<StringFilterInput>;
  events?: InputMaybe<BrandLeadEventFiltersInput>;
  iago?: InputMaybe<JsonFilterInput>;
  lead_token?: InputMaybe<StringFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<BrandLeadFiltersInput>;
  objective?: InputMaybe<StringFilterInput>;
  opted_out_at?: InputMaybe<DateTimeFilterInput>;
  or?: InputMaybe<Array<InputMaybe<BrandLeadFiltersInput>>>;
  phone?: InputMaybe<StringFilterInput>;
  phone_country?: InputMaybe<StringFilterInput>;
  phone_e164?: InputMaybe<StringFilterInput>;
  platforms?: InputMaybe<StringFilterInput>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  social?: InputMaybe<StringFilterInput>;
  source?: InputMaybe<StringFilterInput>;
  state?: InputMaybe<StringFilterInput>;
  state_updated_at?: InputMaybe<DateTimeFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
  utm?: InputMaybe<JsonFilterInput>;
  website?: InputMaybe<StringFilterInput>;
  whatsapp_window_opens_at?: InputMaybe<DateTimeFilterInput>;
};

export type BrandLeadInput = {
  assigned_to?: InputMaybe<Scalars['String']['input']>;
  brief?: InputMaybe<Scalars['JSON']['input']>;
  budget?: InputMaybe<Enum_Brandlead_Budget>;
  calendly_event_uri?: InputMaybe<Scalars['String']['input']>;
  company?: InputMaybe<Scalars['String']['input']>;
  consent_at?: InputMaybe<Scalars['DateTime']['input']>;
  content_type?: InputMaybe<Scalars['JSON']['input']>;
  demand_type?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  events?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  iago?: InputMaybe<Scalars['JSON']['input']>;
  lead_token?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  objective?: InputMaybe<Scalars['String']['input']>;
  opted_out_at?: InputMaybe<Scalars['DateTime']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  phone_country?: InputMaybe<Scalars['String']['input']>;
  phone_e164?: InputMaybe<Scalars['String']['input']>;
  platforms?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  social?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Enum_Brandlead_State>;
  state_updated_at?: InputMaybe<Scalars['DateTime']['input']>;
  utm?: InputMaybe<Scalars['JSON']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
  whatsapp_window_opens_at?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CampaignAuditContent = {
  __typename?: 'CampaignAuditContent';
  banner_url?: Maybe<Scalars['String']['output']>;
  content_locked: Scalars['Boolean']['output'];
  description?: Maybe<Scalars['String']['output']>;
  editing_locked_reason?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  logo_url?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  required_hashtags?: Maybe<Scalars['String']['output']>;
  required_mention?: Maybe<Scalars['String']['output']>;
  rules_allowed?: Maybe<Scalars['String']['output']>;
  rules_attention?: Maybe<Scalars['String']['output']>;
  rules_forbidden?: Maybe<Scalars['String']['output']>;
  rules_warning?: Maybe<Scalars['String']['output']>;
  scheduled_activation_at?: Maybe<Scalars['String']['output']>;
};

export type CampaignAuditContentInput = {
  banner_url?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  logo_url?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  required_hashtags?: InputMaybe<Scalars['String']['input']>;
  required_mention?: InputMaybe<Scalars['String']['input']>;
  rules_allowed?: InputMaybe<Scalars['String']['input']>;
  rules_attention?: InputMaybe<Scalars['String']['input']>;
  rules_forbidden?: InputMaybe<Scalars['String']['input']>;
  rules_warning?: InputMaybe<Scalars['String']['input']>;
};

export type CampaignEntryState = {
  __typename?: 'CampaignEntryState';
  account_id: Scalars['ID']['output'];
  campaign_id?: Maybe<Scalars['ID']['output']>;
  skip_onboarding: Scalars['Boolean']['output'];
};

export type CampaignWatermark = {
  __typename?: 'CampaignWatermark';
  anchor: Scalars['String']['output'];
  image_url: Scalars['String']['output'];
  margin_x_percent: Scalars['Float']['output'];
  margin_y_percent: Scalars['Float']['output'];
  opacity_percent: Scalars['Float']['output'];
  size_percent: Scalars['Float']['output'];
};

export type ChallengeApplication = {
  __typename?: 'ChallengeApplication';
  city: Scalars['String']['output'];
  clip_experience_duration?: Maybe<Enum_Challengeapplication_Clip_Experience_Duration>;
  competition_experience: Enum_Challengeapplication_Competition_Experience;
  content_creation_experience: Enum_Challengeapplication_Content_Creation_Experience;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  documentId: Scalars['ID']['output'];
  editing_device: Enum_Challengeapplication_Editing_Device;
  email?: Maybe<Scalars['String']['output']>;
  full_name: Scalars['String']['output'];
  has_clip_channel: Enum_Challengeapplication_Has_Clip_Channel;
  has_monetized_channel: Enum_Challengeapplication_Has_Monetized_Channel;
  motivation: Scalars['String']['output'];
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  state: Enum_Challengeapplication_State;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  utm_campaign?: Maybe<Scalars['String']['output']>;
  utm_content?: Maybe<Scalars['String']['output']>;
  utm_medium?: Maybe<Scalars['String']['output']>;
  utm_source?: Maybe<Scalars['String']['output']>;
  utm_term?: Maybe<Scalars['String']['output']>;
  whatsapp: Scalars['String']['output'];
};

export type ChallengeApplicationEntityResponseCollection = {
  __typename?: 'ChallengeApplicationEntityResponseCollection';
  nodes: Array<ChallengeApplication>;
  pageInfo: Pagination;
};

export type ChallengeApplicationFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ChallengeApplicationFiltersInput>>>;
  city?: InputMaybe<StringFilterInput>;
  clip_experience_duration?: InputMaybe<StringFilterInput>;
  competition_experience?: InputMaybe<StringFilterInput>;
  content_creation_experience?: InputMaybe<StringFilterInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  documentId?: InputMaybe<IdFilterInput>;
  editing_device?: InputMaybe<StringFilterInput>;
  email?: InputMaybe<StringFilterInput>;
  full_name?: InputMaybe<StringFilterInput>;
  has_clip_channel?: InputMaybe<StringFilterInput>;
  has_monetized_channel?: InputMaybe<StringFilterInput>;
  motivation?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ChallengeApplicationFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ChallengeApplicationFiltersInput>>>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  state?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
  utm_campaign?: InputMaybe<StringFilterInput>;
  utm_content?: InputMaybe<StringFilterInput>;
  utm_medium?: InputMaybe<StringFilterInput>;
  utm_source?: InputMaybe<StringFilterInput>;
  utm_term?: InputMaybe<StringFilterInput>;
  whatsapp?: InputMaybe<StringFilterInput>;
};

export type ChallengeApplicationInput = {
  city?: InputMaybe<Scalars['String']['input']>;
  clip_experience_duration?: InputMaybe<Enum_Challengeapplication_Clip_Experience_Duration>;
  competition_experience?: InputMaybe<Enum_Challengeapplication_Competition_Experience>;
  content_creation_experience?: InputMaybe<Enum_Challengeapplication_Content_Creation_Experience>;
  editing_device?: InputMaybe<Enum_Challengeapplication_Editing_Device>;
  email?: InputMaybe<Scalars['String']['input']>;
  full_name?: InputMaybe<Scalars['String']['input']>;
  has_clip_channel?: InputMaybe<Enum_Challengeapplication_Has_Clip_Channel>;
  has_monetized_channel?: InputMaybe<Enum_Challengeapplication_Has_Monetized_Channel>;
  motivation?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  state?: InputMaybe<Enum_Challengeapplication_State>;
  utm_campaign?: InputMaybe<Scalars['String']['input']>;
  utm_content?: InputMaybe<Scalars['String']['input']>;
  utm_medium?: InputMaybe<Scalars['String']['input']>;
  utm_source?: InputMaybe<Scalars['String']['input']>;
  utm_term?: InputMaybe<Scalars['String']['input']>;
  whatsapp?: InputMaybe<Scalars['String']['input']>;
};

export type ChallengeClip = {
  __typename?: 'ChallengeClip';
  admin_approval: Scalars['String']['output'];
  approval_reason?: Maybe<Scalars['String']['output']>;
  challenge_clip_views?: Maybe<Array<ChallengeClipView>>;
  createdAt: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  platform: Scalars['String']['output'];
  total_views?: Maybe<Scalars['String']['output']>;
  url: Scalars['String']['output'];
  validated_hashtags: Scalars['String']['output'];
};

export type ChallengeClipValidation = {
  __typename?: 'ChallengeClipValidation';
  hashtags_valid: Scalars['Boolean']['output'];
  missing_hashtags: Array<Scalars['String']['output']>;
};

export type ChallengeClipView = {
  __typename?: 'ChallengeClipView';
  comments?: Maybe<Scalars['String']['output']>;
  date: Scalars['String']['output'];
  favorites?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  likes?: Maybe<Scalars['String']['output']>;
  platform: Scalars['String']['output'];
  saves?: Maybe<Scalars['String']['output']>;
  shares?: Maybe<Scalars['String']['output']>;
  views?: Maybe<Scalars['String']['output']>;
};

export type ChallengeParticipation = {
  __typename?: 'ChallengeParticipation';
  challenge_clips?: Maybe<Array<ChallengeClip>>;
  createdAt: Scalars['String']['output'];
  disqualification_reason?: Maybe<Scalars['String']['output']>;
  disqualified?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  total_views?: Maybe<Scalars['String']['output']>;
  user_email?: Maybe<Scalars['String']['output']>;
  user_id: Scalars['ID']['output'];
  user_name?: Maybe<Scalars['String']['output']>;
  user_profile_picture?: Maybe<Scalars['String']['output']>;
};

export type ChallengeRanking = {
  __typename?: 'ChallengeRanking';
  admin_validated: Scalars['Boolean']['output'];
  consolidated_at?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  is_consolidated: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  partial_ranking?: Maybe<Array<ChallengeRankingEntry>>;
  ranking_data?: Maybe<Scalars['JSON']['output']>;
  time_until_end_seconds?: Maybe<Scalars['Int']['output']>;
  time_until_start_seconds?: Maybe<Scalars['Int']['output']>;
  timezone: Scalars['String']['output'];
};

export type ChallengeRankingEntry = {
  __typename?: 'ChallengeRankingEntry';
  clip_count?: Maybe<Scalars['Int']['output']>;
  participation_id: Scalars['ID']['output'];
  total_views?: Maybe<Scalars['String']['output']>;
  user_id: Scalars['ID']['output'];
  user_name?: Maybe<Scalars['String']['output']>;
  user_profile_picture?: Maybe<Scalars['String']['output']>;
};

export type ChallengeViewsTimeSeriesEntry = {
  __typename?: 'ChallengeViewsTimeSeriesEntry';
  clip_count: Scalars['Int']['output'];
  date: Scalars['String']['output'];
  total_views: Scalars['String']['output'];
};

export type Clip = {
  __typename?: 'Clip';
  clip_order?: Maybe<Scalars['Int']['output']>;
  clip_score?: Maybe<Scalars['Float']['output']>;
  clip_views: Array<Maybe<ClipView>>;
  clip_views_connection?: Maybe<ClipViewRelationResponseCollection>;
  clipped_video?: Maybe<UploadFile>;
  clipping_by?: Maybe<Scalars['String']['output']>;
  clipping_seconds?: Maybe<Scalars['Float']['output']>;
  clipping_status?: Maybe<Enum_Clip_Clipping_Status>;
  clipping_wait_seconds?: Maybe<Scalars['Float']['output']>;
  compressed_video?: Maybe<UploadFile>;
  copies: Array<Maybe<CopyGeneration>>;
  copies_connection?: Maybe<CopyGenerationRelationResponseCollection>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  created_by_user?: Maybe<UsersPermissionsUser>;
  curation_rating?: Maybe<Enum_Clip_Curation_Rating>;
  data?: Maybe<Scalars['JSON']['output']>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  dirty?: Maybe<Scalars['Boolean']['output']>;
  documentId: Scalars['ID']['output'];
  duration_seconds?: Maybe<Scalars['Float']['output']>;
  finished_video?: Maybe<UploadFile>;
  finished_video_thumbnail?: Maybe<UploadFile>;
  hide_in_project?: Maybe<Scalars['Boolean']['output']>;
  instagram_url?: Maybe<Scalars['String']['output']>;
  last_copy?: Maybe<CopyGeneration>;
  message_chat_id?: Maybe<Scalars['String']['output']>;
  message_id?: Maybe<Scalars['String']['output']>;
  message_thread_id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  original_clip_end_time?: Maybe<Scalars['Float']['output']>;
  original_clip_start_time?: Maybe<Scalars['Float']['output']>;
  preparing_by?: Maybe<Scalars['String']['output']>;
  preparing_seconds?: Maybe<Scalars['Float']['output']>;
  preparing_status?: Maybe<Enum_Clip_Preparing_Status>;
  preparing_wait_seconds?: Maybe<Scalars['Float']['output']>;
  processing_status?: Maybe<Enum_Clip_Processing_Status>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  rendering_by?: Maybe<Scalars['String']['output']>;
  rendering_failure_code?: Maybe<Scalars['String']['output']>;
  rendering_failure_message?: Maybe<Scalars['String']['output']>;
  rendering_seconds?: Maybe<Scalars['Float']['output']>;
  rendering_status?: Maybe<Enum_Clip_Rendering_Status>;
  rendering_wait_seconds?: Maybe<Scalars['Float']['output']>;
  source_clip?: Maybe<Clip>;
  thumbnail?: Maybe<UploadFile>;
  tiktok_url?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  usage_record?: Maybe<UsageRecord>;
  version_number?: Maybe<Scalars['Int']['output']>;
  watermark?: Maybe<Scalars['Boolean']['output']>;
  watermarked_video?: Maybe<UploadFile>;
  youtube_url?: Maybe<Scalars['String']['output']>;
};


export type ClipClip_ViewsArgs = {
  filters?: InputMaybe<ClipViewFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type ClipClip_Views_ConnectionArgs = {
  filters?: InputMaybe<ClipViewFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type ClipCopiesArgs = {
  filters?: InputMaybe<CopyGenerationFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type ClipCopies_ConnectionArgs = {
  filters?: InputMaybe<CopyGenerationFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ClipEntityResponseCollection = {
  __typename?: 'ClipEntityResponseCollection';
  nodes: Array<Clip>;
  pageInfo: Pagination;
};

export type ClipFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ClipFiltersInput>>>;
  clip_order?: InputMaybe<IntFilterInput>;
  clip_score?: InputMaybe<FloatFilterInput>;
  clip_views?: InputMaybe<ClipViewFiltersInput>;
  clipping_by?: InputMaybe<StringFilterInput>;
  clipping_seconds?: InputMaybe<FloatFilterInput>;
  clipping_status?: InputMaybe<StringFilterInput>;
  clipping_wait_seconds?: InputMaybe<FloatFilterInput>;
  copies?: InputMaybe<CopyGenerationFiltersInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  created_by_user?: InputMaybe<UsersPermissionsUserFiltersInput>;
  curation_rating?: InputMaybe<StringFilterInput>;
  data?: InputMaybe<JsonFilterInput>;
  deleted?: InputMaybe<BooleanFilterInput>;
  dirty?: InputMaybe<BooleanFilterInput>;
  documentId?: InputMaybe<IdFilterInput>;
  duration_seconds?: InputMaybe<FloatFilterInput>;
  hide_in_project?: InputMaybe<BooleanFilterInput>;
  instagram_url?: InputMaybe<StringFilterInput>;
  last_copy?: InputMaybe<CopyGenerationFiltersInput>;
  message_chat_id?: InputMaybe<StringFilterInput>;
  message_id?: InputMaybe<StringFilterInput>;
  message_thread_id?: InputMaybe<IntFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ClipFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ClipFiltersInput>>>;
  original_clip_end_time?: InputMaybe<FloatFilterInput>;
  original_clip_start_time?: InputMaybe<FloatFilterInput>;
  preparing_by?: InputMaybe<StringFilterInput>;
  preparing_seconds?: InputMaybe<FloatFilterInput>;
  preparing_status?: InputMaybe<StringFilterInput>;
  preparing_wait_seconds?: InputMaybe<FloatFilterInput>;
  processing_status?: InputMaybe<StringFilterInput>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  rendering_by?: InputMaybe<StringFilterInput>;
  rendering_failure_code?: InputMaybe<StringFilterInput>;
  rendering_failure_message?: InputMaybe<StringFilterInput>;
  rendering_seconds?: InputMaybe<FloatFilterInput>;
  rendering_status?: InputMaybe<StringFilterInput>;
  rendering_wait_seconds?: InputMaybe<FloatFilterInput>;
  source_clip?: InputMaybe<ClipFiltersInput>;
  tiktok_url?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
  usage_record?: InputMaybe<UsageRecordFiltersInput>;
  version_number?: InputMaybe<IntFilterInput>;
  watermark?: InputMaybe<BooleanFilterInput>;
  youtube_url?: InputMaybe<StringFilterInput>;
};

export type ClipInput = {
  clip_order?: InputMaybe<Scalars['Int']['input']>;
  clip_score?: InputMaybe<Scalars['Float']['input']>;
  clip_views?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  clipped_video?: InputMaybe<Scalars['ID']['input']>;
  clipping_by?: InputMaybe<Scalars['String']['input']>;
  clipping_seconds?: InputMaybe<Scalars['Float']['input']>;
  clipping_status?: InputMaybe<Enum_Clip_Clipping_Status>;
  clipping_wait_seconds?: InputMaybe<Scalars['Float']['input']>;
  compressed_video?: InputMaybe<Scalars['ID']['input']>;
  copies?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  created_by_user?: InputMaybe<Scalars['ID']['input']>;
  curation_rating?: InputMaybe<Enum_Clip_Curation_Rating>;
  data?: InputMaybe<Scalars['JSON']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  dirty?: InputMaybe<Scalars['Boolean']['input']>;
  duration_seconds?: InputMaybe<Scalars['Float']['input']>;
  finished_video?: InputMaybe<Scalars['ID']['input']>;
  finished_video_thumbnail?: InputMaybe<Scalars['ID']['input']>;
  hide_in_project?: InputMaybe<Scalars['Boolean']['input']>;
  instagram_url?: InputMaybe<Scalars['String']['input']>;
  last_copy?: InputMaybe<Scalars['ID']['input']>;
  message_chat_id?: InputMaybe<Scalars['String']['input']>;
  message_id?: InputMaybe<Scalars['String']['input']>;
  message_thread_id?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  original_clip_end_time?: InputMaybe<Scalars['Float']['input']>;
  original_clip_start_time?: InputMaybe<Scalars['Float']['input']>;
  preparing_by?: InputMaybe<Scalars['String']['input']>;
  preparing_seconds?: InputMaybe<Scalars['Float']['input']>;
  preparing_status?: InputMaybe<Enum_Clip_Preparing_Status>;
  preparing_wait_seconds?: InputMaybe<Scalars['Float']['input']>;
  processing_status?: InputMaybe<Enum_Clip_Processing_Status>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  rendering_by?: InputMaybe<Scalars['String']['input']>;
  rendering_failure_code?: InputMaybe<Scalars['String']['input']>;
  rendering_failure_message?: InputMaybe<Scalars['String']['input']>;
  rendering_seconds?: InputMaybe<Scalars['Float']['input']>;
  rendering_status?: InputMaybe<Enum_Clip_Rendering_Status>;
  rendering_wait_seconds?: InputMaybe<Scalars['Float']['input']>;
  source_clip?: InputMaybe<Scalars['ID']['input']>;
  thumbnail?: InputMaybe<Scalars['ID']['input']>;
  tiktok_url?: InputMaybe<Scalars['String']['input']>;
  usage_record?: InputMaybe<Scalars['ID']['input']>;
  version_number?: InputMaybe<Scalars['Int']['input']>;
  watermark?: InputMaybe<Scalars['Boolean']['input']>;
  watermarked_video?: InputMaybe<Scalars['ID']['input']>;
  youtube_url?: InputMaybe<Scalars['String']['input']>;
};

export type ClipMcpGrant = {
  __typename?: 'ClipMcpGrant';
  expires_at?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  label?: Maybe<Scalars['String']['output']>;
  last_used_at?: Maybe<Scalars['DateTime']['output']>;
  revoked_at?: Maybe<Scalars['DateTime']['output']>;
};

export type ClipProjectInput = {
  action: Scalars['String']['input'];
  aspect_ratio_format?: InputMaybe<Scalars['String']['input']>;
  brand_kit_id?: InputMaybe<Scalars['ID']['input']>;
  hide_in_project?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  preset?: InputMaybe<Scalars['String']['input']>;
  project_id: Scalars['ID']['input'];
  segments: Array<ClipSegment>;
};

export type ClipRelationResponseCollection = {
  __typename?: 'ClipRelationResponseCollection';
  nodes: Array<Clip>;
};

export type ClipSegment = {
  end: Scalars['Float']['input'];
  start: Scalars['Float']['input'];
};

export type ClipView = {
  __typename?: 'ClipView';
  clip?: Maybe<Clip>;
  comments?: Maybe<Scalars['Long']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  date: Scalars['Date']['output'];
  documentId: Scalars['ID']['output'];
  favorites?: Maybe<Scalars['Long']['output']>;
  likes?: Maybe<Scalars['Long']['output']>;
  platform: Enum_Clipview_Platform;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  raw_data?: Maybe<Scalars['JSON']['output']>;
  saves?: Maybe<Scalars['Long']['output']>;
  shares?: Maybe<Scalars['Long']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  views?: Maybe<Scalars['Long']['output']>;
};

export type ClipViewEntityResponseCollection = {
  __typename?: 'ClipViewEntityResponseCollection';
  nodes: Array<ClipView>;
  pageInfo: Pagination;
};

export type ClipViewFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ClipViewFiltersInput>>>;
  clip?: InputMaybe<ClipFiltersInput>;
  comments?: InputMaybe<LongFilterInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  date?: InputMaybe<DateFilterInput>;
  documentId?: InputMaybe<IdFilterInput>;
  favorites?: InputMaybe<LongFilterInput>;
  likes?: InputMaybe<LongFilterInput>;
  not?: InputMaybe<ClipViewFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ClipViewFiltersInput>>>;
  platform?: InputMaybe<StringFilterInput>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  raw_data?: InputMaybe<JsonFilterInput>;
  saves?: InputMaybe<LongFilterInput>;
  shares?: InputMaybe<LongFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
  views?: InputMaybe<LongFilterInput>;
};

export type ClipViewInput = {
  clip?: InputMaybe<Scalars['ID']['input']>;
  comments?: InputMaybe<Scalars['Long']['input']>;
  date?: InputMaybe<Scalars['Date']['input']>;
  favorites?: InputMaybe<Scalars['Long']['input']>;
  likes?: InputMaybe<Scalars['Long']['input']>;
  platform?: InputMaybe<Enum_Clipview_Platform>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  raw_data?: InputMaybe<Scalars['JSON']['input']>;
  saves?: InputMaybe<Scalars['Long']['input']>;
  shares?: InputMaybe<Scalars['Long']['input']>;
  views?: InputMaybe<Scalars['Long']['input']>;
};

export type ClipViewRelationResponseCollection = {
  __typename?: 'ClipViewRelationResponseCollection';
  nodes: Array<ClipView>;
};

export type ClipperHallClipper = {
  __typename?: 'ClipperHallClipper';
  anonymous: Scalars['Boolean']['output'];
  avatar_url?: Maybe<Scalars['String']['output']>;
  current_tier_ids: Array<Scalars['String']['output']>;
  families: Array<ClipperRankFamily>;
  lifetime_views: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
  user_id?: Maybe<Scalars['ID']['output']>;
  video_count: Scalars['Int']['output'];
};

export type ClipperRankBadge = {
  __typename?: 'ClipperRankBadge';
  season_id?: Maybe<Scalars['ID']['output']>;
  season_name?: Maybe<Scalars['String']['output']>;
  tier_id: Scalars['String']['output'];
};

export type ClipperRankFamily = {
  __typename?: 'ClipperRankFamily';
  badges: Array<ClipperRankBadge>;
  featured_tier_id?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
};

export type ClipperRankHall = {
  __typename?: 'ClipperRankHall';
  clippers: Array<ClipperHallClipper>;
  page_info: ClipperRankHallPageInfo;
  season?: Maybe<ClipperSeasonHall>;
};

export type ClipperRankHallPageInfo = {
  __typename?: 'ClipperRankHallPageInfo';
  limit: Scalars['Int']['output'];
  offset: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ClipperRankTrack = {
  __typename?: 'ClipperRankTrack';
  current_tier_id?: Maybe<Scalars['String']['output']>;
  id: ClipperRankTrackId;
  metric: Scalars['String']['output'];
  next_threshold?: Maybe<Scalars['String']['output']>;
  unlocked_tier_ids: Array<Scalars['String']['output']>;
};

export enum ClipperRankTrackId {
  Affiliate = 'affiliate',
  CampaignMoney = 'campaign_money',
  Campaigns = 'campaigns',
  Renders = 'renders',
  Views = 'views'
}

export type ClipperRunAdmission = {
  __typename?: 'ClipperRunAdmission';
  id: Scalars['ID']['output'];
  personalBest: Scalars['Int']['output'];
  rulesVersion: Scalars['Int']['output'];
  seed: Scalars['Int']['output'];
};

export type ClipperRunInputEvent = {
  action: Scalars['String']['input'];
  frame: Scalars['Int']['input'];
};

export type ClipperRunResult = {
  __typename?: 'ClipperRunResult';
  personalBest: Scalars['Int']['output'];
  score: Scalars['Int']['output'];
};

export type ClipperSeasonAdmin = {
  __typename?: 'ClipperSeasonAdmin';
  consolidated_at?: Maybe<Scalars['String']['output']>;
  documentId: Scalars['ID']['output'];
  ends_at: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  start_snapshotted_at?: Maybe<Scalars['String']['output']>;
  starts_at: Scalars['String']['output'];
  status: Scalars['String']['output'];
  timezone: Scalars['String']['output'];
};

export type ClipperSeasonHall = {
  __typename?: 'ClipperSeasonHall';
  ends_at?: Maybe<Scalars['String']['output']>;
  entries: Array<ClipperSeasonHallEntry>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  status: Scalars['String']['output'];
};

export type ClipperSeasonHallEntry = {
  __typename?: 'ClipperSeasonHallEntry';
  anonymous: Scalars['Boolean']['output'];
  avatar_url?: Maybe<Scalars['String']['output']>;
  families: Array<ClipperRankFamily>;
  name?: Maybe<Scalars['String']['output']>;
  rank: Scalars['Int']['output'];
  title_id?: Maybe<Scalars['String']['output']>;
  user_id?: Maybe<Scalars['ID']['output']>;
  video_count: Scalars['Int']['output'];
  views_delta: Scalars['String']['output'];
};

export type ClipperSeasonTitle = {
  __typename?: 'ClipperSeasonTitle';
  placement?: Maybe<Scalars['Int']['output']>;
  season_id: Scalars['ID']['output'];
  season_name: Scalars['String']['output'];
  title_id?: Maybe<Scalars['String']['output']>;
};

export type ClippingChallenge = {
  __typename?: 'ClippingChallenge';
  caption_examples?: Maybe<Array<Scalars['String']['output']>>;
  description?: Maybe<Scalars['String']['output']>;
  end_date?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  is_accepting_participants?: Maybe<Scalars['Boolean']['output']>;
  my_participation?: Maybe<ChallengeParticipation>;
  name: Scalars['String']['output'];
  prize_data?: Maybe<Scalars['JSON']['output']>;
  prize_pool: Scalars['Float']['output'];
  ranking?: Maybe<Array<ChallengeRankingEntry>>;
  rankings?: Maybe<Array<ChallengeRanking>>;
  required_hashtags?: Maybe<Scalars['String']['output']>;
  rules_allowed?: Maybe<Scalars['JSON']['output']>;
  rules_attention?: Maybe<Scalars['String']['output']>;
  rules_forbidden?: Maybe<Scalars['JSON']['output']>;
  start_date?: Maybe<Scalars['String']['output']>;
  warning_message?: Maybe<Scalars['String']['output']>;
};

export type CommunityLiveSession = {
  __typename?: 'CommunityLiveSession';
  id: Scalars['ID']['output'];
  library?: Maybe<CommunityLiveSessionLibrary>;
  live_url?: Maybe<Scalars['String']['output']>;
  platform: LiveWatchPlatform;
  started_at?: Maybe<Scalars['DateTime']['output']>;
  youtube_channel: AdminLiveWatchChannel;
};

export type CommunityLiveSessionLibrary = {
  __typename?: 'CommunityLiveSessionLibrary';
  base_video_url?: Maybe<Scalars['String']['output']>;
  duration_seconds: Scalars['Float']['output'];
  end_time?: Maybe<Scalars['Float']['output']>;
  format: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  language: Scalars['String']['output'];
  name: Scalars['String']['output'];
  start_time?: Maybe<Scalars['Float']['output']>;
  thumbnail_url?: Maybe<Scalars['String']['output']>;
};

export type ComponentBlogBlogMenuTags = {
  __typename?: 'ComponentBlogBlogMenuTags';
  id: Scalars['ID']['output'];
  tag?: Maybe<BlogTag>;
};

export type CopyGeneration = {
  __typename?: 'CopyGeneration';
  clip?: Maybe<Clip>;
  clip_last_copy?: Maybe<Clip>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  documentId: Scalars['ID']['output'];
  processing_status?: Maybe<Enum_Copygeneration_Processing_Status>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  result?: Maybe<Scalars['JSON']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type CopyGenerationEntityResponseCollection = {
  __typename?: 'CopyGenerationEntityResponseCollection';
  nodes: Array<CopyGeneration>;
  pageInfo: Pagination;
};

export type CopyGenerationFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<CopyGenerationFiltersInput>>>;
  clip?: InputMaybe<ClipFiltersInput>;
  clip_last_copy?: InputMaybe<ClipFiltersInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  documentId?: InputMaybe<IdFilterInput>;
  not?: InputMaybe<CopyGenerationFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<CopyGenerationFiltersInput>>>;
  processing_status?: InputMaybe<StringFilterInput>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  result?: InputMaybe<JsonFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type CopyGenerationInput = {
  clip?: InputMaybe<Scalars['ID']['input']>;
  clip_last_copy?: InputMaybe<Scalars['ID']['input']>;
  processing_status?: InputMaybe<Enum_Copygeneration_Processing_Status>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  result?: InputMaybe<Scalars['JSON']['input']>;
};

export type CopyGenerationRelationResponseCollection = {
  __typename?: 'CopyGenerationRelationResponseCollection';
  nodes: Array<CopyGeneration>;
};

export type Coupon = {
  __typename?: 'Coupon';
  assigned_user?: Maybe<UsersPermissionsUser>;
  code: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  documentId: Scalars['ID']['output'];
  expiry_date?: Maybe<Scalars['Date']['output']>;
  month_cycles: Scalars['Int']['output'];
  month_discount?: Maybe<Scalars['Int']['output']>;
  plans: Array<Maybe<Plan>>;
  plans_connection?: Maybe<PlanRelationResponseCollection>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  quantity: Scalars['Int']['output'];
  type: Enum_Coupon_Type;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  year_cycles?: Maybe<Scalars['Int']['output']>;
  year_discount?: Maybe<Scalars['Int']['output']>;
};


export type CouponPlansArgs = {
  filters?: InputMaybe<PlanFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type CouponPlans_ConnectionArgs = {
  filters?: InputMaybe<PlanFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CouponEntityResponseCollection = {
  __typename?: 'CouponEntityResponseCollection';
  nodes: Array<Coupon>;
  pageInfo: Pagination;
};

export type CouponFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<CouponFiltersInput>>>;
  assigned_user?: InputMaybe<UsersPermissionsUserFiltersInput>;
  code?: InputMaybe<StringFilterInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  documentId?: InputMaybe<IdFilterInput>;
  expiry_date?: InputMaybe<DateFilterInput>;
  month_cycles?: InputMaybe<IntFilterInput>;
  month_discount?: InputMaybe<IntFilterInput>;
  not?: InputMaybe<CouponFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<CouponFiltersInput>>>;
  plans?: InputMaybe<PlanFiltersInput>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  quantity?: InputMaybe<IntFilterInput>;
  type?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
  year_cycles?: InputMaybe<IntFilterInput>;
  year_discount?: InputMaybe<IntFilterInput>;
};

export type CouponInput = {
  assigned_user?: InputMaybe<Scalars['ID']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  expiry_date?: InputMaybe<Scalars['Date']['input']>;
  month_cycles?: InputMaybe<Scalars['Int']['input']>;
  month_discount?: InputMaybe<Scalars['Int']['input']>;
  plans?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<Enum_Coupon_Type>;
  year_cycles?: InputMaybe<Scalars['Int']['input']>;
  year_discount?: InputMaybe<Scalars['Int']['input']>;
};

export type CouponRelationResponseCollection = {
  __typename?: 'CouponRelationResponseCollection';
  nodes: Array<Coupon>;
};

export type CouponValidation = {
  __typename?: 'CouponValidation';
  coupon?: Maybe<CouponValidationData>;
  error?: Maybe<Scalars['String']['output']>;
  valid: Scalars['Boolean']['output'];
};

export type CouponValidationData = {
  __typename?: 'CouponValidationData';
  code: Scalars['String']['output'];
  cycles?: Maybe<Scalars['Int']['output']>;
  discount: Scalars['Int']['output'];
  expiry_date?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  quantity: Scalars['Int']['output'];
  type: Scalars['String']['output'];
};

export type Course = {
  __typename?: 'Course';
  description?: Maybe<Scalars['String']['output']>;
  durationLabel?: Maybe<Scalars['String']['output']>;
  freeModuleCount: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  isPurchasable: Scalars['Boolean']['output'];
  moduleCount: Scalars['Int']['output'];
  moduleGroups: Array<CourseModuleGroup>;
  order: Scalars['Int']['output'];
  ownedByViewer: Scalars['Boolean']['output'];
  price?: Maybe<Scalars['Float']['output']>;
  progressPercent: Scalars['Int']['output'];
  slug: Scalars['String']['output'];
  thumbnailUrl?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  ungroupedModules: Array<CourseModule>;
  weeksLabel?: Maybe<Scalars['String']['output']>;
};

export type CourseCoupon = {
  __typename?: 'CourseCoupon';
  code: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  discount: Scalars['Int']['output'];
  documentId: Scalars['ID']['output'];
  expiry_date?: Maybe<Scalars['Date']['output']>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  quantity: Scalars['Int']['output'];
  type: Enum_Coursecoupon_Type;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type CourseCouponEntityResponseCollection = {
  __typename?: 'CourseCouponEntityResponseCollection';
  nodes: Array<CourseCoupon>;
  pageInfo: Pagination;
};

export type CourseCouponFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<CourseCouponFiltersInput>>>;
  code?: InputMaybe<StringFilterInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  discount?: InputMaybe<IntFilterInput>;
  documentId?: InputMaybe<IdFilterInput>;
  expiry_date?: InputMaybe<DateFilterInput>;
  not?: InputMaybe<CourseCouponFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<CourseCouponFiltersInput>>>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  quantity?: InputMaybe<IntFilterInput>;
  type?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type CourseCouponInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  discount?: InputMaybe<Scalars['Int']['input']>;
  expiry_date?: InputMaybe<Scalars['Date']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<Enum_Coursecoupon_Type>;
};

export type CourseCouponValidation = {
  __typename?: 'CourseCouponValidation';
  amount?: Maybe<Scalars['Float']['output']>;
  code?: Maybe<Scalars['String']['output']>;
  discount?: Maybe<Scalars['Int']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  valid: Scalars['Boolean']['output'];
};

export type CourseModule = {
  __typename?: 'CourseModule';
  chapters: Array<CourseModuleChapter>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isCompleted: Scalars['Boolean']['output'];
  isFree: Scalars['Boolean']['output'];
  isLocked: Scalars['Boolean']['output'];
  order: Scalars['Int']['output'];
  thumbnailUrl?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  transcriptUrl?: Maybe<Scalars['String']['output']>;
  videoUrl?: Maybe<Scalars['String']['output']>;
};

export type CourseModuleChapter = {
  __typename?: 'CourseModuleChapter';
  startSeconds: Scalars['Float']['output'];
  title: Scalars['String']['output'];
};

export type CourseModuleGroup = {
  __typename?: 'CourseModuleGroup';
  id: Scalars['ID']['output'];
  label: Scalars['String']['output'];
  modules: Array<CourseModule>;
  order: Scalars['Int']['output'];
};

export type CoursePurchaseCheckout = {
  __typename?: 'CoursePurchaseCheckout';
  amount: Scalars['Float']['output'];
  purchase_id: Scalars['ID']['output'];
  url: Scalars['String']['output'];
};

export type CoursePurchasePhoneInput = {
  country: Scalars['String']['input'];
  e164: Scalars['String']['input'];
};

export type CoursePurchasePixOrder = {
  __typename?: 'CoursePurchasePixOrder';
  amount: Scalars['Float']['output'];
  expires_at?: Maybe<Scalars['String']['output']>;
  pix_code?: Maybe<Scalars['String']['output']>;
  pix_qr_code_url?: Maybe<Scalars['String']['output']>;
  purchase_id: Scalars['ID']['output'];
  status: Scalars['String']['output'];
};

export type CoursePurchaseStatus = {
  __typename?: 'CoursePurchaseStatus';
  status: Scalars['String']['output'];
};

export type CoursePurchaseUtmInput = {
  utm_campaign?: InputMaybe<Scalars['String']['input']>;
  utm_content?: InputMaybe<Scalars['String']['input']>;
  utm_medium?: InputMaybe<Scalars['String']['input']>;
  utm_source?: InputMaybe<Scalars['String']['input']>;
  utm_term?: InputMaybe<Scalars['String']['input']>;
};

export type CourseRevenueShareTotals = {
  __typename?: 'CourseRevenueShareTotals';
  accrued_cents: Scalars['Int']['output'];
  available_cents: Scalars['Int']['output'];
  pending_cents: Scalars['Int']['output'];
  reversed_cents: Scalars['Int']['output'];
};

export type CourseRoyaltyConfiguration = {
  __typename?: 'CourseRoyaltyConfiguration';
  active: Scalars['Boolean']['output'];
  course_id: Scalars['ID']['output'];
  course_title: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  rate_percent: Scalars['Int']['output'];
};

export type CourseRoyaltyEarning = {
  __typename?: 'CourseRoyaltyEarning';
  course_id: Scalars['ID']['output'];
  course_title: Scalars['String']['output'];
  gross_amount_cents: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  rate_percent: Scalars['Int']['output'];
  releases_at?: Maybe<Scalars['String']['output']>;
  royalty_cents: Scalars['Int']['output'];
  sale_date: Scalars['String']['output'];
  status: Scalars['String']['output'];
};

export type CourseRoyaltyEarningsPageInfo = {
  __typename?: 'CourseRoyaltyEarningsPageInfo';
  has_more: Scalars['Boolean']['output'];
  next_cursor?: Maybe<Scalars['String']['output']>;
};

export enum CoverAspect {
  Landscape = 'landscape',
  Portrait = 'portrait'
}

export type CpmAccountReliability = {
  __typename?: 'CpmAccountReliability';
  engagement_rate?: Maybe<Scalars['Float']['output']>;
  lifetime_views?: Maybe<Scalars['String']['output']>;
  platform?: Maybe<Scalars['String']['output']>;
  score?: Maybe<Scalars['Int']['output']>;
  status: CpmAccountReliabilityStatus;
  tracked_content?: Maybe<Scalars['Int']['output']>;
  username?: Maybe<Scalars['String']['output']>;
};

export enum CpmAccountReliabilityStatus {
  Low = 'low',
  Ok = 'ok',
  Unknown = 'unknown'
}

export type CpmCampaignParticipant = {
  __typename?: 'CpmCampaignParticipant';
  approved_count: Scalars['Int']['output'];
  disqualification_id?: Maybe<Scalars['ID']['output']>;
  disqualification_reason?: Maybe<Scalars['String']['output']>;
  disqualified: Scalars['Boolean']['output'];
  first_submitted_at?: Maybe<Scalars['String']['output']>;
  submission_count: Scalars['Int']['output'];
  total_earnings_cents: Scalars['Int']['output'];
  total_views: Scalars['String']['output'];
  user_email?: Maybe<Scalars['String']['output']>;
  user_id: Scalars['ID']['output'];
  user_name?: Maybe<Scalars['String']['output']>;
};

export type CpmCampaignParticipantsResult = {
  __typename?: 'CpmCampaignParticipantsResult';
  data: Array<CpmCampaignParticipant>;
  pageCount: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type CpmCampaignRanking = {
  __typename?: 'CpmCampaignRanking';
  admin_reports: Array<CpmRankingReport>;
  campaign_id: Scalars['ID']['output'];
  campaign_type: Scalars['String']['output'];
  can_finalize?: Maybe<Scalars['Boolean']['output']>;
  can_review: Scalars['Boolean']['output'];
  can_submit: Scalars['Boolean']['output'];
  config: Scalars['JSON']['output'];
  finalized_at?: Maybe<Scalars['DateTime']['output']>;
  last_view_sync_at?: Maybe<Scalars['DateTime']['output']>;
  my_progress?: Maybe<CpmRankingProgress>;
  my_row?: Maybe<CpmRankingRow>;
  own_reports: Array<CpmRankingReport>;
  pending_clip_count?: Maybe<Scalars['Int']['output']>;
  pending_metrics_count?: Maybe<Scalars['Int']['output']>;
  pending_reports_count: Scalars['Int']['output'];
  phase: Scalars['String']['output'];
  review_fingerprint: Scalars['String']['output'];
  rows: Array<CpmRankingRow>;
  unresolved_ties: Array<Array<Scalars['ID']['output']>>;
  winner_contact_url?: Maybe<Scalars['String']['output']>;
};

export type CpmCampaignReportConclusions = {
  __typename?: 'CpmCampaignReportConclusions';
  fingerprint: Scalars['String']['output'];
  generatedAt: Scalars['String']['output'];
  highlights: Array<CpmReportConclusionItem>;
  recommendations: Array<CpmReportConclusionItem>;
  summary: Scalars['String']['output'];
};

export type CpmCampaignSubmissionAppeal = {
  __typename?: 'CpmCampaignSubmissionAppeal';
  argument: Scalars['String']['output'];
  campaign_id?: Maybe<Scalars['ID']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  disapproval_cycle_at?: Maybe<Scalars['DateTime']['output']>;
  evidence_image_urls: Array<Scalars['String']['output']>;
  extra_url?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  original_approval_reason?: Maybe<Scalars['String']['output']>;
  platform?: Maybe<Scalars['String']['output']>;
  reviewed_at?: Maybe<Scalars['DateTime']['output']>;
  reviewer_images: Array<CpmReviewImage>;
  reviewer_reply?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  submission_id?: Maybe<Scalars['ID']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  user_email?: Maybe<Scalars['String']['output']>;
  user_id?: Maybe<Scalars['ID']['output']>;
  user_name?: Maybe<Scalars['String']['output']>;
};

export type CpmCampaignSubmissionAppealPage = {
  __typename?: 'CpmCampaignSubmissionAppealPage';
  data: Array<CpmCampaignSubmissionAppeal>;
  pageCount: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type CpmCampaignUserDisqualification = {
  __typename?: 'CpmCampaignUserDisqualification';
  createdAt: Scalars['String']['output'];
  disqualified_by_id?: Maybe<Scalars['ID']['output']>;
  disqualified_by_name?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  reason: Scalars['String']['output'];
  reclaimed_cents?: Maybe<Scalars['Int']['output']>;
  user_email?: Maybe<Scalars['String']['output']>;
  user_id?: Maybe<Scalars['ID']['output']>;
  user_name?: Maybe<Scalars['String']['output']>;
};

export type CpmCampaignVideo = {
  __typename?: 'CpmCampaignVideo';
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  thumbnail_url?: Maybe<Scalars['String']['output']>;
  video_id: Scalars['String']['output'];
  youtube_channels: Array<MyYoutubeChannel>;
};

export type CpmClipperLeaderboardEntry = {
  __typename?: 'CpmClipperLeaderboardEntry';
  anonymous: Scalars['Boolean']['output'];
  avatar_url?: Maybe<Scalars['String']['output']>;
  families: Array<ClipperRankFamily>;
  name?: Maybe<Scalars['String']['output']>;
  total_views: Scalars['String']['output'];
  user_id?: Maybe<Scalars['ID']['output']>;
  video_count: Scalars['Int']['output'];
  views_tier_id?: Maybe<Scalars['String']['output']>;
};

export type CpmClipperLeaderboardStanding = {
  __typename?: 'CpmClipperLeaderboardStanding';
  entries: Array<CpmClipperLeaderboardStandingEntry>;
  rank?: Maybe<Scalars['Int']['output']>;
  total: Scalars['Int']['output'];
};

export type CpmClipperLeaderboardStandingEntry = {
  __typename?: 'CpmClipperLeaderboardStandingEntry';
  anonymous: Scalars['Boolean']['output'];
  avatar_url?: Maybe<Scalars['String']['output']>;
  families: Array<ClipperRankFamily>;
  is_viewer: Scalars['Boolean']['output'];
  name?: Maybe<Scalars['String']['output']>;
  rank: Scalars['Int']['output'];
  total_views: Scalars['String']['output'];
  user_id?: Maybe<Scalars['ID']['output']>;
  video_count: Scalars['Int']['output'];
  views_tier_id?: Maybe<Scalars['String']['output']>;
};

export type CpmContentReviewGroup = {
  __typename?: 'CpmContentReviewGroup';
  decision: Scalars['String']['output'];
  decision_reason?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  submission_ids: Array<Scalars['ID']['output']>;
};

export type CpmOwnedMedia = {
  __typename?: 'CpmOwnedMedia';
  provider_media_id: Scalars['String']['output'];
  social_connection_id: Scalars['ID']['output'];
  username: Scalars['String']['output'];
};

export type CpmPayout = {
  __typename?: 'CpmPayout';
  amount_cents: Scalars['Int']['output'];
  bank_data?: Maybe<Scalars['JSON']['output']>;
  breakdown?: Maybe<Scalars['JSON']['output']>;
  cancelled_at?: Maybe<Scalars['DateTime']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  created_by?: Maybe<UsersPermissionsUser>;
  currency: Enum_Cpmpayout_Currency;
  documentId: Scalars['ID']['output'];
  kind?: Maybe<Enum_Cpmpayout_Kind>;
  note?: Maybe<Scalars['String']['output']>;
  paid_at?: Maybe<Scalars['DateTime']['output']>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  redemption_data?: Maybe<Scalars['JSON']['output']>;
  requested_at?: Maybe<Scalars['DateTime']['output']>;
  status?: Maybe<Enum_Cpmpayout_Status>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  user?: Maybe<UsersPermissionsUser>;
};

export type CpmPayoutEntityResponseCollection = {
  __typename?: 'CpmPayoutEntityResponseCollection';
  nodes: Array<CpmPayout>;
  pageInfo: Pagination;
};

export type CpmPayoutFiltersInput = {
  amount_cents?: InputMaybe<IntFilterInput>;
  and?: InputMaybe<Array<InputMaybe<CpmPayoutFiltersInput>>>;
  bank_data?: InputMaybe<JsonFilterInput>;
  breakdown?: InputMaybe<JsonFilterInput>;
  cancelled_at?: InputMaybe<DateTimeFilterInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  created_by?: InputMaybe<UsersPermissionsUserFiltersInput>;
  currency?: InputMaybe<StringFilterInput>;
  documentId?: InputMaybe<IdFilterInput>;
  kind?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<CpmPayoutFiltersInput>;
  note?: InputMaybe<StringFilterInput>;
  or?: InputMaybe<Array<InputMaybe<CpmPayoutFiltersInput>>>;
  paid_at?: InputMaybe<DateTimeFilterInput>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  redemption_data?: InputMaybe<JsonFilterInput>;
  requested_at?: InputMaybe<DateTimeFilterInput>;
  status?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
  user?: InputMaybe<UsersPermissionsUserFiltersInput>;
};

export type CpmPayoutInput = {
  amount_cents?: InputMaybe<Scalars['Int']['input']>;
  bank_data?: InputMaybe<Scalars['JSON']['input']>;
  breakdown?: InputMaybe<Scalars['JSON']['input']>;
  cancelled_at?: InputMaybe<Scalars['DateTime']['input']>;
  created_by?: InputMaybe<Scalars['ID']['input']>;
  currency?: InputMaybe<Enum_Cpmpayout_Currency>;
  kind?: InputMaybe<Enum_Cpmpayout_Kind>;
  note?: InputMaybe<Scalars['String']['input']>;
  paid_at?: InputMaybe<Scalars['DateTime']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  redemption_data?: InputMaybe<Scalars['JSON']['input']>;
  requested_at?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<Enum_Cpmpayout_Status>;
  user?: InputMaybe<Scalars['ID']['input']>;
};

export type CpmPayoutRelationResponseCollection = {
  __typename?: 'CpmPayoutRelationResponseCollection';
  nodes: Array<CpmPayout>;
};

export type CpmPayoutRequest = {
  __typename?: 'CpmPayoutRequest';
  amount_cents: Scalars['Int']['output'];
  currency: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  requested_at: Scalars['String']['output'];
  status: Scalars['String']['output'];
};

export type CpmRankingAccountReliability = {
  __typename?: 'CpmRankingAccountReliability';
  engagement_rate?: Maybe<Scalars['Float']['output']>;
  lifetime_views?: Maybe<Scalars['String']['output']>;
  score?: Maybe<Scalars['Int']['output']>;
  status: Scalars['String']['output'];
  tracked_content?: Maybe<Scalars['Int']['output']>;
  username?: Maybe<Scalars['String']['output']>;
};

export type CpmRankingBulkApproval = {
  __typename?: 'CpmRankingBulkApproval';
  approved: Array<Scalars['ID']['output']>;
  skipped: Array<CpmRankingBulkSkip>;
};

export type CpmRankingBulkRejection = {
  __typename?: 'CpmRankingBulkRejection';
  rejected: Array<Scalars['ID']['output']>;
  skipped: Array<CpmRankingBulkSkip>;
};

export type CpmRankingBulkSkip = {
  __typename?: 'CpmRankingBulkSkip';
  code: Scalars['String']['output'];
  id: Scalars['ID']['output'];
};

export type CpmRankingProgress = {
  __typename?: 'CpmRankingProgress';
  current_position?: Maybe<Scalars['Int']['output']>;
  estimated_clips_needed?: Maybe<Scalars['String']['output']>;
  next_position?: Maybe<Scalars['Int']['output']>;
  target_type: Scalars['String']['output'];
  views_needed?: Maybe<Scalars['String']['output']>;
};

export type CpmRankingReport = {
  __typename?: 'CpmRankingReport';
  account_reliability?: Maybe<CpmRankingAccountReliability>;
  admission_approved_at?: Maybe<Scalars['DateTime']['output']>;
  clip_approval?: Maybe<Scalars['String']['output']>;
  connected_account: Scalars['Boolean']['output'];
  created_at: Scalars['DateTime']['output'];
  evidence_url?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  last_view_sync_at?: Maybe<Scalars['DateTime']['output']>;
  metrics_status?: Maybe<Scalars['String']['output']>;
  ownership_verified: Scalars['Boolean']['output'];
  participant_id: Scalars['ID']['output'];
  platform: Scalars['String']['output'];
  profile_handle?: Maybe<Scalars['String']['output']>;
  profile_url?: Maybe<Scalars['String']['output']>;
  profile_verified: Scalars['Boolean']['output'];
  published_at?: Maybe<Scalars['DateTime']['output']>;
  ranked_views?: Maybe<Scalars['String']['output']>;
  reported_views?: Maybe<Scalars['String']['output']>;
  review_reason?: Maybe<Scalars['String']['output']>;
  reviewed_at?: Maybe<Scalars['DateTime']['output']>;
  rules_check?: Maybe<Scalars['JSON']['output']>;
  status: Scalars['String']['output'];
  submission_id?: Maybe<Scalars['ID']['output']>;
  tracked_views?: Maybe<Scalars['String']['output']>;
  tracked_views_captured_at?: Maybe<Scalars['DateTime']['output']>;
  tracked_views_source?: Maybe<Scalars['String']['output']>;
  url: Scalars['String']['output'];
  verified_views?: Maybe<Scalars['String']['output']>;
  views_captured_at?: Maybe<Scalars['DateTime']['output']>;
  views_source?: Maybe<Scalars['String']['output']>;
};

export type CpmRankingReportInput = {
  evidence_url: Scalars['String']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  platform: Scalars['String']['input'];
  profile_url: Scalars['String']['input'];
  published_at: Scalars['DateTime']['input'];
  reported_views: Scalars['String']['input'];
  url: Scalars['String']['input'];
};

export type CpmRankingReviewInput = {
  evidence_url?: InputMaybe<Scalars['String']['input']>;
  ownership_verified?: InputMaybe<Scalars['Boolean']['input']>;
  profile_url?: InputMaybe<Scalars['String']['input']>;
  profile_verified?: InputMaybe<Scalars['Boolean']['input']>;
  published_at?: InputMaybe<Scalars['DateTime']['input']>;
  reason: Scalars['String']['input'];
  status: Scalars['String']['input'];
  verified_views?: InputMaybe<Scalars['String']['input']>;
};

export type CpmRankingRow = {
  __typename?: 'CpmRankingRow';
  display_name: Scalars['String']['output'];
  eligible: Scalars['Boolean']['output'];
  is_self: Scalars['Boolean']['output'];
  participant_id?: Maybe<Scalars['ID']['output']>;
  place?: Maybe<Scalars['Int']['output']>;
  prize_cents: Scalars['Int']['output'];
  tie_pending?: Maybe<Scalars['Boolean']['output']>;
  total_views: Scalars['String']['output'];
  valid_post_count: Scalars['Int']['output'];
};

export type CpmReportConclusionItem = {
  __typename?: 'CpmReportConclusionItem';
  evidenceKeys: Array<Scalars['String']['output']>;
  text: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type CpmReviewImage = {
  __typename?: 'CpmReviewImage';
  url: Scalars['String']['output'];
  visibility: Scalars['String']['output'];
};

export type CpmReviewImageInput = {
  url: Scalars['String']['input'];
  visibility: Scalars['String']['input'];
};

export type CpmSubmissionViewSnapshot = {
  __typename?: 'CpmSubmissionViewSnapshot';
  comments: Scalars['String']['output'];
  date: Scalars['String']['output'];
  likes: Scalars['String']['output'];
  shares: Scalars['String']['output'];
  views: Scalars['String']['output'];
};

export type CpmSubmissionsAggregateStats = {
  __typename?: 'CpmSubmissionsAggregateStats';
  /** Peak views of approved submissions, including views after the paid window. */
  approved_views: Scalars['String']['output'];
  daily_series: Array<CpmSubmissionsTimeSeriesPoint>;
  /** Views approved submissions are paid on (in-window peak). */
  paid_views: Scalars['String']['output'];
  top_earning_clips: Array<CpmTopEarningClip>;
  total_earnings_cents: Scalars['Int']['output'];
  total_submissions: Scalars['Int']['output'];
  total_views: Scalars['String']['output'];
};

export type CpmSubmissionsTimeSeriesPoint = {
  __typename?: 'CpmSubmissionsTimeSeriesPoint';
  /** Approved views inside the paid accrual window (cumulative). */
  approved_paid_views: Scalars['String']['output'];
  /** Approved views that arrived after the paid window closed (cumulative). */
  approved_unpaid_views: Scalars['String']['output'];
  clip_count: Scalars['Int']['output'];
  date: Scalars['String']['output'];
  total_views: Scalars['String']['output'];
  /** Eligible but not-yet-approved (neutral) views (cumulative). */
  unapproved_views: Scalars['String']['output'];
};

export type CpmTopEarningClip = {
  __typename?: 'CpmTopEarningClip';
  earnings_cents: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  platform: Scalars['String']['output'];
  url: Scalars['String']['output'];
  user_email?: Maybe<Scalars['String']['output']>;
  user_name?: Maybe<Scalars['String']['output']>;
  views: Scalars['String']['output'];
};

export type CpmTopEarningClipsPage = {
  __typename?: 'CpmTopEarningClipsPage';
  data: Array<CpmTopEarningClip>;
  pageCount: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type CpmWallet = {
  __typename?: 'CpmWallet';
  affiliate_earned_cents: Scalars['Int']['output'];
  affiliate_pending_cents: Scalars['Int']['output'];
  available_cents: Scalars['Int']['output'];
  currency: Scalars['String']['output'];
  pending_cents: Scalars['Int']['output'];
  pending_kind?: Maybe<Scalars['String']['output']>;
  pending_payout_cents: Scalars['Int']['output'];
  per_campaign_breakdown: Array<CpmWalletCampaignEntry>;
  producer_earned_cents: Scalars['Int']['output'];
  total_earned_cents: Scalars['Int']['output'];
  total_paid_out_cents: Scalars['Int']['output'];
};

export type CpmWalletCampaignEntry = {
  __typename?: 'CpmWalletCampaignEntry';
  campaign_id: Scalars['ID']['output'];
  campaign_name: Scalars['String']['output'];
  earned_cents: Scalars['Int']['output'];
};

export type CreateMyCpmCampaignSubmissionInput = {
  campaignId: Scalars['ID']['input'];
  platform: Scalars['String']['input'];
  socialConnectionId?: InputMaybe<Scalars['ID']['input']>;
  url: Scalars['String']['input'];
};

export type Curation = {
  __typename?: 'Curation';
  audience_preference?: Maybe<Scalars['String']['output']>;
  audio_s3_uri: Scalars['String']['output'];
  clip_duration: Enum_Curation_Clip_Duration;
  clips_list?: Maybe<Scalars['JSON']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  documentId: Scalars['ID']['output'];
  language: Scalars['String']['output'];
  processing_status: Enum_Curation_Processing_Status;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  transcription?: Maybe<Scalars['JSON']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  video_s3_uri: Scalars['String']['output'];
  webhook_url: Scalars['String']['output'];
};

export type CurationEntityResponseCollection = {
  __typename?: 'CurationEntityResponseCollection';
  nodes: Array<Curation>;
  pageInfo: Pagination;
};

export type CurationFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<CurationFiltersInput>>>;
  audience_preference?: InputMaybe<StringFilterInput>;
  audio_s3_uri?: InputMaybe<StringFilterInput>;
  clip_duration?: InputMaybe<StringFilterInput>;
  clips_list?: InputMaybe<JsonFilterInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  documentId?: InputMaybe<IdFilterInput>;
  language?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<CurationFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<CurationFiltersInput>>>;
  processing_status?: InputMaybe<StringFilterInput>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  transcription?: InputMaybe<JsonFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
  video_s3_uri?: InputMaybe<StringFilterInput>;
  webhook_url?: InputMaybe<StringFilterInput>;
};

export type CurationInput = {
  audience_preference?: InputMaybe<Scalars['String']['input']>;
  audio_s3_uri?: InputMaybe<Scalars['String']['input']>;
  clip_duration?: InputMaybe<Enum_Curation_Clip_Duration>;
  clips_list?: InputMaybe<Scalars['JSON']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
  processing_status?: InputMaybe<Enum_Curation_Processing_Status>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  transcription?: InputMaybe<Scalars['JSON']['input']>;
  video_s3_uri?: InputMaybe<Scalars['String']['input']>;
  webhook_url?: InputMaybe<Scalars['String']['input']>;
};

export type DateFilterInput = {
  and?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  between?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  contains?: InputMaybe<Scalars['Date']['input']>;
  containsi?: InputMaybe<Scalars['Date']['input']>;
  endsWith?: InputMaybe<Scalars['Date']['input']>;
  eq?: InputMaybe<Scalars['Date']['input']>;
  eqi?: InputMaybe<Scalars['Date']['input']>;
  gt?: InputMaybe<Scalars['Date']['input']>;
  gte?: InputMaybe<Scalars['Date']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  lt?: InputMaybe<Scalars['Date']['input']>;
  lte?: InputMaybe<Scalars['Date']['input']>;
  ne?: InputMaybe<Scalars['Date']['input']>;
  nei?: InputMaybe<Scalars['Date']['input']>;
  not?: InputMaybe<DateFilterInput>;
  notContains?: InputMaybe<Scalars['Date']['input']>;
  notContainsi?: InputMaybe<Scalars['Date']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  notNull?: InputMaybe<Scalars['Boolean']['input']>;
  null?: InputMaybe<Scalars['Boolean']['input']>;
  or?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  startsWith?: InputMaybe<Scalars['Date']['input']>;
};

export type DateTimeFilterInput = {
  and?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  between?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  contains?: InputMaybe<Scalars['DateTime']['input']>;
  containsi?: InputMaybe<Scalars['DateTime']['input']>;
  endsWith?: InputMaybe<Scalars['DateTime']['input']>;
  eq?: InputMaybe<Scalars['DateTime']['input']>;
  eqi?: InputMaybe<Scalars['DateTime']['input']>;
  gt?: InputMaybe<Scalars['DateTime']['input']>;
  gte?: InputMaybe<Scalars['DateTime']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  lt?: InputMaybe<Scalars['DateTime']['input']>;
  lte?: InputMaybe<Scalars['DateTime']['input']>;
  ne?: InputMaybe<Scalars['DateTime']['input']>;
  nei?: InputMaybe<Scalars['DateTime']['input']>;
  not?: InputMaybe<DateTimeFilterInput>;
  notContains?: InputMaybe<Scalars['DateTime']['input']>;
  notContainsi?: InputMaybe<Scalars['DateTime']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  notNull?: InputMaybe<Scalars['Boolean']['input']>;
  null?: InputMaybe<Scalars['Boolean']['input']>;
  or?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  startsWith?: InputMaybe<Scalars['DateTime']['input']>;
};

export type DeleteMutationResponse = {
  __typename?: 'DeleteMutationResponse';
  documentId: Scalars['ID']['output'];
};

export type DownloadCookie = {
  __typename?: 'DownloadCookie';
  cookie: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  documentId: Scalars['ID']['output'];
  key?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type DownloadCookieEntityResponseCollection = {
  __typename?: 'DownloadCookieEntityResponseCollection';
  nodes: Array<DownloadCookie>;
  pageInfo: Pagination;
};

export type DownloadCookieFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<DownloadCookieFiltersInput>>>;
  cookie?: InputMaybe<StringFilterInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  documentId?: InputMaybe<IdFilterInput>;
  key?: InputMaybe<StringFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<DownloadCookieFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<DownloadCookieFiltersInput>>>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type DownloadCookieInput = {
  cookie?: InputMaybe<Scalars['String']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type DownloadInstagramAccount = {
  __typename?: 'DownloadInstagramAccount';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  documentId: Scalars['ID']['output'];
  password: Scalars['String']['output'];
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  username: Scalars['String']['output'];
};

export type DownloadInstagramAccountEntityResponseCollection = {
  __typename?: 'DownloadInstagramAccountEntityResponseCollection';
  nodes: Array<DownloadInstagramAccount>;
  pageInfo: Pagination;
};

export type DownloadInstagramAccountFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<DownloadInstagramAccountFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  documentId?: InputMaybe<IdFilterInput>;
  not?: InputMaybe<DownloadInstagramAccountFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<DownloadInstagramAccountFiltersInput>>>;
  password?: InputMaybe<StringFilterInput>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
  username?: InputMaybe<StringFilterInput>;
};

export type DownloadInstagramAccountInput = {
  password?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
};

export type DropboxVideoMetadata = {
  __typename?: 'DropboxVideoMetadata';
  duration: Scalars['Float']['output'];
  height: Scalars['Int']['output'];
  source_size_bytes: Scalars['Float']['output'];
  title: Scalars['String']['output'];
  width: Scalars['Int']['output'];
};

export enum Enum_Brandleadevent_Actor {
  Calendly = 'calendly',
  Iago = 'iago',
  Landing = 'landing',
  Lara = 'lara',
  Ops = 'ops'
}

export enum Enum_Brandlead_Budget {
  Range_1k_5k = 'range_1k_5k',
  Range_5k_10k = 'range_5k_10k',
  Range_5k_20k = 'range_5k_20k',
  Range_10k_20k = 'range_10k_20k',
  Range_10k_50k = 'range_10k_50k',
  Range_20k_50k = 'range_20k_50k',
  Range_50k_100k = 'range_50k_100k',
  Range_50k_150k = 'range_50k_150k',
  Range_100kPlus = 'range_100k_plus',
  Range_150kPlus = 'range_150k_plus',
  Undecided = 'undecided'
}

export enum Enum_Brandlead_State {
  BriefComplete = 'brief_complete',
  Briefing = 'briefing',
  Captured = 'captured',
  Contacted = 'contacted',
  Diagnosed = 'diagnosed',
  HumanHandoff = 'human_handoff',
  Lost = 'lost',
  MeetingBooked = 'meeting_booked',
  MeetingHeld = 'meeting_held',
  MeetingLinkSent = 'meeting_link_sent',
  OptedOut = 'opted_out'
}

export enum Enum_Challengeapplication_Clip_Experience_Duration {
  From_3To_6Months = 'from_3_to_6_months',
  From_6MonthsTo_1Year = 'from_6_months_to_1_year',
  LessThan_3Months = 'less_than_3_months',
  MoreThan_1Year = 'more_than_1_year'
}

export enum Enum_Challengeapplication_Competition_Experience {
  No = 'no',
  Yes = 'yes'
}

export enum Enum_Challengeapplication_Content_Creation_Experience {
  No = 'no',
  Yes = 'yes'
}

export enum Enum_Challengeapplication_Editing_Device {
  Both = 'both',
  Desktop = 'desktop',
  Mobile = 'mobile'
}

export enum Enum_Challengeapplication_Has_Clip_Channel {
  No = 'no',
  Yes = 'yes'
}

export enum Enum_Challengeapplication_Has_Monetized_Channel {
  No = 'no',
  Yes = 'yes'
}

export enum Enum_Challengeapplication_State {
  Ac = 'AC',
  Al = 'AL',
  Am = 'AM',
  Ap = 'AP',
  Ba = 'BA',
  Ce = 'CE',
  Df = 'DF',
  Es = 'ES',
  Go = 'GO',
  Ma = 'MA',
  Mg = 'MG',
  Ms = 'MS',
  Mt = 'MT',
  Pa = 'PA',
  Pb = 'PB',
  Pe = 'PE',
  Pi = 'PI',
  Pr = 'PR',
  Rj = 'RJ',
  Rn = 'RN',
  Ro = 'RO',
  Rr = 'RR',
  Rs = 'RS',
  Sc = 'SC',
  Se = 'SE',
  Sp = 'SP',
  To = 'TO'
}

export enum Enum_Clipview_Platform {
  Instagram = 'instagram',
  Tiktok = 'tiktok',
  Youtube = 'youtube'
}

export enum Enum_Clip_Clipping_Status {
  Expired = 'expired',
  Failure = 'failure',
  Processing = 'processing',
  Queued = 'queued',
  Skipped = 'skipped',
  Success = 'success'
}

export enum Enum_Clip_Curation_Rating {
  Dislike = 'dislike',
  Like = 'like',
  Neutral = 'neutral'
}

export enum Enum_Clip_Preparing_Status {
  Expired = 'expired',
  Failure = 'failure',
  PreQueued = 'pre_queued',
  Processing = 'processing',
  Queued = 'queued',
  Skipped = 'skipped',
  Success = 'success'
}

export enum Enum_Clip_Processing_Status {
  Expired = 'expired',
  Failure = 'failure',
  Processing = 'processing',
  Queued = 'queued',
  Success = 'success'
}

export enum Enum_Clip_Rendering_Status {
  Expired = 'expired',
  Failure = 'failure',
  PreQueued = 'pre_queued',
  Processing = 'processing',
  Queued = 'queued',
  Skipped = 'skipped',
  Success = 'success'
}

export enum Enum_Copygeneration_Processing_Status {
  Failure = 'failure',
  Processing = 'processing',
  Queued = 'queued',
  Success = 'success'
}

export enum Enum_Coupon_Type {
  Flat = 'flat',
  Percentage = 'percentage'
}

export enum Enum_Coursecoupon_Type {
  Flat = 'flat',
  Percentage = 'percentage'
}

export enum Enum_Cpmpayout_Currency {
  Brl = 'BRL',
  Usd = 'USD'
}

export enum Enum_Cpmpayout_Kind {
  MinutesRedemption = 'minutes_redemption',
  PixWithdrawal = 'pix_withdrawal',
  PlanRedemption = 'plan_redemption'
}

export enum Enum_Cpmpayout_Status {
  Cancelled = 'cancelled',
  Paid = 'paid',
  Pending = 'pending'
}

export enum Enum_Curation_Clip_Duration {
  Auto = 'auto',
  Max_1Min = 'max_1_min'
}

export enum Enum_Curation_Processing_Status {
  Curating = 'curating',
  Failure = 'failure',
  Processing = 'processing',
  Queued = 'queued',
  Segmenting = 'segmenting',
  Success = 'success',
  Transcribing = 'transcribing'
}

export enum Enum_Emailflowrun_Status {
  Cancelled = 'cancelled',
  Completed = 'completed',
  Failed = 'failed',
  Running = 'running',
  Scheduled = 'scheduled'
}

export enum Enum_Emailflowsend_Language_Used {
  En = 'en',
  Pt = 'pt'
}

export enum Enum_Emailflow_Audience {
  All = 'all',
  OtherChannels = 'other_channels',
  OwnBrand = 'own_brand'
}

export enum Enum_Newsletter_Source {
  Blog = 'blog',
  LandingPage = 'landing_page'
}

export enum Enum_Payment_Currency {
  Brl = 'BRL',
  Usd = 'USD'
}

export enum Enum_Payment_Provider {
  Abacatepay = 'abacatepay',
  AppStore = 'app_store',
  Eduzz = 'eduzz',
  GooglePlay = 'google_play',
  Pagarme = 'pagarme',
  Stripe = 'stripe'
}

export enum Enum_Payment_Type {
  CoursePurchase = 'course_purchase',
  ExtraMinutes = 'extra_minutes',
  Subscription = 'subscription'
}

export enum Enum_Usagerecord_Type {
  Clip = 'clip',
  Library = 'library',
  Project = 'project'
}

export enum Enum_Userspermissionsuser_Onboarding_Course_Offer_Decision {
  Accepted = 'accepted',
  Dismissed = 'dismissed'
}

export enum Enum_Userspermissionsuser_Onboarding_Daily_Volume {
  Vol_1_3 = 'vol_1_3',
  Vol_5_10 = 'vol_5_10',
  Vol_10_30 = 'vol_10_30',
  Vol_10Plus = 'vol_10_plus',
  Vol_30Plus = 'vol_30_plus'
}

export enum Enum_Userspermissionsuser_Onboarding_Experience {
  ExperiencedWithClips = 'experienced_with_clips',
  MonetizingClippingChannel = 'monetizing_clipping_channel',
  StartedNotMonetizing = 'started_not_monetizing',
  StartingFromZero = 'starting_from_zero'
}

export enum Enum_Userspermissionsuser_Onboarding_Objective {
  OtherChannels = 'other_channels',
  OwnBrand = 'own_brand'
}

export enum Enum_Youtubedownload_Compression_Status {
  Failed = 'failed',
  Pending = 'pending',
  Processing = 'processing',
  Queued = 'queued',
  Success = 'success'
}

export enum Enum_Youtubedownload_Detection_Status {
  Failed = 'failed',
  Pending = 'pending',
  Processing = 'processing',
  Queued = 'queued',
  Success = 'success'
}

export enum Enum_Youtubedownload_Download_Status {
  Expired = 'expired',
  Failed = 'failed',
  Processing = 'processing',
  Queued = 'queued',
  Success = 'success'
}

export enum Enum_Youtubedownload_Provider {
  Dropbox = 'dropbox',
  Facebook = 'facebook',
  Frameio = 'frameio',
  GoogleDrive = 'google_drive',
  Http = 'http',
  Instagram = 'instagram',
  Linkedin = 'linkedin',
  Mediasilo = 'mediasilo',
  Rumble = 'rumble',
  Tiktok = 'tiktok',
  Twitch = 'twitch',
  Vimeo = 'vimeo',
  X = 'x',
  Youtube = 'youtube'
}

export enum Enum_Youtubedownload_Transcription_Status {
  Failed = 'failed',
  Pending = 'pending',
  Processing = 'processing',
  Queued = 'queued',
  Success = 'success'
}

export type EmailDesignerV5EmailDesignerTemplate = {
  __typename?: 'EmailDesignerV5EmailDesignerTemplate';
  bodyHtml?: Maybe<Scalars['String']['output']>;
  bodyText?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  design?: Maybe<Scalars['JSON']['output']>;
  documentId: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  subject?: Maybe<Scalars['String']['output']>;
  tags?: Maybe<Scalars['JSON']['output']>;
  templateReferenceId?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  versions: Array<Maybe<EmailDesignerV5EmailDesignerTemplateVersion>>;
  versions_connection?: Maybe<EmailDesignerV5EmailDesignerTemplateVersionRelationResponseCollection>;
};


export type EmailDesignerV5EmailDesignerTemplateVersionsArgs = {
  filters?: InputMaybe<EmailDesignerV5EmailDesignerTemplateVersionFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type EmailDesignerV5EmailDesignerTemplateVersions_ConnectionArgs = {
  filters?: InputMaybe<EmailDesignerV5EmailDesignerTemplateVersionFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type EmailDesignerV5EmailDesignerTemplateEntityResponseCollection = {
  __typename?: 'EmailDesignerV5EmailDesignerTemplateEntityResponseCollection';
  nodes: Array<EmailDesignerV5EmailDesignerTemplate>;
  pageInfo: Pagination;
};

export type EmailDesignerV5EmailDesignerTemplateFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<EmailDesignerV5EmailDesignerTemplateFiltersInput>>>;
  bodyHtml?: InputMaybe<StringFilterInput>;
  bodyText?: InputMaybe<StringFilterInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  design?: InputMaybe<JsonFilterInput>;
  documentId?: InputMaybe<IdFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<EmailDesignerV5EmailDesignerTemplateFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<EmailDesignerV5EmailDesignerTemplateFiltersInput>>>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  subject?: InputMaybe<StringFilterInput>;
  tags?: InputMaybe<JsonFilterInput>;
  templateReferenceId?: InputMaybe<IntFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
  versions?: InputMaybe<EmailDesignerV5EmailDesignerTemplateVersionFiltersInput>;
};

export type EmailDesignerV5EmailDesignerTemplateInput = {
  bodyHtml?: InputMaybe<Scalars['String']['input']>;
  bodyText?: InputMaybe<Scalars['String']['input']>;
  design?: InputMaybe<Scalars['JSON']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  subject?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Scalars['JSON']['input']>;
  templateReferenceId?: InputMaybe<Scalars['Int']['input']>;
  versions?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};

export type EmailDesignerV5EmailDesignerTemplateVersion = {
  __typename?: 'EmailDesignerV5EmailDesignerTemplateVersion';
  bodyHtml?: Maybe<Scalars['String']['output']>;
  bodyText?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  design?: Maybe<Scalars['JSON']['output']>;
  documentId: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  subject?: Maybe<Scalars['String']['output']>;
  tags?: Maybe<Scalars['JSON']['output']>;
  templateId?: Maybe<EmailDesignerV5EmailDesignerTemplate>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type EmailDesignerV5EmailDesignerTemplateVersionEntityResponseCollection = {
  __typename?: 'EmailDesignerV5EmailDesignerTemplateVersionEntityResponseCollection';
  nodes: Array<EmailDesignerV5EmailDesignerTemplateVersion>;
  pageInfo: Pagination;
};

export type EmailDesignerV5EmailDesignerTemplateVersionFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<EmailDesignerV5EmailDesignerTemplateVersionFiltersInput>>>;
  bodyHtml?: InputMaybe<StringFilterInput>;
  bodyText?: InputMaybe<StringFilterInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  design?: InputMaybe<JsonFilterInput>;
  documentId?: InputMaybe<IdFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<EmailDesignerV5EmailDesignerTemplateVersionFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<EmailDesignerV5EmailDesignerTemplateVersionFiltersInput>>>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  subject?: InputMaybe<StringFilterInput>;
  tags?: InputMaybe<JsonFilterInput>;
  templateId?: InputMaybe<EmailDesignerV5EmailDesignerTemplateFiltersInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type EmailDesignerV5EmailDesignerTemplateVersionInput = {
  bodyHtml?: InputMaybe<Scalars['String']['input']>;
  bodyText?: InputMaybe<Scalars['String']['input']>;
  design?: InputMaybe<Scalars['JSON']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  subject?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Scalars['JSON']['input']>;
  templateId?: InputMaybe<Scalars['ID']['input']>;
};

export type EmailDesignerV5EmailDesignerTemplateVersionRelationResponseCollection = {
  __typename?: 'EmailDesignerV5EmailDesignerTemplateVersionRelationResponseCollection';
  nodes: Array<EmailDesignerV5EmailDesignerTemplateVersion>;
};

export type EmailFlow = {
  __typename?: 'EmailFlow';
  audience: Enum_Emailflow_Audience;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  documentId: Scalars['ID']['output'];
  is_active?: Maybe<Scalars['Boolean']['output']>;
  is_editable?: Maybe<Scalars['Boolean']['output']>;
  is_transactional?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  runs: Array<Maybe<EmailFlowRun>>;
  runs_connection?: Maybe<EmailFlowRunRelationResponseCollection>;
  slug: Scalars['String']['output'];
  steps: Array<Maybe<EmailFlowStep>>;
  steps_connection?: Maybe<EmailFlowStepRelationResponseCollection>;
  trigger: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type EmailFlowRunsArgs = {
  filters?: InputMaybe<EmailFlowRunFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type EmailFlowRuns_ConnectionArgs = {
  filters?: InputMaybe<EmailFlowRunFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type EmailFlowStepsArgs = {
  filters?: InputMaybe<EmailFlowStepFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type EmailFlowSteps_ConnectionArgs = {
  filters?: InputMaybe<EmailFlowStepFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type EmailFlowEntityResponseCollection = {
  __typename?: 'EmailFlowEntityResponseCollection';
  nodes: Array<EmailFlow>;
  pageInfo: Pagination;
};

export type EmailFlowFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<EmailFlowFiltersInput>>>;
  audience?: InputMaybe<StringFilterInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  description?: InputMaybe<StringFilterInput>;
  documentId?: InputMaybe<IdFilterInput>;
  is_active?: InputMaybe<BooleanFilterInput>;
  is_editable?: InputMaybe<BooleanFilterInput>;
  is_transactional?: InputMaybe<BooleanFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<EmailFlowFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<EmailFlowFiltersInput>>>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  runs?: InputMaybe<EmailFlowRunFiltersInput>;
  slug?: InputMaybe<StringFilterInput>;
  steps?: InputMaybe<EmailFlowStepFiltersInput>;
  trigger?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type EmailFlowInput = {
  audience?: InputMaybe<Enum_Emailflow_Audience>;
  description?: InputMaybe<Scalars['String']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  is_editable?: InputMaybe<Scalars['Boolean']['input']>;
  is_transactional?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  runs?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  slug?: InputMaybe<Scalars['String']['input']>;
  steps?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  trigger?: InputMaybe<Scalars['String']['input']>;
};

export type EmailFlowRun = {
  __typename?: 'EmailFlowRun';
  completed_at?: Maybe<Scalars['DateTime']['output']>;
  context?: Maybe<Scalars['JSON']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  current_step_order?: Maybe<Scalars['Int']['output']>;
  dedupe_key?: Maybe<Scalars['String']['output']>;
  documentId: Scalars['ID']['output'];
  flow?: Maybe<EmailFlow>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  started_at?: Maybe<Scalars['DateTime']['output']>;
  status: Enum_Emailflowrun_Status;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  user?: Maybe<UsersPermissionsUser>;
};

export type EmailFlowRunEntityResponseCollection = {
  __typename?: 'EmailFlowRunEntityResponseCollection';
  nodes: Array<EmailFlowRun>;
  pageInfo: Pagination;
};

export type EmailFlowRunFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<EmailFlowRunFiltersInput>>>;
  completed_at?: InputMaybe<DateTimeFilterInput>;
  context?: InputMaybe<JsonFilterInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  current_step_order?: InputMaybe<IntFilterInput>;
  dedupe_key?: InputMaybe<StringFilterInput>;
  documentId?: InputMaybe<IdFilterInput>;
  flow?: InputMaybe<EmailFlowFiltersInput>;
  not?: InputMaybe<EmailFlowRunFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<EmailFlowRunFiltersInput>>>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  started_at?: InputMaybe<DateTimeFilterInput>;
  status?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
  user?: InputMaybe<UsersPermissionsUserFiltersInput>;
};

export type EmailFlowRunInput = {
  completed_at?: InputMaybe<Scalars['DateTime']['input']>;
  context?: InputMaybe<Scalars['JSON']['input']>;
  current_step_order?: InputMaybe<Scalars['Int']['input']>;
  dedupe_key?: InputMaybe<Scalars['String']['input']>;
  flow?: InputMaybe<Scalars['ID']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  started_at?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<Enum_Emailflowrun_Status>;
  user?: InputMaybe<Scalars['ID']['input']>;
};

export type EmailFlowRunRelationResponseCollection = {
  __typename?: 'EmailFlowRunRelationResponseCollection';
  nodes: Array<EmailFlowRun>;
};

export type EmailFlowSend = {
  __typename?: 'EmailFlowSend';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  documentId: Scalars['ID']['output'];
  error?: Maybe<Scalars['String']['output']>;
  is_test?: Maybe<Scalars['Boolean']['output']>;
  language_used?: Maybe<Enum_Emailflowsend_Language_Used>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  run?: Maybe<EmailFlowRun>;
  sent_at: Scalars['DateTime']['output'];
  step?: Maybe<EmailFlowStep>;
  subject_used?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type EmailFlowSendEntityResponseCollection = {
  __typename?: 'EmailFlowSendEntityResponseCollection';
  nodes: Array<EmailFlowSend>;
  pageInfo: Pagination;
};

export type EmailFlowSendFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<EmailFlowSendFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  documentId?: InputMaybe<IdFilterInput>;
  error?: InputMaybe<StringFilterInput>;
  is_test?: InputMaybe<BooleanFilterInput>;
  language_used?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<EmailFlowSendFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<EmailFlowSendFiltersInput>>>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  run?: InputMaybe<EmailFlowRunFiltersInput>;
  sent_at?: InputMaybe<DateTimeFilterInput>;
  step?: InputMaybe<EmailFlowStepFiltersInput>;
  subject_used?: InputMaybe<StringFilterInput>;
  success?: InputMaybe<BooleanFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type EmailFlowSendInput = {
  error?: InputMaybe<Scalars['String']['input']>;
  is_test?: InputMaybe<Scalars['Boolean']['input']>;
  language_used?: InputMaybe<Enum_Emailflowsend_Language_Used>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  run?: InputMaybe<Scalars['ID']['input']>;
  sent_at?: InputMaybe<Scalars['DateTime']['input']>;
  step?: InputMaybe<Scalars['ID']['input']>;
  subject_used?: InputMaybe<Scalars['String']['input']>;
  success?: InputMaybe<Scalars['Boolean']['input']>;
};

export type EmailFlowStep = {
  __typename?: 'EmailFlowStep';
  body_en?: Maybe<Scalars['String']['output']>;
  body_pt: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  delay_minutes: Scalars['Int']['output'];
  documentId: Scalars['ID']['output'];
  flow?: Maybe<EmailFlow>;
  is_active?: Maybe<Scalars['Boolean']['output']>;
  order: Scalars['Int']['output'];
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  subject_en?: Maybe<Scalars['String']['output']>;
  subject_pt: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type EmailFlowStepEntityResponseCollection = {
  __typename?: 'EmailFlowStepEntityResponseCollection';
  nodes: Array<EmailFlowStep>;
  pageInfo: Pagination;
};

export type EmailFlowStepFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<EmailFlowStepFiltersInput>>>;
  body_en?: InputMaybe<StringFilterInput>;
  body_pt?: InputMaybe<StringFilterInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  delay_minutes?: InputMaybe<IntFilterInput>;
  documentId?: InputMaybe<IdFilterInput>;
  flow?: InputMaybe<EmailFlowFiltersInput>;
  is_active?: InputMaybe<BooleanFilterInput>;
  not?: InputMaybe<EmailFlowStepFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<EmailFlowStepFiltersInput>>>;
  order?: InputMaybe<IntFilterInput>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  subject_en?: InputMaybe<StringFilterInput>;
  subject_pt?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type EmailFlowStepInput = {
  body_en?: InputMaybe<Scalars['String']['input']>;
  body_pt?: InputMaybe<Scalars['String']['input']>;
  delay_minutes?: InputMaybe<Scalars['Int']['input']>;
  flow?: InputMaybe<Scalars['ID']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  subject_en?: InputMaybe<Scalars['String']['input']>;
  subject_pt?: InputMaybe<Scalars['String']['input']>;
};

export type EmailFlowStepRelationResponseCollection = {
  __typename?: 'EmailFlowStepRelationResponseCollection';
  nodes: Array<EmailFlowStep>;
};

export type EmailFlowTrigger = {
  __typename?: 'EmailFlowTrigger';
  key: Scalars['String']['output'];
  label: Scalars['String']['output'];
  variables: Array<Scalars['String']['output']>;
};

export type EnqueueToPublishQueueCopyInput = {
  caption?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type Error = {
  __typename?: 'Error';
  code: Scalars['String']['output'];
  message?: Maybe<Scalars['String']['output']>;
};

export type FileInfoInput = {
  alternativeText?: InputMaybe<Scalars['String']['input']>;
  caption?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type FillerVideo = {
  __typename?: 'FillerVideo';
  categories: Array<Scalars['String']['output']>;
  file_en_url?: Maybe<Scalars['String']['output']>;
  file_url: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  preview_duration_seconds?: Maybe<Scalars['Float']['output']>;
  preview_en_duration_seconds?: Maybe<Scalars['Float']['output']>;
  preview_en_url?: Maybe<Scalars['String']['output']>;
  preview_url?: Maybe<Scalars['String']['output']>;
  thumbnail_url?: Maybe<Scalars['String']['output']>;
};

export type FillerVideoTag = {
  __typename?: 'FillerVideoTag';
  name: Scalars['String']['output'];
  slug: Scalars['String']['output'];
};

export type FloatFilterInput = {
  and?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  between?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  contains?: InputMaybe<Scalars['Float']['input']>;
  containsi?: InputMaybe<Scalars['Float']['input']>;
  endsWith?: InputMaybe<Scalars['Float']['input']>;
  eq?: InputMaybe<Scalars['Float']['input']>;
  eqi?: InputMaybe<Scalars['Float']['input']>;
  gt?: InputMaybe<Scalars['Float']['input']>;
  gte?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  lt?: InputMaybe<Scalars['Float']['input']>;
  lte?: InputMaybe<Scalars['Float']['input']>;
  ne?: InputMaybe<Scalars['Float']['input']>;
  nei?: InputMaybe<Scalars['Float']['input']>;
  not?: InputMaybe<FloatFilterInput>;
  notContains?: InputMaybe<Scalars['Float']['input']>;
  notContainsi?: InputMaybe<Scalars['Float']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  notNull?: InputMaybe<Scalars['Boolean']['input']>;
  null?: InputMaybe<Scalars['Boolean']['input']>;
  or?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  startsWith?: InputMaybe<Scalars['Float']['input']>;
};

export type Font = {
  __typename?: 'Font';
  createdAt: Scalars['String']['output'];
  family: Scalars['String']['output'];
  file_url: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  preview_black_url?: Maybe<Scalars['String']['output']>;
  preview_white_url?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['String']['output'];
};

export type FrameioShareVideo = {
  __typename?: 'FrameioShareVideo';
  asset_id: Scalars['String']['output'];
  canonical_url: Scalars['String']['output'];
  duration_seconds: Scalars['Float']['output'];
  height?: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  thumbnail_url?: Maybe<Scalars['String']['output']>;
  width?: Maybe<Scalars['Int']['output']>;
};

export type FrameioShareVideos = {
  __typename?: 'FrameioShareVideos';
  share_name?: Maybe<Scalars['String']['output']>;
  truncated: Scalars['Boolean']['output'];
  videos: Array<FrameioShareVideo>;
};

export type GenericMorph = Affiliate | ApiIdempotency | BrandLead | BrandLeadEvent | ChallengeApplication | Clip | ClipView | ComponentBlogBlogMenuTags | CopyGeneration | Coupon | CourseCoupon | CpmPayout | Curation | DownloadCookie | DownloadInstagramAccount | EmailDesignerV5EmailDesignerTemplate | EmailDesignerV5EmailDesignerTemplateVersion | EmailFlow | EmailFlowRun | EmailFlowSend | EmailFlowStep | I18NLocale | Newsletter | Payment | Plan | ReviewWorkflowsWorkflow | ReviewWorkflowsWorkflowStage | ShortLink | SubtitlePreset | UploadFile | UsageRecord | UserTag | UsersPermissionsPermission | UsersPermissionsRole | UsersPermissionsUser | Webhook | YoutubeDownload;

export type GuestSubscriptionCheckout = {
  __typename?: 'GuestSubscriptionCheckout';
  purchase_id: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type GuestSubscriptionPixOrder = {
  __typename?: 'GuestSubscriptionPixOrder';
  expires_at?: Maybe<Scalars['String']['output']>;
  purchase_id: Scalars['String']['output'];
  qr_code?: Maybe<Scalars['String']['output']>;
  qr_code_url?: Maybe<Scalars['String']['output']>;
};

export type GuestSubscriptionStatus = {
  __typename?: 'GuestSubscriptionStatus';
  status: Scalars['String']['output'];
};

export type I18NLocale = {
  __typename?: 'I18NLocale';
  code?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  documentId: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type I18NLocaleEntityResponseCollection = {
  __typename?: 'I18NLocaleEntityResponseCollection';
  nodes: Array<I18NLocale>;
  pageInfo: Pagination;
};

export type I18NLocaleFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<I18NLocaleFiltersInput>>>;
  code?: InputMaybe<StringFilterInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  documentId?: InputMaybe<IdFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<I18NLocaleFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<I18NLocaleFiltersInput>>>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type IdFilterInput = {
  and?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  between?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  contains?: InputMaybe<Scalars['ID']['input']>;
  containsi?: InputMaybe<Scalars['ID']['input']>;
  endsWith?: InputMaybe<Scalars['ID']['input']>;
  eq?: InputMaybe<Scalars['ID']['input']>;
  eqi?: InputMaybe<Scalars['ID']['input']>;
  gt?: InputMaybe<Scalars['ID']['input']>;
  gte?: InputMaybe<Scalars['ID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  lt?: InputMaybe<Scalars['ID']['input']>;
  lte?: InputMaybe<Scalars['ID']['input']>;
  ne?: InputMaybe<Scalars['ID']['input']>;
  nei?: InputMaybe<Scalars['ID']['input']>;
  not?: InputMaybe<IdFilterInput>;
  notContains?: InputMaybe<Scalars['ID']['input']>;
  notContainsi?: InputMaybe<Scalars['ID']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  notNull?: InputMaybe<Scalars['Boolean']['input']>;
  null?: InputMaybe<Scalars['Boolean']['input']>;
  or?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  startsWith?: InputMaybe<Scalars['ID']['input']>;
};

export type IntFilterInput = {
  and?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  between?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  contains?: InputMaybe<Scalars['Int']['input']>;
  containsi?: InputMaybe<Scalars['Int']['input']>;
  endsWith?: InputMaybe<Scalars['Int']['input']>;
  eq?: InputMaybe<Scalars['Int']['input']>;
  eqi?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  nei?: InputMaybe<Scalars['Int']['input']>;
  not?: InputMaybe<IntFilterInput>;
  notContains?: InputMaybe<Scalars['Int']['input']>;
  notContainsi?: InputMaybe<Scalars['Int']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  notNull?: InputMaybe<Scalars['Boolean']['input']>;
  null?: InputMaybe<Scalars['Boolean']['input']>;
  or?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  startsWith?: InputMaybe<Scalars['Int']['input']>;
};

export type Invitation = {
  __typename?: 'Invitation';
  email: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  profile_picture?: Maybe<Scalars['String']['output']>;
};

export type JsonFilterInput = {
  and?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  between?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  contains?: InputMaybe<Scalars['JSON']['input']>;
  containsi?: InputMaybe<Scalars['JSON']['input']>;
  endsWith?: InputMaybe<Scalars['JSON']['input']>;
  eq?: InputMaybe<Scalars['JSON']['input']>;
  eqi?: InputMaybe<Scalars['JSON']['input']>;
  gt?: InputMaybe<Scalars['JSON']['input']>;
  gte?: InputMaybe<Scalars['JSON']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  lt?: InputMaybe<Scalars['JSON']['input']>;
  lte?: InputMaybe<Scalars['JSON']['input']>;
  ne?: InputMaybe<Scalars['JSON']['input']>;
  nei?: InputMaybe<Scalars['JSON']['input']>;
  not?: InputMaybe<JsonFilterInput>;
  notContains?: InputMaybe<Scalars['JSON']['input']>;
  notContainsi?: InputMaybe<Scalars['JSON']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  notNull?: InputMaybe<Scalars['Boolean']['input']>;
  null?: InputMaybe<Scalars['Boolean']['input']>;
  or?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  startsWith?: InputMaybe<Scalars['JSON']['input']>;
};

export enum LiveIngestStatus {
  Failed = 'failed',
  Idle = 'idle',
  Running = 'running',
  Stopped = 'stopped'
}

export enum LiveSessionStatus {
  Ended = 'ended',
  Failed = 'failed',
  Live = 'live',
  Pending = 'pending'
}

export enum LiveWatchKind {
  Channel = 'channel',
  Url = 'url'
}

export enum LiveWatchPlatform {
  Kick = 'kick',
  Twitch = 'twitch',
  Youtube = 'youtube'
}

export enum LiveWindowStatus {
  Curating = 'curating',
  Empty = 'empty',
  Failed = 'failed',
  Pending = 'pending',
  Published = 'published'
}

export type LongFilterInput = {
  and?: InputMaybe<Array<InputMaybe<Scalars['Long']['input']>>>;
  between?: InputMaybe<Array<InputMaybe<Scalars['Long']['input']>>>;
  contains?: InputMaybe<Scalars['Long']['input']>;
  containsi?: InputMaybe<Scalars['Long']['input']>;
  endsWith?: InputMaybe<Scalars['Long']['input']>;
  eq?: InputMaybe<Scalars['Long']['input']>;
  eqi?: InputMaybe<Scalars['Long']['input']>;
  gt?: InputMaybe<Scalars['Long']['input']>;
  gte?: InputMaybe<Scalars['Long']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Long']['input']>>>;
  lt?: InputMaybe<Scalars['Long']['input']>;
  lte?: InputMaybe<Scalars['Long']['input']>;
  ne?: InputMaybe<Scalars['Long']['input']>;
  nei?: InputMaybe<Scalars['Long']['input']>;
  not?: InputMaybe<LongFilterInput>;
  notContains?: InputMaybe<Scalars['Long']['input']>;
  notContainsi?: InputMaybe<Scalars['Long']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Long']['input']>>>;
  notNull?: InputMaybe<Scalars['Boolean']['input']>;
  null?: InputMaybe<Scalars['Boolean']['input']>;
  or?: InputMaybe<Array<InputMaybe<Scalars['Long']['input']>>>;
  startsWith?: InputMaybe<Scalars['Long']['input']>;
};

export type Media = {
  size: Scalars['Float']['input'];
  type: Scalars['String']['input'];
  url: Scalars['String']['input'];
};

export type MediasiloReviewVideo = {
  __typename?: 'MediasiloReviewVideo';
  asset_id: Scalars['String']['output'];
  canonical_url: Scalars['String']['output'];
  duration_seconds: Scalars['Float']['output'];
  height?: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  thumbnail_url?: Maybe<Scalars['String']['output']>;
  width?: Maybe<Scalars['Int']['output']>;
};

export type MediasiloReviewVideos = {
  __typename?: 'MediasiloReviewVideos';
  share_name?: Maybe<Scalars['String']['output']>;
  truncated: Scalars['Boolean']['output'];
  videos: Array<MediasiloReviewVideo>;
};

export type MotionAttachmentInput = {
  footageId?: InputMaybe<Scalars['String']['input']>;
  kind: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type MotionConversation = {
  __typename?: 'MotionConversation';
  id: Scalars['ID']['output'];
  lastError?: Maybe<Scalars['String']['output']>;
  messages: Array<MotionMessage>;
  status?: Maybe<Scalars['String']['output']>;
};

export type MotionEditOpInput = {
  duration?: InputMaybe<Scalars['Float']['input']>;
  elementId: Scalars['String']['input'];
  file: Scalars['String']['input'];
  kind: Scalars['String']['input'];
  start?: InputMaybe<Scalars['Float']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
};

export type MotionFile = {
  __typename?: 'MotionFile';
  path: Scalars['String']['output'];
  sha256: Scalars['String']['output'];
  size: Scalars['Float']['output'];
  url: Scalars['String']['output'];
};

export type MotionFootage = {
  __typename?: 'MotionFootage';
  durationSeconds?: Maybe<Scalars['Float']['output']>;
  height?: Maybe<Scalars['Int']['output']>;
  id: Scalars['String']['output'];
  source?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  videoUrl?: Maybe<Scalars['String']['output']>;
  width?: Maybe<Scalars['Int']['output']>;
};

export type MotionFootageInput = {
  audioUrl: Scalars['String']['input'];
  durationSeconds: Scalars['Float']['input'];
  height: Scalars['Int']['input'];
  id: Scalars['String']['input'];
  sizeBytes: Scalars['Float']['input'];
  stills: Array<MotionStillInput>;
  width: Scalars['Int']['input'];
};

export type MotionMessage = {
  __typename?: 'MotionMessage';
  attachments?: Maybe<Scalars['JSON']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  quickReplies: Array<MotionQuestion>;
  role: Scalars['String']['output'];
  step?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
  toolName?: Maybe<Scalars['String']['output']>;
  toolStatus?: Maybe<Scalars['String']['output']>;
  versionId?: Maybe<Scalars['ID']['output']>;
};

export type MotionMusic = {
  __typename?: 'MotionMusic';
  kind?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  trackId?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type MotionMusicInput = {
  kind: Scalars['String']['input'];
  trackId?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type MotionProject = {
  __typename?: 'MotionProject';
  conversation?: Maybe<MotionConversation>;
  currentVersion?: Maybe<MotionVersion>;
  durationSeconds?: Maybe<Scalars['Float']['output']>;
  footage: Array<MotionFootage>;
  fps?: Maybe<Scalars['Int']['output']>;
  height?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  music?: Maybe<MotionMusic>;
  thumbnailUrl?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  width?: Maybe<Scalars['Int']['output']>;
};

export type MotionProjectsPage = {
  __typename?: 'MotionProjectsPage';
  hasMore: Scalars['Boolean']['output'];
  items: Array<MotionProject>;
};

export type MotionQuestion = {
  __typename?: 'MotionQuestion';
  options: Array<Scalars['String']['output']>;
  text: Scalars['String']['output'];
};

export type MotionStillInput = {
  t: Scalars['Float']['input'];
  url: Scalars['String']['input'];
};

export type MotionTrack = {
  __typename?: 'MotionTrack';
  author?: Maybe<Scalars['String']['output']>;
  durationSeconds?: Maybe<Scalars['Float']['output']>;
  id: Scalars['String']['output'];
  license?: Maybe<Scalars['String']['output']>;
  mood?: Maybe<Scalars['String']['output']>;
  tempo?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type MotionUsage = {
  __typename?: 'MotionUsage';
  freeMessagesLeft?: Maybe<Scalars['Int']['output']>;
  plan: Scalars['String']['output'];
  resetsAt?: Maybe<Scalars['String']['output']>;
};

export type MotionVersion = {
  __typename?: 'MotionVersion';
  createdAt?: Maybe<Scalars['String']['output']>;
  durationSeconds?: Maybe<Scalars['Float']['output']>;
  files: Array<MotionFile>;
  fps?: Maybe<Scalars['Int']['output']>;
  height?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  number: Scalars['Int']['output'];
  previewErrors?: Maybe<Scalars['JSON']['output']>;
  request?: Maybe<Scalars['String']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  thumbnailUrl?: Maybe<Scalars['String']['output']>;
  width?: Maybe<Scalars['Int']['output']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  acceptAffiliateTerms: MyAffiliateStatus;
  acceptCpmTerms: MyData;
  acceptInvitation: MyData;
  activateClip: MyClip;
  addMotionFootage: MotionProject;
  addUserTag?: Maybe<MyUserTag>;
  adminAddChallengeParticipant: AdminChallengeParticipant;
  adminAddCommunityCurationVideo: AdminCommunityCurationPick;
  adminAddToLibrary: Array<AdminLibraryItem>;
  adminApproveCpmPayout: AdminCpmPayout;
  adminBulkApproveCpmRankingClips: CpmRankingBulkApproval;
  adminBulkRejectCpmRankingClips: CpmRankingBulkRejection;
  adminBulkReviewCpmCampaignSubmissions: AdminBulkReviewResult;
  adminConsolidateClipperSeason: ClipperSeasonAdmin;
  adminCreateBrandKit: MyBrandKit;
  adminCreateChallenge: AdminChallenge;
  adminCreateChallengeRanking: AdminChallengeRanking;
  adminCreateClipperSeason: ClipperSeasonAdmin;
  adminCreateCommunityCurationNiche: AdminCommunityCurationNiche;
  adminCreateCoupon: AdminCoupon;
  adminCreateCpmCampaign: AdminCpmCampaign;
  adminCreateCpmPayout: AdminCpmPayout;
  adminCreateEmailFlow: AdminEmailFlow;
  adminCreateLiveWatch: AdminLiveWatch;
  adminCreateManualClipView: Scalars['Boolean']['output'];
  adminDeleteChallenge: Scalars['Boolean']['output'];
  adminDeleteChallengeRanking: Scalars['Boolean']['output'];
  adminDeleteCommunityCurationNiche: Scalars['Boolean']['output'];
  adminDeleteCoupon: AdminCoupon;
  adminDeleteCpmCampaign: Scalars['Boolean']['output'];
  adminDeleteCpmPayout: Scalars['Boolean']['output'];
  adminDeleteEmailFlow: Scalars['Boolean']['output'];
  adminDeleteEmailFlowStep: Scalars['Boolean']['output'];
  adminDeleteLibrary: Scalars['Boolean']['output'];
  adminDisqualifyCpmCampaignSubmission: AdminCpmCampaignSubmission;
  adminDisqualifyCpmCampaignUser: CpmCampaignUserDisqualification;
  adminDisqualifyParticipant: Scalars['Boolean']['output'];
  adminEnqueueCpmSubmissionMediaDownload: AdminCpmSubmissionMediaDownload;
  adminFinalizeCpmRanking: CpmCampaignRanking;
  adminForceConsolidation: AdminChallengeRanking;
  adminForceStartSnapshot: AdminChallengeRanking;
  adminForceUpdateAllChallengeClipViews: Scalars['Int']['output'];
  adminForceUpdateAllCpmCampaignSubmissionViews: Scalars['Int']['output'];
  adminForceUpdateChallengeClipView: Scalars['Boolean']['output'];
  adminForceUpdateChallengeClipViews: Scalars['Int']['output'];
  adminForceUpdateCpmCampaignSubmissionView: Scalars['Boolean']['output'];
  adminGenerateCpmCampaignReportConclusions: CpmCampaignReportConclusions;
  adminImpersonateUser: AdminImpersonationResponse;
  adminImportDriveToChannel: Array<AdminDriveImportResult>;
  adminInviteCpmCampaignUser: AdminCpmCampaignChannelRequest;
  adminLinkCpmSubmissionContent: CpmContentReviewGroup;
  adminRecomputeCpmCampaignPayouts: AdminCpmCampaignRecomputeResult;
  adminRegenerateTranscription: Scalars['Boolean']['output'];
  adminRemoveChallengeParticipant: Scalars['Boolean']['output'];
  adminReorderEmailFlowSteps: Array<AdminEmailFlowStep>;
  adminReplyCpmLead: AdminCpmLeadMessage;
  adminResetAllChallengeParticipantsUsage: Scalars['Boolean']['output'];
  adminResetChallengeParticipantUsage: Scalars['Boolean']['output'];
  adminResolveCpmRankingTie: CpmCampaignRanking;
  adminResolveSuspectedDuplicate: AdminCpmCampaignSubmission;
  adminRestartCpmLead: AdminCpmLeadMessage;
  adminRestoreExpiredClip: Scalars['Boolean']['output'];
  adminRestoreExpiredItems: AdminRestoreExpiredItemsResponse;
  adminRestoreExpiredLibrary: Scalars['Boolean']['output'];
  adminRestoreExpiredProject: Scalars['Boolean']['output'];
  adminRetryFailedClip: Scalars['Boolean']['output'];
  adminRetryFailedLibrary: Scalars['Boolean']['output'];
  adminRetryFailedProject: Scalars['Boolean']['output'];
  adminReverseAffiliateEarning: Scalars['Boolean']['output'];
  adminReviewCpmCampaignChannelRequest: AdminCpmCampaignChannelRequest;
  adminReviewCpmCampaignSubmission: AdminCpmCampaignSubmission;
  adminReviewCpmCampaignSubmissionAppeal: CpmCampaignSubmissionAppeal;
  adminReviewCpmContentGroup: CpmContentReviewGroup;
  adminReviewCpmRankingClip: CpmRankingReport;
  adminReviewCpmRankingReport: CpmRankingReport;
  adminReviewCpmRankingSubmission: CpmRankingReport;
  adminReviewPixVerification: AdminPixVerification;
  adminReviewTemplateSuggestion: AdminTemplateSuggestion;
  adminRevokeCpmCampaignChannelRequest: AdminCpmCampaignChannelRequest;
  adminRunCampaignLiveImport: AdminCampaignLiveImport;
  adminRunCommunityCuration: AdminCommunityCurationRun;
  adminSaveCampaignLiveImport: AdminCampaignLiveImport;
  adminSendTestEmailFlowStep: Scalars['Boolean']['output'];
  adminSetAffiliateBlocked: AdminAffiliateBlockResult;
  adminSetAffiliateRates: AdminAffiliateRatesResult;
  adminSetAiAssistantAccess: Scalars['Boolean']['output'];
  adminSetChallengeClipApproval: Scalars['Boolean']['output'];
  adminSetChallengeClipHashtagValidation: Scalars['Boolean']['output'];
  adminSetCourseRevenueShareActive: AdminCourseRevenueShare;
  adminSetCpmCampaignSubmissionCpmOverride: AdminCpmCampaignSubmission;
  adminSetCpmCampaignSubmissionHashtagValidation: Scalars['Boolean']['output'];
  adminSetCpmCampaignSubmissionObservation: AdminCpmCampaignSubmission;
  adminSetCpmLeaderboardExclusion: AdminCpmLeaderboardExclusionResult;
  adminSetFacebookConnectionsAccess: Scalars['Boolean']['output'];
  adminSetLiveWatchEnabled: AdminLiveWatch;
  adminSnapshotClipperSeasonStart: ClipperSeasonAdmin;
  adminStopLiveSession: AdminLiveSession;
  adminSyncMissingChallengeClipViews: Scalars['Int']['output'];
  adminSyncMissingCpmCampaignSubmissionViews: Scalars['Int']['output'];
  adminUndisqualifyCpmCampaignUser: Scalars['Boolean']['output'];
  adminUpdateChallenge: AdminChallenge;
  adminUpdateChallengeRanking: AdminChallengeRanking;
  adminUpdateClipperSeason: ClipperSeasonAdmin;
  adminUpdateCommunityCurationNiche: AdminCommunityCurationNiche;
  adminUpdateCommunityCurationSettings: AdminCommunityCurationSettings;
  adminUpdateCoupon: AdminCoupon;
  adminUpdateCpmCampaign: AdminCpmCampaign;
  adminUpdateCpmCampaignContent: CampaignAuditContent;
  adminUpdateEmailFlow: AdminEmailFlow;
  adminUpdateLiveWatch: AdminLiveWatch;
  adminUpdateSnapshotView: Scalars['Boolean']['output'];
  adminUpdateUserSubscription: AdminUser;
  adminUpdateYoutubeChannel: AdminYoutubeChannel;
  adminUpsertCourseRevenueShare: AdminCourseRevenueShare;
  adminUpsertEmailFlowStep: AdminEmailFlowStep;
  adminValidateRanking: AdminChallengeRanking;
  applyMotionEdits: MotionProject;
  applyRenewalCoupon: RenewalCouponResult;
  cancelMyScheduledPublish: Scalars['Boolean']['output'];
  cancelMyWalletRedemptionHold: Scalars['Boolean']['output'];
  changeOnboardingObjective: MyData;
  /** Change user password. Confirm with the current password. */
  changePassword?: Maybe<UsersPermissionsLoginPayload>;
  claimReferralAttribution: Scalars['Boolean']['output'];
  clipProject: MyClip;
  completeMyCampaignEntry: CampaignEntryState;
  createAffiliate?: Maybe<Affiliate>;
  createApiIdempotency?: Maybe<ApiIdempotency>;
  createBrandLead: BrandLead;
  createBrandLeadEvent?: Maybe<BrandLeadEvent>;
  createChallengeApplication?: Maybe<ChallengeApplication>;
  createClip?: Maybe<Clip>;
  createClipView?: Maybe<ClipView>;
  createCopies: MyClip;
  createCopyGeneration?: Maybe<CopyGeneration>;
  createCoupon?: Maybe<Coupon>;
  createCourseCoupon?: Maybe<CourseCoupon>;
  createCoursePurchaseCheckout: CoursePurchaseCheckout;
  createCoursePurchasePix: CoursePurchasePixOrder;
  createCpmPayout?: Maybe<CpmPayout>;
  createCuration?: Maybe<Curation>;
  createDownloadCookie?: Maybe<DownloadCookie>;
  createDownloadInstagramAccount?: Maybe<DownloadInstagramAccount>;
  createEmailDesignerV5EmailDesignerTemplate?: Maybe<EmailDesignerV5EmailDesignerTemplate>;
  createEmailDesignerV5EmailDesignerTemplateVersion?: Maybe<EmailDesignerV5EmailDesignerTemplateVersion>;
  createEmailFlow?: Maybe<EmailFlow>;
  createEmailFlowRun?: Maybe<EmailFlowRun>;
  createEmailFlowSend?: Maybe<EmailFlowSend>;
  createEmailFlowStep?: Maybe<EmailFlowStep>;
  createGuestSubscriptionCheckout: GuestSubscriptionCheckout;
  createGuestSubscriptionPix: GuestSubscriptionPixOrder;
  createLibraryTag: MyLibraryTag;
  createMotionProject: MotionProject;
  createMyAPIKey: MyApiKey;
  createMyBrandKit: MyBrandKit;
  createMyCpmCampaignChannelRequest: MyCpmCampaignChannelRequest;
  createMyCpmCampaignSubmission: MyCpmCampaignSubmission;
  createMyCpmCampaignSubmissionAppeal: CpmCampaignSubmissionAppeal;
  createMyLibrary: MyLibrary;
  createMyProject: MyProject;
  createMyPublishQueue: PublishQueue;
  createMyScheduledPublish: SocialPublish;
  createMyTemplateSuggestion: TemplateSuggestionSubmitResult;
  createMyUserMedia: MyUserMedia;
  createMyUserMediaFolder: MyUserMediaFolder;
  createNewsletter: Newsletter;
  createPayment?: Maybe<Payment>;
  createPixRenewalOrder: PixRenewalOrder;
  createReportLead: ReportLeadResponse;
  createReviewWorkflowsWorkflow?: Maybe<ReviewWorkflowsWorkflow>;
  createReviewWorkflowsWorkflowStage?: Maybe<ReviewWorkflowsWorkflowStage>;
  createShortLink?: Maybe<ShortLink>;
  createSubtitlePreset?: Maybe<SubtitlePreset>;
  createUsageRecord?: Maybe<UsageRecord>;
  createUserTag?: Maybe<UserTag>;
  /** Create a new role */
  createUsersPermissionsRole?: Maybe<UsersPermissionsCreateRolePayload>;
  /** Create a new user */
  createUsersPermissionsUser: UsersPermissionsUserEntityResponse;
  createWebhook?: Maybe<Webhook>;
  createYoutubeDownload?: Maybe<YoutubeDownload>;
  deleteAffiliate?: Maybe<DeleteMutationResponse>;
  deleteApiIdempotency?: Maybe<DeleteMutationResponse>;
  deleteBrandLead?: Maybe<DeleteMutationResponse>;
  deleteBrandLeadEvent?: Maybe<DeleteMutationResponse>;
  deleteChallengeApplication?: Maybe<DeleteMutationResponse>;
  deleteClip?: Maybe<DeleteMutationResponse>;
  deleteClipView?: Maybe<DeleteMutationResponse>;
  deleteCopyGeneration?: Maybe<DeleteMutationResponse>;
  deleteCoupon?: Maybe<DeleteMutationResponse>;
  deleteCourseCoupon?: Maybe<DeleteMutationResponse>;
  deleteCpmPayout?: Maybe<DeleteMutationResponse>;
  deleteCuration?: Maybe<DeleteMutationResponse>;
  deleteDownloadCookie?: Maybe<DeleteMutationResponse>;
  deleteDownloadInstagramAccount?: Maybe<DeleteMutationResponse>;
  deleteEmailDesignerV5EmailDesignerTemplate?: Maybe<DeleteMutationResponse>;
  deleteEmailDesignerV5EmailDesignerTemplateVersion?: Maybe<DeleteMutationResponse>;
  deleteEmailFlow?: Maybe<DeleteMutationResponse>;
  deleteEmailFlowRun?: Maybe<DeleteMutationResponse>;
  deleteEmailFlowSend?: Maybe<DeleteMutationResponse>;
  deleteEmailFlowStep?: Maybe<DeleteMutationResponse>;
  deleteLibraryTag: MyLibraryTag;
  deleteMotionProject: Scalars['Boolean']['output'];
  deleteMyAPIKey: MyApiKey;
  deleteMyAiAssistantConversation: Scalars['Boolean']['output'];
  deleteMyBrandKit: MyBrandKit;
  deleteMyClip: MyClip;
  deleteMyCpmCampaignChannelRequest: Scalars['Boolean']['output'];
  deleteMyCpmCampaignSubmission: Scalars['Boolean']['output'];
  deleteMyLibrary: MyLibrary;
  deleteMyProject: MyProject;
  deleteMyPublishQueue: Scalars['Boolean']['output'];
  deleteMyUserMedia: Scalars['Boolean']['output'];
  deleteMyUserMediaFolder: Scalars['Boolean']['output'];
  deleteNewsletter?: Maybe<DeleteMutationResponse>;
  deletePayment?: Maybe<DeleteMutationResponse>;
  deleteReviewWorkflowsWorkflow?: Maybe<DeleteMutationResponse>;
  deleteReviewWorkflowsWorkflowStage?: Maybe<DeleteMutationResponse>;
  deleteShortLink?: Maybe<DeleteMutationResponse>;
  deleteSubtitlePreset?: Maybe<DeleteMutationResponse>;
  deleteUploadFile?: Maybe<UploadFile>;
  deleteUsageRecord?: Maybe<DeleteMutationResponse>;
  deleteUserTag?: Maybe<DeleteMutationResponse>;
  /** Delete an existing role */
  deleteUsersPermissionsRole?: Maybe<UsersPermissionsDeleteRolePayload>;
  /** Delete an existing user */
  deleteUsersPermissionsUser: UsersPermissionsUserEntityResponse;
  deleteWebhook?: Maybe<DeleteMutationResponse>;
  deleteYoutubeDownload?: Maybe<DeleteMutationResponse>;
  disconnectMySocialConnection: Scalars['Boolean']['output'];
  /** Confirm an email users email address */
  emailConfirmation?: Maybe<UsersPermissionsLoginPayload>;
  enqueueToPublishQueue: Array<SocialPublish>;
  finishMyClipperRun: ClipperRunResult;
  /** Request a reset password token */
  forgotPassword?: Maybe<UsersPermissionsPasswordPayload>;
  generateMyAiAssistantSuggestions: Array<Scalars['String']['output']>;
  generateMyCoverImage: AiCoverGeneration;
  generateMyQuoteSuggestions: QuoteSuggestionJob;
  incrementBlogPostViews: Scalars['JSON']['output'];
  joinChallenge: ChallengeParticipation;
  joinCpmCampaign: Scalars['Boolean']['output'];
  leaveCpmCampaign: Scalars['Boolean']['output'];
  leaveTeam: MyData;
  login: UsersPermissionsLoginPayload;
  markCommunityJoined: MyData;
  markCourseModuleCompleted: CourseModule;
  prepareClip: MyClip;
  publishClipToFacebook: SocialPublish;
  publishClipToInstagram: SocialPublish;
  publishClipToTikTok: SocialPublish;
  publishClipToYouTube: SocialPublish;
  rateClip: RateClipResponse;
  recordOnboardingCourseOffer: MyData;
  redeemWalletForExtraMinutes: RedeemWalletResult;
  redeemWalletForPlan: RedeemWalletResult;
  refreshInvitationToken: MyData;
  /** Register a user */
  register: UsersPermissionsLoginPayload;
  removeTeamAccess: MyData;
  renderClip: MyClip;
  renderLibraryClip: MyClip;
  renderProjectClipV2: MyClip;
  renewPlanWithWallet: RedeemWalletResult;
  reportMotionPreview: Scalars['Boolean']['output'];
  requestCpmPayout: CpmPayoutRequest;
  requestSocialAnalyticsRefresh: Array<SocialAnalyticsRefreshResult>;
  requestTldvDownload: TldvDownload;
  /** Reset user password. Confirm with a code (resetToken from forgotPassword) */
  resetPassword?: Maybe<UsersPermissionsLoginPayload>;
  resolveAiAssistantAction: AssistantConversation;
  respondToMyCpmCampaignSubmissionAppeal: CpmCampaignSubmissionAppeal;
  restoreMotionVersion: MotionProject;
  retriggerMyAPIRequestWebhook: OkResponse;
  retryMyProject: MyProject;
  revokeMyClipMcpGrant?: Maybe<ClipMcpGrant>;
  saveMyViralizeQualificationAnswer: ViralizeQualification;
  saveMyViralizeQualificationContact: MyData;
  sendAiAssistantMessage: AssistantConversation;
  sendClipToTikTokDrafts: SocialPublish;
  sendMotionMessage: MotionProject;
  setCancellationReason: OkResponse;
  setMotionMusic: MotionProject;
  setMyAffiliateCustomCode: MyAffiliateStatus;
  setMyCpmLeaderboardAnonymous: MyCpmLeaderboardPrivacy;
  setPassword: Scalars['Boolean']['output'];
  startEditOnlyLibrary: MyLibrary;
  startEditOnlyProject: MyProject;
  startMyClipperRun: ClipperRunAdmission;
  startRenewedCycleNow: Scalars['Boolean']['output'];
  stopAiAssistantTurn: AssistantConversation;
  stopMotionTurn: MotionProject;
  submitAiAssistantClientResults: AssistantConversation;
  submitChallengeClip: ChallengeClip;
  submitMyCpmRankingReport: CpmRankingReport;
  submitMyPixVerification: MyPixVerification;
  tagLibrary: Scalars['Boolean']['output'];
  trackStockMediaUse: Scalars['Boolean']['output'];
  untagLibrary: Scalars['Boolean']['output'];
  unvoteTemplateSuggestion: TemplateSuggestion;
  updateAffiliate?: Maybe<Affiliate>;
  updateApiIdempotency?: Maybe<ApiIdempotency>;
  updateBrandLead?: Maybe<BrandLead>;
  updateBrandLeadEvent?: Maybe<BrandLeadEvent>;
  updateChallengeApplication?: Maybe<ChallengeApplication>;
  updateClip?: Maybe<Clip>;
  updateClipData: MyClip;
  updateClipView?: Maybe<ClipView>;
  updateCopyGeneration?: Maybe<CopyGeneration>;
  updateCoupon?: Maybe<Coupon>;
  updateCourseCoupon?: Maybe<CourseCoupon>;
  updateCpmPayout?: Maybe<CpmPayout>;
  updateCuration?: Maybe<Curation>;
  updateDownloadCookie?: Maybe<DownloadCookie>;
  updateDownloadInstagramAccount?: Maybe<DownloadInstagramAccount>;
  updateEmailDesignerV5EmailDesignerTemplate?: Maybe<EmailDesignerV5EmailDesignerTemplate>;
  updateEmailDesignerV5EmailDesignerTemplateVersion?: Maybe<EmailDesignerV5EmailDesignerTemplateVersion>;
  updateEmailFlow?: Maybe<EmailFlow>;
  updateEmailFlowRun?: Maybe<EmailFlowRun>;
  updateEmailFlowSend?: Maybe<EmailFlowSend>;
  updateEmailFlowStep?: Maybe<EmailFlowStep>;
  updateMyAPIKey: MyApiKey;
  updateMyBrandKit: MyBrandKit;
  updateMyData: MyData;
  updateMyPayoutData: MyPayoutData;
  updateMyProject: MyProject;
  updateMyPublishQueue: PublishQueue;
  updateMyScheduledPublish: SocialPublish;
  updateMyUserMedia: MyUserMedia;
  updateMyUserMediaFolder: MyUserMediaFolder;
  updateNewsletter?: Maybe<Newsletter>;
  updatePayment?: Maybe<Payment>;
  updateReviewWorkflowsWorkflow?: Maybe<ReviewWorkflowsWorkflow>;
  updateReviewWorkflowsWorkflowStage?: Maybe<ReviewWorkflowsWorkflowStage>;
  updateShortLink?: Maybe<ShortLink>;
  updateSubtitlePreset?: Maybe<SubtitlePreset>;
  updateTeamRole: MyData;
  updateUploadFile: UploadFile;
  updateUsageRecord?: Maybe<UsageRecord>;
  updateUserTag?: Maybe<UserTag>;
  /** Update an existing role */
  updateUsersPermissionsRole?: Maybe<UsersPermissionsUpdateRolePayload>;
  /** Update an existing user */
  updateUsersPermissionsUser: UsersPermissionsUserEntityResponse;
  updateWebhook?: Maybe<Webhook>;
  updateYoutubeDownload?: Maybe<YoutubeDownload>;
  validateChallengeClipHashtags: ChallengeClipValidation;
  verifyStorePurchase: StorePurchaseResult;
  voteTemplateSuggestion: TemplateSuggestion;
};


export type MutationAcceptAffiliateTermsArgs = {
  version: Scalars['String']['input'];
};


export type MutationAcceptCpmTermsArgs = {
  version: Scalars['String']['input'];
};


export type MutationAcceptInvitationArgs = {
  token: Scalars['String']['input'];
};


export type MutationActivateClipArgs = {
  id: Scalars['ID']['input'];
  input: ActivateClipInput;
};


export type MutationAddMotionFootageArgs = {
  footage: MotionFootageInput;
  projectId: Scalars['ID']['input'];
};


export type MutationAddUserTagArgs = {
  name: Scalars['String']['input'];
};


export type MutationAdminAddChallengeParticipantArgs = {
  challengeId: Scalars['ID']['input'];
  email: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
};


export type MutationAdminAddCommunityCurationVideoArgs = {
  nicheId?: InputMaybe<Scalars['ID']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
  url: Scalars['String']['input'];
};


export type MutationAdminAddToLibraryArgs = {
  input: AdminAddToLibraryInput;
};


export type MutationAdminApproveCpmPayoutArgs = {
  id: Scalars['ID']['input'];
};


export type MutationAdminBulkApproveCpmRankingClipsArgs = {
  campaignId: Scalars['ID']['input'];
  ids: Array<Scalars['ID']['input']>;
};


export type MutationAdminBulkRejectCpmRankingClipsArgs = {
  campaignId: Scalars['ID']['input'];
  ids: Array<Scalars['ID']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
};


export type MutationAdminBulkReviewCpmCampaignSubmissionsArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type MutationAdminConsolidateClipperSeasonArgs = {
  id: Scalars['ID']['input'];
};


export type MutationAdminCreateBrandKitArgs = {
  input: MyBrandKitCreateInput;
};


export type MutationAdminCreateChallengeArgs = {
  input: AdminChallengeCreateInput;
};


export type MutationAdminCreateChallengeRankingArgs = {
  challengeId: Scalars['ID']['input'];
  input: AdminChallengeRankingCreateInput;
};


export type MutationAdminCreateClipperSeasonArgs = {
  ends_at: Scalars['String']['input'];
  name: Scalars['String']['input'];
  starts_at: Scalars['String']['input'];
};


export type MutationAdminCreateCommunityCurationNicheArgs = {
  input: AdminCommunityCurationNicheInput;
};


export type MutationAdminCreateCouponArgs = {
  input: AdminCouponCreateInput;
};


export type MutationAdminCreateCpmCampaignArgs = {
  input: AdminCpmCampaignInput;
};


export type MutationAdminCreateCpmPayoutArgs = {
  input: AdminCreateCpmPayoutInput;
};


export type MutationAdminCreateEmailFlowArgs = {
  input: AdminEmailFlowInput;
};


export type MutationAdminCreateLiveWatchArgs = {
  input: AdminCreateLiveWatchInput;
};


export type MutationAdminCreateManualClipViewArgs = {
  clipId: Scalars['ID']['input'];
  date?: InputMaybe<Scalars['String']['input']>;
  views: Scalars['String']['input'];
};


export type MutationAdminDeleteChallengeArgs = {
  id: Scalars['ID']['input'];
};


export type MutationAdminDeleteChallengeRankingArgs = {
  id: Scalars['ID']['input'];
};


export type MutationAdminDeleteCommunityCurationNicheArgs = {
  id: Scalars['ID']['input'];
};


export type MutationAdminDeleteCouponArgs = {
  id: Scalars['ID']['input'];
};


export type MutationAdminDeleteCpmCampaignArgs = {
  force?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
};


export type MutationAdminDeleteCpmPayoutArgs = {
  id: Scalars['ID']['input'];
};


export type MutationAdminDeleteEmailFlowArgs = {
  id: Scalars['ID']['input'];
};


export type MutationAdminDeleteEmailFlowStepArgs = {
  id: Scalars['ID']['input'];
};


export type MutationAdminDeleteLibraryArgs = {
  id: Scalars['ID']['input'];
};


export type MutationAdminDisqualifyCpmCampaignSubmissionArgs = {
  id: Scalars['ID']['input'];
  reason: Scalars['String']['input'];
};


export type MutationAdminDisqualifyCpmCampaignUserArgs = {
  campaignId: Scalars['ID']['input'];
  reason: Scalars['String']['input'];
  userId: Scalars['ID']['input'];
};


export type MutationAdminDisqualifyParticipantArgs = {
  disqualified: Scalars['Boolean']['input'];
  participantId: Scalars['ID']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
};


export type MutationAdminEnqueueCpmSubmissionMediaDownloadArgs = {
  submissionId: Scalars['ID']['input'];
};


export type MutationAdminFinalizeCpmRankingArgs = {
  campaignId: Scalars['ID']['input'];
  expectedFingerprint: Scalars['String']['input'];
};


export type MutationAdminForceConsolidationArgs = {
  rankingId: Scalars['ID']['input'];
};


export type MutationAdminForceStartSnapshotArgs = {
  rankingId: Scalars['ID']['input'];
};


export type MutationAdminForceUpdateAllChallengeClipViewsArgs = {
  challengeId: Scalars['ID']['input'];
};


export type MutationAdminForceUpdateAllCpmCampaignSubmissionViewsArgs = {
  campaignId: Scalars['ID']['input'];
};


export type MutationAdminForceUpdateChallengeClipViewArgs = {
  clipId: Scalars['ID']['input'];
};


export type MutationAdminForceUpdateChallengeClipViewsArgs = {
  clipIds: Array<Scalars['ID']['input']>;
};


export type MutationAdminForceUpdateCpmCampaignSubmissionViewArgs = {
  id: Scalars['ID']['input'];
};


export type MutationAdminGenerateCpmCampaignReportConclusionsArgs = {
  campaignId: Scalars['ID']['input'];
  expectedFactsFingerprint: Scalars['String']['input'];
  reportAsOf: Scalars['String']['input'];
};


export type MutationAdminImpersonateUserArgs = {
  userId: Scalars['ID']['input'];
};


export type MutationAdminImportDriveToChannelArgs = {
  channelId: Scalars['ID']['input'];
  urls: Array<Scalars['String']['input']>;
};


export type MutationAdminInviteCpmCampaignUserArgs = {
  campaignId: Scalars['ID']['input'];
  channelUrl: Scalars['String']['input'];
  email: Scalars['String']['input'];
  platform: Scalars['String']['input'];
};


export type MutationAdminLinkCpmSubmissionContentArgs = {
  reason?: InputMaybe<Scalars['String']['input']>;
  submissionIds: Array<Scalars['ID']['input']>;
};


export type MutationAdminRecomputeCpmCampaignPayoutsArgs = {
  campaignId: Scalars['ID']['input'];
};


export type MutationAdminRegenerateTranscriptionArgs = {
  id: Scalars['ID']['input'];
};


export type MutationAdminRemoveChallengeParticipantArgs = {
  challengeId: Scalars['ID']['input'];
  participantId: Scalars['ID']['input'];
};


export type MutationAdminReorderEmailFlowStepsArgs = {
  flowId: Scalars['ID']['input'];
  stepIds: Array<Scalars['ID']['input']>;
};


export type MutationAdminReplyCpmLeadArgs = {
  documentId: Scalars['ID']['input'];
  text: Scalars['String']['input'];
};


export type MutationAdminResetAllChallengeParticipantsUsageArgs = {
  challengeId: Scalars['ID']['input'];
};


export type MutationAdminResetChallengeParticipantUsageArgs = {
  challengeId: Scalars['ID']['input'];
  participantId: Scalars['ID']['input'];
};


export type MutationAdminResolveCpmRankingTieArgs = {
  campaignId: Scalars['ID']['input'];
  participantIds: Array<Scalars['ID']['input']>;
  reason: Scalars['String']['input'];
};


export type MutationAdminResolveSuspectedDuplicateArgs = {
  action: Scalars['String']['input'];
  id: Scalars['ID']['input'];
};


export type MutationAdminRestartCpmLeadArgs = {
  documentId: Scalars['ID']['input'];
};


export type MutationAdminRestoreExpiredClipArgs = {
  id: Scalars['ID']['input'];
};


export type MutationAdminRestoreExpiredItemsArgs = {
  userId: Scalars['ID']['input'];
};


export type MutationAdminRestoreExpiredLibraryArgs = {
  id: Scalars['ID']['input'];
};


export type MutationAdminRestoreExpiredProjectArgs = {
  id: Scalars['ID']['input'];
};


export type MutationAdminRetryFailedClipArgs = {
  id: Scalars['ID']['input'];
};


export type MutationAdminRetryFailedLibraryArgs = {
  id: Scalars['ID']['input'];
};


export type MutationAdminRetryFailedProjectArgs = {
  id: Scalars['ID']['input'];
};


export type MutationAdminReverseAffiliateEarningArgs = {
  id: Scalars['ID']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
};


export type MutationAdminReviewCpmCampaignChannelRequestArgs = {
  id: Scalars['ID']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
  status: Scalars['String']['input'];
};


export type MutationAdminReviewCpmCampaignSubmissionArgs = {
  approval: Scalars['String']['input'];
  id: Scalars['ID']['input'];
  images?: InputMaybe<Array<CpmReviewImageInput>>;
  reason?: InputMaybe<Scalars['String']['input']>;
};


export type MutationAdminReviewCpmCampaignSubmissionAppealArgs = {
  decision: Scalars['String']['input'];
  id: Scalars['ID']['input'];
  images?: InputMaybe<Array<CpmReviewImageInput>>;
  reply?: InputMaybe<Scalars['String']['input']>;
};


export type MutationAdminReviewCpmContentGroupArgs = {
  decision: Scalars['String']['input'];
  id: Scalars['ID']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
};


export type MutationAdminReviewCpmRankingClipArgs = {
  approval: Scalars['String']['input'];
  id: Scalars['ID']['input'];
  ownershipVerified?: InputMaybe<Scalars['Boolean']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
};


export type MutationAdminReviewCpmRankingReportArgs = {
  id: Scalars['ID']['input'];
  input: CpmRankingReviewInput;
};


export type MutationAdminReviewCpmRankingSubmissionArgs = {
  id: Scalars['ID']['input'];
  input: CpmRankingReviewInput;
};


export type MutationAdminReviewPixVerificationArgs = {
  id: Scalars['ID']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
  status: Scalars['String']['input'];
};


export type MutationAdminReviewTemplateSuggestionArgs = {
  brandKitId?: InputMaybe<Scalars['ID']['input']>;
  id: Scalars['ID']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
  status: Scalars['String']['input'];
};


export type MutationAdminRevokeCpmCampaignChannelRequestArgs = {
  id: Scalars['ID']['input'];
  reason: Scalars['String']['input'];
};


export type MutationAdminRunCampaignLiveImportArgs = {
  campaignId: Scalars['ID']['input'];
};


export type MutationAdminRunCommunityCurationArgs = {
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationAdminSaveCampaignLiveImportArgs = {
  campaignId: Scalars['ID']['input'];
  input: AdminCampaignLiveImportInput;
};


export type MutationAdminSendTestEmailFlowStepArgs = {
  locale: Scalars['String']['input'];
  recipientEmail: Scalars['String']['input'];
  stepId: Scalars['ID']['input'];
};


export type MutationAdminSetAffiliateBlockedArgs = {
  blocked: Scalars['Boolean']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['ID']['input'];
};


export type MutationAdminSetAffiliateRatesArgs = {
  input: AdminAffiliateRatesInput;
  userId: Scalars['ID']['input'];
};


export type MutationAdminSetAiAssistantAccessArgs = {
  enabled: Scalars['Boolean']['input'];
  userId: Scalars['ID']['input'];
};


export type MutationAdminSetChallengeClipApprovalArgs = {
  approval: Scalars['String']['input'];
  id: Scalars['ID']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
};


export type MutationAdminSetChallengeClipHashtagValidationArgs = {
  id: Scalars['ID']['input'];
  validated_hashtags: Scalars['String']['input'];
};


export type MutationAdminSetCourseRevenueShareActiveArgs = {
  active: Scalars['Boolean']['input'];
  id: Scalars['ID']['input'];
};


export type MutationAdminSetCpmCampaignSubmissionCpmOverrideArgs = {
  cpm_rate_cents?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['ID']['input'];
};


export type MutationAdminSetCpmCampaignSubmissionHashtagValidationArgs = {
  id: Scalars['ID']['input'];
  validated_hashtags: Scalars['String']['input'];
};


export type MutationAdminSetCpmCampaignSubmissionObservationArgs = {
  id: Scalars['ID']['input'];
  observation?: InputMaybe<Scalars['String']['input']>;
};


export type MutationAdminSetCpmLeaderboardExclusionArgs = {
  excluded: Scalars['Boolean']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['ID']['input'];
};


export type MutationAdminSetFacebookConnectionsAccessArgs = {
  enabled: Scalars['Boolean']['input'];
  userId: Scalars['ID']['input'];
};


export type MutationAdminSetLiveWatchEnabledArgs = {
  enabled: Scalars['Boolean']['input'];
  id: Scalars['ID']['input'];
};


export type MutationAdminSnapshotClipperSeasonStartArgs = {
  id: Scalars['ID']['input'];
};


export type MutationAdminStopLiveSessionArgs = {
  id: Scalars['ID']['input'];
};


export type MutationAdminSyncMissingChallengeClipViewsArgs = {
  challengeId: Scalars['ID']['input'];
};


export type MutationAdminSyncMissingCpmCampaignSubmissionViewsArgs = {
  campaignId: Scalars['ID']['input'];
};


export type MutationAdminUndisqualifyCpmCampaignUserArgs = {
  campaignId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};


export type MutationAdminUpdateChallengeArgs = {
  id: Scalars['ID']['input'];
  input: AdminChallengeUpdateInput;
};


export type MutationAdminUpdateChallengeRankingArgs = {
  id: Scalars['ID']['input'];
  input: AdminChallengeRankingUpdateInput;
};


export type MutationAdminUpdateClipperSeasonArgs = {
  ends_at?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  starts_at?: InputMaybe<Scalars['String']['input']>;
};


export type MutationAdminUpdateCommunityCurationNicheArgs = {
  id: Scalars['ID']['input'];
  input: AdminCommunityCurationNicheInput;
};


export type MutationAdminUpdateCommunityCurationSettingsArgs = {
  input: AdminCommunityCurationSettingsInput;
};


export type MutationAdminUpdateCouponArgs = {
  id: Scalars['ID']['input'];
  input: AdminCouponUpdateInput;
};


export type MutationAdminUpdateCpmCampaignArgs = {
  id: Scalars['ID']['input'];
  input: AdminCpmCampaignInput;
};


export type MutationAdminUpdateCpmCampaignContentArgs = {
  campaignId: Scalars['ID']['input'];
  input: CampaignAuditContentInput;
};


export type MutationAdminUpdateEmailFlowArgs = {
  id: Scalars['ID']['input'];
  input: AdminEmailFlowUpdateInput;
};


export type MutationAdminUpdateLiveWatchArgs = {
  id: Scalars['ID']['input'];
  input: AdminCreateLiveWatchInput;
};


export type MutationAdminUpdateSnapshotViewArgs = {
  id: Scalars['ID']['input'];
  views: Scalars['String']['input'];
};


export type MutationAdminUpdateUserSubscriptionArgs = {
  input: AdminUpdateUserSubscriptionInput;
  userId: Scalars['ID']['input'];
};


export type MutationAdminUpdateYoutubeChannelArgs = {
  id: Scalars['ID']['input'];
  is_autoclipper_partner: Scalars['Boolean']['input'];
};


export type MutationAdminUpsertCourseRevenueShareArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  input: AdminCourseRevenueShareInput;
};


export type MutationAdminUpsertEmailFlowStepArgs = {
  input: AdminEmailFlowStepInput;
};


export type MutationAdminValidateRankingArgs = {
  id: Scalars['ID']['input'];
  validated: Scalars['Boolean']['input'];
};


export type MutationApplyMotionEditsArgs = {
  baseVersionId: Scalars['ID']['input'];
  ops: Array<MotionEditOpInput>;
  projectId: Scalars['ID']['input'];
};


export type MutationApplyRenewalCouponArgs = {
  code: Scalars['String']['input'];
};


export type MutationCancelMyScheduledPublishArgs = {
  id: Scalars['ID']['input'];
};


export type MutationChangeOnboardingObjectiveArgs = {
  to: Scalars['String']['input'];
};


export type MutationChangePasswordArgs = {
  currentPassword: Scalars['String']['input'];
  password: Scalars['String']['input'];
  passwordConfirmation: Scalars['String']['input'];
};


export type MutationClaimReferralAttributionArgs = {
  code: Scalars['String']['input'];
};


export type MutationClipProjectArgs = {
  input: ClipProjectInput;
};


export type MutationCompleteMyCampaignEntryArgs = {
  campaignId: Scalars['ID']['input'];
};


export type MutationCreateAffiliateArgs = {
  data: AffiliateInput;
  status?: InputMaybe<PublicationStatus>;
};


export type MutationCreateApiIdempotencyArgs = {
  data: ApiIdempotencyInput;
  status?: InputMaybe<PublicationStatus>;
};


export type MutationCreateBrandLeadArgs = {
  data: BrandLeadInput;
  status?: InputMaybe<PublicationStatus>;
};


export type MutationCreateBrandLeadEventArgs = {
  data: BrandLeadEventInput;
  status?: InputMaybe<PublicationStatus>;
};


export type MutationCreateChallengeApplicationArgs = {
  data: ChallengeApplicationInput;
  status?: InputMaybe<PublicationStatus>;
};


export type MutationCreateClipArgs = {
  data: ClipInput;
  status?: InputMaybe<PublicationStatus>;
};


export type MutationCreateClipViewArgs = {
  data: ClipViewInput;
  status?: InputMaybe<PublicationStatus>;
};


export type MutationCreateCopiesArgs = {
  id: Scalars['ID']['input'];
};


export type MutationCreateCopyGenerationArgs = {
  data: CopyGenerationInput;
  status?: InputMaybe<PublicationStatus>;
};


export type MutationCreateCouponArgs = {
  data: CouponInput;
  status?: InputMaybe<PublicationStatus>;
};


export type MutationCreateCourseCouponArgs = {
  data: CourseCouponInput;
  status?: InputMaybe<PublicationStatus>;
};


export type MutationCreateCoursePurchaseCheckoutArgs = {
  affiliateCode?: InputMaybe<Scalars['String']['input']>;
  cancelUrl?: InputMaybe<Scalars['String']['input']>;
  couponCode?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  offerCode?: InputMaybe<Scalars['String']['input']>;
  phone: Scalars['String']['input'];
  phoneDetails?: InputMaybe<CoursePurchasePhoneInput>;
  returnUrl: Scalars['String']['input'];
  slug: Scalars['String']['input'];
  utm?: InputMaybe<CoursePurchaseUtmInput>;
};


export type MutationCreateCoursePurchasePixArgs = {
  affiliateCode?: InputMaybe<Scalars['String']['input']>;
  couponCode?: InputMaybe<Scalars['String']['input']>;
  documentNumber: Scalars['String']['input'];
  documentType: Scalars['String']['input'];
  email?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  offerCode?: InputMaybe<Scalars['String']['input']>;
  phone: Scalars['String']['input'];
  phoneDetails?: InputMaybe<CoursePurchasePhoneInput>;
  slug: Scalars['String']['input'];
  utm?: InputMaybe<CoursePurchaseUtmInput>;
};


export type MutationCreateCpmPayoutArgs = {
  data: CpmPayoutInput;
  status?: InputMaybe<PublicationStatus>;
};


export type MutationCreateCurationArgs = {
  data: CurationInput;
  status?: InputMaybe<PublicationStatus>;
};


export type MutationCreateDownloadCookieArgs = {
  data: DownloadCookieInput;
  status?: InputMaybe<PublicationStatus>;
};


export type MutationCreateDownloadInstagramAccountArgs = {
  data: DownloadInstagramAccountInput;
  status?: InputMaybe<PublicationStatus>;
};


export type MutationCreateEmailDesignerV5EmailDesignerTemplateArgs = {
  data: EmailDesignerV5EmailDesignerTemplateInput;
  status?: InputMaybe<PublicationStatus>;
};


export type MutationCreateEmailDesignerV5EmailDesignerTemplateVersionArgs = {
  data: EmailDesignerV5EmailDesignerTemplateVersionInput;
  status?: InputMaybe<PublicationStatus>;
};


export type MutationCreateEmailFlowArgs = {
  data: EmailFlowInput;
  status?: InputMaybe<PublicationStatus>;
};


export type MutationCreateEmailFlowRunArgs = {
  data: EmailFlowRunInput;
  status?: InputMaybe<PublicationStatus>;
};


export type MutationCreateEmailFlowSendArgs = {
  data: EmailFlowSendInput;
  status?: InputMaybe<PublicationStatus>;
};


export type MutationCreateEmailFlowStepArgs = {
  data: EmailFlowStepInput;
  status?: InputMaybe<PublicationStatus>;
};


export type MutationCreateGuestSubscriptionCheckoutArgs = {
  affiliateCode?: InputMaybe<Scalars['String']['input']>;
  brandLook?: InputMaybe<Scalars['String']['input']>;
  cancelUrl?: InputMaybe<Scalars['String']['input']>;
  coupon?: InputMaybe<Scalars['String']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  planId: Scalars['ID']['input'];
  returnUrl: Scalars['String']['input'];
  utm?: InputMaybe<CoursePurchaseUtmInput>;
  yearly: Scalars['Boolean']['input'];
};


export type MutationCreateGuestSubscriptionPixArgs = {
  affiliateCode?: InputMaybe<Scalars['String']['input']>;
  brandLook?: InputMaybe<Scalars['String']['input']>;
  coupon?: InputMaybe<Scalars['String']['input']>;
  documentNumber: Scalars['String']['input'];
  documentType: Scalars['String']['input'];
  email: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  phone: Scalars['String']['input'];
  phoneDetails?: InputMaybe<CoursePurchasePhoneInput>;
  planId: Scalars['ID']['input'];
  utm?: InputMaybe<CoursePurchaseUtmInput>;
  yearly: Scalars['Boolean']['input'];
};


export type MutationCreateLibraryTagArgs = {
  color?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};


export type MutationCreateMotionProjectArgs = {
  attachments?: InputMaybe<Array<MotionAttachmentInput>>;
  deferStart?: InputMaybe<Scalars['Boolean']['input']>;
  text: Scalars['String']['input'];
};


export type MutationCreateMyApiKeyArgs = {
  input: MyApiKeyCreateInput;
};


export type MutationCreateMyBrandKitArgs = {
  input: MyBrandKitCreateInput;
};


export type MutationCreateMyCpmCampaignChannelRequestArgs = {
  campaignId: Scalars['ID']['input'];
  platform: Scalars['String']['input'];
  url: Scalars['String']['input'];
};


export type MutationCreateMyCpmCampaignSubmissionArgs = {
  input: CreateMyCpmCampaignSubmissionInput;
};


export type MutationCreateMyCpmCampaignSubmissionAppealArgs = {
  argument: Scalars['String']['input'];
  evidenceImageUrls?: InputMaybe<Array<Scalars['String']['input']>>;
  extraUrl?: InputMaybe<Scalars['String']['input']>;
  submissionId: Scalars['ID']['input'];
};


export type MutationCreateMyLibraryArgs = {
  input: MyLibraryCreateInput;
};


export type MutationCreateMyProjectArgs = {
  input: MyProjectCreateInput;
};


export type MutationCreateMyPublishQueueArgs = {
  input: PublishQueueInput;
};


export type MutationCreateMyScheduledPublishArgs = {
  input: ScheduledPublishInput;
};


export type MutationCreateMyTemplateSuggestionArgs = {
  input: TemplateSuggestionInput;
};


export type MutationCreateMyUserMediaArgs = {
  input: MyUserMediaCreateInput;
};


export type MutationCreateMyUserMediaFolderArgs = {
  name: Scalars['String']['input'];
};


export type MutationCreateNewsletterArgs = {
  data: NewsletterInput;
  status?: InputMaybe<PublicationStatus>;
};


export type MutationCreatePaymentArgs = {
  data: PaymentInput;
  status?: InputMaybe<PublicationStatus>;
};


export type MutationCreatePixRenewalOrderArgs = {
  resetNow?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationCreateReportLeadArgs = {
  data: ReportLeadInput;
};


export type MutationCreateReviewWorkflowsWorkflowArgs = {
  data: ReviewWorkflowsWorkflowInput;
  status?: InputMaybe<PublicationStatus>;
};


export type MutationCreateReviewWorkflowsWorkflowStageArgs = {
  data: ReviewWorkflowsWorkflowStageInput;
  status?: InputMaybe<PublicationStatus>;
};


export type MutationCreateShortLinkArgs = {
  data: ShortLinkInput;
  status?: InputMaybe<PublicationStatus>;
};


export type MutationCreateSubtitlePresetArgs = {
  data: SubtitlePresetInput;
  status?: InputMaybe<PublicationStatus>;
};


export type MutationCreateUsageRecordArgs = {
  data: UsageRecordInput;
  status?: InputMaybe<PublicationStatus>;
};


export type MutationCreateUserTagArgs = {
  data: UserTagInput;
  status?: InputMaybe<PublicationStatus>;
};


export type MutationCreateUsersPermissionsRoleArgs = {
  data: UsersPermissionsRoleInput;
};


export type MutationCreateUsersPermissionsUserArgs = {
  data: UsersPermissionsUserInput;
};


export type MutationCreateWebhookArgs = {
  data: WebhookInput;
  status?: InputMaybe<PublicationStatus>;
};


export type MutationCreateYoutubeDownloadArgs = {
  data: YoutubeDownloadInput;
  status?: InputMaybe<PublicationStatus>;
};


export type MutationDeleteAffiliateArgs = {
  documentId: Scalars['ID']['input'];
};


export type MutationDeleteApiIdempotencyArgs = {
  documentId: Scalars['ID']['input'];
};


export type MutationDeleteBrandLeadArgs = {
  documentId: Scalars['ID']['input'];
};


export type MutationDeleteBrandLeadEventArgs = {
  documentId: Scalars['ID']['input'];
};


export type MutationDeleteChallengeApplicationArgs = {
  documentId: Scalars['ID']['input'];
};


export type MutationDeleteClipArgs = {
  documentId: Scalars['ID']['input'];
};


export type MutationDeleteClipViewArgs = {
  documentId: Scalars['ID']['input'];
};


export type MutationDeleteCopyGenerationArgs = {
  documentId: Scalars['ID']['input'];
};


export type MutationDeleteCouponArgs = {
  documentId: Scalars['ID']['input'];
};


export type MutationDeleteCourseCouponArgs = {
  documentId: Scalars['ID']['input'];
};


export type MutationDeleteCpmPayoutArgs = {
  documentId: Scalars['ID']['input'];
};


export type MutationDeleteCurationArgs = {
  documentId: Scalars['ID']['input'];
};


export type MutationDeleteDownloadCookieArgs = {
  documentId: Scalars['ID']['input'];
};


export type MutationDeleteDownloadInstagramAccountArgs = {
  documentId: Scalars['ID']['input'];
};


export type MutationDeleteEmailDesignerV5EmailDesignerTemplateArgs = {
  documentId: Scalars['ID']['input'];
};


export type MutationDeleteEmailDesignerV5EmailDesignerTemplateVersionArgs = {
  documentId: Scalars['ID']['input'];
};


export type MutationDeleteEmailFlowArgs = {
  documentId: Scalars['ID']['input'];
};


export type MutationDeleteEmailFlowRunArgs = {
  documentId: Scalars['ID']['input'];
};


export type MutationDeleteEmailFlowSendArgs = {
  documentId: Scalars['ID']['input'];
};


export type MutationDeleteEmailFlowStepArgs = {
  documentId: Scalars['ID']['input'];
};


export type MutationDeleteLibraryTagArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteMotionProjectArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteMyApiKeyArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteMyAiAssistantConversationArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteMyBrandKitArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteMyClipArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteMyCpmCampaignChannelRequestArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteMyCpmCampaignSubmissionArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteMyLibraryArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteMyProjectArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteMyPublishQueueArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteMyUserMediaArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteMyUserMediaFolderArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteNewsletterArgs = {
  documentId: Scalars['ID']['input'];
};


export type MutationDeletePaymentArgs = {
  documentId: Scalars['ID']['input'];
};


export type MutationDeleteReviewWorkflowsWorkflowArgs = {
  documentId: Scalars['ID']['input'];
};


export type MutationDeleteReviewWorkflowsWorkflowStageArgs = {
  documentId: Scalars['ID']['input'];
};


export type MutationDeleteShortLinkArgs = {
  documentId: Scalars['ID']['input'];
};


export type MutationDeleteSubtitlePresetArgs = {
  documentId: Scalars['ID']['input'];
};


export type MutationDeleteUploadFileArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteUsageRecordArgs = {
  documentId: Scalars['ID']['input'];
};


export type MutationDeleteUserTagArgs = {
  documentId: Scalars['ID']['input'];
};


export type MutationDeleteUsersPermissionsRoleArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteUsersPermissionsUserArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteWebhookArgs = {
  documentId: Scalars['ID']['input'];
};


export type MutationDeleteYoutubeDownloadArgs = {
  documentId: Scalars['ID']['input'];
};


export type MutationDisconnectMySocialConnectionArgs = {
  id: Scalars['ID']['input'];
};


export type MutationEmailConfirmationArgs = {
  confirmation: Scalars['String']['input'];
};


export type MutationEnqueueToPublishQueueArgs = {
  clipId: Scalars['ID']['input'];
  copy: EnqueueToPublishQueueCopyInput;
  queueId: Scalars['ID']['input'];
};


export type MutationFinishMyClipperRunArgs = {
  events: Array<ClipperRunInputEvent>;
  frames: Scalars['Int']['input'];
  runId: Scalars['ID']['input'];
};


export type MutationForgotPasswordArgs = {
  email: Scalars['String']['input'];
};


export type MutationGenerateMyAiAssistantSuggestionsArgs = {
  clientContext?: InputMaybe<Scalars['JSON']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  path?: InputMaybe<Scalars['String']['input']>;
  previous?: InputMaybe<Array<Scalars['String']['input']>>;
  sessionId: Scalars['String']['input'];
};


export type MutationGenerateMyCoverImageArgs = {
  aspect: CoverAspect;
  clipId: Scalars['ID']['input'];
  prompt?: InputMaybe<Scalars['String']['input']>;
  referenceUrl?: InputMaybe<Scalars['String']['input']>;
};


export type MutationGenerateMyQuoteSuggestionsArgs = {
  clipId: Scalars['ID']['input'];
};


export type MutationIncrementBlogPostViewsArgs = {
  id: Scalars['ID']['input'];
};


export type MutationJoinChallengeArgs = {
  challengeId: Scalars['ID']['input'];
};


export type MutationJoinCpmCampaignArgs = {
  campaignId: Scalars['ID']['input'];
};


export type MutationLeaveCpmCampaignArgs = {
  campaignId: Scalars['ID']['input'];
};


export type MutationLoginArgs = {
  input: UsersPermissionsLoginInput;
};


export type MutationMarkCourseModuleCompletedArgs = {
  moduleId: Scalars['ID']['input'];
};


export type MutationPrepareClipArgs = {
  id: Scalars['ID']['input'];
};


export type MutationPublishClipToFacebookArgs = {
  caption?: InputMaybe<Scalars['String']['input']>;
  clipId: Scalars['ID']['input'];
  imageUrls?: InputMaybe<Array<Scalars['String']['input']>>;
  socialConnectionId: Scalars['ID']['input'];
};


export type MutationPublishClipToInstagramArgs = {
  caption?: InputMaybe<Scalars['String']['input']>;
  clipId: Scalars['ID']['input'];
  imageUrls?: InputMaybe<Array<Scalars['String']['input']>>;
  socialConnectionId: Scalars['ID']['input'];
};


export type MutationPublishClipToTikTokArgs = {
  brandContentToggle?: InputMaybe<Scalars['Boolean']['input']>;
  brandOrganicToggle?: InputMaybe<Scalars['Boolean']['input']>;
  clipId: Scalars['ID']['input'];
  disableComment?: InputMaybe<Scalars['Boolean']['input']>;
  disableDuet?: InputMaybe<Scalars['Boolean']['input']>;
  disableStitch?: InputMaybe<Scalars['Boolean']['input']>;
  imageUrls?: InputMaybe<Array<Scalars['String']['input']>>;
  isAigc?: InputMaybe<Scalars['Boolean']['input']>;
  privacyLevel: Scalars['String']['input'];
  socialConnectionId: Scalars['ID']['input'];
  title?: InputMaybe<Scalars['String']['input']>;
};


export type MutationPublishClipToYouTubeArgs = {
  clipId: Scalars['ID']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  madeForKids: Scalars['Boolean']['input'];
  privacyStatus: Scalars['String']['input'];
  socialConnectionId: Scalars['ID']['input'];
  title: Scalars['String']['input'];
};


export type MutationRateClipArgs = {
  id: Scalars['ID']['input'];
  rating: Scalars['String']['input'];
};


export type MutationRecordOnboardingCourseOfferArgs = {
  event: Scalars['String']['input'];
  experience?: InputMaybe<Scalars['String']['input']>;
};


export type MutationRedeemWalletForExtraMinutesArgs = {
  document?: InputMaybe<Scalars['JSON']['input']>;
  minutes: Scalars['Int']['input'];
  remainderMethod?: InputMaybe<Scalars['String']['input']>;
  returnUrl?: InputMaybe<Scalars['String']['input']>;
};


export type MutationRedeemWalletForPlanArgs = {
  coupon?: InputMaybe<Scalars['String']['input']>;
  document?: InputMaybe<Scalars['JSON']['input']>;
  planId: Scalars['ID']['input'];
  remainderMethod?: InputMaybe<Scalars['String']['input']>;
  yearly?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationRegisterArgs = {
  input: UsersPermissionsRegisterInput;
};


export type MutationRemoveTeamAccessArgs = {
  email: Scalars['String']['input'];
};


export type MutationRenderClipArgs = {
  id: Scalars['ID']['input'];
  input: Scalars['JSON']['input'];
};


export type MutationRenderLibraryClipArgs = {
  id: Scalars['ID']['input'];
  input: Scalars['JSON']['input'];
};


export type MutationRenderProjectClipV2Args = {
  id: Scalars['ID']['input'];
  input: Scalars['JSON']['input'];
};


export type MutationRenewPlanWithWalletArgs = {
  document?: InputMaybe<Scalars['JSON']['input']>;
  remainderMethod?: InputMaybe<Scalars['String']['input']>;
  returnUrl?: InputMaybe<Scalars['String']['input']>;
};


export type MutationReportMotionPreviewArgs = {
  errors?: InputMaybe<Scalars['JSON']['input']>;
  versionId: Scalars['ID']['input'];
};


export type MutationRequestCpmPayoutArgs = {
  input: RequestCpmPayoutInput;
};


export type MutationRequestSocialAnalyticsRefreshArgs = {
  socialConnectionIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type MutationRequestTldvDownloadArgs = {
  url: Scalars['String']['input'];
};


export type MutationResetPasswordArgs = {
  code: Scalars['String']['input'];
  password: Scalars['String']['input'];
  passwordConfirmation: Scalars['String']['input'];
};


export type MutationResolveAiAssistantActionArgs = {
  actionId: Scalars['ID']['input'];
  approve: Scalars['Boolean']['input'];
  conversationId: Scalars['ID']['input'];
  path?: InputMaybe<Scalars['String']['input']>;
};


export type MutationRespondToMyCpmCampaignSubmissionAppealArgs = {
  argument: Scalars['String']['input'];
  evidenceImageUrls?: InputMaybe<Array<Scalars['String']['input']>>;
  extraUrl?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};


export type MutationRestoreMotionVersionArgs = {
  projectId: Scalars['ID']['input'];
  versionId: Scalars['ID']['input'];
};


export type MutationRetriggerMyApiRequestWebhookArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRetryMyProjectArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRevokeMyClipMcpGrantArgs = {
  id: Scalars['ID']['input'];
};


export type MutationSaveMyViralizeQualificationAnswerArgs = {
  input: SaveMyViralizeQualificationAnswerInput;
};


export type MutationSaveMyViralizeQualificationContactArgs = {
  name?: InputMaybe<Scalars['String']['input']>;
  phoneDetails?: InputMaybe<CoursePurchasePhoneInput>;
};


export type MutationSendAiAssistantMessageArgs = {
  attachments?: InputMaybe<Array<AssistantAttachmentInput>>;
  clientContext?: InputMaybe<Scalars['JSON']['input']>;
  conversationId?: InputMaybe<Scalars['ID']['input']>;
  path?: InputMaybe<Scalars['String']['input']>;
  text: Scalars['String']['input'];
};


export type MutationSendClipToTikTokDraftsArgs = {
  caption?: InputMaybe<Scalars['String']['input']>;
  clipId: Scalars['ID']['input'];
  socialConnectionId: Scalars['ID']['input'];
};


export type MutationSendMotionMessageArgs = {
  attachments?: InputMaybe<Array<MotionAttachmentInput>>;
  clientRequestId?: InputMaybe<Scalars['String']['input']>;
  projectId: Scalars['ID']['input'];
  repair?: InputMaybe<Scalars['Boolean']['input']>;
  text: Scalars['String']['input'];
};


export type MutationSetCancellationReasonArgs = {
  feedback: Scalars['String']['input'];
  reason: Scalars['String']['input'];
};


export type MutationSetMotionMusicArgs = {
  baseVersionId: Scalars['ID']['input'];
  music: MotionMusicInput;
  projectId: Scalars['ID']['input'];
};


export type MutationSetMyAffiliateCustomCodeArgs = {
  code: Scalars['String']['input'];
};


export type MutationSetMyCpmLeaderboardAnonymousArgs = {
  anonymous: Scalars['Boolean']['input'];
};


export type MutationSetPasswordArgs = {
  currentPassword?: InputMaybe<Scalars['String']['input']>;
  newPassword: Scalars['String']['input'];
};


export type MutationStartEditOnlyLibraryArgs = {
  endSeconds?: InputMaybe<Scalars['Float']['input']>;
  id: Scalars['ID']['input'];
  startSeconds: Scalars['Float']['input'];
};


export type MutationStartEditOnlyProjectArgs = {
  endSeconds?: InputMaybe<Scalars['Float']['input']>;
  id: Scalars['ID']['input'];
  startSeconds: Scalars['Float']['input'];
};


export type MutationStopAiAssistantTurnArgs = {
  conversationId: Scalars['ID']['input'];
};


export type MutationStopMotionTurnArgs = {
  projectId: Scalars['ID']['input'];
};


export type MutationSubmitAiAssistantClientResultsArgs = {
  clientContext?: InputMaybe<Scalars['JSON']['input']>;
  conversationId: Scalars['ID']['input'];
  results: Array<AssistantClientResultInput>;
};


export type MutationSubmitChallengeClipArgs = {
  input: SubmitChallengeClipInput;
};


export type MutationSubmitMyCpmRankingReportArgs = {
  campaignId: Scalars['ID']['input'];
  input: CpmRankingReportInput;
};


export type MutationSubmitMyPixVerificationArgs = {
  cpf: Scalars['String']['input'];
  document_back_url?: InputMaybe<Scalars['String']['input']>;
  document_url: Scalars['String']['input'];
};


export type MutationTagLibraryArgs = {
  libraryId: Scalars['ID']['input'];
  tagId: Scalars['ID']['input'];
};


export type MutationTrackStockMediaUseArgs = {
  download_location: Scalars['String']['input'];
  provider: StockMediaProvider;
};


export type MutationUntagLibraryArgs = {
  libraryId: Scalars['ID']['input'];
  tagId: Scalars['ID']['input'];
};


export type MutationUnvoteTemplateSuggestionArgs = {
  id: Scalars['ID']['input'];
};


export type MutationUpdateAffiliateArgs = {
  data: AffiliateInput;
  documentId: Scalars['ID']['input'];
  status?: InputMaybe<PublicationStatus>;
};


export type MutationUpdateApiIdempotencyArgs = {
  data: ApiIdempotencyInput;
  documentId: Scalars['ID']['input'];
  status?: InputMaybe<PublicationStatus>;
};


export type MutationUpdateBrandLeadArgs = {
  data: BrandLeadInput;
  documentId: Scalars['ID']['input'];
  status?: InputMaybe<PublicationStatus>;
};


export type MutationUpdateBrandLeadEventArgs = {
  data: BrandLeadEventInput;
  documentId: Scalars['ID']['input'];
  status?: InputMaybe<PublicationStatus>;
};


export type MutationUpdateChallengeApplicationArgs = {
  data: ChallengeApplicationInput;
  documentId: Scalars['ID']['input'];
  status?: InputMaybe<PublicationStatus>;
};


export type MutationUpdateClipArgs = {
  data: ClipInput;
  documentId: Scalars['ID']['input'];
  status?: InputMaybe<PublicationStatus>;
};


export type MutationUpdateClipDataArgs = {
  data: Scalars['JSON']['input'];
  id: Scalars['ID']['input'];
};


export type MutationUpdateClipViewArgs = {
  data: ClipViewInput;
  documentId: Scalars['ID']['input'];
  status?: InputMaybe<PublicationStatus>;
};


export type MutationUpdateCopyGenerationArgs = {
  data: CopyGenerationInput;
  documentId: Scalars['ID']['input'];
  status?: InputMaybe<PublicationStatus>;
};


export type MutationUpdateCouponArgs = {
  data: CouponInput;
  documentId: Scalars['ID']['input'];
  status?: InputMaybe<PublicationStatus>;
};


export type MutationUpdateCourseCouponArgs = {
  data: CourseCouponInput;
  documentId: Scalars['ID']['input'];
  status?: InputMaybe<PublicationStatus>;
};


export type MutationUpdateCpmPayoutArgs = {
  data: CpmPayoutInput;
  documentId: Scalars['ID']['input'];
  status?: InputMaybe<PublicationStatus>;
};


export type MutationUpdateCurationArgs = {
  data: CurationInput;
  documentId: Scalars['ID']['input'];
  status?: InputMaybe<PublicationStatus>;
};


export type MutationUpdateDownloadCookieArgs = {
  data: DownloadCookieInput;
  documentId: Scalars['ID']['input'];
  status?: InputMaybe<PublicationStatus>;
};


export type MutationUpdateDownloadInstagramAccountArgs = {
  data: DownloadInstagramAccountInput;
  documentId: Scalars['ID']['input'];
  status?: InputMaybe<PublicationStatus>;
};


export type MutationUpdateEmailDesignerV5EmailDesignerTemplateArgs = {
  data: EmailDesignerV5EmailDesignerTemplateInput;
  documentId: Scalars['ID']['input'];
  status?: InputMaybe<PublicationStatus>;
};


export type MutationUpdateEmailDesignerV5EmailDesignerTemplateVersionArgs = {
  data: EmailDesignerV5EmailDesignerTemplateVersionInput;
  documentId: Scalars['ID']['input'];
  status?: InputMaybe<PublicationStatus>;
};


export type MutationUpdateEmailFlowArgs = {
  data: EmailFlowInput;
  documentId: Scalars['ID']['input'];
  status?: InputMaybe<PublicationStatus>;
};


export type MutationUpdateEmailFlowRunArgs = {
  data: EmailFlowRunInput;
  documentId: Scalars['ID']['input'];
  status?: InputMaybe<PublicationStatus>;
};


export type MutationUpdateEmailFlowSendArgs = {
  data: EmailFlowSendInput;
  documentId: Scalars['ID']['input'];
  status?: InputMaybe<PublicationStatus>;
};


export type MutationUpdateEmailFlowStepArgs = {
  data: EmailFlowStepInput;
  documentId: Scalars['ID']['input'];
  status?: InputMaybe<PublicationStatus>;
};


export type MutationUpdateMyApiKeyArgs = {
  id: Scalars['ID']['input'];
  input: MyApiKeyUpdateInput;
};


export type MutationUpdateMyBrandKitArgs = {
  id: Scalars['ID']['input'];
  input: MyBrandKitUpdateInput;
};


export type MutationUpdateMyDataArgs = {
  emailMarketingOptIn?: InputMaybe<Scalars['Boolean']['input']>;
  jobTitle?: InputMaybe<Scalars['String']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  objectivesWithPlatform?: InputMaybe<Scalars['String']['input']>;
  onboardingDailyVolume?: InputMaybe<Scalars['String']['input']>;
  onboardingExperience?: InputMaybe<Scalars['String']['input']>;
  onboardingObjective?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  profilePicture?: InputMaybe<Media>;
  targetObjective?: InputMaybe<Scalars['String']['input']>;
  workflowDescription?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateMyPayoutDataArgs = {
  input: UpdateMyPayoutDataInput;
};


export type MutationUpdateMyProjectArgs = {
  id: Scalars['ID']['input'];
  input: MyProjectUpdateInput;
};


export type MutationUpdateMyPublishQueueArgs = {
  id: Scalars['ID']['input'];
  input: PublishQueueInput;
};


export type MutationUpdateMyScheduledPublishArgs = {
  id: Scalars['ID']['input'];
  input: ScheduledPublishInput;
};


export type MutationUpdateMyUserMediaArgs = {
  id: Scalars['ID']['input'];
  input: MyUserMediaUpdateInput;
};


export type MutationUpdateMyUserMediaFolderArgs = {
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
};


export type MutationUpdateNewsletterArgs = {
  data: NewsletterInput;
  documentId: Scalars['ID']['input'];
  status?: InputMaybe<PublicationStatus>;
};


export type MutationUpdatePaymentArgs = {
  data: PaymentInput;
  documentId: Scalars['ID']['input'];
  status?: InputMaybe<PublicationStatus>;
};


export type MutationUpdateReviewWorkflowsWorkflowArgs = {
  data: ReviewWorkflowsWorkflowInput;
  documentId: Scalars['ID']['input'];
  status?: InputMaybe<PublicationStatus>;
};


export type MutationUpdateReviewWorkflowsWorkflowStageArgs = {
  data: ReviewWorkflowsWorkflowStageInput;
  documentId: Scalars['ID']['input'];
  status?: InputMaybe<PublicationStatus>;
};


export type MutationUpdateShortLinkArgs = {
  data: ShortLinkInput;
  documentId: Scalars['ID']['input'];
  status?: InputMaybe<PublicationStatus>;
};


export type MutationUpdateSubtitlePresetArgs = {
  data: SubtitlePresetInput;
  documentId: Scalars['ID']['input'];
  status?: InputMaybe<PublicationStatus>;
};


export type MutationUpdateTeamRoleArgs = {
  email: Scalars['String']['input'];
  role: Scalars['String']['input'];
};


export type MutationUpdateUploadFileArgs = {
  id: Scalars['ID']['input'];
  info?: InputMaybe<FileInfoInput>;
};


export type MutationUpdateUsageRecordArgs = {
  data: UsageRecordInput;
  documentId: Scalars['ID']['input'];
  status?: InputMaybe<PublicationStatus>;
};


export type MutationUpdateUserTagArgs = {
  data: UserTagInput;
  documentId: Scalars['ID']['input'];
  status?: InputMaybe<PublicationStatus>;
};


export type MutationUpdateUsersPermissionsRoleArgs = {
  data: UsersPermissionsRoleInput;
  id: Scalars['ID']['input'];
};


export type MutationUpdateUsersPermissionsUserArgs = {
  data: UsersPermissionsUserInput;
  id: Scalars['ID']['input'];
};


export type MutationUpdateWebhookArgs = {
  data: WebhookInput;
  documentId: Scalars['ID']['input'];
  status?: InputMaybe<PublicationStatus>;
};


export type MutationUpdateYoutubeDownloadArgs = {
  data: YoutubeDownloadInput;
  documentId: Scalars['ID']['input'];
  status?: InputMaybe<PublicationStatus>;
};


export type MutationValidateChallengeClipHashtagsArgs = {
  input: ValidateChallengeClipInput;
};


export type MutationVerifyStorePurchaseArgs = {
  platform: StorePlatform;
  productId: Scalars['String']['input'];
  purchaseToken: Scalars['String']['input'];
};


export type MutationVoteTemplateSuggestionArgs = {
  id: Scalars['ID']['input'];
};

export type MyApiKey = {
  __typename?: 'MyAPIKey';
  createdAt: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  key: Scalars['String']['output'];
  name: Scalars['String']['output'];
  updatedAt: Scalars['String']['output'];
};

export type MyApiKeyCreateInput = {
  name: Scalars['String']['input'];
};

export type MyApiKeyUpdateInput = {
  name?: InputMaybe<Scalars['String']['input']>;
};

export type MyApiRequest = {
  __typename?: 'MyAPIRequest';
  api_key_name?: Maybe<Scalars['String']['output']>;
  base_video_url: Scalars['String']['output'];
  clips: Array<MyApiRequestClip>;
  createdAt: Scalars['String']['output'];
  format?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  language?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  process_status: Scalars['String']['output'];
  prompt?: Maybe<Scalars['String']['output']>;
  thumbnail_url?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['String']['output'];
  webhook_url?: Maybe<Scalars['String']['output']>;
};

export type MyApiRequestClip = {
  __typename?: 'MyAPIRequestClip';
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  rendered_video_url?: Maybe<Scalars['String']['output']>;
};

export type MyAffiliateStatus = {
  __typename?: 'MyAffiliateStatus';
  blocked: Scalars['Boolean']['output'];
  blocked_reason?: Maybe<Scalars['String']['output']>;
  code?: Maybe<Scalars['String']['output']>;
  custom_code?: Maybe<Scalars['String']['output']>;
  earnings: Array<AffiliateEarningEntry>;
  joined: Scalars['Boolean']['output'];
  rates: AffiliateRates;
  referred_users: Array<AffiliateReferredUser>;
  terms_current_version: Scalars['String']['output'];
  total_referred: Scalars['Int']['output'];
  totals: AffiliateTotals;
};

export type MyBrandKit = {
  __typename?: 'MyBrandKit';
  createdAt: Scalars['String']['output'];
  data: BrandKitData;
  id: Scalars['ID']['output'];
  is_default: Scalars['Boolean']['output'];
  is_public: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  name_en?: Maybe<Scalars['String']['output']>;
  preview_poster_url?: Maybe<Scalars['String']['output']>;
  preview_video_url?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['String']['output'];
};

export type MyBrandKitCreateInput = {
  data: BrandKitDataInput;
  is_default?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
};

export type MyBrandKitUpdateInput = {
  data?: InputMaybe<BrandKitDataInput>;
  is_default?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type MyChallengeBrief = {
  __typename?: 'MyChallengeBrief';
  end_date?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type MyClip = {
  __typename?: 'MyClip';
  brand_kit?: Maybe<MyClipBrandKit>;
  can_edit?: Maybe<Scalars['Boolean']['output']>;
  can_set_cover?: Maybe<Scalars['Boolean']['output']>;
  clip_end_time?: Maybe<Scalars['Float']['output']>;
  clip_order?: Maybe<Scalars['Int']['output']>;
  clip_score?: Maybe<Scalars['Float']['output']>;
  clip_start_time?: Maybe<Scalars['Float']['output']>;
  clip_summary?: Maybe<Scalars['String']['output']>;
  clip_thumbnail?: Maybe<Scalars['String']['output']>;
  clipped_video_url?: Maybe<Scalars['String']['output']>;
  clipping_status: Scalars['String']['output'];
  compressed_video_url?: Maybe<Scalars['String']['output']>;
  copy?: Maybe<MyCopyGeneration>;
  cover_image_url?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['String']['output'];
  created_by_user?: Maybe<Scalars['JSON']['output']>;
  curation_rating?: Maybe<Scalars['String']['output']>;
  data?: Maybe<Scalars['JSON']['output']>;
  dirty?: Maybe<Scalars['Boolean']['output']>;
  duration_seconds: Scalars['Float']['output'];
  eta_seconds?: Maybe<Scalars['Float']['output']>;
  finished_video_thumbnail_url?: Maybe<Scalars['String']['output']>;
  finished_video_url?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  is_library_clip?: Maybe<Scalars['Boolean']['output']>;
  library_id?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  original_clip_end_time?: Maybe<Scalars['Float']['output']>;
  original_clip_start_time?: Maybe<Scalars['Float']['output']>;
  preparing_status: Scalars['String']['output'];
  project_id?: Maybe<Scalars['ID']['output']>;
  rendering_failure_code?: Maybe<Scalars['String']['output']>;
  rendering_failure_message?: Maybe<Scalars['String']['output']>;
  rendering_status?: Maybe<Scalars['String']['output']>;
  source_clip_id?: Maybe<Scalars['ID']['output']>;
  thumbnail_url?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['String']['output'];
  version_number?: Maybe<Scalars['Int']['output']>;
};

export type MyClipBrandKit = {
  __typename?: 'MyClipBrandKit';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type MyClipperRankPreview = {
  __typename?: 'MyClipperRankPreview';
  season_id?: Maybe<Scalars['ID']['output']>;
  season_name?: Maybe<Scalars['String']['output']>;
  season_title_id?: Maybe<Scalars['String']['output']>;
  views_tier_id?: Maybe<Scalars['String']['output']>;
};

export type MyClipperRanks = {
  __typename?: 'MyClipperRanks';
  season_titles: Array<ClipperSeasonTitle>;
  tracks: Array<ClipperRankTrack>;
};

export type MyCopyGeneration = {
  __typename?: 'MyCopyGeneration';
  createdAt: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  processing_status: Scalars['String']['output'];
  result?: Maybe<Scalars['JSON']['output']>;
  updatedAt: Scalars['String']['output'];
};

export type MyCourseRoyalties = {
  __typename?: 'MyCourseRoyalties';
  accrued_cents: Scalars['String']['output'];
  available_cents: Scalars['String']['output'];
  configurations: Array<CourseRoyaltyConfiguration>;
  earnings: Array<CourseRoyaltyEarning>;
  earnings_page_info: CourseRoyaltyEarningsPageInfo;
  pending_cents: Scalars['String']['output'];
  reversed_cents: Scalars['String']['output'];
};

export type CpmPlatformRate = {
  __typename?: 'CpmPlatformRate';
  cpm_rate_cents: Scalars['Int']['output'];
  platform: Scalars['String']['output'];
};

export type CpmPlatformRateInput = {
  cpm_rate_cents: Scalars['Int']['input'];
  platform: Scalars['String']['input'];
};

export type MyCpmCampaign = {
  __typename?: 'MyCpmCampaign';
  allowed_platforms?: Maybe<Array<Scalars['String']['output']>>;
  banner_url?: Maybe<Scalars['String']['output']>;
  budget_pending_cents: Scalars['Int']['output'];
  budget_remaining_cents: Scalars['Int']['output'];
  budget_total_cents: Scalars['Int']['output'];
  campaign_type?: Maybe<Scalars['String']['output']>;
  caption_examples?: Maybe<Scalars['String']['output']>;
  categories: Array<Scalars['String']['output']>;
  cpm_rate_cents: Scalars['Int']['output'];
  cpm_platform_rates: Array<CpmPlatformRate>;
  currency: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  editing_assets?: Maybe<Scalars['JSON']['output']>;
  end_date?: Maybe<Scalars['String']['output']>;
  enforced_post_layout?: Maybe<Scalars['JSON']['output']>;
  id: Scalars['ID']['output'];
  invite_only: Scalars['Boolean']['output'];
  is_joined: Scalars['Boolean']['output'];
  is_selected_user: Scalars['Boolean']['output'];
  join_blocked_reason?: Maybe<Scalars['String']['output']>;
  library_projects: Array<MyLibrary>;
  logo_url?: Maybe<Scalars['String']['output']>;
  max_payout_per_clip_cents?: Maybe<Scalars['Int']['output']>;
  max_payout_per_clipper_cents?: Maybe<Scalars['Int']['output']>;
  min_clip_duration_seconds?: Maybe<Scalars['Int']['output']>;
  min_payout_per_clipper_cents?: Maybe<Scalars['Int']['output']>;
  min_views_threshold?: Maybe<Scalars['Int']['output']>;
  my_approved_platforms: Array<Scalars['String']['output']>;
  my_channel_requests: Array<MyCpmCampaignChannelRequest>;
  my_submissions: Array<MyCpmCampaignSubmission>;
  my_total_earnings_cents: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  participating_libraries: Array<MyLibrary>;
  ranking_config?: Maybe<Scalars['JSON']['output']>;
  required_hashtags?: Maybe<Scalars['String']['output']>;
  required_mention?: Maybe<Scalars['String']['output']>;
  requires_channel_approval: Scalars['Boolean']['output'];
  restrict_to_listed_videos: Scalars['Boolean']['output'];
  rules_allowed?: Maybe<Scalars['String']['output']>;
  rules_attention?: Maybe<Scalars['String']['output']>;
  rules_forbidden?: Maybe<Scalars['String']['output']>;
  rules_warning?: Maybe<Scalars['String']['output']>;
  scheduled_activation_at?: Maybe<Scalars['DateTime']['output']>;
  selected_only: Scalars['Boolean']['output'];
  start_date?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  view_accrual_window_hours: Scalars['Int']['output'];
  youtube_channels: Array<MyYoutubeChannel>;
  youtube_downloads: Array<CpmCampaignVideo>;
};

export type MyCpmCampaignChannelRequest = {
  __typename?: 'MyCpmCampaignChannelRequest';
  createdAt: Scalars['String']['output'];
  handle?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  platform: Scalars['String']['output'];
  review_reason?: Maybe<Scalars['String']['output']>;
  reviewed_at?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  submitted_url: Scalars['String']['output'];
  youtube_channel?: Maybe<MyYoutubeChannel>;
};

export type MyCpmCampaignSubmission = {
  __typename?: 'MyCpmCampaignSubmission';
  accumulated_payout_cents: Scalars['Int']['output'];
  admin_approval: Scalars['String']['output'];
  admin_observation?: Maybe<Scalars['String']['output']>;
  appeal?: Maybe<CpmCampaignSubmissionAppeal>;
  approval_reason?: Maybe<Scalars['String']['output']>;
  cpm_rate_override_cents?: Maybe<Scalars['Int']['output']>;
  createdAt: Scalars['String']['output'];
  disapproved_at?: Maybe<Scalars['String']['output']>;
  disqualification_reason?: Maybe<Scalars['String']['output']>;
  disqualified: Scalars['Boolean']['output'];
  estimated_payout_cents?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  last_counted_views: Scalars['String']['output'];
  last_view_sync_at?: Maybe<Scalars['String']['output']>;
  latest_views?: Maybe<Scalars['String']['output']>;
  media_duration_seconds?: Maybe<Scalars['Float']['output']>;
  metrics_error?: Maybe<Scalars['String']['output']>;
  metrics_source?: Maybe<Scalars['String']['output']>;
  metrics_status?: Maybe<Scalars['String']['output']>;
  payable_views: Scalars['String']['output'];
  platform: Scalars['String']['output'];
  pre_approval: Scalars['String']['output'];
  pre_approval_at?: Maybe<Scalars['String']['output']>;
  pre_approval_score?: Maybe<Scalars['Int']['output']>;
  provider_media_id?: Maybe<Scalars['String']['output']>;
  rejection_images: Array<CpmReviewImage>;
  rules_check_failures: Array<Scalars['String']['output']>;
  rules_check_missing_hashtags: Array<Scalars['String']['output']>;
  rules_check_missing_mentions: Array<Scalars['String']['output']>;
  social_connection_id?: Maybe<Scalars['ID']['output']>;
  suspected_duplicate: Scalars['Boolean']['output'];
  url: Scalars['String']['output'];
  validated_hashtags: Scalars['String']['output'];
};

export type MyCpmLeaderboardPrivacy = {
  __typename?: 'MyCpmLeaderboardPrivacy';
  anonymous: Scalars['Boolean']['output'];
  can_remain_anonymous: Scalars['Boolean']['output'];
};

export type MyData = {
  __typename?: 'MyData';
  affiliate?: Maybe<Scalars['String']['output']>;
  challenge_participation?: Maybe<MyChallengeBrief>;
  cpm_terms_accepted_at?: Maybe<Scalars['String']['output']>;
  cpm_terms_accepted_version?: Maybe<Scalars['String']['output']>;
  cpm_terms_current_version: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  email: Scalars['String']['output'];
  email_marketing_opt_in: Scalars['Boolean']['output'];
  googleLinked: Scalars['Boolean']['output'];
  hasPassword: Scalars['Boolean']['output'];
  has_challenge_participation: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  invitation_token: Scalars['String']['output'];
  is_admin: Scalars['Boolean']['output'];
  job_title?: Maybe<Scalars['String']['output']>;
  joined_community: Scalars['Boolean']['output'];
  locale?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  objectives_with_platform?: Maybe<Scalars['String']['output']>;
  onboarding_daily_volume?: Maybe<Scalars['String']['output']>;
  onboarding_experience?: Maybe<Scalars['String']['output']>;
  onboarding_objective?: Maybe<Scalars['String']['output']>;
  payout_data?: Maybe<MyPayoutData>;
  phone_number?: Maybe<Scalars['String']['output']>;
  profile_picture?: Maybe<Scalars['String']['output']>;
  provider?: Maybe<Scalars['String']['output']>;
  role: Scalars['String']['output'];
  subscription: Scalars['JSON']['output'];
  tags: Array<MyUserTag>;
  target_objective?: Maybe<Scalars['String']['output']>;
  tos_accepted: Scalars['Boolean']['output'];
  tos_accepted_at?: Maybe<Scalars['String']['output']>;
  tos_accepted_version?: Maybe<Scalars['String']['output']>;
  tos_current_version: Scalars['String']['output'];
  workflow_description?: Maybe<Scalars['String']['output']>;
};

export type MyLibrariesCounts = {
  __typename?: 'MyLibrariesCounts';
  community: Scalars['Int']['output'];
  mine: Scalars['Int']['output'];
};

export type MyLibrary = {
  __typename?: 'MyLibrary';
  active_cpm_campaigns: Array<MyCpmCampaign>;
  aired_at?: Maybe<Scalars['String']['output']>;
  audio_language?: Maybe<Scalars['String']['output']>;
  audio_track?: Maybe<Scalars['String']['output']>;
  base_video_url?: Maybe<Scalars['String']['output']>;
  brand_kit?: Maybe<MyProjectBrandKit>;
  clips?: Maybe<Array<ProjectClip>>;
  clips_count?: Maybe<Scalars['Int']['output']>;
  compressed_base_video_url?: Maybe<Scalars['String']['output']>;
  compressed_cut_video_url?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['String']['output'];
  created_by_user?: Maybe<Scalars['String']['output']>;
  created_by_user_name?: Maybe<Scalars['String']['output']>;
  curated_clips?: Maybe<Scalars['JSON']['output']>;
  curation_rating?: Maybe<Scalars['String']['output']>;
  curation_status?: Maybe<Scalars['String']['output']>;
  cut_video_url?: Maybe<Scalars['String']['output']>;
  default_subtitles_enabled?: Maybe<Scalars['Boolean']['output']>;
  duration_seconds?: Maybe<Scalars['Float']['output']>;
  edit_only?: Maybe<Scalars['Boolean']['output']>;
  effective_post_layout?: Maybe<Scalars['JSON']['output']>;
  effective_subtitle_position?: Maybe<Scalars['JSON']['output']>;
  effective_watermark?: Maybe<CampaignWatermark>;
  end_time?: Maybe<Scalars['Float']['output']>;
  eta_seconds?: Maybe<Scalars['Float']['output']>;
  failure_code?: Maybe<Scalars['String']['output']>;
  favorite?: Maybe<Scalars['Boolean']['output']>;
  filesize?: Maybe<Scalars['Float']['output']>;
  format: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  language: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
  original_transcription_url?: Maybe<Scalars['String']['output']>;
  original_video_url?: Maybe<Scalars['String']['output']>;
  post_layout?: Maybe<Scalars['JSON']['output']>;
  processing_mode?: Maybe<Scalars['String']['output']>;
  prompt?: Maybe<Scalars['String']['output']>;
  public?: Maybe<Scalars['Boolean']['output']>;
  remix_count?: Maybe<Scalars['Int']['output']>;
  remove_silence?: Maybe<Scalars['Boolean']['output']>;
  scene_detection?: Maybe<Scalars['JSON']['output']>;
  scene_detection_url?: Maybe<Scalars['String']['output']>;
  source_library_id?: Maybe<Scalars['String']['output']>;
  source_status?: Maybe<Scalars['String']['output']>;
  speaker_layout?: Maybe<Scalars['Int']['output']>;
  start_time?: Maybe<Scalars['Float']['output']>;
  subtitle_config?: Maybe<Scalars['JSON']['output']>;
  tags: Array<MyLibraryTag>;
  thumbnail_url?: Maybe<Scalars['String']['output']>;
  transcription?: Maybe<Scalars['JSON']['output']>;
  transcription_url?: Maybe<Scalars['String']['output']>;
  translation_status?: Maybe<Scalars['String']['output']>;
  upload_date?: Maybe<Scalars['String']['output']>;
  view_count?: Maybe<Scalars['String']['output']>;
  watermark_position?: Maybe<Scalars['JSON']['output']>;
  windowed_remix_count?: Maybe<Scalars['Int']['output']>;
  youtube_channel?: Maybe<MyYoutubeChannel>;
  youtube_channels: Array<MyYoutubeChannel>;
  youtube_download_id?: Maybe<Scalars['String']['output']>;
  youtube_video_id?: Maybe<Scalars['String']['output']>;
};

export type MyLibraryCreateInput = {
  audio_language?: InputMaybe<Scalars['String']['input']>;
  audio_track?: InputMaybe<Scalars['String']['input']>;
  base_video?: InputMaybe<Media>;
  base_video_url?: InputMaybe<Scalars['String']['input']>;
  brand_kit_id?: InputMaybe<Scalars['ID']['input']>;
  duration_seconds: Scalars['Float']['input'];
  end_time?: InputMaybe<Scalars['Float']['input']>;
  format: Scalars['String']['input'];
  language: Scalars['String']['input'];
  name: Scalars['String']['input'];
  processing_mode?: InputMaybe<Scalars['String']['input']>;
  prompt: Scalars['String']['input'];
  remove_silence?: InputMaybe<Scalars['Boolean']['input']>;
  source_library_id?: InputMaybe<Scalars['ID']['input']>;
  start_time?: InputMaybe<Scalars['Float']['input']>;
  tag_names?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type MyLibraryTag = {
  __typename?: 'MyLibraryTag';
  color?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['String']['output'];
  download_count?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type MyPayoutData = {
  __typename?: 'MyPayoutData';
  account?: Maybe<Scalars['String']['output']>;
  agency?: Maybe<Scalars['String']['output']>;
  bank?: Maybe<Scalars['String']['output']>;
  document: Scalars['String']['output'];
  name: Scalars['String']['output'];
  pix_key?: Maybe<Scalars['String']['output']>;
};

export type MyPixVerification = {
  __typename?: 'MyPixVerification';
  cpf: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  review_reason?: Maybe<Scalars['String']['output']>;
  reviewed_at?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  submitted_at?: Maybe<Scalars['String']['output']>;
};

export type MyProject = {
  __typename?: 'MyProject';
  audio_language?: Maybe<Scalars['String']['output']>;
  audio_track?: Maybe<Scalars['String']['output']>;
  base_video_url?: Maybe<Scalars['String']['output']>;
  brand_kit?: Maybe<MyProjectBrandKit>;
  clips?: Maybe<Array<ProjectClip>>;
  clips_count?: Maybe<Scalars['Int']['output']>;
  compressed_base_video_url?: Maybe<Scalars['String']['output']>;
  compressed_cut_video_url?: Maybe<Scalars['String']['output']>;
  content_type?: Maybe<Scalars['String']['output']>;
  content_type_confidence?: Maybe<Scalars['Float']['output']>;
  createdAt: Scalars['String']['output'];
  created_by_user?: Maybe<Scalars['JSON']['output']>;
  curated_clips?: Maybe<Scalars['JSON']['output']>;
  curation_rating?: Maybe<Scalars['String']['output']>;
  curation_status?: Maybe<Scalars['String']['output']>;
  cut_video_url?: Maybe<Scalars['String']['output']>;
  default_subtitles_enabled?: Maybe<Scalars['Boolean']['output']>;
  duration_seconds?: Maybe<Scalars['Float']['output']>;
  edit_only?: Maybe<Scalars['Boolean']['output']>;
  effective_post_layout?: Maybe<Scalars['JSON']['output']>;
  effective_subtitle_position?: Maybe<Scalars['JSON']['output']>;
  effective_watermark?: Maybe<CampaignWatermark>;
  end_time?: Maybe<Scalars['Float']['output']>;
  eta_seconds?: Maybe<Scalars['Float']['output']>;
  failure_code?: Maybe<Scalars['String']['output']>;
  favorite?: Maybe<Scalars['Boolean']['output']>;
  filesize?: Maybe<Scalars['Float']['output']>;
  format: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  language: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
  news_pdf_mirror_url?: Maybe<Scalars['String']['output']>;
  original_transcription_url?: Maybe<Scalars['String']['output']>;
  post_layout?: Maybe<Scalars['JSON']['output']>;
  processing_mode?: Maybe<Scalars['String']['output']>;
  prompt?: Maybe<Scalars['String']['output']>;
  public?: Maybe<Scalars['Boolean']['output']>;
  remove_silence?: Maybe<Scalars['Boolean']['output']>;
  scene_detection?: Maybe<Scalars['JSON']['output']>;
  scene_detection_url?: Maybe<Scalars['String']['output']>;
  source_status?: Maybe<Scalars['String']['output']>;
  speaker_layout?: Maybe<Scalars['Int']['output']>;
  start_time?: Maybe<Scalars['Float']['output']>;
  subtitle_config?: Maybe<Scalars['JSON']['output']>;
  thumbnail_url?: Maybe<Scalars['String']['output']>;
  transcription?: Maybe<Scalars['JSON']['output']>;
  transcription_url?: Maybe<Scalars['String']['output']>;
  translation_status?: Maybe<Scalars['String']['output']>;
  video_signals_url?: Maybe<Scalars['String']['output']>;
  watermark_position?: Maybe<Scalars['JSON']['output']>;
};

export type MyProjectBrandKit = {
  __typename?: 'MyProjectBrandKit';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type MyProjectCreateInput = {
  audio_language?: InputMaybe<Scalars['String']['input']>;
  audio_track?: InputMaybe<Scalars['String']['input']>;
  autocreate_clips?: InputMaybe<Scalars['Boolean']['input']>;
  autocreate_clips_action?: InputMaybe<Scalars['String']['input']>;
  base_video?: InputMaybe<Media>;
  base_video_url?: InputMaybe<Scalars['String']['input']>;
  brand_kit_id?: InputMaybe<Scalars['ID']['input']>;
  duration_seconds: Scalars['Float']['input'];
  end_time?: InputMaybe<Scalars['Float']['input']>;
  format: Scalars['String']['input'];
  language: Scalars['String']['input'];
  name: Scalars['String']['input'];
  news_pdf_mirror?: InputMaybe<Media>;
  processing_mode?: InputMaybe<Scalars['String']['input']>;
  prompt: Scalars['String']['input'];
  remove_silence?: InputMaybe<Scalars['Boolean']['input']>;
  source_project_id?: InputMaybe<Scalars['ID']['input']>;
  start_time?: InputMaybe<Scalars['Float']['input']>;
};

export type MyProjectUpdateInput = {
  brand_kit_id?: InputMaybe<Scalars['ID']['input']>;
  curation_rating?: InputMaybe<Scalars['String']['input']>;
  favorite?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  post_layout?: InputMaybe<Scalars['JSON']['input']>;
  speaker_layout?: InputMaybe<Scalars['Int']['input']>;
  subtitle_config?: InputMaybe<Scalars['JSON']['input']>;
  transcription_url?: InputMaybe<Scalars['String']['input']>;
  watermark_position?: InputMaybe<Scalars['JSON']['input']>;
};

export type MySocialConnection = {
  __typename?: 'MySocialConnection';
  access_expires_at?: Maybe<Scalars['String']['output']>;
  analytics_backfill_completed_at?: Maybe<Scalars['String']['output']>;
  analytics_last_attempt_at?: Maybe<Scalars['String']['output']>;
  analytics_last_error_code?: Maybe<Scalars['String']['output']>;
  analytics_last_success_at?: Maybe<Scalars['String']['output']>;
  analytics_sync_status: Scalars['String']['output'];
  avatar_url?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['String']['output'];
  display_name: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  last_synced_at?: Maybe<Scalars['String']['output']>;
  platform: Scalars['String']['output'];
  scopes?: Maybe<Scalars['JSON']['output']>;
  status: Scalars['String']['output'];
  username: Scalars['String']['output'];
};

export type MyTemplateSuggestion = {
  __typename?: 'MyTemplateSuggestion';
  author_name?: Maybe<Scalars['String']['output']>;
  brand_kit_id?: Maybe<Scalars['ID']['output']>;
  createdAt: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  note?: Maybe<Scalars['String']['output']>;
  platform: Scalars['String']['output'];
  promoted_at?: Maybe<Scalars['String']['output']>;
  review_reason?: Maybe<Scalars['String']['output']>;
  reviewed_at?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  submitted_by_name?: Maybe<Scalars['String']['output']>;
  submitted_url: Scalars['String']['output'];
  thumbnail_url?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  use_case: Scalars['String']['output'];
  vote_count: Scalars['Int']['output'];
};

export type MyUserMedia = {
  __typename?: 'MyUserMedia';
  createdAt: Scalars['String']['output'];
  duration?: Maybe<Scalars['Float']['output']>;
  folder_id?: Maybe<Scalars['ID']['output']>;
  height?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  kind: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
  url: Scalars['String']['output'];
  width?: Maybe<Scalars['Int']['output']>;
};

export type MyUserMediaCreateInput = {
  duration?: InputMaybe<Scalars['Float']['input']>;
  folderId?: InputMaybe<Scalars['ID']['input']>;
  height?: InputMaybe<Scalars['Int']['input']>;
  kind: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  url: Scalars['String']['input'];
  width?: InputMaybe<Scalars['Int']['input']>;
};

export type MyUserMediaFolder = {
  __typename?: 'MyUserMediaFolder';
  createdAt: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  media_count: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type MyUserMediaUpdateInput = {
  folderId?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type MyUserTag = {
  __typename?: 'MyUserTag';
  id: Scalars['ID']['output'];
};

export type MyYoutubeChannel = {
  __typename?: 'MyYoutubeChannel';
  category?: Maybe<Scalars['String']['output']>;
  channel_id: Scalars['String']['output'];
  handle?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  is_autoclipper_partner?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  remix_count?: Maybe<Scalars['Int']['output']>;
  subscriber_count?: Maybe<Scalars['Int']['output']>;
  thumbnail?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type Newsletter = {
  __typename?: 'Newsletter';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  documentId: Scalars['ID']['output'];
  email?: Maybe<Scalars['String']['output']>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  source: Enum_Newsletter_Source;
  synced?: Maybe<Scalars['Boolean']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type NewsletterEntityResponseCollection = {
  __typename?: 'NewsletterEntityResponseCollection';
  nodes: Array<Newsletter>;
  pageInfo: Pagination;
};

export type NewsletterFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<NewsletterFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  documentId?: InputMaybe<IdFilterInput>;
  email?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<NewsletterFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<NewsletterFiltersInput>>>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  source?: InputMaybe<StringFilterInput>;
  synced?: InputMaybe<BooleanFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type NewsletterInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  source?: InputMaybe<Enum_Newsletter_Source>;
  synced?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OkResponse = {
  __typename?: 'OKResponse';
  success: Scalars['Boolean']['output'];
};

export type Pagination = {
  __typename?: 'Pagination';
  page: Scalars['Int']['output'];
  pageCount: Scalars['Int']['output'];
  pageSize: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type PaginationArg = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  start?: InputMaybe<Scalars['Int']['input']>;
};

export type PartialRankingByDateEntry = {
  __typename?: 'PartialRankingByDateEntry';
  clip_count: Scalars['Int']['output'];
  participation_id: Scalars['ID']['output'];
  total_views: Scalars['String']['output'];
  user_name?: Maybe<Scalars['String']['output']>;
};

export type PartialRankingByDateResponse = {
  __typename?: 'PartialRankingByDateResponse';
  clips_without_views: Array<PartialRankingClipWarning>;
  end_date_used?: Maybe<Scalars['String']['output']>;
  entries: Array<PartialRankingByDateEntry>;
  start_date_used?: Maybe<Scalars['String']['output']>;
};

export type PartialRankingClipWarning = {
  __typename?: 'PartialRankingClipWarning';
  clip_id: Scalars['ID']['output'];
  clip_url: Scalars['String']['output'];
  missing: Scalars['String']['output'];
  participant_name?: Maybe<Scalars['String']['output']>;
};

export type Payment = {
  __typename?: 'Payment';
  amount?: Maybe<Scalars['Float']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  currency: Enum_Payment_Currency;
  data?: Maybe<Scalars['JSON']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  documentId: Scalars['ID']['output'];
  invoice_cancellation_error?: Maybe<Scalars['String']['output']>;
  invoice_cancelled_at?: Maybe<Scalars['DateTime']['output']>;
  invoice_url?: Maybe<Scalars['String']['output']>;
  payment_date?: Maybe<Scalars['DateTime']['output']>;
  payment_method?: Maybe<Scalars['String']['output']>;
  payment_provider_id: Scalars['String']['output'];
  payment_status?: Maybe<Scalars['String']['output']>;
  provider?: Maybe<Enum_Payment_Provider>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  type: Enum_Payment_Type;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  xml_content?: Maybe<Scalars['String']['output']>;
};

export type PaymentEntityResponseCollection = {
  __typename?: 'PaymentEntityResponseCollection';
  nodes: Array<Payment>;
  pageInfo: Pagination;
};

export type PaymentFiltersInput = {
  amount?: InputMaybe<FloatFilterInput>;
  and?: InputMaybe<Array<InputMaybe<PaymentFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  currency?: InputMaybe<StringFilterInput>;
  data?: InputMaybe<JsonFilterInput>;
  description?: InputMaybe<StringFilterInput>;
  documentId?: InputMaybe<IdFilterInput>;
  invoice_cancellation_error?: InputMaybe<StringFilterInput>;
  invoice_cancelled_at?: InputMaybe<DateTimeFilterInput>;
  invoice_url?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<PaymentFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<PaymentFiltersInput>>>;
  payment_date?: InputMaybe<DateTimeFilterInput>;
  payment_method?: InputMaybe<StringFilterInput>;
  payment_provider_id?: InputMaybe<StringFilterInput>;
  payment_status?: InputMaybe<StringFilterInput>;
  provider?: InputMaybe<StringFilterInput>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  type?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
  xml_content?: InputMaybe<StringFilterInput>;
};

export type PaymentInput = {
  amount?: InputMaybe<Scalars['Float']['input']>;
  currency?: InputMaybe<Enum_Payment_Currency>;
  data?: InputMaybe<Scalars['JSON']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  invoice_cancellation_error?: InputMaybe<Scalars['String']['input']>;
  invoice_cancelled_at?: InputMaybe<Scalars['DateTime']['input']>;
  invoice_url?: InputMaybe<Scalars['String']['input']>;
  payment_date?: InputMaybe<Scalars['DateTime']['input']>;
  payment_method?: InputMaybe<Scalars['String']['input']>;
  payment_provider_id?: InputMaybe<Scalars['String']['input']>;
  payment_status?: InputMaybe<Scalars['String']['input']>;
  provider?: InputMaybe<Enum_Payment_Provider>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  type?: InputMaybe<Enum_Payment_Type>;
  xml_content?: InputMaybe<Scalars['String']['input']>;
};

export type PixRenewalOrder = {
  __typename?: 'PixRenewalOrder';
  amount: Scalars['Float']['output'];
  expires_at?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  pix_code?: Maybe<Scalars['String']['output']>;
  pix_qr_code_url?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
};

export type Plan = {
  __typename?: 'Plan';
  apple_monthly_product_id?: Maybe<Scalars['String']['output']>;
  apple_yearly_product_id?: Maybe<Scalars['String']['output']>;
  color?: Maybe<Scalars['String']['output']>;
  coupons: Array<Maybe<Coupon>>;
  coupons_connection?: Maybe<CouponRelationResponseCollection>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  description_items?: Maybe<Scalars['JSON']['output']>;
  discount_label?: Maybe<Scalars['String']['output']>;
  documentId: Scalars['ID']['output'];
  eduzz_code?: Maybe<Scalars['String']['output']>;
  eduzz_code_yearly?: Maybe<Scalars['String']['output']>;
  features?: Maybe<Scalars['JSON']['output']>;
  google_monthly_base_plan_id?: Maybe<Scalars['String']['output']>;
  google_product_id?: Maybe<Scalars['String']['output']>;
  google_yearly_base_plan_id?: Maybe<Scalars['String']['output']>;
  hidden?: Maybe<Scalars['Boolean']['output']>;
  max_brand_kits?: Maybe<Scalars['Int']['output']>;
  max_clips?: Maybe<Scalars['Int']['output']>;
  max_expiry_days?: Maybe<Scalars['Int']['output']>;
  max_library_curations?: Maybe<Scalars['Int']['output']>;
  max_library_exports?: Maybe<Scalars['Int']['output']>;
  max_library_video_seconds?: Maybe<Scalars['Int']['output']>;
  max_project_remixes?: Maybe<Scalars['Int']['output']>;
  max_users?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  order?: Maybe<Scalars['Int']['output']>;
  payment_link?: Maybe<Scalars['String']['output']>;
  payment_link_yearly?: Maybe<Scalars['String']['output']>;
  priority?: Maybe<Scalars['Int']['output']>;
  processing_seconds?: Maybe<Scalars['Long']['output']>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  stripe_monthly_price_id?: Maybe<Scalars['String']['output']>;
  stripe_monthly_price_id_usd?: Maybe<Scalars['String']['output']>;
  stripe_product_id?: Maybe<Scalars['String']['output']>;
  stripe_yearly_price_id?: Maybe<Scalars['String']['output']>;
  stripe_yearly_price_id_usd?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
  value_usd?: Maybe<Scalars['Float']['output']>;
  value_yearly?: Maybe<Scalars['Float']['output']>;
  value_yearly_usd?: Maybe<Scalars['Float']['output']>;
};


export type PlanCouponsArgs = {
  filters?: InputMaybe<CouponFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type PlanCoupons_ConnectionArgs = {
  filters?: InputMaybe<CouponFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type PlanFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<PlanFiltersInput>>>;
  apple_monthly_product_id?: InputMaybe<StringFilterInput>;
  apple_yearly_product_id?: InputMaybe<StringFilterInput>;
  color?: InputMaybe<StringFilterInput>;
  coupons?: InputMaybe<CouponFiltersInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  description_items?: InputMaybe<JsonFilterInput>;
  discount_label?: InputMaybe<StringFilterInput>;
  documentId?: InputMaybe<IdFilterInput>;
  eduzz_code?: InputMaybe<StringFilterInput>;
  eduzz_code_yearly?: InputMaybe<StringFilterInput>;
  features?: InputMaybe<JsonFilterInput>;
  google_monthly_base_plan_id?: InputMaybe<StringFilterInput>;
  google_product_id?: InputMaybe<StringFilterInput>;
  google_yearly_base_plan_id?: InputMaybe<StringFilterInput>;
  hidden?: InputMaybe<BooleanFilterInput>;
  max_brand_kits?: InputMaybe<IntFilterInput>;
  max_clips?: InputMaybe<IntFilterInput>;
  max_expiry_days?: InputMaybe<IntFilterInput>;
  max_library_curations?: InputMaybe<IntFilterInput>;
  max_library_exports?: InputMaybe<IntFilterInput>;
  max_library_video_seconds?: InputMaybe<IntFilterInput>;
  max_project_remixes?: InputMaybe<IntFilterInput>;
  max_users?: InputMaybe<IntFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<PlanFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<PlanFiltersInput>>>;
  order?: InputMaybe<IntFilterInput>;
  payment_link?: InputMaybe<StringFilterInput>;
  payment_link_yearly?: InputMaybe<StringFilterInput>;
  priority?: InputMaybe<IntFilterInput>;
  processing_seconds?: InputMaybe<LongFilterInput>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  slug?: InputMaybe<StringFilterInput>;
  stripe_monthly_price_id?: InputMaybe<StringFilterInput>;
  stripe_monthly_price_id_usd?: InputMaybe<StringFilterInput>;
  stripe_product_id?: InputMaybe<StringFilterInput>;
  stripe_yearly_price_id?: InputMaybe<StringFilterInput>;
  stripe_yearly_price_id_usd?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
  value?: InputMaybe<FloatFilterInput>;
  value_usd?: InputMaybe<FloatFilterInput>;
  value_yearly?: InputMaybe<FloatFilterInput>;
  value_yearly_usd?: InputMaybe<FloatFilterInput>;
};

export type PlanRelationResponseCollection = {
  __typename?: 'PlanRelationResponseCollection';
  nodes: Array<Plan>;
};

export type PostableClip = {
  __typename?: 'PostableClip';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  finished_video_url?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  thumbnail_url?: Maybe<Scalars['String']['output']>;
};

export type ProjectClip = {
  __typename?: 'ProjectClip';
  clip_end_time?: Maybe<Scalars['Float']['output']>;
  clip_order?: Maybe<Scalars['Int']['output']>;
  clip_score?: Maybe<Scalars['Float']['output']>;
  clip_start_time?: Maybe<Scalars['Float']['output']>;
  clip_summary?: Maybe<Scalars['String']['output']>;
  clip_thumbnail?: Maybe<Scalars['String']['output']>;
  clipping_status?: Maybe<Scalars['String']['output']>;
  curation_rating?: Maybe<Scalars['String']['output']>;
  data?: Maybe<Scalars['JSON']['output']>;
  dirty?: Maybe<Scalars['Boolean']['output']>;
  duration_seconds?: Maybe<Scalars['Float']['output']>;
  finished_video_thumbnail_url?: Maybe<Scalars['String']['output']>;
  finished_video_url?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  original_clip_end_time?: Maybe<Scalars['Float']['output']>;
  original_clip_start_time?: Maybe<Scalars['Float']['output']>;
  rendering_status?: Maybe<Scalars['String']['output']>;
  thumbnail_url?: Maybe<Scalars['String']['output']>;
};

export enum PublicationStatus {
  Draft = 'DRAFT',
  Published = 'PUBLISHED'
}

export type PublishQueue = {
  __typename?: 'PublishQueue';
  active: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  min_gap_minutes: Scalars['Int']['output'];
  multi_account_mode: Scalars['String']['output'];
  name: Scalars['String']['output'];
  social_connection_ids: Array<Scalars['ID']['output']>;
  spacing_scope: Scalars['String']['output'];
  timezone: Scalars['String']['output'];
  weekly_slots: Scalars['JSON']['output'];
};

export type PublishQueueInput = {
  minGapMinutes: Scalars['Int']['input'];
  multiAccountMode: Scalars['String']['input'];
  name: Scalars['String']['input'];
  socialConnectionIds: Array<Scalars['ID']['input']>;
  spacingScope?: InputMaybe<Scalars['String']['input']>;
  timezone: Scalars['String']['input'];
  weeklySlots: Scalars['JSON']['input'];
};

export type Query = {
  __typename?: 'Query';
  activeChallenge?: Maybe<ClippingChallenge>;
  adminAffiliateEarnings: AdminAffiliateEarningsResponse;
  adminAiAssistantUsage: AssistantUsageReport;
  adminBotChatConversation?: Maybe<AdminBotChatConversation>;
  adminBotChatConversations: AdminBotChatConversationsResponse;
  adminBotChatMessages: AdminBotChatMessagesResponse;
  adminBrandLeadSubmissions: AdminBrandLeadSubmissionsResponse;
  adminBrandLeads: AdminBrandLeadsResponse;
  adminCampaignLiveImport: AdminCampaignLiveImport;
  adminChallenge?: Maybe<AdminChallenge>;
  adminChallengeApplications: AdminChallengeApplicationsResponse;
  adminChallengeClips: AdminChallengeClipsResponse;
  adminChallengeViewsTimeSeries: Array<ChallengeViewsTimeSeriesEntry>;
  adminChallenges: AdminChallengesResponse;
  adminClipperSeasons: Array<ClipperSeasonAdmin>;
  adminClips: AdminClipsResponse;
  adminCommunityCurationNiches: Array<AdminCommunityCurationNiche>;
  adminCommunityCurationPicks: AdminCommunityCurationPicksResponse;
  adminCommunityCurationRun: AdminCommunityCurationRun;
  adminCommunityCurationRuns: AdminCommunityCurationRunsResponse;
  adminCommunityCurationSettings: AdminCommunityCurationSettings;
  adminCoupon?: Maybe<AdminCoupon>;
  adminCoupons: AdminCouponsResponse;
  adminCourseRevenueShares: Array<AdminCourseRevenueShare>;
  adminCpmCampaign?: Maybe<AdminCpmCampaign>;
  adminCpmCampaignChannelRequests: AdminCpmCampaignChannelRequestsResponse;
  adminCpmCampaignContent: CampaignAuditContent;
  adminCpmCampaignParticipants: CpmCampaignParticipantsResult;
  adminCpmCampaignSubmissionAppeals: CpmCampaignSubmissionAppealPage;
  adminCpmCampaignSubmissions: AdminCpmCampaignSubmissionsResponse;
  adminCpmCampaignTopEarningClips: CpmTopEarningClipsPage;
  adminCpmCampaigns: AdminCpmCampaignsResponse;
  adminCpmLead?: Maybe<AdminCpmLead>;
  adminCpmPayouts: AdminCpmPayoutsResponse;
  adminCpmSubmissionMediaDownload: AdminCpmSubmissionMediaDownload;
  adminEmailFlow?: Maybe<AdminEmailFlow>;
  adminEmailFlowRunSends: Array<AdminEmailFlowSend>;
  adminEmailFlowRuns: AdminEmailFlowRunsResponse;
  adminEmailFlowStepTestSends: Array<AdminEmailFlowSend>;
  adminEmailFlowTriggers: Array<EmailFlowTrigger>;
  adminEmailFlows: AdminEmailFlowsResponse;
  adminFetchChannelVideos: Array<YouTubeChannelVideo>;
  adminFunnelStats: AdminFunnelData;
  adminLibraries: AdminLibrariesResponse;
  adminLiveSessions: AdminLiveSessionPage;
  adminLiveWatch?: Maybe<AdminLiveWatch>;
  adminLiveWatches: AdminLiveWatchPage;
  adminLiveWindows: AdminLiveWindowPage;
  adminPartialRankingByDateRange: PartialRankingByDateResponse;
  adminPixVerificationDocumentUrl: Scalars['String']['output'];
  adminPixVerifications: AdminPixVerificationsResponse;
  adminPlans: Array<AdminPlanFull>;
  adminProjects: AdminProjectsResponse;
  adminRankingSnapshots: AdminRankingSnapshots;
  adminResultsDashboard: AdminResultsDashboard;
  adminStats: AdminStatsResponse;
  adminTemplateSuggestions: AdminTemplateSuggestionsResponse;
  adminUser?: Maybe<AdminUser>;
  adminUserCpmWallet: AdminUserCpmWallet;
  adminUsers: AdminUsersResponse;
  adminYouTubeDownloads: AdminYouTubeDownloadsResponse;
  adminYoutubeChannels: AdminYoutubeChannelsResponse;
  affiliate?: Maybe<Affiliate>;
  affiliates: Array<Maybe<Affiliate>>;
  affiliates_connection?: Maybe<AffiliateEntityResponseCollection>;
  apiIdempotencies: Array<Maybe<ApiIdempotency>>;
  apiIdempotencies_connection?: Maybe<ApiIdempotencyEntityResponseCollection>;
  apiIdempotency?: Maybe<ApiIdempotency>;
  blogPost?: Maybe<BlogPost>;
  blogPosts: Array<Maybe<BlogPost>>;
  blogSetting?: Maybe<BlogSetting>;
  brandLead?: Maybe<BrandLead>;
  brandLeadEvent?: Maybe<BrandLeadEvent>;
  brandLeadEvents: Array<Maybe<BrandLeadEvent>>;
  brandLeadEvents_connection?: Maybe<BrandLeadEventEntityResponseCollection>;
  brandLeads: Array<Maybe<BrandLead>>;
  brandLeads_connection?: Maybe<BrandLeadEntityResponseCollection>;
  browseSoundEffects: SoundEffectsPage;
  challenge?: Maybe<ClippingChallenge>;
  challengeApplication?: Maybe<ChallengeApplication>;
  challengeApplications: Array<Maybe<ChallengeApplication>>;
  challengeApplications_connection?: Maybe<ChallengeApplicationEntityResponseCollection>;
  checkCommunityLibraryByUrl?: Maybe<MyLibrary>;
  clip?: Maybe<Clip>;
  clipView?: Maybe<ClipView>;
  clipViews: Array<Maybe<ClipView>>;
  clipViews_connection?: Maybe<ClipViewEntityResponseCollection>;
  clipperRankHall: ClipperRankHall;
  clips: Array<Maybe<Clip>>;
  clips_connection?: Maybe<ClipEntityResponseCollection>;
  communityChannels: Array<MyYoutubeChannel>;
  communityLibraries: Array<MyLibrary>;
  communityLiveSessions: Array<CommunityLiveSession>;
  communityTags: Array<MyLibraryTag>;
  copyGeneration?: Maybe<CopyGeneration>;
  copyGenerations: Array<Maybe<CopyGeneration>>;
  copyGenerations_connection?: Maybe<CopyGenerationEntityResponseCollection>;
  coupon?: Maybe<Coupon>;
  coupons: Array<Maybe<Coupon>>;
  coupons_connection?: Maybe<CouponEntityResponseCollection>;
  course?: Maybe<Course>;
  courseCoupon?: Maybe<CourseCoupon>;
  courseCoupons: Array<Maybe<CourseCoupon>>;
  courseCoupons_connection?: Maybe<CourseCouponEntityResponseCollection>;
  coursePurchaseStatus: CoursePurchaseStatus;
  courses: Array<Course>;
  cpmCampaignRanking: CpmCampaignRanking;
  cpmClipperLeaderboard: Array<CpmClipperLeaderboardEntry>;
  cpmPayout?: Maybe<CpmPayout>;
  cpmPayouts: Array<Maybe<CpmPayout>>;
  cpmPayouts_connection?: Maybe<CpmPayoutEntityResponseCollection>;
  curation?: Maybe<Curation>;
  curations: Array<Maybe<Curation>>;
  curations_connection?: Maybe<CurationEntityResponseCollection>;
  downloadCookie?: Maybe<DownloadCookie>;
  downloadCookies: Array<Maybe<DownloadCookie>>;
  downloadCookies_connection?: Maybe<DownloadCookieEntityResponseCollection>;
  downloadInstagramAccount?: Maybe<DownloadInstagramAccount>;
  downloadInstagramAccounts: Array<Maybe<DownloadInstagramAccount>>;
  downloadInstagramAccounts_connection?: Maybe<DownloadInstagramAccountEntityResponseCollection>;
  dropboxVideoMetadata: DropboxVideoMetadata;
  emailDesignerV5EmailDesignerTemplate?: Maybe<EmailDesignerV5EmailDesignerTemplate>;
  emailDesignerV5EmailDesignerTemplateVersion?: Maybe<EmailDesignerV5EmailDesignerTemplateVersion>;
  emailDesignerV5EmailDesignerTemplateVersions: Array<Maybe<EmailDesignerV5EmailDesignerTemplateVersion>>;
  emailDesignerV5EmailDesignerTemplateVersions_connection?: Maybe<EmailDesignerV5EmailDesignerTemplateVersionEntityResponseCollection>;
  emailDesignerV5EmailDesignerTemplates: Array<Maybe<EmailDesignerV5EmailDesignerTemplate>>;
  emailDesignerV5EmailDesignerTemplates_connection?: Maybe<EmailDesignerV5EmailDesignerTemplateEntityResponseCollection>;
  emailFlow?: Maybe<EmailFlow>;
  emailFlowRun?: Maybe<EmailFlowRun>;
  emailFlowRuns: Array<Maybe<EmailFlowRun>>;
  emailFlowRuns_connection?: Maybe<EmailFlowRunEntityResponseCollection>;
  emailFlowSend?: Maybe<EmailFlowSend>;
  emailFlowSends: Array<Maybe<EmailFlowSend>>;
  emailFlowSends_connection?: Maybe<EmailFlowSendEntityResponseCollection>;
  emailFlowStep?: Maybe<EmailFlowStep>;
  emailFlowSteps: Array<Maybe<EmailFlowStep>>;
  emailFlowSteps_connection?: Maybe<EmailFlowStepEntityResponseCollection>;
  emailFlows: Array<Maybe<EmailFlow>>;
  emailFlows_connection?: Maybe<EmailFlowEntityResponseCollection>;
  fillerVideoTags: Array<FillerVideoTag>;
  fillerVideos: Array<FillerVideo>;
  frameioShareVideos: FrameioShareVideos;
  guestSubscriptionStatus: GuestSubscriptionStatus;
  i18NLocale?: Maybe<I18NLocale>;
  i18NLocales: Array<Maybe<I18NLocale>>;
  i18NLocales_connection?: Maybe<I18NLocaleEntityResponseCollection>;
  invitation: Invitation;
  me?: Maybe<UsersPermissionsMe>;
  mediasiloReviewVideos: MediasiloReviewVideos;
  motionMusicLibrary: Array<MotionTrack>;
  myAPIKey: MyApiKey;
  myAPIKeys: Array<MyApiKey>;
  myAPIRequests: Array<MyApiRequest>;
  myAffiliateReferredUserEarnings: Array<AffiliateReferredUserEarning>;
  myAffiliateStatus: MyAffiliateStatus;
  myAiAssistantConversation: AssistantConversation;
  myAiAssistantConversations: Array<AssistantConversationSummary>;
  myBrandKit?: Maybe<MyBrandKit>;
  myBrandKits: Array<MyBrandKit>;
  myCampaignEntry: CampaignEntryState;
  myClip?: Maybe<MyClip>;
  myClipMcpGrants: Array<ClipMcpGrant>;
  myClipPublishes: Array<SocialPublish>;
  myClipRenderData?: Maybe<Scalars['JSON']['output']>;
  myClipperRankPreview: MyClipperRankPreview;
  myClipperRanks: MyClipperRanks;
  myClips: Array<MyClip>;
  myConnectionPublishes: Array<SocialPublish>;
  myCourseRoyalties: MyCourseRoyalties;
  myCoverGeneration?: Maybe<AiCoverGeneration>;
  myCoverGenerationQuota: AiCoverQuota;
  myCpmCampaign?: Maybe<MyCpmCampaign>;
  myCpmCampaigns: Array<MyCpmCampaign>;
  myCpmLeaderboardPrivacy: MyCpmLeaderboardPrivacy;
  myCpmLeaderboardStanding: CpmClipperLeaderboardStanding;
  myCpmWallet: CpmWallet;
  myData: MyData;
  myFont?: Maybe<Font>;
  myFonts: Array<Font>;
  myLibraries: Array<MyLibrary>;
  myLibrariesCounts: MyLibrariesCounts;
  myLibrary?: Maybe<MyLibrary>;
  myMotionProject: MotionProject;
  myMotionProjects: MotionProjectsPage;
  myMotionUsage: MotionUsage;
  myMotionVersions: Array<MotionVersion>;
  myPixVerification?: Maybe<MyPixVerification>;
  myPostableClips: Array<PostableClip>;
  myProject?: Maybe<MyProject>;
  myProjects: Array<MyProject>;
  myPublishQueues: Array<PublishQueue>;
  myQuoteSuggestionJob?: Maybe<QuoteSuggestionJob>;
  myQuoteSuggestionQuota: QuoteSuggestionQuota;
  myScheduledPublishes: Array<SocialPublish>;
  mySocialConnections: Array<MySocialConnection>;
  mySocialLinkingPlatforms: Array<Scalars['String']['output']>;
  mySocialPostingPlatforms: Array<Scalars['String']['output']>;
  myTags: Array<MyLibraryTag>;
  myTemplateSuggestions: Array<MyTemplateSuggestion>;
  myUserMedia: Array<MyUserMedia>;
  myUserMediaFolders: Array<MyUserMediaFolder>;
  myViralizeQualification?: Maybe<ViralizeQualification>;
  myWalletMonthlyEarnings: WalletMonthlyEarnings;
  myWalletStatement: WalletStatement;
  newsletter?: Maybe<Newsletter>;
  newsletters: Array<Maybe<Newsletter>>;
  newsletters_connection?: Maybe<NewsletterEntityResponseCollection>;
  payment?: Maybe<Payment>;
  payments: Array<Maybe<Payment>>;
  payments_connection?: Maybe<PaymentEntityResponseCollection>;
  plan?: Maybe<Plan>;
  plans: Array<Plan>;
  resolveMyCpmOwnedMedia: CpmOwnedMedia;
  reviewWorkflowsWorkflow?: Maybe<ReviewWorkflowsWorkflow>;
  reviewWorkflowsWorkflowStage?: Maybe<ReviewWorkflowsWorkflowStage>;
  reviewWorkflowsWorkflowStages: Array<Maybe<ReviewWorkflowsWorkflowStage>>;
  reviewWorkflowsWorkflowStages_connection?: Maybe<ReviewWorkflowsWorkflowStageEntityResponseCollection>;
  reviewWorkflowsWorkflows: Array<Maybe<ReviewWorkflowsWorkflow>>;
  reviewWorkflowsWorkflows_connection?: Maybe<ReviewWorkflowsWorkflowEntityResponseCollection>;
  shortLink?: Maybe<ShortLink>;
  shortLinks: Array<Maybe<ShortLink>>;
  shortLinks_connection?: Maybe<ShortLinkEntityResponseCollection>;
  socialAnalyticsConnections: Array<MySocialConnection>;
  socialAnalyticsCpmSubmissions: SocialAnalyticsCpmSubmissionPage;
  socialAnalyticsInsights: SocialAnalyticsInsights;
  socialAnalyticsMedia: SocialAnalyticsMediaPage;
  socialAnalyticsMediaHistory: Array<SocialAnalyticsMediaHistoryPoint>;
  socialAnalyticsSummary: SocialAnalyticsSummary;
  soundEffects: Array<SoundEffect>;
  stockMediaSearch: StockMediaSearchResult;
  storeBillingContext: StoreBillingContext;
  subtitlePreset?: Maybe<SubtitlePreset>;
  subtitlePresets: Array<Maybe<SubtitlePreset>>;
  subtitlePresets_connection?: Maybe<SubtitlePresetEntityResponseCollection>;
  templateSuggestions: TemplateSuggestionsResponse;
  tiktokCreatorInfo: TikTokCreatorInfo;
  tldvDownload: TldvDownload;
  uploadFile?: Maybe<UploadFile>;
  uploadFiles: Array<Maybe<UploadFile>>;
  uploadFiles_connection?: Maybe<UploadFileEntityResponseCollection>;
  usageRecord?: Maybe<UsageRecord>;
  usageRecords: Array<Maybe<UsageRecord>>;
  usageRecords_connection?: Maybe<UsageRecordEntityResponseCollection>;
  userTag?: Maybe<UserTag>;
  userTags: Array<Maybe<UserTag>>;
  userTags_connection?: Maybe<UserTagEntityResponseCollection>;
  usersPermissionsRole?: Maybe<UsersPermissionsRole>;
  usersPermissionsRoles: Array<Maybe<UsersPermissionsRole>>;
  usersPermissionsRoles_connection?: Maybe<UsersPermissionsRoleEntityResponseCollection>;
  usersPermissionsUser?: Maybe<UsersPermissionsUser>;
  usersPermissionsUsers: Array<Maybe<UsersPermissionsUser>>;
  usersPermissionsUsers_connection?: Maybe<UsersPermissionsUserEntityResponseCollection>;
  validateCoupon: CouponValidation;
  validateCourseCoupon: CourseCouponValidation;
  webhook?: Maybe<Webhook>;
  webhooks: Array<Maybe<Webhook>>;
  webhooks_connection?: Maybe<WebhookEntityResponseCollection>;
  youtubeAudioTracks: YoutubeAudioTracks;
  youtubeDownload?: Maybe<YoutubeDownload>;
  youtubeDownloads: Array<Maybe<YoutubeDownload>>;
  youtubeDownloads_connection?: Maybe<YoutubeDownloadEntityResponseCollection>;
};


export type QueryAdminAffiliateEarningsArgs = {
  kind?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAdminAiAssistantUsageArgs = {
  direction?: InputMaybe<Scalars['String']['input']>;
  from?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  to?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAdminBotChatConversationArgs = {
  id: Scalars['ID']['input'];
};


export type QueryAdminBotChatConversationsArgs = {
  channel?: InputMaybe<Scalars['String']['input']>;
  hasError?: InputMaybe<Scalars['Boolean']['input']>;
  linked?: InputMaybe<Scalars['Boolean']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryAdminBotChatMessagesArgs = {
  conversationId: Scalars['ID']['input'];
  order?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryAdminBrandLeadSubmissionsArgs = {
  origin?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAdminBrandLeadsArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAdminCampaignLiveImportArgs = {
  campaignId: Scalars['ID']['input'];
};


export type QueryAdminChallengeArgs = {
  id: Scalars['ID']['input'];
};


export type QueryAdminChallengeApplicationsArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAdminChallengeClipsArgs = {
  approval?: InputMaybe<Scalars['String']['input']>;
  challengeId: Scalars['ID']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  validated_hashtags?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAdminChallengeViewsTimeSeriesArgs = {
  challengeId: Scalars['ID']['input'];
  days?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryAdminChallengesArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAdminClipsArgs = {
  clipping_status?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  project_id?: InputMaybe<Scalars['ID']['input']>;
  rendering_status?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<Scalars['String']['input']>;
  user_id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryAdminCommunityCurationPicksArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  nicheId?: InputMaybe<Scalars['ID']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  runId?: InputMaybe<Scalars['ID']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAdminCommunityCurationRunArgs = {
  id: Scalars['ID']['input'];
};


export type QueryAdminCommunityCurationRunsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryAdminCouponArgs = {
  id: Scalars['ID']['input'];
};


export type QueryAdminCouponsArgs = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAdminCourseRevenueSharesArgs = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  courseId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryAdminCpmCampaignArgs = {
  id: Scalars['ID']['input'];
};


export type QueryAdminCpmCampaignChannelRequestsArgs = {
  campaignId: Scalars['ID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAdminCpmCampaignContentArgs = {
  campaignId: Scalars['ID']['input'];
};


export type QueryAdminCpmCampaignParticipantsArgs = {
  campaignId: Scalars['ID']['input'];
  disqualifiedOnly?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAdminCpmCampaignSubmissionAppealsArgs = {
  campaignId: Scalars['ID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAdminCpmCampaignSubmissionsArgs = {
  approval?: InputMaybe<Scalars['String']['input']>;
  campaignId: Scalars['ID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  pendingOlderThanHours?: InputMaybe<Scalars['Int']['input']>;
  platform?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  suspectedDuplicatesOnly?: InputMaybe<Scalars['Boolean']['input']>;
  validatedHashtags?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAdminCpmCampaignTopEarningClipsArgs = {
  campaignId: Scalars['ID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryAdminCpmCampaignsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAdminCpmLeadArgs = {
  documentId: Scalars['ID']['input'];
};


export type QueryAdminCpmPayoutsArgs = {
  kind?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryAdminCpmSubmissionMediaDownloadArgs = {
  submissionId: Scalars['ID']['input'];
};


export type QueryAdminEmailFlowArgs = {
  id: Scalars['ID']['input'];
};


export type QueryAdminEmailFlowRunSendsArgs = {
  runId: Scalars['ID']['input'];
};


export type QueryAdminEmailFlowRunsArgs = {
  flowId: Scalars['ID']['input'];
  includeTest?: InputMaybe<Scalars['Boolean']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryAdminEmailFlowStepTestSendsArgs = {
  stepId: Scalars['ID']['input'];
};


export type QueryAdminEmailFlowsArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAdminFetchChannelVideosArgs = {
  channelUrl: Scalars['String']['input'];
};


export type QueryAdminLibrariesArgs = {
  curation_status?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAdminLiveSessionsArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  watchId: Scalars['ID']['input'];
};


export type QueryAdminLiveWatchArgs = {
  id: Scalars['ID']['input'];
};


export type QueryAdminLiveWatchesArgs = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  platform?: InputMaybe<LiveWatchPlatform>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAdminLiveWindowsArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  sessionId: Scalars['ID']['input'];
};


export type QueryAdminPartialRankingByDateRangeArgs = {
  challengeId: Scalars['ID']['input'];
  endDate?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAdminPixVerificationDocumentUrlArgs = {
  id: Scalars['ID']['input'];
  side?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAdminPixVerificationsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAdminProjectsArgs = {
  curation_status?: InputMaybe<Scalars['String']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<Scalars['String']['input']>;
  user_id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryAdminRankingSnapshotsArgs = {
  rankingId: Scalars['ID']['input'];
};


export type QueryAdminResultsDashboardArgs = {
  endDate?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAdminStatsArgs = {
  endDate?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAdminTemplateSuggestionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAdminUserArgs = {
  id: Scalars['ID']['input'];
};


export type QueryAdminUserCpmWalletArgs = {
  userId: Scalars['ID']['input'];
};


export type QueryAdminUsersArgs = {
  email?: InputMaybe<Scalars['String']['input']>;
  is_partner?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  phone_number?: InputMaybe<Scalars['String']['input']>;
  plan_slug?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAdminYouTubeDownloadsArgs = {
  download_status?: InputMaybe<Scalars['String']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  provider?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<Scalars['String']['input']>;
  video_id?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAdminYoutubeChannelsArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  partnerOnly?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAffiliateArgs = {
  documentId: Scalars['ID']['input'];
};


export type QueryAffiliatesArgs = {
  filters?: InputMaybe<AffiliateFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryAffiliates_ConnectionArgs = {
  filters?: InputMaybe<AffiliateFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryApiIdempotenciesArgs = {
  filters?: InputMaybe<ApiIdempotencyFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryApiIdempotencies_ConnectionArgs = {
  filters?: InputMaybe<ApiIdempotencyFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryApiIdempotencyArgs = {
  documentId: Scalars['ID']['input'];
};


export type QueryBlogPostArgs = {
  documentId: Scalars['ID']['input'];
};


export type QueryBlogPostsArgs = {
  filters?: InputMaybe<BlogPostFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryBrandLeadArgs = {
  documentId: Scalars['ID']['input'];
};


export type QueryBrandLeadEventArgs = {
  documentId: Scalars['ID']['input'];
};


export type QueryBrandLeadEventsArgs = {
  filters?: InputMaybe<BrandLeadEventFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryBrandLeadEvents_ConnectionArgs = {
  filters?: InputMaybe<BrandLeadEventFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryBrandLeadsArgs = {
  filters?: InputMaybe<BrandLeadFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryBrandLeads_ConnectionArgs = {
  filters?: InputMaybe<BrandLeadFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryBrowseSoundEffectsArgs = {
  category?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
};


export type QueryChallengeArgs = {
  id: Scalars['ID']['input'];
};


export type QueryChallengeApplicationArgs = {
  documentId: Scalars['ID']['input'];
};


export type QueryChallengeApplicationsArgs = {
  filters?: InputMaybe<ChallengeApplicationFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryChallengeApplications_ConnectionArgs = {
  filters?: InputMaybe<ChallengeApplicationFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryCheckCommunityLibraryByUrlArgs = {
  url: Scalars['String']['input'];
};


export type QueryClipArgs = {
  documentId: Scalars['ID']['input'];
};


export type QueryClipViewArgs = {
  documentId: Scalars['ID']['input'];
};


export type QueryClipViewsArgs = {
  filters?: InputMaybe<ClipViewFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryClipViews_ConnectionArgs = {
  filters?: InputMaybe<ClipViewFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryClipperRankHallArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  seasonId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryClipsArgs = {
  filters?: InputMaybe<ClipFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryClips_ConnectionArgs = {
  filters?: InputMaybe<ClipFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryCommunityChannelsArgs = {
  category?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCommunityLibrariesArgs = {
  campaignId?: InputMaybe<Scalars['ID']['input']>;
  channelCategory?: InputMaybe<Scalars['String']['input']>;
  channelId?: InputMaybe<Scalars['ID']['input']>;
  expandCampaignChannel?: InputMaybe<Scalars['Boolean']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  tagId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryCommunityTagsArgs = {
  channelCategory?: InputMaybe<Scalars['String']['input']>;
  channelId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryCopyGenerationArgs = {
  documentId: Scalars['ID']['input'];
};


export type QueryCopyGenerationsArgs = {
  filters?: InputMaybe<CopyGenerationFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryCopyGenerations_ConnectionArgs = {
  filters?: InputMaybe<CopyGenerationFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryCouponArgs = {
  documentId: Scalars['ID']['input'];
};


export type QueryCouponsArgs = {
  filters?: InputMaybe<CouponFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryCoupons_ConnectionArgs = {
  filters?: InputMaybe<CouponFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryCourseArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  slug: Scalars['String']['input'];
};


export type QueryCourseCouponArgs = {
  documentId: Scalars['ID']['input'];
};


export type QueryCourseCouponsArgs = {
  filters?: InputMaybe<CourseCouponFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryCourseCoupons_ConnectionArgs = {
  filters?: InputMaybe<CourseCouponFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryCoursePurchaseStatusArgs = {
  purchaseId: Scalars['ID']['input'];
};


export type QueryCoursesArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCpmCampaignRankingArgs = {
  campaignId: Scalars['ID']['input'];
};


export type QueryCpmPayoutArgs = {
  documentId: Scalars['ID']['input'];
};


export type QueryCpmPayoutsArgs = {
  filters?: InputMaybe<CpmPayoutFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryCpmPayouts_ConnectionArgs = {
  filters?: InputMaybe<CpmPayoutFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryCurationArgs = {
  documentId: Scalars['ID']['input'];
};


export type QueryCurationsArgs = {
  filters?: InputMaybe<CurationFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryCurations_ConnectionArgs = {
  filters?: InputMaybe<CurationFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryDownloadCookieArgs = {
  documentId: Scalars['ID']['input'];
};


export type QueryDownloadCookiesArgs = {
  filters?: InputMaybe<DownloadCookieFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryDownloadCookies_ConnectionArgs = {
  filters?: InputMaybe<DownloadCookieFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryDownloadInstagramAccountArgs = {
  documentId: Scalars['ID']['input'];
};


export type QueryDownloadInstagramAccountsArgs = {
  filters?: InputMaybe<DownloadInstagramAccountFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryDownloadInstagramAccounts_ConnectionArgs = {
  filters?: InputMaybe<DownloadInstagramAccountFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryDropboxVideoMetadataArgs = {
  url: Scalars['String']['input'];
};


export type QueryEmailDesignerV5EmailDesignerTemplateArgs = {
  documentId: Scalars['ID']['input'];
};


export type QueryEmailDesignerV5EmailDesignerTemplateVersionArgs = {
  documentId: Scalars['ID']['input'];
};


export type QueryEmailDesignerV5EmailDesignerTemplateVersionsArgs = {
  filters?: InputMaybe<EmailDesignerV5EmailDesignerTemplateVersionFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryEmailDesignerV5EmailDesignerTemplateVersions_ConnectionArgs = {
  filters?: InputMaybe<EmailDesignerV5EmailDesignerTemplateVersionFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryEmailDesignerV5EmailDesignerTemplatesArgs = {
  filters?: InputMaybe<EmailDesignerV5EmailDesignerTemplateFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryEmailDesignerV5EmailDesignerTemplates_ConnectionArgs = {
  filters?: InputMaybe<EmailDesignerV5EmailDesignerTemplateFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryEmailFlowArgs = {
  documentId: Scalars['ID']['input'];
};


export type QueryEmailFlowRunArgs = {
  documentId: Scalars['ID']['input'];
};


export type QueryEmailFlowRunsArgs = {
  filters?: InputMaybe<EmailFlowRunFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryEmailFlowRuns_ConnectionArgs = {
  filters?: InputMaybe<EmailFlowRunFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryEmailFlowSendArgs = {
  documentId: Scalars['ID']['input'];
};


export type QueryEmailFlowSendsArgs = {
  filters?: InputMaybe<EmailFlowSendFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryEmailFlowSends_ConnectionArgs = {
  filters?: InputMaybe<EmailFlowSendFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryEmailFlowStepArgs = {
  documentId: Scalars['ID']['input'];
};


export type QueryEmailFlowStepsArgs = {
  filters?: InputMaybe<EmailFlowStepFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryEmailFlowSteps_ConnectionArgs = {
  filters?: InputMaybe<EmailFlowStepFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryEmailFlowsArgs = {
  filters?: InputMaybe<EmailFlowFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryEmailFlows_ConnectionArgs = {
  filters?: InputMaybe<EmailFlowFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryFillerVideosArgs = {
  category?: InputMaybe<Scalars['String']['input']>;
};


export type QueryFrameioShareVideosArgs = {
  url: Scalars['String']['input'];
};


export type QueryGuestSubscriptionStatusArgs = {
  purchaseId: Scalars['ID']['input'];
};


export type QueryI18NLocaleArgs = {
  documentId: Scalars['ID']['input'];
};


export type QueryI18NLocalesArgs = {
  filters?: InputMaybe<I18NLocaleFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryI18NLocales_ConnectionArgs = {
  filters?: InputMaybe<I18NLocaleFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryInvitationArgs = {
  token: Scalars['String']['input'];
};


export type QueryMediasiloReviewVideosArgs = {
  url: Scalars['String']['input'];
};


export type QueryMotionMusicLibraryArgs = {
  mood?: InputMaybe<Scalars['String']['input']>;
};


export type QueryMyApiKeyArgs = {
  id: Scalars['ID']['input'];
};


export type QueryMyApiKeysArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryMyApiRequestsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryMyAffiliateReferredUserEarningsArgs = {
  userId: Scalars['ID']['input'];
};


export type QueryMyAiAssistantConversationArgs = {
  id: Scalars['ID']['input'];
};


export type QueryMyAiAssistantConversationsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryMyBrandKitArgs = {
  id: Scalars['ID']['input'];
};


export type QueryMyBrandKitsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryMyClipArgs = {
  id: Scalars['ID']['input'];
};


export type QueryMyClipPublishesArgs = {
  clipIds: Array<Scalars['ID']['input']>;
};


export type QueryMyClipRenderDataArgs = {
  id: Scalars['ID']['input'];
  input: Scalars['JSON']['input'];
};


export type QueryMyClipsArgs = {
  library_id?: InputMaybe<Scalars['ID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  project_id?: InputMaybe<Scalars['ID']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
};


export type QueryMyConnectionPublishesArgs = {
  socialConnectionId: Scalars['ID']['input'];
};


export type QueryMyCourseRoyaltiesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryMyCoverGenerationArgs = {
  id: Scalars['ID']['input'];
};


export type QueryMyCpmCampaignArgs = {
  id: Scalars['ID']['input'];
};


export type QueryMyCpmCampaignsArgs = {
  includeInviteOnlyTeasers?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};


export type QueryMyFontArgs = {
  id: Scalars['ID']['input'];
};


export type QueryMyFontsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryMyLibrariesArgs = {
  channelCategory?: InputMaybe<Scalars['String']['input']>;
  channelId?: InputMaybe<Scalars['ID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  tagIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type QueryMyLibraryArgs = {
  id: Scalars['ID']['input'];
};


export type QueryMyMotionProjectArgs = {
  id: Scalars['ID']['input'];
};


export type QueryMyMotionProjectsArgs = {
  before?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryMyMotionVersionsArgs = {
  projectId: Scalars['ID']['input'];
};


export type QueryMyPostableClipsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryMyProjectArgs = {
  id: Scalars['ID']['input'];
};


export type QueryMyProjectsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryMyQuoteSuggestionJobArgs = {
  id: Scalars['ID']['input'];
};


export type QueryMyScheduledPublishesArgs = {
  from: Scalars['DateTime']['input'];
  to: Scalars['DateTime']['input'];
};


export type QueryMyUserMediaArgs = {
  folderId?: InputMaybe<Scalars['ID']['input']>;
  kind?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryMyWalletMonthlyEarningsArgs = {
  months?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryMyWalletStatementArgs = {
  from?: InputMaybe<Scalars['String']['input']>;
  to?: InputMaybe<Scalars['String']['input']>;
};


export type QueryNewsletterArgs = {
  documentId: Scalars['ID']['input'];
};


export type QueryNewslettersArgs = {
  filters?: InputMaybe<NewsletterFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryNewsletters_ConnectionArgs = {
  filters?: InputMaybe<NewsletterFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryPaymentArgs = {
  documentId: Scalars['ID']['input'];
};


export type QueryPaymentsArgs = {
  filters?: InputMaybe<PaymentFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryPayments_ConnectionArgs = {
  filters?: InputMaybe<PaymentFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryPlanArgs = {
  id: Scalars['ID']['input'];
};


export type QueryResolveMyCpmOwnedMediaArgs = {
  platform: Scalars['String']['input'];
  url: Scalars['String']['input'];
};


export type QueryReviewWorkflowsWorkflowArgs = {
  documentId: Scalars['ID']['input'];
};


export type QueryReviewWorkflowsWorkflowStageArgs = {
  documentId: Scalars['ID']['input'];
};


export type QueryReviewWorkflowsWorkflowStagesArgs = {
  filters?: InputMaybe<ReviewWorkflowsWorkflowStageFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryReviewWorkflowsWorkflowStages_ConnectionArgs = {
  filters?: InputMaybe<ReviewWorkflowsWorkflowStageFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryReviewWorkflowsWorkflowsArgs = {
  filters?: InputMaybe<ReviewWorkflowsWorkflowFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryReviewWorkflowsWorkflows_ConnectionArgs = {
  filters?: InputMaybe<ReviewWorkflowsWorkflowFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryShortLinkArgs = {
  documentId: Scalars['ID']['input'];
};


export type QueryShortLinksArgs = {
  filters?: InputMaybe<ShortLinkFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryShortLinks_ConnectionArgs = {
  filters?: InputMaybe<ShortLinkFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QuerySocialAnalyticsCpmSubmissionsArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  platforms?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type QuerySocialAnalyticsInsightsArgs = {
  platforms?: InputMaybe<Array<Scalars['String']['input']>>;
  range?: InputMaybe<SocialAnalyticsRange>;
  socialConnectionIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  timezone: Scalars['String']['input'];
};


export type QuerySocialAnalyticsMediaArgs = {
  availability?: InputMaybe<Scalars['String']['input']>;
  direction?: InputMaybe<Scalars['String']['input']>;
  mediaTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  period?: InputMaybe<Scalars['String']['input']>;
  platforms?: InputMaybe<Array<Scalars['String']['input']>>;
  range?: InputMaybe<SocialAnalyticsRange>;
  search?: InputMaybe<Scalars['String']['input']>;
  socialConnectionIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  sort?: InputMaybe<Scalars['String']['input']>;
};


export type QuerySocialAnalyticsMediaHistoryArgs = {
  mediaId: Scalars['ID']['input'];
};


export type QuerySocialAnalyticsSummaryArgs = {
  platforms?: InputMaybe<Array<Scalars['String']['input']>>;
  range?: InputMaybe<SocialAnalyticsRange>;
  socialConnectionIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type QuerySoundEffectsArgs = {
  category?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
};


export type QueryStockMediaSearchArgs = {
  kind: StockMediaKind;
  page?: InputMaybe<Scalars['Int']['input']>;
  provider?: InputMaybe<StockMediaProvider>;
  query?: InputMaybe<Scalars['String']['input']>;
};


export type QueryStoreBillingContextArgs = {
  platform?: InputMaybe<StorePlatform>;
};


export type QuerySubtitlePresetArgs = {
  documentId: Scalars['ID']['input'];
};


export type QuerySubtitlePresetsArgs = {
  filters?: InputMaybe<SubtitlePresetFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QuerySubtitlePresets_ConnectionArgs = {
  filters?: InputMaybe<SubtitlePresetFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryTemplateSuggestionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};


export type QueryTiktokCreatorInfoArgs = {
  socialConnectionId: Scalars['ID']['input'];
};


export type QueryTldvDownloadArgs = {
  id: Scalars['ID']['input'];
};


export type QueryUploadFileArgs = {
  documentId: Scalars['ID']['input'];
};


export type QueryUploadFilesArgs = {
  filters?: InputMaybe<UploadFileFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryUploadFiles_ConnectionArgs = {
  filters?: InputMaybe<UploadFileFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryUsageRecordArgs = {
  documentId: Scalars['ID']['input'];
};


export type QueryUsageRecordsArgs = {
  filters?: InputMaybe<UsageRecordFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryUsageRecords_ConnectionArgs = {
  filters?: InputMaybe<UsageRecordFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryUserTagArgs = {
  documentId: Scalars['ID']['input'];
};


export type QueryUserTagsArgs = {
  filters?: InputMaybe<UserTagFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryUserTags_ConnectionArgs = {
  filters?: InputMaybe<UserTagFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryUsersPermissionsRoleArgs = {
  documentId: Scalars['ID']['input'];
};


export type QueryUsersPermissionsRolesArgs = {
  filters?: InputMaybe<UsersPermissionsRoleFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryUsersPermissionsRoles_ConnectionArgs = {
  filters?: InputMaybe<UsersPermissionsRoleFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryUsersPermissionsUserArgs = {
  documentId: Scalars['ID']['input'];
};


export type QueryUsersPermissionsUsersArgs = {
  filters?: InputMaybe<UsersPermissionsUserFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryUsersPermissionsUsers_ConnectionArgs = {
  filters?: InputMaybe<UsersPermissionsUserFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryValidateCouponArgs = {
  code: Scalars['String']['input'];
  planId: Scalars['ID']['input'];
  recurrency: Scalars['String']['input'];
};


export type QueryValidateCourseCouponArgs = {
  code: Scalars['String']['input'];
  slug: Scalars['String']['input'];
};


export type QueryWebhookArgs = {
  documentId: Scalars['ID']['input'];
};


export type QueryWebhooksArgs = {
  filters?: InputMaybe<WebhookFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryWebhooks_ConnectionArgs = {
  filters?: InputMaybe<WebhookFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryYoutubeAudioTracksArgs = {
  url: Scalars['String']['input'];
};


export type QueryYoutubeDownloadArgs = {
  documentId: Scalars['ID']['input'];
};


export type QueryYoutubeDownloadsArgs = {
  filters?: InputMaybe<YoutubeDownloadFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryYoutubeDownloads_ConnectionArgs = {
  filters?: InputMaybe<YoutubeDownloadFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type QuoteSuggestionJob = {
  __typename?: 'QuoteSuggestionJob';
  createdAt?: Maybe<Scalars['String']['output']>;
  error_code?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  processing_status: Scalars['String']['output'];
  quotes: Array<QuoteSuggestionQuote>;
};

export type QuoteSuggestionQuota = {
  __typename?: 'QuoteSuggestionQuota';
  limit: Scalars['Int']['output'];
  resets_at: Scalars['String']['output'];
  used: Scalars['Int']['output'];
};

export type QuoteSuggestionQuote = {
  __typename?: 'QuoteSuggestionQuote';
  end: Scalars['Float']['output'];
  start: Scalars['Float']['output'];
  text: Scalars['String']['output'];
};

export type RankingSnapshotClip = {
  __typename?: 'RankingSnapshotClip';
  clip_id: Scalars['ID']['output'];
  clip_platform: Scalars['String']['output'];
  clip_url: Scalars['String']['output'];
  participant_id?: Maybe<Scalars['ID']['output']>;
  participant_name?: Maybe<Scalars['String']['output']>;
  snapshot_view_id: Scalars['ID']['output'];
  views: Scalars['String']['output'];
};

export type RateClipResponse = {
  __typename?: 'RateClipResponse';
  curation_rating?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
};

export type RedeemWalletResult = {
  __typename?: 'RedeemWalletResult';
  checkout?: Maybe<Scalars['JSON']['output']>;
  payoutDocumentId?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
};

export type RenewalCouponResult = {
  __typename?: 'RenewalCouponResult';
  code: Scalars['String']['output'];
  cycles: Scalars['Int']['output'];
  discount: Scalars['Float']['output'];
  pix_order_regenerated: Scalars['Boolean']['output'];
  renewal_price_cents: Scalars['Int']['output'];
  type: Scalars['String']['output'];
};

export type ReportLeadInput = {
  company?: InputMaybe<Scalars['String']['input']>;
  companySegment?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  name: Scalars['String']['input'];
  phone: Scalars['String']['input'];
  report?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
  utm?: InputMaybe<Scalars['JSON']['input']>;
};

/**
 * Outcome of a gated-report request. Deliberately carries no lead data and
 * no PDF URL: the report travels by email only, so a fabricated address
 * gets nothing back. `emailSent: false` means the lead was stored but
 * delivery failed, and the page should say so instead of claiming success.
 */
export type ReportLeadResponse = {
  __typename?: 'ReportLeadResponse';
  emailSent: Scalars['Boolean']['output'];
  ok: Scalars['Boolean']['output'];
};

export type RequestCpmPayoutInput = {
  amount_cents: Scalars['Int']['input'];
  bank_data: Scalars['JSON']['input'];
  breakdown: Scalars['JSON']['input'];
  currency: Scalars['String']['input'];
};

export type ReviewWorkflowsWorkflow = {
  __typename?: 'ReviewWorkflowsWorkflow';
  contentTypes: Scalars['JSON']['output'];
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  documentId: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  stageRequiredToPublish?: Maybe<ReviewWorkflowsWorkflowStage>;
  stages: Array<Maybe<ReviewWorkflowsWorkflowStage>>;
  stages_connection?: Maybe<ReviewWorkflowsWorkflowStageRelationResponseCollection>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type ReviewWorkflowsWorkflowStagesArgs = {
  filters?: InputMaybe<ReviewWorkflowsWorkflowStageFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type ReviewWorkflowsWorkflowStages_ConnectionArgs = {
  filters?: InputMaybe<ReviewWorkflowsWorkflowStageFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ReviewWorkflowsWorkflowEntityResponseCollection = {
  __typename?: 'ReviewWorkflowsWorkflowEntityResponseCollection';
  nodes: Array<ReviewWorkflowsWorkflow>;
  pageInfo: Pagination;
};

export type ReviewWorkflowsWorkflowFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ReviewWorkflowsWorkflowFiltersInput>>>;
  contentTypes?: InputMaybe<JsonFilterInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  documentId?: InputMaybe<IdFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ReviewWorkflowsWorkflowFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ReviewWorkflowsWorkflowFiltersInput>>>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  stageRequiredToPublish?: InputMaybe<ReviewWorkflowsWorkflowStageFiltersInput>;
  stages?: InputMaybe<ReviewWorkflowsWorkflowStageFiltersInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type ReviewWorkflowsWorkflowInput = {
  contentTypes?: InputMaybe<Scalars['JSON']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  stageRequiredToPublish?: InputMaybe<Scalars['ID']['input']>;
  stages?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};

export type ReviewWorkflowsWorkflowStage = {
  __typename?: 'ReviewWorkflowsWorkflowStage';
  color?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  documentId: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  workflow?: Maybe<ReviewWorkflowsWorkflow>;
};

export type ReviewWorkflowsWorkflowStageEntityResponseCollection = {
  __typename?: 'ReviewWorkflowsWorkflowStageEntityResponseCollection';
  nodes: Array<ReviewWorkflowsWorkflowStage>;
  pageInfo: Pagination;
};

export type ReviewWorkflowsWorkflowStageFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ReviewWorkflowsWorkflowStageFiltersInput>>>;
  color?: InputMaybe<StringFilterInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  documentId?: InputMaybe<IdFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ReviewWorkflowsWorkflowStageFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ReviewWorkflowsWorkflowStageFiltersInput>>>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
  workflow?: InputMaybe<ReviewWorkflowsWorkflowFiltersInput>;
};

export type ReviewWorkflowsWorkflowStageInput = {
  color?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  workflow?: InputMaybe<Scalars['ID']['input']>;
};

export type ReviewWorkflowsWorkflowStageRelationResponseCollection = {
  __typename?: 'ReviewWorkflowsWorkflowStageRelationResponseCollection';
  nodes: Array<ReviewWorkflowsWorkflowStage>;
};

export type SaveMyViralizeQualificationAnswerInput = {
  clipperExperience?: InputMaybe<Scalars['String']['input']>;
  couldEarnMore?: InputMaybe<Scalars['Boolean']['input']>;
  equipment?: InputMaybe<Array<Scalars['String']['input']>>;
  financiallyStuck?: InputMaybe<Scalars['Boolean']['input']>;
  first30DayRevenueOutlook?: InputMaybe<Scalars['String']['input']>;
  likesCurrentJob?: InputMaybe<Scalars['Boolean']['input']>;
  monthlyIncome?: InputMaybe<Scalars['String']['input']>;
  motivation?: InputMaybe<Scalars['String']['input']>;
  selfEmploymentOutlook?: InputMaybe<Scalars['String']['input']>;
  startingDifficulty?: InputMaybe<Scalars['String']['input']>;
  wantsRemoteMobileWork?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ScheduledPublishInput = {
  caption?: InputMaybe<Scalars['String']['input']>;
  clipId: Scalars['ID']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  imageUrls?: InputMaybe<Array<Scalars['String']['input']>>;
  madeForKids?: InputMaybe<Scalars['Boolean']['input']>;
  platform: Scalars['String']['input'];
  privacyStatus?: InputMaybe<Scalars['String']['input']>;
  scheduledAt: Scalars['DateTime']['input'];
  socialConnectionId: Scalars['ID']['input'];
  tiktokPostInfo?: InputMaybe<TikTokPostInfoInput>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type ShortLink = {
  __typename?: 'ShortLink';
  clicks?: Maybe<Scalars['Int']['output']>;
  code: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  documentId: Scalars['ID']['output'];
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  target_hash: Scalars['String']['output'];
  target_url: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type ShortLinkEntityResponseCollection = {
  __typename?: 'ShortLinkEntityResponseCollection';
  nodes: Array<ShortLink>;
  pageInfo: Pagination;
};

export type ShortLinkFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ShortLinkFiltersInput>>>;
  clicks?: InputMaybe<IntFilterInput>;
  code?: InputMaybe<StringFilterInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  documentId?: InputMaybe<IdFilterInput>;
  not?: InputMaybe<ShortLinkFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ShortLinkFiltersInput>>>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  target_hash?: InputMaybe<StringFilterInput>;
  target_url?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type ShortLinkInput = {
  clicks?: InputMaybe<Scalars['Int']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  target_hash?: InputMaybe<Scalars['String']['input']>;
  target_url?: InputMaybe<Scalars['String']['input']>;
};

export type SocialAnalyticsAccount = {
  __typename?: 'SocialAnalyticsAccount';
  avatar_url?: Maybe<Scalars['String']['output']>;
  display_name?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  platform: Scalars['String']['output'];
  username: Scalars['String']['output'];
};

export type SocialAnalyticsAccountBreakdown = {
  __typename?: 'SocialAnalyticsAccountBreakdown';
  avatar_url?: Maybe<Scalars['String']['output']>;
  display_name?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  latest_complete_sync_at?: Maybe<Scalars['String']['output']>;
  lifetime_views?: Maybe<Scalars['Float']['output']>;
  platform: Scalars['String']['output'];
  tracked_content: Scalars['Int']['output'];
  username: Scalars['String']['output'];
};

export type SocialAnalyticsCampaign = {
  __typename?: 'SocialAnalyticsCampaign';
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type SocialAnalyticsCpmSubmission = {
  __typename?: 'SocialAnalyticsCpmSubmission';
  account?: Maybe<SocialAnalyticsAccount>;
  accumulated_payout_cents?: Maybe<Scalars['Int']['output']>;
  campaign?: Maybe<SocialAnalyticsCampaign>;
  disqualified: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  last_cpm_synced_at?: Maybe<Scalars['String']['output']>;
  payout_qualified_views?: Maybe<Scalars['Float']['output']>;
  platform: Scalars['String']['output'];
  status?: Maybe<Scalars['String']['output']>;
  url: Scalars['String']['output'];
};

export type SocialAnalyticsCpmSubmissionPage = {
  __typename?: 'SocialAnalyticsCpmSubmissionPage';
  data: Array<SocialAnalyticsCpmSubmission>;
  pagination: SocialAnalyticsPagination;
};

export type SocialAnalyticsDailyPoint = {
  __typename?: 'SocialAnalyticsDailyPoint';
  date: Scalars['String']['output'];
  views_gained?: Maybe<Scalars['Float']['output']>;
};

export type SocialAnalyticsFormatInsight = {
  __typename?: 'SocialAnalyticsFormatInsight';
  media_type: Scalars['String']['output'];
  median_views?: Maybe<Scalars['Float']['output']>;
  posts: Scalars['Int']['output'];
};

export type SocialAnalyticsHourlySlotInsight = {
  __typename?: 'SocialAnalyticsHourlySlotInsight';
  hour: Scalars['Int']['output'];
  median_views?: Maybe<Scalars['Float']['output']>;
  posts: Scalars['Int']['output'];
  weekday: Scalars['Int']['output'];
};

export type SocialAnalyticsInsights = {
  __typename?: 'SocialAnalyticsInsights';
  eligible_posts: Scalars['Int']['output'];
  formats: Array<SocialAnalyticsFormatInsight>;
  hourly_slots: Array<SocialAnalyticsHourlySlotInsight>;
  min_post_age_days: Scalars['Int']['output'];
  time_slots: Array<SocialAnalyticsTimeSlotInsight>;
};

export type SocialAnalyticsMediaHistoryPoint = {
  __typename?: 'SocialAnalyticsMediaHistoryPoint';
  comments?: Maybe<Scalars['Float']['output']>;
  date: Scalars['String']['output'];
  likes?: Maybe<Scalars['Float']['output']>;
  shares?: Maybe<Scalars['Float']['output']>;
  views?: Maybe<Scalars['Float']['output']>;
};

export type SocialAnalyticsMediaPage = {
  __typename?: 'SocialAnalyticsMediaPage';
  data: Array<SocialAnalyticsMediaRow>;
  pagination: SocialAnalyticsPagination;
};

export type SocialAnalyticsMediaRow = {
  __typename?: 'SocialAnalyticsMediaRow';
  account?: Maybe<SocialAnalyticsAccount>;
  availability: Scalars['String']['output'];
  canonical_url: Scalars['String']['output'];
  caption?: Maybe<Scalars['String']['output']>;
  comments?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  last_synced_at?: Maybe<Scalars['String']['output']>;
  likes?: Maybe<Scalars['Float']['output']>;
  media_type: Scalars['String']['output'];
  platform: Scalars['String']['output'];
  published_at?: Maybe<Scalars['String']['output']>;
  shares?: Maybe<Scalars['Float']['output']>;
  thumbnail_url?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  views?: Maybe<Scalars['Float']['output']>;
  views_gained?: Maybe<Scalars['Float']['output']>;
};

export type SocialAnalyticsPagination = {
  __typename?: 'SocialAnalyticsPagination';
  page: Scalars['Int']['output'];
  page_count: Scalars['Int']['output'];
  page_size: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type SocialAnalyticsPlatformBreakdown = {
  __typename?: 'SocialAnalyticsPlatformBreakdown';
  lifetime_views?: Maybe<Scalars['Float']['output']>;
  platform: Scalars['String']['output'];
  tracked_content: Scalars['Int']['output'];
};

export enum SocialAnalyticsRange {
  All = 'ALL',
  D7 = 'D7',
  D30 = 'D30',
  D90 = 'D90'
}

export type SocialAnalyticsRefreshResult = {
  __typename?: 'SocialAnalyticsRefreshResult';
  connection_id: Scalars['ID']['output'];
  error_code?: Maybe<Scalars['String']['output']>;
  next_allowed_at?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
};

export type SocialAnalyticsSummary = {
  __typename?: 'SocialAnalyticsSummary';
  account_breakdowns: Array<SocialAnalyticsAccountBreakdown>;
  daily: Array<SocialAnalyticsDailyPoint>;
  earliest_tracking_date?: Maybe<Scalars['String']['output']>;
  engagement_rate?: Maybe<Scalars['Float']['output']>;
  latest_complete_sync_at?: Maybe<Scalars['String']['output']>;
  lifetime_views?: Maybe<Scalars['Float']['output']>;
  platform_breakdowns: Array<SocialAnalyticsPlatformBreakdown>;
  previous_period_views_gained?: Maybe<Scalars['Float']['output']>;
  selected_accounts: Scalars['Int']['output'];
  total_comments?: Maybe<Scalars['Float']['output']>;
  total_likes?: Maybe<Scalars['Float']['output']>;
  total_shares?: Maybe<Scalars['Float']['output']>;
  tracked_content: Scalars['Int']['output'];
  views_gained?: Maybe<Scalars['Float']['output']>;
};

export type SocialAnalyticsTimeSlotInsight = {
  __typename?: 'SocialAnalyticsTimeSlotInsight';
  daypart: Scalars['String']['output'];
  median_views?: Maybe<Scalars['Float']['output']>;
  posts: Scalars['Int']['output'];
  weekday: Scalars['Int']['output'];
};

export type SocialPublish = {
  __typename?: 'SocialPublish';
  cancelled_at?: Maybe<Scalars['DateTime']['output']>;
  caption?: Maybe<Scalars['String']['output']>;
  clip_id?: Maybe<Scalars['ID']['output']>;
  clip_name?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  facebook_post_kind?: Maybe<Scalars['String']['output']>;
  fail_code?: Maybe<Scalars['String']['output']>;
  fail_reason?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  image_count: Scalars['Int']['output'];
  made_for_kids?: Maybe<Scalars['Boolean']['output']>;
  media_kind: Scalars['String']['output'];
  mode: Scalars['String']['output'];
  platform: Scalars['String']['output'];
  privacy_status?: Maybe<Scalars['String']['output']>;
  provider_post_id?: Maybe<Scalars['String']['output']>;
  publish_queue?: Maybe<PublishQueue>;
  scheduled_at?: Maybe<Scalars['DateTime']['output']>;
  social_connection_id?: Maybe<Scalars['ID']['output']>;
  status: Scalars['String']['output'];
  title?: Maybe<Scalars['String']['output']>;
};

export type SoundEffect = {
  __typename?: 'SoundEffect';
  category: Scalars['String']['output'];
  duration: Scalars['Float']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  peak_at: Scalars['Float']['output'];
  tags: Array<Scalars['String']['output']>;
  url: Scalars['String']['output'];
};

export type SoundEffectsPage = {
  __typename?: 'SoundEffectsPage';
  has_more: Scalars['Boolean']['output'];
  items: Array<SoundEffect>;
  total: Scalars['Int']['output'];
};

export type StockMediaItem = {
  __typename?: 'StockMediaItem';
  author?: Maybe<Scalars['String']['output']>;
  author_url?: Maybe<Scalars['String']['output']>;
  download_location?: Maybe<Scalars['String']['output']>;
  duration?: Maybe<Scalars['Float']['output']>;
  file_url: Scalars['String']['output'];
  height: Scalars['Int']['output'];
  id: Scalars['String']['output'];
  kind: StockMediaKind;
  preview_url?: Maybe<Scalars['String']['output']>;
  provider: StockMediaProvider;
  source_url?: Maybe<Scalars['String']['output']>;
  thumbnail_url: Scalars['String']['output'];
  width: Scalars['Int']['output'];
};

export enum StockMediaKind {
  Image = 'image',
  Video = 'video'
}

export enum StockMediaProvider {
  Pexels = 'pexels',
  Unsplash = 'unsplash'
}

export type StockMediaSearchResult = {
  __typename?: 'StockMediaSearchResult';
  has_more: Scalars['Boolean']['output'];
  items: Array<StockMediaItem>;
  page: Scalars['Int']['output'];
};

export type StoreBillingContext = {
  __typename?: 'StoreBillingContext';
  accountToken: Scalars['String']['output'];
  canPurchaseMinutes: Scalars['Boolean']['output'];
  canPurchasePlans: Scalars['Boolean']['output'];
  productId?: Maybe<Scalars['String']['output']>;
  provider?: Maybe<Scalars['String']['output']>;
  reason?: Maybe<Scalars['String']['output']>;
};

export enum StorePlatform {
  Android = 'android',
  Ios = 'ios'
}

export type StorePurchaseResult = {
  __typename?: 'StorePurchaseResult';
  status: Scalars['String']['output'];
  subscription?: Maybe<Scalars['JSON']['output']>;
};

export type StringFilterInput = {
  and?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  between?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contains?: InputMaybe<Scalars['String']['input']>;
  containsi?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  eq?: InputMaybe<Scalars['String']['input']>;
  eqi?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nei?: InputMaybe<Scalars['String']['input']>;
  not?: InputMaybe<StringFilterInput>;
  notContains?: InputMaybe<Scalars['String']['input']>;
  notContainsi?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  notNull?: InputMaybe<Scalars['Boolean']['input']>;
  null?: InputMaybe<Scalars['Boolean']['input']>;
  or?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};

export type SubmitChallengeClipInput = {
  challenge_id: Scalars['ID']['input'];
  platform: Scalars['String']['input'];
  url: Scalars['String']['input'];
};

export type SubtitlePreset = {
  __typename?: 'SubtitlePreset';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  documentId: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  preset?: Maybe<Scalars['JSON']['output']>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type SubtitlePresetEntityResponseCollection = {
  __typename?: 'SubtitlePresetEntityResponseCollection';
  nodes: Array<SubtitlePreset>;
  pageInfo: Pagination;
};

export type SubtitlePresetFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<SubtitlePresetFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  documentId?: InputMaybe<IdFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<SubtitlePresetFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<SubtitlePresetFiltersInput>>>;
  preset?: InputMaybe<JsonFilterInput>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type SubtitlePresetInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  preset?: InputMaybe<Scalars['JSON']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type TemplateSuggestion = {
  __typename?: 'TemplateSuggestion';
  author_name?: Maybe<Scalars['String']['output']>;
  brand_kit_id?: Maybe<Scalars['ID']['output']>;
  createdAt: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  note?: Maybe<Scalars['String']['output']>;
  platform: Scalars['String']['output'];
  promoted_at?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  submitted_by_name?: Maybe<Scalars['String']['output']>;
  submitted_url: Scalars['String']['output'];
  thumbnail_url?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  use_case: Scalars['String']['output'];
  viewer_has_voted: Scalars['Boolean']['output'];
  vote_count: Scalars['Int']['output'];
};

export type TemplateSuggestionInput = {
  note?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
  url: Scalars['String']['input'];
  useCase: Scalars['String']['input'];
};

/**
 * Exactly one of these three states holds: "created" non-null (a new suggestion),
 * "duplicate" non-null (the post was already suggested AND the caller may see that
 * card), or duplicate_hidden true (already suggested, but the existing row is
 * pending or rejected and the caller is neither its author nor an admin — so the
 * caller learns only that the post is taken, never its content or who sent it).
 */
export type TemplateSuggestionSubmitResult = {
  __typename?: 'TemplateSuggestionSubmitResult';
  created?: Maybe<MyTemplateSuggestion>;
  duplicate?: Maybe<TemplateSuggestion>;
  duplicate_hidden: Scalars['Boolean']['output'];
};

export type TemplateSuggestionsResponse = {
  __typename?: 'TemplateSuggestionsResponse';
  data: Array<TemplateSuggestion>;
  pageCount: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type TikTokCreatorInfo = {
  __typename?: 'TikTokCreatorInfo';
  comment_disabled: Scalars['Boolean']['output'];
  creator_avatar_url?: Maybe<Scalars['String']['output']>;
  creator_nickname?: Maybe<Scalars['String']['output']>;
  creator_username?: Maybe<Scalars['String']['output']>;
  duet_disabled: Scalars['Boolean']['output'];
  max_video_post_duration_sec?: Maybe<Scalars['Int']['output']>;
  privacy_level_options: Array<Scalars['String']['output']>;
  stitch_disabled: Scalars['Boolean']['output'];
};

export type TikTokPostInfoInput = {
  brandContentToggle?: InputMaybe<Scalars['Boolean']['input']>;
  brandOrganicToggle?: InputMaybe<Scalars['Boolean']['input']>;
  disableComment?: InputMaybe<Scalars['Boolean']['input']>;
  disableDuet?: InputMaybe<Scalars['Boolean']['input']>;
  disableStitch?: InputMaybe<Scalars['Boolean']['input']>;
  isAigc?: InputMaybe<Scalars['Boolean']['input']>;
  privacyLevel: Scalars['String']['input'];
};

/**
 * A public tl;dv meeting download (autoclipper.live/tldv-downloader).
 * status: queued | processing | completed | failed | expired.
 * videoUrl/srtUrl are set only while completed; files expire at expiresAt.
 */
export type TldvDownload = {
  __typename?: 'TldvDownload';
  createdAt?: Maybe<Scalars['String']['output']>;
  durationSeconds?: Maybe<Scalars['Int']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  expiresAt?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  meetingId: Scalars['String']['output'];
  progress?: Maybe<Scalars['Int']['output']>;
  srtUrl?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  title?: Maybe<Scalars['String']['output']>;
  videoSizeKb?: Maybe<Scalars['Int']['output']>;
  videoUrl?: Maybe<Scalars['String']['output']>;
};

export type UpdateMyPayoutDataInput = {
  account?: InputMaybe<Scalars['String']['input']>;
  agency?: InputMaybe<Scalars['String']['input']>;
  bank?: InputMaybe<Scalars['String']['input']>;
  document: Scalars['String']['input'];
  name: Scalars['String']['input'];
  pixKey?: InputMaybe<Scalars['String']['input']>;
};

export type UploadFile = {
  __typename?: 'UploadFile';
  alternativeText?: Maybe<Scalars['String']['output']>;
  caption?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  documentId: Scalars['ID']['output'];
  ext?: Maybe<Scalars['String']['output']>;
  focalPoint?: Maybe<Scalars['JSON']['output']>;
  formats?: Maybe<Scalars['JSON']['output']>;
  hash: Scalars['String']['output'];
  height?: Maybe<Scalars['Int']['output']>;
  mime: Scalars['String']['output'];
  name: Scalars['String']['output'];
  previewUrl?: Maybe<Scalars['String']['output']>;
  provider: Scalars['String']['output'];
  provider_metadata?: Maybe<Scalars['JSON']['output']>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  related?: Maybe<Array<Maybe<GenericMorph>>>;
  size: Scalars['Float']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  url: Scalars['String']['output'];
  width?: Maybe<Scalars['Int']['output']>;
};

export type UploadFileEntityResponseCollection = {
  __typename?: 'UploadFileEntityResponseCollection';
  nodes: Array<UploadFile>;
  pageInfo: Pagination;
};

export type UploadFileFiltersInput = {
  alternativeText?: InputMaybe<StringFilterInput>;
  and?: InputMaybe<Array<InputMaybe<UploadFileFiltersInput>>>;
  caption?: InputMaybe<StringFilterInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  documentId?: InputMaybe<IdFilterInput>;
  ext?: InputMaybe<StringFilterInput>;
  focalPoint?: InputMaybe<JsonFilterInput>;
  formats?: InputMaybe<JsonFilterInput>;
  hash?: InputMaybe<StringFilterInput>;
  height?: InputMaybe<IntFilterInput>;
  mime?: InputMaybe<StringFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<UploadFileFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<UploadFileFiltersInput>>>;
  previewUrl?: InputMaybe<StringFilterInput>;
  provider?: InputMaybe<StringFilterInput>;
  provider_metadata?: InputMaybe<JsonFilterInput>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  size?: InputMaybe<FloatFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
  url?: InputMaybe<StringFilterInput>;
  width?: InputMaybe<IntFilterInput>;
};

export type UsageRecord = {
  __typename?: 'UsageRecord';
  clip?: Maybe<Clip>;
  count: Scalars['Float']['output'];
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  documentId: Scalars['ID']['output'];
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  refunded?: Maybe<Scalars['Boolean']['output']>;
  type: Enum_Usagerecord_Type;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type UsageRecordEntityResponseCollection = {
  __typename?: 'UsageRecordEntityResponseCollection';
  nodes: Array<UsageRecord>;
  pageInfo: Pagination;
};

export type UsageRecordFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<UsageRecordFiltersInput>>>;
  clip?: InputMaybe<ClipFiltersInput>;
  count?: InputMaybe<FloatFilterInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  documentId?: InputMaybe<IdFilterInput>;
  not?: InputMaybe<UsageRecordFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<UsageRecordFiltersInput>>>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  refunded?: InputMaybe<BooleanFilterInput>;
  type?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type UsageRecordInput = {
  clip?: InputMaybe<Scalars['ID']['input']>;
  count?: InputMaybe<Scalars['Float']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  refunded?: InputMaybe<Scalars['Boolean']['input']>;
  type?: InputMaybe<Enum_Usagerecord_Type>;
};

export type UserTag = {
  __typename?: 'UserTag';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  documentId: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  sellflux_webhook?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  users: Array<Maybe<UsersPermissionsUser>>;
  users_connection?: Maybe<UsersPermissionsUserRelationResponseCollection>;
};


export type UserTagUsersArgs = {
  filters?: InputMaybe<UsersPermissionsUserFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type UserTagUsers_ConnectionArgs = {
  filters?: InputMaybe<UsersPermissionsUserFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type UserTagEntityResponseCollection = {
  __typename?: 'UserTagEntityResponseCollection';
  nodes: Array<UserTag>;
  pageInfo: Pagination;
};

export type UserTagFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<UserTagFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  description?: InputMaybe<StringFilterInput>;
  documentId?: InputMaybe<IdFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<UserTagFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<UserTagFiltersInput>>>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  sellflux_webhook?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
  users?: InputMaybe<UsersPermissionsUserFiltersInput>;
};

export type UserTagInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  sellflux_webhook?: InputMaybe<Scalars['String']['input']>;
  users?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};

export type UserTagRelationResponseCollection = {
  __typename?: 'UserTagRelationResponseCollection';
  nodes: Array<UserTag>;
};

export type UsersPermissionsCreateRolePayload = {
  __typename?: 'UsersPermissionsCreateRolePayload';
  ok: Scalars['Boolean']['output'];
};

export type UsersPermissionsDeleteRolePayload = {
  __typename?: 'UsersPermissionsDeleteRolePayload';
  ok: Scalars['Boolean']['output'];
};

export type UsersPermissionsLoginInput = {
  identifier: Scalars['String']['input'];
  password: Scalars['String']['input'];
  provider?: Scalars['String']['input'];
};

export type UsersPermissionsLoginPayload = {
  __typename?: 'UsersPermissionsLoginPayload';
  jwt?: Maybe<Scalars['String']['output']>;
  user: UsersPermissionsMe;
};

export type UsersPermissionsMe = {
  __typename?: 'UsersPermissionsMe';
  blocked?: Maybe<Scalars['Boolean']['output']>;
  confirmed?: Maybe<Scalars['Boolean']['output']>;
  documentId: Scalars['ID']['output'];
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  role?: Maybe<UsersPermissionsMeRole>;
  username: Scalars['String']['output'];
};

export type UsersPermissionsMeRole = {
  __typename?: 'UsersPermissionsMeRole';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  type?: Maybe<Scalars['String']['output']>;
};

export type UsersPermissionsPasswordPayload = {
  __typename?: 'UsersPermissionsPasswordPayload';
  ok: Scalars['Boolean']['output'];
};

export type UsersPermissionsPermission = {
  __typename?: 'UsersPermissionsPermission';
  action: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  documentId: Scalars['ID']['output'];
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  role?: Maybe<UsersPermissionsRole>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type UsersPermissionsPermissionFiltersInput = {
  action?: InputMaybe<StringFilterInput>;
  and?: InputMaybe<Array<InputMaybe<UsersPermissionsPermissionFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  documentId?: InputMaybe<IdFilterInput>;
  not?: InputMaybe<UsersPermissionsPermissionFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<UsersPermissionsPermissionFiltersInput>>>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  role?: InputMaybe<UsersPermissionsRoleFiltersInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type UsersPermissionsPermissionRelationResponseCollection = {
  __typename?: 'UsersPermissionsPermissionRelationResponseCollection';
  nodes: Array<UsersPermissionsPermission>;
};

export type UsersPermissionsRegisterInput = {
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
  username: Scalars['String']['input'];
};

export type UsersPermissionsRole = {
  __typename?: 'UsersPermissionsRole';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  documentId: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  permissions: Array<Maybe<UsersPermissionsPermission>>;
  permissions_connection?: Maybe<UsersPermissionsPermissionRelationResponseCollection>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  users: Array<Maybe<UsersPermissionsUser>>;
  users_connection?: Maybe<UsersPermissionsUserRelationResponseCollection>;
};


export type UsersPermissionsRolePermissionsArgs = {
  filters?: InputMaybe<UsersPermissionsPermissionFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type UsersPermissionsRolePermissions_ConnectionArgs = {
  filters?: InputMaybe<UsersPermissionsPermissionFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type UsersPermissionsRoleUsersArgs = {
  filters?: InputMaybe<UsersPermissionsUserFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type UsersPermissionsRoleUsers_ConnectionArgs = {
  filters?: InputMaybe<UsersPermissionsUserFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type UsersPermissionsRoleEntityResponseCollection = {
  __typename?: 'UsersPermissionsRoleEntityResponseCollection';
  nodes: Array<UsersPermissionsRole>;
  pageInfo: Pagination;
};

export type UsersPermissionsRoleFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<UsersPermissionsRoleFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  description?: InputMaybe<StringFilterInput>;
  documentId?: InputMaybe<IdFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<UsersPermissionsRoleFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<UsersPermissionsRoleFiltersInput>>>;
  permissions?: InputMaybe<UsersPermissionsPermissionFiltersInput>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  type?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
  users?: InputMaybe<UsersPermissionsUserFiltersInput>;
};

export type UsersPermissionsRoleInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  permissions?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  users?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};

export type UsersPermissionsUpdateRolePayload = {
  __typename?: 'UsersPermissionsUpdateRolePayload';
  ok: Scalars['Boolean']['output'];
};

export type UsersPermissionsUser = {
  __typename?: 'UsersPermissionsUser';
  affiliate?: Maybe<Scalars['String']['output']>;
  affiliate_blocked?: Maybe<Scalars['Boolean']['output']>;
  affiliate_blocked_at?: Maybe<Scalars['DateTime']['output']>;
  affiliate_blocked_reason?: Maybe<Scalars['String']['output']>;
  affiliate_code?: Maybe<Scalars['String']['output']>;
  affiliate_custom_code?: Maybe<Scalars['String']['output']>;
  affiliate_from?: Maybe<Affiliate>;
  affiliate_rate_course?: Maybe<Scalars['Int']['output']>;
  affiliate_rate_cpm?: Maybe<Scalars['Int']['output']>;
  affiliate_rate_note?: Maybe<Scalars['String']['output']>;
  affiliate_rate_payment?: Maybe<Scalars['Int']['output']>;
  affiliate_terms_accepted_at?: Maybe<Scalars['DateTime']['output']>;
  affiliate_terms_accepted_version?: Maybe<Scalars['String']['output']>;
  blocked?: Maybe<Scalars['Boolean']['output']>;
  clips: Array<Maybe<Clip>>;
  clips_connection?: Maybe<ClipRelationResponseCollection>;
  confirmed?: Maybe<Scalars['Boolean']['output']>;
  cpm_leaderboard_anonymous?: Maybe<Scalars['Boolean']['output']>;
  cpm_leaderboard_excluded?: Maybe<Scalars['Boolean']['output']>;
  cpm_leaderboard_excluded_reason?: Maybe<Scalars['String']['output']>;
  cpm_payouts: Array<Maybe<CpmPayout>>;
  cpm_payouts_connection?: Maybe<CpmPayoutRelationResponseCollection>;
  cpm_terms_accepted_at?: Maybe<Scalars['DateTime']['output']>;
  cpm_terms_accepted_version?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  documentId: Scalars['ID']['output'];
  email: Scalars['String']['output'];
  email_marketing_opt_in?: Maybe<Scalars['Boolean']['output']>;
  ip_address?: Maybe<Scalars['String']['output']>;
  is_admin?: Maybe<Scalars['Boolean']['output']>;
  job_title?: Maybe<Scalars['String']['output']>;
  joined_community?: Maybe<Scalars['Boolean']['output']>;
  last_active_at?: Maybe<Scalars['DateTime']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  objective_changed_at?: Maybe<Scalars['DateTime']['output']>;
  objectives_with_platform?: Maybe<Scalars['String']['output']>;
  onboarding_course_offer_decision?: Maybe<Enum_Userspermissionsuser_Onboarding_Course_Offer_Decision>;
  onboarding_course_offer_viewed_at?: Maybe<Scalars['DateTime']['output']>;
  onboarding_daily_volume?: Maybe<Enum_Userspermissionsuser_Onboarding_Daily_Volume>;
  onboarding_experience?: Maybe<Enum_Userspermissionsuser_Onboarding_Experience>;
  onboarding_objective?: Maybe<Enum_Userspermissionsuser_Onboarding_Objective>;
  phone_number?: Maybe<Scalars['String']['output']>;
  profile_picture?: Maybe<UploadFile>;
  provider?: Maybe<Scalars['String']['output']>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  referred_at?: Maybe<Scalars['DateTime']['output']>;
  referred_by?: Maybe<UsersPermissionsUser>;
  referred_users: Array<Maybe<UsersPermissionsUser>>;
  referred_users_connection?: Maybe<UsersPermissionsUserRelationResponseCollection>;
  role?: Maybe<UsersPermissionsRole>;
  tags: Array<Maybe<UserTag>>;
  tags_connection?: Maybe<UserTagRelationResponseCollection>;
  target_objective?: Maybe<Scalars['String']['output']>;
  tos_accepted?: Maybe<Scalars['Boolean']['output']>;
  tos_accepted_at?: Maybe<Scalars['DateTime']['output']>;
  tos_accepted_version?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  username: Scalars['String']['output'];
  utm_campaign?: Maybe<Scalars['String']['output']>;
  utm_content?: Maybe<Scalars['String']['output']>;
  utm_medium?: Maybe<Scalars['String']['output']>;
  utm_source?: Maybe<Scalars['String']['output']>;
  utm_term?: Maybe<Scalars['String']['output']>;
  workflow_description?: Maybe<Scalars['String']['output']>;
};


export type UsersPermissionsUserClipsArgs = {
  filters?: InputMaybe<ClipFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type UsersPermissionsUserClips_ConnectionArgs = {
  filters?: InputMaybe<ClipFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type UsersPermissionsUserCpm_PayoutsArgs = {
  filters?: InputMaybe<CpmPayoutFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type UsersPermissionsUserCpm_Payouts_ConnectionArgs = {
  filters?: InputMaybe<CpmPayoutFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type UsersPermissionsUserReferred_UsersArgs = {
  filters?: InputMaybe<UsersPermissionsUserFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type UsersPermissionsUserReferred_Users_ConnectionArgs = {
  filters?: InputMaybe<UsersPermissionsUserFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type UsersPermissionsUserTagsArgs = {
  filters?: InputMaybe<UserTagFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type UsersPermissionsUserTags_ConnectionArgs = {
  filters?: InputMaybe<UserTagFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type UsersPermissionsUserEntityResponse = {
  __typename?: 'UsersPermissionsUserEntityResponse';
  data?: Maybe<UsersPermissionsUser>;
};

export type UsersPermissionsUserEntityResponseCollection = {
  __typename?: 'UsersPermissionsUserEntityResponseCollection';
  nodes: Array<UsersPermissionsUser>;
  pageInfo: Pagination;
};

export type UsersPermissionsUserFiltersInput = {
  affiliate?: InputMaybe<StringFilterInput>;
  affiliate_blocked?: InputMaybe<BooleanFilterInput>;
  affiliate_blocked_at?: InputMaybe<DateTimeFilterInput>;
  affiliate_blocked_reason?: InputMaybe<StringFilterInput>;
  affiliate_code?: InputMaybe<StringFilterInput>;
  affiliate_custom_code?: InputMaybe<StringFilterInput>;
  affiliate_from?: InputMaybe<AffiliateFiltersInput>;
  affiliate_rate_course?: InputMaybe<IntFilterInput>;
  affiliate_rate_cpm?: InputMaybe<IntFilterInput>;
  affiliate_rate_note?: InputMaybe<StringFilterInput>;
  affiliate_rate_payment?: InputMaybe<IntFilterInput>;
  affiliate_terms_accepted_at?: InputMaybe<DateTimeFilterInput>;
  affiliate_terms_accepted_version?: InputMaybe<StringFilterInput>;
  and?: InputMaybe<Array<InputMaybe<UsersPermissionsUserFiltersInput>>>;
  blocked?: InputMaybe<BooleanFilterInput>;
  clips?: InputMaybe<ClipFiltersInput>;
  confirmed?: InputMaybe<BooleanFilterInput>;
  cpm_leaderboard_anonymous?: InputMaybe<BooleanFilterInput>;
  cpm_leaderboard_excluded?: InputMaybe<BooleanFilterInput>;
  cpm_leaderboard_excluded_reason?: InputMaybe<StringFilterInput>;
  cpm_payouts?: InputMaybe<CpmPayoutFiltersInput>;
  cpm_terms_accepted_at?: InputMaybe<DateTimeFilterInput>;
  cpm_terms_accepted_version?: InputMaybe<StringFilterInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  documentId?: InputMaybe<IdFilterInput>;
  email?: InputMaybe<StringFilterInput>;
  email_marketing_opt_in?: InputMaybe<BooleanFilterInput>;
  ip_address?: InputMaybe<StringFilterInput>;
  is_admin?: InputMaybe<BooleanFilterInput>;
  job_title?: InputMaybe<StringFilterInput>;
  joined_community?: InputMaybe<BooleanFilterInput>;
  last_active_at?: InputMaybe<DateTimeFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<UsersPermissionsUserFiltersInput>;
  objective_changed_at?: InputMaybe<DateTimeFilterInput>;
  objectives_with_platform?: InputMaybe<StringFilterInput>;
  onboarding_course_offer_decision?: InputMaybe<StringFilterInput>;
  onboarding_course_offer_viewed_at?: InputMaybe<DateTimeFilterInput>;
  onboarding_daily_volume?: InputMaybe<StringFilterInput>;
  onboarding_experience?: InputMaybe<StringFilterInput>;
  onboarding_objective?: InputMaybe<StringFilterInput>;
  or?: InputMaybe<Array<InputMaybe<UsersPermissionsUserFiltersInput>>>;
  phone_number?: InputMaybe<StringFilterInput>;
  provider?: InputMaybe<StringFilterInput>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  referred_at?: InputMaybe<DateTimeFilterInput>;
  referred_by?: InputMaybe<UsersPermissionsUserFiltersInput>;
  referred_users?: InputMaybe<UsersPermissionsUserFiltersInput>;
  role?: InputMaybe<UsersPermissionsRoleFiltersInput>;
  tags?: InputMaybe<UserTagFiltersInput>;
  target_objective?: InputMaybe<StringFilterInput>;
  tos_accepted?: InputMaybe<BooleanFilterInput>;
  tos_accepted_at?: InputMaybe<DateTimeFilterInput>;
  tos_accepted_version?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
  username?: InputMaybe<StringFilterInput>;
  utm_campaign?: InputMaybe<StringFilterInput>;
  utm_content?: InputMaybe<StringFilterInput>;
  utm_medium?: InputMaybe<StringFilterInput>;
  utm_source?: InputMaybe<StringFilterInput>;
  utm_term?: InputMaybe<StringFilterInput>;
  workflow_description?: InputMaybe<StringFilterInput>;
};

export type UsersPermissionsUserInput = {
  affiliate?: InputMaybe<Scalars['String']['input']>;
  affiliate_blocked?: InputMaybe<Scalars['Boolean']['input']>;
  affiliate_blocked_at?: InputMaybe<Scalars['DateTime']['input']>;
  affiliate_blocked_reason?: InputMaybe<Scalars['String']['input']>;
  affiliate_code?: InputMaybe<Scalars['String']['input']>;
  affiliate_custom_code?: InputMaybe<Scalars['String']['input']>;
  affiliate_from?: InputMaybe<Scalars['ID']['input']>;
  affiliate_rate_course?: InputMaybe<Scalars['Int']['input']>;
  affiliate_rate_cpm?: InputMaybe<Scalars['Int']['input']>;
  affiliate_rate_note?: InputMaybe<Scalars['String']['input']>;
  affiliate_rate_payment?: InputMaybe<Scalars['Int']['input']>;
  affiliate_terms_accepted_at?: InputMaybe<Scalars['DateTime']['input']>;
  affiliate_terms_accepted_version?: InputMaybe<Scalars['String']['input']>;
  blocked?: InputMaybe<Scalars['Boolean']['input']>;
  clips?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  confirmed?: InputMaybe<Scalars['Boolean']['input']>;
  cpm_leaderboard_anonymous?: InputMaybe<Scalars['Boolean']['input']>;
  cpm_leaderboard_excluded?: InputMaybe<Scalars['Boolean']['input']>;
  cpm_leaderboard_excluded_reason?: InputMaybe<Scalars['String']['input']>;
  cpm_payouts?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  cpm_terms_accepted_at?: InputMaybe<Scalars['DateTime']['input']>;
  cpm_terms_accepted_version?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  email_marketing_opt_in?: InputMaybe<Scalars['Boolean']['input']>;
  ip_address?: InputMaybe<Scalars['String']['input']>;
  is_admin?: InputMaybe<Scalars['Boolean']['input']>;
  job_title?: InputMaybe<Scalars['String']['input']>;
  joined_community?: InputMaybe<Scalars['Boolean']['input']>;
  last_active_at?: InputMaybe<Scalars['DateTime']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  objective_changed_at?: InputMaybe<Scalars['DateTime']['input']>;
  objectives_with_platform?: InputMaybe<Scalars['String']['input']>;
  onboarding_course_offer_decision?: InputMaybe<Enum_Userspermissionsuser_Onboarding_Course_Offer_Decision>;
  onboarding_course_offer_viewed_at?: InputMaybe<Scalars['DateTime']['input']>;
  onboarding_daily_volume?: InputMaybe<Enum_Userspermissionsuser_Onboarding_Daily_Volume>;
  onboarding_experience?: InputMaybe<Enum_Userspermissionsuser_Onboarding_Experience>;
  onboarding_objective?: InputMaybe<Enum_Userspermissionsuser_Onboarding_Objective>;
  password?: InputMaybe<Scalars['String']['input']>;
  phone_number?: InputMaybe<Scalars['String']['input']>;
  profile_picture?: InputMaybe<Scalars['ID']['input']>;
  provider?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  referred_at?: InputMaybe<Scalars['DateTime']['input']>;
  referred_by?: InputMaybe<Scalars['ID']['input']>;
  referred_users?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  role?: InputMaybe<Scalars['ID']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  target_objective?: InputMaybe<Scalars['String']['input']>;
  tos_accepted?: InputMaybe<Scalars['Boolean']['input']>;
  tos_accepted_at?: InputMaybe<Scalars['DateTime']['input']>;
  tos_accepted_version?: InputMaybe<Scalars['String']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
  utm_campaign?: InputMaybe<Scalars['String']['input']>;
  utm_content?: InputMaybe<Scalars['String']['input']>;
  utm_medium?: InputMaybe<Scalars['String']['input']>;
  utm_source?: InputMaybe<Scalars['String']['input']>;
  utm_term?: InputMaybe<Scalars['String']['input']>;
  workflow_description?: InputMaybe<Scalars['String']['input']>;
};

export type UsersPermissionsUserRelationResponseCollection = {
  __typename?: 'UsersPermissionsUserRelationResponseCollection';
  nodes: Array<UsersPermissionsUser>;
};

export type ValidateChallengeClipInput = {
  challenge_id: Scalars['ID']['input'];
  platform: Scalars['String']['input'];
  url: Scalars['String']['input'];
};

export type ViralizeQualification = {
  __typename?: 'ViralizeQualification';
  clipper_experience?: Maybe<Scalars['String']['output']>;
  completed_at?: Maybe<Scalars['String']['output']>;
  could_earn_more?: Maybe<Scalars['Boolean']['output']>;
  equipment?: Maybe<Array<Scalars['String']['output']>>;
  financially_stuck?: Maybe<Scalars['Boolean']['output']>;
  first_30_day_revenue_outlook?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  likes_current_job?: Maybe<Scalars['Boolean']['output']>;
  monthly_income?: Maybe<Scalars['String']['output']>;
  motivation?: Maybe<Scalars['String']['output']>;
  self_employment_outlook?: Maybe<Scalars['String']['output']>;
  starting_difficulty?: Maybe<Scalars['String']['output']>;
  wants_remote_mobile_work?: Maybe<Scalars['Boolean']['output']>;
};

export type WalletEarningsMonth = {
  __typename?: 'WalletEarningsMonth';
  affiliate_cents: Scalars['Int']['output'];
  clips_cents: Scalars['Int']['output'];
  month: Scalars['String']['output'];
  producer_cents: Scalars['Int']['output'];
  total_cents: Scalars['Int']['output'];
};

export type WalletMonthlyEarnings = {
  __typename?: 'WalletMonthlyEarnings';
  currency: Scalars['String']['output'];
  months: Array<WalletEarningsMonth>;
};

export type WalletStatement = {
  __typename?: 'WalletStatement';
  current_balance_cents: Scalars['Int']['output'];
  days: Array<WalletStatementDay>;
  first_snapshot_day?: Maybe<Scalars['String']['output']>;
  from: Scalars['String']['output'];
  opening_balance_cents?: Maybe<Scalars['Int']['output']>;
  to: Scalars['String']['output'];
  today: Scalars['String']['output'];
  upcoming: Array<WalletStatementLine>;
};

export type WalletStatementDay = {
  __typename?: 'WalletStatementDay';
  closing_balance_cents?: Maybe<Scalars['Int']['output']>;
  day: Scalars['String']['output'];
  lines: Array<WalletStatementLine>;
};

export type WalletStatementLine = {
  __typename?: 'WalletStatementLine';
  amount_cents: Scalars['Int']['output'];
  at?: Maybe<Scalars['String']['output']>;
  course_title?: Maybe<Scalars['String']['output']>;
  earning_kind?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  kind: Scalars['String']['output'];
  paid_at?: Maybe<Scalars['String']['output']>;
  payout_kind?: Maybe<Scalars['String']['output']>;
  payout_status?: Maybe<Scalars['String']['output']>;
  referred_user_name?: Maybe<Scalars['String']['output']>;
  reversal_reason?: Maybe<Scalars['String']['output']>;
  since_day?: Maybe<Scalars['String']['output']>;
  source?: Maybe<Scalars['String']['output']>;
};

export type Webhook = {
  __typename?: 'Webhook';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  data?: Maybe<Scalars['JSON']['output']>;
  documentId: Scalars['ID']['output'];
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  uid?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type WebhookEntityResponseCollection = {
  __typename?: 'WebhookEntityResponseCollection';
  nodes: Array<Webhook>;
  pageInfo: Pagination;
};

export type WebhookFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<WebhookFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  data?: InputMaybe<JsonFilterInput>;
  documentId?: InputMaybe<IdFilterInput>;
  not?: InputMaybe<WebhookFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<WebhookFiltersInput>>>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  source?: InputMaybe<StringFilterInput>;
  type?: InputMaybe<StringFilterInput>;
  uid?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type WebhookInput = {
  data?: InputMaybe<Scalars['JSON']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  uid?: InputMaybe<Scalars['String']['input']>;
};

export type YouTubeChannelVideo = {
  __typename?: 'YouTubeChannelVideo';
  channel?: Maybe<Scalars['String']['output']>;
  duration?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  publishedAt?: Maybe<Scalars['String']['output']>;
  thumbnail?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  url: Scalars['String']['output'];
  viewCount?: Maybe<Scalars['String']['output']>;
};

export type YoutubeAudioTrack = {
  __typename?: 'YoutubeAudioTrack';
  code?: Maybe<Scalars['String']['output']>;
  kind: Scalars['String']['output'];
  language?: Maybe<Scalars['String']['output']>;
  transcribable: Scalars['Boolean']['output'];
};

export type YoutubeAudioTracks = {
  __typename?: 'YoutubeAudioTracks';
  status: Scalars['String']['output'];
  tracks: Array<YoutubeAudioTrack>;
};

export type YoutubeDownload = {
  __typename?: 'YoutubeDownload';
  aired_at?: Maybe<Scalars['DateTime']['output']>;
  audio?: Maybe<UploadFile>;
  audio_track?: Maybe<Scalars['String']['output']>;
  audio_track_language?: Maybe<Scalars['String']['output']>;
  audio_track_original?: Maybe<Scalars['Boolean']['output']>;
  compressed_video_url?: Maybe<Scalars['String']['output']>;
  compression_finished_at?: Maybe<Scalars['DateTime']['output']>;
  compression_seconds?: Maybe<Scalars['Float']['output']>;
  compression_started_at?: Maybe<Scalars['DateTime']['output']>;
  compression_status?: Maybe<Enum_Youtubedownload_Compression_Status>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  detection_finished_at?: Maybe<Scalars['DateTime']['output']>;
  detection_seconds?: Maybe<Scalars['Float']['output']>;
  detection_started_at?: Maybe<Scalars['DateTime']['output']>;
  detection_status?: Maybe<Enum_Youtubedownload_Detection_Status>;
  documentId: Scalars['ID']['output'];
  download_seconds?: Maybe<Scalars['Float']['output']>;
  download_status: Enum_Youtubedownload_Download_Status;
  downloaded_by?: Maybe<Scalars['String']['output']>;
  duration_seconds?: Maybe<Scalars['Float']['output']>;
  finished_at?: Maybe<Scalars['DateTime']['output']>;
  hash?: Maybe<Scalars['String']['output']>;
  language?: Maybe<Scalars['String']['output']>;
  message_chat_id?: Maybe<Scalars['String']['output']>;
  message_id?: Maybe<Scalars['String']['output']>;
  message_thread_id?: Maybe<Scalars['Int']['output']>;
  original_creator?: Maybe<UsersPermissionsUser>;
  priority?: Maybe<Scalars['Int']['output']>;
  provider?: Maybe<Enum_Youtubedownload_Provider>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  queue_at?: Maybe<Scalars['DateTime']['output']>;
  queue_wait_seconds?: Maybe<Scalars['Float']['output']>;
  scene_detection?: Maybe<Scalars['JSON']['output']>;
  scene_detection_url?: Maybe<Scalars['String']['output']>;
  thumbnail?: Maybe<UploadFile>;
  title?: Maybe<Scalars['String']['output']>;
  topic?: Maybe<Scalars['String']['output']>;
  topic_classified_at?: Maybe<Scalars['DateTime']['output']>;
  topic_confidence?: Maybe<Scalars['Float']['output']>;
  topic_language?: Maybe<Scalars['String']['output']>;
  topic_summary?: Maybe<Scalars['String']['output']>;
  transcription?: Maybe<Scalars['JSON']['output']>;
  transcription_failure_code?: Maybe<Scalars['String']['output']>;
  transcription_finished_at?: Maybe<Scalars['DateTime']['output']>;
  transcription_retries?: Maybe<Scalars['Int']['output']>;
  transcription_seconds?: Maybe<Scalars['Float']['output']>;
  transcription_started_at?: Maybe<Scalars['DateTime']['output']>;
  transcription_status?: Maybe<Enum_Youtubedownload_Transcription_Status>;
  transcription_url?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  upload_date?: Maybe<Scalars['String']['output']>;
  video?: Maybe<UploadFile>;
  video_id: Scalars['String']['output'];
  view_count?: Maybe<Scalars['Long']['output']>;
};

export type YoutubeDownloadEntityResponseCollection = {
  __typename?: 'YoutubeDownloadEntityResponseCollection';
  nodes: Array<YoutubeDownload>;
  pageInfo: Pagination;
};

export type YoutubeDownloadFiltersInput = {
  aired_at?: InputMaybe<DateTimeFilterInput>;
  and?: InputMaybe<Array<InputMaybe<YoutubeDownloadFiltersInput>>>;
  audio_track?: InputMaybe<StringFilterInput>;
  audio_track_language?: InputMaybe<StringFilterInput>;
  audio_track_original?: InputMaybe<BooleanFilterInput>;
  compressed_video_url?: InputMaybe<StringFilterInput>;
  compression_finished_at?: InputMaybe<DateTimeFilterInput>;
  compression_seconds?: InputMaybe<FloatFilterInput>;
  compression_started_at?: InputMaybe<DateTimeFilterInput>;
  compression_status?: InputMaybe<StringFilterInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  detection_finished_at?: InputMaybe<DateTimeFilterInput>;
  detection_seconds?: InputMaybe<FloatFilterInput>;
  detection_started_at?: InputMaybe<DateTimeFilterInput>;
  detection_status?: InputMaybe<StringFilterInput>;
  documentId?: InputMaybe<IdFilterInput>;
  download_seconds?: InputMaybe<FloatFilterInput>;
  download_status?: InputMaybe<StringFilterInput>;
  downloaded_by?: InputMaybe<StringFilterInput>;
  duration_seconds?: InputMaybe<FloatFilterInput>;
  finished_at?: InputMaybe<DateTimeFilterInput>;
  hash?: InputMaybe<StringFilterInput>;
  language?: InputMaybe<StringFilterInput>;
  message_chat_id?: InputMaybe<StringFilterInput>;
  message_id?: InputMaybe<StringFilterInput>;
  message_thread_id?: InputMaybe<IntFilterInput>;
  not?: InputMaybe<YoutubeDownloadFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<YoutubeDownloadFiltersInput>>>;
  original_creator?: InputMaybe<UsersPermissionsUserFiltersInput>;
  priority?: InputMaybe<IntFilterInput>;
  provider?: InputMaybe<StringFilterInput>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  queue_at?: InputMaybe<DateTimeFilterInput>;
  queue_wait_seconds?: InputMaybe<FloatFilterInput>;
  scene_detection?: InputMaybe<JsonFilterInput>;
  scene_detection_url?: InputMaybe<StringFilterInput>;
  title?: InputMaybe<StringFilterInput>;
  topic?: InputMaybe<StringFilterInput>;
  topic_classified_at?: InputMaybe<DateTimeFilterInput>;
  topic_confidence?: InputMaybe<FloatFilterInput>;
  topic_language?: InputMaybe<StringFilterInput>;
  topic_summary?: InputMaybe<StringFilterInput>;
  transcription?: InputMaybe<JsonFilterInput>;
  transcription_failure_code?: InputMaybe<StringFilterInput>;
  transcription_finished_at?: InputMaybe<DateTimeFilterInput>;
  transcription_retries?: InputMaybe<IntFilterInput>;
  transcription_seconds?: InputMaybe<FloatFilterInput>;
  transcription_started_at?: InputMaybe<DateTimeFilterInput>;
  transcription_status?: InputMaybe<StringFilterInput>;
  transcription_url?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
  upload_date?: InputMaybe<StringFilterInput>;
  video_id?: InputMaybe<StringFilterInput>;
  view_count?: InputMaybe<LongFilterInput>;
};

export type YoutubeDownloadInput = {
  aired_at?: InputMaybe<Scalars['DateTime']['input']>;
  audio?: InputMaybe<Scalars['ID']['input']>;
  audio_track?: InputMaybe<Scalars['String']['input']>;
  audio_track_language?: InputMaybe<Scalars['String']['input']>;
  audio_track_original?: InputMaybe<Scalars['Boolean']['input']>;
  compressed_video_url?: InputMaybe<Scalars['String']['input']>;
  compression_finished_at?: InputMaybe<Scalars['DateTime']['input']>;
  compression_seconds?: InputMaybe<Scalars['Float']['input']>;
  compression_started_at?: InputMaybe<Scalars['DateTime']['input']>;
  compression_status?: InputMaybe<Enum_Youtubedownload_Compression_Status>;
  detection_finished_at?: InputMaybe<Scalars['DateTime']['input']>;
  detection_seconds?: InputMaybe<Scalars['Float']['input']>;
  detection_started_at?: InputMaybe<Scalars['DateTime']['input']>;
  detection_status?: InputMaybe<Enum_Youtubedownload_Detection_Status>;
  download_seconds?: InputMaybe<Scalars['Float']['input']>;
  download_status?: InputMaybe<Enum_Youtubedownload_Download_Status>;
  downloaded_by?: InputMaybe<Scalars['String']['input']>;
  duration_seconds?: InputMaybe<Scalars['Float']['input']>;
  finished_at?: InputMaybe<Scalars['DateTime']['input']>;
  hash?: InputMaybe<Scalars['String']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
  message_chat_id?: InputMaybe<Scalars['String']['input']>;
  message_id?: InputMaybe<Scalars['String']['input']>;
  message_thread_id?: InputMaybe<Scalars['Int']['input']>;
  original_creator?: InputMaybe<Scalars['ID']['input']>;
  priority?: InputMaybe<Scalars['Int']['input']>;
  provider?: InputMaybe<Enum_Youtubedownload_Provider>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  queue_at?: InputMaybe<Scalars['DateTime']['input']>;
  queue_wait_seconds?: InputMaybe<Scalars['Float']['input']>;
  scene_detection?: InputMaybe<Scalars['JSON']['input']>;
  scene_detection_url?: InputMaybe<Scalars['String']['input']>;
  thumbnail?: InputMaybe<Scalars['ID']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  topic?: InputMaybe<Scalars['String']['input']>;
  topic_classified_at?: InputMaybe<Scalars['DateTime']['input']>;
  topic_confidence?: InputMaybe<Scalars['Float']['input']>;
  topic_language?: InputMaybe<Scalars['String']['input']>;
  topic_summary?: InputMaybe<Scalars['String']['input']>;
  transcription?: InputMaybe<Scalars['JSON']['input']>;
  transcription_failure_code?: InputMaybe<Scalars['String']['input']>;
  transcription_finished_at?: InputMaybe<Scalars['DateTime']['input']>;
  transcription_retries?: InputMaybe<Scalars['Int']['input']>;
  transcription_seconds?: InputMaybe<Scalars['Float']['input']>;
  transcription_started_at?: InputMaybe<Scalars['DateTime']['input']>;
  transcription_status?: InputMaybe<Enum_Youtubedownload_Transcription_Status>;
  transcription_url?: InputMaybe<Scalars['String']['input']>;
  upload_date?: InputMaybe<Scalars['String']['input']>;
  video?: InputMaybe<Scalars['ID']['input']>;
  video_id?: InputMaybe<Scalars['String']['input']>;
  view_count?: InputMaybe<Scalars['Long']['input']>;
};

export type AppealKeepPendingIdFragment = { __typename?: 'AdminCpmCampaignSubmission', pending_appeal_id?: string | null };

export type RecordOnboardingCourseOfferMutationVariables = Exact<{
  event: Scalars['String']['input'];
  experience?: InputMaybe<Scalars['String']['input']>;
}>;


export type RecordOnboardingCourseOfferMutation = { __typename?: 'Mutation', recordOnboardingCourseOffer: { __typename?: 'MyData', id: string, onboarding_experience?: string | null } };

export type SubmissionHashtagValidationFragment = { __typename?: 'AdminCpmCampaignSubmission', validated_hashtags: string };

export type AdminBrandLeadsQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
}>;


export type AdminBrandLeadsQuery = { __typename?: 'Query', adminBrandLeads: { __typename?: 'AdminBrandLeadsResponse', total: number, page: number, pageCount: number, data: Array<{ __typename?: 'AdminBrandLead', documentId: string, name: string, email: string, phone: string, phoneE164?: string | null, company?: string | null, state?: string | null, updatedAt: string }> } };

export type AdminCpmLeadQueryVariables = Exact<{
  documentId: Scalars['ID']['input'];
}>;


export type AdminCpmLeadQuery = { __typename?: 'Query', adminCpmLead?: { __typename?: 'AdminCpmLead', documentId: string, name: string, email: string, phone: string, phoneE164?: string | null, company?: string | null, website?: string | null, social?: string | null, demandType?: string | null, objective?: string | null, contentType?: any | null, platforms?: string | null, budget: string, source?: string | null, state?: string | null, brief?: any | null, iago?: any | null, messages: Array<{ __typename?: 'AdminCpmLeadMessage', id: string, direction: string, actor?: string | null, text: string, createdAt: string }> } | null };

export type AdminRestartCpmLeadMutationVariables = Exact<{
  documentId: Scalars['ID']['input'];
}>;


export type AdminRestartCpmLeadMutation = { __typename?: 'Mutation', adminRestartCpmLead: { __typename?: 'AdminCpmLeadMessage', id: string, direction: string, actor?: string | null, text: string, createdAt: string } };

export type AdminReplyCpmLeadMutationVariables = Exact<{
  documentId: Scalars['ID']['input'];
  text: Scalars['String']['input'];
}>;


export type AdminReplyCpmLeadMutation = { __typename?: 'Mutation', adminReplyCpmLead: { __typename?: 'AdminCpmLeadMessage', id: string, direction: string, actor?: string | null, text: string, createdAt: string } };

export type YoutubeAudioTracksQueryVariables = Exact<{
  url: Scalars['String']['input'];
}>;


export type YoutubeAudioTracksQuery = { __typename?: 'Query', youtubeAudioTracks: { __typename?: 'YoutubeAudioTracks', status: string, tracks: Array<{ __typename?: 'YoutubeAudioTrack', code?: string | null, language?: string | null, kind: string, transcribable: boolean }> } };

export type AdminBrandLeadSubmissionsQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  origin?: InputMaybe<Scalars['String']['input']>;
}>;


export type AdminBrandLeadSubmissionsQuery = { __typename?: 'Query', adminBrandLeadSubmissions: { __typename?: 'AdminBrandLeadSubmissionsResponse', total: number, page: number, pageSize: number, pageCount: number, data: Array<{ __typename?: 'AdminBrandLeadSubmission', documentId: string, isDuplicate: boolean, submittedAt: string, lead: { __typename?: 'AdminBrandLead', documentId: string, name: string, email: string, phone: string, website?: string | null, social?: string | null, company?: string | null, demandType?: string | null, objective?: string | null, contentType?: any | null, platforms?: string | null, budget: string, source?: string | null, utm?: any | null, createdAt: string, updatedAt: string } }>, originCounts: { __typename?: 'AdminBrandLeadOriginCounts', app: number, site: number, marcas: number, other: number } } };

export type CreateBrandLeadFromAppMutationVariables = Exact<{
  data: BrandLeadInput;
}>;


export type CreateBrandLeadFromAppMutation = { __typename?: 'Mutation', createBrandLead: { __typename?: 'BrandLead', documentId: string } };

export type CampaignAuditAccessQueryVariables = Exact<{ [key: string]: never; }>;


export type CampaignAuditAccessQuery = { __typename?: 'Query', adminCpmCampaigns: { __typename?: 'AdminCpmCampaignsResponse', total: number } };

export type AdminCpmCampaignContentQueryVariables = Exact<{
  campaignId: Scalars['ID']['input'];
}>;


export type AdminCpmCampaignContentQuery = { __typename?: 'Query', adminCpmCampaignContent: { __typename?: 'CampaignAuditContent', id: string, name: string, description?: string | null, rules_allowed?: string | null, rules_forbidden?: string | null, rules_attention?: string | null, rules_warning?: string | null, required_hashtags?: string | null, required_mention?: string | null, banner_url?: string | null, logo_url?: string | null, content_locked: boolean, editing_locked_reason?: string | null, scheduled_activation_at?: string | null } };

export type AdminUpdateCpmCampaignContentMutationVariables = Exact<{
  campaignId: Scalars['ID']['input'];
  input: CampaignAuditContentInput;
}>;


export type AdminUpdateCpmCampaignContentMutation = { __typename?: 'Mutation', adminUpdateCpmCampaignContent: { __typename?: 'CampaignAuditContent', id: string, name: string, description?: string | null, rules_allowed?: string | null, rules_forbidden?: string | null, rules_attention?: string | null, rules_warning?: string | null, required_hashtags?: string | null, required_mention?: string | null, banner_url?: string | null, logo_url?: string | null, content_locked: boolean, editing_locked_reason?: string | null, scheduled_activation_at?: string | null } };

export type MyCampaignEntryQueryVariables = Exact<{ [key: string]: never; }>;


export type MyCampaignEntryQuery = { __typename?: 'Query', myCampaignEntry: { __typename?: 'CampaignEntryState', account_id: string, campaign_id?: string | null, skip_onboarding: boolean } };

export type CompleteMyCampaignEntryMutationVariables = Exact<{
  campaignId: Scalars['ID']['input'];
}>;


export type CompleteMyCampaignEntryMutation = { __typename?: 'Mutation', completeMyCampaignEntry: { __typename?: 'CampaignEntryState', account_id: string, campaign_id?: string | null, skip_onboarding: boolean } };

export type SuperHeroPromotionQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type SuperHeroPromotionQuery = { __typename?: 'Query', adminCpmCampaign?: { __typename?: 'AdminCpmCampaign', id: string, name: string, status: string, campaign_type?: string | null, end_date?: string | null, ranking_config?: any | null, logo_url?: string | null, banner_url?: string | null } | null };

export type MyClipRenderDataQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  input: Scalars['JSON']['input'];
}>;


export type MyClipRenderDataQuery = { __typename?: 'Query', myClipRenderData?: any | null };

export type StartMyClipperRunMutationVariables = Exact<{ [key: string]: never; }>;


export type StartMyClipperRunMutation = { __typename?: 'Mutation', startMyClipperRun: { __typename?: 'ClipperRunAdmission', id: string, seed: number, rulesVersion: number, personalBest: number } };

export type FinishMyClipperRunMutationVariables = Exact<{
  runId: Scalars['ID']['input'];
  frames: Scalars['Int']['input'];
  events: Array<ClipperRunInputEvent> | ClipperRunInputEvent;
}>;


export type FinishMyClipperRunMutation = { __typename?: 'Mutation', finishMyClipperRun: { __typename?: 'ClipperRunResult', score: number, personalBest: number } };

export type GetCoursesQueryVariables = Exact<{
  locale?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetCoursesQuery = { __typename?: 'Query', courses: Array<{ __typename?: 'Course', id: string, slug: string, title: string, description?: string | null, weeksLabel?: string | null, durationLabel?: string | null, thumbnailUrl?: string | null, order: number, moduleCount: number, freeModuleCount: number, progressPercent: number, ungroupedModules: Array<{ __typename?: 'CourseModule', id: string, title: string, videoUrl?: string | null, thumbnailUrl?: string | null, isFree: boolean, order: number, isLocked: boolean, isCompleted: boolean }>, moduleGroups: Array<{ __typename?: 'CourseModuleGroup', id: string, label: string, order: number, modules: Array<{ __typename?: 'CourseModule', id: string, title: string, videoUrl?: string | null, thumbnailUrl?: string | null, isFree: boolean, order: number, isLocked: boolean, isCompleted: boolean }> }> }> };

export type MarkCourseModuleCompletedMutationVariables = Exact<{
  moduleId: Scalars['ID']['input'];
}>;


export type MarkCourseModuleCompletedMutation = { __typename?: 'Mutation', markCourseModuleCompleted: { __typename?: 'CourseModule', id: string, isCompleted: boolean, isLocked: boolean, videoUrl?: string | null } };

export type GetCourseBySlugQueryVariables = Exact<{
  slug: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetCourseBySlugQuery = { __typename?: 'Query', course?: { __typename?: 'Course', id: string, slug: string, title: string, description?: string | null, weeksLabel?: string | null, durationLabel?: string | null, thumbnailUrl?: string | null, order: number, moduleCount: number, freeModuleCount: number, progressPercent: number, price?: number | null, isPurchasable: boolean, ownedByViewer: boolean, ungroupedModules: Array<{ __typename?: 'CourseModule', id: string, title: string, description?: string | null, videoUrl?: string | null, thumbnailUrl?: string | null, transcriptUrl?: string | null, isFree: boolean, order: number, isLocked: boolean, isCompleted: boolean, chapters: Array<{ __typename?: 'CourseModuleChapter', title: string, startSeconds: number }> }>, moduleGroups: Array<{ __typename?: 'CourseModuleGroup', id: string, label: string, order: number, modules: Array<{ __typename?: 'CourseModule', id: string, title: string, description?: string | null, videoUrl?: string | null, thumbnailUrl?: string | null, transcriptUrl?: string | null, isFree: boolean, order: number, isLocked: boolean, isCompleted: boolean, chapters: Array<{ __typename?: 'CourseModuleChapter', title: string, startSeconds: number }> }> }> } | null };

export type CreateCoursePurchasePixMutationVariables = Exact<{
  slug: Scalars['String']['input'];
  documentType: Scalars['String']['input'];
  documentNumber: Scalars['String']['input'];
  phone: Scalars['String']['input'];
  phoneDetails?: InputMaybe<CoursePurchasePhoneInput>;
  couponCode?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreateCoursePurchasePixMutation = { __typename?: 'Mutation', createCoursePurchasePix: { __typename?: 'CoursePurchasePixOrder', purchase_id: string, status: string, amount: number, pix_code?: string | null, pix_qr_code_url?: string | null, expires_at?: string | null } };

export type CreateCoursePurchaseCheckoutMutationVariables = Exact<{
  slug: Scalars['String']['input'];
  phone: Scalars['String']['input'];
  phoneDetails?: InputMaybe<CoursePurchasePhoneInput>;
  returnUrl: Scalars['String']['input'];
  cancelUrl?: InputMaybe<Scalars['String']['input']>;
  couponCode?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreateCoursePurchaseCheckoutMutation = { __typename?: 'Mutation', createCoursePurchaseCheckout: { __typename?: 'CoursePurchaseCheckout', purchase_id: string, url: string, amount: number } };

export type ValidateCourseCouponQueryVariables = Exact<{
  code: Scalars['String']['input'];
  slug: Scalars['String']['input'];
}>;


export type ValidateCourseCouponQuery = { __typename?: 'Query', validateCourseCoupon: { __typename?: 'CourseCouponValidation', valid: boolean, error?: string | null, code?: string | null, type?: string | null, discount?: number | null, amount?: number | null } };

export type CoursePurchaseStatusQueryVariables = Exact<{
  purchaseId: Scalars['ID']['input'];
}>;


export type CoursePurchaseStatusQuery = { __typename?: 'Query', coursePurchaseStatus: { __typename?: 'CoursePurchaseStatus', status: string } };

export type CpmReportCampaignQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type CpmReportCampaignQuery = { __typename?: 'Query', adminCpmCampaign?: { __typename?: 'AdminCpmCampaign', id: string, name: string, status: string, start_date?: string | null, end_date?: string | null, currency: string, cpm_rate_cents: number, budget_total_cents: number, budget_spent_cents: number, budget_stored_spent_cents: number, budget_remaining_cents: number, budget_spend_drift_cents: number, min_views_threshold?: number | null, max_payout_per_clip_cents?: number | null, max_payout_per_clipper_cents?: number | null, view_accrual_window_hours?: number | null, submissions_count: number, createdAt: string, updatedAt: string } | null };

export type CpmReportSubmissionsQueryVariables = Exact<{
  campaignId: Scalars['ID']['input'];
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
}>;


export type CpmReportSubmissionsQuery = { __typename?: 'Query', adminCpmCampaignSubmissions: { __typename?: 'AdminCpmCampaignSubmissionsResponse', total: number, pageCount: number, data: Array<{ __typename?: 'AdminCpmCampaignSubmission', id: string, platform: string, url: string, canonical_url?: string | null, admin_approval: string, disqualified: boolean, last_counted_views: string, accumulated_payout_cents: number, cpm_rate_override_cents?: number | null, last_view_sync_at?: string | null, createdAt: string, user_id: string, suspected_duplicate: boolean, accrual_window_ends_at?: string | null, final_accrual_views?: string | null, final_accrual_captured_at?: string | null, daily_views: Array<{ __typename?: 'CpmSubmissionViewSnapshot', date: string, views: string }> }> } };

export type CpmReportConclusionsMutationVariables = Exact<{
  campaignId: Scalars['ID']['input'];
  reportAsOf: Scalars['String']['input'];
  expectedFactsFingerprint: Scalars['String']['input'];
}>;


export type CpmReportConclusionsMutation = { __typename?: 'Mutation', adminGenerateCpmCampaignReportConclusions: { __typename?: 'CpmCampaignReportConclusions', fingerprint: string, generatedAt: string, summary: string, highlights: Array<{ __typename?: 'CpmReportConclusionItem', title: string, text: string, evidenceKeys: Array<string> }>, recommendations: Array<{ __typename?: 'CpmReportConclusionItem', title: string, text: string, evidenceKeys: Array<string> }> } };

export type CpmCampaignRankingQueryVariables = Exact<{
  campaignId: Scalars['ID']['input'];
}>;


export type CpmCampaignRankingQuery = { __typename?: 'Query', cpmCampaignRanking: { __typename?: 'CpmCampaignRanking', campaign_id: string, campaign_type: string, config: any, phase: string, can_review: boolean, can_submit: boolean, review_fingerprint: string, pending_reports_count: number, pending_clip_count?: number | null, pending_metrics_count?: number | null, can_finalize?: boolean | null, unresolved_ties: Array<Array<string>>, finalized_at?: any | null, winner_contact_url?: string | null, last_view_sync_at?: any | null, rows: Array<{ __typename?: 'CpmRankingRow', participant_id?: string | null, display_name: string, total_views: string, valid_post_count: number, eligible: boolean, place?: number | null, prize_cents: number, is_self: boolean, tie_pending?: boolean | null }>, my_row?: { __typename?: 'CpmRankingRow', participant_id?: string | null, display_name: string, total_views: string, valid_post_count: number, eligible: boolean, place?: number | null, prize_cents: number, is_self: boolean, tie_pending?: boolean | null } | null, my_progress?: { __typename?: 'CpmRankingProgress', target_type: string, current_position?: number | null, next_position?: number | null, views_needed?: string | null, estimated_clips_needed?: string | null } | null, own_reports: Array<{ __typename?: 'CpmRankingReport', id: string, submission_id?: string | null, participant_id: string, platform: string, url: string, profile_handle?: string | null, profile_url?: string | null, published_at?: any | null, reported_views?: string | null, evidence_url?: string | null, status: string, verified_views?: string | null, profile_verified: boolean, ownership_verified: boolean, connected_account: boolean, review_reason?: string | null, reviewed_at?: any | null, created_at: any, admission_approved_at?: any | null, rules_check?: any | null, last_view_sync_at?: any | null, clip_approval?: string | null, ranked_views?: string | null, views_source?: string | null, views_captured_at?: any | null, metrics_status?: string | null, tracked_views?: string | null, tracked_views_captured_at?: any | null, tracked_views_source?: string | null }>, admin_reports: Array<{ __typename?: 'CpmRankingReport', id: string, submission_id?: string | null, participant_id: string, platform: string, url: string, profile_handle?: string | null, profile_url?: string | null, published_at?: any | null, reported_views?: string | null, evidence_url?: string | null, status: string, verified_views?: string | null, profile_verified: boolean, ownership_verified: boolean, connected_account: boolean, review_reason?: string | null, reviewed_at?: any | null, created_at: any, admission_approved_at?: any | null, rules_check?: any | null, last_view_sync_at?: any | null, clip_approval?: string | null, ranked_views?: string | null, views_source?: string | null, views_captured_at?: any | null, metrics_status?: string | null, tracked_views?: string | null, tracked_views_captured_at?: any | null, tracked_views_source?: string | null, account_reliability?: { __typename?: 'CpmRankingAccountReliability', status: string, score?: number | null, engagement_rate?: number | null, lifetime_views?: string | null, tracked_content?: number | null, username?: string | null } | null }> } };

export type SubmitMyCpmRankingReportMutationVariables = Exact<{
  campaignId: Scalars['ID']['input'];
  input: CpmRankingReportInput;
}>;


export type SubmitMyCpmRankingReportMutation = { __typename?: 'Mutation', submitMyCpmRankingReport: { __typename?: 'CpmRankingReport', id: string, status: string } };

export type AdminReviewCpmRankingReportMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: CpmRankingReviewInput;
}>;


export type AdminReviewCpmRankingReportMutation = { __typename?: 'Mutation', adminReviewCpmRankingReport: { __typename?: 'CpmRankingReport', id: string, status: string, verified_views?: string | null } };

export type AdminReviewCpmRankingSubmissionMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: CpmRankingReviewInput;
}>;


export type AdminReviewCpmRankingSubmissionMutation = { __typename?: 'Mutation', adminReviewCpmRankingSubmission: { __typename?: 'CpmRankingReport', id: string, submission_id?: string | null, status: string, verified_views?: string | null } };

export type AdminReviewCpmRankingClipMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  approval: Scalars['String']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
  ownershipVerified?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type AdminReviewCpmRankingClipMutation = { __typename?: 'Mutation', adminReviewCpmRankingClip: { __typename?: 'CpmRankingReport', id: string, submission_id?: string | null, clip_approval?: string | null, ranked_views?: string | null, views_source?: string | null, views_captured_at?: any | null, metrics_status?: string | null } };

export type AdminBulkApproveCpmRankingClipsMutationVariables = Exact<{
  campaignId: Scalars['ID']['input'];
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type AdminBulkApproveCpmRankingClipsMutation = { __typename?: 'Mutation', adminBulkApproveCpmRankingClips: { __typename?: 'CpmRankingBulkApproval', approved: Array<string>, skipped: Array<{ __typename?: 'CpmRankingBulkSkip', id: string, code: string }> } };

export type AdminBulkRejectCpmRankingClipsMutationVariables = Exact<{
  campaignId: Scalars['ID']['input'];
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
}>;


export type AdminBulkRejectCpmRankingClipsMutation = { __typename?: 'Mutation', adminBulkRejectCpmRankingClips: { __typename?: 'CpmRankingBulkRejection', rejected: Array<string>, skipped: Array<{ __typename?: 'CpmRankingBulkSkip', id: string, code: string }> } };

export type AdminResolveCpmRankingTieMutationVariables = Exact<{
  campaignId: Scalars['ID']['input'];
  participantIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  reason: Scalars['String']['input'];
}>;


export type AdminResolveCpmRankingTieMutation = { __typename?: 'Mutation', adminResolveCpmRankingTie: { __typename?: 'CpmCampaignRanking', campaign_id: string, review_fingerprint: string } };

export type AdminFinalizeCpmRankingMutationVariables = Exact<{
  campaignId: Scalars['ID']['input'];
  expectedFingerprint: Scalars['String']['input'];
}>;


export type AdminFinalizeCpmRankingMutation = { __typename?: 'Mutation', adminFinalizeCpmRanking: { __typename?: 'CpmCampaignRanking', campaign_id: string, phase: string, finalized_at?: any | null } };

export type DropboxVideoMetadataQueryVariables = Exact<{
  url: Scalars['String']['input'];
}>;


export type DropboxVideoMetadataQuery = { __typename?: 'Query', dropboxVideoMetadata: { __typename?: 'DropboxVideoMetadata', title: string, duration: number, width: number, height: number, source_size_bytes: number } };

export type StartEditOnlyLibraryMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  startSeconds: Scalars['Float']['input'];
  endSeconds?: InputMaybe<Scalars['Float']['input']>;
}>;


export type StartEditOnlyLibraryMutation = { __typename?: 'Mutation', startEditOnlyLibrary: { __typename?: 'MyLibrary', id: string, curation_status?: string | null, failure_code?: string | null, edit_only?: boolean | null } };

export type StartEditOnlyProjectMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  startSeconds: Scalars['Float']['input'];
  endSeconds?: InputMaybe<Scalars['Float']['input']>;
}>;


export type StartEditOnlyProjectMutation = { __typename?: 'Mutation', startEditOnlyProject: { __typename?: 'MyProject', id: string, curation_status?: string | null, failure_code?: string | null, edit_only?: boolean | null } };

export type FillerVideoPreviewsQueryVariables = Exact<{ [key: string]: never; }>;


export type FillerVideoPreviewsQuery = { __typename?: 'Query', fillerVideos: Array<{ __typename?: 'FillerVideo', id: string, file_url: string, file_en_url?: string | null, preview_url?: string | null, preview_en_url?: string | null, preview_duration_seconds?: number | null, preview_en_duration_seconds?: number | null }> };

export type FrameioShareVideosQueryVariables = Exact<{
  url: Scalars['String']['input'];
}>;


export type FrameioShareVideosQuery = { __typename?: 'Query', frameioShareVideos: { __typename?: 'FrameioShareVideos', share_name?: string | null, truncated: boolean, videos: Array<{ __typename?: 'FrameioShareVideo', asset_id: string, name: string, duration_seconds: number, width?: number | null, height?: number | null, thumbnail_url?: string | null, canonical_url: string }> } };

export type MediasiloReviewVideosQueryVariables = Exact<{
  url: Scalars['String']['input'];
}>;


export type MediasiloReviewVideosQuery = { __typename?: 'Query', mediasiloReviewVideos: { __typename?: 'MediasiloReviewVideos', share_name?: string | null, truncated: boolean, videos: Array<{ __typename?: 'MediasiloReviewVideo', asset_id: string, name: string, duration_seconds: number, width?: number | null, height?: number | null, thumbnail_url?: string | null, canonical_url: string }> } };

export type PublishQueueFieldsFragment = { __typename?: 'PublishQueue', id: string, name: string, weekly_slots: any, social_connection_ids: Array<string>, multi_account_mode: string, min_gap_minutes: number, timezone: string, spacing_scope: string, active: boolean };

export type MyPublishQueuesQueryVariables = Exact<{ [key: string]: never; }>;


export type MyPublishQueuesQuery = { __typename?: 'Query', myPublishQueues: Array<{ __typename?: 'PublishQueue', id: string, name: string, weekly_slots: any, social_connection_ids: Array<string>, multi_account_mode: string, min_gap_minutes: number, timezone: string, spacing_scope: string, active: boolean }> };

export type CreateMyPublishQueueMutationVariables = Exact<{
  input: PublishQueueInput;
}>;


export type CreateMyPublishQueueMutation = { __typename?: 'Mutation', createMyPublishQueue: { __typename?: 'PublishQueue', id: string, name: string, weekly_slots: any, social_connection_ids: Array<string>, multi_account_mode: string, min_gap_minutes: number, timezone: string, spacing_scope: string, active: boolean } };

export type UpdateMyPublishQueueMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: PublishQueueInput;
}>;


export type UpdateMyPublishQueueMutation = { __typename?: 'Mutation', updateMyPublishQueue: { __typename?: 'PublishQueue', id: string, name: string, weekly_slots: any, social_connection_ids: Array<string>, multi_account_mode: string, min_gap_minutes: number, timezone: string, spacing_scope: string, active: boolean } };

export type DeleteMyPublishQueueMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteMyPublishQueueMutation = { __typename?: 'Mutation', deleteMyPublishQueue: boolean };

export type EnqueueToPublishQueueMutationVariables = Exact<{
  queueId: Scalars['ID']['input'];
  clipId: Scalars['ID']['input'];
  copy: EnqueueToPublishQueueCopyInput;
}>;


export type EnqueueToPublishQueueMutation = { __typename?: 'Mutation', enqueueToPublishQueue: Array<{ __typename?: 'SocialPublish', id: string, platform: string, status: string, scheduled_at?: any | null, title?: string | null, caption?: string | null, publish_queue?: { __typename?: 'PublishQueue', id: string, name: string } | null }> };

export type QueueScheduledPublishesQueryVariables = Exact<{
  from: Scalars['DateTime']['input'];
  to: Scalars['DateTime']['input'];
}>;


export type QueueScheduledPublishesQuery = { __typename?: 'Query', myScheduledPublishes: Array<{ __typename?: 'SocialPublish', id: string, platform: string, status: string, scheduled_at?: any | null, clip_id?: string | null, clip_name?: string | null, title?: string | null, caption?: string | null, social_connection_id?: string | null, publish_queue?: { __typename?: 'PublishQueue', id: string, name: string } | null }> };

export type PublishFieldsFragment = { __typename?: 'SocialPublish', id: string, platform: string, mode: string, status: string, caption?: string | null, fail_reason?: string | null, clip_id?: string | null, social_connection_id?: string | null, title?: string | null, description?: string | null, privacy_status?: string | null, made_for_kids?: boolean | null, provider_post_id?: string | null, facebook_post_kind?: string | null, scheduled_at?: any | null, cancelled_at?: any | null, createdAt?: any | null, media_kind: string, image_count: number, publish_queue?: { __typename?: 'PublishQueue', id: string, name: string } | null };

export type MyClipPublishesQueryVariables = Exact<{
  clipIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type MyClipPublishesQuery = { __typename?: 'Query', myClipPublishes: Array<{ __typename?: 'SocialPublish', id: string, platform: string, mode: string, status: string, caption?: string | null, fail_reason?: string | null, clip_id?: string | null, social_connection_id?: string | null, title?: string | null, description?: string | null, privacy_status?: string | null, made_for_kids?: boolean | null, provider_post_id?: string | null, facebook_post_kind?: string | null, scheduled_at?: any | null, cancelled_at?: any | null, createdAt?: any | null, media_kind: string, image_count: number, publish_queue?: { __typename?: 'PublishQueue', id: string, name: string } | null }> };

export type MyConnectionPublishesQueryVariables = Exact<{
  socialConnectionId: Scalars['ID']['input'];
}>;


export type MyConnectionPublishesQuery = { __typename?: 'Query', myConnectionPublishes: Array<{ __typename?: 'SocialPublish', id: string, platform: string, mode: string, status: string, caption?: string | null, fail_reason?: string | null, clip_id?: string | null, social_connection_id?: string | null, title?: string | null, description?: string | null, privacy_status?: string | null, made_for_kids?: boolean | null, provider_post_id?: string | null, facebook_post_kind?: string | null, scheduled_at?: any | null, cancelled_at?: any | null, createdAt?: any | null, media_kind: string, image_count: number, publish_queue?: { __typename?: 'PublishQueue', id: string, name: string } | null }> };

export type TikTokCreatorInfoQueryVariables = Exact<{
  socialConnectionId: Scalars['ID']['input'];
}>;


export type TikTokCreatorInfoQuery = { __typename?: 'Query', tiktokCreatorInfo: { __typename?: 'TikTokCreatorInfo', creator_avatar_url?: string | null, creator_username?: string | null, creator_nickname?: string | null, privacy_level_options: Array<string>, comment_disabled: boolean, duet_disabled: boolean, stitch_disabled: boolean, max_video_post_duration_sec?: number | null } };

export type PublishClipToTikTokMutationVariables = Exact<{
  clipId: Scalars['ID']['input'];
  socialConnectionId: Scalars['ID']['input'];
  title?: InputMaybe<Scalars['String']['input']>;
  privacyLevel: Scalars['String']['input'];
  disableComment?: InputMaybe<Scalars['Boolean']['input']>;
  disableDuet?: InputMaybe<Scalars['Boolean']['input']>;
  disableStitch?: InputMaybe<Scalars['Boolean']['input']>;
  brandOrganicToggle?: InputMaybe<Scalars['Boolean']['input']>;
  brandContentToggle?: InputMaybe<Scalars['Boolean']['input']>;
  isAigc?: InputMaybe<Scalars['Boolean']['input']>;
  imageUrls?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type PublishClipToTikTokMutation = { __typename?: 'Mutation', publishClipToTikTok: { __typename?: 'SocialPublish', id: string, platform: string, mode: string, status: string, caption?: string | null, fail_reason?: string | null, clip_id?: string | null, social_connection_id?: string | null, title?: string | null, description?: string | null, privacy_status?: string | null, made_for_kids?: boolean | null, provider_post_id?: string | null, facebook_post_kind?: string | null, scheduled_at?: any | null, cancelled_at?: any | null, createdAt?: any | null, media_kind: string, image_count: number, publish_queue?: { __typename?: 'PublishQueue', id: string, name: string } | null } };

export type SendClipToTikTokDraftsMutationVariables = Exact<{
  clipId: Scalars['ID']['input'];
  socialConnectionId: Scalars['ID']['input'];
  caption?: InputMaybe<Scalars['String']['input']>;
}>;


export type SendClipToTikTokDraftsMutation = { __typename?: 'Mutation', sendClipToTikTokDrafts: { __typename?: 'SocialPublish', id: string, platform: string, mode: string, status: string, caption?: string | null, fail_reason?: string | null, clip_id?: string | null, social_connection_id?: string | null, title?: string | null, description?: string | null, privacy_status?: string | null, made_for_kids?: boolean | null, provider_post_id?: string | null, facebook_post_kind?: string | null, scheduled_at?: any | null, cancelled_at?: any | null, createdAt?: any | null, media_kind: string, image_count: number, publish_queue?: { __typename?: 'PublishQueue', id: string, name: string } | null } };

export type PublishClipToInstagramMutationVariables = Exact<{
  clipId: Scalars['ID']['input'];
  socialConnectionId: Scalars['ID']['input'];
  caption?: InputMaybe<Scalars['String']['input']>;
  imageUrls?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type PublishClipToInstagramMutation = { __typename?: 'Mutation', publishClipToInstagram: { __typename?: 'SocialPublish', id: string, platform: string, mode: string, status: string, caption?: string | null, fail_reason?: string | null, clip_id?: string | null, social_connection_id?: string | null, title?: string | null, description?: string | null, privacy_status?: string | null, made_for_kids?: boolean | null, provider_post_id?: string | null, facebook_post_kind?: string | null, scheduled_at?: any | null, cancelled_at?: any | null, createdAt?: any | null, media_kind: string, image_count: number, publish_queue?: { __typename?: 'PublishQueue', id: string, name: string } | null } };

export type PublishClipToFacebookMutationVariables = Exact<{
  clipId: Scalars['ID']['input'];
  socialConnectionId: Scalars['ID']['input'];
  caption?: InputMaybe<Scalars['String']['input']>;
  imageUrls?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type PublishClipToFacebookMutation = { __typename?: 'Mutation', publishClipToFacebook: { __typename?: 'SocialPublish', id: string, platform: string, mode: string, status: string, caption?: string | null, fail_reason?: string | null, clip_id?: string | null, social_connection_id?: string | null, title?: string | null, description?: string | null, privacy_status?: string | null, made_for_kids?: boolean | null, provider_post_id?: string | null, facebook_post_kind?: string | null, scheduled_at?: any | null, cancelled_at?: any | null, createdAt?: any | null, media_kind: string, image_count: number, publish_queue?: { __typename?: 'PublishQueue', id: string, name: string } | null } };

export type PublishClipToYouTubeMutationVariables = Exact<{
  clipId: Scalars['ID']['input'];
  socialConnectionId: Scalars['ID']['input'];
  title: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  privacyStatus: Scalars['String']['input'];
  madeForKids: Scalars['Boolean']['input'];
}>;


export type PublishClipToYouTubeMutation = { __typename?: 'Mutation', publishClipToYouTube: { __typename?: 'SocialPublish', id: string, platform: string, mode: string, status: string, caption?: string | null, fail_reason?: string | null, clip_id?: string | null, social_connection_id?: string | null, title?: string | null, description?: string | null, privacy_status?: string | null, made_for_kids?: boolean | null, provider_post_id?: string | null, facebook_post_kind?: string | null, scheduled_at?: any | null, cancelled_at?: any | null, createdAt?: any | null, media_kind: string, image_count: number, publish_queue?: { __typename?: 'PublishQueue', id: string, name: string } | null } };

export type UpdateMyDataMutationVariables = Exact<{
  name: Scalars['String']['input'];
  profilePicture?: InputMaybe<Media>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  targetObjective?: InputMaybe<Scalars['String']['input']>;
  objectivesWithPlatform?: InputMaybe<Scalars['String']['input']>;
  workflowDescription?: InputMaybe<Scalars['String']['input']>;
  jobTitle?: InputMaybe<Scalars['String']['input']>;
  emailMarketingOptIn?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type UpdateMyDataMutation = { __typename?: 'Mutation', updateMyData: { __typename?: 'MyData', id: string, name?: string | null, profile_picture?: string | null, phone_number?: string | null, job_title?: string | null, target_objective?: string | null, objectives_with_platform?: string | null, workflow_description?: string | null, email_marketing_opt_in: boolean } };

export type GetMyLocaleQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMyLocaleQuery = { __typename?: 'Query', myData: { __typename?: 'MyData', id: string, locale?: string | null } };

export type UpdateMyLocaleMutationVariables = Exact<{
  locale: Scalars['String']['input'];
}>;


export type UpdateMyLocaleMutation = { __typename?: 'Mutation', updateMyData: { __typename?: 'MyData', id: string, locale?: string | null } };

export type UpdateOnboardingMutationVariables = Exact<{
  onboardingObjective: Scalars['String']['input'];
  jobTitle: Scalars['String']['input'];
  onboardingExperience?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateOnboardingMutation = { __typename?: 'Mutation', updateMyData: { __typename?: 'MyData', id: string, job_title?: string | null, onboarding_objective?: string | null, onboarding_experience?: string | null } };

export type ChangeOnboardingObjectiveMutationVariables = Exact<{
  to: Scalars['String']['input'];
}>;


export type ChangeOnboardingObjectiveMutation = { __typename?: 'Mutation', changeOnboardingObjective: { __typename?: 'MyData', id: string, job_title?: string | null, onboarding_objective?: string | null, onboarding_experience?: string | null } };

export type MyDataQueryVariables = Exact<{ [key: string]: never; }>;


export type MyDataQuery = { __typename?: 'Query', myData: { __typename?: 'MyData', id: string, name?: string | null, email: string, provider?: string | null, hasPassword: boolean, googleLinked: boolean, role: string, is_admin: boolean, job_title?: string | null, phone_number?: string | null, target_objective?: string | null, objectives_with_platform?: string | null, workflow_description?: string | null, profile_picture?: string | null, affiliate?: string | null, subscription: any, createdAt: string, onboarding_objective?: string | null, onboarding_experience?: string | null, joined_community: boolean, has_challenge_participation: boolean, cpm_terms_accepted_version?: string | null, cpm_terms_accepted_at?: string | null, cpm_terms_current_version: string, email_marketing_opt_in: boolean, challenge_participation?: { __typename?: 'MyChallengeBrief', id: string, name: string, end_date?: string | null } | null, tags: Array<{ __typename?: 'MyUserTag', id: string }>, payout_data?: { __typename?: 'MyPayoutData', name: string, document: string, bank?: string | null, agency?: string | null, account?: string | null, pix_key?: string | null } | null } };

export type SetPasswordMutationVariables = Exact<{
  currentPassword?: InputMaybe<Scalars['String']['input']>;
  newPassword: Scalars['String']['input'];
}>;


export type SetPasswordMutation = { __typename?: 'Mutation', setPassword: boolean };

export type UpdateMyPayoutDataMutationVariables = Exact<{
  input: UpdateMyPayoutDataInput;
}>;


export type UpdateMyPayoutDataMutation = { __typename?: 'Mutation', updateMyPayoutData: { __typename?: 'MyPayoutData', name: string, document: string, bank?: string | null, agency?: string | null, account?: string | null, pix_key?: string | null } };

export type MarkCommunityJoinedMutationVariables = Exact<{ [key: string]: never; }>;


export type MarkCommunityJoinedMutation = { __typename?: 'Mutation', markCommunityJoined: { __typename?: 'MyData', id: string, joined_community: boolean } };

export type AcceptCpmTermsMutationVariables = Exact<{
  version: Scalars['String']['input'];
}>;


export type AcceptCpmTermsMutation = { __typename?: 'Mutation', acceptCpmTerms: { __typename?: 'MyData', id: string, cpm_terms_accepted_version?: string | null, cpm_terms_accepted_at?: string | null, cpm_terms_current_version: string } };

export type MyProjectsQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type MyProjectsQuery = { __typename?: 'Query', myProjects: Array<{ __typename?: 'MyProject', id: string, name?: string | null, curation_status?: string | null, favorite?: boolean | null, public?: boolean | null, format: string, language: string, audio_language?: string | null, audio_track?: string | null, translation_status?: string | null, prompt?: string | null, processing_mode?: string | null, eta_seconds?: number | null, base_video_url?: string | null, compressed_base_video_url?: string | null, cut_video_url?: string | null, created_by_user?: any | null, compressed_cut_video_url?: string | null, thumbnail_url?: string | null, news_pdf_mirror_url?: string | null, duration_seconds?: number | null, clips_count?: number | null, filesize?: number | null, start_time?: number | null, end_time?: number | null, createdAt: string }> };

export type MyProjectQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type MyProjectQuery = { __typename?: 'Query', myProject?: { __typename?: 'MyProject', id: string, name?: string | null, curation_status?: string | null, source_status?: string | null, failure_code?: string | null, curation_rating?: string | null, favorite?: boolean | null, public?: boolean | null, format: string, language: string, audio_language?: string | null, audio_track?: string | null, translation_status?: string | null, prompt?: string | null, processing_mode?: string | null, eta_seconds?: number | null, base_video_url?: string | null, compressed_base_video_url?: string | null, cut_video_url?: string | null, thumbnail_url?: string | null, compressed_cut_video_url?: string | null, news_pdf_mirror_url?: string | null, speaker_layout?: number | null, post_layout?: any | null, subtitle_config?: any | null, watermark_position?: any | null, default_subtitles_enabled?: boolean | null, scene_detection?: any | null, scene_detection_url?: string | null, video_signals_url?: string | null, content_type?: string | null, content_type_confidence?: number | null, duration_seconds?: number | null, clips_count?: number | null, filesize?: number | null, start_time?: number | null, end_time?: number | null, curated_clips?: any | null, transcription?: any | null, transcription_url?: string | null, original_transcription_url?: string | null, createdAt: string, clips?: Array<{ __typename?: 'ProjectClip', id: string, name?: string | null, duration_seconds?: number | null, clip_start_time?: number | null, clip_end_time?: number | null, original_clip_start_time?: number | null, original_clip_end_time?: number | null, clip_score?: number | null, clip_order?: number | null, clip_summary?: string | null, clip_thumbnail?: string | null, curation_rating?: string | null, dirty?: boolean | null, clipping_status?: string | null, rendering_status?: string | null, thumbnail_url?: string | null, finished_video_url?: string | null, finished_video_thumbnail_url?: string | null, data?: any | null }> | null, brand_kit?: { __typename?: 'MyProjectBrandKit', id: string, name: string } | null } | null };

export type MyLibrariesQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  tagIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  channelId?: InputMaybe<Scalars['ID']['input']>;
  channelCategory?: InputMaybe<Scalars['String']['input']>;
}>;


export type MyLibrariesQuery = { __typename?: 'Query', myLibraries: Array<{ __typename?: 'MyLibrary', id: string, name?: string | null, curation_status?: string | null, favorite?: boolean | null, public?: boolean | null, format: string, language: string, audio_language?: string | null, audio_track?: string | null, translation_status?: string | null, prompt?: string | null, processing_mode?: string | null, eta_seconds?: number | null, created_by_user?: string | null, created_by_user_name?: string | null, base_video_url?: string | null, compressed_base_video_url?: string | null, original_video_url?: string | null, cut_video_url?: string | null, compressed_cut_video_url?: string | null, thumbnail_url?: string | null, duration_seconds?: number | null, clips_count?: number | null, filesize?: number | null, start_time?: number | null, end_time?: number | null, source_library_id?: string | null, youtube_video_id?: string | null, view_count?: string | null, upload_date?: string | null, createdAt: string, tags: Array<{ __typename?: 'MyLibraryTag', id: string, name: string, color?: string | null }>, youtube_channels: Array<{ __typename?: 'MyYoutubeChannel', id: string, channel_id: string, name: string, url?: string | null, thumbnail?: string | null, handle?: string | null, subscriber_count?: number | null, category?: string | null }> }> };

export type MyLibrariesCountsQueryVariables = Exact<{ [key: string]: never; }>;


export type MyLibrariesCountsQuery = { __typename?: 'Query', myLibrariesCounts: { __typename?: 'MyLibrariesCounts', mine: number, community: number } };

export type CommunityLibrariesQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  channelId?: InputMaybe<Scalars['ID']['input']>;
  channelCategory?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  tagId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type CommunityLibrariesQuery = { __typename?: 'Query', communityLibraries: Array<{ __typename?: 'MyLibrary', id: string, name?: string | null, curation_status?: string | null, format: string, language: string, processing_mode?: string | null, created_by_user?: string | null, created_by_user_name?: string | null, base_video_url?: string | null, compressed_base_video_url?: string | null, original_video_url?: string | null, cut_video_url?: string | null, thumbnail_url?: string | null, duration_seconds?: number | null, start_time?: number | null, end_time?: number | null, source_library_id?: string | null, youtube_video_id?: string | null, remix_count?: number | null, view_count?: string | null, upload_date?: string | null, createdAt: string, youtube_channels: Array<{ __typename?: 'MyYoutubeChannel', id: string, channel_id: string, name: string, url?: string | null, thumbnail?: string | null, handle?: string | null, subscriber_count?: number | null, category?: string | null }> }> };

export type CheckCommunityLibraryByUrlQueryVariables = Exact<{
  url: Scalars['String']['input'];
}>;


export type CheckCommunityLibraryByUrlQuery = { __typename?: 'Query', checkCommunityLibraryByUrl?: { __typename?: 'MyLibrary', id: string, name?: string | null, base_video_url?: string | null, duration_seconds?: number | null, format: string, language: string, start_time?: number | null, end_time?: number | null, active_cpm_campaigns: Array<{ __typename?: 'MyCpmCampaign', id: string }>, youtube_channels: Array<{ __typename?: 'MyYoutubeChannel', channel_id: string }> } | null };

export type CommunityTagsQueryVariables = Exact<{
  channelId?: InputMaybe<Scalars['ID']['input']>;
  channelCategory?: InputMaybe<Scalars['String']['input']>;
}>;


export type CommunityTagsQuery = { __typename?: 'Query', communityTags: Array<{ __typename?: 'MyLibraryTag', id: string, name: string, color?: string | null, download_count?: number | null }> };

export type CommunityChannelsQueryVariables = Exact<{
  category?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
}>;


export type CommunityChannelsQuery = { __typename?: 'Query', communityChannels: Array<{ __typename?: 'MyYoutubeChannel', id: string, channel_id: string, name: string, url?: string | null, thumbnail?: string | null, handle?: string | null, subscriber_count?: number | null, category?: string | null, is_autoclipper_partner?: boolean | null, remix_count?: number | null }> };

export type CreateMyLibraryMutationVariables = Exact<{
  input: MyLibraryCreateInput;
}>;


export type CreateMyLibraryMutation = { __typename?: 'Mutation', createMyLibrary: { __typename?: 'MyLibrary', id: string, name?: string | null, curation_status?: string | null, favorite?: boolean | null, public?: boolean | null, format: string, language: string, prompt?: string | null, processing_mode?: string | null, remove_silence?: boolean | null, eta_seconds?: number | null, created_by_user?: string | null, cut_video_url?: string | null, compressed_cut_video_url?: string | null, thumbnail_url?: string | null, duration_seconds?: number | null, clips_count?: number | null, filesize?: number | null, start_time?: number | null, end_time?: number | null, createdAt: string, tags: Array<{ __typename?: 'MyLibraryTag', id: string, name: string, color?: string | null }>, youtube_channels: Array<{ __typename?: 'MyYoutubeChannel', id: string, channel_id: string, name: string, url?: string | null, thumbnail?: string | null, handle?: string | null, subscriber_count?: number | null, category?: string | null }> } };

export type DeleteMyLibraryMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteMyLibraryMutation = { __typename?: 'Mutation', deleteMyLibrary: { __typename?: 'MyLibrary', id: string } };

export type MyClipsQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type MyClipsQuery = { __typename?: 'Query', myClips: Array<{ __typename?: 'MyClip', id: string, name?: string | null, can_edit?: boolean | null, eta_seconds?: number | null, duration_seconds: number, clip_score?: number | null, clip_order?: number | null, dirty?: boolean | null, clipping_status: string, preparing_status: string, rendering_status?: string | null, clipped_video_url?: string | null, thumbnail_url?: string | null, created_by_user?: any | null, compressed_video_url?: string | null, finished_video_url?: string | null, finished_video_thumbnail_url?: string | null, is_library_clip?: boolean | null, project_id?: string | null, library_id?: string | null, source_clip_id?: string | null, version_number?: number | null, curation_rating?: string | null, cover_image_url?: string | null, can_set_cover?: boolean | null, createdAt: string }> };

export type MyClipQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type MyClipQuery = { __typename?: 'Query', myClip?: { __typename?: 'MyClip', id: string, name?: string | null, can_edit?: boolean | null, eta_seconds?: number | null, duration_seconds: number, clip_score?: number | null, clip_order?: number | null, clip_start_time?: number | null, clip_end_time?: number | null, original_clip_start_time?: number | null, original_clip_end_time?: number | null, clip_summary?: string | null, clip_thumbnail?: string | null, clipping_status: string, preparing_status: string, rendering_status?: string | null, clipped_video_url?: string | null, thumbnail_url?: string | null, created_by_user?: any | null, compressed_video_url?: string | null, finished_video_url?: string | null, finished_video_thumbnail_url?: string | null, curation_rating?: string | null, cover_image_url?: string | null, can_set_cover?: boolean | null, dirty?: boolean | null, data?: any | null, is_library_clip?: boolean | null, project_id?: string | null, library_id?: string | null, source_clip_id?: string | null, version_number?: number | null, createdAt: string, copy?: { __typename?: 'MyCopyGeneration', id: string, processing_status: string, result?: any | null, createdAt: string, updatedAt: string } | null } | null };

export type PlansQueryVariables = Exact<{ [key: string]: never; }>;


export type PlansQuery = { __typename?: 'Query', plans: Array<{ __typename?: 'Plan', documentId: string, name?: string | null, slug?: string | null, value?: number | null, value_yearly?: number | null, value_usd?: number | null, value_yearly_usd?: number | null, processing_seconds?: any | null, description_items?: any | null, max_clips?: number | null, max_library_curations?: number | null, max_library_exports?: number | null, max_library_video_seconds?: number | null, max_brand_kits?: number | null, payment_link?: string | null, payment_link_yearly?: string | null, discount_label?: string | null, max_expiry_days?: number | null, color?: string | null, order?: number | null }> };

export type PlanQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type PlanQuery = { __typename?: 'Query', plan?: { __typename?: 'Plan', documentId: string, name?: string | null, slug?: string | null, value?: number | null, value_yearly?: number | null, value_usd?: number | null, value_yearly_usd?: number | null, processing_seconds?: any | null, description_items?: any | null, max_clips?: number | null, payment_link?: string | null, payment_link_yearly?: string | null, discount_label?: string | null, color?: string | null, order?: number | null } | null };

export type MyApiKeysQueryVariables = Exact<{ [key: string]: never; }>;


export type MyApiKeysQuery = { __typename?: 'Query', myAPIKeys: Array<{ __typename?: 'MyAPIKey', id: string, name: string, key: string, createdAt: string }> };

export type CreateMyApiKeyMutationVariables = Exact<{
  input: MyApiKeyCreateInput;
}>;


export type CreateMyApiKeyMutation = { __typename?: 'Mutation', createMyAPIKey: { __typename?: 'MyAPIKey', id: string, name: string, key: string, createdAt: string, updatedAt: string } };

export type UpdateMyApiKeyMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: MyApiKeyUpdateInput;
}>;


export type UpdateMyApiKeyMutation = { __typename?: 'Mutation', updateMyAPIKey: { __typename?: 'MyAPIKey', id: string, name: string, key: string, createdAt: string, updatedAt: string } };

export type DeleteMyApiKeyMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteMyApiKeyMutation = { __typename?: 'Mutation', deleteMyAPIKey: { __typename?: 'MyAPIKey', id: string, name: string, key: string, createdAt: string, updatedAt: string } };

export type MyApiRequestsQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type MyApiRequestsQuery = { __typename?: 'Query', myAPIRequests: Array<{ __typename?: 'MyAPIRequest', id: string, name: string, process_status: string, base_video_url: string, webhook_url?: string | null, thumbnail_url?: string | null, api_key_name?: string | null, createdAt: string, clips: Array<{ __typename?: 'MyAPIRequestClip', id: string, name?: string | null, rendered_video_url?: string | null }> }> };

export type RetriggerMyApiRequestWebhookMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type RetriggerMyApiRequestWebhookMutation = { __typename?: 'Mutation', retriggerMyAPIRequestWebhook: { __typename?: 'OKResponse', success: boolean } };

export type CreateMyProjectMutationVariables = Exact<{
  input: MyProjectCreateInput;
}>;


export type CreateMyProjectMutation = { __typename?: 'Mutation', createMyProject: { __typename?: 'MyProject', id: string, name?: string | null, curation_status?: string | null, favorite?: boolean | null, public?: boolean | null, format: string, language: string, prompt?: string | null, processing_mode?: string | null, remove_silence?: boolean | null, eta_seconds?: number | null, base_video_url?: string | null, compressed_base_video_url?: string | null, cut_video_url?: string | null, created_by_user?: any | null, compressed_cut_video_url?: string | null, thumbnail_url?: string | null, duration_seconds?: number | null, filesize?: number | null, start_time?: number | null, end_time?: number | null, createdAt: string } };

export type DeleteMyProjectMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteMyProjectMutation = { __typename?: 'Mutation', deleteMyProject: { __typename?: 'MyProject', id: string } };

export type UpdateMyProjectMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: MyProjectUpdateInput;
}>;


export type UpdateMyProjectMutation = { __typename?: 'Mutation', updateMyProject: { __typename?: 'MyProject', id: string, name?: string | null, curation_rating?: string | null, transcription_url?: string | null, speaker_layout?: number | null, post_layout?: any | null, subtitle_config?: any | null, watermark_position?: any | null, brand_kit?: { __typename?: 'MyProjectBrandKit', id: string, name: string } | null } };

export type ClipProjectMutationVariables = Exact<{
  input: ClipProjectInput;
}>;


export type ClipProjectMutation = { __typename?: 'Mutation', clipProject: { __typename?: 'MyClip', id: string, name?: string | null, can_edit?: boolean | null, eta_seconds?: number | null, duration_seconds: number, clipping_status: string, preparing_status: string, rendering_status?: string | null, clipped_video_url?: string | null, created_by_user?: any | null, compressed_video_url?: string | null, finished_video_url?: string | null, createdAt: string } };

export type ActivateClipMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: ActivateClipInput;
}>;


export type ActivateClipMutation = { __typename?: 'Mutation', activateClip: { __typename?: 'MyClip', id: string, name?: string | null, can_edit?: boolean | null, eta_seconds?: number | null, duration_seconds: number, clipping_status: string, preparing_status: string, rendering_status?: string | null, clipped_video_url?: string | null, created_by_user?: any | null, compressed_video_url?: string | null, finished_video_url?: string | null, createdAt: string } };

export type CreateClipTitlesMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type CreateClipTitlesMutation = { __typename?: 'Mutation', createCopies: { __typename?: 'MyClip', id: string, copy?: { __typename?: 'MyCopyGeneration', id: string, processing_status: string, result?: any | null, createdAt: string, updatedAt: string } | null } };

export type AcceptInvitationMutationVariables = Exact<{
  token: Scalars['String']['input'];
}>;


export type AcceptInvitationMutation = { __typename?: 'Mutation', acceptInvitation: { __typename?: 'MyData', id: string, name?: string | null, email: string, subscription: any, createdAt: string } };

export type LeaveTeamMutationVariables = Exact<{ [key: string]: never; }>;


export type LeaveTeamMutation = { __typename?: 'Mutation', leaveTeam: { __typename?: 'MyData', id: string, name?: string | null, email: string, subscription: any, createdAt: string } };

export type RemoveTeamAccessMutationVariables = Exact<{
  email: Scalars['String']['input'];
}>;


export type RemoveTeamAccessMutation = { __typename?: 'Mutation', removeTeamAccess: { __typename?: 'MyData', id: string, name?: string | null, email: string, job_title?: string | null, profile_picture?: string | null, affiliate?: string | null, subscription: any, createdAt: string } };

export type UpdateTeamRoleMutationVariables = Exact<{
  email: Scalars['String']['input'];
  role: Scalars['String']['input'];
}>;


export type UpdateTeamRoleMutation = { __typename?: 'Mutation', updateTeamRole: { __typename?: 'MyData', id: string, name?: string | null, email: string, subscription: any, createdAt: string } };

export type RefreshInvitationTokenMutationVariables = Exact<{ [key: string]: never; }>;


export type RefreshInvitationTokenMutation = { __typename?: 'Mutation', refreshInvitationToken: { __typename?: 'MyData', id: string, name?: string | null, email: string, subscription: any, createdAt: string } };

export type RenderClipMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: Scalars['JSON']['input'];
}>;


export type RenderClipMutation = { __typename?: 'Mutation', renderClip: { __typename?: 'MyClip', id: string, name?: string | null, duration_seconds: number, clipping_status: string, preparing_status: string, rendering_status?: string | null, clipped_video_url?: string | null, compressed_video_url?: string | null, finished_video_url?: string | null, createdAt: string } };

export type RenderLibraryClipMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: Scalars['JSON']['input'];
}>;


export type RenderLibraryClipMutation = { __typename?: 'Mutation', renderLibraryClip: { __typename?: 'MyClip', id: string, name?: string | null, duration_seconds: number, clipping_status: string, preparing_status: string, rendering_status?: string | null, clipped_video_url?: string | null, compressed_video_url?: string | null, finished_video_url?: string | null, source_clip_id?: string | null, version_number?: number | null, createdAt: string } };

export type PrepareClipMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type PrepareClipMutation = { __typename?: 'Mutation', prepareClip: { __typename?: 'MyClip', id: string, name?: string | null, duration_seconds: number, clipping_status: string, preparing_status: string, rendering_status?: string | null, clipped_video_url?: string | null, compressed_video_url?: string | null, finished_video_url?: string | null, createdAt: string } };

export type SetCancellationReasonMutationVariables = Exact<{
  reason: Scalars['String']['input'];
  feedback: Scalars['String']['input'];
}>;


export type SetCancellationReasonMutation = { __typename?: 'Mutation', setCancellationReason: { __typename?: 'OKResponse', success: boolean } };

export type MyFontsQueryVariables = Exact<{ [key: string]: never; }>;


export type MyFontsQuery = { __typename?: 'Query', myFonts: Array<{ __typename?: 'Font', id: string, name: string, family: string, file_url: string, preview_black_url?: string | null, preview_white_url?: string | null, createdAt: string, updatedAt: string }> };

export type MyBrandKitsQueryVariables = Exact<{ [key: string]: never; }>;


export type MyBrandKitsQuery = { __typename?: 'Query', myBrandKits: Array<{ __typename?: 'MyBrandKit', id: string, name: string, is_default: boolean, is_public: boolean, preview_video_url?: string | null, preview_poster_url?: string | null, createdAt: string, updatedAt: string, data: { __typename?: 'BrandKitData', colors: Array<string>, post_layout?: any | null, logo?: { __typename?: 'BrandKitLogoSettings', logo_horizontal_margin: number, logo_vertical_margin: number, logo_image_url?: string | null, logo_opacity: number, logo_position: string, logo_size: number } | null, title_font: { __typename?: 'BrandKitFontSettings', font_id: string, font_size: number }, body_font: { __typename?: 'BrandKitFontSettings', font_id: string, font_size: number }, subtitle: { __typename?: 'BrandKitSubtitleSettings', subtitle_color: string, subtitle_font_id: string, text_align?: string | null, subtitle_font_size: number, subtitle_highlight_color?: string | null, subtitle_highlight_enabled: boolean, highlight_box_enabled?: boolean | null, highlight_box_background_color?: string | null, highlight_box_border_radius?: number | null, highlight_box_padding_x?: number | null, highlight_box_padding_y?: number | null, vertical_margin_percentage: number, align_items: string, animation: string, background_color: string, background_enabled: boolean, background_height: number, background_opacity: number, background_width: number, horizontal_margin_percentage: number, justify_content: string, max_words_per_line: number, shadow_color: string, shadow_enabled: boolean, shadow_size: number, stroke_enabled?: boolean | null, stroke_color?: string | null, stroke_width?: number | null, shadow_style?: string | null, shadow_offset_x?: number | null, shadow_offset_y?: number | null, shadow_spread?: number | null } } }> };

export type MyBrandKitQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type MyBrandKitQuery = { __typename?: 'Query', myBrandKit?: { __typename?: 'MyBrandKit', id: string, name: string, is_default: boolean, is_public: boolean, createdAt: string, updatedAt: string, data: { __typename?: 'BrandKitData', colors: Array<string>, post_layout?: any | null, logo?: { __typename?: 'BrandKitLogoSettings', logo_horizontal_margin: number, logo_vertical_margin: number, logo_image_url?: string | null, logo_opacity: number, logo_position: string, logo_size: number } | null, title_font: { __typename?: 'BrandKitFontSettings', font_id: string, font_size: number }, body_font: { __typename?: 'BrandKitFontSettings', font_id: string, font_size: number }, subtitle: { __typename?: 'BrandKitSubtitleSettings', subtitle_color: string, subtitle_font_id: string, text_align?: string | null, subtitle_font_size: number, subtitle_highlight_color?: string | null, subtitle_highlight_enabled: boolean, highlight_box_enabled?: boolean | null, highlight_box_background_color?: string | null, highlight_box_border_radius?: number | null, highlight_box_padding_x?: number | null, highlight_box_padding_y?: number | null, vertical_margin_percentage: number, align_items: string, animation: string, background_color: string, background_enabled: boolean, background_height: number, background_opacity: number, background_width: number, horizontal_margin_percentage: number, justify_content: string, max_words_per_line: number, shadow_color: string, shadow_enabled: boolean, shadow_size: number, stroke_enabled?: boolean | null, stroke_color?: string | null, stroke_width?: number | null, shadow_style?: string | null, shadow_offset_x?: number | null, shadow_offset_y?: number | null, shadow_spread?: number | null } } } | null };

export type CreateMyBrandKitMutationVariables = Exact<{
  input: MyBrandKitCreateInput;
}>;


export type CreateMyBrandKitMutation = { __typename?: 'Mutation', createMyBrandKit: { __typename?: 'MyBrandKit', id: string, name: string, is_default: boolean, is_public: boolean, createdAt: string, updatedAt: string, data: { __typename?: 'BrandKitData', colors: Array<string>, post_layout?: any | null, logo?: { __typename?: 'BrandKitLogoSettings', logo_horizontal_margin: number, logo_vertical_margin: number, logo_image_url?: string | null, logo_opacity: number, logo_position: string, logo_size: number } | null, title_font: { __typename?: 'BrandKitFontSettings', font_id: string, font_size: number }, body_font: { __typename?: 'BrandKitFontSettings', font_id: string, font_size: number }, subtitle: { __typename?: 'BrandKitSubtitleSettings', subtitle_color: string, subtitle_font_id: string, text_align?: string | null, subtitle_font_size: number, subtitle_highlight_color?: string | null, subtitle_highlight_enabled: boolean, highlight_box_enabled?: boolean | null, highlight_box_background_color?: string | null, highlight_box_border_radius?: number | null, highlight_box_padding_x?: number | null, highlight_box_padding_y?: number | null, vertical_margin_percentage: number, align_items: string, animation: string, background_color: string, background_enabled: boolean, background_height: number, background_opacity: number, background_width: number, horizontal_margin_percentage: number, justify_content: string, max_words_per_line: number, shadow_color: string, shadow_enabled: boolean, shadow_size: number, stroke_enabled?: boolean | null, stroke_color?: string | null, stroke_width?: number | null, shadow_style?: string | null, shadow_offset_x?: number | null, shadow_offset_y?: number | null, shadow_spread?: number | null } } } };

export type UpdateMyBrandKitMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: MyBrandKitUpdateInput;
}>;


export type UpdateMyBrandKitMutation = { __typename?: 'Mutation', updateMyBrandKit: { __typename?: 'MyBrandKit', id: string, name: string, is_default: boolean, createdAt: string, updatedAt: string, data: { __typename?: 'BrandKitData', colors: Array<string>, post_layout?: any | null, logo?: { __typename?: 'BrandKitLogoSettings', logo_horizontal_margin: number, logo_vertical_margin: number, logo_image_url?: string | null, logo_opacity: number, logo_position: string, logo_size: number } | null, title_font: { __typename?: 'BrandKitFontSettings', font_id: string, font_size: number }, body_font: { __typename?: 'BrandKitFontSettings', font_id: string, font_size: number }, subtitle: { __typename?: 'BrandKitSubtitleSettings', subtitle_color: string, subtitle_font_id: string, text_align?: string | null, subtitle_font_size: number, subtitle_highlight_color?: string | null, subtitle_highlight_enabled: boolean, highlight_box_enabled?: boolean | null, highlight_box_background_color?: string | null, highlight_box_border_radius?: number | null, highlight_box_padding_x?: number | null, highlight_box_padding_y?: number | null, vertical_margin_percentage: number, align_items: string, animation: string, background_color: string, background_enabled: boolean, background_height: number, background_opacity: number, background_width: number, horizontal_margin_percentage: number, justify_content: string, max_words_per_line: number, shadow_color: string, shadow_enabled: boolean, shadow_size: number, stroke_enabled?: boolean | null, stroke_color?: string | null, stroke_width?: number | null, shadow_style?: string | null, shadow_offset_x?: number | null, shadow_offset_y?: number | null, shadow_spread?: number | null } } } };

export type DeleteMyBrandKitMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteMyBrandKitMutation = { __typename?: 'Mutation', deleteMyBrandKit: { __typename?: 'MyBrandKit', id: string, name: string, createdAt: string, updatedAt: string } };

export type AdminCreateBrandKitMutationVariables = Exact<{
  input: MyBrandKitCreateInput;
}>;


export type AdminCreateBrandKitMutation = { __typename?: 'Mutation', adminCreateBrandKit: { __typename?: 'MyBrandKit', id: string, name: string, is_default: boolean, is_public: boolean, createdAt: string, updatedAt: string, data: { __typename?: 'BrandKitData', colors: Array<string>, post_layout?: any | null, logo?: { __typename?: 'BrandKitLogoSettings', logo_horizontal_margin: number, logo_vertical_margin: number, logo_image_url?: string | null, logo_opacity: number, logo_position: string, logo_size: number } | null, title_font: { __typename?: 'BrandKitFontSettings', font_id: string, font_size: number }, body_font: { __typename?: 'BrandKitFontSettings', font_id: string, font_size: number }, subtitle: { __typename?: 'BrandKitSubtitleSettings', subtitle_color: string, subtitle_font_id: string, text_align?: string | null, subtitle_font_size: number, subtitle_highlight_color?: string | null, subtitle_highlight_enabled: boolean, highlight_box_enabled?: boolean | null, highlight_box_background_color?: string | null, highlight_box_border_radius?: number | null, highlight_box_padding_x?: number | null, highlight_box_padding_y?: number | null, vertical_margin_percentage: number, align_items: string, animation: string, background_color: string, background_enabled: boolean, background_height: number, background_opacity: number, background_width: number, horizontal_margin_percentage: number, justify_content: string, max_words_per_line: number, shadow_color: string, shadow_enabled: boolean, shadow_size: number, stroke_enabled?: boolean | null, stroke_color?: string | null, stroke_width?: number | null, shadow_style?: string | null, shadow_offset_x?: number | null, shadow_offset_y?: number | null, shadow_spread?: number | null } } } };

export type RateClipMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  rating: Scalars['String']['input'];
}>;


export type RateClipMutation = { __typename?: 'Mutation', rateClip: { __typename?: 'RateClipResponse', id: string, curation_rating?: string | null } };

export type UpdateClipDataMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  data: Scalars['JSON']['input'];
}>;


export type UpdateClipDataMutation = { __typename?: 'Mutation', updateClipData: { __typename?: 'MyClip', id: string, data?: any | null, dirty?: boolean | null } };

export type AddUserTagMutationVariables = Exact<{
  name: Scalars['String']['input'];
}>;


export type AddUserTagMutation = { __typename?: 'Mutation', addUserTag?: { __typename?: 'MyUserTag', id: string } | null };

export type ValidateCouponQueryVariables = Exact<{
  code: Scalars['String']['input'];
  planId: Scalars['ID']['input'];
  recurrency: Scalars['String']['input'];
}>;


export type ValidateCouponQuery = { __typename?: 'Query', validateCoupon: { __typename?: 'CouponValidation', error?: string | null, valid: boolean, coupon?: { __typename?: 'CouponValidationData', id: string, code: string, cycles?: number | null, discount: number, expiry_date?: string | null } | null } };

export type MyClipsByProjectIdQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  project_id: Scalars['ID']['input'];
  sort?: InputMaybe<Scalars['String']['input']>;
}>;


export type MyClipsByProjectIdQuery = { __typename?: 'Query', myClips: Array<{ __typename?: 'MyClip', id: string, name?: string | null, can_edit?: boolean | null, eta_seconds?: number | null, duration_seconds: number, clip_score?: number | null, clip_order?: number | null, dirty?: boolean | null, clipping_status: string, preparing_status: string, rendering_status?: string | null, clipped_video_url?: string | null, thumbnail_url?: string | null, created_by_user?: any | null, compressed_video_url?: string | null, finished_video_url?: string | null, finished_video_thumbnail_url?: string | null, curation_rating?: string | null, data?: any | null, source_clip_id?: string | null, version_number?: number | null, createdAt: string }> };

export type RenderProjectClipV2MutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: Scalars['JSON']['input'];
}>;


export type RenderProjectClipV2Mutation = { __typename?: 'Mutation', renderProjectClipV2: { __typename?: 'MyClip', id: string, name?: string | null, duration_seconds: number, clipping_status: string, preparing_status: string, rendering_status?: string | null, clipped_video_url?: string | null, compressed_video_url?: string | null, finished_video_url?: string | null, source_clip_id?: string | null, version_number?: number | null, createdAt: string } };

export type MyLibraryQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type MyLibraryQuery = { __typename?: 'Query', myLibrary?: { __typename?: 'MyLibrary', id: string, name?: string | null, curation_status?: string | null, source_status?: string | null, failure_code?: string | null, curation_rating?: string | null, favorite?: boolean | null, public?: boolean | null, format: string, language: string, audio_language?: string | null, audio_track?: string | null, translation_status?: string | null, prompt?: string | null, processing_mode?: string | null, eta_seconds?: number | null, created_by_user?: string | null, created_by_user_name?: string | null, base_video_url?: string | null, compressed_base_video_url?: string | null, cut_video_url?: string | null, compressed_cut_video_url?: string | null, thumbnail_url?: string | null, duration_seconds?: number | null, clips_count?: number | null, filesize?: number | null, start_time?: number | null, end_time?: number | null, scene_detection?: any | null, scene_detection_url?: string | null, curated_clips?: any | null, speaker_layout?: number | null, post_layout?: any | null, subtitle_config?: any | null, watermark_position?: any | null, default_subtitles_enabled?: boolean | null, transcription?: any | null, transcription_url?: string | null, original_transcription_url?: string | null, createdAt: string, clips?: Array<{ __typename?: 'ProjectClip', id: string, name?: string | null, duration_seconds?: number | null, clip_start_time?: number | null, clip_end_time?: number | null, original_clip_start_time?: number | null, original_clip_end_time?: number | null, clip_score?: number | null, clip_order?: number | null, clip_summary?: string | null, clip_thumbnail?: string | null, curation_rating?: string | null, dirty?: boolean | null, clipping_status?: string | null, rendering_status?: string | null, thumbnail_url?: string | null, finished_video_url?: string | null, finished_video_thumbnail_url?: string | null, data?: any | null }> | null, brand_kit?: { __typename?: 'MyProjectBrandKit', id: string, name: string } | null, youtube_channels: Array<{ __typename?: 'MyYoutubeChannel', id: string, channel_id: string, name: string, url?: string | null, thumbnail?: string | null, handle?: string | null, subscriber_count?: number | null, category?: string | null }> } | null };

export type MyClipsByLibraryIdQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  library_id: Scalars['ID']['input'];
  sort?: InputMaybe<Scalars['String']['input']>;
}>;


export type MyClipsByLibraryIdQuery = { __typename?: 'Query', myClips: Array<{ __typename?: 'MyClip', id: string, name?: string | null, can_edit?: boolean | null, eta_seconds?: number | null, duration_seconds: number, clip_score?: number | null, clip_order?: number | null, clip_start_time?: number | null, clip_end_time?: number | null, dirty?: boolean | null, clipping_status: string, preparing_status: string, rendering_status?: string | null, clipped_video_url?: string | null, thumbnail_url?: string | null, created_by_user?: any | null, compressed_video_url?: string | null, finished_video_url?: string | null, finished_video_thumbnail_url?: string | null, curation_rating?: string | null, data?: any | null, source_clip_id?: string | null, version_number?: number | null, createdAt: string }> };

export type DeleteMyClipMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteMyClipMutation = { __typename?: 'Mutation', deleteMyClip: { __typename?: 'MyClip', id: string } };

export type AdminUserQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type AdminUserQuery = { __typename?: 'Query', adminUser?: { __typename?: 'AdminUser', id: string, name?: string | null, email: string, phone_number?: string | null, job_title?: string | null, is_admin?: boolean | null, provider?: string | null, confirmed: boolean, blocked: boolean, onboarding_objective?: string | null, profile_picture?: string | null, createdAt: string, updatedAt: string, account_reliabilities: Array<{ __typename?: 'CpmAccountReliability', platform?: string | null, status: CpmAccountReliabilityStatus, score?: number | null, engagement_rate?: number | null, lifetime_views?: string | null, tracked_content?: number | null, username?: string | null }>, subscription?: { __typename?: 'AdminSubscription', id: string, current_month_processing_seconds?: number | null, current_month_clips?: number | null, current_month_library_video_seconds?: number | null, current_month_library_exports?: number | null, current_month_library_curations?: number | null, extra_clips?: number | null, extra_seconds?: number | null, payment_provider?: string | null, payment_recurrency?: string | null, next_payment_at?: string | null, cancellation_at?: string | null, payment_count?: number | null, total_payment_value?: number | null, original_price?: number | null, discounted_price?: number | null, discount_amount?: number | null, createdAt: string, updatedAt: string, active_coupon?: { __typename?: 'AdminActiveCoupon', id: string, code: string, type: string, month_discount?: number | null, year_discount?: number | null, month_cycles?: number | null, year_cycles?: number | null } | null, plan?: { __typename?: 'AdminPlan', id: string, name: string, slug: string, value?: number | null, processing_seconds?: number | null, max_clips?: number | null, max_users?: number | null, max_library_video_seconds?: number | null, max_library_exports?: number | null, max_library_curations?: number | null } | null } | null } | null };

export type AdminUsersQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  phone_number?: InputMaybe<Scalars['String']['input']>;
  plan_slug?: InputMaybe<Scalars['String']['input']>;
  is_partner?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type AdminUsersQuery = { __typename?: 'Query', adminUsers: { __typename?: 'AdminUsersResponse', page: number, pageSize: number, pageCount: number, total: number, data: Array<{ __typename?: 'AdminUser', id: string, name?: string | null, email: string, phone_number?: string | null, job_title?: string | null, is_admin?: boolean | null, blocked: boolean, confirmed: boolean, provider?: string | null, onboarding_objective?: string | null, utm_source?: string | null, utm_medium?: string | null, utm_campaign?: string | null, utm_term?: string | null, utm_content?: string | null, affiliate_rate_payment?: number | null, affiliate_rate_course?: number | null, affiliate_rate_cpm?: number | null, affiliate_rate_note?: string | null, cpm_leaderboard_excluded?: boolean | null, cpm_leaderboard_excluded_reason?: string | null, createdAt: string, updatedAt: string, account_reliabilities: Array<{ __typename?: 'CpmAccountReliability', platform?: string | null, status: CpmAccountReliabilityStatus, score?: number | null, engagement_rate?: number | null, lifetime_views?: string | null, tracked_content?: number | null, username?: string | null }>, subscription?: { __typename?: 'AdminSubscription', id: string, current_month_processing_seconds?: number | null, current_month_clips?: number | null, current_month_library_video_seconds?: number | null, current_month_library_exports?: number | null, current_month_library_curations?: number | null, extra_clips?: number | null, is_partner?: boolean | null, partner_expires_at?: string | null, partner_note?: string | null, ai_assistant_granted?: boolean | null, facebook_connections_granted?: boolean | null, extra_seconds?: number | null, payment_count?: number | null, total_payment_value?: number | null, plan?: { __typename?: 'AdminPlan', id: string, name: string, slug: string, processing_seconds?: number | null, max_clips?: number | null, max_library_video_seconds?: number | null, max_library_exports?: number | null, max_library_curations?: number | null } | null } | null }> } };

export type AdminBotChatConversationsQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  channel?: InputMaybe<Scalars['String']['input']>;
  linked?: InputMaybe<Scalars['Boolean']['input']>;
  hasError?: InputMaybe<Scalars['Boolean']['input']>;
  userId?: InputMaybe<Scalars['ID']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<Scalars['String']['input']>;
}>;


export type AdminBotChatConversationsQuery = { __typename?: 'Query', adminBotChatConversations: { __typename?: 'AdminBotChatConversationsResponse', total: number, page: number, pageSize: number, pageCount: number, data: Array<{ __typename?: 'AdminBotChatConversation', id: string, channel: string, channel_user_id: string, first_seen_at?: string | null, last_seen_at?: string | null, message_count?: number | null, error_count?: number | null, memory_summary?: string | null, memory_updated_at?: string | null, user?: { __typename?: 'AdminBotChatConversationUser', id: string, name?: string | null, email?: string | null, phone_number?: string | null } | null }> } };

export type AdminBotChatConversationQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type AdminBotChatConversationQuery = { __typename?: 'Query', adminBotChatConversation?: { __typename?: 'AdminBotChatConversation', id: string, channel: string, channel_user_id: string, first_seen_at?: string | null, last_seen_at?: string | null, message_count?: number | null, error_count?: number | null, memory_summary?: string | null, memory_updated_at?: string | null, user?: { __typename?: 'AdminBotChatConversationUser', id: string, name?: string | null, email?: string | null, phone_number?: string | null } | null } | null };

export type AdminBotChatMessagesQueryVariables = Exact<{
  conversationId: Scalars['ID']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
}>;


export type AdminBotChatMessagesQuery = { __typename?: 'Query', adminBotChatMessages: { __typename?: 'AdminBotChatMessagesResponse', total: number, page: number, pageSize: number, pageCount: number, data: Array<{ __typename?: 'AdminBotChatMessage', id: string, direction: string, text?: string | null, intent_kind?: string | null, intent_source?: string | null, current_flow?: string | null, error?: string | null, llm_model?: string | null, createdAt: string }> } };

export type AdminProjectsQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  user_id?: InputMaybe<Scalars['ID']['input']>;
  curation_status?: InputMaybe<Scalars['String']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<Scalars['String']['input']>;
}>;


export type AdminProjectsQuery = { __typename?: 'Query', adminProjects: { __typename?: 'AdminProjectsResponse', page: number, pageSize: number, pageCount: number, total: number, data: Array<{ __typename?: 'AdminProject', id: string, name?: string | null, curation_status?: string | null, language?: string | null, duration_seconds?: number | null, format?: string | null, deleted?: boolean | null, createdAt: string, updatedAt: string, created_by_user?: { __typename?: 'AdminUserBasic', id: string, name?: string | null, email: string } | null }> } };

export type AdminClipsQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  user_id?: InputMaybe<Scalars['ID']['input']>;
  project_id?: InputMaybe<Scalars['ID']['input']>;
  clipping_status?: InputMaybe<Scalars['String']['input']>;
  rendering_status?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<Scalars['String']['input']>;
}>;


export type AdminClipsQuery = { __typename?: 'Query', adminClips: { __typename?: 'AdminClipsResponse', page: number, pageSize: number, pageCount: number, total: number, data: Array<{ __typename?: 'AdminClip', id: string, name?: string | null, clipping_status?: string | null, preparing_status?: string | null, rendering_status?: string | null, duration_seconds?: number | null, deleted?: boolean | null, clipped_video_url?: string | null, finished_video_url?: string | null, createdAt: string, updatedAt: string, project?: { __typename?: 'AdminProjectBasic', id: string, name?: string | null } | null, created_by_user?: { __typename?: 'AdminUserBasic', id: string, name?: string | null, email: string } | null }> } };

export type AdminYouTubeDownloadsQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  video_id?: InputMaybe<Scalars['String']['input']>;
  download_status?: InputMaybe<Scalars['String']['input']>;
  provider?: InputMaybe<Scalars['String']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<Scalars['String']['input']>;
}>;


export type AdminYouTubeDownloadsQuery = { __typename?: 'Query', adminYouTubeDownloads: { __typename?: 'AdminYouTubeDownloadsResponse', page: number, pageSize: number, pageCount: number, total: number, data: Array<{ __typename?: 'AdminYouTubeDownload', id: string, video_id: string, download_status: string, provider?: string | null, language?: string | null, hash?: string | null, priority?: number | null, linked_projects_count: number, createdAt: string, updatedAt: string }> } };

export type AdminCouponsQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  active?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type AdminCouponsQuery = { __typename?: 'Query', adminCoupons: { __typename?: 'AdminCouponsResponse', page: number, pageSize: number, pageCount: number, total: number, data: Array<{ __typename?: 'AdminCoupon', id: string, documentId: string, code: string, type: string, quantity: number, month_cycles: number, month_discount?: number | null, year_cycles?: number | null, year_discount?: number | null, expiry_date?: string | null, createdAt: string, updatedAt: string, assigned_user?: { __typename?: 'AdminCouponAssignedUser', id: string, name?: string | null, email: string } | null }> } };

export type AdminCouponQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type AdminCouponQuery = { __typename?: 'Query', adminCoupon?: { __typename?: 'AdminCoupon', id: string, documentId: string, code: string, type: string, quantity: number, month_cycles: number, month_discount?: number | null, year_cycles?: number | null, year_discount?: number | null, expiry_date?: string | null, createdAt: string, updatedAt: string, assigned_user?: { __typename?: 'AdminCouponAssignedUser', id: string, name?: string | null, email: string } | null } | null };

export type AdminCreateCouponMutationVariables = Exact<{
  input: AdminCouponCreateInput;
}>;


export type AdminCreateCouponMutation = { __typename?: 'Mutation', adminCreateCoupon: { __typename?: 'AdminCoupon', id: string, code: string, type: string, quantity: number, month_cycles: number, month_discount?: number | null, year_cycles?: number | null, year_discount?: number | null, expiry_date?: string | null, assigned_user?: { __typename?: 'AdminCouponAssignedUser', id: string, name?: string | null, email: string } | null } };

export type AdminUpdateCouponMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: AdminCouponUpdateInput;
}>;


export type AdminUpdateCouponMutation = { __typename?: 'Mutation', adminUpdateCoupon: { __typename?: 'AdminCoupon', id: string, code: string, type: string, quantity: number, month_cycles: number, month_discount?: number | null, year_cycles?: number | null, year_discount?: number | null, expiry_date?: string | null, assigned_user?: { __typename?: 'AdminCouponAssignedUser', id: string, name?: string | null, email: string } | null } };

export type AdminDeleteCouponMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type AdminDeleteCouponMutation = { __typename?: 'Mutation', adminDeleteCoupon: { __typename?: 'AdminCoupon', id: string } };

export type CommunityLiveSessionsQueryVariables = Exact<{ [key: string]: never; }>;


export type CommunityLiveSessionsQuery = { __typename?: 'Query', communityLiveSessions: Array<{ __typename?: 'CommunityLiveSession', id: string, platform: LiveWatchPlatform, live_url?: string | null, started_at?: any | null, youtube_channel: { __typename?: 'AdminLiveWatchChannel', id: string, channel_id?: string | null, name?: string | null, thumbnail?: string | null, handle?: string | null }, library?: { __typename?: 'CommunityLiveSessionLibrary', id: string, name: string, duration_seconds: number, format: string, language: string, start_time?: number | null, end_time?: number | null, base_video_url?: string | null, thumbnail_url?: string | null } | null }> };

export type AdminLiveWatchesQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  platform?: InputMaybe<LiveWatchPlatform>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type AdminLiveWatchesQuery = { __typename?: 'Query', adminLiveWatches: { __typename?: 'AdminLiveWatchPage', page: number, pageSize: number, pageCount: number, total: number, data: Array<{ __typename?: 'AdminLiveWatch', id: string, kind: LiveWatchKind, platform: LiveWatchPlatform, platform_channel_id?: string | null, platform_login?: string | null, source_url?: string | null, enabled: boolean, window_minutes: number, retention_days: number, overlap_seconds: number, createdAt?: any | null, youtube_channel?: { __typename?: 'AdminLiveWatchChannel', id: string, channel_id?: string | null, name?: string | null, thumbnail?: string | null, handle?: string | null } | null, current_session?: { __typename?: 'AdminLiveSession', id: string, status: LiveSessionStatus, platform_live_id?: string | null, live_url?: string | null, started_at?: any | null, ended_at?: any | null, last_error?: string | null, ingest_status: LiveIngestStatus, heartbeat_at?: any | null, r2_prefix?: string | null, retention_expires_at?: any | null } | null }> } };

export type AdminLiveWatchQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type AdminLiveWatchQuery = { __typename?: 'Query', adminLiveWatch?: { __typename?: 'AdminLiveWatch', id: string, kind: LiveWatchKind, platform: LiveWatchPlatform, platform_channel_id?: string | null, platform_login?: string | null, source_url?: string | null, enabled: boolean, window_minutes: number, retention_days: number, overlap_seconds: number, createdAt?: any | null, youtube_channel?: { __typename?: 'AdminLiveWatchChannel', id: string, channel_id?: string | null, name?: string | null, thumbnail?: string | null, handle?: string | null } | null, current_session?: { __typename?: 'AdminLiveSession', id: string, status: LiveSessionStatus, platform_live_id?: string | null, live_url?: string | null, started_at?: any | null, ended_at?: any | null, last_error?: string | null, ingest_status: LiveIngestStatus, heartbeat_at?: any | null, r2_prefix?: string | null, retention_expires_at?: any | null } | null } | null };

export type AdminLiveSessionsQueryVariables = Exact<{
  watchId: Scalars['ID']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
}>;


export type AdminLiveSessionsQuery = { __typename?: 'Query', adminLiveSessions: { __typename?: 'AdminLiveSessionPage', page: number, pageSize: number, pageCount: number, total: number, data: Array<{ __typename?: 'AdminLiveSession', id: string, status: LiveSessionStatus, platform_live_id?: string | null, live_url?: string | null, started_at?: any | null, ended_at?: any | null, last_error?: string | null, ingest_status: LiveIngestStatus, heartbeat_at?: any | null, r2_prefix?: string | null, retention_expires_at?: any | null }> } };

export type AdminCreateLiveWatchMutationVariables = Exact<{
  input: AdminCreateLiveWatchInput;
}>;


export type AdminCreateLiveWatchMutation = { __typename?: 'Mutation', adminCreateLiveWatch: { __typename?: 'AdminLiveWatch', id: string, kind: LiveWatchKind, platform: LiveWatchPlatform, platform_channel_id?: string | null, platform_login?: string | null, source_url?: string | null, enabled: boolean, window_minutes: number, retention_days: number, overlap_seconds: number, createdAt?: any | null, youtube_channel?: { __typename?: 'AdminLiveWatchChannel', id: string, channel_id?: string | null, name?: string | null, thumbnail?: string | null, handle?: string | null } | null, current_session?: { __typename?: 'AdminLiveSession', id: string, status: LiveSessionStatus, platform_live_id?: string | null, live_url?: string | null, started_at?: any | null, ended_at?: any | null, last_error?: string | null, ingest_status: LiveIngestStatus, heartbeat_at?: any | null, r2_prefix?: string | null, retention_expires_at?: any | null } | null } };

export type AdminUpdateLiveWatchMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: AdminCreateLiveWatchInput;
}>;


export type AdminUpdateLiveWatchMutation = { __typename?: 'Mutation', adminUpdateLiveWatch: { __typename?: 'AdminLiveWatch', id: string, kind: LiveWatchKind, platform: LiveWatchPlatform, platform_channel_id?: string | null, platform_login?: string | null, source_url?: string | null, enabled: boolean, window_minutes: number, retention_days: number, overlap_seconds: number, createdAt?: any | null, youtube_channel?: { __typename?: 'AdminLiveWatchChannel', id: string, channel_id?: string | null, name?: string | null, thumbnail?: string | null, handle?: string | null } | null, current_session?: { __typename?: 'AdminLiveSession', id: string, status: LiveSessionStatus, platform_live_id?: string | null, live_url?: string | null, started_at?: any | null, ended_at?: any | null, last_error?: string | null, ingest_status: LiveIngestStatus, heartbeat_at?: any | null, r2_prefix?: string | null, retention_expires_at?: any | null } | null } };

export type AdminSetLiveWatchEnabledMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  enabled: Scalars['Boolean']['input'];
}>;


export type AdminSetLiveWatchEnabledMutation = { __typename?: 'Mutation', adminSetLiveWatchEnabled: { __typename?: 'AdminLiveWatch', id: string, kind: LiveWatchKind, platform: LiveWatchPlatform, platform_channel_id?: string | null, platform_login?: string | null, source_url?: string | null, enabled: boolean, window_minutes: number, retention_days: number, overlap_seconds: number, createdAt?: any | null, youtube_channel?: { __typename?: 'AdminLiveWatchChannel', id: string, channel_id?: string | null, name?: string | null, thumbnail?: string | null, handle?: string | null } | null, current_session?: { __typename?: 'AdminLiveSession', id: string, status: LiveSessionStatus, platform_live_id?: string | null, live_url?: string | null, started_at?: any | null, ended_at?: any | null, last_error?: string | null, ingest_status: LiveIngestStatus, heartbeat_at?: any | null, r2_prefix?: string | null, retention_expires_at?: any | null } | null } };

export type AdminStopLiveSessionMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type AdminStopLiveSessionMutation = { __typename?: 'Mutation', adminStopLiveSession: { __typename?: 'AdminLiveSession', id: string, status: LiveSessionStatus, platform_live_id?: string | null, live_url?: string | null, started_at?: any | null, ended_at?: any | null, last_error?: string | null, ingest_status: LiveIngestStatus, heartbeat_at?: any | null, r2_prefix?: string | null, retention_expires_at?: any | null } };

export type AdminLiveWindowsQueryVariables = Exact<{
  sessionId: Scalars['ID']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
}>;


export type AdminLiveWindowsQuery = { __typename?: 'Query', adminLiveWindows: { __typename?: 'AdminLiveWindowPage', page: number, pageSize: number, pageCount: number, total: number, data: Array<{ __typename?: 'AdminLiveWindow', id: string, window_start: number, window_end: number, status: LiveWindowStatus, library_document_id?: string | null, attempt_count: number, last_error?: string | null }> } };

export type AdminYoutubeChannelsQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  partnerOnly?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type AdminYoutubeChannelsQuery = { __typename?: 'Query', adminYoutubeChannels: { __typename?: 'AdminYoutubeChannelsResponse', total: number, page: number, pageSize: number, pageCount: number, data: Array<{ __typename?: 'AdminYoutubeChannel', id: string, channel_id: string, name: string, url?: string | null, thumbnail?: string | null, handle?: string | null, subscriber_count?: number | null, category?: string | null, is_autoclipper_partner: boolean }> } };

export type AdminUpdateYoutubeChannelMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  is_autoclipper_partner: Scalars['Boolean']['input'];
}>;


export type AdminUpdateYoutubeChannelMutation = { __typename?: 'Mutation', adminUpdateYoutubeChannel: { __typename?: 'AdminYoutubeChannel', id: string, channel_id: string, name: string, is_autoclipper_partner: boolean } };

export type AdminImportDriveToChannelMutationVariables = Exact<{
  channelId: Scalars['ID']['input'];
  urls: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type AdminImportDriveToChannelMutation = { __typename?: 'Mutation', adminImportDriveToChannel: Array<{ __typename?: 'AdminDriveImportResult', input: string, status: AdminDriveImportStatus, fileId?: string | null, fileName?: string | null, downloadId?: string | null, error?: string | null }> };

export type AdminPlansQueryVariables = Exact<{ [key: string]: never; }>;


export type AdminPlansQuery = { __typename?: 'Query', adminPlans: Array<{ __typename?: 'AdminPlanFull', id: string, name?: string | null, slug?: string | null, processing_seconds?: string | null, max_clips?: number | null, max_library_video_seconds?: number | null, max_library_exports?: number | null, max_library_curations?: number | null, value?: number | null, order?: number | null }> };

export type ApplyRenewalCouponMutationVariables = Exact<{
  code: Scalars['String']['input'];
}>;


export type ApplyRenewalCouponMutation = { __typename?: 'Mutation', applyRenewalCoupon: { __typename?: 'RenewalCouponResult', code: string, type: string, discount: number, cycles: number, renewal_price_cents: number, pix_order_regenerated: boolean } };

export type CreatePixRenewalOrderMutationVariables = Exact<{
  resetNow?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CreatePixRenewalOrderMutation = { __typename?: 'Mutation', createPixRenewalOrder: { __typename?: 'PixRenewalOrder', id: string, amount: number, status: string, pix_code?: string | null, pix_qr_code_url?: string | null, expires_at?: string | null } };

export type StartRenewedCycleNowMutationVariables = Exact<{ [key: string]: never; }>;


export type StartRenewedCycleNowMutation = { __typename?: 'Mutation', startRenewedCycleNow: boolean };

export type AdminStatsQueryVariables = Exact<{
  startDate?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['String']['input']>;
}>;


export type AdminStatsQuery = { __typename?: 'Query', adminStats: { __typename?: 'AdminStatsResponse', planCustomerCounts: Array<{ __typename?: 'AdminPlanCustomerCount', plan_id: string, plan_name?: string | null, plan_slug?: string | null, customer_count: number }>, users: { __typename?: 'AdminUserStats', total: number, admins: number, blocked: number, confirmed: number, timeSeries: Array<{ __typename?: 'AdminTimeSeriesPoint', date: string, total: number, success: number, failure: number }>, utmTimeSeries: Array<{ __typename?: 'AdminUtmTimeSeriesPoint', date: string, utm_source: string, count: number }> }, projects: { __typename?: 'AdminEntityStats', total: number, success: number, processing: number, queued: number, failure: number, timeSeries: Array<{ __typename?: 'AdminTimeSeriesPoint', date: string, total: number, success: number, failure: number }> }, libraryProjects: { __typename?: 'AdminEntityStats', total: number, success: number, processing: number, queued: number, failure: number, timeSeries: Array<{ __typename?: 'AdminTimeSeriesPoint', date: string, total: number, success: number, failure: number }> }, clips: { __typename?: 'AdminEntityStats', total: number, success: number, processing: number, queued: number, failure: number, timeSeries: Array<{ __typename?: 'AdminTimeSeriesPoint', date: string, total: number, success: number, failure: number }> }, youtubeDownloads: { __typename?: 'AdminEntityStats', total: number, success: number, processing: number, queued: number, failure: number, timeSeries: Array<{ __typename?: 'AdminTimeSeriesPoint', date: string, total: number, success: number, failure: number }> } } };

export type AdminFunnelStatsQueryVariables = Exact<{ [key: string]: never; }>;


export type AdminFunnelStatsQuery = { __typename?: 'Query', adminFunnelStats: { __typename?: 'AdminFunnelData', own_brand: Array<{ __typename?: 'AdminFunnelStep', label: string, count: number }>, other_channels: Array<{ __typename?: 'AdminFunnelStep', label: string, count: number }> } };

export type AdminResultsDashboardQueryVariables = Exact<{
  startDate?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['String']['input']>;
}>;


export type AdminResultsDashboardQuery = { __typename?: 'Query', adminResultsDashboard: { __typename?: 'AdminResultsDashboard', dateRange: { __typename?: 'AdminResultsDateRange', startDate: string, endDate: string, days: number, capped: boolean }, conversion: { __typename?: 'AdminResultsConversion', totalFree: number, totalPaid: number, rate: number }, funnelCreator: Array<{ __typename?: 'AdminResultsFunnelStep', label: string, count: number, pct: number }>, funnelClipper: Array<{ __typename?: 'AdminResultsFunnelStep', label: string, count: number, pct: number }>, sourcesCreator: Array<{ __typename?: 'AdminResultsSource', key: string, label: string, count: number, pct: number }>, sourcesClipper: Array<{ __typename?: 'AdminResultsSource', key: string, label: string, count: number, pct: number }>, retentionCreator: Array<{ __typename?: 'AdminResultsRetentionPoint', period: string, pct: number, retained: number, cohort: number }>, retentionClipper: Array<{ __typename?: 'AdminResultsRetentionPoint', period: string, pct: number, retained: number, cohort: number }>, campaigns: { __typename?: 'AdminResultsCampaignSummary', enrolled: number, submitted: number, approved: number, earningsCents: number, clipperToPaidPct: number, subscriberToCampaignPct: number }, nwc: { __typename?: 'AdminResultsNwcSummary', total: number, paidPct: number, campaignPct: number, retentionD1: number, retentionD7: number, retentionD30: number, organicRetentionD1: number, organicRetentionD7: number, organicRetentionD30: number }, activity: Array<{ __typename?: 'AdminResultsActivityPoint', date: string, users: number, clips: number }> } };

export type AdminRestoreExpiredItemsMutationVariables = Exact<{
  userId: Scalars['ID']['input'];
}>;


export type AdminRestoreExpiredItemsMutation = { __typename?: 'Mutation', adminRestoreExpiredItems: { __typename?: 'AdminRestoreExpiredItemsResponse', restoredProjects: number, restoredClips: number } };

export type AdminRestoreExpiredProjectMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type AdminRestoreExpiredProjectMutation = { __typename?: 'Mutation', adminRestoreExpiredProject: boolean };

export type AdminRestoreExpiredClipMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type AdminRestoreExpiredClipMutation = { __typename?: 'Mutation', adminRestoreExpiredClip: boolean };

export type AdminRetryFailedProjectMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type AdminRetryFailedProjectMutation = { __typename?: 'Mutation', adminRetryFailedProject: boolean };

export type AdminRetryFailedClipMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type AdminRetryFailedClipMutation = { __typename?: 'Mutation', adminRetryFailedClip: boolean };

export type AdminFetchChannelVideosQueryVariables = Exact<{
  channelUrl: Scalars['String']['input'];
}>;


export type AdminFetchChannelVideosQuery = { __typename?: 'Query', adminFetchChannelVideos: Array<{ __typename?: 'YouTubeChannelVideo', id: string, title: string, url: string, thumbnail?: string | null, duration?: string | null, publishedAt?: string | null, viewCount?: string | null, channel?: string | null }> };

export type AdminLibrariesQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  curation_status?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<Scalars['String']['input']>;
}>;


export type AdminLibrariesQuery = { __typename?: 'Query', adminLibraries: { __typename?: 'AdminLibrariesResponse', total: number, page: number, pageSize: number, pageCount: number, data: Array<{ __typename?: 'AdminLibraryItem', id: string, name?: string | null, curation_status?: string | null, language?: string | null, format?: string | null, prompt?: string | null, base_video_url?: string | null, thumbnail_url?: string | null, duration_seconds?: number | null, deleted?: boolean | null, createdAt: string, updatedAt: string, created_by_user?: { __typename?: 'AdminUserBasic', id: string, email: string, name?: string | null } | null }> } };

export type AdminAddToLibraryMutationVariables = Exact<{
  input: AdminAddToLibraryInput;
}>;


export type AdminAddToLibraryMutation = { __typename?: 'Mutation', adminAddToLibrary: Array<{ __typename?: 'AdminLibraryItem', id: string, name?: string | null, curation_status?: string | null, language?: string | null, format?: string | null, prompt?: string | null, base_video_url?: string | null, thumbnail_url?: string | null, duration_seconds?: number | null, createdAt: string, updatedAt: string }> };

export type AdminDeleteLibraryMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type AdminDeleteLibraryMutation = { __typename?: 'Mutation', adminDeleteLibrary: boolean };

export type AdminRetryFailedLibraryMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type AdminRetryFailedLibraryMutation = { __typename?: 'Mutation', adminRetryFailedLibrary: boolean };

export type AdminRestoreExpiredLibraryMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type AdminRestoreExpiredLibraryMutation = { __typename?: 'Mutation', adminRestoreExpiredLibrary: boolean };

export type AdminImpersonateUserMutationVariables = Exact<{
  userId: Scalars['ID']['input'];
}>;


export type AdminImpersonateUserMutation = { __typename?: 'Mutation', adminImpersonateUser: { __typename?: 'AdminImpersonationResponse', jwt: string } };

export type AdminUpdateUserSubscriptionMutationVariables = Exact<{
  userId: Scalars['ID']['input'];
  input: AdminUpdateUserSubscriptionInput;
}>;


export type AdminUpdateUserSubscriptionMutation = { __typename?: 'Mutation', adminUpdateUserSubscription: { __typename?: 'AdminUser', id: string, name?: string | null, email: string, onboarding_objective?: string | null, subscription?: { __typename?: 'AdminSubscription', id: string, current_month_processing_seconds?: number | null, current_month_clips?: number | null, current_month_library_video_seconds?: number | null, current_month_library_exports?: number | null, current_month_library_curations?: number | null, extra_clips?: number | null, is_partner?: boolean | null, partner_expires_at?: string | null, partner_note?: string | null, extra_seconds?: number | null, plan?: { __typename?: 'AdminPlan', id: string, name: string, slug: string, max_library_curations?: number | null, max_library_exports?: number | null, max_library_video_seconds?: number | null } | null } | null } };

export type AdminSetAffiliateRatesMutationVariables = Exact<{
  userId: Scalars['ID']['input'];
  input: AdminAffiliateRatesInput;
}>;


export type AdminSetAffiliateRatesMutation = { __typename?: 'Mutation', adminSetAffiliateRates: { __typename?: 'AdminAffiliateRatesResult', id: string, affiliate_rate_payment?: number | null, affiliate_rate_course?: number | null, affiliate_rate_cpm?: number | null, affiliate_rate_note?: string | null } };

export type AdminSetCpmLeaderboardExclusionMutationVariables = Exact<{
  userId: Scalars['ID']['input'];
  excluded: Scalars['Boolean']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
}>;


export type AdminSetCpmLeaderboardExclusionMutation = { __typename?: 'Mutation', adminSetCpmLeaderboardExclusion: { __typename?: 'AdminCpmLeaderboardExclusionResult', id: string, cpm_leaderboard_excluded: boolean, cpm_leaderboard_excluded_reason?: string | null } };

export type ActiveChallengeQueryVariables = Exact<{ [key: string]: never; }>;


export type ActiveChallengeQuery = { __typename?: 'Query', activeChallenge?: { __typename?: 'ClippingChallenge', id: string, name: string, description?: string | null, start_date?: string | null, end_date?: string | null, prize_pool: number, warning_message?: string | null, rules_allowed?: any | null, rules_forbidden?: any | null, rules_attention?: string | null, is_accepting_participants?: boolean | null, required_hashtags?: string | null, caption_examples?: Array<string> | null, prize_data?: any | null, my_participation?: { __typename?: 'ChallengeParticipation', id: string, user_id: string, user_name?: string | null, user_email?: string | null, user_profile_picture?: string | null, disqualified?: boolean | null, disqualification_reason?: string | null, total_views?: string | null, createdAt: string, challenge_clips?: Array<{ __typename?: 'ChallengeClip', id: string, platform: string, url: string, total_views?: string | null, admin_approval: string, approval_reason?: string | null, validated_hashtags: string, createdAt: string, challenge_clip_views?: Array<{ __typename?: 'ChallengeClipView', id: string, date: string, platform: string, views?: string | null, likes?: string | null, comments?: string | null, shares?: string | null, saves?: string | null, favorites?: string | null }> | null }> | null } | null, ranking?: Array<{ __typename?: 'ChallengeRankingEntry', participation_id: string, user_id: string, user_name?: string | null, user_profile_picture?: string | null, total_views?: string | null, clip_count?: number | null }> | null } | null };

export type GetChallengeQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetChallengeQuery = { __typename?: 'Query', challenge?: { __typename?: 'ClippingChallenge', id: string, name: string, description?: string | null, start_date?: string | null, end_date?: string | null, prize_pool: number, warning_message?: string | null, rules_allowed?: any | null, rules_forbidden?: any | null, rules_attention?: string | null, is_accepting_participants?: boolean | null, required_hashtags?: string | null, caption_examples?: Array<string> | null, prize_data?: any | null, my_participation?: { __typename?: 'ChallengeParticipation', id: string, user_id: string, user_name?: string | null, user_email?: string | null, user_profile_picture?: string | null, disqualified?: boolean | null, disqualification_reason?: string | null, total_views?: string | null, createdAt: string, challenge_clips?: Array<{ __typename?: 'ChallengeClip', id: string, platform: string, url: string, total_views?: string | null, admin_approval: string, approval_reason?: string | null, validated_hashtags: string, createdAt: string, challenge_clip_views?: Array<{ __typename?: 'ChallengeClipView', id: string, date: string, platform: string, views?: string | null, likes?: string | null, comments?: string | null, shares?: string | null, saves?: string | null, favorites?: string | null }> | null }> | null } | null, ranking?: Array<{ __typename?: 'ChallengeRankingEntry', participation_id: string, user_id: string, user_name?: string | null, user_profile_picture?: string | null, total_views?: string | null, clip_count?: number | null }> | null, rankings?: Array<{ __typename?: 'ChallengeRanking', id: string, name: string, timezone: string, is_consolidated: boolean, admin_validated: boolean, consolidated_at?: string | null, ranking_data?: any | null, time_until_start_seconds?: number | null, time_until_end_seconds?: number | null, partial_ranking?: Array<{ __typename?: 'ChallengeRankingEntry', participation_id: string, user_id: string, user_name?: string | null, user_profile_picture?: string | null, total_views?: string | null, clip_count?: number | null }> | null }> | null } | null };

export type JoinChallengeMutationVariables = Exact<{
  challengeId: Scalars['ID']['input'];
}>;


export type JoinChallengeMutation = { __typename?: 'Mutation', joinChallenge: { __typename?: 'ChallengeParticipation', id: string, user_id: string, total_views?: string | null, createdAt: string, challenge_clips?: Array<{ __typename?: 'ChallengeClip', id: string, platform: string, url: string, total_views?: string | null, createdAt: string }> | null } };

export type SubmitChallengeClipMutationVariables = Exact<{
  input: SubmitChallengeClipInput;
}>;


export type SubmitChallengeClipMutation = { __typename?: 'Mutation', submitChallengeClip: { __typename?: 'ChallengeClip', id: string, platform: string, url: string, total_views?: string | null, createdAt: string } };

export type ValidateChallengeClipHashtagsMutationVariables = Exact<{
  input: ValidateChallengeClipInput;
}>;


export type ValidateChallengeClipHashtagsMutation = { __typename?: 'Mutation', validateChallengeClipHashtags: { __typename?: 'ChallengeClipValidation', hashtags_valid: boolean, missing_hashtags: Array<string> } };

export type AdminChallengesQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
}>;


export type AdminChallengesQuery = { __typename?: 'Query', adminChallenges: { __typename?: 'AdminChallengesResponse', page: number, pageSize: number, pageCount: number, total: number, data: Array<{ __typename?: 'AdminChallenge', id: string, name: string, description?: string | null, start_date?: string | null, end_date?: string | null, prize_pool: number, warning_message?: string | null, rules_allowed?: string | null, rules_forbidden?: string | null, rules_attention?: string | null, is_accepting_participants?: boolean | null, required_hashtags?: string | null, caption_examples?: string | null, prize_data?: string | null, createdAt: string, updatedAt: string, rankings?: Array<{ __typename?: 'AdminChallengeRanking', id: string, name: string, timezone: string, is_consolidated: boolean, consolidated_at?: string | null, ranking_data?: any | null }> | null, participants?: Array<{ __typename?: 'AdminChallengeParticipant', id: string, user_id?: string | null, user_name?: string | null, user_email?: string | null, total_views?: string | null, clip_count?: number | null, createdAt: string, challenge_clips?: Array<{ __typename?: 'AdminChallengeClip', id: string, platform: string, url: string, total_views?: string | null, admin_approval: string, approval_reason?: string | null, validated_hashtags: string, createdAt: string }> | null }> | null }> } };

export type AdminChallengeQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type AdminChallengeQuery = { __typename?: 'Query', adminChallenge?: { __typename?: 'AdminChallenge', id: string, name: string, description?: string | null, start_date?: string | null, end_date?: string | null, prize_pool: number, warning_message?: string | null, rules_allowed?: string | null, rules_forbidden?: string | null, rules_attention?: string | null, is_accepting_participants?: boolean | null, required_hashtags?: string | null, caption_examples?: string | null, prize_data?: string | null, createdAt: string, updatedAt: string, rankings?: Array<{ __typename?: 'AdminChallengeRanking', id: string, name: string, timezone: string, is_consolidated: boolean, admin_validated: boolean, consolidated_at?: string | null, ranking_data?: any | null, start_date?: string | null, end_date?: string | null, start_snapshotted_at?: string | null, end_snapshotted_at?: string | null, time_until_start_seconds?: number | null, time_until_end_seconds?: number | null, partial_ranking?: Array<{ __typename?: 'ChallengeRankingEntry', participation_id: string, user_id: string, user_name?: string | null, user_profile_picture?: string | null, total_views?: string | null, clip_count?: number | null }> | null }> | null, participants?: Array<{ __typename?: 'AdminChallengeParticipant', id: string, user_id?: string | null, user_name?: string | null, user_email?: string | null, total_views?: string | null, clip_count?: number | null, disqualified?: boolean | null, disqualification_reason?: string | null, createdAt: string, subscription?: { __typename?: 'AdminSubscription', id: string, current_month_processing_seconds?: number | null, current_month_clips?: number | null, current_month_library_video_seconds?: number | null, current_month_library_exports?: number | null, createdAt: string, updatedAt: string, plan?: { __typename?: 'AdminPlan', id: string, name: string, processing_seconds?: number | null, max_clips?: number | null, max_library_video_seconds?: number | null, max_library_exports?: number | null } | null } | null, challenge_clips?: Array<{ __typename?: 'AdminChallengeClip', id: string, platform: string, url: string, total_views?: string | null, admin_approval: string, approval_reason?: string | null, validated_hashtags: string, createdAt: string }> | null }> | null } | null };

export type AdminCreateChallengeMutationVariables = Exact<{
  input: AdminChallengeCreateInput;
}>;


export type AdminCreateChallengeMutation = { __typename?: 'Mutation', adminCreateChallenge: { __typename?: 'AdminChallenge', id: string, name: string, start_date?: string | null, end_date?: string | null, prize_pool: number, createdAt: string } };

export type AdminUpdateChallengeMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: AdminChallengeUpdateInput;
}>;


export type AdminUpdateChallengeMutation = { __typename?: 'Mutation', adminUpdateChallenge: { __typename?: 'AdminChallenge', id: string, name: string, start_date?: string | null, end_date?: string | null, prize_pool: number, createdAt: string } };

export type AdminDeleteChallengeMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type AdminDeleteChallengeMutation = { __typename?: 'Mutation', adminDeleteChallenge: boolean };

export type AdminAddChallengeParticipantMutationVariables = Exact<{
  challengeId: Scalars['ID']['input'];
  email: Scalars['String']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
}>;


export type AdminAddChallengeParticipantMutation = { __typename?: 'Mutation', adminAddChallengeParticipant: { __typename?: 'AdminChallengeParticipant', id: string, user_id?: string | null, user_name?: string | null, user_email?: string | null, total_views?: string | null, clip_count?: number | null, was_created?: boolean | null, createdAt: string, challenge_clips?: Array<{ __typename?: 'AdminChallengeClip', id: string, platform: string, url: string, total_views?: string | null, admin_approval: string, approval_reason?: string | null, createdAt: string }> | null } };

export type AdminRemoveChallengeParticipantMutationVariables = Exact<{
  challengeId: Scalars['ID']['input'];
  participantId: Scalars['ID']['input'];
}>;


export type AdminRemoveChallengeParticipantMutation = { __typename?: 'Mutation', adminRemoveChallengeParticipant: boolean };

export type AdminDisqualifyParticipantMutationVariables = Exact<{
  participantId: Scalars['ID']['input'];
  disqualified: Scalars['Boolean']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
}>;


export type AdminDisqualifyParticipantMutation = { __typename?: 'Mutation', adminDisqualifyParticipant: boolean };

export type AdminResetChallengeParticipantUsageMutationVariables = Exact<{
  challengeId: Scalars['ID']['input'];
  participantId: Scalars['ID']['input'];
}>;


export type AdminResetChallengeParticipantUsageMutation = { __typename?: 'Mutation', adminResetChallengeParticipantUsage: boolean };

export type AdminResetAllChallengeParticipantsUsageMutationVariables = Exact<{
  challengeId: Scalars['ID']['input'];
}>;


export type AdminResetAllChallengeParticipantsUsageMutation = { __typename?: 'Mutation', adminResetAllChallengeParticipantsUsage: boolean };

export type AdminCreateChallengeRankingMutationVariables = Exact<{
  challengeId: Scalars['ID']['input'];
  input: AdminChallengeRankingCreateInput;
}>;


export type AdminCreateChallengeRankingMutation = { __typename?: 'Mutation', adminCreateChallengeRanking: { __typename?: 'AdminChallengeRanking', id: string, name: string, timezone: string, is_consolidated: boolean, admin_validated: boolean, consolidated_at?: string | null, ranking_data?: any | null } };

export type AdminUpdateChallengeRankingMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: AdminChallengeRankingUpdateInput;
}>;


export type AdminUpdateChallengeRankingMutation = { __typename?: 'Mutation', adminUpdateChallengeRanking: { __typename?: 'AdminChallengeRanking', id: string, name: string, timezone: string, is_consolidated: boolean, admin_validated: boolean, consolidated_at?: string | null, ranking_data?: any | null } };

export type AdminDeleteChallengeRankingMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type AdminDeleteChallengeRankingMutation = { __typename?: 'Mutation', adminDeleteChallengeRanking: boolean };

export type AdminValidateRankingMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  validated: Scalars['Boolean']['input'];
}>;


export type AdminValidateRankingMutation = { __typename?: 'Mutation', adminValidateRanking: { __typename?: 'AdminChallengeRanking', id: string, name: string, timezone: string, is_consolidated: boolean, admin_validated: boolean, consolidated_at?: string | null, ranking_data?: any | null, start_date?: string | null, end_date?: string | null } };

export type AdminChallengeClipsQueryVariables = Exact<{
  challengeId: Scalars['ID']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  approval?: InputMaybe<Scalars['String']['input']>;
  validated_hashtags?: InputMaybe<Scalars['String']['input']>;
}>;


export type AdminChallengeClipsQuery = { __typename?: 'Query', adminChallengeClips: { __typename?: 'AdminChallengeClipsResponse', page: number, pageSize: number, pageCount: number, total: number, data: Array<{ __typename?: 'AdminChallengeClipDetail', id: string, platform: string, url: string, total_views?: string | null, admin_approval: string, approval_reason?: string | null, validated_hashtags: string, participant_id: string, participant_user_name?: string | null, participant_user_email?: string | null, createdAt: string }> } };

export type AdminSetChallengeClipApprovalMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  approval: Scalars['String']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
}>;


export type AdminSetChallengeClipApprovalMutation = { __typename?: 'Mutation', adminSetChallengeClipApproval: boolean };

export type AdminSetChallengeClipHashtagValidationMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  validated_hashtags: Scalars['String']['input'];
}>;


export type AdminSetChallengeClipHashtagValidationMutation = { __typename?: 'Mutation', adminSetChallengeClipHashtagValidation: boolean };

export type AdminRankingSnapshotsQueryVariables = Exact<{
  rankingId: Scalars['ID']['input'];
}>;


export type AdminRankingSnapshotsQuery = { __typename?: 'Query', adminRankingSnapshots: { __typename?: 'AdminRankingSnapshots', ranking_id: string, ranking_name: string, start_views: Array<{ __typename?: 'RankingSnapshotClip', snapshot_view_id: string, clip_id: string, clip_url: string, clip_platform: string, participant_name?: string | null, participant_id?: string | null, views: string }>, end_views: Array<{ __typename?: 'RankingSnapshotClip', snapshot_view_id: string, clip_id: string, clip_url: string, clip_platform: string, participant_name?: string | null, participant_id?: string | null, views: string }> } };

export type AdminPartialRankingByDateRangeQueryVariables = Exact<{
  challengeId: Scalars['ID']['input'];
  startDate?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
}>;


export type AdminPartialRankingByDateRangeQuery = { __typename?: 'Query', adminPartialRankingByDateRange: { __typename?: 'PartialRankingByDateResponse', start_date_used?: string | null, end_date_used?: string | null, entries: Array<{ __typename?: 'PartialRankingByDateEntry', participation_id: string, user_name?: string | null, clip_count: number, total_views: string }>, clips_without_views: Array<{ __typename?: 'PartialRankingClipWarning', clip_id: string, clip_url: string, participant_name?: string | null, missing: string }> } };

export type AdminChallengeViewsTimeSeriesQueryVariables = Exact<{
  challengeId: Scalars['ID']['input'];
  days?: InputMaybe<Scalars['Int']['input']>;
}>;


export type AdminChallengeViewsTimeSeriesQuery = { __typename?: 'Query', adminChallengeViewsTimeSeries: Array<{ __typename?: 'ChallengeViewsTimeSeriesEntry', date: string, total_views: string, clip_count: number }> };

export type AdminForceStartSnapshotMutationVariables = Exact<{
  rankingId: Scalars['ID']['input'];
}>;


export type AdminForceStartSnapshotMutation = { __typename?: 'Mutation', adminForceStartSnapshot: { __typename?: 'AdminChallengeRanking', id: string, name: string, start_snapshotted_at?: string | null, end_snapshotted_at?: string | null } };

export type AdminForceConsolidationMutationVariables = Exact<{
  rankingId: Scalars['ID']['input'];
}>;


export type AdminForceConsolidationMutation = { __typename?: 'Mutation', adminForceConsolidation: { __typename?: 'AdminChallengeRanking', id: string, name: string, is_consolidated: boolean, consolidated_at?: string | null, ranking_data?: any | null, start_snapshotted_at?: string | null, end_snapshotted_at?: string | null } };

export type AdminUpdateSnapshotViewMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  views: Scalars['String']['input'];
}>;


export type AdminUpdateSnapshotViewMutation = { __typename?: 'Mutation', adminUpdateSnapshotView: boolean };

export type AdminCreateManualClipViewMutationVariables = Exact<{
  clipId: Scalars['ID']['input'];
  views: Scalars['String']['input'];
  date?: InputMaybe<Scalars['String']['input']>;
}>;


export type AdminCreateManualClipViewMutation = { __typename?: 'Mutation', adminCreateManualClipView: boolean };

export type AdminForceUpdateAllChallengeClipViewsMutationVariables = Exact<{
  challengeId: Scalars['ID']['input'];
}>;


export type AdminForceUpdateAllChallengeClipViewsMutation = { __typename?: 'Mutation', adminForceUpdateAllChallengeClipViews: number };

export type AdminSyncMissingChallengeClipViewsMutationVariables = Exact<{
  challengeId: Scalars['ID']['input'];
}>;


export type AdminSyncMissingChallengeClipViewsMutation = { __typename?: 'Mutation', adminSyncMissingChallengeClipViews: number };

export type AdminForceUpdateChallengeClipViewsMutationVariables = Exact<{
  clipIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type AdminForceUpdateChallengeClipViewsMutation = { __typename?: 'Mutation', adminForceUpdateChallengeClipViews: number };

export type AdminForceUpdateChallengeClipViewMutationVariables = Exact<{
  clipId: Scalars['ID']['input'];
}>;


export type AdminForceUpdateChallengeClipViewMutation = { __typename?: 'Mutation', adminForceUpdateChallengeClipView: boolean };

export type CommunityLibrariesWithCampaignsQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  channelId?: InputMaybe<Scalars['ID']['input']>;
  channelCategory?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  tagId?: InputMaybe<Scalars['ID']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
  campaignId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type CommunityLibrariesWithCampaignsQuery = { __typename?: 'Query', communityLibraries: Array<{ __typename?: 'MyLibrary', id: string, name?: string | null, curation_status?: string | null, base_video_url?: string | null, compressed_base_video_url?: string | null, original_video_url?: string | null, cut_video_url?: string | null, format: string, language: string, duration_seconds?: number | null, start_time?: number | null, end_time?: number | null, thumbnail_url?: string | null, youtube_video_id?: string | null, view_count?: string | null, upload_date?: string | null, remix_count?: number | null, windowed_remix_count?: number | null, createdAt: string, created_by_user_name?: string | null, youtube_channels: Array<{ __typename?: 'MyYoutubeChannel', channel_id: string, name: string, thumbnail?: string | null }>, active_cpm_campaigns: Array<{ __typename?: 'MyCpmCampaign', campaign_type?: string | null, ranking_config?: any | null, id: string, name: string, cpm_rate_cents: number, cpm_platform_rates: Array<{ __typename?: 'CpmPlatformRate', platform: string, cpm_rate_cents: number }>, allowed_platforms?: Array<string> | null, currency: string, budget_total_cents: number, budget_remaining_cents: number, budget_pending_cents: number, invite_only: boolean, selected_only: boolean, my_approved_platforms: Array<string> }> }> };

export type MyCpmCampaignQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type MyCpmCampaignQuery = { __typename?: 'Query', myCpmCampaign?: { __typename?: 'MyCpmCampaign', campaign_type?: string | null, ranking_config?: any | null, id: string, name: string, description?: string | null, status: string, start_date?: string | null, end_date?: string | null, currency: string, banner_url?: string | null, categories: Array<string>, cpm_rate_cents: number, cpm_platform_rates: Array<{ __typename?: 'CpmPlatformRate', platform: string, cpm_rate_cents: number }>, budget_total_cents: number, budget_remaining_cents: number, budget_pending_cents: number, min_views_threshold?: number | null, min_payout_per_clipper_cents?: number | null, max_payout_per_clipper_cents?: number | null, max_payout_per_clip_cents?: number | null, view_accrual_window_hours: number, required_hashtags?: string | null, required_mention?: string | null, min_clip_duration_seconds?: number | null, allowed_platforms?: Array<string> | null, rules_allowed?: string | null, rules_forbidden?: string | null, rules_attention?: string | null, rules_warning?: string | null, caption_examples?: string | null, enforced_post_layout?: any | null, requires_channel_approval: boolean, invite_only: boolean, selected_only: boolean, is_selected_user: boolean, editing_assets?: any | null, my_approved_platforms: Array<string>, is_joined: boolean, join_blocked_reason?: string | null, my_total_earnings_cents: number, my_channel_requests: Array<{ __typename?: 'MyCpmCampaignChannelRequest', id: string, platform: string, submitted_url: string, handle?: string | null, status: string, review_reason?: string | null, reviewed_at?: string | null, createdAt: string, youtube_channel?: { __typename?: 'MyYoutubeChannel', id: string, name: string, handle?: string | null, thumbnail?: string | null, subscriber_count?: number | null } | null }>, youtube_channels: Array<{ __typename?: 'MyYoutubeChannel', channel_id: string, name: string, thumbnail?: string | null }>, library_projects: Array<{ __typename?: 'MyLibrary', id: string, name?: string | null, thumbnail_url?: string | null }>, participating_libraries: Array<{ __typename?: 'MyLibrary', id: string, name?: string | null, thumbnail_url?: string | null, duration_seconds?: number | null, aired_at?: string | null, view_count?: string | null, youtube_video_id?: string | null, base_video_url?: string | null, original_video_url?: string | null, cut_video_url?: string | null, compressed_base_video_url?: string | null, format: string, language: string, start_time?: number | null, end_time?: number | null, active_cpm_campaigns: Array<{ __typename?: 'MyCpmCampaign', id: string }>, youtube_channels: Array<{ __typename?: 'MyYoutubeChannel', channel_id: string, name: string, thumbnail?: string | null }> }>, my_submissions: Array<{ __typename?: 'MyCpmCampaignSubmission', id: string, platform: string, url: string, admin_approval: string, validated_hashtags: string, disqualified: boolean, last_counted_views: string, accumulated_payout_cents: number, cpm_rate_override_cents?: number | null, last_view_sync_at?: string | null, latest_views?: string | null, payable_views: string, approval_reason?: string | null, disqualification_reason?: string | null, admin_observation?: string | null, suspected_duplicate: boolean, social_connection_id?: string | null, provider_media_id?: string | null, metrics_source?: string | null, metrics_status?: string | null, metrics_error?: string | null, disapproved_at?: string | null, pre_approval: string, pre_approval_score?: number | null, pre_approval_at?: string | null, rules_check_failures: Array<string>, estimated_payout_cents?: number | null, media_duration_seconds?: number | null, rules_check_missing_hashtags: Array<string>, rules_check_missing_mentions: Array<string>, createdAt: string, appeal?: { __typename?: 'CpmCampaignSubmissionAppeal', id: string, status: string, argument: string, extra_url?: string | null, evidence_image_urls: Array<string>, reviewer_reply?: string | null, original_approval_reason?: string | null, createdAt?: any | null, reviewer_images: Array<{ __typename?: 'CpmReviewImage', url: string, visibility: string }> } | null, rejection_images: Array<{ __typename?: 'CpmReviewImage', url: string, visibility: string }> }> } | null };

export type MySocialLinkingPlatformsQueryVariables = Exact<{ [key: string]: never; }>;


export type MySocialLinkingPlatformsQuery = { __typename?: 'Query', mySocialLinkingPlatforms: Array<string> };

export type MySocialPostingPlatformsQueryVariables = Exact<{ [key: string]: never; }>;


export type MySocialPostingPlatformsQuery = { __typename?: 'Query', mySocialPostingPlatforms: Array<string> };

export type MySocialConnectionsQueryVariables = Exact<{ [key: string]: never; }>;


export type MySocialConnectionsQuery = { __typename?: 'Query', mySocialConnections: Array<{ __typename?: 'MySocialConnection', id: string, platform: string, username: string, display_name: string, avatar_url?: string | null, status: string, scopes?: any | null, access_expires_at?: string | null, last_synced_at?: string | null, createdAt: string }> };

export type ResolveMyCpmOwnedMediaQueryVariables = Exact<{
  platform: Scalars['String']['input'];
  url: Scalars['String']['input'];
}>;


export type ResolveMyCpmOwnedMediaQuery = { __typename?: 'Query', resolveMyCpmOwnedMedia: { __typename?: 'CpmOwnedMedia', social_connection_id: string, username: string, provider_media_id: string } };

export type DisconnectMySocialConnectionMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DisconnectMySocialConnectionMutation = { __typename?: 'Mutation', disconnectMySocialConnection: boolean };

export type CreateMyCpmCampaignSubmissionMutationVariables = Exact<{
  input: CreateMyCpmCampaignSubmissionInput;
}>;


export type CreateMyCpmCampaignSubmissionMutation = { __typename?: 'Mutation', createMyCpmCampaignSubmission: { __typename?: 'MyCpmCampaignSubmission', id: string, platform: string, url: string, admin_approval: string, accumulated_payout_cents: number, createdAt: string } };

export type DeleteMyCpmCampaignSubmissionMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteMyCpmCampaignSubmissionMutation = { __typename?: 'Mutation', deleteMyCpmCampaignSubmission: boolean };

export type CreateMyCpmCampaignSubmissionAppealMutationVariables = Exact<{
  submissionId: Scalars['ID']['input'];
  argument: Scalars['String']['input'];
  extraUrl?: InputMaybe<Scalars['String']['input']>;
  evidenceImageUrls?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type CreateMyCpmCampaignSubmissionAppealMutation = { __typename?: 'Mutation', createMyCpmCampaignSubmissionAppeal: { __typename?: 'CpmCampaignSubmissionAppeal', id: string, status: string, argument: string, extra_url?: string | null, evidence_image_urls: Array<string>, reviewer_reply?: string | null, createdAt?: any | null, reviewer_images: Array<{ __typename?: 'CpmReviewImage', url: string, visibility: string }> } };

export type RespondToMyCpmCampaignSubmissionAppealMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  argument: Scalars['String']['input'];
  extraUrl?: InputMaybe<Scalars['String']['input']>;
  evidenceImageUrls?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type RespondToMyCpmCampaignSubmissionAppealMutation = { __typename?: 'Mutation', respondToMyCpmCampaignSubmissionAppeal: { __typename?: 'CpmCampaignSubmissionAppeal', id: string, status: string, argument: string, extra_url?: string | null, evidence_image_urls: Array<string>, reviewer_reply?: string | null, createdAt?: any | null, reviewer_images: Array<{ __typename?: 'CpmReviewImage', url: string, visibility: string }> } };

export type JoinCpmCampaignMutationVariables = Exact<{
  campaignId: Scalars['ID']['input'];
}>;


export type JoinCpmCampaignMutation = { __typename?: 'Mutation', joinCpmCampaign: boolean };

export type LeaveCpmCampaignMutationVariables = Exact<{
  campaignId: Scalars['ID']['input'];
}>;


export type LeaveCpmCampaignMutation = { __typename?: 'Mutation', leaveCpmCampaign: boolean };

export type AdminCpmCampaignsQueryVariables = Exact<{
  status?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type AdminCpmCampaignsQuery = { __typename?: 'Query', adminCpmCampaigns: { __typename?: 'AdminCpmCampaignsResponse', total: number, data: Array<{ __typename?: 'AdminCpmCampaign', campaign_type?: string | null, ranking_config?: any | null, id: string, name: string, status: string, currency: string, cpm_rate_cents: number, cpm_platform_rates: Array<{ __typename?: 'CpmPlatformRate', platform: string, cpm_rate_cents: number }>, allowed_platforms?: Array<string> | null, budget_total_cents: number, budget_spent_cents: number, budget_stored_spent_cents: number, budget_spend_drift_cents: number, budget_remaining_cents: number, budget_pending_cents: number, submissions_count: number, createdAt: string, start_date?: string | null, end_date?: string | null, requires_channel_approval: boolean, pending_channel_requests_count: number }> } };

export type AdminCpmCampaignQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type AdminCpmCampaignQuery = { __typename?: 'Query', adminCpmCampaign?: { __typename?: 'AdminCpmCampaign', campaign_type?: string | null, ranking_config?: any | null, id: string, name: string, logo_url?: string | null, banner_url?: string | null, categories: Array<string>, description?: string | null, status: string, start_date?: string | null, end_date?: string | null, currency: string, cpm_rate_cents: number, cpm_platform_rates: Array<{ __typename?: 'CpmPlatformRate', platform: string, cpm_rate_cents: number }>, budget_total_cents: number, budget_spent_cents: number, budget_stored_spent_cents: number, budget_spend_drift_cents: number, budget_remaining_cents: number, budget_pending_cents: number, min_views_threshold?: number | null, min_payout_per_clipper_cents?: number | null, max_payout_per_clipper_cents?: number | null, max_payout_per_clip_cents?: number | null, view_accrual_window_hours?: number | null, required_hashtags?: string | null, required_mention?: string | null, min_clip_duration_seconds?: number | null, allowed_platforms?: Array<string> | null, rules_allowed?: string | null, rules_forbidden?: string | null, rules_attention?: string | null, rules_warning?: string | null, caption_examples?: string | null, requires_channel_approval: boolean, restrict_to_listed_videos: boolean, pre_approval_enabled: boolean, pre_approval_min_score?: number | null, rank_min_finished_renders?: number | null, invite_only: boolean, selected_only: boolean, watermark_image_url?: string | null, watermark_anchor?: string | null, watermark_size_percent?: number | null, watermark_opacity_percent?: number | null, watermark_margin_x_percent?: number | null, watermark_margin_y_percent?: number | null, enforced_post_layout?: any | null, enforced_subtitle_position?: any | null, editing_assets?: any | null, allow_cpm_override: boolean, cpm_override_mode: string, cpm_override_presets_cents?: Array<number> | null, cpm_override_min_cents?: number | null, cpm_override_max_cents?: number | null, pending_channel_requests_count: number, pending_appeals_count: number, submissions_count: number, createdAt: string, updatedAt: string, youtube_channels: Array<{ __typename?: 'MyYoutubeChannel', id: string, channel_id: string, name: string, thumbnail?: string | null }>, library_projects: Array<{ __typename?: 'MyLibrary', id: string, name?: string | null, thumbnail_url?: string | null }>, youtube_downloads: Array<{ __typename?: 'CpmCampaignVideo', id: string, video_id: string, name?: string | null, thumbnail_url?: string | null, youtube_channels: Array<{ __typename?: 'MyYoutubeChannel', id: string, channel_id: string, name: string, thumbnail?: string | null }> }>, campaign_admins: Array<{ __typename?: 'AdminUser', id: string, email: string, name?: string | null }>, selected_users: Array<{ __typename?: 'AdminUser', id: string, email: string, name?: string | null }> } | null };

export type MyAuditedCpmCampaignsQueryVariables = Exact<{ [key: string]: never; }>;


export type MyAuditedCpmCampaignsQuery = { __typename?: 'Query', adminCpmCampaigns: { __typename?: 'AdminCpmCampaignsResponse', total: number, data: Array<{ __typename?: 'AdminCpmCampaign', campaign_type?: string | null, ranking_config?: any | null, id: string, name: string, description?: string | null, status: string, logo_url?: string | null, banner_url?: string | null, categories: Array<string>, start_date?: string | null, currency: string, cpm_rate_cents: number, cpm_platform_rates: Array<{ __typename?: 'CpmPlatformRate', platform: string, cpm_rate_cents: number }>, allowed_platforms?: Array<string> | null, max_payout_per_clip_cents?: number | null, budget_total_cents: number, budget_spent_cents: number, budget_stored_spent_cents: number, budget_spend_drift_cents: number, budget_remaining_cents: number, budget_pending_cents: number, submissions_count: number, pending_submissions_count: number, approved_submissions_count: number, disapproved_submissions_count: number, pending_appeals_count: number, pending_channel_requests_count: number, createdAt: string, youtube_channels: Array<{ __typename?: 'MyYoutubeChannel', id: string, name: string, handle?: string | null, thumbnail?: string | null }> }> } };

export type ActiveCpmCampaignChannelsQueryVariables = Exact<{ [key: string]: never; }>;


export type ActiveCpmCampaignChannelsQuery = { __typename?: 'Query', myCpmCampaigns: Array<{ __typename?: 'MyCpmCampaign', campaign_type?: string | null, ranking_config?: any | null, id: string, name: string, required_hashtags?: string | null, logo_url?: string | null, banner_url?: string | null, categories: Array<string>, invite_only: boolean, selected_only: boolean, is_selected_user: boolean, my_approved_platforms: Array<string>, cpm_rate_cents: number, cpm_platform_rates: Array<{ __typename?: 'CpmPlatformRate', platform: string, cpm_rate_cents: number }>, allowed_platforms?: Array<string> | null, min_views_threshold?: number | null, currency: string, budget_total_cents: number, budget_remaining_cents: number, budget_pending_cents: number, youtube_channels: Array<{ __typename?: 'MyYoutubeChannel', channel_id: string, thumbnail?: string | null }> }> };

export type EarnPageCampaignsQueryVariables = Exact<{ [key: string]: never; }>;


export type EarnPageCampaignsQuery = { __typename?: 'Query', myCpmCampaigns: Array<{ __typename?: 'MyCpmCampaign', campaign_type?: string | null, ranking_config?: any | null, id: string, name: string, logo_url?: string | null, banner_url?: string | null, categories: Array<string>, cpm_rate_cents: number, cpm_platform_rates: Array<{ __typename?: 'CpmPlatformRate', platform: string, cpm_rate_cents: number }>, allowed_platforms?: Array<string> | null, min_views_threshold?: number | null, currency: string, budget_total_cents: number, budget_remaining_cents: number, budget_pending_cents: number, required_hashtags?: string | null, invite_only: boolean, selected_only: boolean, is_selected_user: boolean, my_approved_platforms: Array<string>, is_joined: boolean, join_blocked_reason?: string | null, youtube_channels: Array<{ __typename?: 'MyYoutubeChannel', channel_id: string, name: string, thumbnail?: string | null, category?: string | null, is_autoclipper_partner?: boolean | null }> }> };

export type CpmClipperLeaderboardQueryVariables = Exact<{ [key: string]: never; }>;


export type CpmClipperLeaderboardQuery = { __typename?: 'Query', cpmClipperLeaderboard: Array<{ __typename?: 'CpmClipperLeaderboardEntry', user_id?: string | null, name?: string | null, avatar_url?: string | null, total_views: string, video_count: number, anonymous: boolean, views_tier_id?: string | null, families: Array<{ __typename?: 'ClipperRankFamily', id: string, featured_tier_id?: string | null, badges: Array<{ __typename?: 'ClipperRankBadge', tier_id: string, season_id?: string | null, season_name?: string | null }> }> }> };

export type MyCpmLeaderboardStandingQueryVariables = Exact<{ [key: string]: never; }>;


export type MyCpmLeaderboardStandingQuery = { __typename?: 'Query', myCpmLeaderboardStanding: { __typename?: 'CpmClipperLeaderboardStanding', rank?: number | null, total: number, entries: Array<{ __typename?: 'CpmClipperLeaderboardStandingEntry', rank: number, is_viewer: boolean, user_id?: string | null, name?: string | null, avatar_url?: string | null, total_views: string, video_count: number, anonymous: boolean, views_tier_id?: string | null, families: Array<{ __typename?: 'ClipperRankFamily', id: string, featured_tier_id?: string | null, badges: Array<{ __typename?: 'ClipperRankBadge', tier_id: string, season_id?: string | null, season_name?: string | null }> }> }> } };

export type MyCpmLeaderboardViewerQueryVariables = Exact<{ [key: string]: never; }>;


export type MyCpmLeaderboardViewerQuery = { __typename?: 'Query', myData: { __typename?: 'MyData', id: string, name?: string | null, profile_picture?: string | null, onboarding_objective?: string | null } };

export type MyCpmLeaderboardPrivacyQueryVariables = Exact<{ [key: string]: never; }>;


export type MyCpmLeaderboardPrivacyQuery = { __typename?: 'Query', myCpmLeaderboardPrivacy: { __typename?: 'MyCpmLeaderboardPrivacy', anonymous: boolean, can_remain_anonymous: boolean } };

export type SetMyCpmLeaderboardAnonymousMutationVariables = Exact<{
  anonymous: Scalars['Boolean']['input'];
}>;


export type SetMyCpmLeaderboardAnonymousMutation = { __typename?: 'Mutation', setMyCpmLeaderboardAnonymous: { __typename?: 'MyCpmLeaderboardPrivacy', anonymous: boolean, can_remain_anonymous: boolean } };

export type EarnPageEndedCampaignsQueryVariables = Exact<{ [key: string]: never; }>;


export type EarnPageEndedCampaignsQuery = { __typename?: 'Query', myCpmCampaigns: Array<{ __typename?: 'MyCpmCampaign', campaign_type?: string | null, ranking_config?: any | null, id: string, name: string, logo_url?: string | null, banner_url?: string | null, categories: Array<string>, currency: string, budget_total_cents: number, budget_remaining_cents: number, youtube_channels: Array<{ __typename?: 'MyYoutubeChannel', channel_id: string, name: string, thumbnail?: string | null }> }> };

export type EarnPageScheduledCampaignsQueryVariables = Exact<{ [key: string]: never; }>;


export type EarnPageScheduledCampaignsQuery = { __typename?: 'Query', myCpmCampaigns: Array<{ __typename?: 'MyCpmCampaign', campaign_type?: string | null, ranking_config?: any | null, id: string, name: string, logo_url?: string | null, banner_url?: string | null, categories: Array<string>, currency: string, cpm_rate_cents: number, start_date?: string | null, budget_total_cents: number, youtube_channels: Array<{ __typename?: 'MyYoutubeChannel', channel_id: string, name: string, thumbnail?: string | null }> }> };

export type CampaignChannelPickerQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']['input']>;
}>;


export type CampaignChannelPickerQuery = { __typename?: 'Query', communityChannels: Array<{ __typename?: 'MyYoutubeChannel', id: string, channel_id: string, name: string, thumbnail?: string | null }> };

export type CampaignLibraryPickerQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']['input']>;
  channelId?: InputMaybe<Scalars['ID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type CampaignLibraryPickerQuery = { __typename?: 'Query', communityLibraries: Array<{ __typename?: 'MyLibrary', id: string, name?: string | null, thumbnail_url?: string | null, youtube_download_id?: string | null, youtube_channels: Array<{ __typename?: 'MyYoutubeChannel', channel_id: string, name: string }> }> };

export type CampaignAdminUserPickerQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
}>;


export type CampaignAdminUserPickerQuery = { __typename?: 'Query', adminUsers: { __typename?: 'AdminUsersResponse', data: Array<{ __typename?: 'AdminUser', id: string, name?: string | null, email: string }> } };

export type AdminCpmCampaignSubmissionsQueryVariables = Exact<{
  campaignId: Scalars['ID']['input'];
  approval?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  suspectedDuplicatesOnly?: InputMaybe<Scalars['Boolean']['input']>;
  platform?: InputMaybe<Scalars['String']['input']>;
  validatedHashtags?: InputMaybe<Scalars['String']['input']>;
  pendingOlderThanHours?: InputMaybe<Scalars['Int']['input']>;
}>;


export type AdminCpmCampaignSubmissionsQuery = { __typename?: 'Query', adminCpmCampaignSubmissions: { __typename?: 'AdminCpmCampaignSubmissionsResponse', total: number, pageCount: number, data: Array<{ __typename?: 'AdminCpmCampaignSubmission', id: string, platform: string, url: string, admin_approval: string, validated_hashtags: string, disqualified: boolean, last_counted_views: string, accumulated_payout_cents: number, cpm_rate_override_cents?: number | null, last_view_sync_at?: string | null, latest_views?: string | null, approval_reason?: string | null, disqualification_reason?: string | null, admin_observation?: string | null, user_disqualified: boolean, user_id: string, user_email?: string | null, user_name?: string | null, createdAt: string, pending_appeal_id?: string | null, disapproved_at?: string | null, suspected_duplicate: boolean, suspected_duplicate_reason?: string | null, video_hash?: string | null, canonical_url?: string | null, content_review_group_id?: string | null, content_review_group_decision?: string | null, accrual_window_ends_at?: string | null, final_accrual_views?: string | null, final_accrual_captured_at?: string | null, final_accrual_source?: string | null, metrics_status?: string | null, metrics_error?: string | null, pre_approval: string, pre_approval_score?: number | null, pre_approval_at?: string | null, rules_check_failures: Array<string>, estimated_payout_cents?: number | null, media_duration_seconds?: number | null, pre_approval_gates?: any | null, rules_check?: any | null, rejection_images: Array<{ __typename?: 'CpmReviewImage', url: string, visibility: string }>, daily_views: Array<{ __typename?: 'CpmSubmissionViewSnapshot', date: string, views: string, likes: string, comments: string, shares: string }>, account_reliability: { __typename?: 'CpmAccountReliability', status: CpmAccountReliabilityStatus, score?: number | null, engagement_rate?: number | null, lifetime_views?: string | null, tracked_content?: number | null, username?: string | null } }> } };

export type AdminCpmCampaignSubmissionStatsQueryVariables = Exact<{
  campaignId: Scalars['ID']['input'];
}>;


export type AdminCpmCampaignSubmissionStatsQuery = { __typename?: 'Query', adminCpmCampaignSubmissions: { __typename?: 'AdminCpmCampaignSubmissionsResponse', stats: { __typename?: 'CpmSubmissionsAggregateStats', total_views: string, approved_views: string, paid_views: string, total_earnings_cents: number, total_submissions: number, daily_series: Array<{ __typename?: 'CpmSubmissionsTimeSeriesPoint', date: string, total_views: string, approved_paid_views: string, approved_unpaid_views: string, clip_count: number }> } } };

export type AdminCpmCampaignTopEarningClipsQueryVariables = Exact<{
  campaignId: Scalars['ID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type AdminCpmCampaignTopEarningClipsQuery = { __typename?: 'Query', adminCpmCampaignTopEarningClips: { __typename?: 'CpmTopEarningClipsPage', total: number, pageCount: number, data: Array<{ __typename?: 'CpmTopEarningClip', id: string, platform: string, url: string, user_name?: string | null, user_email?: string | null, views: string, earnings_cents: number }> } };

export type AdminEnqueueCpmSubmissionMediaDownloadMutationVariables = Exact<{
  submissionId: Scalars['ID']['input'];
}>;


export type AdminEnqueueCpmSubmissionMediaDownloadMutation = { __typename?: 'Mutation', adminEnqueueCpmSubmissionMediaDownload: { __typename?: 'AdminCpmSubmissionMediaDownload', id?: string | null, submission_id: string, status: string, provider?: string | null, video_url?: string | null, error?: string | null } };

export type AdminCpmSubmissionMediaDownloadQueryVariables = Exact<{
  submissionId: Scalars['ID']['input'];
}>;


export type AdminCpmSubmissionMediaDownloadQuery = { __typename?: 'Query', adminCpmSubmissionMediaDownload: { __typename?: 'AdminCpmSubmissionMediaDownload', id?: string | null, submission_id: string, status: string, provider?: string | null, video_url?: string | null, error?: string | null } };

export type AdminCreateCpmCampaignMutationVariables = Exact<{
  input: AdminCpmCampaignInput;
}>;


export type AdminCreateCpmCampaignMutation = { __typename?: 'Mutation', adminCreateCpmCampaign: { __typename?: 'AdminCpmCampaign', id: string, name: string, logo_url?: string | null, banner_url?: string | null, categories: Array<string>, status: string, watermark_image_url?: string | null, watermark_anchor?: string | null, watermark_size_percent?: number | null, watermark_opacity_percent?: number | null, watermark_margin_x_percent?: number | null, watermark_margin_y_percent?: number | null, enforced_post_layout?: any | null, enforced_subtitle_position?: any | null, editing_assets?: any | null } };

export type AdminUpdateCpmCampaignMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: AdminCpmCampaignInput;
}>;


export type AdminUpdateCpmCampaignMutation = { __typename?: 'Mutation', adminUpdateCpmCampaign: { __typename?: 'AdminCpmCampaign', id: string, name: string, logo_url?: string | null, banner_url?: string | null, categories: Array<string>, status: string, watermark_image_url?: string | null, watermark_anchor?: string | null, watermark_size_percent?: number | null, watermark_opacity_percent?: number | null, watermark_margin_x_percent?: number | null, watermark_margin_y_percent?: number | null, enforced_post_layout?: any | null, enforced_subtitle_position?: any | null, editing_assets?: any | null } };

export type AdminDeleteCpmCampaignMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  force?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type AdminDeleteCpmCampaignMutation = { __typename?: 'Mutation', adminDeleteCpmCampaign: boolean };

export type AdminRecomputeCpmCampaignPayoutsMutationVariables = Exact<{
  campaignId: Scalars['ID']['input'];
}>;


export type AdminRecomputeCpmCampaignPayoutsMutation = { __typename?: 'Mutation', adminRecomputeCpmCampaignPayouts: { __typename?: 'AdminCpmCampaignRecomputeResult', recomputed_count: number, changed_count: number, total_delta_cents: number } };

export type AdminReviewCpmCampaignSubmissionMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  approval: Scalars['String']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
  images?: InputMaybe<Array<CpmReviewImageInput> | CpmReviewImageInput>;
}>;


export type AdminReviewCpmCampaignSubmissionMutation = { __typename?: 'Mutation', adminReviewCpmCampaignSubmission: { __typename?: 'AdminCpmCampaignSubmission', id: string, admin_approval: string, approval_reason?: string | null, accumulated_payout_cents: number, disqualified: boolean, disqualification_reason?: string | null, last_counted_views: string, latest_views?: string | null, pending_appeal_id?: string | null, rejection_images: Array<{ __typename?: 'CpmReviewImage', url: string, visibility: string }> } };

export type AdminLinkCpmSubmissionContentMutationVariables = Exact<{
  submissionIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
}>;


export type AdminLinkCpmSubmissionContentMutation = { __typename?: 'Mutation', adminLinkCpmSubmissionContent: { __typename?: 'CpmContentReviewGroup', id: string, decision: string, decision_reason?: string | null, submission_ids: Array<string> } };

export type AdminSetCpmCampaignSubmissionObservationMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  observation?: InputMaybe<Scalars['String']['input']>;
}>;


export type AdminSetCpmCampaignSubmissionObservationMutation = { __typename?: 'Mutation', adminSetCpmCampaignSubmissionObservation: { __typename?: 'AdminCpmCampaignSubmission', id: string, admin_observation?: string | null } };

export type AdminSetCpmCampaignSubmissionCpmOverrideMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  cpm_rate_cents?: InputMaybe<Scalars['Int']['input']>;
}>;


export type AdminSetCpmCampaignSubmissionCpmOverrideMutation = { __typename?: 'Mutation', adminSetCpmCampaignSubmissionCpmOverride: { __typename?: 'AdminCpmCampaignSubmission', id: string, cpm_rate_override_cents?: number | null, accumulated_payout_cents: number, last_counted_views: string, latest_views?: string | null } };

export type AdminResolveSuspectedDuplicateMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  action: Scalars['String']['input'];
}>;


export type AdminResolveSuspectedDuplicateMutation = { __typename?: 'Mutation', adminResolveSuspectedDuplicate: { __typename?: 'AdminCpmCampaignSubmission', id: string, suspected_duplicate: boolean, suspected_duplicate_reason?: string | null, disqualified: boolean, disqualification_reason?: string | null, accumulated_payout_cents: number } };

export type AdminDisqualifyCpmCampaignSubmissionMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  reason: Scalars['String']['input'];
}>;


export type AdminDisqualifyCpmCampaignSubmissionMutation = { __typename?: 'Mutation', adminDisqualifyCpmCampaignSubmission: { __typename?: 'AdminCpmCampaignSubmission', id: string, disqualified: boolean, disqualification_reason?: string | null } };

export type AdminCpmCampaignParticipantsQueryVariables = Exact<{
  campaignId: Scalars['ID']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
  disqualifiedOnly?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type AdminCpmCampaignParticipantsQuery = { __typename?: 'Query', adminCpmCampaignParticipants: { __typename?: 'CpmCampaignParticipantsResult', total: number, pageCount: number, data: Array<{ __typename?: 'CpmCampaignParticipant', user_id: string, user_name?: string | null, user_email?: string | null, submission_count: number, approved_count: number, total_views: string, total_earnings_cents: number, disqualified: boolean, disqualification_reason?: string | null, disqualification_id?: string | null, first_submitted_at?: string | null }> } };

export type AdminDisqualifyCpmCampaignUserMutationVariables = Exact<{
  campaignId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
  reason: Scalars['String']['input'];
}>;


export type AdminDisqualifyCpmCampaignUserMutation = { __typename?: 'Mutation', adminDisqualifyCpmCampaignUser: { __typename?: 'CpmCampaignUserDisqualification', id: string, user_id?: string | null, reason: string, createdAt: string, reclaimed_cents?: number | null } };

export type AdminUndisqualifyCpmCampaignUserMutationVariables = Exact<{
  campaignId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
}>;


export type AdminUndisqualifyCpmCampaignUserMutation = { __typename?: 'Mutation', adminUndisqualifyCpmCampaignUser: boolean };

export type AdminForceUpdateCpmCampaignSubmissionViewMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type AdminForceUpdateCpmCampaignSubmissionViewMutation = { __typename?: 'Mutation', adminForceUpdateCpmCampaignSubmissionView: boolean };

export type AdminForceUpdateAllCpmCampaignSubmissionViewsMutationVariables = Exact<{
  campaignId: Scalars['ID']['input'];
}>;


export type AdminForceUpdateAllCpmCampaignSubmissionViewsMutation = { __typename?: 'Mutation', adminForceUpdateAllCpmCampaignSubmissionViews: number };

export type AdminSyncMissingCpmCampaignSubmissionViewsMutationVariables = Exact<{
  campaignId: Scalars['ID']['input'];
}>;


export type AdminSyncMissingCpmCampaignSubmissionViewsMutation = { __typename?: 'Mutation', adminSyncMissingCpmCampaignSubmissionViews: number };

export type AdminSetCpmCampaignSubmissionHashtagValidationMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  validated_hashtags: Scalars['String']['input'];
}>;


export type AdminSetCpmCampaignSubmissionHashtagValidationMutation = { __typename?: 'Mutation', adminSetCpmCampaignSubmissionHashtagValidation: boolean };

export type AdminCpmCampaignSubmissionAppealsQueryVariables = Exact<{
  campaignId: Scalars['ID']['input'];
  status?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type AdminCpmCampaignSubmissionAppealsQuery = { __typename?: 'Query', adminCpmCampaignSubmissionAppeals: { __typename?: 'CpmCampaignSubmissionAppealPage', total: number, pageCount: number, data: Array<{ __typename?: 'CpmCampaignSubmissionAppeal', id: string, submission_id?: string | null, user_name?: string | null, user_email?: string | null, platform?: string | null, url?: string | null, argument: string, extra_url?: string | null, evidence_image_urls: Array<string>, status: string, original_approval_reason?: string | null, reviewer_reply?: string | null, createdAt?: any | null, reviewed_at?: any | null, reviewer_images: Array<{ __typename?: 'CpmReviewImage', url: string, visibility: string }> }> } };

export type AdminReviewCpmCampaignSubmissionAppealMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  decision: Scalars['String']['input'];
  reply?: InputMaybe<Scalars['String']['input']>;
  images?: InputMaybe<Array<CpmReviewImageInput> | CpmReviewImageInput>;
}>;


export type AdminReviewCpmCampaignSubmissionAppealMutation = { __typename?: 'Mutation', adminReviewCpmCampaignSubmissionAppeal: { __typename?: 'CpmCampaignSubmissionAppeal', id: string, status: string, reviewer_reply?: string | null, reviewed_at?: any | null, submission_id?: string | null, reviewer_images: Array<{ __typename?: 'CpmReviewImage', url: string, visibility: string }> } };

export type AdminBulkReviewCpmCampaignSubmissionsMutationVariables = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type AdminBulkReviewCpmCampaignSubmissionsMutation = { __typename?: 'Mutation', adminBulkReviewCpmCampaignSubmissions: { __typename?: 'AdminBulkReviewResult', approved: number, skipped: Array<{ __typename?: 'AdminBulkReviewSkip', id: string, code: string }> } };

export type MyCpmWalletQueryVariables = Exact<{ [key: string]: never; }>;


export type MyCpmWalletQuery = { __typename?: 'Query', myCpmWallet: { __typename?: 'CpmWallet', total_earned_cents: number, total_paid_out_cents: number, pending_cents: number, pending_payout_cents: number, affiliate_pending_cents: number, available_cents: number, affiliate_earned_cents: number, producer_earned_cents: number, currency: string, pending_kind?: string | null, per_campaign_breakdown: Array<{ __typename?: 'CpmWalletCampaignEntry', campaign_id: string, campaign_name: string, earned_cents: number }> } };

export type AffiliateStatusFieldsFragment = { __typename?: 'MyAffiliateStatus', joined: boolean, blocked: boolean, blocked_reason?: string | null, code?: string | null, custom_code?: string | null, total_referred: number, terms_current_version: string, totals: { __typename?: 'AffiliateTotals', total_earned_cents: number, pending_cents: number, released_cents: number, payment_cents: number, course_cents: number, cpm_cents: number }, rates: { __typename?: 'AffiliateRates', payment: number, course: number, cpm: number }, earnings: Array<{ __typename?: 'AffiliateEarningEntry', id: string, amount_cents: number, commission_rate: number, status: string, source: string, payment_date?: string | null, payment_amount_cents: number, referred_user_name?: string | null, createdAt: string, releases_at?: string | null }>, referred_users: Array<{ __typename?: 'AffiliateReferredUser', id: string, name?: string | null, createdAt: string, has_paid: boolean, total_commission_cents: number }> };

export type MyPixVerificationQueryVariables = Exact<{ [key: string]: never; }>;


export type MyPixVerificationQuery = { __typename?: 'Query', myPixVerification?: { __typename?: 'MyPixVerification', id: string, cpf: string, status: string, review_reason?: string | null, submitted_at?: string | null, reviewed_at?: string | null, createdAt: string } | null };

export type SubmitMyPixVerificationMutationVariables = Exact<{
  cpf: Scalars['String']['input'];
  document_url: Scalars['String']['input'];
  document_back_url?: InputMaybe<Scalars['String']['input']>;
}>;


export type SubmitMyPixVerificationMutation = { __typename?: 'Mutation', submitMyPixVerification: { __typename?: 'MyPixVerification', id: string, cpf: string, status: string, review_reason?: string | null, submitted_at?: string | null, reviewed_at?: string | null, createdAt: string } };

export type AdminPixVerificationsQueryVariables = Exact<{
  status?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type AdminPixVerificationsQuery = { __typename?: 'Query', adminPixVerifications: { __typename?: 'AdminPixVerificationsResponse', total: number, pageCount: number, data: Array<{ __typename?: 'AdminPixVerification', id: string, cpf: string, status: string, review_reason?: string | null, submitted_at?: string | null, reviewed_at?: string | null, createdAt: string, document_url: string, document_back_url?: string | null, user_id?: string | null, user_email?: string | null, user_name?: string | null, reviewed_by_id?: string | null, reviewed_by_name?: string | null }> } };

export type AdminPixVerificationDocumentUrlQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  side?: InputMaybe<Scalars['String']['input']>;
}>;


export type AdminPixVerificationDocumentUrlQuery = { __typename?: 'Query', adminPixVerificationDocumentUrl: string };

export type AdminReviewPixVerificationMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  status: Scalars['String']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
}>;


export type AdminReviewPixVerificationMutation = { __typename?: 'Mutation', adminReviewPixVerification: { __typename?: 'AdminPixVerification', id: string, status: string, review_reason?: string | null, reviewed_at?: string | null, reviewed_by_id?: string | null, reviewed_by_name?: string | null } };

export type MyAffiliateStatusQueryVariables = Exact<{ [key: string]: never; }>;


export type MyAffiliateStatusQuery = { __typename?: 'Query', myAffiliateStatus: { __typename?: 'MyAffiliateStatus', joined: boolean, blocked: boolean, blocked_reason?: string | null, code?: string | null, custom_code?: string | null, total_referred: number, terms_current_version: string, totals: { __typename?: 'AffiliateTotals', total_earned_cents: number, pending_cents: number, released_cents: number, payment_cents: number, course_cents: number, cpm_cents: number }, rates: { __typename?: 'AffiliateRates', payment: number, course: number, cpm: number }, earnings: Array<{ __typename?: 'AffiliateEarningEntry', id: string, amount_cents: number, commission_rate: number, status: string, source: string, payment_date?: string | null, payment_amount_cents: number, referred_user_name?: string | null, createdAt: string, releases_at?: string | null }>, referred_users: Array<{ __typename?: 'AffiliateReferredUser', id: string, name?: string | null, createdAt: string, has_paid: boolean, total_commission_cents: number }> } };

export type AcceptAffiliateTermsMutationVariables = Exact<{
  version: Scalars['String']['input'];
}>;


export type AcceptAffiliateTermsMutation = { __typename?: 'Mutation', acceptAffiliateTerms: { __typename?: 'MyAffiliateStatus', joined: boolean, blocked: boolean, blocked_reason?: string | null, code?: string | null, custom_code?: string | null, total_referred: number, terms_current_version: string, totals: { __typename?: 'AffiliateTotals', total_earned_cents: number, pending_cents: number, released_cents: number, payment_cents: number, course_cents: number, cpm_cents: number }, rates: { __typename?: 'AffiliateRates', payment: number, course: number, cpm: number }, earnings: Array<{ __typename?: 'AffiliateEarningEntry', id: string, amount_cents: number, commission_rate: number, status: string, source: string, payment_date?: string | null, payment_amount_cents: number, referred_user_name?: string | null, createdAt: string, releases_at?: string | null }>, referred_users: Array<{ __typename?: 'AffiliateReferredUser', id: string, name?: string | null, createdAt: string, has_paid: boolean, total_commission_cents: number }> } };

export type SetMyAffiliateCustomCodeMutationVariables = Exact<{
  code: Scalars['String']['input'];
}>;


export type SetMyAffiliateCustomCodeMutation = { __typename?: 'Mutation', setMyAffiliateCustomCode: { __typename?: 'MyAffiliateStatus', joined: boolean, blocked: boolean, blocked_reason?: string | null, code?: string | null, custom_code?: string | null, total_referred: number, terms_current_version: string, totals: { __typename?: 'AffiliateTotals', total_earned_cents: number, pending_cents: number, released_cents: number, payment_cents: number, course_cents: number, cpm_cents: number }, rates: { __typename?: 'AffiliateRates', payment: number, course: number, cpm: number }, earnings: Array<{ __typename?: 'AffiliateEarningEntry', id: string, amount_cents: number, commission_rate: number, status: string, source: string, payment_date?: string | null, payment_amount_cents: number, referred_user_name?: string | null, createdAt: string, releases_at?: string | null }>, referred_users: Array<{ __typename?: 'AffiliateReferredUser', id: string, name?: string | null, createdAt: string, has_paid: boolean, total_commission_cents: number }> } };

export type MyAffiliateReferredUserEarningsQueryVariables = Exact<{
  userId: Scalars['ID']['input'];
}>;


export type MyAffiliateReferredUserEarningsQuery = { __typename?: 'Query', myAffiliateReferredUserEarnings: Array<{ __typename?: 'AffiliateReferredUserEarning', id: string, date: string, description?: string | null, source: string, payment_amount_cents: number, commission_cents: number, commission_rate: number, status: string }> };

export type ClaimReferralAttributionMutationVariables = Exact<{
  code: Scalars['String']['input'];
}>;


export type ClaimReferralAttributionMutation = { __typename?: 'Mutation', claimReferralAttribution: boolean };

export type AdminAffiliateEarningsQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']['input']>;
  kind?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type AdminAffiliateEarningsQuery = { __typename?: 'Query', adminAffiliateEarnings: { __typename?: 'AdminAffiliateEarningsResponse', total: number, data: Array<{ __typename?: 'AdminAffiliateEarning', id: string, kind: string, course_id?: string | null, course_title?: string | null, user_id: string, user_email?: string | null, user_name?: string | null, referred_user_email?: string | null, referred_user_name?: string | null, amount_cents: number, commission_rate: number, status: string, source: string, payment_date?: string | null, payment_amount_cents: number, payment_provider?: string | null, reversal_note?: string | null, createdAt: string }> } };

export type AdminCourseRevenueSharesQueryVariables = Exact<{
  courseId?: InputMaybe<Scalars['ID']['input']>;
  active?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type AdminCourseRevenueSharesQuery = { __typename?: 'Query', adminCourseRevenueShares: Array<{ __typename?: 'AdminCourseRevenueShare', id: string, course_id: string, course_title: string, user_id: string, user_email: string, user_name?: string | null, rate_percent: number, active: boolean, note?: string | null, createdAt: string, updatedAt: string, totals: { __typename?: 'CourseRevenueShareTotals', accrued_cents: number, pending_cents: number, available_cents: number, reversed_cents: number } }> };

export type AdminUpsertCourseRevenueShareMutationVariables = Exact<{
  id?: InputMaybe<Scalars['ID']['input']>;
  input: AdminCourseRevenueShareInput;
}>;


export type AdminUpsertCourseRevenueShareMutation = { __typename?: 'Mutation', adminUpsertCourseRevenueShare: { __typename?: 'AdminCourseRevenueShare', id: string, course_id: string, course_title: string, user_id: string, user_email: string, user_name?: string | null, rate_percent: number, active: boolean, note?: string | null, createdAt: string, updatedAt: string, totals: { __typename?: 'CourseRevenueShareTotals', accrued_cents: number, pending_cents: number, available_cents: number, reversed_cents: number } } };

export type AdminSetCourseRevenueShareActiveMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  active: Scalars['Boolean']['input'];
}>;


export type AdminSetCourseRevenueShareActiveMutation = { __typename?: 'Mutation', adminSetCourseRevenueShareActive: { __typename?: 'AdminCourseRevenueShare', id: string, active: boolean, updatedAt: string } };

export type MyCourseRoyaltiesQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type MyCourseRoyaltiesQuery = { __typename?: 'Query', myCourseRoyalties: { __typename?: 'MyCourseRoyalties', accrued_cents: string, pending_cents: string, available_cents: string, reversed_cents: string, configurations: Array<{ __typename?: 'CourseRoyaltyConfiguration', id: string, course_id: string, course_title: string, rate_percent: number, active: boolean }>, earnings: Array<{ __typename?: 'CourseRoyaltyEarning', id: string, course_id: string, course_title: string, sale_date: string, gross_amount_cents: string, royalty_cents: number, rate_percent: number, status: string, releases_at?: string | null }>, earnings_page_info: { __typename?: 'CourseRoyaltyEarningsPageInfo', has_more: boolean, next_cursor?: string | null } } };

export type AdminReverseAffiliateEarningMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
}>;


export type AdminReverseAffiliateEarningMutation = { __typename?: 'Mutation', adminReverseAffiliateEarning: boolean };

export type RequestCpmPayoutMutationVariables = Exact<{
  input: RequestCpmPayoutInput;
}>;


export type RequestCpmPayoutMutation = { __typename?: 'Mutation', requestCpmPayout: { __typename?: 'CpmPayoutRequest', id: string, status: string, amount_cents: number, currency: string, requested_at: string } };

export type AdminCpmPayoutsQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['ID']['input']>;
  kind?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type AdminCpmPayoutsQuery = { __typename?: 'Query', adminCpmPayouts: { __typename?: 'AdminCpmPayoutsResponse', total: number, data: Array<{ __typename?: 'AdminCpmPayout', id: string, user_id: string, user_email?: string | null, user_name?: string | null, amount_cents: number, currency: string, status: string, note?: string | null, paid_at?: string | null, requested_at?: string | null, bank_data?: any | null, breakdown?: any | null, kind?: string | null, redemption_data?: any | null, created_by_email?: string | null, createdAt: string, pix_verification_status?: string | null, pix_verification_review_reason?: string | null }> } };

export type RedeemWalletForPlanMutationVariables = Exact<{
  planId: Scalars['ID']['input'];
  yearly?: InputMaybe<Scalars['Boolean']['input']>;
  remainderMethod?: InputMaybe<Scalars['String']['input']>;
  document?: InputMaybe<Scalars['JSON']['input']>;
  coupon?: InputMaybe<Scalars['String']['input']>;
}>;


export type RedeemWalletForPlanMutation = { __typename?: 'Mutation', redeemWalletForPlan: { __typename?: 'RedeemWalletResult', status: string, checkout?: any | null, payoutDocumentId?: string | null } };

export type CancelMyWalletRedemptionHoldMutationVariables = Exact<{ [key: string]: never; }>;


export type CancelMyWalletRedemptionHoldMutation = { __typename?: 'Mutation', cancelMyWalletRedemptionHold: boolean };

export type RedeemWalletForExtraMinutesMutationVariables = Exact<{
  minutes: Scalars['Int']['input'];
  remainderMethod?: InputMaybe<Scalars['String']['input']>;
  document?: InputMaybe<Scalars['JSON']['input']>;
  returnUrl?: InputMaybe<Scalars['String']['input']>;
}>;


export type RedeemWalletForExtraMinutesMutation = { __typename?: 'Mutation', redeemWalletForExtraMinutes: { __typename?: 'RedeemWalletResult', status: string, checkout?: any | null, payoutDocumentId?: string | null } };

export type RenewPlanWithWalletMutationVariables = Exact<{
  remainderMethod?: InputMaybe<Scalars['String']['input']>;
  document?: InputMaybe<Scalars['JSON']['input']>;
  returnUrl?: InputMaybe<Scalars['String']['input']>;
}>;


export type RenewPlanWithWalletMutation = { __typename?: 'Mutation', renewPlanWithWallet: { __typename?: 'RedeemWalletResult', status: string, checkout?: any | null, payoutDocumentId?: string | null } };

export type AdminApproveCpmPayoutMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type AdminApproveCpmPayoutMutation = { __typename?: 'Mutation', adminApproveCpmPayout: { __typename?: 'AdminCpmPayout', id: string, status: string, paid_at?: string | null } };

export type AdminUserCpmWalletQueryVariables = Exact<{
  userId: Scalars['ID']['input'];
}>;


export type AdminUserCpmWalletQuery = { __typename?: 'Query', adminUserCpmWallet: { __typename?: 'AdminUserCpmWallet', user_id: string, total_earned_cents: number, total_paid_out_cents: number, available_cents: number, currency: string, payouts: Array<{ __typename?: 'AdminCpmPayout', id: string, amount_cents: number, currency: string, note?: string | null, paid_at?: string | null, created_by_email?: string | null, createdAt: string }> } };

export type AdminCreateCpmPayoutMutationVariables = Exact<{
  input: AdminCreateCpmPayoutInput;
}>;


export type AdminCreateCpmPayoutMutation = { __typename?: 'Mutation', adminCreateCpmPayout: { __typename?: 'AdminCpmPayout', id: string, user_id: string, user_email?: string | null, user_name?: string | null, amount_cents: number, currency: string, status: string, note?: string | null, paid_at?: string | null, requested_at?: string | null, created_by_email?: string | null, createdAt: string } };

export type AdminDeleteCpmPayoutMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type AdminDeleteCpmPayoutMutation = { __typename?: 'Mutation', adminDeleteCpmPayout: boolean };

export type AdminCpmCampaignChannelRequestsQueryVariables = Exact<{
  campaignId: Scalars['ID']['input'];
  status?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type AdminCpmCampaignChannelRequestsQuery = { __typename?: 'Query', adminCpmCampaignChannelRequests: { __typename?: 'AdminCpmCampaignChannelRequestsResponse', total: number, pageCount: number, data: Array<{ __typename?: 'AdminCpmCampaignChannelRequest', id: string, platform: string, submitted_url: string, handle?: string | null, status: string, review_reason?: string | null, reviewed_at?: string | null, createdAt: string, user_id: string, user_email?: string | null, user_name?: string | null, reviewed_by_id?: string | null, reviewed_by_name?: string | null, youtube_channel?: { __typename?: 'MyYoutubeChannel', id: string, name: string, handle?: string | null, thumbnail?: string | null, subscriber_count?: number | null } | null }> } };

export type CreateMyCpmCampaignChannelRequestMutationVariables = Exact<{
  campaignId: Scalars['ID']['input'];
  platform: Scalars['String']['input'];
  url: Scalars['String']['input'];
}>;


export type CreateMyCpmCampaignChannelRequestMutation = { __typename?: 'Mutation', createMyCpmCampaignChannelRequest: { __typename?: 'MyCpmCampaignChannelRequest', id: string, status: string, platform: string, handle?: string | null, submitted_url: string } };

export type DeleteMyCpmCampaignChannelRequestMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteMyCpmCampaignChannelRequestMutation = { __typename?: 'Mutation', deleteMyCpmCampaignChannelRequest: boolean };

export type AdminReviewCpmCampaignChannelRequestMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  status: Scalars['String']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
}>;


export type AdminReviewCpmCampaignChannelRequestMutation = { __typename?: 'Mutation', adminReviewCpmCampaignChannelRequest: { __typename?: 'AdminCpmCampaignChannelRequest', id: string, status: string, review_reason?: string | null, reviewed_at?: string | null } };

export type AdminRevokeCpmCampaignChannelRequestMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  reason: Scalars['String']['input'];
}>;


export type AdminRevokeCpmCampaignChannelRequestMutation = { __typename?: 'Mutation', adminRevokeCpmCampaignChannelRequest: { __typename?: 'AdminCpmCampaignChannelRequest', id: string, status: string, review_reason?: string | null, reviewed_at?: string | null } };

export type AdminInviteCpmCampaignUserMutationVariables = Exact<{
  campaignId: Scalars['ID']['input'];
  email: Scalars['String']['input'];
  platform: Scalars['String']['input'];
  channelUrl: Scalars['String']['input'];
}>;


export type AdminInviteCpmCampaignUserMutation = { __typename?: 'Mutation', adminInviteCpmCampaignUser: { __typename?: 'AdminCpmCampaignChannelRequest', id: string, status: string, platform: string, handle?: string | null, user_email?: string | null, reviewed_at?: string | null } };

export type AdminEmailFlowTriggersQueryVariables = Exact<{ [key: string]: never; }>;


export type AdminEmailFlowTriggersQuery = { __typename?: 'Query', adminEmailFlowTriggers: Array<{ __typename?: 'EmailFlowTrigger', key: string, label: string, variables: Array<string> }> };

export type AdminEmailFlowsQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
}>;


export type AdminEmailFlowsQuery = { __typename?: 'Query', adminEmailFlows: { __typename?: 'AdminEmailFlowsResponse', total: number, page: number, pageSize: number, data: Array<{ __typename?: 'AdminEmailFlow', id: string, name: string, slug: string, description?: string | null, trigger: string, is_active: boolean, is_transactional: boolean, is_editable: boolean, audience: string, stepsCount: number }> } };

export type AdminEmailFlowQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type AdminEmailFlowQuery = { __typename?: 'Query', adminEmailFlow?: { __typename?: 'AdminEmailFlow', id: string, name: string, slug: string, description?: string | null, trigger: string, is_active: boolean, is_transactional: boolean, is_editable: boolean, audience: string, stepsCount: number, steps: Array<{ __typename?: 'AdminEmailFlowStep', id: string, order: number, delay_minutes: number, subject_pt: string, body_pt: string, subject_en?: string | null, body_en?: string | null, is_active: boolean }> } | null };

export type AdminCreateEmailFlowMutationVariables = Exact<{
  input: AdminEmailFlowInput;
}>;


export type AdminCreateEmailFlowMutation = { __typename?: 'Mutation', adminCreateEmailFlow: { __typename?: 'AdminEmailFlow', id: string, name: string, slug: string, trigger: string, is_active: boolean, is_transactional: boolean, is_editable: boolean, audience: string, stepsCount: number } };

export type AdminUpdateEmailFlowMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: AdminEmailFlowUpdateInput;
}>;


export type AdminUpdateEmailFlowMutation = { __typename?: 'Mutation', adminUpdateEmailFlow: { __typename?: 'AdminEmailFlow', id: string, name: string, slug: string, description?: string | null, trigger: string, is_active: boolean, is_transactional: boolean, is_editable: boolean, audience: string, stepsCount: number } };

export type AdminDeleteEmailFlowMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type AdminDeleteEmailFlowMutation = { __typename?: 'Mutation', adminDeleteEmailFlow: boolean };

export type AdminUpsertEmailFlowStepMutationVariables = Exact<{
  input: AdminEmailFlowStepInput;
}>;


export type AdminUpsertEmailFlowStepMutation = { __typename?: 'Mutation', adminUpsertEmailFlowStep: { __typename?: 'AdminEmailFlowStep', id: string, order: number, delay_minutes: number, subject_pt: string, body_pt: string, subject_en?: string | null, body_en?: string | null, is_active: boolean } };

export type AdminDeleteEmailFlowStepMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type AdminDeleteEmailFlowStepMutation = { __typename?: 'Mutation', adminDeleteEmailFlowStep: boolean };

export type AdminReorderEmailFlowStepsMutationVariables = Exact<{
  flowId: Scalars['ID']['input'];
  stepIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type AdminReorderEmailFlowStepsMutation = { __typename?: 'Mutation', adminReorderEmailFlowSteps: Array<{ __typename?: 'AdminEmailFlowStep', id: string, order: number, delay_minutes: number, subject_pt: string, body_pt: string, subject_en?: string | null, body_en?: string | null, is_active: boolean }> };

export type AdminSendTestEmailFlowStepMutationVariables = Exact<{
  stepId: Scalars['ID']['input'];
  locale: Scalars['String']['input'];
  recipientEmail: Scalars['String']['input'];
}>;


export type AdminSendTestEmailFlowStepMutation = { __typename?: 'Mutation', adminSendTestEmailFlowStep: boolean };

export type AdminEmailFlowRunsQueryVariables = Exact<{
  flowId: Scalars['ID']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
}>;


export type AdminEmailFlowRunsQuery = { __typename?: 'Query', adminEmailFlowRuns: { __typename?: 'AdminEmailFlowRunsResponse', total: number, page: number, pageSize: number, data: Array<{ __typename?: 'AdminEmailFlowRun', id: string, user_email?: string | null, current_step_order?: number | null, status: string, started_at?: any | null, completed_at?: any | null, sendsCount: number }> } };

export type AdminEmailFlowRunSendsQueryVariables = Exact<{
  runId: Scalars['ID']['input'];
}>;


export type AdminEmailFlowRunSendsQuery = { __typename?: 'Query', adminEmailFlowRunSends: Array<{ __typename?: 'AdminEmailFlowSend', id: string, step_id?: string | null, step_order?: number | null, sent_at: any, success: boolean, error?: string | null, subject_used?: string | null, language_used?: string | null, is_test: boolean }> };

export type EffectiveWatermarkQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type EffectiveWatermarkQuery = { __typename?: 'Query', myProject?: { __typename?: 'MyProject', id: string, effective_post_layout?: any | null, effective_subtitle_position?: any | null, effective_watermark?: { __typename?: 'CampaignWatermark', image_url: string, anchor: string, size_percent: number, opacity_percent: number, margin_x_percent: number, margin_y_percent: number } | null } | null };

export type LibraryEffectiveWatermarkQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type LibraryEffectiveWatermarkQuery = { __typename?: 'Query', myLibrary?: { __typename?: 'MyLibrary', id: string, effective_post_layout?: any | null, effective_subtitle_position?: any | null, effective_watermark?: { __typename?: 'CampaignWatermark', image_url: string, anchor: string, size_percent: number, opacity_percent: number, margin_x_percent: number, margin_y_percent: number } | null, active_cpm_campaigns: Array<{ __typename?: 'MyCpmCampaign', id: string }> } | null };

export type FillerVideosQueryVariables = Exact<{
  category?: InputMaybe<Scalars['String']['input']>;
}>;


export type FillerVideosQuery = { __typename?: 'Query', fillerVideos: Array<{ __typename?: 'FillerVideo', id: string, name: string, categories: Array<string>, file_url: string, file_en_url?: string | null, thumbnail_url?: string | null }> };

export type FillerVideoTagsQueryVariables = Exact<{ [key: string]: never; }>;


export type FillerVideoTagsQuery = { __typename?: 'Query', fillerVideoTags: Array<{ __typename?: 'FillerVideoTag', slug: string, name: string }> };

export type MyUserMediaQueryVariables = Exact<{
  kind?: InputMaybe<Scalars['String']['input']>;
  folderId?: InputMaybe<Scalars['ID']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type MyUserMediaQuery = { __typename?: 'Query', myUserMedia: Array<{ __typename?: 'MyUserMedia', id: string, url: string, kind: string, name?: string | null, width?: number | null, height?: number | null, duration?: number | null, folder_id?: string | null, createdAt: string }> };

export type CreateMyUserMediaMutationVariables = Exact<{
  input: MyUserMediaCreateInput;
}>;


export type CreateMyUserMediaMutation = { __typename?: 'Mutation', createMyUserMedia: { __typename?: 'MyUserMedia', id: string, url: string, kind: string, name?: string | null, width?: number | null, height?: number | null, duration?: number | null, folder_id?: string | null, createdAt: string } };

export type MyUserMediaFoldersQueryVariables = Exact<{ [key: string]: never; }>;


export type MyUserMediaFoldersQuery = { __typename?: 'Query', myUserMediaFolders: Array<{ __typename?: 'MyUserMediaFolder', id: string, name: string, media_count: number, createdAt: string }> };

export type UpdateMyUserMediaMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: MyUserMediaUpdateInput;
}>;


export type UpdateMyUserMediaMutation = { __typename?: 'Mutation', updateMyUserMedia: { __typename?: 'MyUserMedia', id: string, url: string, kind: string, name?: string | null, width?: number | null, height?: number | null, duration?: number | null, folder_id?: string | null, createdAt: string } };

export type DeleteMyUserMediaMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteMyUserMediaMutation = { __typename?: 'Mutation', deleteMyUserMedia: boolean };

export type CreateMyUserMediaFolderMutationVariables = Exact<{
  name: Scalars['String']['input'];
}>;


export type CreateMyUserMediaFolderMutation = { __typename?: 'Mutation', createMyUserMediaFolder: { __typename?: 'MyUserMediaFolder', id: string, name: string, media_count: number, createdAt: string } };

export type UpdateMyUserMediaFolderMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
}>;


export type UpdateMyUserMediaFolderMutation = { __typename?: 'Mutation', updateMyUserMediaFolder: { __typename?: 'MyUserMediaFolder', id: string, name: string, media_count: number, createdAt: string } };

export type DeleteMyUserMediaFolderMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteMyUserMediaFolderMutation = { __typename?: 'Mutation', deleteMyUserMediaFolder: boolean };

export type StockMediaSearchQueryVariables = Exact<{
  kind: StockMediaKind;
  query?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  provider?: InputMaybe<StockMediaProvider>;
}>;


export type StockMediaSearchQuery = { __typename?: 'Query', stockMediaSearch: { __typename?: 'StockMediaSearchResult', page: number, has_more: boolean, items: Array<{ __typename?: 'StockMediaItem', id: string, provider: StockMediaProvider, kind: StockMediaKind, thumbnail_url: string, preview_url?: string | null, file_url: string, width: number, height: number, duration?: number | null, author?: string | null, author_url?: string | null, source_url?: string | null, download_location?: string | null }> } };

export type TrackStockMediaUseMutationVariables = Exact<{
  provider: StockMediaProvider;
  download_location: Scalars['String']['input'];
}>;


export type TrackStockMediaUseMutation = { __typename?: 'Mutation', trackStockMediaUse: boolean };

export type MyClipMcpGrantsQueryVariables = Exact<{ [key: string]: never; }>;


export type MyClipMcpGrantsQuery = { __typename?: 'Query', myClipMcpGrants: Array<{ __typename?: 'ClipMcpGrant', id: string, label?: string | null, expires_at?: any | null, revoked_at?: any | null, last_used_at?: any | null }> };

export type RevokeMyClipMcpGrantMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type RevokeMyClipMcpGrantMutation = { __typename?: 'Mutation', revokeMyClipMcpGrant?: { __typename?: 'ClipMcpGrant', id: string, label?: string | null, expires_at?: any | null, revoked_at?: any | null, last_used_at?: any | null } | null };

export type AdminCampaignLiveImportQueryVariables = Exact<{
  campaignId: Scalars['ID']['input'];
}>;


export type AdminCampaignLiveImportQuery = { __typename?: 'Query', adminCampaignLiveImport: { __typename?: 'AdminCampaignLiveImport', campaign_id: string, enabled: boolean, channel_id?: string | null, channel_name?: string | null, channel_thumbnail?: string | null, keywords: Array<string>, format: string, language: string, prompt?: string | null, notify_participants: boolean, enabled_at?: string | null, last_checked_at?: string | null, next_check_at?: string | null, last_error?: string | null, items: Array<{ __typename?: 'AdminCampaignLiveImportItem', id: string, video_id: string, title?: string | null, aired_at?: string | null, status: string, email_sent_at?: string | null, email_recipients?: number | null, updated_at?: string | null }> } };

export type AdminSaveCampaignLiveImportMutationVariables = Exact<{
  campaignId: Scalars['ID']['input'];
  input: AdminCampaignLiveImportInput;
}>;


export type AdminSaveCampaignLiveImportMutation = { __typename?: 'Mutation', adminSaveCampaignLiveImport: { __typename?: 'AdminCampaignLiveImport', campaign_id: string, enabled: boolean, channel_id?: string | null, channel_name?: string | null, channel_thumbnail?: string | null, keywords: Array<string>, format: string, language: string, prompt?: string | null, notify_participants: boolean, enabled_at?: string | null, last_checked_at?: string | null, next_check_at?: string | null, last_error?: string | null, items: Array<{ __typename?: 'AdminCampaignLiveImportItem', id: string, video_id: string, title?: string | null, aired_at?: string | null, status: string, email_sent_at?: string | null, email_recipients?: number | null, updated_at?: string | null }> } };

export type AdminRunCampaignLiveImportMutationVariables = Exact<{
  campaignId: Scalars['ID']['input'];
}>;


export type AdminRunCampaignLiveImportMutation = { __typename?: 'Mutation', adminRunCampaignLiveImport: { __typename?: 'AdminCampaignLiveImport', campaign_id: string, enabled: boolean, channel_id?: string | null, channel_name?: string | null, channel_thumbnail?: string | null, keywords: Array<string>, format: string, language: string, prompt?: string | null, notify_participants: boolean, enabled_at?: string | null, last_checked_at?: string | null, next_check_at?: string | null, last_error?: string | null, items: Array<{ __typename?: 'AdminCampaignLiveImportItem', id: string, video_id: string, title?: string | null, aired_at?: string | null, status: string, email_sent_at?: string | null, email_recipients?: number | null, updated_at?: string | null }> } };

export type MyClipperRankPreviewQueryVariables = Exact<{ [key: string]: never; }>;


export type MyClipperRankPreviewQuery = { __typename?: 'Query', myClipperRankPreview: { __typename?: 'MyClipperRankPreview', views_tier_id?: string | null, season_id?: string | null, season_name?: string | null, season_title_id?: string | null } };

export type MyClipperRanksQueryVariables = Exact<{ [key: string]: never; }>;


export type MyClipperRanksQuery = { __typename?: 'Query', myClipperRanks: { __typename?: 'MyClipperRanks', tracks: Array<{ __typename?: 'ClipperRankTrack', id: ClipperRankTrackId, metric: string, current_tier_id?: string | null, unlocked_tier_ids: Array<string>, next_threshold?: string | null }>, season_titles: Array<{ __typename?: 'ClipperSeasonTitle', season_id: string, season_name: string, title_id?: string | null, placement?: number | null }> } };

export type ClipperRankHallQueryVariables = Exact<{
  seasonId?: InputMaybe<Scalars['ID']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type ClipperRankHallQuery = { __typename?: 'Query', clipperRankHall: { __typename?: 'ClipperRankHall', season?: { __typename?: 'ClipperSeasonHall', id: string, name: string, status: string, ends_at?: string | null, entries: Array<{ __typename?: 'ClipperSeasonHallEntry', rank: number, user_id?: string | null, name?: string | null, avatar_url?: string | null, anonymous: boolean, title_id?: string | null, views_delta: string, video_count: number, families: Array<{ __typename?: 'ClipperRankFamily', id: string, featured_tier_id?: string | null, badges: Array<{ __typename?: 'ClipperRankBadge', tier_id: string, season_id?: string | null, season_name?: string | null }> }> }> } | null, clippers: Array<{ __typename?: 'ClipperHallClipper', user_id?: string | null, name?: string | null, avatar_url?: string | null, anonymous: boolean, current_tier_ids: Array<string>, lifetime_views: string, video_count: number, families: Array<{ __typename?: 'ClipperRankFamily', id: string, featured_tier_id?: string | null, badges: Array<{ __typename?: 'ClipperRankBadge', tier_id: string, season_id?: string | null, season_name?: string | null }> }> }>, page_info: { __typename?: 'ClipperRankHallPageInfo', offset: number, limit: number, total: number } } };

export type ClipperRankHallViewerQueryVariables = Exact<{ [key: string]: never; }>;


export type ClipperRankHallViewerQuery = { __typename?: 'Query', myData: { __typename?: 'MyData', id: string, name?: string | null, profile_picture?: string | null } };

export type AdminClipperSeasonsQueryVariables = Exact<{ [key: string]: never; }>;


export type AdminClipperSeasonsQuery = { __typename?: 'Query', adminClipperSeasons: Array<{ __typename?: 'ClipperSeasonAdmin', id: string, documentId: string, name: string, starts_at: string, ends_at: string, timezone: string, status: string, start_snapshotted_at?: string | null, consolidated_at?: string | null }> };

export type AdminCreateClipperSeasonMutationVariables = Exact<{
  name: Scalars['String']['input'];
  starts_at: Scalars['String']['input'];
  ends_at: Scalars['String']['input'];
}>;


export type AdminCreateClipperSeasonMutation = { __typename?: 'Mutation', adminCreateClipperSeason: { __typename?: 'ClipperSeasonAdmin', id: string, documentId: string, name: string, starts_at: string, ends_at: string, timezone: string, status: string, start_snapshotted_at?: string | null, consolidated_at?: string | null } };

export type AdminUpdateClipperSeasonMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  starts_at?: InputMaybe<Scalars['String']['input']>;
  ends_at?: InputMaybe<Scalars['String']['input']>;
}>;


export type AdminUpdateClipperSeasonMutation = { __typename?: 'Mutation', adminUpdateClipperSeason: { __typename?: 'ClipperSeasonAdmin', id: string, documentId: string, name: string, starts_at: string, ends_at: string, timezone: string, status: string, start_snapshotted_at?: string | null, consolidated_at?: string | null } };

export type AdminSnapshotClipperSeasonStartMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type AdminSnapshotClipperSeasonStartMutation = { __typename?: 'Mutation', adminSnapshotClipperSeasonStart: { __typename?: 'ClipperSeasonAdmin', id: string, documentId: string, name: string, starts_at: string, ends_at: string, timezone: string, status: string, start_snapshotted_at?: string | null, consolidated_at?: string | null } };

export type AdminConsolidateClipperSeasonMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type AdminConsolidateClipperSeasonMutation = { __typename?: 'Mutation', adminConsolidateClipperSeason: { __typename?: 'ClipperSeasonAdmin', id: string, documentId: string, name: string, starts_at: string, ends_at: string, timezone: string, status: string, start_snapshotted_at?: string | null, consolidated_at?: string | null } };

export type MyScheduledPublishesQueryVariables = Exact<{
  from: Scalars['DateTime']['input'];
  to: Scalars['DateTime']['input'];
}>;


export type MyScheduledPublishesQuery = { __typename?: 'Query', myScheduledPublishes: Array<{ __typename?: 'SocialPublish', id: string, platform: string, mode: string, status: string, caption?: string | null, fail_reason?: string | null, clip_id?: string | null, social_connection_id?: string | null, title?: string | null, description?: string | null, privacy_status?: string | null, made_for_kids?: boolean | null, provider_post_id?: string | null, facebook_post_kind?: string | null, scheduled_at?: any | null, cancelled_at?: any | null, createdAt?: any | null, media_kind: string, image_count: number, publish_queue?: { __typename?: 'PublishQueue', id: string, name: string } | null }> };

export type MyPostableClipsQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type MyPostableClipsQuery = { __typename?: 'Query', myPostableClips: Array<{ __typename?: 'PostableClip', id: string, name?: string | null, thumbnail_url?: string | null, finished_video_url?: string | null, createdAt?: any | null }> };

export type MyClipDisplayQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type MyClipDisplayQuery = { __typename?: 'Query', myClip?: { __typename?: 'MyClip', id: string, name?: string | null } | null };

export type CreateMyScheduledPublishMutationVariables = Exact<{
  input: ScheduledPublishInput;
}>;


export type CreateMyScheduledPublishMutation = { __typename?: 'Mutation', createMyScheduledPublish: { __typename?: 'SocialPublish', id: string, platform: string, mode: string, status: string, caption?: string | null, fail_reason?: string | null, clip_id?: string | null, social_connection_id?: string | null, title?: string | null, description?: string | null, privacy_status?: string | null, made_for_kids?: boolean | null, provider_post_id?: string | null, facebook_post_kind?: string | null, scheduled_at?: any | null, cancelled_at?: any | null, createdAt?: any | null, media_kind: string, image_count: number, publish_queue?: { __typename?: 'PublishQueue', id: string, name: string } | null } };

export type UpdateMyScheduledPublishMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: ScheduledPublishInput;
}>;


export type UpdateMyScheduledPublishMutation = { __typename?: 'Mutation', updateMyScheduledPublish: { __typename?: 'SocialPublish', id: string, platform: string, mode: string, status: string, caption?: string | null, fail_reason?: string | null, clip_id?: string | null, social_connection_id?: string | null, title?: string | null, description?: string | null, privacy_status?: string | null, made_for_kids?: boolean | null, provider_post_id?: string | null, facebook_post_kind?: string | null, scheduled_at?: any | null, cancelled_at?: any | null, createdAt?: any | null, media_kind: string, image_count: number, publish_queue?: { __typename?: 'PublishQueue', id: string, name: string } | null } };

export type CancelMyScheduledPublishMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type CancelMyScheduledPublishMutation = { __typename?: 'Mutation', cancelMyScheduledPublish: boolean };

export type SocialAnalyticsConnectionsQueryVariables = Exact<{ [key: string]: never; }>;


export type SocialAnalyticsConnectionsQuery = { __typename?: 'Query', socialAnalyticsConnections: Array<{ __typename?: 'MySocialConnection', id: string, platform: string, username: string, display_name: string, avatar_url?: string | null, status: string, analytics_sync_status: string, analytics_last_attempt_at?: string | null, analytics_last_success_at?: string | null, analytics_backfill_completed_at?: string | null, analytics_last_error_code?: string | null }> };

export type SocialAnalyticsSummaryQueryVariables = Exact<{
  range?: InputMaybe<SocialAnalyticsRange>;
  platforms?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  socialConnectionIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
}>;


export type SocialAnalyticsSummaryQuery = { __typename?: 'Query', socialAnalyticsSummary: { __typename?: 'SocialAnalyticsSummary', lifetime_views?: number | null, views_gained?: number | null, previous_period_views_gained?: number | null, total_likes?: number | null, total_comments?: number | null, total_shares?: number | null, engagement_rate?: number | null, tracked_content: number, selected_accounts: number, earliest_tracking_date?: string | null, latest_complete_sync_at?: string | null, daily: Array<{ __typename?: 'SocialAnalyticsDailyPoint', date: string, views_gained?: number | null }>, platform_breakdowns: Array<{ __typename?: 'SocialAnalyticsPlatformBreakdown', platform: string, tracked_content: number, lifetime_views?: number | null }>, account_breakdowns: Array<{ __typename?: 'SocialAnalyticsAccountBreakdown', id: string, platform: string, username: string, display_name?: string | null, avatar_url?: string | null, tracked_content: number, lifetime_views?: number | null, latest_complete_sync_at?: string | null }> } };

export type SocialAnalyticsMediaQueryVariables = Exact<{
  range?: InputMaybe<SocialAnalyticsRange>;
  platforms?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  socialConnectionIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  availability?: InputMaybe<Scalars['String']['input']>;
  mediaTypes?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  period?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  direction?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
}>;


export type SocialAnalyticsMediaQuery = { __typename?: 'Query', socialAnalyticsMedia: { __typename?: 'SocialAnalyticsMediaPage', data: Array<{ __typename?: 'SocialAnalyticsMediaRow', id: string, platform: string, media_type: string, canonical_url: string, title?: string | null, caption?: string | null, thumbnail_url?: string | null, published_at?: string | null, availability: string, views?: number | null, likes?: number | null, comments?: number | null, shares?: number | null, views_gained?: number | null, last_synced_at?: string | null, account?: { __typename?: 'SocialAnalyticsAccount', id: string, platform: string, username: string, display_name?: string | null, avatar_url?: string | null } | null }>, pagination: { __typename?: 'SocialAnalyticsPagination', page: number, page_size: number, page_count: number, total: number } } };

export type SocialAnalyticsCpmSubmissionsQueryVariables = Exact<{
  platforms?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
}>;


export type SocialAnalyticsCpmSubmissionsQuery = { __typename?: 'Query', socialAnalyticsCpmSubmissions: { __typename?: 'SocialAnalyticsCpmSubmissionPage', data: Array<{ __typename?: 'SocialAnalyticsCpmSubmission', id: string, platform: string, url: string, status?: string | null, disqualified: boolean, payout_qualified_views?: number | null, accumulated_payout_cents?: number | null, last_cpm_synced_at?: string | null, account?: { __typename?: 'SocialAnalyticsAccount', id: string, platform: string, username: string, display_name?: string | null, avatar_url?: string | null } | null, campaign?: { __typename?: 'SocialAnalyticsCampaign', id: string, name?: string | null } | null }>, pagination: { __typename?: 'SocialAnalyticsPagination', page: number, page_size: number, page_count: number, total: number } } };

export type RequestSocialAnalyticsRefreshMutationVariables = Exact<{
  socialConnectionIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
}>;


export type RequestSocialAnalyticsRefreshMutation = { __typename?: 'Mutation', requestSocialAnalyticsRefresh: Array<{ __typename?: 'SocialAnalyticsRefreshResult', connection_id: string, status: string, next_allowed_at?: string | null, error_code?: string | null }> };

export type SocialAnalyticsInsightsQueryVariables = Exact<{
  range?: InputMaybe<SocialAnalyticsRange>;
  platforms?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  socialConnectionIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  timezone: Scalars['String']['input'];
}>;


export type SocialAnalyticsInsightsQuery = { __typename?: 'Query', socialAnalyticsInsights: { __typename?: 'SocialAnalyticsInsights', eligible_posts: number, min_post_age_days: number, formats: Array<{ __typename?: 'SocialAnalyticsFormatInsight', media_type: string, posts: number, median_views?: number | null }>, hourly_slots: Array<{ __typename?: 'SocialAnalyticsHourlySlotInsight', weekday: number, hour: number, posts: number, median_views?: number | null }> } };

export type SocialAnalyticsMediaHistoryQueryVariables = Exact<{
  mediaId: Scalars['ID']['input'];
}>;


export type SocialAnalyticsMediaHistoryQuery = { __typename?: 'Query', socialAnalyticsMediaHistory: Array<{ __typename?: 'SocialAnalyticsMediaHistoryPoint', date: string, views?: number | null, likes?: number | null, comments?: number | null, shares?: number | null }> };

export type AdminSetFacebookConnectionsAccessMutationVariables = Exact<{
  userId: Scalars['ID']['input'];
  enabled: Scalars['Boolean']['input'];
}>;


export type AdminSetFacebookConnectionsAccessMutation = { __typename?: 'Mutation', adminSetFacebookConnectionsAccess: boolean };

export type SoundEffectsQueryVariables = Exact<{
  query?: InputMaybe<Scalars['String']['input']>;
  category?: InputMaybe<Scalars['String']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type SoundEffectsQuery = { __typename?: 'Query', soundEffects: Array<{ __typename?: 'SoundEffect', id: string, category: string, name: string, tags: Array<string>, duration: number, peak_at: number, url: string }> };

export type BrowseSoundEffectsQueryVariables = Exact<{
  query?: InputMaybe<Scalars['String']['input']>;
  category?: InputMaybe<Scalars['String']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type BrowseSoundEffectsQuery = { __typename?: 'Query', browseSoundEffects: { __typename?: 'SoundEffectsPage', total: number, has_more: boolean, items: Array<{ __typename?: 'SoundEffect', id: string, category: string, name: string, tags: Array<string>, duration: number, peak_at: number, url: string }> } };

export type TemplateSuggestionsQueryVariables = Exact<{
  status?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type TemplateSuggestionsQuery = { __typename?: 'Query', templateSuggestions: { __typename?: 'TemplateSuggestionsResponse', total: number, pageCount: number, data: Array<{ __typename?: 'TemplateSuggestion', viewer_has_voted: boolean }> } };

export type MyTemplateSuggestionsQueryVariables = Exact<{ [key: string]: never; }>;


export type MyTemplateSuggestionsQuery = { __typename?: 'Query', myTemplateSuggestions: Array<{ __typename?: 'MyTemplateSuggestion', review_reason?: string | null, reviewed_at?: string | null }> };

export type CreateMyTemplateSuggestionMutationVariables = Exact<{
  input: TemplateSuggestionInput;
}>;


export type CreateMyTemplateSuggestionMutation = { __typename?: 'Mutation', createMyTemplateSuggestion: { __typename?: 'TemplateSuggestionSubmitResult', duplicate_hidden: boolean, created?: { __typename?: 'MyTemplateSuggestion', review_reason?: string | null, reviewed_at?: string | null } | null, duplicate?: { __typename?: 'TemplateSuggestion', viewer_has_voted: boolean } | null } };

export type VoteTemplateSuggestionMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type VoteTemplateSuggestionMutation = { __typename?: 'Mutation', voteTemplateSuggestion: { __typename?: 'TemplateSuggestion', viewer_has_voted: boolean } };

export type UnvoteTemplateSuggestionMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type UnvoteTemplateSuggestionMutation = { __typename?: 'Mutation', unvoteTemplateSuggestion: { __typename?: 'TemplateSuggestion', viewer_has_voted: boolean } };

export type AdminTemplateSuggestionsQueryVariables = Exact<{
  status?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type AdminTemplateSuggestionsQuery = { __typename?: 'Query', adminTemplateSuggestions: { __typename?: 'AdminTemplateSuggestionsResponse', total: number, pageCount: number, data: Array<{ __typename?: 'AdminTemplateSuggestion', review_reason?: string | null, reviewed_at?: string | null, user_id?: string | null, user_email?: string | null, user_name?: string | null, reviewed_by_id?: string | null, reviewed_by_name?: string | null }> } };

export type AdminReviewTemplateSuggestionMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  status: Scalars['String']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
  brandKitId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type AdminReviewTemplateSuggestionMutation = { __typename?: 'Mutation', adminReviewTemplateSuggestion: { __typename?: 'AdminTemplateSuggestion', review_reason?: string | null, reviewed_at?: string | null, user_id?: string | null, user_email?: string | null, user_name?: string | null, reviewed_by_id?: string | null, reviewed_by_name?: string | null } };

export type MyViralizeQualificationQueryVariables = Exact<{ [key: string]: never; }>;


export type MyViralizeQualificationQuery = { __typename?: 'Query', myViralizeQualification?: { __typename?: 'ViralizeQualification', id: string, motivation?: string | null, starting_difficulty?: string | null, equipment?: Array<string> | null, monthly_income?: string | null, clipper_experience?: string | null, could_earn_more?: boolean | null, financially_stuck?: boolean | null, likes_current_job?: boolean | null, wants_remote_mobile_work?: boolean | null, self_employment_outlook?: string | null, first_30_day_revenue_outlook?: string | null, completed_at?: string | null } | null };

export type SaveMyViralizeQualificationAnswerMutationVariables = Exact<{
  input: SaveMyViralizeQualificationAnswerInput;
}>;


export type SaveMyViralizeQualificationAnswerMutation = { __typename?: 'Mutation', saveMyViralizeQualificationAnswer: { __typename?: 'ViralizeQualification', id: string, motivation?: string | null, starting_difficulty?: string | null, equipment?: Array<string> | null, monthly_income?: string | null, clipper_experience?: string | null, could_earn_more?: boolean | null, financially_stuck?: boolean | null, likes_current_job?: boolean | null, wants_remote_mobile_work?: boolean | null, self_employment_outlook?: string | null, first_30_day_revenue_outlook?: string | null, completed_at?: string | null } };

export type SaveMyViralizeQualificationContactMutationVariables = Exact<{
  name?: InputMaybe<Scalars['String']['input']>;
  phoneDetails?: InputMaybe<CoursePurchasePhoneInput>;
}>;


export type SaveMyViralizeQualificationContactMutation = { __typename?: 'Mutation', saveMyViralizeQualificationContact: { __typename?: 'MyData', id: string, name?: string | null, phone_number?: string | null } };

export type MyWalletMonthlyEarningsQueryVariables = Exact<{
  months?: InputMaybe<Scalars['Int']['input']>;
}>;


export type MyWalletMonthlyEarningsQuery = { __typename?: 'Query', myWalletMonthlyEarnings: { __typename?: 'WalletMonthlyEarnings', currency: string, months: Array<{ __typename?: 'WalletEarningsMonth', month: string, clips_cents: number, affiliate_cents: number, producer_cents: number, total_cents: number }> } };

export type WalletStatementLineFieldsFragment = { __typename?: 'WalletStatementLine', id: string, kind: string, at?: string | null, amount_cents: number, since_day?: string | null, source?: string | null, earning_kind?: string | null, referred_user_name?: string | null, course_title?: string | null, reversal_reason?: string | null, payout_kind?: string | null, payout_status?: string | null, paid_at?: string | null };

export type MyWalletStatementQueryVariables = Exact<{
  from?: InputMaybe<Scalars['String']['input']>;
  to?: InputMaybe<Scalars['String']['input']>;
}>;


export type MyWalletStatementQuery = { __typename?: 'Query', myWalletStatement: { __typename?: 'WalletStatement', from: string, to: string, today: string, opening_balance_cents?: number | null, current_balance_cents: number, first_snapshot_day?: string | null, upcoming: Array<{ __typename?: 'WalletStatementLine', id: string, kind: string, at?: string | null, amount_cents: number, since_day?: string | null, source?: string | null, earning_kind?: string | null, referred_user_name?: string | null, course_title?: string | null, reversal_reason?: string | null, payout_kind?: string | null, payout_status?: string | null, paid_at?: string | null }>, days: Array<{ __typename?: 'WalletStatementDay', day: string, closing_balance_cents?: number | null, lines: Array<{ __typename?: 'WalletStatementLine', id: string, kind: string, at?: string | null, amount_cents: number, since_day?: string | null, source?: string | null, earning_kind?: string | null, referred_user_name?: string | null, course_title?: string | null, reversal_reason?: string | null, payout_kind?: string | null, payout_status?: string | null, paid_at?: string | null }> }> } };

export const AppealKeepPendingIdFragmentDoc = gql`
    fragment AppealKeepPendingId on AdminCpmCampaignSubmission {
  pending_appeal_id
}
    `;
export const SubmissionHashtagValidationFragmentDoc = gql`
    fragment SubmissionHashtagValidation on AdminCpmCampaignSubmission {
  validated_hashtags
}
    `;
export const PublishQueueFieldsFragmentDoc = gql`
    fragment PublishQueueFields on PublishQueue {
  id
  name
  weekly_slots
  social_connection_ids
  multi_account_mode
  min_gap_minutes
  timezone
  spacing_scope
  active
}
    `;
export const PublishFieldsFragmentDoc = gql`
    fragment PublishFields on SocialPublish {
  id
  platform
  mode
  status
  caption
  fail_reason
  clip_id
  social_connection_id
  title
  description
  privacy_status
  made_for_kids
  provider_post_id
  facebook_post_kind
  scheduled_at
  cancelled_at
  createdAt
  media_kind
  image_count
  publish_queue {
    id
    name
  }
}
    `;
export const AffiliateStatusFieldsFragmentDoc = gql`
    fragment AffiliateStatusFields on MyAffiliateStatus {
  joined
  blocked
  blocked_reason
  code
  custom_code
  total_referred
  terms_current_version
  totals {
    total_earned_cents
    pending_cents
    released_cents
    payment_cents
    course_cents
    cpm_cents
  }
  rates {
    payment
    course
    cpm
  }
  earnings {
    id
    amount_cents
    commission_rate
    status
    source
    payment_date
    payment_amount_cents
    referred_user_name
    createdAt
    releases_at
  }
  referred_users {
    id
    name
    createdAt
    has_paid
    total_commission_cents
  }
}
    `;
export const WalletStatementLineFieldsFragmentDoc = gql`
    fragment WalletStatementLineFields on WalletStatementLine {
  id
  kind
  at
  amount_cents
  since_day
  source
  earning_kind
  referred_user_name
  course_title
  reversal_reason
  payout_kind
  payout_status
  paid_at
}
    `;
export const RecordOnboardingCourseOfferDocument = gql`
    mutation RecordOnboardingCourseOffer($event: String!, $experience: String) {
  recordOnboardingCourseOffer(event: $event, experience: $experience) {
    id
    onboarding_experience
  }
}
    `;
export type RecordOnboardingCourseOfferMutationFn = Apollo.MutationFunction<RecordOnboardingCourseOfferMutation, RecordOnboardingCourseOfferMutationVariables>;

/**
 * __useRecordOnboardingCourseOfferMutation__
 *
 * To run a mutation, you first call `useRecordOnboardingCourseOfferMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRecordOnboardingCourseOfferMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [recordOnboardingCourseOfferMutation, { data, loading, error }] = useRecordOnboardingCourseOfferMutation({
 *   variables: {
 *      event: // value for 'event'
 *      experience: // value for 'experience'
 *   },
 * });
 */
export function useRecordOnboardingCourseOfferMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<RecordOnboardingCourseOfferMutation, RecordOnboardingCourseOfferMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<RecordOnboardingCourseOfferMutation, RecordOnboardingCourseOfferMutationVariables>(RecordOnboardingCourseOfferDocument, options);
      }
export type RecordOnboardingCourseOfferMutationHookResult = ReturnType<typeof useRecordOnboardingCourseOfferMutation>;
export type RecordOnboardingCourseOfferMutationResult = Apollo.MutationResult<RecordOnboardingCourseOfferMutation>;
export type RecordOnboardingCourseOfferMutationOptions = Apollo.BaseMutationOptions<RecordOnboardingCourseOfferMutation, RecordOnboardingCourseOfferMutationVariables>;
export const AdminBrandLeadsDocument = gql`
    query AdminBrandLeads($page: Int, $pageSize: Int, $search: String) {
  adminBrandLeads(page: $page, pageSize: $pageSize, search: $search) {
    data {
      documentId
      name
      email
      phone
      phoneE164
      company
      state
      updatedAt
    }
    total
    page
    pageCount
  }
}
    `;

/**
 * __useAdminBrandLeadsQuery__
 *
 * To run a query within a React component, call `useAdminBrandLeadsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminBrandLeadsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminBrandLeadsQuery({
 *   variables: {
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useAdminBrandLeadsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<AdminBrandLeadsQuery, AdminBrandLeadsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AdminBrandLeadsQuery, AdminBrandLeadsQueryVariables>(AdminBrandLeadsDocument, options);
      }
export function useAdminBrandLeadsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AdminBrandLeadsQuery, AdminBrandLeadsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AdminBrandLeadsQuery, AdminBrandLeadsQueryVariables>(AdminBrandLeadsDocument, options);
        }
// @ts-ignore
export function useAdminBrandLeadsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<AdminBrandLeadsQuery, AdminBrandLeadsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AdminBrandLeadsQuery, AdminBrandLeadsQueryVariables>;
export function useAdminBrandLeadsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AdminBrandLeadsQuery, AdminBrandLeadsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AdminBrandLeadsQuery | undefined, AdminBrandLeadsQueryVariables>;
export function useAdminBrandLeadsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AdminBrandLeadsQuery, AdminBrandLeadsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<AdminBrandLeadsQuery, AdminBrandLeadsQueryVariables>(AdminBrandLeadsDocument, options);
        }
export type AdminBrandLeadsQueryHookResult = ReturnType<typeof useAdminBrandLeadsQuery>;
export type AdminBrandLeadsLazyQueryHookResult = ReturnType<typeof useAdminBrandLeadsLazyQuery>;
export type AdminBrandLeadsSuspenseQueryHookResult = ReturnType<typeof useAdminBrandLeadsSuspenseQuery>;
export type AdminBrandLeadsQueryResult = Apollo.QueryResult<AdminBrandLeadsQuery, AdminBrandLeadsQueryVariables>;
export const AdminCpmLeadDocument = gql`
    query AdminCpmLead($documentId: ID!) {
  adminCpmLead(documentId: $documentId) {
    documentId
    name
    email
    phone
    phoneE164
    company
    website
    social
    demandType
    objective
    contentType
    platforms
    budget
    source
    state
    brief
    iago
    messages {
      id
      direction
      actor
      text
      createdAt
    }
  }
}
    `;

/**
 * __useAdminCpmLeadQuery__
 *
 * To run a query within a React component, call `useAdminCpmLeadQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminCpmLeadQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminCpmLeadQuery({
 *   variables: {
 *      documentId: // value for 'documentId'
 *   },
 * });
 */
export function useAdminCpmLeadQuery(baseOptions: ApolloReactHooks.QueryHookOptions<AdminCpmLeadQuery, AdminCpmLeadQueryVariables> & ({ variables: AdminCpmLeadQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AdminCpmLeadQuery, AdminCpmLeadQueryVariables>(AdminCpmLeadDocument, options);
      }
export function useAdminCpmLeadLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AdminCpmLeadQuery, AdminCpmLeadQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AdminCpmLeadQuery, AdminCpmLeadQueryVariables>(AdminCpmLeadDocument, options);
        }
// @ts-ignore
export function useAdminCpmLeadSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<AdminCpmLeadQuery, AdminCpmLeadQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AdminCpmLeadQuery, AdminCpmLeadQueryVariables>;
export function useAdminCpmLeadSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AdminCpmLeadQuery, AdminCpmLeadQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AdminCpmLeadQuery | undefined, AdminCpmLeadQueryVariables>;
export function useAdminCpmLeadSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AdminCpmLeadQuery, AdminCpmLeadQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<AdminCpmLeadQuery, AdminCpmLeadQueryVariables>(AdminCpmLeadDocument, options);
        }
export type AdminCpmLeadQueryHookResult = ReturnType<typeof useAdminCpmLeadQuery>;
export type AdminCpmLeadLazyQueryHookResult = ReturnType<typeof useAdminCpmLeadLazyQuery>;
export type AdminCpmLeadSuspenseQueryHookResult = ReturnType<typeof useAdminCpmLeadSuspenseQuery>;
export type AdminCpmLeadQueryResult = Apollo.QueryResult<AdminCpmLeadQuery, AdminCpmLeadQueryVariables>;
export const AdminRestartCpmLeadDocument = gql`
    mutation AdminRestartCpmLead($documentId: ID!) {
  adminRestartCpmLead(documentId: $documentId) {
    id
    direction
    actor
    text
    createdAt
  }
}
    `;
export type AdminRestartCpmLeadMutationFn = Apollo.MutationFunction<AdminRestartCpmLeadMutation, AdminRestartCpmLeadMutationVariables>;

/**
 * __useAdminRestartCpmLeadMutation__
 *
 * To run a mutation, you first call `useAdminRestartCpmLeadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminRestartCpmLeadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminRestartCpmLeadMutation, { data, loading, error }] = useAdminRestartCpmLeadMutation({
 *   variables: {
 *      documentId: // value for 'documentId'
 *   },
 * });
 */
export function useAdminRestartCpmLeadMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AdminRestartCpmLeadMutation, AdminRestartCpmLeadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AdminRestartCpmLeadMutation, AdminRestartCpmLeadMutationVariables>(AdminRestartCpmLeadDocument, options);
      }
export type AdminRestartCpmLeadMutationHookResult = ReturnType<typeof useAdminRestartCpmLeadMutation>;
export type AdminRestartCpmLeadMutationResult = Apollo.MutationResult<AdminRestartCpmLeadMutation>;
export type AdminRestartCpmLeadMutationOptions = Apollo.BaseMutationOptions<AdminRestartCpmLeadMutation, AdminRestartCpmLeadMutationVariables>;
export const AdminReplyCpmLeadDocument = gql`
    mutation AdminReplyCpmLead($documentId: ID!, $text: String!) {
  adminReplyCpmLead(documentId: $documentId, text: $text) {
    id
    direction
    actor
    text
    createdAt
  }
}
    `;
export type AdminReplyCpmLeadMutationFn = Apollo.MutationFunction<AdminReplyCpmLeadMutation, AdminReplyCpmLeadMutationVariables>;

/**
 * __useAdminReplyCpmLeadMutation__
 *
 * To run a mutation, you first call `useAdminReplyCpmLeadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminReplyCpmLeadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminReplyCpmLeadMutation, { data, loading, error }] = useAdminReplyCpmLeadMutation({
 *   variables: {
 *      documentId: // value for 'documentId'
 *      text: // value for 'text'
 *   },
 * });
 */
export function useAdminReplyCpmLeadMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AdminReplyCpmLeadMutation, AdminReplyCpmLeadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AdminReplyCpmLeadMutation, AdminReplyCpmLeadMutationVariables>(AdminReplyCpmLeadDocument, options);
      }
export type AdminReplyCpmLeadMutationHookResult = ReturnType<typeof useAdminReplyCpmLeadMutation>;
export type AdminReplyCpmLeadMutationResult = Apollo.MutationResult<AdminReplyCpmLeadMutation>;
export type AdminReplyCpmLeadMutationOptions = Apollo.BaseMutationOptions<AdminReplyCpmLeadMutation, AdminReplyCpmLeadMutationVariables>;
export const YoutubeAudioTracksDocument = gql`
    query YoutubeAudioTracks($url: String!) {
  youtubeAudioTracks(url: $url) {
    status
    tracks {
      code
      language
      kind
      transcribable
    }
  }
}
    `;

/**
 * __useYoutubeAudioTracksQuery__
 *
 * To run a query within a React component, call `useYoutubeAudioTracksQuery` and pass it any options that fit your needs.
 * When your component renders, `useYoutubeAudioTracksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useYoutubeAudioTracksQuery({
 *   variables: {
 *      url: // value for 'url'
 *   },
 * });
 */
export function useYoutubeAudioTracksQuery(baseOptions: ApolloReactHooks.QueryHookOptions<YoutubeAudioTracksQuery, YoutubeAudioTracksQueryVariables> & ({ variables: YoutubeAudioTracksQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<YoutubeAudioTracksQuery, YoutubeAudioTracksQueryVariables>(YoutubeAudioTracksDocument, options);
      }
export function useYoutubeAudioTracksLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<YoutubeAudioTracksQuery, YoutubeAudioTracksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<YoutubeAudioTracksQuery, YoutubeAudioTracksQueryVariables>(YoutubeAudioTracksDocument, options);
        }
// @ts-ignore
export function useYoutubeAudioTracksSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<YoutubeAudioTracksQuery, YoutubeAudioTracksQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<YoutubeAudioTracksQuery, YoutubeAudioTracksQueryVariables>;
export function useYoutubeAudioTracksSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<YoutubeAudioTracksQuery, YoutubeAudioTracksQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<YoutubeAudioTracksQuery | undefined, YoutubeAudioTracksQueryVariables>;
export function useYoutubeAudioTracksSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<YoutubeAudioTracksQuery, YoutubeAudioTracksQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<YoutubeAudioTracksQuery, YoutubeAudioTracksQueryVariables>(YoutubeAudioTracksDocument, options);
        }
export type YoutubeAudioTracksQueryHookResult = ReturnType<typeof useYoutubeAudioTracksQuery>;
export type YoutubeAudioTracksLazyQueryHookResult = ReturnType<typeof useYoutubeAudioTracksLazyQuery>;
export type YoutubeAudioTracksSuspenseQueryHookResult = ReturnType<typeof useYoutubeAudioTracksSuspenseQuery>;
export type YoutubeAudioTracksQueryResult = Apollo.QueryResult<YoutubeAudioTracksQuery, YoutubeAudioTracksQueryVariables>;
export const AdminBrandLeadSubmissionsDocument = gql`
    query AdminBrandLeadSubmissions($page: Int, $pageSize: Int, $search: String, $origin: String) {
  adminBrandLeadSubmissions(
    page: $page
    pageSize: $pageSize
    search: $search
    origin: $origin
  ) {
    data {
      documentId
      isDuplicate
      submittedAt
      lead {
        documentId
        name
        email
        phone
        website
        social
        company
        demandType
        objective
        contentType
        platforms
        budget
        source
        utm
        createdAt
        updatedAt
      }
    }
    total
    page
    pageSize
    pageCount
    originCounts {
      app
      site
      marcas
      other
    }
  }
}
    `;

/**
 * __useAdminBrandLeadSubmissionsQuery__
 *
 * To run a query within a React component, call `useAdminBrandLeadSubmissionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminBrandLeadSubmissionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminBrandLeadSubmissionsQuery({
 *   variables: {
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *      search: // value for 'search'
 *      origin: // value for 'origin'
 *   },
 * });
 */
export function useAdminBrandLeadSubmissionsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<AdminBrandLeadSubmissionsQuery, AdminBrandLeadSubmissionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AdminBrandLeadSubmissionsQuery, AdminBrandLeadSubmissionsQueryVariables>(AdminBrandLeadSubmissionsDocument, options);
      }
export function useAdminBrandLeadSubmissionsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AdminBrandLeadSubmissionsQuery, AdminBrandLeadSubmissionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AdminBrandLeadSubmissionsQuery, AdminBrandLeadSubmissionsQueryVariables>(AdminBrandLeadSubmissionsDocument, options);
        }
// @ts-ignore
export function useAdminBrandLeadSubmissionsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<AdminBrandLeadSubmissionsQuery, AdminBrandLeadSubmissionsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AdminBrandLeadSubmissionsQuery, AdminBrandLeadSubmissionsQueryVariables>;
export function useAdminBrandLeadSubmissionsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AdminBrandLeadSubmissionsQuery, AdminBrandLeadSubmissionsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AdminBrandLeadSubmissionsQuery | undefined, AdminBrandLeadSubmissionsQueryVariables>;
export function useAdminBrandLeadSubmissionsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AdminBrandLeadSubmissionsQuery, AdminBrandLeadSubmissionsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<AdminBrandLeadSubmissionsQuery, AdminBrandLeadSubmissionsQueryVariables>(AdminBrandLeadSubmissionsDocument, options);
        }
export type AdminBrandLeadSubmissionsQueryHookResult = ReturnType<typeof useAdminBrandLeadSubmissionsQuery>;
export type AdminBrandLeadSubmissionsLazyQueryHookResult = ReturnType<typeof useAdminBrandLeadSubmissionsLazyQuery>;
export type AdminBrandLeadSubmissionsSuspenseQueryHookResult = ReturnType<typeof useAdminBrandLeadSubmissionsSuspenseQuery>;
export type AdminBrandLeadSubmissionsQueryResult = Apollo.QueryResult<AdminBrandLeadSubmissionsQuery, AdminBrandLeadSubmissionsQueryVariables>;
export const CreateBrandLeadFromAppDocument = gql`
    mutation CreateBrandLeadFromApp($data: BrandLeadInput!) {
  createBrandLead(data: $data) {
    documentId
  }
}
    `;
export type CreateBrandLeadFromAppMutationFn = Apollo.MutationFunction<CreateBrandLeadFromAppMutation, CreateBrandLeadFromAppMutationVariables>;

/**
 * __useCreateBrandLeadFromAppMutation__
 *
 * To run a mutation, you first call `useCreateBrandLeadFromAppMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateBrandLeadFromAppMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createBrandLeadFromAppMutation, { data, loading, error }] = useCreateBrandLeadFromAppMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateBrandLeadFromAppMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateBrandLeadFromAppMutation, CreateBrandLeadFromAppMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateBrandLeadFromAppMutation, CreateBrandLeadFromAppMutationVariables>(CreateBrandLeadFromAppDocument, options);
      }
export type CreateBrandLeadFromAppMutationHookResult = ReturnType<typeof useCreateBrandLeadFromAppMutation>;
export type CreateBrandLeadFromAppMutationResult = Apollo.MutationResult<CreateBrandLeadFromAppMutation>;
export type CreateBrandLeadFromAppMutationOptions = Apollo.BaseMutationOptions<CreateBrandLeadFromAppMutation, CreateBrandLeadFromAppMutationVariables>;
export const CampaignAuditAccessDocument = gql`
    query CampaignAuditAccess {
  adminCpmCampaigns(limit: 1) {
    total
  }
}
    `;

/**
 * __useCampaignAuditAccessQuery__
 *
 * To run a query within a React component, call `useCampaignAuditAccessQuery` and pass it any options that fit your needs.
 * When your component renders, `useCampaignAuditAccessQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCampaignAuditAccessQuery({
 *   variables: {
 *   },
 * });
 */
export function useCampaignAuditAccessQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<CampaignAuditAccessQuery, CampaignAuditAccessQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<CampaignAuditAccessQuery, CampaignAuditAccessQueryVariables>(CampaignAuditAccessDocument, options);
      }
export function useCampaignAuditAccessLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CampaignAuditAccessQuery, CampaignAuditAccessQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<CampaignAuditAccessQuery, CampaignAuditAccessQueryVariables>(CampaignAuditAccessDocument, options);
        }
// @ts-ignore
export function useCampaignAuditAccessSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<CampaignAuditAccessQuery, CampaignAuditAccessQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<CampaignAuditAccessQuery, CampaignAuditAccessQueryVariables>;
export function useCampaignAuditAccessSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<CampaignAuditAccessQuery, CampaignAuditAccessQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<CampaignAuditAccessQuery | undefined, CampaignAuditAccessQueryVariables>;
export function useCampaignAuditAccessSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<CampaignAuditAccessQuery, CampaignAuditAccessQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<CampaignAuditAccessQuery, CampaignAuditAccessQueryVariables>(CampaignAuditAccessDocument, options);
        }
export type CampaignAuditAccessQueryHookResult = ReturnType<typeof useCampaignAuditAccessQuery>;
export type CampaignAuditAccessLazyQueryHookResult = ReturnType<typeof useCampaignAuditAccessLazyQuery>;
export type CampaignAuditAccessSuspenseQueryHookResult = ReturnType<typeof useCampaignAuditAccessSuspenseQuery>;
export type CampaignAuditAccessQueryResult = Apollo.QueryResult<CampaignAuditAccessQuery, CampaignAuditAccessQueryVariables>;
export const AdminCpmCampaignContentDocument = gql`
    query AdminCpmCampaignContent($campaignId: ID!) {
  adminCpmCampaignContent(campaignId: $campaignId) {
    id
    name
    description
    rules_allowed
    rules_forbidden
    rules_attention
    rules_warning
    required_hashtags
    required_mention
    banner_url
    logo_url
    content_locked
    editing_locked_reason
    scheduled_activation_at
  }
}
    `;

/**
 * __useAdminCpmCampaignContentQuery__
 *
 * To run a query within a React component, call `useAdminCpmCampaignContentQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminCpmCampaignContentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminCpmCampaignContentQuery({
 *   variables: {
 *      campaignId: // value for 'campaignId'
 *   },
 * });
 */
export function useAdminCpmCampaignContentQuery(baseOptions: ApolloReactHooks.QueryHookOptions<AdminCpmCampaignContentQuery, AdminCpmCampaignContentQueryVariables> & ({ variables: AdminCpmCampaignContentQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AdminCpmCampaignContentQuery, AdminCpmCampaignContentQueryVariables>(AdminCpmCampaignContentDocument, options);
      }
export function useAdminCpmCampaignContentLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AdminCpmCampaignContentQuery, AdminCpmCampaignContentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AdminCpmCampaignContentQuery, AdminCpmCampaignContentQueryVariables>(AdminCpmCampaignContentDocument, options);
        }
// @ts-ignore
export function useAdminCpmCampaignContentSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<AdminCpmCampaignContentQuery, AdminCpmCampaignContentQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AdminCpmCampaignContentQuery, AdminCpmCampaignContentQueryVariables>;
export function useAdminCpmCampaignContentSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AdminCpmCampaignContentQuery, AdminCpmCampaignContentQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AdminCpmCampaignContentQuery | undefined, AdminCpmCampaignContentQueryVariables>;
export function useAdminCpmCampaignContentSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AdminCpmCampaignContentQuery, AdminCpmCampaignContentQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<AdminCpmCampaignContentQuery, AdminCpmCampaignContentQueryVariables>(AdminCpmCampaignContentDocument, options);
        }
export type AdminCpmCampaignContentQueryHookResult = ReturnType<typeof useAdminCpmCampaignContentQuery>;
export type AdminCpmCampaignContentLazyQueryHookResult = ReturnType<typeof useAdminCpmCampaignContentLazyQuery>;
export type AdminCpmCampaignContentSuspenseQueryHookResult = ReturnType<typeof useAdminCpmCampaignContentSuspenseQuery>;
export type AdminCpmCampaignContentQueryResult = Apollo.QueryResult<AdminCpmCampaignContentQuery, AdminCpmCampaignContentQueryVariables>;
export const AdminUpdateCpmCampaignContentDocument = gql`
    mutation AdminUpdateCpmCampaignContent($campaignId: ID!, $input: CampaignAuditContentInput!) {
  adminUpdateCpmCampaignContent(campaignId: $campaignId, input: $input) {
    id
    name
    description
    rules_allowed
    rules_forbidden
    rules_attention
    rules_warning
    required_hashtags
    required_mention
    banner_url
    logo_url
    content_locked
    editing_locked_reason
    scheduled_activation_at
  }
}
    `;
export type AdminUpdateCpmCampaignContentMutationFn = Apollo.MutationFunction<AdminUpdateCpmCampaignContentMutation, AdminUpdateCpmCampaignContentMutationVariables>;

/**
 * __useAdminUpdateCpmCampaignContentMutation__
 *
 * To run a mutation, you first call `useAdminUpdateCpmCampaignContentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminUpdateCpmCampaignContentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminUpdateCpmCampaignContentMutation, { data, loading, error }] = useAdminUpdateCpmCampaignContentMutation({
 *   variables: {
 *      campaignId: // value for 'campaignId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdminUpdateCpmCampaignContentMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AdminUpdateCpmCampaignContentMutation, AdminUpdateCpmCampaignContentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AdminUpdateCpmCampaignContentMutation, AdminUpdateCpmCampaignContentMutationVariables>(AdminUpdateCpmCampaignContentDocument, options);
      }
export type AdminUpdateCpmCampaignContentMutationHookResult = ReturnType<typeof useAdminUpdateCpmCampaignContentMutation>;
export type AdminUpdateCpmCampaignContentMutationResult = Apollo.MutationResult<AdminUpdateCpmCampaignContentMutation>;
export type AdminUpdateCpmCampaignContentMutationOptions = Apollo.BaseMutationOptions<AdminUpdateCpmCampaignContentMutation, AdminUpdateCpmCampaignContentMutationVariables>;
export const MyCampaignEntryDocument = gql`
    query MyCampaignEntry {
  myCampaignEntry {
    account_id
    campaign_id
    skip_onboarding
  }
}
    `;

/**
 * __useMyCampaignEntryQuery__
 *
 * To run a query within a React component, call `useMyCampaignEntryQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyCampaignEntryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyCampaignEntryQuery({
 *   variables: {
 *   },
 * });
 */
export function useMyCampaignEntryQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<MyCampaignEntryQuery, MyCampaignEntryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<MyCampaignEntryQuery, MyCampaignEntryQueryVariables>(MyCampaignEntryDocument, options);
      }
export function useMyCampaignEntryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<MyCampaignEntryQuery, MyCampaignEntryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<MyCampaignEntryQuery, MyCampaignEntryQueryVariables>(MyCampaignEntryDocument, options);
        }
// @ts-ignore
export function useMyCampaignEntrySuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<MyCampaignEntryQuery, MyCampaignEntryQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<MyCampaignEntryQuery, MyCampaignEntryQueryVariables>;
export function useMyCampaignEntrySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<MyCampaignEntryQuery, MyCampaignEntryQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<MyCampaignEntryQuery | undefined, MyCampaignEntryQueryVariables>;
export function useMyCampaignEntrySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<MyCampaignEntryQuery, MyCampaignEntryQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<MyCampaignEntryQuery, MyCampaignEntryQueryVariables>(MyCampaignEntryDocument, options);
        }
export type MyCampaignEntryQueryHookResult = ReturnType<typeof useMyCampaignEntryQuery>;
export type MyCampaignEntryLazyQueryHookResult = ReturnType<typeof useMyCampaignEntryLazyQuery>;
export type MyCampaignEntrySuspenseQueryHookResult = ReturnType<typeof useMyCampaignEntrySuspenseQuery>;
export type MyCampaignEntryQueryResult = Apollo.QueryResult<MyCampaignEntryQuery, MyCampaignEntryQueryVariables>;
export const CompleteMyCampaignEntryDocument = gql`
    mutation CompleteMyCampaignEntry($campaignId: ID!) {
  completeMyCampaignEntry(campaignId: $campaignId) {
    account_id
    campaign_id
    skip_onboarding
  }
}
    `;
export type CompleteMyCampaignEntryMutationFn = Apollo.MutationFunction<CompleteMyCampaignEntryMutation, CompleteMyCampaignEntryMutationVariables>;

/**
 * __useCompleteMyCampaignEntryMutation__
 *
 * To run a mutation, you first call `useCompleteMyCampaignEntryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCompleteMyCampaignEntryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [completeMyCampaignEntryMutation, { data, loading, error }] = useCompleteMyCampaignEntryMutation({
 *   variables: {
 *      campaignId: // value for 'campaignId'
 *   },
 * });
 */
export function useCompleteMyCampaignEntryMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CompleteMyCampaignEntryMutation, CompleteMyCampaignEntryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CompleteMyCampaignEntryMutation, CompleteMyCampaignEntryMutationVariables>(CompleteMyCampaignEntryDocument, options);
      }
export type CompleteMyCampaignEntryMutationHookResult = ReturnType<typeof useCompleteMyCampaignEntryMutation>;
export type CompleteMyCampaignEntryMutationResult = Apollo.MutationResult<CompleteMyCampaignEntryMutation>;
export type CompleteMyCampaignEntryMutationOptions = Apollo.BaseMutationOptions<CompleteMyCampaignEntryMutation, CompleteMyCampaignEntryMutationVariables>;
export const SuperHeroPromotionDocument = gql`
    query SuperHeroPromotion($id: ID!) {
  adminCpmCampaign(id: $id) {
    id
    name
    status
    campaign_type
    end_date
    ranking_config
    logo_url
    banner_url
  }
}
    `;

/**
 * __useSuperHeroPromotionQuery__
 *
 * To run a query within a React component, call `useSuperHeroPromotionQuery` and pass it any options that fit your needs.
 * When your component renders, `useSuperHeroPromotionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSuperHeroPromotionQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSuperHeroPromotionQuery(baseOptions: ApolloReactHooks.QueryHookOptions<SuperHeroPromotionQuery, SuperHeroPromotionQueryVariables> & ({ variables: SuperHeroPromotionQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SuperHeroPromotionQuery, SuperHeroPromotionQueryVariables>(SuperHeroPromotionDocument, options);
      }
export function useSuperHeroPromotionLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SuperHeroPromotionQuery, SuperHeroPromotionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SuperHeroPromotionQuery, SuperHeroPromotionQueryVariables>(SuperHeroPromotionDocument, options);
        }
// @ts-ignore
export function useSuperHeroPromotionSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<SuperHeroPromotionQuery, SuperHeroPromotionQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SuperHeroPromotionQuery, SuperHeroPromotionQueryVariables>;
export function useSuperHeroPromotionSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SuperHeroPromotionQuery, SuperHeroPromotionQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SuperHeroPromotionQuery | undefined, SuperHeroPromotionQueryVariables>;
export function useSuperHeroPromotionSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SuperHeroPromotionQuery, SuperHeroPromotionQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<SuperHeroPromotionQuery, SuperHeroPromotionQueryVariables>(SuperHeroPromotionDocument, options);
        }
export type SuperHeroPromotionQueryHookResult = ReturnType<typeof useSuperHeroPromotionQuery>;
export type SuperHeroPromotionLazyQueryHookResult = ReturnType<typeof useSuperHeroPromotionLazyQuery>;
export type SuperHeroPromotionSuspenseQueryHookResult = ReturnType<typeof useSuperHeroPromotionSuspenseQuery>;
export type SuperHeroPromotionQueryResult = Apollo.QueryResult<SuperHeroPromotionQuery, SuperHeroPromotionQueryVariables>;
export const MyClipRenderDataDocument = gql`
    query MyClipRenderData($id: ID!, $input: JSON!) {
  myClipRenderData(id: $id, input: $input)
}
    `;

/**
 * __useMyClipRenderDataQuery__
 *
 * To run a query within a React component, call `useMyClipRenderDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyClipRenderDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyClipRenderDataQuery({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMyClipRenderDataQuery(baseOptions: ApolloReactHooks.QueryHookOptions<MyClipRenderDataQuery, MyClipRenderDataQueryVariables> & ({ variables: MyClipRenderDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<MyClipRenderDataQuery, MyClipRenderDataQueryVariables>(MyClipRenderDataDocument, options);
      }
export function useMyClipRenderDataLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<MyClipRenderDataQuery, MyClipRenderDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<MyClipRenderDataQuery, MyClipRenderDataQueryVariables>(MyClipRenderDataDocument, options);
        }
// @ts-ignore
export function useMyClipRenderDataSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<MyClipRenderDataQuery, MyClipRenderDataQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<MyClipRenderDataQuery, MyClipRenderDataQueryVariables>;
export function useMyClipRenderDataSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<MyClipRenderDataQuery, MyClipRenderDataQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<MyClipRenderDataQuery | undefined, MyClipRenderDataQueryVariables>;
export function useMyClipRenderDataSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<MyClipRenderDataQuery, MyClipRenderDataQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<MyClipRenderDataQuery, MyClipRenderDataQueryVariables>(MyClipRenderDataDocument, options);
        }
export type MyClipRenderDataQueryHookResult = ReturnType<typeof useMyClipRenderDataQuery>;
export type MyClipRenderDataLazyQueryHookResult = ReturnType<typeof useMyClipRenderDataLazyQuery>;
export type MyClipRenderDataSuspenseQueryHookResult = ReturnType<typeof useMyClipRenderDataSuspenseQuery>;
export type MyClipRenderDataQueryResult = Apollo.QueryResult<MyClipRenderDataQuery, MyClipRenderDataQueryVariables>;
export const StartMyClipperRunDocument = gql`
    mutation StartMyClipperRun {
  startMyClipperRun {
    id
    seed
    rulesVersion
    personalBest
  }
}
    `;
export type StartMyClipperRunMutationFn = Apollo.MutationFunction<StartMyClipperRunMutation, StartMyClipperRunMutationVariables>;

/**
 * __useStartMyClipperRunMutation__
 *
 * To run a mutation, you first call `useStartMyClipperRunMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartMyClipperRunMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startMyClipperRunMutation, { data, loading, error }] = useStartMyClipperRunMutation({
 *   variables: {
 *   },
 * });
 */
export function useStartMyClipperRunMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<StartMyClipperRunMutation, StartMyClipperRunMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<StartMyClipperRunMutation, StartMyClipperRunMutationVariables>(StartMyClipperRunDocument, options);
      }
export type StartMyClipperRunMutationHookResult = ReturnType<typeof useStartMyClipperRunMutation>;
export type StartMyClipperRunMutationResult = Apollo.MutationResult<StartMyClipperRunMutation>;
export type StartMyClipperRunMutationOptions = Apollo.BaseMutationOptions<StartMyClipperRunMutation, StartMyClipperRunMutationVariables>;
export const FinishMyClipperRunDocument = gql`
    mutation FinishMyClipperRun($runId: ID!, $frames: Int!, $events: [ClipperRunInputEvent!]!) {
  finishMyClipperRun(runId: $runId, frames: $frames, events: $events) {
    score
    personalBest
  }
}
    `;
export type FinishMyClipperRunMutationFn = Apollo.MutationFunction<FinishMyClipperRunMutation, FinishMyClipperRunMutationVariables>;

/**
 * __useFinishMyClipperRunMutation__
 *
 * To run a mutation, you first call `useFinishMyClipperRunMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFinishMyClipperRunMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [finishMyClipperRunMutation, { data, loading, error }] = useFinishMyClipperRunMutation({
 *   variables: {
 *      runId: // value for 'runId'
 *      frames: // value for 'frames'
 *      events: // value for 'events'
 *   },
 * });
 */
export function useFinishMyClipperRunMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<FinishMyClipperRunMutation, FinishMyClipperRunMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<FinishMyClipperRunMutation, FinishMyClipperRunMutationVariables>(FinishMyClipperRunDocument, options);
      }
export type FinishMyClipperRunMutationHookResult = ReturnType<typeof useFinishMyClipperRunMutation>;
export type FinishMyClipperRunMutationResult = Apollo.MutationResult<FinishMyClipperRunMutation>;
export type FinishMyClipperRunMutationOptions = Apollo.BaseMutationOptions<FinishMyClipperRunMutation, FinishMyClipperRunMutationVariables>;
export const GetCoursesDocument = gql`
    query GetCourses($locale: String) {
  courses(locale: $locale) {
    id
    slug
    title
    description
    weeksLabel
    durationLabel
    thumbnailUrl
    order
    moduleCount
    freeModuleCount
    progressPercent
    ungroupedModules {
      id
      title
      videoUrl
      thumbnailUrl
      isFree
      order
      isLocked
      isCompleted
    }
    moduleGroups {
      id
      label
      order
      modules {
        id
        title
        videoUrl
        thumbnailUrl
        isFree
        order
        isLocked
        isCompleted
      }
    }
  }
}
    `;

/**
 * __useGetCoursesQuery__
 *
 * To run a query within a React component, call `useGetCoursesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCoursesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCoursesQuery({
 *   variables: {
 *      locale: // value for 'locale'
 *   },
 * });
 */
export function useGetCoursesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetCoursesQuery, GetCoursesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetCoursesQuery, GetCoursesQueryVariables>(GetCoursesDocument, options);
      }
export function useGetCoursesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetCoursesQuery, GetCoursesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetCoursesQuery, GetCoursesQueryVariables>(GetCoursesDocument, options);
        }
// @ts-ignore
export function useGetCoursesSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetCoursesQuery, GetCoursesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetCoursesQuery, GetCoursesQueryVariables>;
export function useGetCoursesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetCoursesQuery, GetCoursesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetCoursesQuery | undefined, GetCoursesQueryVariables>;
export function useGetCoursesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetCoursesQuery, GetCoursesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetCoursesQuery, GetCoursesQueryVariables>(GetCoursesDocument, options);
        }
export type GetCoursesQueryHookResult = ReturnType<typeof useGetCoursesQuery>;
export type GetCoursesLazyQueryHookResult = ReturnType<typeof useGetCoursesLazyQuery>;
export type GetCoursesSuspenseQueryHookResult = ReturnType<typeof useGetCoursesSuspenseQuery>;
export type GetCoursesQueryResult = Apollo.QueryResult<GetCoursesQuery, GetCoursesQueryVariables>;
export const MarkCourseModuleCompletedDocument = gql`
    mutation MarkCourseModuleCompleted($moduleId: ID!) {
  markCourseModuleCompleted(moduleId: $moduleId) {
    id
    isCompleted
    isLocked
    videoUrl
  }
}
    `;
export type MarkCourseModuleCompletedMutationFn = Apollo.MutationFunction<MarkCourseModuleCompletedMutation, MarkCourseModuleCompletedMutationVariables>;

/**
 * __useMarkCourseModuleCompletedMutation__
 *
 * To run a mutation, you first call `useMarkCourseModuleCompletedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkCourseModuleCompletedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markCourseModuleCompletedMutation, { data, loading, error }] = useMarkCourseModuleCompletedMutation({
 *   variables: {
 *      moduleId: // value for 'moduleId'
 *   },
 * });
 */
export function useMarkCourseModuleCompletedMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<MarkCourseModuleCompletedMutation, MarkCourseModuleCompletedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<MarkCourseModuleCompletedMutation, MarkCourseModuleCompletedMutationVariables>(MarkCourseModuleCompletedDocument, options);
      }
export type MarkCourseModuleCompletedMutationHookResult = ReturnType<typeof useMarkCourseModuleCompletedMutation>;
export type MarkCourseModuleCompletedMutationResult = Apollo.MutationResult<MarkCourseModuleCompletedMutation>;
export type MarkCourseModuleCompletedMutationOptions = Apollo.BaseMutationOptions<MarkCourseModuleCompletedMutation, MarkCourseModuleCompletedMutationVariables>;
export const GetCourseBySlugDocument = gql`
    query GetCourseBySlug($slug: String!, $locale: String) {
  course(slug: $slug, locale: $locale) {
    id
    slug
    title
    description
    weeksLabel
    durationLabel
    thumbnailUrl
    order
    moduleCount
    freeModuleCount
    progressPercent
    price
    isPurchasable
    ownedByViewer
    ungroupedModules {
      id
      title
      description
      videoUrl
      thumbnailUrl
      transcriptUrl
      chapters {
        title
        startSeconds
      }
      isFree
      order
      isLocked
      isCompleted
    }
    moduleGroups {
      id
      label
      order
      modules {
        id
        title
        description
        videoUrl
        thumbnailUrl
        transcriptUrl
        chapters {
          title
          startSeconds
        }
        isFree
        order
        isLocked
        isCompleted
      }
    }
  }
}
    `;

/**
 * __useGetCourseBySlugQuery__
 *
 * To run a query within a React component, call `useGetCourseBySlugQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCourseBySlugQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCourseBySlugQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *      locale: // value for 'locale'
 *   },
 * });
 */
export function useGetCourseBySlugQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetCourseBySlugQuery, GetCourseBySlugQueryVariables> & ({ variables: GetCourseBySlugQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetCourseBySlugQuery, GetCourseBySlugQueryVariables>(GetCourseBySlugDocument, options);
      }
export function useGetCourseBySlugLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetCourseBySlugQuery, GetCourseBySlugQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetCourseBySlugQuery, GetCourseBySlugQueryVariables>(GetCourseBySlugDocument, options);
        }
// @ts-ignore
export function useGetCourseBySlugSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetCourseBySlugQuery, GetCourseBySlugQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetCourseBySlugQuery, GetCourseBySlugQueryVariables>;
export function useGetCourseBySlugSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetCourseBySlugQuery, GetCourseBySlugQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetCourseBySlugQuery | undefined, GetCourseBySlugQueryVariables>;
export function useGetCourseBySlugSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetCourseBySlugQuery, GetCourseBySlugQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetCourseBySlugQuery, GetCourseBySlugQueryVariables>(GetCourseBySlugDocument, options);
        }
export type GetCourseBySlugQueryHookResult = ReturnType<typeof useGetCourseBySlugQuery>;
export type GetCourseBySlugLazyQueryHookResult = ReturnType<typeof useGetCourseBySlugLazyQuery>;
export type GetCourseBySlugSuspenseQueryHookResult = ReturnType<typeof useGetCourseBySlugSuspenseQuery>;
export type GetCourseBySlugQueryResult = Apollo.QueryResult<GetCourseBySlugQuery, GetCourseBySlugQueryVariables>;
export const CreateCoursePurchasePixDocument = gql`
    mutation CreateCoursePurchasePix($slug: String!, $documentType: String!, $documentNumber: String!, $phone: String!, $phoneDetails: CoursePurchasePhoneInput, $couponCode: String) {
  createCoursePurchasePix(
    slug: $slug
    documentType: $documentType
    documentNumber: $documentNumber
    phone: $phone
    phoneDetails: $phoneDetails
    couponCode: $couponCode
  ) {
    purchase_id
    status
    amount
    pix_code
    pix_qr_code_url
    expires_at
  }
}
    `;
export type CreateCoursePurchasePixMutationFn = Apollo.MutationFunction<CreateCoursePurchasePixMutation, CreateCoursePurchasePixMutationVariables>;

/**
 * __useCreateCoursePurchasePixMutation__
 *
 * To run a mutation, you first call `useCreateCoursePurchasePixMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCoursePurchasePixMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCoursePurchasePixMutation, { data, loading, error }] = useCreateCoursePurchasePixMutation({
 *   variables: {
 *      slug: // value for 'slug'
 *      documentType: // value for 'documentType'
 *      documentNumber: // value for 'documentNumber'
 *      phone: // value for 'phone'
 *      phoneDetails: // value for 'phoneDetails'
 *      couponCode: // value for 'couponCode'
 *   },
 * });
 */
export function useCreateCoursePurchasePixMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateCoursePurchasePixMutation, CreateCoursePurchasePixMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateCoursePurchasePixMutation, CreateCoursePurchasePixMutationVariables>(CreateCoursePurchasePixDocument, options);
      }
export type CreateCoursePurchasePixMutationHookResult = ReturnType<typeof useCreateCoursePurchasePixMutation>;
export type CreateCoursePurchasePixMutationResult = Apollo.MutationResult<CreateCoursePurchasePixMutation>;
export type CreateCoursePurchasePixMutationOptions = Apollo.BaseMutationOptions<CreateCoursePurchasePixMutation, CreateCoursePurchasePixMutationVariables>;
export const CreateCoursePurchaseCheckoutDocument = gql`
    mutation CreateCoursePurchaseCheckout($slug: String!, $phone: String!, $phoneDetails: CoursePurchasePhoneInput, $returnUrl: String!, $cancelUrl: String, $couponCode: String) {
  createCoursePurchaseCheckout(
    slug: $slug
    phone: $phone
    phoneDetails: $phoneDetails
    returnUrl: $returnUrl
    cancelUrl: $cancelUrl
    couponCode: $couponCode
  ) {
    purchase_id
    url
    amount
  }
}
    `;
export type CreateCoursePurchaseCheckoutMutationFn = Apollo.MutationFunction<CreateCoursePurchaseCheckoutMutation, CreateCoursePurchaseCheckoutMutationVariables>;

/**
 * __useCreateCoursePurchaseCheckoutMutation__
 *
 * To run a mutation, you first call `useCreateCoursePurchaseCheckoutMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCoursePurchaseCheckoutMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCoursePurchaseCheckoutMutation, { data, loading, error }] = useCreateCoursePurchaseCheckoutMutation({
 *   variables: {
 *      slug: // value for 'slug'
 *      phone: // value for 'phone'
 *      phoneDetails: // value for 'phoneDetails'
 *      returnUrl: // value for 'returnUrl'
 *      cancelUrl: // value for 'cancelUrl'
 *      couponCode: // value for 'couponCode'
 *   },
 * });
 */
export function useCreateCoursePurchaseCheckoutMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateCoursePurchaseCheckoutMutation, CreateCoursePurchaseCheckoutMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateCoursePurchaseCheckoutMutation, CreateCoursePurchaseCheckoutMutationVariables>(CreateCoursePurchaseCheckoutDocument, options);
      }
export type CreateCoursePurchaseCheckoutMutationHookResult = ReturnType<typeof useCreateCoursePurchaseCheckoutMutation>;
export type CreateCoursePurchaseCheckoutMutationResult = Apollo.MutationResult<CreateCoursePurchaseCheckoutMutation>;
export type CreateCoursePurchaseCheckoutMutationOptions = Apollo.BaseMutationOptions<CreateCoursePurchaseCheckoutMutation, CreateCoursePurchaseCheckoutMutationVariables>;
export const ValidateCourseCouponDocument = gql`
    query ValidateCourseCoupon($code: String!, $slug: String!) {
  validateCourseCoupon(code: $code, slug: $slug) {
    valid
    error
    code
    type
    discount
    amount
  }
}
    `;

/**
 * __useValidateCourseCouponQuery__
 *
 * To run a query within a React component, call `useValidateCourseCouponQuery` and pass it any options that fit your needs.
 * When your component renders, `useValidateCourseCouponQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useValidateCourseCouponQuery({
 *   variables: {
 *      code: // value for 'code'
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useValidateCourseCouponQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ValidateCourseCouponQuery, ValidateCourseCouponQueryVariables> & ({ variables: ValidateCourseCouponQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ValidateCourseCouponQuery, ValidateCourseCouponQueryVariables>(ValidateCourseCouponDocument, options);
      }
export function useValidateCourseCouponLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ValidateCourseCouponQuery, ValidateCourseCouponQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ValidateCourseCouponQuery, ValidateCourseCouponQueryVariables>(ValidateCourseCouponDocument, options);
        }
// @ts-ignore
export function useValidateCourseCouponSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ValidateCourseCouponQuery, ValidateCourseCouponQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ValidateCourseCouponQuery, ValidateCourseCouponQueryVariables>;
export function useValidateCourseCouponSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ValidateCourseCouponQuery, ValidateCourseCouponQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ValidateCourseCouponQuery | undefined, ValidateCourseCouponQueryVariables>;
export function useValidateCourseCouponSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ValidateCourseCouponQuery, ValidateCourseCouponQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ValidateCourseCouponQuery, ValidateCourseCouponQueryVariables>(ValidateCourseCouponDocument, options);
        }
export type ValidateCourseCouponQueryHookResult = ReturnType<typeof useValidateCourseCouponQuery>;
export type ValidateCourseCouponLazyQueryHookResult = ReturnType<typeof useValidateCourseCouponLazyQuery>;
export type ValidateCourseCouponSuspenseQueryHookResult = ReturnType<typeof useValidateCourseCouponSuspenseQuery>;
export type ValidateCourseCouponQueryResult = Apollo.QueryResult<ValidateCourseCouponQuery, ValidateCourseCouponQueryVariables>;
export const CoursePurchaseStatusDocument = gql`
    query CoursePurchaseStatus($purchaseId: ID!) {
  coursePurchaseStatus(purchaseId: $purchaseId) {
    status
  }
}
    `;

/**
 * __useCoursePurchaseStatusQuery__
 *
 * To run a query within a React component, call `useCoursePurchaseStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useCoursePurchaseStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCoursePurchaseStatusQuery({
 *   variables: {
 *      purchaseId: // value for 'purchaseId'
 *   },
 * });
 */
export function useCoursePurchaseStatusQuery(baseOptions: ApolloReactHooks.QueryHookOptions<CoursePurchaseStatusQuery, CoursePurchaseStatusQueryVariables> & ({ variables: CoursePurchaseStatusQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<CoursePurchaseStatusQuery, CoursePurchaseStatusQueryVariables>(CoursePurchaseStatusDocument, options);
      }
export function useCoursePurchaseStatusLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CoursePurchaseStatusQuery, CoursePurchaseStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<CoursePurchaseStatusQuery, CoursePurchaseStatusQueryVariables>(CoursePurchaseStatusDocument, options);
        }
// @ts-ignore
export function useCoursePurchaseStatusSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<CoursePurchaseStatusQuery, CoursePurchaseStatusQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<CoursePurchaseStatusQuery, CoursePurchaseStatusQueryVariables>;
export function useCoursePurchaseStatusSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<CoursePurchaseStatusQuery, CoursePurchaseStatusQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<CoursePurchaseStatusQuery | undefined, CoursePurchaseStatusQueryVariables>;
export function useCoursePurchaseStatusSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<CoursePurchaseStatusQuery, CoursePurchaseStatusQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<CoursePurchaseStatusQuery, CoursePurchaseStatusQueryVariables>(CoursePurchaseStatusDocument, options);
        }
export type CoursePurchaseStatusQueryHookResult = ReturnType<typeof useCoursePurchaseStatusQuery>;
export type CoursePurchaseStatusLazyQueryHookResult = ReturnType<typeof useCoursePurchaseStatusLazyQuery>;
export type CoursePurchaseStatusSuspenseQueryHookResult = ReturnType<typeof useCoursePurchaseStatusSuspenseQuery>;
export type CoursePurchaseStatusQueryResult = Apollo.QueryResult<CoursePurchaseStatusQuery, CoursePurchaseStatusQueryVariables>;
export const CpmReportCampaignDocument = gql`
    query CpmReportCampaign($id: ID!) {
  adminCpmCampaign(id: $id) {
    id
    name
    status
    start_date
    end_date
    currency
    cpm_rate_cents
    budget_total_cents
    budget_spent_cents
    budget_stored_spent_cents
    budget_remaining_cents
    budget_spend_drift_cents
    min_views_threshold
    max_payout_per_clip_cents
    max_payout_per_clipper_cents
    view_accrual_window_hours
    submissions_count
    createdAt
    updatedAt
  }
}
    `;

/**
 * __useCpmReportCampaignQuery__
 *
 * To run a query within a React component, call `useCpmReportCampaignQuery` and pass it any options that fit your needs.
 * When your component renders, `useCpmReportCampaignQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCpmReportCampaignQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCpmReportCampaignQuery(baseOptions: ApolloReactHooks.QueryHookOptions<CpmReportCampaignQuery, CpmReportCampaignQueryVariables> & ({ variables: CpmReportCampaignQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<CpmReportCampaignQuery, CpmReportCampaignQueryVariables>(CpmReportCampaignDocument, options);
      }
export function useCpmReportCampaignLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CpmReportCampaignQuery, CpmReportCampaignQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<CpmReportCampaignQuery, CpmReportCampaignQueryVariables>(CpmReportCampaignDocument, options);
        }
// @ts-ignore
export function useCpmReportCampaignSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<CpmReportCampaignQuery, CpmReportCampaignQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<CpmReportCampaignQuery, CpmReportCampaignQueryVariables>;
export function useCpmReportCampaignSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<CpmReportCampaignQuery, CpmReportCampaignQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<CpmReportCampaignQuery | undefined, CpmReportCampaignQueryVariables>;
export function useCpmReportCampaignSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<CpmReportCampaignQuery, CpmReportCampaignQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<CpmReportCampaignQuery, CpmReportCampaignQueryVariables>(CpmReportCampaignDocument, options);
        }
export type CpmReportCampaignQueryHookResult = ReturnType<typeof useCpmReportCampaignQuery>;
export type CpmReportCampaignLazyQueryHookResult = ReturnType<typeof useCpmReportCampaignLazyQuery>;
export type CpmReportCampaignSuspenseQueryHookResult = ReturnType<typeof useCpmReportCampaignSuspenseQuery>;
export type CpmReportCampaignQueryResult = Apollo.QueryResult<CpmReportCampaignQuery, CpmReportCampaignQueryVariables>;
export const CpmReportSubmissionsDocument = gql`
    query CpmReportSubmissions($campaignId: ID!, $limit: Int!, $offset: Int!) {
  adminCpmCampaignSubmissions(
    campaignId: $campaignId
    limit: $limit
    offset: $offset
  ) {
    data {
      id
      platform
      url
      canonical_url
      admin_approval
      disqualified
      last_counted_views
      accumulated_payout_cents
      cpm_rate_override_cents
      last_view_sync_at
      createdAt
      user_id
      suspected_duplicate
      accrual_window_ends_at
      final_accrual_views
      final_accrual_captured_at
      daily_views {
        date
        views
      }
    }
    total
    pageCount
  }
}
    `;

/**
 * __useCpmReportSubmissionsQuery__
 *
 * To run a query within a React component, call `useCpmReportSubmissionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCpmReportSubmissionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCpmReportSubmissionsQuery({
 *   variables: {
 *      campaignId: // value for 'campaignId'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useCpmReportSubmissionsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<CpmReportSubmissionsQuery, CpmReportSubmissionsQueryVariables> & ({ variables: CpmReportSubmissionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<CpmReportSubmissionsQuery, CpmReportSubmissionsQueryVariables>(CpmReportSubmissionsDocument, options);
      }
export function useCpmReportSubmissionsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CpmReportSubmissionsQuery, CpmReportSubmissionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<CpmReportSubmissionsQuery, CpmReportSubmissionsQueryVariables>(CpmReportSubmissionsDocument, options);
        }
// @ts-ignore
export function useCpmReportSubmissionsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<CpmReportSubmissionsQuery, CpmReportSubmissionsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<CpmReportSubmissionsQuery, CpmReportSubmissionsQueryVariables>;
export function useCpmReportSubmissionsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<CpmReportSubmissionsQuery, CpmReportSubmissionsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<CpmReportSubmissionsQuery | undefined, CpmReportSubmissionsQueryVariables>;
export function useCpmReportSubmissionsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<CpmReportSubmissionsQuery, CpmReportSubmissionsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<CpmReportSubmissionsQuery, CpmReportSubmissionsQueryVariables>(CpmReportSubmissionsDocument, options);
        }
export type CpmReportSubmissionsQueryHookResult = ReturnType<typeof useCpmReportSubmissionsQuery>;
export type CpmReportSubmissionsLazyQueryHookResult = ReturnType<typeof useCpmReportSubmissionsLazyQuery>;
export type CpmReportSubmissionsSuspenseQueryHookResult = ReturnType<typeof useCpmReportSubmissionsSuspenseQuery>;
export type CpmReportSubmissionsQueryResult = Apollo.QueryResult<CpmReportSubmissionsQuery, CpmReportSubmissionsQueryVariables>;
export const CpmReportConclusionsDocument = gql`
    mutation CpmReportConclusions($campaignId: ID!, $reportAsOf: String!, $expectedFactsFingerprint: String!) {
  adminGenerateCpmCampaignReportConclusions(
    campaignId: $campaignId
    reportAsOf: $reportAsOf
    expectedFactsFingerprint: $expectedFactsFingerprint
  ) {
    fingerprint
    generatedAt
    summary
    highlights {
      title
      text
      evidenceKeys
    }
    recommendations {
      title
      text
      evidenceKeys
    }
  }
}
    `;
export type CpmReportConclusionsMutationFn = Apollo.MutationFunction<CpmReportConclusionsMutation, CpmReportConclusionsMutationVariables>;

/**
 * __useCpmReportConclusionsMutation__
 *
 * To run a mutation, you first call `useCpmReportConclusionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCpmReportConclusionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cpmReportConclusionsMutation, { data, loading, error }] = useCpmReportConclusionsMutation({
 *   variables: {
 *      campaignId: // value for 'campaignId'
 *      reportAsOf: // value for 'reportAsOf'
 *      expectedFactsFingerprint: // value for 'expectedFactsFingerprint'
 *   },
 * });
 */
export function useCpmReportConclusionsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CpmReportConclusionsMutation, CpmReportConclusionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CpmReportConclusionsMutation, CpmReportConclusionsMutationVariables>(CpmReportConclusionsDocument, options);
      }
export type CpmReportConclusionsMutationHookResult = ReturnType<typeof useCpmReportConclusionsMutation>;
export type CpmReportConclusionsMutationResult = Apollo.MutationResult<CpmReportConclusionsMutation>;
export type CpmReportConclusionsMutationOptions = Apollo.BaseMutationOptions<CpmReportConclusionsMutation, CpmReportConclusionsMutationVariables>;
export const CpmCampaignRankingDocument = gql`
    query CpmCampaignRanking($campaignId: ID!) {
  cpmCampaignRanking(campaignId: $campaignId) {
    campaign_id
    campaign_type
    config
    phase
    can_review
    can_submit
    review_fingerprint
    pending_reports_count
    pending_clip_count
    pending_metrics_count
    can_finalize
    unresolved_ties
    finalized_at
    winner_contact_url
    last_view_sync_at
    rows {
      participant_id
      display_name
      total_views
      valid_post_count
      eligible
      place
      prize_cents
      is_self
      tie_pending
    }
    my_row {
      participant_id
      display_name
      total_views
      valid_post_count
      eligible
      place
      prize_cents
      is_self
      tie_pending
    }
    my_progress {
      target_type
      current_position
      next_position
      views_needed
      estimated_clips_needed
    }
    own_reports {
      id
      submission_id
      participant_id
      platform
      url
      profile_handle
      profile_url
      published_at
      reported_views
      evidence_url
      status
      verified_views
      profile_verified
      ownership_verified
      connected_account
      review_reason
      reviewed_at
      created_at
      admission_approved_at
      rules_check
      last_view_sync_at
      clip_approval
      ranked_views
      views_source
      views_captured_at
      metrics_status
      tracked_views
      tracked_views_captured_at
      tracked_views_source
    }
    admin_reports {
      id
      submission_id
      participant_id
      platform
      url
      profile_handle
      profile_url
      published_at
      reported_views
      evidence_url
      status
      verified_views
      profile_verified
      ownership_verified
      connected_account
      review_reason
      reviewed_at
      created_at
      admission_approved_at
      rules_check
      last_view_sync_at
      clip_approval
      ranked_views
      views_source
      views_captured_at
      metrics_status
      tracked_views
      tracked_views_captured_at
      tracked_views_source
      account_reliability {
        status
        score
        engagement_rate
        lifetime_views
        tracked_content
        username
      }
    }
  }
}
    `;

/**
 * __useCpmCampaignRankingQuery__
 *
 * To run a query within a React component, call `useCpmCampaignRankingQuery` and pass it any options that fit your needs.
 * When your component renders, `useCpmCampaignRankingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCpmCampaignRankingQuery({
 *   variables: {
 *      campaignId: // value for 'campaignId'
 *   },
 * });
 */
export function useCpmCampaignRankingQuery(baseOptions: ApolloReactHooks.QueryHookOptions<CpmCampaignRankingQuery, CpmCampaignRankingQueryVariables> & ({ variables: CpmCampaignRankingQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<CpmCampaignRankingQuery, CpmCampaignRankingQueryVariables>(CpmCampaignRankingDocument, options);
      }
export function useCpmCampaignRankingLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CpmCampaignRankingQuery, CpmCampaignRankingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<CpmCampaignRankingQuery, CpmCampaignRankingQueryVariables>(CpmCampaignRankingDocument, options);
        }
// @ts-ignore
export function useCpmCampaignRankingSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<CpmCampaignRankingQuery, CpmCampaignRankingQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<CpmCampaignRankingQuery, CpmCampaignRankingQueryVariables>;
export function useCpmCampaignRankingSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<CpmCampaignRankingQuery, CpmCampaignRankingQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<CpmCampaignRankingQuery | undefined, CpmCampaignRankingQueryVariables>;
export function useCpmCampaignRankingSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<CpmCampaignRankingQuery, CpmCampaignRankingQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<CpmCampaignRankingQuery, CpmCampaignRankingQueryVariables>(CpmCampaignRankingDocument, options);
        }
export type CpmCampaignRankingQueryHookResult = ReturnType<typeof useCpmCampaignRankingQuery>;
export type CpmCampaignRankingLazyQueryHookResult = ReturnType<typeof useCpmCampaignRankingLazyQuery>;
export type CpmCampaignRankingSuspenseQueryHookResult = ReturnType<typeof useCpmCampaignRankingSuspenseQuery>;
export type CpmCampaignRankingQueryResult = Apollo.QueryResult<CpmCampaignRankingQuery, CpmCampaignRankingQueryVariables>;
export const SubmitMyCpmRankingReportDocument = gql`
    mutation SubmitMyCpmRankingReport($campaignId: ID!, $input: CpmRankingReportInput!) {
  submitMyCpmRankingReport(campaignId: $campaignId, input: $input) {
    id
    status
  }
}
    `;
export type SubmitMyCpmRankingReportMutationFn = Apollo.MutationFunction<SubmitMyCpmRankingReportMutation, SubmitMyCpmRankingReportMutationVariables>;

/**
 * __useSubmitMyCpmRankingReportMutation__
 *
 * To run a mutation, you first call `useSubmitMyCpmRankingReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitMyCpmRankingReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitMyCpmRankingReportMutation, { data, loading, error }] = useSubmitMyCpmRankingReportMutation({
 *   variables: {
 *      campaignId: // value for 'campaignId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSubmitMyCpmRankingReportMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SubmitMyCpmRankingReportMutation, SubmitMyCpmRankingReportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SubmitMyCpmRankingReportMutation, SubmitMyCpmRankingReportMutationVariables>(SubmitMyCpmRankingReportDocument, options);
      }
export type SubmitMyCpmRankingReportMutationHookResult = ReturnType<typeof useSubmitMyCpmRankingReportMutation>;
export type SubmitMyCpmRankingReportMutationResult = Apollo.MutationResult<SubmitMyCpmRankingReportMutation>;
export type SubmitMyCpmRankingReportMutationOptions = Apollo.BaseMutationOptions<SubmitMyCpmRankingReportMutation, SubmitMyCpmRankingReportMutationVariables>;
export const AdminReviewCpmRankingReportDocument = gql`
    mutation AdminReviewCpmRankingReport($id: ID!, $input: CpmRankingReviewInput!) {
  adminReviewCpmRankingReport(id: $id, input: $input) {
    id
    status
    verified_views
  }
}
    `;
export type AdminReviewCpmRankingReportMutationFn = Apollo.MutationFunction<AdminReviewCpmRankingReportMutation, AdminReviewCpmRankingReportMutationVariables>;

/**
 * __useAdminReviewCpmRankingReportMutation__
 *
 * To run a mutation, you first call `useAdminReviewCpmRankingReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminReviewCpmRankingReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminReviewCpmRankingReportMutation, { data, loading, error }] = useAdminReviewCpmRankingReportMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdminReviewCpmRankingReportMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AdminReviewCpmRankingReportMutation, AdminReviewCpmRankingReportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AdminReviewCpmRankingReportMutation, AdminReviewCpmRankingReportMutationVariables>(AdminReviewCpmRankingReportDocument, options);
      }
export type AdminReviewCpmRankingReportMutationHookResult = ReturnType<typeof useAdminReviewCpmRankingReportMutation>;
export type AdminReviewCpmRankingReportMutationResult = Apollo.MutationResult<AdminReviewCpmRankingReportMutation>;
export type AdminReviewCpmRankingReportMutationOptions = Apollo.BaseMutationOptions<AdminReviewCpmRankingReportMutation, AdminReviewCpmRankingReportMutationVariables>;
export const AdminReviewCpmRankingSubmissionDocument = gql`
    mutation AdminReviewCpmRankingSubmission($id: ID!, $input: CpmRankingReviewInput!) {
  adminReviewCpmRankingSubmission(id: $id, input: $input) {
    id
    submission_id
    status
    verified_views
  }
}
    `;
export type AdminReviewCpmRankingSubmissionMutationFn = Apollo.MutationFunction<AdminReviewCpmRankingSubmissionMutation, AdminReviewCpmRankingSubmissionMutationVariables>;

/**
 * __useAdminReviewCpmRankingSubmissionMutation__
 *
 * To run a mutation, you first call `useAdminReviewCpmRankingSubmissionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminReviewCpmRankingSubmissionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminReviewCpmRankingSubmissionMutation, { data, loading, error }] = useAdminReviewCpmRankingSubmissionMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdminReviewCpmRankingSubmissionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AdminReviewCpmRankingSubmissionMutation, AdminReviewCpmRankingSubmissionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AdminReviewCpmRankingSubmissionMutation, AdminReviewCpmRankingSubmissionMutationVariables>(AdminReviewCpmRankingSubmissionDocument, options);
      }
export type AdminReviewCpmRankingSubmissionMutationHookResult = ReturnType<typeof useAdminReviewCpmRankingSubmissionMutation>;
export type AdminReviewCpmRankingSubmissionMutationResult = Apollo.MutationResult<AdminReviewCpmRankingSubmissionMutation>;
export type AdminReviewCpmRankingSubmissionMutationOptions = Apollo.BaseMutationOptions<AdminReviewCpmRankingSubmissionMutation, AdminReviewCpmRankingSubmissionMutationVariables>;
export const AdminReviewCpmRankingClipDocument = gql`
    mutation AdminReviewCpmRankingClip($id: ID!, $approval: String!, $reason: String, $ownershipVerified: Boolean) {
  adminReviewCpmRankingClip(
    id: $id
    approval: $approval
    reason: $reason
    ownershipVerified: $ownershipVerified
  ) {
    id
    submission_id
    clip_approval
    ranked_views
    views_source
    views_captured_at
    metrics_status
  }
}
    `;
export type AdminReviewCpmRankingClipMutationFn = Apollo.MutationFunction<AdminReviewCpmRankingClipMutation, AdminReviewCpmRankingClipMutationVariables>;

/**
 * __useAdminReviewCpmRankingClipMutation__
 *
 * To run a mutation, you first call `useAdminReviewCpmRankingClipMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminReviewCpmRankingClipMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminReviewCpmRankingClipMutation, { data, loading, error }] = useAdminReviewCpmRankingClipMutation({
 *   variables: {
 *      id: // value for 'id'
 *      approval: // value for 'approval'
 *      reason: // value for 'reason'
 *      ownershipVerified: // value for 'ownershipVerified'
 *   },
 * });
 */
export function useAdminReviewCpmRankingClipMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AdminReviewCpmRankingClipMutation, AdminReviewCpmRankingClipMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AdminReviewCpmRankingClipMutation, AdminReviewCpmRankingClipMutationVariables>(AdminReviewCpmRankingClipDocument, options);
      }
export type AdminReviewCpmRankingClipMutationHookResult = ReturnType<typeof useAdminReviewCpmRankingClipMutation>;
export type AdminReviewCpmRankingClipMutationResult = Apollo.MutationResult<AdminReviewCpmRankingClipMutation>;
export type AdminReviewCpmRankingClipMutationOptions = Apollo.BaseMutationOptions<AdminReviewCpmRankingClipMutation, AdminReviewCpmRankingClipMutationVariables>;
export const AdminBulkApproveCpmRankingClipsDocument = gql`
    mutation AdminBulkApproveCpmRankingClips($campaignId: ID!, $ids: [ID!]!) {
  adminBulkApproveCpmRankingClips(campaignId: $campaignId, ids: $ids) {
    approved
    skipped {
      id
      code
    }
  }
}
    `;
export type AdminBulkApproveCpmRankingClipsMutationFn = Apollo.MutationFunction<AdminBulkApproveCpmRankingClipsMutation, AdminBulkApproveCpmRankingClipsMutationVariables>;

/**
 * __useAdminBulkApproveCpmRankingClipsMutation__
 *
 * To run a mutation, you first call `useAdminBulkApproveCpmRankingClipsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminBulkApproveCpmRankingClipsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminBulkApproveCpmRankingClipsMutation, { data, loading, error }] = useAdminBulkApproveCpmRankingClipsMutation({
 *   variables: {
 *      campaignId: // value for 'campaignId'
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useAdminBulkApproveCpmRankingClipsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AdminBulkApproveCpmRankingClipsMutation, AdminBulkApproveCpmRankingClipsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AdminBulkApproveCpmRankingClipsMutation, AdminBulkApproveCpmRankingClipsMutationVariables>(AdminBulkApproveCpmRankingClipsDocument, options);
      }
export type AdminBulkApproveCpmRankingClipsMutationHookResult = ReturnType<typeof useAdminBulkApproveCpmRankingClipsMutation>;
export type AdminBulkApproveCpmRankingClipsMutationResult = Apollo.MutationResult<AdminBulkApproveCpmRankingClipsMutation>;
export type AdminBulkApproveCpmRankingClipsMutationOptions = Apollo.BaseMutationOptions<AdminBulkApproveCpmRankingClipsMutation, AdminBulkApproveCpmRankingClipsMutationVariables>;
export const AdminBulkRejectCpmRankingClipsDocument = gql`
    mutation AdminBulkRejectCpmRankingClips($campaignId: ID!, $ids: [ID!]!, $reason: String) {
  adminBulkRejectCpmRankingClips(
    campaignId: $campaignId
    ids: $ids
    reason: $reason
  ) {
    rejected
    skipped {
      id
      code
    }
  }
}
    `;
export type AdminBulkRejectCpmRankingClipsMutationFn = Apollo.MutationFunction<AdminBulkRejectCpmRankingClipsMutation, AdminBulkRejectCpmRankingClipsMutationVariables>;

/**
 * __useAdminBulkRejectCpmRankingClipsMutation__
 *
 * To run a mutation, you first call `useAdminBulkRejectCpmRankingClipsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminBulkRejectCpmRankingClipsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminBulkRejectCpmRankingClipsMutation, { data, loading, error }] = useAdminBulkRejectCpmRankingClipsMutation({
 *   variables: {
 *      campaignId: // value for 'campaignId'
 *      ids: // value for 'ids'
 *      reason: // value for 'reason'
 *   },
 * });
 */
export function useAdminBulkRejectCpmRankingClipsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AdminBulkRejectCpmRankingClipsMutation, AdminBulkRejectCpmRankingClipsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AdminBulkRejectCpmRankingClipsMutation, AdminBulkRejectCpmRankingClipsMutationVariables>(AdminBulkRejectCpmRankingClipsDocument, options);
      }
export type AdminBulkRejectCpmRankingClipsMutationHookResult = ReturnType<typeof useAdminBulkRejectCpmRankingClipsMutation>;
export type AdminBulkRejectCpmRankingClipsMutationResult = Apollo.MutationResult<AdminBulkRejectCpmRankingClipsMutation>;
export type AdminBulkRejectCpmRankingClipsMutationOptions = Apollo.BaseMutationOptions<AdminBulkRejectCpmRankingClipsMutation, AdminBulkRejectCpmRankingClipsMutationVariables>;
export const AdminResolveCpmRankingTieDocument = gql`
    mutation AdminResolveCpmRankingTie($campaignId: ID!, $participantIds: [ID!]!, $reason: String!) {
  adminResolveCpmRankingTie(
    campaignId: $campaignId
    participantIds: $participantIds
    reason: $reason
  ) {
    campaign_id
    review_fingerprint
  }
}
    `;
export type AdminResolveCpmRankingTieMutationFn = Apollo.MutationFunction<AdminResolveCpmRankingTieMutation, AdminResolveCpmRankingTieMutationVariables>;

/**
 * __useAdminResolveCpmRankingTieMutation__
 *
 * To run a mutation, you first call `useAdminResolveCpmRankingTieMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminResolveCpmRankingTieMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminResolveCpmRankingTieMutation, { data, loading, error }] = useAdminResolveCpmRankingTieMutation({
 *   variables: {
 *      campaignId: // value for 'campaignId'
 *      participantIds: // value for 'participantIds'
 *      reason: // value for 'reason'
 *   },
 * });
 */
export function useAdminResolveCpmRankingTieMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AdminResolveCpmRankingTieMutation, AdminResolveCpmRankingTieMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AdminResolveCpmRankingTieMutation, AdminResolveCpmRankingTieMutationVariables>(AdminResolveCpmRankingTieDocument, options);
      }
export type AdminResolveCpmRankingTieMutationHookResult = ReturnType<typeof useAdminResolveCpmRankingTieMutation>;
export type AdminResolveCpmRankingTieMutationResult = Apollo.MutationResult<AdminResolveCpmRankingTieMutation>;
export type AdminResolveCpmRankingTieMutationOptions = Apollo.BaseMutationOptions<AdminResolveCpmRankingTieMutation, AdminResolveCpmRankingTieMutationVariables>;
export const AdminFinalizeCpmRankingDocument = gql`
    mutation AdminFinalizeCpmRanking($campaignId: ID!, $expectedFingerprint: String!) {
  adminFinalizeCpmRanking(
    campaignId: $campaignId
    expectedFingerprint: $expectedFingerprint
  ) {
    campaign_id
    phase
    finalized_at
  }
}
    `;
export type AdminFinalizeCpmRankingMutationFn = Apollo.MutationFunction<AdminFinalizeCpmRankingMutation, AdminFinalizeCpmRankingMutationVariables>;

/**
 * __useAdminFinalizeCpmRankingMutation__
 *
 * To run a mutation, you first call `useAdminFinalizeCpmRankingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminFinalizeCpmRankingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminFinalizeCpmRankingMutation, { data, loading, error }] = useAdminFinalizeCpmRankingMutation({
 *   variables: {
 *      campaignId: // value for 'campaignId'
 *      expectedFingerprint: // value for 'expectedFingerprint'
 *   },
 * });
 */
export function useAdminFinalizeCpmRankingMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AdminFinalizeCpmRankingMutation, AdminFinalizeCpmRankingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AdminFinalizeCpmRankingMutation, AdminFinalizeCpmRankingMutationVariables>(AdminFinalizeCpmRankingDocument, options);
      }
export type AdminFinalizeCpmRankingMutationHookResult = ReturnType<typeof useAdminFinalizeCpmRankingMutation>;
export type AdminFinalizeCpmRankingMutationResult = Apollo.MutationResult<AdminFinalizeCpmRankingMutation>;
export type AdminFinalizeCpmRankingMutationOptions = Apollo.BaseMutationOptions<AdminFinalizeCpmRankingMutation, AdminFinalizeCpmRankingMutationVariables>;
export const DropboxVideoMetadataDocument = gql`
    query DropboxVideoMetadata($url: String!) {
  dropboxVideoMetadata(url: $url) {
    title
    duration
    width
    height
    source_size_bytes
  }
}
    `;

/**
 * __useDropboxVideoMetadataQuery__
 *
 * To run a query within a React component, call `useDropboxVideoMetadataQuery` and pass it any options that fit your needs.
 * When your component renders, `useDropboxVideoMetadataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDropboxVideoMetadataQuery({
 *   variables: {
 *      url: // value for 'url'
 *   },
 * });
 */
export function useDropboxVideoMetadataQuery(baseOptions: ApolloReactHooks.QueryHookOptions<DropboxVideoMetadataQuery, DropboxVideoMetadataQueryVariables> & ({ variables: DropboxVideoMetadataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<DropboxVideoMetadataQuery, DropboxVideoMetadataQueryVariables>(DropboxVideoMetadataDocument, options);
      }
export function useDropboxVideoMetadataLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<DropboxVideoMetadataQuery, DropboxVideoMetadataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<DropboxVideoMetadataQuery, DropboxVideoMetadataQueryVariables>(DropboxVideoMetadataDocument, options);
        }
// @ts-ignore
export function useDropboxVideoMetadataSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<DropboxVideoMetadataQuery, DropboxVideoMetadataQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<DropboxVideoMetadataQuery, DropboxVideoMetadataQueryVariables>;
export function useDropboxVideoMetadataSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<DropboxVideoMetadataQuery, DropboxVideoMetadataQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<DropboxVideoMetadataQuery | undefined, DropboxVideoMetadataQueryVariables>;
export function useDropboxVideoMetadataSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<DropboxVideoMetadataQuery, DropboxVideoMetadataQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<DropboxVideoMetadataQuery, DropboxVideoMetadataQueryVariables>(DropboxVideoMetadataDocument, options);
        }
export type DropboxVideoMetadataQueryHookResult = ReturnType<typeof useDropboxVideoMetadataQuery>;
export type DropboxVideoMetadataLazyQueryHookResult = ReturnType<typeof useDropboxVideoMetadataLazyQuery>;
export type DropboxVideoMetadataSuspenseQueryHookResult = ReturnType<typeof useDropboxVideoMetadataSuspenseQuery>;
export type DropboxVideoMetadataQueryResult = Apollo.QueryResult<DropboxVideoMetadataQuery, DropboxVideoMetadataQueryVariables>;
export const StartEditOnlyLibraryDocument = gql`
    mutation StartEditOnlyLibrary($id: ID!, $startSeconds: Float!, $endSeconds: Float) {
  startEditOnlyLibrary(
    id: $id
    startSeconds: $startSeconds
    endSeconds: $endSeconds
  ) {
    id
    curation_status
    failure_code
    edit_only
  }
}
    `;
export type StartEditOnlyLibraryMutationFn = Apollo.MutationFunction<StartEditOnlyLibraryMutation, StartEditOnlyLibraryMutationVariables>;

/**
 * __useStartEditOnlyLibraryMutation__
 *
 * To run a mutation, you first call `useStartEditOnlyLibraryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartEditOnlyLibraryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startEditOnlyLibraryMutation, { data, loading, error }] = useStartEditOnlyLibraryMutation({
 *   variables: {
 *      id: // value for 'id'
 *      startSeconds: // value for 'startSeconds'
 *      endSeconds: // value for 'endSeconds'
 *   },
 * });
 */
export function useStartEditOnlyLibraryMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<StartEditOnlyLibraryMutation, StartEditOnlyLibraryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<StartEditOnlyLibraryMutation, StartEditOnlyLibraryMutationVariables>(StartEditOnlyLibraryDocument, options);
      }
export type StartEditOnlyLibraryMutationHookResult = ReturnType<typeof useStartEditOnlyLibraryMutation>;
export type StartEditOnlyLibraryMutationResult = Apollo.MutationResult<StartEditOnlyLibraryMutation>;
export type StartEditOnlyLibraryMutationOptions = Apollo.BaseMutationOptions<StartEditOnlyLibraryMutation, StartEditOnlyLibraryMutationVariables>;
export const StartEditOnlyProjectDocument = gql`
    mutation StartEditOnlyProject($id: ID!, $startSeconds: Float!, $endSeconds: Float) {
  startEditOnlyProject(
    id: $id
    startSeconds: $startSeconds
    endSeconds: $endSeconds
  ) {
    id
    curation_status
    failure_code
    edit_only
  }
}
    `;
export type StartEditOnlyProjectMutationFn = Apollo.MutationFunction<StartEditOnlyProjectMutation, StartEditOnlyProjectMutationVariables>;

/**
 * __useStartEditOnlyProjectMutation__
 *
 * To run a mutation, you first call `useStartEditOnlyProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartEditOnlyProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startEditOnlyProjectMutation, { data, loading, error }] = useStartEditOnlyProjectMutation({
 *   variables: {
 *      id: // value for 'id'
 *      startSeconds: // value for 'startSeconds'
 *      endSeconds: // value for 'endSeconds'
 *   },
 * });
 */
export function useStartEditOnlyProjectMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<StartEditOnlyProjectMutation, StartEditOnlyProjectMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<StartEditOnlyProjectMutation, StartEditOnlyProjectMutationVariables>(StartEditOnlyProjectDocument, options);
      }
export type StartEditOnlyProjectMutationHookResult = ReturnType<typeof useStartEditOnlyProjectMutation>;
export type StartEditOnlyProjectMutationResult = Apollo.MutationResult<StartEditOnlyProjectMutation>;
export type StartEditOnlyProjectMutationOptions = Apollo.BaseMutationOptions<StartEditOnlyProjectMutation, StartEditOnlyProjectMutationVariables>;
export const FillerVideoPreviewsDocument = gql`
    query fillerVideoPreviews {
  fillerVideos {
    id
    file_url
    file_en_url
    preview_url
    preview_en_url
    preview_duration_seconds
    preview_en_duration_seconds
  }
}
    `;

/**
 * __useFillerVideoPreviewsQuery__
 *
 * To run a query within a React component, call `useFillerVideoPreviewsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFillerVideoPreviewsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFillerVideoPreviewsQuery({
 *   variables: {
 *   },
 * });
 */
export function useFillerVideoPreviewsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<FillerVideoPreviewsQuery, FillerVideoPreviewsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<FillerVideoPreviewsQuery, FillerVideoPreviewsQueryVariables>(FillerVideoPreviewsDocument, options);
      }
export function useFillerVideoPreviewsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<FillerVideoPreviewsQuery, FillerVideoPreviewsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<FillerVideoPreviewsQuery, FillerVideoPreviewsQueryVariables>(FillerVideoPreviewsDocument, options);
        }
// @ts-ignore
export function useFillerVideoPreviewsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<FillerVideoPreviewsQuery, FillerVideoPreviewsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<FillerVideoPreviewsQuery, FillerVideoPreviewsQueryVariables>;
export function useFillerVideoPreviewsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<FillerVideoPreviewsQuery, FillerVideoPreviewsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<FillerVideoPreviewsQuery | undefined, FillerVideoPreviewsQueryVariables>;
export function useFillerVideoPreviewsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<FillerVideoPreviewsQuery, FillerVideoPreviewsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<FillerVideoPreviewsQuery, FillerVideoPreviewsQueryVariables>(FillerVideoPreviewsDocument, options);
        }
export type FillerVideoPreviewsQueryHookResult = ReturnType<typeof useFillerVideoPreviewsQuery>;
export type FillerVideoPreviewsLazyQueryHookResult = ReturnType<typeof useFillerVideoPreviewsLazyQuery>;
export type FillerVideoPreviewsSuspenseQueryHookResult = ReturnType<typeof useFillerVideoPreviewsSuspenseQuery>;
export type FillerVideoPreviewsQueryResult = Apollo.QueryResult<FillerVideoPreviewsQuery, FillerVideoPreviewsQueryVariables>;
export const FrameioShareVideosDocument = gql`
    query FrameioShareVideos($url: String!) {
  frameioShareVideos(url: $url) {
    share_name
    truncated
    videos {
      asset_id
      name
      duration_seconds
      width
      height
      thumbnail_url
      canonical_url
    }
  }
}
    `;

/**
 * __useFrameioShareVideosQuery__
 *
 * To run a query within a React component, call `useFrameioShareVideosQuery` and pass it any options that fit your needs.
 * When your component renders, `useFrameioShareVideosQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFrameioShareVideosQuery({
 *   variables: {
 *      url: // value for 'url'
 *   },
 * });
 */
export function useFrameioShareVideosQuery(baseOptions: ApolloReactHooks.QueryHookOptions<FrameioShareVideosQuery, FrameioShareVideosQueryVariables> & ({ variables: FrameioShareVideosQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<FrameioShareVideosQuery, FrameioShareVideosQueryVariables>(FrameioShareVideosDocument, options);
      }
export function useFrameioShareVideosLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<FrameioShareVideosQuery, FrameioShareVideosQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<FrameioShareVideosQuery, FrameioShareVideosQueryVariables>(FrameioShareVideosDocument, options);
        }
// @ts-ignore
export function useFrameioShareVideosSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<FrameioShareVideosQuery, FrameioShareVideosQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<FrameioShareVideosQuery, FrameioShareVideosQueryVariables>;
export function useFrameioShareVideosSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<FrameioShareVideosQuery, FrameioShareVideosQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<FrameioShareVideosQuery | undefined, FrameioShareVideosQueryVariables>;
export function useFrameioShareVideosSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<FrameioShareVideosQuery, FrameioShareVideosQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<FrameioShareVideosQuery, FrameioShareVideosQueryVariables>(FrameioShareVideosDocument, options);
        }
export type FrameioShareVideosQueryHookResult = ReturnType<typeof useFrameioShareVideosQuery>;
export type FrameioShareVideosLazyQueryHookResult = ReturnType<typeof useFrameioShareVideosLazyQuery>;
export type FrameioShareVideosSuspenseQueryHookResult = ReturnType<typeof useFrameioShareVideosSuspenseQuery>;
export type FrameioShareVideosQueryResult = Apollo.QueryResult<FrameioShareVideosQuery, FrameioShareVideosQueryVariables>;
export const MediasiloReviewVideosDocument = gql`
    query MediasiloReviewVideos($url: String!) {
  mediasiloReviewVideos(url: $url) {
    share_name
    truncated
    videos {
      asset_id
      name
      duration_seconds
      width
      height
      thumbnail_url
      canonical_url
    }
  }
}
    `;

/**
 * __useMediasiloReviewVideosQuery__
 *
 * To run a query within a React component, call `useMediasiloReviewVideosQuery` and pass it any options that fit your needs.
 * When your component renders, `useMediasiloReviewVideosQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMediasiloReviewVideosQuery({
 *   variables: {
 *      url: // value for 'url'
 *   },
 * });
 */
export function useMediasiloReviewVideosQuery(baseOptions: ApolloReactHooks.QueryHookOptions<MediasiloReviewVideosQuery, MediasiloReviewVideosQueryVariables> & ({ variables: MediasiloReviewVideosQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<MediasiloReviewVideosQuery, MediasiloReviewVideosQueryVariables>(MediasiloReviewVideosDocument, options);
      }
export function useMediasiloReviewVideosLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<MediasiloReviewVideosQuery, MediasiloReviewVideosQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<MediasiloReviewVideosQuery, MediasiloReviewVideosQueryVariables>(MediasiloReviewVideosDocument, options);
        }
// @ts-ignore
export function useMediasiloReviewVideosSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<MediasiloReviewVideosQuery, MediasiloReviewVideosQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<MediasiloReviewVideosQuery, MediasiloReviewVideosQueryVariables>;
export function useMediasiloReviewVideosSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<MediasiloReviewVideosQuery, MediasiloReviewVideosQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<MediasiloReviewVideosQuery | undefined, MediasiloReviewVideosQueryVariables>;
export function useMediasiloReviewVideosSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<MediasiloReviewVideosQuery, MediasiloReviewVideosQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<MediasiloReviewVideosQuery, MediasiloReviewVideosQueryVariables>(MediasiloReviewVideosDocument, options);
        }
export type MediasiloReviewVideosQueryHookResult = ReturnType<typeof useMediasiloReviewVideosQuery>;
export type MediasiloReviewVideosLazyQueryHookResult = ReturnType<typeof useMediasiloReviewVideosLazyQuery>;
export type MediasiloReviewVideosSuspenseQueryHookResult = ReturnType<typeof useMediasiloReviewVideosSuspenseQuery>;
export type MediasiloReviewVideosQueryResult = Apollo.QueryResult<MediasiloReviewVideosQuery, MediasiloReviewVideosQueryVariables>;
export const MyPublishQueuesDocument = gql`
    query MyPublishQueues {
  myPublishQueues {
    ...PublishQueueFields
  }
}
    ${PublishQueueFieldsFragmentDoc}`;

/**
 * __useMyPublishQueuesQuery__
 *
 * To run a query within a React component, call `useMyPublishQueuesQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyPublishQueuesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyPublishQueuesQuery({
 *   variables: {
 *   },
 * });
 */
export function useMyPublishQueuesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<MyPublishQueuesQuery, MyPublishQueuesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<MyPublishQueuesQuery, MyPublishQueuesQueryVariables>(MyPublishQueuesDocument, options);
      }
export function useMyPublishQueuesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<MyPublishQueuesQuery, MyPublishQueuesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<MyPublishQueuesQuery, MyPublishQueuesQueryVariables>(MyPublishQueuesDocument, options);
        }
// @ts-ignore
export function useMyPublishQueuesSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<MyPublishQueuesQuery, MyPublishQueuesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<MyPublishQueuesQuery, MyPublishQueuesQueryVariables>;
export function useMyPublishQueuesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<MyPublishQueuesQuery, MyPublishQueuesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<MyPublishQueuesQuery | undefined, MyPublishQueuesQueryVariables>;
export function useMyPublishQueuesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<MyPublishQueuesQuery, MyPublishQueuesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<MyPublishQueuesQuery, MyPublishQueuesQueryVariables>(MyPublishQueuesDocument, options);
        }
export type MyPublishQueuesQueryHookResult = ReturnType<typeof useMyPublishQueuesQuery>;
export type MyPublishQueuesLazyQueryHookResult = ReturnType<typeof useMyPublishQueuesLazyQuery>;
export type MyPublishQueuesSuspenseQueryHookResult = ReturnType<typeof useMyPublishQueuesSuspenseQuery>;
export type MyPublishQueuesQueryResult = Apollo.QueryResult<MyPublishQueuesQuery, MyPublishQueuesQueryVariables>;
export const CreateMyPublishQueueDocument = gql`
    mutation CreateMyPublishQueue($input: PublishQueueInput!) {
  createMyPublishQueue(input: $input) {
    ...PublishQueueFields
  }
}
    ${PublishQueueFieldsFragmentDoc}`;
export type CreateMyPublishQueueMutationFn = Apollo.MutationFunction<CreateMyPublishQueueMutation, CreateMyPublishQueueMutationVariables>;

/**
 * __useCreateMyPublishQueueMutation__
 *
 * To run a mutation, you first call `useCreateMyPublishQueueMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMyPublishQueueMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMyPublishQueueMutation, { data, loading, error }] = useCreateMyPublishQueueMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateMyPublishQueueMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateMyPublishQueueMutation, CreateMyPublishQueueMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateMyPublishQueueMutation, CreateMyPublishQueueMutationVariables>(CreateMyPublishQueueDocument, options);
      }
export type CreateMyPublishQueueMutationHookResult = ReturnType<typeof useCreateMyPublishQueueMutation>;
export type CreateMyPublishQueueMutationResult = Apollo.MutationResult<CreateMyPublishQueueMutation>;
export type CreateMyPublishQueueMutationOptions = Apollo.BaseMutationOptions<CreateMyPublishQueueMutation, CreateMyPublishQueueMutationVariables>;
export const UpdateMyPublishQueueDocument = gql`
    mutation UpdateMyPublishQueue($id: ID!, $input: PublishQueueInput!) {
  updateMyPublishQueue(id: $id, input: $input) {
    ...PublishQueueFields
  }
}
    ${PublishQueueFieldsFragmentDoc}`;
export type UpdateMyPublishQueueMutationFn = Apollo.MutationFunction<UpdateMyPublishQueueMutation, UpdateMyPublishQueueMutationVariables>;

/**
 * __useUpdateMyPublishQueueMutation__
 *
 * To run a mutation, you first call `useUpdateMyPublishQueueMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMyPublishQueueMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMyPublishQueueMutation, { data, loading, error }] = useUpdateMyPublishQueueMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateMyPublishQueueMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateMyPublishQueueMutation, UpdateMyPublishQueueMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateMyPublishQueueMutation, UpdateMyPublishQueueMutationVariables>(UpdateMyPublishQueueDocument, options);
      }
export type UpdateMyPublishQueueMutationHookResult = ReturnType<typeof useUpdateMyPublishQueueMutation>;
export type UpdateMyPublishQueueMutationResult = Apollo.MutationResult<UpdateMyPublishQueueMutation>;
export type UpdateMyPublishQueueMutationOptions = Apollo.BaseMutationOptions<UpdateMyPublishQueueMutation, UpdateMyPublishQueueMutationVariables>;
export const DeleteMyPublishQueueDocument = gql`
    mutation DeleteMyPublishQueue($id: ID!) {
  deleteMyPublishQueue(id: $id)
}
    `;
export type DeleteMyPublishQueueMutationFn = Apollo.MutationFunction<DeleteMyPublishQueueMutation, DeleteMyPublishQueueMutationVariables>;

/**
 * __useDeleteMyPublishQueueMutation__
 *
 * To run a mutation, you first call `useDeleteMyPublishQueueMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteMyPublishQueueMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteMyPublishQueueMutation, { data, loading, error }] = useDeleteMyPublishQueueMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteMyPublishQueueMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteMyPublishQueueMutation, DeleteMyPublishQueueMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteMyPublishQueueMutation, DeleteMyPublishQueueMutationVariables>(DeleteMyPublishQueueDocument, options);
      }
export type DeleteMyPublishQueueMutationHookResult = ReturnType<typeof useDeleteMyPublishQueueMutation>;
export type DeleteMyPublishQueueMutationResult = Apollo.MutationResult<DeleteMyPublishQueueMutation>;
export type DeleteMyPublishQueueMutationOptions = Apollo.BaseMutationOptions<DeleteMyPublishQueueMutation, DeleteMyPublishQueueMutationVariables>;
export const EnqueueToPublishQueueDocument = gql`
    mutation EnqueueToPublishQueue($queueId: ID!, $clipId: ID!, $copy: EnqueueToPublishQueueCopyInput!) {
  enqueueToPublishQueue(queueId: $queueId, clipId: $clipId, copy: $copy) {
    id
    platform
    status
    scheduled_at
    title
    caption
    publish_queue {
      id
      name
    }
  }
}
    `;
export type EnqueueToPublishQueueMutationFn = Apollo.MutationFunction<EnqueueToPublishQueueMutation, EnqueueToPublishQueueMutationVariables>;

/**
 * __useEnqueueToPublishQueueMutation__
 *
 * To run a mutation, you first call `useEnqueueToPublishQueueMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEnqueueToPublishQueueMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [enqueueToPublishQueueMutation, { data, loading, error }] = useEnqueueToPublishQueueMutation({
 *   variables: {
 *      queueId: // value for 'queueId'
 *      clipId: // value for 'clipId'
 *      copy: // value for 'copy'
 *   },
 * });
 */
export function useEnqueueToPublishQueueMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<EnqueueToPublishQueueMutation, EnqueueToPublishQueueMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<EnqueueToPublishQueueMutation, EnqueueToPublishQueueMutationVariables>(EnqueueToPublishQueueDocument, options);
      }
export type EnqueueToPublishQueueMutationHookResult = ReturnType<typeof useEnqueueToPublishQueueMutation>;
export type EnqueueToPublishQueueMutationResult = Apollo.MutationResult<EnqueueToPublishQueueMutation>;
export type EnqueueToPublishQueueMutationOptions = Apollo.BaseMutationOptions<EnqueueToPublishQueueMutation, EnqueueToPublishQueueMutationVariables>;
export const QueueScheduledPublishesDocument = gql`
    query QueueScheduledPublishes($from: DateTime!, $to: DateTime!) {
  myScheduledPublishes(from: $from, to: $to) {
    id
    platform
    status
    scheduled_at
    clip_id
    clip_name
    title
    caption
    social_connection_id
    publish_queue {
      id
      name
    }
  }
}
    `;

/**
 * __useQueueScheduledPublishesQuery__
 *
 * To run a query within a React component, call `useQueueScheduledPublishesQuery` and pass it any options that fit your needs.
 * When your component renders, `useQueueScheduledPublishesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQueueScheduledPublishesQuery({
 *   variables: {
 *      from: // value for 'from'
 *      to: // value for 'to'
 *   },
 * });
 */
export function useQueueScheduledPublishesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<QueueScheduledPublishesQuery, QueueScheduledPublishesQueryVariables> & ({ variables: QueueScheduledPublishesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<QueueScheduledPublishesQuery, QueueScheduledPublishesQueryVariables>(QueueScheduledPublishesDocument, options);
      }
export function useQueueScheduledPublishesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<QueueScheduledPublishesQuery, QueueScheduledPublishesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<QueueScheduledPublishesQuery, QueueScheduledPublishesQueryVariables>(QueueScheduledPublishesDocument, options);
        }
// @ts-ignore
export function useQueueScheduledPublishesSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<QueueScheduledPublishesQuery, QueueScheduledPublishesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<QueueScheduledPublishesQuery, QueueScheduledPublishesQueryVariables>;
export function useQueueScheduledPublishesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<QueueScheduledPublishesQuery, QueueScheduledPublishesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<QueueScheduledPublishesQuery | undefined, QueueScheduledPublishesQueryVariables>;
export function useQueueScheduledPublishesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<QueueScheduledPublishesQuery, QueueScheduledPublishesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<QueueScheduledPublishesQuery, QueueScheduledPublishesQueryVariables>(QueueScheduledPublishesDocument, options);
        }
export type QueueScheduledPublishesQueryHookResult = ReturnType<typeof useQueueScheduledPublishesQuery>;
export type QueueScheduledPublishesLazyQueryHookResult = ReturnType<typeof useQueueScheduledPublishesLazyQuery>;
export type QueueScheduledPublishesSuspenseQueryHookResult = ReturnType<typeof useQueueScheduledPublishesSuspenseQuery>;
export type QueueScheduledPublishesQueryResult = Apollo.QueryResult<QueueScheduledPublishesQuery, QueueScheduledPublishesQueryVariables>;
export const MyClipPublishesDocument = gql`
    query MyClipPublishes($clipIds: [ID!]!) {
  myClipPublishes(clipIds: $clipIds) {
    ...PublishFields
  }
}
    ${PublishFieldsFragmentDoc}`;

/**
 * __useMyClipPublishesQuery__
 *
 * To run a query within a React component, call `useMyClipPublishesQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyClipPublishesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyClipPublishesQuery({
 *   variables: {
 *      clipIds: // value for 'clipIds'
 *   },
 * });
 */
export function useMyClipPublishesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<MyClipPublishesQuery, MyClipPublishesQueryVariables> & ({ variables: MyClipPublishesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<MyClipPublishesQuery, MyClipPublishesQueryVariables>(MyClipPublishesDocument, options);
      }
export function useMyClipPublishesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<MyClipPublishesQuery, MyClipPublishesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<MyClipPublishesQuery, MyClipPublishesQueryVariables>(MyClipPublishesDocument, options);
        }
// @ts-ignore
export function useMyClipPublishesSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<MyClipPublishesQuery, MyClipPublishesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<MyClipPublishesQuery, MyClipPublishesQueryVariables>;
export function useMyClipPublishesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<MyClipPublishesQuery, MyClipPublishesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<MyClipPublishesQuery | undefined, MyClipPublishesQueryVariables>;
export function useMyClipPublishesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<MyClipPublishesQuery, MyClipPublishesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<MyClipPublishesQuery, MyClipPublishesQueryVariables>(MyClipPublishesDocument, options);
        }
export type MyClipPublishesQueryHookResult = ReturnType<typeof useMyClipPublishesQuery>;
export type MyClipPublishesLazyQueryHookResult = ReturnType<typeof useMyClipPublishesLazyQuery>;
export type MyClipPublishesSuspenseQueryHookResult = ReturnType<typeof useMyClipPublishesSuspenseQuery>;
export type MyClipPublishesQueryResult = Apollo.QueryResult<MyClipPublishesQuery, MyClipPublishesQueryVariables>;
export const MyConnectionPublishesDocument = gql`
    query MyConnectionPublishes($socialConnectionId: ID!) {
  myConnectionPublishes(socialConnectionId: $socialConnectionId) {
    ...PublishFields
  }
}
    ${PublishFieldsFragmentDoc}`;

/**
 * __useMyConnectionPublishesQuery__
 *
 * To run a query within a React component, call `useMyConnectionPublishesQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyConnectionPublishesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyConnectionPublishesQuery({
 *   variables: {
 *      socialConnectionId: // value for 'socialConnectionId'
 *   },
 * });
 */
export function useMyConnectionPublishesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<MyConnectionPublishesQuery, MyConnectionPublishesQueryVariables> & ({ variables: MyConnectionPublishesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<MyConnectionPublishesQuery, MyConnectionPublishesQueryVariables>(MyConnectionPublishesDocument, options);
      }
export function useMyConnectionPublishesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<MyConnectionPublishesQuery, MyConnectionPublishesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<MyConnectionPublishesQuery, MyConnectionPublishesQueryVariables>(MyConnectionPublishesDocument, options);
        }
// @ts-ignore
export function useMyConnectionPublishesSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<MyConnectionPublishesQuery, MyConnectionPublishesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<MyConnectionPublishesQuery, MyConnectionPublishesQueryVariables>;
export function useMyConnectionPublishesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<MyConnectionPublishesQuery, MyConnectionPublishesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<MyConnectionPublishesQuery | undefined, MyConnectionPublishesQueryVariables>;
export function useMyConnectionPublishesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<MyConnectionPublishesQuery, MyConnectionPublishesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<MyConnectionPublishesQuery, MyConnectionPublishesQueryVariables>(MyConnectionPublishesDocument, options);
        }
export type MyConnectionPublishesQueryHookResult = ReturnType<typeof useMyConnectionPublishesQuery>;
export type MyConnectionPublishesLazyQueryHookResult = ReturnType<typeof useMyConnectionPublishesLazyQuery>;
export type MyConnectionPublishesSuspenseQueryHookResult = ReturnType<typeof useMyConnectionPublishesSuspenseQuery>;
export type MyConnectionPublishesQueryResult = Apollo.QueryResult<MyConnectionPublishesQuery, MyConnectionPublishesQueryVariables>;
export const TikTokCreatorInfoDocument = gql`
    query TikTokCreatorInfo($socialConnectionId: ID!) {
  tiktokCreatorInfo(socialConnectionId: $socialConnectionId) {
    creator_avatar_url
    creator_username
    creator_nickname
    privacy_level_options
    comment_disabled
    duet_disabled
    stitch_disabled
    max_video_post_duration_sec
  }
}
    `;

/**
 * __useTikTokCreatorInfoQuery__
 *
 * To run a query within a React component, call `useTikTokCreatorInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useTikTokCreatorInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTikTokCreatorInfoQuery({
 *   variables: {
 *      socialConnectionId: // value for 'socialConnectionId'
 *   },
 * });
 */
export function useTikTokCreatorInfoQuery(baseOptions: ApolloReactHooks.QueryHookOptions<TikTokCreatorInfoQuery, TikTokCreatorInfoQueryVariables> & ({ variables: TikTokCreatorInfoQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TikTokCreatorInfoQuery, TikTokCreatorInfoQueryVariables>(TikTokCreatorInfoDocument, options);
      }
export function useTikTokCreatorInfoLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TikTokCreatorInfoQuery, TikTokCreatorInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TikTokCreatorInfoQuery, TikTokCreatorInfoQueryVariables>(TikTokCreatorInfoDocument, options);
        }
// @ts-ignore
export function useTikTokCreatorInfoSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<TikTokCreatorInfoQuery, TikTokCreatorInfoQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<TikTokCreatorInfoQuery, TikTokCreatorInfoQueryVariables>;
export function useTikTokCreatorInfoSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<TikTokCreatorInfoQuery, TikTokCreatorInfoQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<TikTokCreatorInfoQuery | undefined, TikTokCreatorInfoQueryVariables>;
export function useTikTokCreatorInfoSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<TikTokCreatorInfoQuery, TikTokCreatorInfoQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<TikTokCreatorInfoQuery, TikTokCreatorInfoQueryVariables>(TikTokCreatorInfoDocument, options);
        }
export type TikTokCreatorInfoQueryHookResult = ReturnType<typeof useTikTokCreatorInfoQuery>;
export type TikTokCreatorInfoLazyQueryHookResult = ReturnType<typeof useTikTokCreatorInfoLazyQuery>;
export type TikTokCreatorInfoSuspenseQueryHookResult = ReturnType<typeof useTikTokCreatorInfoSuspenseQuery>;
export type TikTokCreatorInfoQueryResult = Apollo.QueryResult<TikTokCreatorInfoQuery, TikTokCreatorInfoQueryVariables>;
export const PublishClipToTikTokDocument = gql`
    mutation PublishClipToTikTok($clipId: ID!, $socialConnectionId: ID!, $title: String, $privacyLevel: String!, $disableComment: Boolean, $disableDuet: Boolean, $disableStitch: Boolean, $brandOrganicToggle: Boolean, $brandContentToggle: Boolean, $isAigc: Boolean, $imageUrls: [String!]) {
  publishClipToTikTok(
    clipId: $clipId
    socialConnectionId: $socialConnectionId
    title: $title
    privacyLevel: $privacyLevel
    disableComment: $disableComment
    disableDuet: $disableDuet
    disableStitch: $disableStitch
    brandOrganicToggle: $brandOrganicToggle
    brandContentToggle: $brandContentToggle
    isAigc: $isAigc
    imageUrls: $imageUrls
  ) {
    ...PublishFields
  }
}
    ${PublishFieldsFragmentDoc}`;
export type PublishClipToTikTokMutationFn = Apollo.MutationFunction<PublishClipToTikTokMutation, PublishClipToTikTokMutationVariables>;

/**
 * __usePublishClipToTikTokMutation__
 *
 * To run a mutation, you first call `usePublishClipToTikTokMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePublishClipToTikTokMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [publishClipToTikTokMutation, { data, loading, error }] = usePublishClipToTikTokMutation({
 *   variables: {
 *      clipId: // value for 'clipId'
 *      socialConnectionId: // value for 'socialConnectionId'
 *      title: // value for 'title'
 *      privacyLevel: // value for 'privacyLevel'
 *      disableComment: // value for 'disableComment'
 *      disableDuet: // value for 'disableDuet'
 *      disableStitch: // value for 'disableStitch'
 *      brandOrganicToggle: // value for 'brandOrganicToggle'
 *      brandContentToggle: // value for 'brandContentToggle'
 *      isAigc: // value for 'isAigc'
 *      imageUrls: // value for 'imageUrls'
 *   },
 * });
 */
export function usePublishClipToTikTokMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<PublishClipToTikTokMutation, PublishClipToTikTokMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<PublishClipToTikTokMutation, PublishClipToTikTokMutationVariables>(PublishClipToTikTokDocument, options);
      }
export type PublishClipToTikTokMutationHookResult = ReturnType<typeof usePublishClipToTikTokMutation>;
export type PublishClipToTikTokMutationResult = Apollo.MutationResult<PublishClipToTikTokMutation>;
export type PublishClipToTikTokMutationOptions = Apollo.BaseMutationOptions<PublishClipToTikTokMutation, PublishClipToTikTokMutationVariables>;
export const SendClipToTikTokDraftsDocument = gql`
    mutation SendClipToTikTokDrafts($clipId: ID!, $socialConnectionId: ID!, $caption: String) {
  sendClipToTikTokDrafts(
    clipId: $clipId
    socialConnectionId: $socialConnectionId
    caption: $caption
  ) {
    ...PublishFields
  }
}
    ${PublishFieldsFragmentDoc}`;
export type SendClipToTikTokDraftsMutationFn = Apollo.MutationFunction<SendClipToTikTokDraftsMutation, SendClipToTikTokDraftsMutationVariables>;

/**
 * __useSendClipToTikTokDraftsMutation__
 *
 * To run a mutation, you first call `useSendClipToTikTokDraftsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendClipToTikTokDraftsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendClipToTikTokDraftsMutation, { data, loading, error }] = useSendClipToTikTokDraftsMutation({
 *   variables: {
 *      clipId: // value for 'clipId'
 *      socialConnectionId: // value for 'socialConnectionId'
 *      caption: // value for 'caption'
 *   },
 * });
 */
export function useSendClipToTikTokDraftsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SendClipToTikTokDraftsMutation, SendClipToTikTokDraftsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SendClipToTikTokDraftsMutation, SendClipToTikTokDraftsMutationVariables>(SendClipToTikTokDraftsDocument, options);
      }
export type SendClipToTikTokDraftsMutationHookResult = ReturnType<typeof useSendClipToTikTokDraftsMutation>;
export type SendClipToTikTokDraftsMutationResult = Apollo.MutationResult<SendClipToTikTokDraftsMutation>;
export type SendClipToTikTokDraftsMutationOptions = Apollo.BaseMutationOptions<SendClipToTikTokDraftsMutation, SendClipToTikTokDraftsMutationVariables>;
export const PublishClipToInstagramDocument = gql`
    mutation PublishClipToInstagram($clipId: ID!, $socialConnectionId: ID!, $caption: String, $imageUrls: [String!]) {
  publishClipToInstagram(
    clipId: $clipId
    socialConnectionId: $socialConnectionId
    caption: $caption
    imageUrls: $imageUrls
  ) {
    ...PublishFields
  }
}
    ${PublishFieldsFragmentDoc}`;
export type PublishClipToInstagramMutationFn = Apollo.MutationFunction<PublishClipToInstagramMutation, PublishClipToInstagramMutationVariables>;

/**
 * __usePublishClipToInstagramMutation__
 *
 * To run a mutation, you first call `usePublishClipToInstagramMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePublishClipToInstagramMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [publishClipToInstagramMutation, { data, loading, error }] = usePublishClipToInstagramMutation({
 *   variables: {
 *      clipId: // value for 'clipId'
 *      socialConnectionId: // value for 'socialConnectionId'
 *      caption: // value for 'caption'
 *      imageUrls: // value for 'imageUrls'
 *   },
 * });
 */
export function usePublishClipToInstagramMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<PublishClipToInstagramMutation, PublishClipToInstagramMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<PublishClipToInstagramMutation, PublishClipToInstagramMutationVariables>(PublishClipToInstagramDocument, options);
      }
export type PublishClipToInstagramMutationHookResult = ReturnType<typeof usePublishClipToInstagramMutation>;
export type PublishClipToInstagramMutationResult = Apollo.MutationResult<PublishClipToInstagramMutation>;
export type PublishClipToInstagramMutationOptions = Apollo.BaseMutationOptions<PublishClipToInstagramMutation, PublishClipToInstagramMutationVariables>;
export const PublishClipToFacebookDocument = gql`
    mutation PublishClipToFacebook($clipId: ID!, $socialConnectionId: ID!, $caption: String, $imageUrls: [String!]) {
  publishClipToFacebook(
    clipId: $clipId
    socialConnectionId: $socialConnectionId
    caption: $caption
    imageUrls: $imageUrls
  ) {
    ...PublishFields
  }
}
    ${PublishFieldsFragmentDoc}`;
export type PublishClipToFacebookMutationFn = Apollo.MutationFunction<PublishClipToFacebookMutation, PublishClipToFacebookMutationVariables>;

/**
 * __usePublishClipToFacebookMutation__
 *
 * To run a mutation, you first call `usePublishClipToFacebookMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePublishClipToFacebookMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [publishClipToFacebookMutation, { data, loading, error }] = usePublishClipToFacebookMutation({
 *   variables: {
 *      clipId: // value for 'clipId'
 *      socialConnectionId: // value for 'socialConnectionId'
 *      caption: // value for 'caption'
 *      imageUrls: // value for 'imageUrls'
 *   },
 * });
 */
export function usePublishClipToFacebookMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<PublishClipToFacebookMutation, PublishClipToFacebookMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<PublishClipToFacebookMutation, PublishClipToFacebookMutationVariables>(PublishClipToFacebookDocument, options);
      }
export type PublishClipToFacebookMutationHookResult = ReturnType<typeof usePublishClipToFacebookMutation>;
export type PublishClipToFacebookMutationResult = Apollo.MutationResult<PublishClipToFacebookMutation>;
export type PublishClipToFacebookMutationOptions = Apollo.BaseMutationOptions<PublishClipToFacebookMutation, PublishClipToFacebookMutationVariables>;
export const PublishClipToYouTubeDocument = gql`
    mutation PublishClipToYouTube($clipId: ID!, $socialConnectionId: ID!, $title: String!, $description: String, $privacyStatus: String!, $madeForKids: Boolean!) {
  publishClipToYouTube(
    clipId: $clipId
    socialConnectionId: $socialConnectionId
    title: $title
    description: $description
    privacyStatus: $privacyStatus
    madeForKids: $madeForKids
  ) {
    ...PublishFields
  }
}
    ${PublishFieldsFragmentDoc}`;
export type PublishClipToYouTubeMutationFn = Apollo.MutationFunction<PublishClipToYouTubeMutation, PublishClipToYouTubeMutationVariables>;

/**
 * __usePublishClipToYouTubeMutation__
 *
 * To run a mutation, you first call `usePublishClipToYouTubeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePublishClipToYouTubeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [publishClipToYouTubeMutation, { data, loading, error }] = usePublishClipToYouTubeMutation({
 *   variables: {
 *      clipId: // value for 'clipId'
 *      socialConnectionId: // value for 'socialConnectionId'
 *      title: // value for 'title'
 *      description: // value for 'description'
 *      privacyStatus: // value for 'privacyStatus'
 *      madeForKids: // value for 'madeForKids'
 *   },
 * });
 */
export function usePublishClipToYouTubeMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<PublishClipToYouTubeMutation, PublishClipToYouTubeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<PublishClipToYouTubeMutation, PublishClipToYouTubeMutationVariables>(PublishClipToYouTubeDocument, options);
      }
export type PublishClipToYouTubeMutationHookResult = ReturnType<typeof usePublishClipToYouTubeMutation>;
export type PublishClipToYouTubeMutationResult = Apollo.MutationResult<PublishClipToYouTubeMutation>;
export type PublishClipToYouTubeMutationOptions = Apollo.BaseMutationOptions<PublishClipToYouTubeMutation, PublishClipToYouTubeMutationVariables>;
export const UpdateMyDataDocument = gql`
    mutation UpdateMyData($name: String!, $profilePicture: Media, $phoneNumber: String, $targetObjective: String, $objectivesWithPlatform: String, $workflowDescription: String, $jobTitle: String, $emailMarketingOptIn: Boolean) {
  updateMyData(
    name: $name
    profilePicture: $profilePicture
    phoneNumber: $phoneNumber
    targetObjective: $targetObjective
    objectivesWithPlatform: $objectivesWithPlatform
    workflowDescription: $workflowDescription
    jobTitle: $jobTitle
    emailMarketingOptIn: $emailMarketingOptIn
  ) {
    id
    name
    profile_picture
    phone_number
    job_title
    target_objective
    objectives_with_platform
    workflow_description
    email_marketing_opt_in
  }
}
    `;
export type UpdateMyDataMutationFn = Apollo.MutationFunction<UpdateMyDataMutation, UpdateMyDataMutationVariables>;

/**
 * __useUpdateMyDataMutation__
 *
 * To run a mutation, you first call `useUpdateMyDataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMyDataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMyDataMutation, { data, loading, error }] = useUpdateMyDataMutation({
 *   variables: {
 *      name: // value for 'name'
 *      profilePicture: // value for 'profilePicture'
 *      phoneNumber: // value for 'phoneNumber'
 *      targetObjective: // value for 'targetObjective'
 *      objectivesWithPlatform: // value for 'objectivesWithPlatform'
 *      workflowDescription: // value for 'workflowDescription'
 *      jobTitle: // value for 'jobTitle'
 *      emailMarketingOptIn: // value for 'emailMarketingOptIn'
 *   },
 * });
 */
export function useUpdateMyDataMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateMyDataMutation, UpdateMyDataMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateMyDataMutation, UpdateMyDataMutationVariables>(UpdateMyDataDocument, options);
      }
export type UpdateMyDataMutationHookResult = ReturnType<typeof useUpdateMyDataMutation>;
export type UpdateMyDataMutationResult = Apollo.MutationResult<UpdateMyDataMutation>;
export type UpdateMyDataMutationOptions = Apollo.BaseMutationOptions<UpdateMyDataMutation, UpdateMyDataMutationVariables>;
export const GetMyLocaleDocument = gql`
    query GetMyLocale {
  myData {
    id
    locale
  }
}
    `;

/**
 * __useGetMyLocaleQuery__
 *
 * To run a query within a React component, call `useGetMyLocaleQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyLocaleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyLocaleQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMyLocaleQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetMyLocaleQuery, GetMyLocaleQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetMyLocaleQuery, GetMyLocaleQueryVariables>(GetMyLocaleDocument, options);
      }
export function useGetMyLocaleLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetMyLocaleQuery, GetMyLocaleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetMyLocaleQuery, GetMyLocaleQueryVariables>(GetMyLocaleDocument, options);
        }
// @ts-ignore
export function useGetMyLocaleSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetMyLocaleQuery, GetMyLocaleQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetMyLocaleQuery, GetMyLocaleQueryVariables>;
export function useGetMyLocaleSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetMyLocaleQuery, GetMyLocaleQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetMyLocaleQuery | undefined, GetMyLocaleQueryVariables>;
export function useGetMyLocaleSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetMyLocaleQuery, GetMyLocaleQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetMyLocaleQuery, GetMyLocaleQueryVariables>(GetMyLocaleDocument, options);
        }
export type GetMyLocaleQueryHookResult = ReturnType<typeof useGetMyLocaleQuery>;
export type GetMyLocaleLazyQueryHookResult = ReturnType<typeof useGetMyLocaleLazyQuery>;
export type GetMyLocaleSuspenseQueryHookResult = ReturnType<typeof useGetMyLocaleSuspenseQuery>;
export type GetMyLocaleQueryResult = Apollo.QueryResult<GetMyLocaleQuery, GetMyLocaleQueryVariables>;
export const UpdateMyLocaleDocument = gql`
    mutation UpdateMyLocale($locale: String!) {
  updateMyData(locale: $locale) {
    id
    locale
  }
}
    `;
export type UpdateMyLocaleMutationFn = Apollo.MutationFunction<UpdateMyLocaleMutation, UpdateMyLocaleMutationVariables>;

/**
 * __useUpdateMyLocaleMutation__
 *
 * To run a mutation, you first call `useUpdateMyLocaleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMyLocaleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMyLocaleMutation, { data, loading, error }] = useUpdateMyLocaleMutation({
 *   variables: {
 *      locale: // value for 'locale'
 *   },
 * });
 */
export function useUpdateMyLocaleMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateMyLocaleMutation, UpdateMyLocaleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateMyLocaleMutation, UpdateMyLocaleMutationVariables>(UpdateMyLocaleDocument, options);
      }
export type UpdateMyLocaleMutationHookResult = ReturnType<typeof useUpdateMyLocaleMutation>;
export type UpdateMyLocaleMutationResult = Apollo.MutationResult<UpdateMyLocaleMutation>;
export type UpdateMyLocaleMutationOptions = Apollo.BaseMutationOptions<UpdateMyLocaleMutation, UpdateMyLocaleMutationVariables>;
export const UpdateOnboardingDocument = gql`
    mutation UpdateOnboarding($onboardingObjective: String!, $jobTitle: String!, $onboardingExperience: String) {
  updateMyData(
    onboardingObjective: $onboardingObjective
    jobTitle: $jobTitle
    onboardingExperience: $onboardingExperience
  ) {
    id
    job_title
    onboarding_objective
    onboarding_experience
  }
}
    `;
export type UpdateOnboardingMutationFn = Apollo.MutationFunction<UpdateOnboardingMutation, UpdateOnboardingMutationVariables>;

/**
 * __useUpdateOnboardingMutation__
 *
 * To run a mutation, you first call `useUpdateOnboardingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOnboardingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOnboardingMutation, { data, loading, error }] = useUpdateOnboardingMutation({
 *   variables: {
 *      onboardingObjective: // value for 'onboardingObjective'
 *      jobTitle: // value for 'jobTitle'
 *      onboardingExperience: // value for 'onboardingExperience'
 *   },
 * });
 */
export function useUpdateOnboardingMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateOnboardingMutation, UpdateOnboardingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateOnboardingMutation, UpdateOnboardingMutationVariables>(UpdateOnboardingDocument, options);
      }
export type UpdateOnboardingMutationHookResult = ReturnType<typeof useUpdateOnboardingMutation>;
export type UpdateOnboardingMutationResult = Apollo.MutationResult<UpdateOnboardingMutation>;
export type UpdateOnboardingMutationOptions = Apollo.BaseMutationOptions<UpdateOnboardingMutation, UpdateOnboardingMutationVariables>;
export const ChangeOnboardingObjectiveDocument = gql`
    mutation ChangeOnboardingObjective($to: String!) {
  changeOnboardingObjective(to: $to) {
    id
    job_title
    onboarding_objective
    onboarding_experience
  }
}
    `;
export type ChangeOnboardingObjectiveMutationFn = Apollo.MutationFunction<ChangeOnboardingObjectiveMutation, ChangeOnboardingObjectiveMutationVariables>;

/**
 * __useChangeOnboardingObjectiveMutation__
 *
 * To run a mutation, you first call `useChangeOnboardingObjectiveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangeOnboardingObjectiveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changeOnboardingObjectiveMutation, { data, loading, error }] = useChangeOnboardingObjectiveMutation({
 *   variables: {
 *      to: // value for 'to'
 *   },
 * });
 */
export function useChangeOnboardingObjectiveMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ChangeOnboardingObjectiveMutation, ChangeOnboardingObjectiveMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ChangeOnboardingObjectiveMutation, ChangeOnboardingObjectiveMutationVariables>(ChangeOnboardingObjectiveDocument, options);
      }
export type ChangeOnboardingObjectiveMutationHookResult = ReturnType<typeof useChangeOnboardingObjectiveMutation>;
export type ChangeOnboardingObjectiveMutationResult = Apollo.MutationResult<ChangeOnboardingObjectiveMutation>;
export type ChangeOnboardingObjectiveMutationOptions = Apollo.BaseMutationOptions<ChangeOnboardingObjectiveMutation, ChangeOnboardingObjectiveMutationVariables>;
export const MyDataDocument = gql`
    query MyData {
  myData {
    id
    name
    email
    provider
    hasPassword
    googleLinked
    role
    is_admin
    job_title
    phone_number
    target_objective
    objectives_with_platform
    workflow_description
    profile_picture
    affiliate
    subscription
    createdAt
    onboarding_objective
    onboarding_experience
    joined_community
    has_challenge_participation
    challenge_participation {
      id
      name
      end_date
    }
    tags {
      id
    }
    cpm_terms_accepted_version
    cpm_terms_accepted_at
    cpm_terms_current_version
    payout_data {
      name
      document
      bank
      agency
      account
      pix_key
    }
    email_marketing_opt_in
  }
}
    `;

/**
 * __useMyDataQuery__
 *
 * To run a query within a React component, call `useMyDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyDataQuery({
 *   variables: {
 *   },
 * });
 */
export function useMyDataQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<MyDataQuery, MyDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<MyDataQuery, MyDataQueryVariables>(MyDataDocument, options);
      }
export function useMyDataLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<MyDataQuery, MyDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<MyDataQuery, MyDataQueryVariables>(MyDataDocument, options);
        }
// @ts-ignore
export function useMyDataSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<MyDataQuery, MyDataQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<MyDataQuery, MyDataQueryVariables>;
export function useMyDataSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<MyDataQuery, MyDataQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<MyDataQuery | undefined, MyDataQueryVariables>;
export function useMyDataSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<MyDataQuery, MyDataQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<MyDataQuery, MyDataQueryVariables>(MyDataDocument, options);
        }
export type MyDataQueryHookResult = ReturnType<typeof useMyDataQuery>;
export type MyDataLazyQueryHookResult = ReturnType<typeof useMyDataLazyQuery>;
export type MyDataSuspenseQueryHookResult = ReturnType<typeof useMyDataSuspenseQuery>;
export type MyDataQueryResult = Apollo.QueryResult<MyDataQuery, MyDataQueryVariables>;
export const SetPasswordDocument = gql`
    mutation SetPassword($currentPassword: String, $newPassword: String!) {
  setPassword(currentPassword: $currentPassword, newPassword: $newPassword)
}
    `;
export type SetPasswordMutationFn = Apollo.MutationFunction<SetPasswordMutation, SetPasswordMutationVariables>;

/**
 * __useSetPasswordMutation__
 *
 * To run a mutation, you first call `useSetPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setPasswordMutation, { data, loading, error }] = useSetPasswordMutation({
 *   variables: {
 *      currentPassword: // value for 'currentPassword'
 *      newPassword: // value for 'newPassword'
 *   },
 * });
 */
export function useSetPasswordMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SetPasswordMutation, SetPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SetPasswordMutation, SetPasswordMutationVariables>(SetPasswordDocument, options);
      }
export type SetPasswordMutationHookResult = ReturnType<typeof useSetPasswordMutation>;
export type SetPasswordMutationResult = Apollo.MutationResult<SetPasswordMutation>;
export type SetPasswordMutationOptions = Apollo.BaseMutationOptions<SetPasswordMutation, SetPasswordMutationVariables>;
export const UpdateMyPayoutDataDocument = gql`
    mutation UpdateMyPayoutData($input: UpdateMyPayoutDataInput!) {
  updateMyPayoutData(input: $input) {
    name
    document
    bank
    agency
    account
    pix_key
  }
}
    `;
export type UpdateMyPayoutDataMutationFn = Apollo.MutationFunction<UpdateMyPayoutDataMutation, UpdateMyPayoutDataMutationVariables>;

/**
 * __useUpdateMyPayoutDataMutation__
 *
 * To run a mutation, you first call `useUpdateMyPayoutDataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMyPayoutDataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMyPayoutDataMutation, { data, loading, error }] = useUpdateMyPayoutDataMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateMyPayoutDataMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateMyPayoutDataMutation, UpdateMyPayoutDataMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateMyPayoutDataMutation, UpdateMyPayoutDataMutationVariables>(UpdateMyPayoutDataDocument, options);
      }
export type UpdateMyPayoutDataMutationHookResult = ReturnType<typeof useUpdateMyPayoutDataMutation>;
export type UpdateMyPayoutDataMutationResult = Apollo.MutationResult<UpdateMyPayoutDataMutation>;
export type UpdateMyPayoutDataMutationOptions = Apollo.BaseMutationOptions<UpdateMyPayoutDataMutation, UpdateMyPayoutDataMutationVariables>;
export const MarkCommunityJoinedDocument = gql`
    mutation MarkCommunityJoined {
  markCommunityJoined {
    id
    joined_community
  }
}
    `;
export type MarkCommunityJoinedMutationFn = Apollo.MutationFunction<MarkCommunityJoinedMutation, MarkCommunityJoinedMutationVariables>;

/**
 * __useMarkCommunityJoinedMutation__
 *
 * To run a mutation, you first call `useMarkCommunityJoinedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkCommunityJoinedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markCommunityJoinedMutation, { data, loading, error }] = useMarkCommunityJoinedMutation({
 *   variables: {
 *   },
 * });
 */
export function useMarkCommunityJoinedMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<MarkCommunityJoinedMutation, MarkCommunityJoinedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<MarkCommunityJoinedMutation, MarkCommunityJoinedMutationVariables>(MarkCommunityJoinedDocument, options);
      }
export type MarkCommunityJoinedMutationHookResult = ReturnType<typeof useMarkCommunityJoinedMutation>;
export type MarkCommunityJoinedMutationResult = Apollo.MutationResult<MarkCommunityJoinedMutation>;
export type MarkCommunityJoinedMutationOptions = Apollo.BaseMutationOptions<MarkCommunityJoinedMutation, MarkCommunityJoinedMutationVariables>;
export const AcceptCpmTermsDocument = gql`
    mutation AcceptCpmTerms($version: String!) {
  acceptCpmTerms(version: $version) {
    id
    cpm_terms_accepted_version
    cpm_terms_accepted_at
    cpm_terms_current_version
  }
}
    `;
export type AcceptCpmTermsMutationFn = Apollo.MutationFunction<AcceptCpmTermsMutation, AcceptCpmTermsMutationVariables>;

/**
 * __useAcceptCpmTermsMutation__
 *
 * To run a mutation, you first call `useAcceptCpmTermsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAcceptCpmTermsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [acceptCpmTermsMutation, { data, loading, error }] = useAcceptCpmTermsMutation({
 *   variables: {
 *      version: // value for 'version'
 *   },
 * });
 */
export function useAcceptCpmTermsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AcceptCpmTermsMutation, AcceptCpmTermsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AcceptCpmTermsMutation, AcceptCpmTermsMutationVariables>(AcceptCpmTermsDocument, options);
      }
export type AcceptCpmTermsMutationHookResult = ReturnType<typeof useAcceptCpmTermsMutation>;
export type AcceptCpmTermsMutationResult = Apollo.MutationResult<AcceptCpmTermsMutation>;
export type AcceptCpmTermsMutationOptions = Apollo.BaseMutationOptions<AcceptCpmTermsMutation, AcceptCpmTermsMutationVariables>;
export const MyProjectsDocument = gql`
    query MyProjects($limit: Int, $offset: Int) {
  myProjects(limit: $limit, offset: $offset) {
    id
    name
    curation_status
    favorite
    public
    format
    language
    audio_language
    audio_track
    translation_status
    prompt
    processing_mode
    eta_seconds
    base_video_url
    compressed_base_video_url
    cut_video_url
    created_by_user
    compressed_cut_video_url
    thumbnail_url
    news_pdf_mirror_url
    duration_seconds
    clips_count
    filesize
    start_time
    end_time
    createdAt
  }
}
    `;

/**
 * __useMyProjectsQuery__
 *
 * To run a query within a React component, call `useMyProjectsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyProjectsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyProjectsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useMyProjectsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<MyProjectsQuery, MyProjectsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<MyProjectsQuery, MyProjectsQueryVariables>(MyProjectsDocument, options);
      }
export function useMyProjectsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<MyProjectsQuery, MyProjectsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<MyProjectsQuery, MyProjectsQueryVariables>(MyProjectsDocument, options);
        }
// @ts-ignore
export function useMyProjectsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<MyProjectsQuery, MyProjectsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<MyProjectsQuery, MyProjectsQueryVariables>;
export function useMyProjectsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<MyProjectsQuery, MyProjectsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<MyProjectsQuery | undefined, MyProjectsQueryVariables>;
export function useMyProjectsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<MyProjectsQuery, MyProjectsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<MyProjectsQuery, MyProjectsQueryVariables>(MyProjectsDocument, options);
        }
export type MyProjectsQueryHookResult = ReturnType<typeof useMyProjectsQuery>;
export type MyProjectsLazyQueryHookResult = ReturnType<typeof useMyProjectsLazyQuery>;
export type MyProjectsSuspenseQueryHookResult = ReturnType<typeof useMyProjectsSuspenseQuery>;
export type MyProjectsQueryResult = Apollo.QueryResult<MyProjectsQuery, MyProjectsQueryVariables>;
export const MyProjectDocument = gql`
    query MyProject($id: ID!) {
  myProject(id: $id) {
    id
    name
    curation_status
    source_status
    failure_code
    curation_rating
    favorite
    public
    format
    language
    audio_language
    audio_track
    translation_status
    prompt
    processing_mode
    eta_seconds
    base_video_url
    compressed_base_video_url
    cut_video_url
    thumbnail_url
    compressed_cut_video_url
    news_pdf_mirror_url
    speaker_layout
    post_layout
    subtitle_config
    watermark_position
    default_subtitles_enabled
    scene_detection
    scene_detection_url
    video_signals_url
    content_type
    content_type_confidence
    duration_seconds
    clips_count
    filesize
    start_time
    end_time
    curated_clips
    clips {
      id
      name
      duration_seconds
      clip_start_time
      clip_end_time
      original_clip_start_time
      original_clip_end_time
      clip_score
      clip_order
      clip_summary
      clip_thumbnail
      curation_rating
      dirty
      clipping_status
      rendering_status
      thumbnail_url
      finished_video_url
      finished_video_thumbnail_url
      data
    }
    transcription
    transcription_url
    original_transcription_url
    brand_kit {
      id
      name
    }
    createdAt
  }
}
    `;

/**
 * __useMyProjectQuery__
 *
 * To run a query within a React component, call `useMyProjectQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyProjectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyProjectQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useMyProjectQuery(baseOptions: ApolloReactHooks.QueryHookOptions<MyProjectQuery, MyProjectQueryVariables> & ({ variables: MyProjectQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<MyProjectQuery, MyProjectQueryVariables>(MyProjectDocument, options);
      }
export function useMyProjectLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<MyProjectQuery, MyProjectQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<MyProjectQuery, MyProjectQueryVariables>(MyProjectDocument, options);
        }
// @ts-ignore
export function useMyProjectSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<MyProjectQuery, MyProjectQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<MyProjectQuery, MyProjectQueryVariables>;
export function useMyProjectSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<MyProjectQuery, MyProjectQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<MyProjectQuery | undefined, MyProjectQueryVariables>;
export function useMyProjectSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<MyProjectQuery, MyProjectQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<MyProjectQuery, MyProjectQueryVariables>(MyProjectDocument, options);
        }
export type MyProjectQueryHookResult = ReturnType<typeof useMyProjectQuery>;
export type MyProjectLazyQueryHookResult = ReturnType<typeof useMyProjectLazyQuery>;
export type MyProjectSuspenseQueryHookResult = ReturnType<typeof useMyProjectSuspenseQuery>;
export type MyProjectQueryResult = Apollo.QueryResult<MyProjectQuery, MyProjectQueryVariables>;
export const MyLibrariesDocument = gql`
    query MyLibraries($limit: Int, $offset: Int, $tagIds: [ID!], $search: String, $channelId: ID, $channelCategory: String) {
  myLibraries(
    limit: $limit
    offset: $offset
    tagIds: $tagIds
    search: $search
    channelId: $channelId
    channelCategory: $channelCategory
  ) {
    id
    name
    curation_status
    favorite
    public
    format
    language
    audio_language
    audio_track
    translation_status
    prompt
    processing_mode
    eta_seconds
    created_by_user
    created_by_user_name
    base_video_url
    compressed_base_video_url
    original_video_url
    cut_video_url
    compressed_cut_video_url
    thumbnail_url
    duration_seconds
    clips_count
    filesize
    start_time
    end_time
    tags {
      id
      name
      color
    }
    youtube_channels {
      id
      channel_id
      name
      url
      thumbnail
      handle
      subscriber_count
      category
    }
    source_library_id
    youtube_video_id
    view_count
    upload_date
    createdAt
  }
}
    `;

/**
 * __useMyLibrariesQuery__
 *
 * To run a query within a React component, call `useMyLibrariesQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyLibrariesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyLibrariesQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      tagIds: // value for 'tagIds'
 *      search: // value for 'search'
 *      channelId: // value for 'channelId'
 *      channelCategory: // value for 'channelCategory'
 *   },
 * });
 */
export function useMyLibrariesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<MyLibrariesQuery, MyLibrariesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<MyLibrariesQuery, MyLibrariesQueryVariables>(MyLibrariesDocument, options);
      }
export function useMyLibrariesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<MyLibrariesQuery, MyLibrariesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<MyLibrariesQuery, MyLibrariesQueryVariables>(MyLibrariesDocument, options);
        }
// @ts-ignore
export function useMyLibrariesSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<MyLibrariesQuery, MyLibrariesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<MyLibrariesQuery, MyLibrariesQueryVariables>;
export function useMyLibrariesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<MyLibrariesQuery, MyLibrariesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<MyLibrariesQuery | undefined, MyLibrariesQueryVariables>;
export function useMyLibrariesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<MyLibrariesQuery, MyLibrariesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<MyLibrariesQuery, MyLibrariesQueryVariables>(MyLibrariesDocument, options);
        }
export type MyLibrariesQueryHookResult = ReturnType<typeof useMyLibrariesQuery>;
export type MyLibrariesLazyQueryHookResult = ReturnType<typeof useMyLibrariesLazyQuery>;
export type MyLibrariesSuspenseQueryHookResult = ReturnType<typeof useMyLibrariesSuspenseQuery>;
export type MyLibrariesQueryResult = Apollo.QueryResult<MyLibrariesQuery, MyLibrariesQueryVariables>;
export const MyLibrariesCountsDocument = gql`
    query MyLibrariesCounts {
  myLibrariesCounts {
    mine
    community
  }
}
    `;

/**
 * __useMyLibrariesCountsQuery__
 *
 * To run a query within a React component, call `useMyLibrariesCountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyLibrariesCountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyLibrariesCountsQuery({
 *   variables: {
 *   },
 * });
 */
export function useMyLibrariesCountsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<MyLibrariesCountsQuery, MyLibrariesCountsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<MyLibrariesCountsQuery, MyLibrariesCountsQueryVariables>(MyLibrariesCountsDocument, options);
      }
export function useMyLibrariesCountsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<MyLibrariesCountsQuery, MyLibrariesCountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<MyLibrariesCountsQuery, MyLibrariesCountsQueryVariables>(MyLibrariesCountsDocument, options);
        }
// @ts-ignore
export function useMyLibrariesCountsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<MyLibrariesCountsQuery, MyLibrariesCountsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<MyLibrariesCountsQuery, MyLibrariesCountsQueryVariables>;
export function useMyLibrariesCountsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<MyLibrariesCountsQuery, MyLibrariesCountsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<MyLibrariesCountsQuery | undefined, MyLibrariesCountsQueryVariables>;
export function useMyLibrariesCountsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<MyLibrariesCountsQuery, MyLibrariesCountsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<MyLibrariesCountsQuery, MyLibrariesCountsQueryVariables>(MyLibrariesCountsDocument, options);
        }
export type MyLibrariesCountsQueryHookResult = ReturnType<typeof useMyLibrariesCountsQuery>;
export type MyLibrariesCountsLazyQueryHookResult = ReturnType<typeof useMyLibrariesCountsLazyQuery>;
export type MyLibrariesCountsSuspenseQueryHookResult = ReturnType<typeof useMyLibrariesCountsSuspenseQuery>;
export type MyLibrariesCountsQueryResult = Apollo.QueryResult<MyLibrariesCountsQuery, MyLibrariesCountsQueryVariables>;
export const CommunityLibrariesDocument = gql`
    query CommunityLibraries($limit: Int, $offset: Int, $search: String, $channelId: ID, $channelCategory: String, $sort: String, $tagId: ID) {
  communityLibraries(
    limit: $limit
    offset: $offset
    search: $search
    channelId: $channelId
    channelCategory: $channelCategory
    sort: $sort
    tagId: $tagId
  ) {
    id
    name
    curation_status
    format
    language
    processing_mode
    created_by_user
    created_by_user_name
    base_video_url
    compressed_base_video_url
    original_video_url
    cut_video_url
    thumbnail_url
    duration_seconds
    start_time
    end_time
    youtube_channels {
      id
      channel_id
      name
      url
      thumbnail
      handle
      subscriber_count
      category
    }
    source_library_id
    youtube_video_id
    remix_count
    view_count
    upload_date
    createdAt
  }
}
    `;

/**
 * __useCommunityLibrariesQuery__
 *
 * To run a query within a React component, call `useCommunityLibrariesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCommunityLibrariesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCommunityLibrariesQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      search: // value for 'search'
 *      channelId: // value for 'channelId'
 *      channelCategory: // value for 'channelCategory'
 *      sort: // value for 'sort'
 *      tagId: // value for 'tagId'
 *   },
 * });
 */
export function useCommunityLibrariesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<CommunityLibrariesQuery, CommunityLibrariesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<CommunityLibrariesQuery, CommunityLibrariesQueryVariables>(CommunityLibrariesDocument, options);
      }
export function useCommunityLibrariesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CommunityLibrariesQuery, CommunityLibrariesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<CommunityLibrariesQuery, CommunityLibrariesQueryVariables>(CommunityLibrariesDocument, options);
        }
// @ts-ignore
export function useCommunityLibrariesSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<CommunityLibrariesQuery, CommunityLibrariesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<CommunityLibrariesQuery, CommunityLibrariesQueryVariables>;
export function useCommunityLibrariesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<CommunityLibrariesQuery, CommunityLibrariesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<CommunityLibrariesQuery | undefined, CommunityLibrariesQueryVariables>;
export function useCommunityLibrariesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<CommunityLibrariesQuery, CommunityLibrariesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<CommunityLibrariesQuery, CommunityLibrariesQueryVariables>(CommunityLibrariesDocument, options);
        }
export type CommunityLibrariesQueryHookResult = ReturnType<typeof useCommunityLibrariesQuery>;
export type CommunityLibrariesLazyQueryHookResult = ReturnType<typeof useCommunityLibrariesLazyQuery>;
export type CommunityLibrariesSuspenseQueryHookResult = ReturnType<typeof useCommunityLibrariesSuspenseQuery>;
export type CommunityLibrariesQueryResult = Apollo.QueryResult<CommunityLibrariesQuery, CommunityLibrariesQueryVariables>;
export const CheckCommunityLibraryByUrlDocument = gql`
    query CheckCommunityLibraryByUrl($url: String!) {
  checkCommunityLibraryByUrl(url: $url) {
    id
    name
    base_video_url
    duration_seconds
    format
    language
    start_time
    end_time
    active_cpm_campaigns {
      id
    }
    youtube_channels {
      channel_id
    }
  }
}
    `;

/**
 * __useCheckCommunityLibraryByUrlQuery__
 *
 * To run a query within a React component, call `useCheckCommunityLibraryByUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckCommunityLibraryByUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckCommunityLibraryByUrlQuery({
 *   variables: {
 *      url: // value for 'url'
 *   },
 * });
 */
export function useCheckCommunityLibraryByUrlQuery(baseOptions: ApolloReactHooks.QueryHookOptions<CheckCommunityLibraryByUrlQuery, CheckCommunityLibraryByUrlQueryVariables> & ({ variables: CheckCommunityLibraryByUrlQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<CheckCommunityLibraryByUrlQuery, CheckCommunityLibraryByUrlQueryVariables>(CheckCommunityLibraryByUrlDocument, options);
      }
export function useCheckCommunityLibraryByUrlLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CheckCommunityLibraryByUrlQuery, CheckCommunityLibraryByUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<CheckCommunityLibraryByUrlQuery, CheckCommunityLibraryByUrlQueryVariables>(CheckCommunityLibraryByUrlDocument, options);
        }
// @ts-ignore
export function useCheckCommunityLibraryByUrlSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<CheckCommunityLibraryByUrlQuery, CheckCommunityLibraryByUrlQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<CheckCommunityLibraryByUrlQuery, CheckCommunityLibraryByUrlQueryVariables>;
export function useCheckCommunityLibraryByUrlSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<CheckCommunityLibraryByUrlQuery, CheckCommunityLibraryByUrlQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<CheckCommunityLibraryByUrlQuery | undefined, CheckCommunityLibraryByUrlQueryVariables>;
export function useCheckCommunityLibraryByUrlSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<CheckCommunityLibraryByUrlQuery, CheckCommunityLibraryByUrlQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<CheckCommunityLibraryByUrlQuery, CheckCommunityLibraryByUrlQueryVariables>(CheckCommunityLibraryByUrlDocument, options);
        }
export type CheckCommunityLibraryByUrlQueryHookResult = ReturnType<typeof useCheckCommunityLibraryByUrlQuery>;
export type CheckCommunityLibraryByUrlLazyQueryHookResult = ReturnType<typeof useCheckCommunityLibraryByUrlLazyQuery>;
export type CheckCommunityLibraryByUrlSuspenseQueryHookResult = ReturnType<typeof useCheckCommunityLibraryByUrlSuspenseQuery>;
export type CheckCommunityLibraryByUrlQueryResult = Apollo.QueryResult<CheckCommunityLibraryByUrlQuery, CheckCommunityLibraryByUrlQueryVariables>;
export const CommunityTagsDocument = gql`
    query CommunityTags($channelId: ID, $channelCategory: String) {
  communityTags(channelId: $channelId, channelCategory: $channelCategory) {
    id
    name
    color
    download_count
  }
}
    `;

/**
 * __useCommunityTagsQuery__
 *
 * To run a query within a React component, call `useCommunityTagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCommunityTagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCommunityTagsQuery({
 *   variables: {
 *      channelId: // value for 'channelId'
 *      channelCategory: // value for 'channelCategory'
 *   },
 * });
 */
export function useCommunityTagsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<CommunityTagsQuery, CommunityTagsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<CommunityTagsQuery, CommunityTagsQueryVariables>(CommunityTagsDocument, options);
      }
export function useCommunityTagsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CommunityTagsQuery, CommunityTagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<CommunityTagsQuery, CommunityTagsQueryVariables>(CommunityTagsDocument, options);
        }
// @ts-ignore
export function useCommunityTagsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<CommunityTagsQuery, CommunityTagsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<CommunityTagsQuery, CommunityTagsQueryVariables>;
export function useCommunityTagsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<CommunityTagsQuery, CommunityTagsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<CommunityTagsQuery | undefined, CommunityTagsQueryVariables>;
export function useCommunityTagsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<CommunityTagsQuery, CommunityTagsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<CommunityTagsQuery, CommunityTagsQueryVariables>(CommunityTagsDocument, options);
        }
export type CommunityTagsQueryHookResult = ReturnType<typeof useCommunityTagsQuery>;
export type CommunityTagsLazyQueryHookResult = ReturnType<typeof useCommunityTagsLazyQuery>;
export type CommunityTagsSuspenseQueryHookResult = ReturnType<typeof useCommunityTagsSuspenseQuery>;
export type CommunityTagsQueryResult = Apollo.QueryResult<CommunityTagsQuery, CommunityTagsQueryVariables>;
export const CommunityChannelsDocument = gql`
    query CommunityChannels($category: String, $search: String, $sort: String) {
  communityChannels(category: $category, search: $search, sort: $sort) {
    id
    channel_id
    name
    url
    thumbnail
    handle
    subscriber_count
    category
    is_autoclipper_partner
    remix_count
  }
}
    `;

/**
 * __useCommunityChannelsQuery__
 *
 * To run a query within a React component, call `useCommunityChannelsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCommunityChannelsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCommunityChannelsQuery({
 *   variables: {
 *      category: // value for 'category'
 *      search: // value for 'search'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useCommunityChannelsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<CommunityChannelsQuery, CommunityChannelsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<CommunityChannelsQuery, CommunityChannelsQueryVariables>(CommunityChannelsDocument, options);
      }
export function useCommunityChannelsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CommunityChannelsQuery, CommunityChannelsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<CommunityChannelsQuery, CommunityChannelsQueryVariables>(CommunityChannelsDocument, options);
        }
// @ts-ignore
export function useCommunityChannelsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<CommunityChannelsQuery, CommunityChannelsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<CommunityChannelsQuery, CommunityChannelsQueryVariables>;
export function useCommunityChannelsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<CommunityChannelsQuery, CommunityChannelsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<CommunityChannelsQuery | undefined, CommunityChannelsQueryVariables>;
export function useCommunityChannelsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<CommunityChannelsQuery, CommunityChannelsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<CommunityChannelsQuery, CommunityChannelsQueryVariables>(CommunityChannelsDocument, options);
        }
export type CommunityChannelsQueryHookResult = ReturnType<typeof useCommunityChannelsQuery>;
export type CommunityChannelsLazyQueryHookResult = ReturnType<typeof useCommunityChannelsLazyQuery>;
export type CommunityChannelsSuspenseQueryHookResult = ReturnType<typeof useCommunityChannelsSuspenseQuery>;
export type CommunityChannelsQueryResult = Apollo.QueryResult<CommunityChannelsQuery, CommunityChannelsQueryVariables>;
export const CreateMyLibraryDocument = gql`
    mutation createMyLibrary($input: MyLibraryCreateInput!) {
  createMyLibrary(input: $input) {
    id
    name
    curation_status
    favorite
    public
    format
    language
    prompt
    processing_mode
    remove_silence
    eta_seconds
    created_by_user
    cut_video_url
    compressed_cut_video_url
    thumbnail_url
    duration_seconds
    clips_count
    filesize
    start_time
    end_time
    tags {
      id
      name
      color
    }
    youtube_channels {
      id
      channel_id
      name
      url
      thumbnail
      handle
      subscriber_count
      category
    }
    createdAt
  }
}
    `;
export type CreateMyLibraryMutationFn = Apollo.MutationFunction<CreateMyLibraryMutation, CreateMyLibraryMutationVariables>;

/**
 * __useCreateMyLibraryMutation__
 *
 * To run a mutation, you first call `useCreateMyLibraryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMyLibraryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMyLibraryMutation, { data, loading, error }] = useCreateMyLibraryMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateMyLibraryMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateMyLibraryMutation, CreateMyLibraryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateMyLibraryMutation, CreateMyLibraryMutationVariables>(CreateMyLibraryDocument, options);
      }
export type CreateMyLibraryMutationHookResult = ReturnType<typeof useCreateMyLibraryMutation>;
export type CreateMyLibraryMutationResult = Apollo.MutationResult<CreateMyLibraryMutation>;
export type CreateMyLibraryMutationOptions = Apollo.BaseMutationOptions<CreateMyLibraryMutation, CreateMyLibraryMutationVariables>;
export const DeleteMyLibraryDocument = gql`
    mutation deleteMyLibrary($id: ID!) {
  deleteMyLibrary(id: $id) {
    id
  }
}
    `;
export type DeleteMyLibraryMutationFn = Apollo.MutationFunction<DeleteMyLibraryMutation, DeleteMyLibraryMutationVariables>;

/**
 * __useDeleteMyLibraryMutation__
 *
 * To run a mutation, you first call `useDeleteMyLibraryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteMyLibraryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteMyLibraryMutation, { data, loading, error }] = useDeleteMyLibraryMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteMyLibraryMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteMyLibraryMutation, DeleteMyLibraryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteMyLibraryMutation, DeleteMyLibraryMutationVariables>(DeleteMyLibraryDocument, options);
      }
export type DeleteMyLibraryMutationHookResult = ReturnType<typeof useDeleteMyLibraryMutation>;
export type DeleteMyLibraryMutationResult = Apollo.MutationResult<DeleteMyLibraryMutation>;
export type DeleteMyLibraryMutationOptions = Apollo.BaseMutationOptions<DeleteMyLibraryMutation, DeleteMyLibraryMutationVariables>;
export const MyClipsDocument = gql`
    query MyClips($limit: Int, $offset: Int) {
  myClips(limit: $limit, offset: $offset) {
    id
    name
    can_edit
    eta_seconds
    duration_seconds
    clip_score
    clip_order
    dirty
    clipping_status
    preparing_status
    rendering_status
    clipped_video_url
    thumbnail_url
    created_by_user
    compressed_video_url
    finished_video_url
    finished_video_thumbnail_url
    is_library_clip
    project_id
    library_id
    source_clip_id
    version_number
    curation_rating
    cover_image_url
    can_set_cover
    createdAt
  }
}
    `;

/**
 * __useMyClipsQuery__
 *
 * To run a query within a React component, call `useMyClipsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyClipsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyClipsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useMyClipsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<MyClipsQuery, MyClipsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<MyClipsQuery, MyClipsQueryVariables>(MyClipsDocument, options);
      }
export function useMyClipsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<MyClipsQuery, MyClipsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<MyClipsQuery, MyClipsQueryVariables>(MyClipsDocument, options);
        }
// @ts-ignore
export function useMyClipsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<MyClipsQuery, MyClipsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<MyClipsQuery, MyClipsQueryVariables>;
export function useMyClipsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<MyClipsQuery, MyClipsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<MyClipsQuery | undefined, MyClipsQueryVariables>;
export function useMyClipsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<MyClipsQuery, MyClipsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<MyClipsQuery, MyClipsQueryVariables>(MyClipsDocument, options);
        }
export type MyClipsQueryHookResult = ReturnType<typeof useMyClipsQuery>;
export type MyClipsLazyQueryHookResult = ReturnType<typeof useMyClipsLazyQuery>;
export type MyClipsSuspenseQueryHookResult = ReturnType<typeof useMyClipsSuspenseQuery>;
export type MyClipsQueryResult = Apollo.QueryResult<MyClipsQuery, MyClipsQueryVariables>;
export const MyClipDocument = gql`
    query MyClip($id: ID!) {
  myClip(id: $id) {
    id
    name
    can_edit
    eta_seconds
    duration_seconds
    clip_score
    clip_order
    clip_start_time
    clip_end_time
    original_clip_start_time
    original_clip_end_time
    clip_summary
    clip_thumbnail
    clipping_status
    preparing_status
    rendering_status
    clipped_video_url
    thumbnail_url
    created_by_user
    compressed_video_url
    finished_video_url
    finished_video_thumbnail_url
    curation_rating
    cover_image_url
    can_set_cover
    dirty
    data
    is_library_clip
    project_id
    library_id
    source_clip_id
    version_number
    copy {
      id
      processing_status
      result
      createdAt
      updatedAt
    }
    createdAt
  }
}
    `;

/**
 * __useMyClipQuery__
 *
 * To run a query within a React component, call `useMyClipQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyClipQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyClipQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useMyClipQuery(baseOptions: ApolloReactHooks.QueryHookOptions<MyClipQuery, MyClipQueryVariables> & ({ variables: MyClipQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<MyClipQuery, MyClipQueryVariables>(MyClipDocument, options);
      }
export function useMyClipLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<MyClipQuery, MyClipQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<MyClipQuery, MyClipQueryVariables>(MyClipDocument, options);
        }
// @ts-ignore
export function useMyClipSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<MyClipQuery, MyClipQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<MyClipQuery, MyClipQueryVariables>;
export function useMyClipSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<MyClipQuery, MyClipQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<MyClipQuery | undefined, MyClipQueryVariables>;
export function useMyClipSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<MyClipQuery, MyClipQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<MyClipQuery, MyClipQueryVariables>(MyClipDocument, options);
        }
export type MyClipQueryHookResult = ReturnType<typeof useMyClipQuery>;
export type MyClipLazyQueryHookResult = ReturnType<typeof useMyClipLazyQuery>;
export type MyClipSuspenseQueryHookResult = ReturnType<typeof useMyClipSuspenseQuery>;
export type MyClipQueryResult = Apollo.QueryResult<MyClipQuery, MyClipQueryVariables>;
export const PlansDocument = gql`
    query Plans {
  plans {
    documentId
    name
    slug
    value
    value_yearly
    value_usd
    value_yearly_usd
    processing_seconds
    description_items
    max_clips
    max_library_curations
    max_library_exports
    max_library_video_seconds
    max_brand_kits
    payment_link
    payment_link_yearly
    discount_label
    max_expiry_days
    color
    order
  }
}
    `;

/**
 * __usePlansQuery__
 *
 * To run a query within a React component, call `usePlansQuery` and pass it any options that fit your needs.
 * When your component renders, `usePlansQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePlansQuery({
 *   variables: {
 *   },
 * });
 */
export function usePlansQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<PlansQuery, PlansQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<PlansQuery, PlansQueryVariables>(PlansDocument, options);
      }
export function usePlansLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<PlansQuery, PlansQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<PlansQuery, PlansQueryVariables>(PlansDocument, options);
        }
// @ts-ignore
export function usePlansSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<PlansQuery, PlansQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<PlansQuery, PlansQueryVariables>;
export function usePlansSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<PlansQuery, PlansQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<PlansQuery | undefined, PlansQueryVariables>;
export function usePlansSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<PlansQuery, PlansQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<PlansQuery, PlansQueryVariables>(PlansDocument, options);
        }
export type PlansQueryHookResult = ReturnType<typeof usePlansQuery>;
export type PlansLazyQueryHookResult = ReturnType<typeof usePlansLazyQuery>;
export type PlansSuspenseQueryHookResult = ReturnType<typeof usePlansSuspenseQuery>;
export type PlansQueryResult = Apollo.QueryResult<PlansQuery, PlansQueryVariables>;
export const PlanDocument = gql`
    query Plan($id: ID!) {
  plan(id: $id) {
    documentId
    name
    slug
    value
    value_yearly
    value_usd
    value_yearly_usd
    processing_seconds
    description_items
    max_clips
    payment_link
    payment_link_yearly
    discount_label
    color
    order
  }
}
    `;

/**
 * __usePlanQuery__
 *
 * To run a query within a React component, call `usePlanQuery` and pass it any options that fit your needs.
 * When your component renders, `usePlanQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePlanQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePlanQuery(baseOptions: ApolloReactHooks.QueryHookOptions<PlanQuery, PlanQueryVariables> & ({ variables: PlanQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<PlanQuery, PlanQueryVariables>(PlanDocument, options);
      }
export function usePlanLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<PlanQuery, PlanQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<PlanQuery, PlanQueryVariables>(PlanDocument, options);
        }
// @ts-ignore
export function usePlanSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<PlanQuery, PlanQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<PlanQuery, PlanQueryVariables>;
export function usePlanSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<PlanQuery, PlanQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<PlanQuery | undefined, PlanQueryVariables>;
export function usePlanSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<PlanQuery, PlanQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<PlanQuery, PlanQueryVariables>(PlanDocument, options);
        }
export type PlanQueryHookResult = ReturnType<typeof usePlanQuery>;
export type PlanLazyQueryHookResult = ReturnType<typeof usePlanLazyQuery>;
export type PlanSuspenseQueryHookResult = ReturnType<typeof usePlanSuspenseQuery>;
export type PlanQueryResult = Apollo.QueryResult<PlanQuery, PlanQueryVariables>;
export const MyApiKeysDocument = gql`
    query myApiKeys {
  myAPIKeys {
    id
    name
    key
    createdAt
  }
}
    `;

/**
 * __useMyApiKeysQuery__
 *
 * To run a query within a React component, call `useMyApiKeysQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyApiKeysQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyApiKeysQuery({
 *   variables: {
 *   },
 * });
 */
export function useMyApiKeysQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<MyApiKeysQuery, MyApiKeysQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<MyApiKeysQuery, MyApiKeysQueryVariables>(MyApiKeysDocument, options);
      }
export function useMyApiKeysLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<MyApiKeysQuery, MyApiKeysQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<MyApiKeysQuery, MyApiKeysQueryVariables>(MyApiKeysDocument, options);
        }
// @ts-ignore
export function useMyApiKeysSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<MyApiKeysQuery, MyApiKeysQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<MyApiKeysQuery, MyApiKeysQueryVariables>;
export function useMyApiKeysSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<MyApiKeysQuery, MyApiKeysQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<MyApiKeysQuery | undefined, MyApiKeysQueryVariables>;
export function useMyApiKeysSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<MyApiKeysQuery, MyApiKeysQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<MyApiKeysQuery, MyApiKeysQueryVariables>(MyApiKeysDocument, options);
        }
export type MyApiKeysQueryHookResult = ReturnType<typeof useMyApiKeysQuery>;
export type MyApiKeysLazyQueryHookResult = ReturnType<typeof useMyApiKeysLazyQuery>;
export type MyApiKeysSuspenseQueryHookResult = ReturnType<typeof useMyApiKeysSuspenseQuery>;
export type MyApiKeysQueryResult = Apollo.QueryResult<MyApiKeysQuery, MyApiKeysQueryVariables>;
export const CreateMyApiKeyDocument = gql`
    mutation createMyApiKey($input: MyAPIKeyCreateInput!) {
  createMyAPIKey(input: $input) {
    id
    name
    key
    createdAt
    updatedAt
  }
}
    `;
export type CreateMyApiKeyMutationFn = Apollo.MutationFunction<CreateMyApiKeyMutation, CreateMyApiKeyMutationVariables>;

/**
 * __useCreateMyApiKeyMutation__
 *
 * To run a mutation, you first call `useCreateMyApiKeyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMyApiKeyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMyApiKeyMutation, { data, loading, error }] = useCreateMyApiKeyMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateMyApiKeyMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateMyApiKeyMutation, CreateMyApiKeyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateMyApiKeyMutation, CreateMyApiKeyMutationVariables>(CreateMyApiKeyDocument, options);
      }
export type CreateMyApiKeyMutationHookResult = ReturnType<typeof useCreateMyApiKeyMutation>;
export type CreateMyApiKeyMutationResult = Apollo.MutationResult<CreateMyApiKeyMutation>;
export type CreateMyApiKeyMutationOptions = Apollo.BaseMutationOptions<CreateMyApiKeyMutation, CreateMyApiKeyMutationVariables>;
export const UpdateMyApiKeyDocument = gql`
    mutation updateMyApiKey($id: ID!, $input: MyAPIKeyUpdateInput!) {
  updateMyAPIKey(id: $id, input: $input) {
    id
    name
    key
    createdAt
    updatedAt
  }
}
    `;
export type UpdateMyApiKeyMutationFn = Apollo.MutationFunction<UpdateMyApiKeyMutation, UpdateMyApiKeyMutationVariables>;

/**
 * __useUpdateMyApiKeyMutation__
 *
 * To run a mutation, you first call `useUpdateMyApiKeyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMyApiKeyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMyApiKeyMutation, { data, loading, error }] = useUpdateMyApiKeyMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateMyApiKeyMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateMyApiKeyMutation, UpdateMyApiKeyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateMyApiKeyMutation, UpdateMyApiKeyMutationVariables>(UpdateMyApiKeyDocument, options);
      }
export type UpdateMyApiKeyMutationHookResult = ReturnType<typeof useUpdateMyApiKeyMutation>;
export type UpdateMyApiKeyMutationResult = Apollo.MutationResult<UpdateMyApiKeyMutation>;
export type UpdateMyApiKeyMutationOptions = Apollo.BaseMutationOptions<UpdateMyApiKeyMutation, UpdateMyApiKeyMutationVariables>;
export const DeleteMyApiKeyDocument = gql`
    mutation deleteMyApiKey($id: ID!) {
  deleteMyAPIKey(id: $id) {
    id
    name
    key
    createdAt
    updatedAt
  }
}
    `;
export type DeleteMyApiKeyMutationFn = Apollo.MutationFunction<DeleteMyApiKeyMutation, DeleteMyApiKeyMutationVariables>;

/**
 * __useDeleteMyApiKeyMutation__
 *
 * To run a mutation, you first call `useDeleteMyApiKeyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteMyApiKeyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteMyApiKeyMutation, { data, loading, error }] = useDeleteMyApiKeyMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteMyApiKeyMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteMyApiKeyMutation, DeleteMyApiKeyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteMyApiKeyMutation, DeleteMyApiKeyMutationVariables>(DeleteMyApiKeyDocument, options);
      }
export type DeleteMyApiKeyMutationHookResult = ReturnType<typeof useDeleteMyApiKeyMutation>;
export type DeleteMyApiKeyMutationResult = Apollo.MutationResult<DeleteMyApiKeyMutation>;
export type DeleteMyApiKeyMutationOptions = Apollo.BaseMutationOptions<DeleteMyApiKeyMutation, DeleteMyApiKeyMutationVariables>;
export const MyApiRequestsDocument = gql`
    query myApiRequests($limit: Int, $offset: Int) {
  myAPIRequests(limit: $limit, offset: $offset) {
    id
    name
    process_status
    base_video_url
    webhook_url
    thumbnail_url
    clips {
      id
      name
      rendered_video_url
    }
    api_key_name
    createdAt
  }
}
    `;

/**
 * __useMyApiRequestsQuery__
 *
 * To run a query within a React component, call `useMyApiRequestsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyApiRequestsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyApiRequestsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useMyApiRequestsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<MyApiRequestsQuery, MyApiRequestsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<MyApiRequestsQuery, MyApiRequestsQueryVariables>(MyApiRequestsDocument, options);
      }
export function useMyApiRequestsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<MyApiRequestsQuery, MyApiRequestsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<MyApiRequestsQuery, MyApiRequestsQueryVariables>(MyApiRequestsDocument, options);
        }
// @ts-ignore
export function useMyApiRequestsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<MyApiRequestsQuery, MyApiRequestsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<MyApiRequestsQuery, MyApiRequestsQueryVariables>;
export function useMyApiRequestsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<MyApiRequestsQuery, MyApiRequestsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<MyApiRequestsQuery | undefined, MyApiRequestsQueryVariables>;
export function useMyApiRequestsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<MyApiRequestsQuery, MyApiRequestsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<MyApiRequestsQuery, MyApiRequestsQueryVariables>(MyApiRequestsDocument, options);
        }
export type MyApiRequestsQueryHookResult = ReturnType<typeof useMyApiRequestsQuery>;
export type MyApiRequestsLazyQueryHookResult = ReturnType<typeof useMyApiRequestsLazyQuery>;
export type MyApiRequestsSuspenseQueryHookResult = ReturnType<typeof useMyApiRequestsSuspenseQuery>;
export type MyApiRequestsQueryResult = Apollo.QueryResult<MyApiRequestsQuery, MyApiRequestsQueryVariables>;
export const RetriggerMyApiRequestWebhookDocument = gql`
    mutation retriggerMyApiRequestWebhook($id: ID!) {
  retriggerMyAPIRequestWebhook(id: $id) {
    success
  }
}
    `;
export type RetriggerMyApiRequestWebhookMutationFn = Apollo.MutationFunction<RetriggerMyApiRequestWebhookMutation, RetriggerMyApiRequestWebhookMutationVariables>;

/**
 * __useRetriggerMyApiRequestWebhookMutation__
 *
 * To run a mutation, you first call `useRetriggerMyApiRequestWebhookMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRetriggerMyApiRequestWebhookMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [retriggerMyApiRequestWebhookMutation, { data, loading, error }] = useRetriggerMyApiRequestWebhookMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRetriggerMyApiRequestWebhookMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<RetriggerMyApiRequestWebhookMutation, RetriggerMyApiRequestWebhookMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<RetriggerMyApiRequestWebhookMutation, RetriggerMyApiRequestWebhookMutationVariables>(RetriggerMyApiRequestWebhookDocument, options);
      }
export type RetriggerMyApiRequestWebhookMutationHookResult = ReturnType<typeof useRetriggerMyApiRequestWebhookMutation>;
export type RetriggerMyApiRequestWebhookMutationResult = Apollo.MutationResult<RetriggerMyApiRequestWebhookMutation>;
export type RetriggerMyApiRequestWebhookMutationOptions = Apollo.BaseMutationOptions<RetriggerMyApiRequestWebhookMutation, RetriggerMyApiRequestWebhookMutationVariables>;
export const CreateMyProjectDocument = gql`
    mutation createMyProject($input: MyProjectCreateInput!) {
  createMyProject(input: $input) {
    id
    name
    curation_status
    favorite
    public
    format
    language
    prompt
    processing_mode
    remove_silence
    eta_seconds
    base_video_url
    compressed_base_video_url
    cut_video_url
    created_by_user
    compressed_cut_video_url
    thumbnail_url
    duration_seconds
    filesize
    start_time
    end_time
    createdAt
  }
}
    `;
export type CreateMyProjectMutationFn = Apollo.MutationFunction<CreateMyProjectMutation, CreateMyProjectMutationVariables>;

/**
 * __useCreateMyProjectMutation__
 *
 * To run a mutation, you first call `useCreateMyProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMyProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMyProjectMutation, { data, loading, error }] = useCreateMyProjectMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateMyProjectMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateMyProjectMutation, CreateMyProjectMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateMyProjectMutation, CreateMyProjectMutationVariables>(CreateMyProjectDocument, options);
      }
export type CreateMyProjectMutationHookResult = ReturnType<typeof useCreateMyProjectMutation>;
export type CreateMyProjectMutationResult = Apollo.MutationResult<CreateMyProjectMutation>;
export type CreateMyProjectMutationOptions = Apollo.BaseMutationOptions<CreateMyProjectMutation, CreateMyProjectMutationVariables>;
export const DeleteMyProjectDocument = gql`
    mutation deleteMyProject($id: ID!) {
  deleteMyProject(id: $id) {
    id
  }
}
    `;
export type DeleteMyProjectMutationFn = Apollo.MutationFunction<DeleteMyProjectMutation, DeleteMyProjectMutationVariables>;

/**
 * __useDeleteMyProjectMutation__
 *
 * To run a mutation, you first call `useDeleteMyProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteMyProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteMyProjectMutation, { data, loading, error }] = useDeleteMyProjectMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteMyProjectMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteMyProjectMutation, DeleteMyProjectMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteMyProjectMutation, DeleteMyProjectMutationVariables>(DeleteMyProjectDocument, options);
      }
export type DeleteMyProjectMutationHookResult = ReturnType<typeof useDeleteMyProjectMutation>;
export type DeleteMyProjectMutationResult = Apollo.MutationResult<DeleteMyProjectMutation>;
export type DeleteMyProjectMutationOptions = Apollo.BaseMutationOptions<DeleteMyProjectMutation, DeleteMyProjectMutationVariables>;
export const UpdateMyProjectDocument = gql`
    mutation updateMyProject($id: ID!, $input: MyProjectUpdateInput!) {
  updateMyProject(id: $id, input: $input) {
    id
    name
    curation_rating
    transcription_url
    speaker_layout
    post_layout
    subtitle_config
    watermark_position
    brand_kit {
      id
      name
    }
  }
}
    `;
export type UpdateMyProjectMutationFn = Apollo.MutationFunction<UpdateMyProjectMutation, UpdateMyProjectMutationVariables>;

/**
 * __useUpdateMyProjectMutation__
 *
 * To run a mutation, you first call `useUpdateMyProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMyProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMyProjectMutation, { data, loading, error }] = useUpdateMyProjectMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateMyProjectMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateMyProjectMutation, UpdateMyProjectMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateMyProjectMutation, UpdateMyProjectMutationVariables>(UpdateMyProjectDocument, options);
      }
export type UpdateMyProjectMutationHookResult = ReturnType<typeof useUpdateMyProjectMutation>;
export type UpdateMyProjectMutationResult = Apollo.MutationResult<UpdateMyProjectMutation>;
export type UpdateMyProjectMutationOptions = Apollo.BaseMutationOptions<UpdateMyProjectMutation, UpdateMyProjectMutationVariables>;
export const ClipProjectDocument = gql`
    mutation clipProject($input: ClipProjectInput!) {
  clipProject(input: $input) {
    id
    name
    can_edit
    eta_seconds
    duration_seconds
    clipping_status
    preparing_status
    rendering_status
    clipped_video_url
    created_by_user
    compressed_video_url
    finished_video_url
    createdAt
  }
}
    `;
export type ClipProjectMutationFn = Apollo.MutationFunction<ClipProjectMutation, ClipProjectMutationVariables>;

/**
 * __useClipProjectMutation__
 *
 * To run a mutation, you first call `useClipProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useClipProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [clipProjectMutation, { data, loading, error }] = useClipProjectMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useClipProjectMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ClipProjectMutation, ClipProjectMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ClipProjectMutation, ClipProjectMutationVariables>(ClipProjectDocument, options);
      }
export type ClipProjectMutationHookResult = ReturnType<typeof useClipProjectMutation>;
export type ClipProjectMutationResult = Apollo.MutationResult<ClipProjectMutation>;
export type ClipProjectMutationOptions = Apollo.BaseMutationOptions<ClipProjectMutation, ClipProjectMutationVariables>;
export const ActivateClipDocument = gql`
    mutation activateClip($id: ID!, $input: ActivateClipInput!) {
  activateClip(id: $id, input: $input) {
    id
    name
    can_edit
    eta_seconds
    duration_seconds
    clipping_status
    preparing_status
    rendering_status
    clipped_video_url
    created_by_user
    compressed_video_url
    finished_video_url
    createdAt
  }
}
    `;
export type ActivateClipMutationFn = Apollo.MutationFunction<ActivateClipMutation, ActivateClipMutationVariables>;

/**
 * __useActivateClipMutation__
 *
 * To run a mutation, you first call `useActivateClipMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useActivateClipMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [activateClipMutation, { data, loading, error }] = useActivateClipMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useActivateClipMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ActivateClipMutation, ActivateClipMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ActivateClipMutation, ActivateClipMutationVariables>(ActivateClipDocument, options);
      }
export type ActivateClipMutationHookResult = ReturnType<typeof useActivateClipMutation>;
export type ActivateClipMutationResult = Apollo.MutationResult<ActivateClipMutation>;
export type ActivateClipMutationOptions = Apollo.BaseMutationOptions<ActivateClipMutation, ActivateClipMutationVariables>;
export const CreateClipTitlesDocument = gql`
    mutation createClipTitles($id: ID!) {
  createCopies(id: $id) {
    id
    copy {
      id
      processing_status
      result
      createdAt
      updatedAt
    }
  }
}
    `;
export type CreateClipTitlesMutationFn = Apollo.MutationFunction<CreateClipTitlesMutation, CreateClipTitlesMutationVariables>;

/**
 * __useCreateClipTitlesMutation__
 *
 * To run a mutation, you first call `useCreateClipTitlesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateClipTitlesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createClipTitlesMutation, { data, loading, error }] = useCreateClipTitlesMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCreateClipTitlesMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateClipTitlesMutation, CreateClipTitlesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateClipTitlesMutation, CreateClipTitlesMutationVariables>(CreateClipTitlesDocument, options);
      }
export type CreateClipTitlesMutationHookResult = ReturnType<typeof useCreateClipTitlesMutation>;
export type CreateClipTitlesMutationResult = Apollo.MutationResult<CreateClipTitlesMutation>;
export type CreateClipTitlesMutationOptions = Apollo.BaseMutationOptions<CreateClipTitlesMutation, CreateClipTitlesMutationVariables>;
export const AcceptInvitationDocument = gql`
    mutation AcceptInvitation($token: String!) {
  acceptInvitation(token: $token) {
    id
    name
    email
    subscription
    createdAt
  }
}
    `;
export type AcceptInvitationMutationFn = Apollo.MutationFunction<AcceptInvitationMutation, AcceptInvitationMutationVariables>;

/**
 * __useAcceptInvitationMutation__
 *
 * To run a mutation, you first call `useAcceptInvitationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAcceptInvitationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [acceptInvitationMutation, { data, loading, error }] = useAcceptInvitationMutation({
 *   variables: {
 *      token: // value for 'token'
 *   },
 * });
 */
export function useAcceptInvitationMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AcceptInvitationMutation, AcceptInvitationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AcceptInvitationMutation, AcceptInvitationMutationVariables>(AcceptInvitationDocument, options);
      }
export type AcceptInvitationMutationHookResult = ReturnType<typeof useAcceptInvitationMutation>;
export type AcceptInvitationMutationResult = Apollo.MutationResult<AcceptInvitationMutation>;
export type AcceptInvitationMutationOptions = Apollo.BaseMutationOptions<AcceptInvitationMutation, AcceptInvitationMutationVariables>;
export const LeaveTeamDocument = gql`
    mutation LeaveTeam {
  leaveTeam {
    id
    name
    email
    subscription
    createdAt
  }
}
    `;
export type LeaveTeamMutationFn = Apollo.MutationFunction<LeaveTeamMutation, LeaveTeamMutationVariables>;

/**
 * __useLeaveTeamMutation__
 *
 * To run a mutation, you first call `useLeaveTeamMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLeaveTeamMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [leaveTeamMutation, { data, loading, error }] = useLeaveTeamMutation({
 *   variables: {
 *   },
 * });
 */
export function useLeaveTeamMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<LeaveTeamMutation, LeaveTeamMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<LeaveTeamMutation, LeaveTeamMutationVariables>(LeaveTeamDocument, options);
      }
export type LeaveTeamMutationHookResult = ReturnType<typeof useLeaveTeamMutation>;
export type LeaveTeamMutationResult = Apollo.MutationResult<LeaveTeamMutation>;
export type LeaveTeamMutationOptions = Apollo.BaseMutationOptions<LeaveTeamMutation, LeaveTeamMutationVariables>;
export const RemoveTeamAccessDocument = gql`
    mutation RemoveTeamAccess($email: String!) {
  removeTeamAccess(email: $email) {
    id
    name
    email
    job_title
    profile_picture
    affiliate
    subscription
    createdAt
  }
}
    `;
export type RemoveTeamAccessMutationFn = Apollo.MutationFunction<RemoveTeamAccessMutation, RemoveTeamAccessMutationVariables>;

/**
 * __useRemoveTeamAccessMutation__
 *
 * To run a mutation, you first call `useRemoveTeamAccessMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveTeamAccessMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeTeamAccessMutation, { data, loading, error }] = useRemoveTeamAccessMutation({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useRemoveTeamAccessMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<RemoveTeamAccessMutation, RemoveTeamAccessMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<RemoveTeamAccessMutation, RemoveTeamAccessMutationVariables>(RemoveTeamAccessDocument, options);
      }
export type RemoveTeamAccessMutationHookResult = ReturnType<typeof useRemoveTeamAccessMutation>;
export type RemoveTeamAccessMutationResult = Apollo.MutationResult<RemoveTeamAccessMutation>;
export type RemoveTeamAccessMutationOptions = Apollo.BaseMutationOptions<RemoveTeamAccessMutation, RemoveTeamAccessMutationVariables>;
export const UpdateTeamRoleDocument = gql`
    mutation UpdateTeamRole($email: String!, $role: String!) {
  updateTeamRole(email: $email, role: $role) {
    id
    name
    email
    subscription
    createdAt
  }
}
    `;
export type UpdateTeamRoleMutationFn = Apollo.MutationFunction<UpdateTeamRoleMutation, UpdateTeamRoleMutationVariables>;

/**
 * __useUpdateTeamRoleMutation__
 *
 * To run a mutation, you first call `useUpdateTeamRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTeamRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTeamRoleMutation, { data, loading, error }] = useUpdateTeamRoleMutation({
 *   variables: {
 *      email: // value for 'email'
 *      role: // value for 'role'
 *   },
 * });
 */
export function useUpdateTeamRoleMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateTeamRoleMutation, UpdateTeamRoleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateTeamRoleMutation, UpdateTeamRoleMutationVariables>(UpdateTeamRoleDocument, options);
      }
export type UpdateTeamRoleMutationHookResult = ReturnType<typeof useUpdateTeamRoleMutation>;
export type UpdateTeamRoleMutationResult = Apollo.MutationResult<UpdateTeamRoleMutation>;
export type UpdateTeamRoleMutationOptions = Apollo.BaseMutationOptions<UpdateTeamRoleMutation, UpdateTeamRoleMutationVariables>;
export const RefreshInvitationTokenDocument = gql`
    mutation RefreshInvitationToken {
  refreshInvitationToken {
    id
    name
    email
    subscription
    createdAt
  }
}
    `;
export type RefreshInvitationTokenMutationFn = Apollo.MutationFunction<RefreshInvitationTokenMutation, RefreshInvitationTokenMutationVariables>;

/**
 * __useRefreshInvitationTokenMutation__
 *
 * To run a mutation, you first call `useRefreshInvitationTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRefreshInvitationTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [refreshInvitationTokenMutation, { data, loading, error }] = useRefreshInvitationTokenMutation({
 *   variables: {
 *   },
 * });
 */
export function useRefreshInvitationTokenMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<RefreshInvitationTokenMutation, RefreshInvitationTokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<RefreshInvitationTokenMutation, RefreshInvitationTokenMutationVariables>(RefreshInvitationTokenDocument, options);
      }
export type RefreshInvitationTokenMutationHookResult = ReturnType<typeof useRefreshInvitationTokenMutation>;
export type RefreshInvitationTokenMutationResult = Apollo.MutationResult<RefreshInvitationTokenMutation>;
export type RefreshInvitationTokenMutationOptions = Apollo.BaseMutationOptions<RefreshInvitationTokenMutation, RefreshInvitationTokenMutationVariables>;
export const RenderClipDocument = gql`
    mutation renderClip($id: ID!, $input: JSON!) {
  renderClip(id: $id, input: $input) {
    id
    name
    duration_seconds
    clipping_status
    preparing_status
    rendering_status
    clipped_video_url
    compressed_video_url
    finished_video_url
    createdAt
  }
}
    `;
export type RenderClipMutationFn = Apollo.MutationFunction<RenderClipMutation, RenderClipMutationVariables>;

/**
 * __useRenderClipMutation__
 *
 * To run a mutation, you first call `useRenderClipMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRenderClipMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [renderClipMutation, { data, loading, error }] = useRenderClipMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRenderClipMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<RenderClipMutation, RenderClipMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<RenderClipMutation, RenderClipMutationVariables>(RenderClipDocument, options);
      }
export type RenderClipMutationHookResult = ReturnType<typeof useRenderClipMutation>;
export type RenderClipMutationResult = Apollo.MutationResult<RenderClipMutation>;
export type RenderClipMutationOptions = Apollo.BaseMutationOptions<RenderClipMutation, RenderClipMutationVariables>;
export const RenderLibraryClipDocument = gql`
    mutation renderLibraryClip($id: ID!, $input: JSON!) {
  renderLibraryClip(id: $id, input: $input) {
    id
    name
    duration_seconds
    clipping_status
    preparing_status
    rendering_status
    clipped_video_url
    compressed_video_url
    finished_video_url
    source_clip_id
    version_number
    createdAt
  }
}
    `;
export type RenderLibraryClipMutationFn = Apollo.MutationFunction<RenderLibraryClipMutation, RenderLibraryClipMutationVariables>;

/**
 * __useRenderLibraryClipMutation__
 *
 * To run a mutation, you first call `useRenderLibraryClipMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRenderLibraryClipMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [renderLibraryClipMutation, { data, loading, error }] = useRenderLibraryClipMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRenderLibraryClipMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<RenderLibraryClipMutation, RenderLibraryClipMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<RenderLibraryClipMutation, RenderLibraryClipMutationVariables>(RenderLibraryClipDocument, options);
      }
export type RenderLibraryClipMutationHookResult = ReturnType<typeof useRenderLibraryClipMutation>;
export type RenderLibraryClipMutationResult = Apollo.MutationResult<RenderLibraryClipMutation>;
export type RenderLibraryClipMutationOptions = Apollo.BaseMutationOptions<RenderLibraryClipMutation, RenderLibraryClipMutationVariables>;
export const PrepareClipDocument = gql`
    mutation prepareClip($id: ID!) {
  prepareClip(id: $id) {
    id
    name
    duration_seconds
    clipping_status
    preparing_status
    rendering_status
    clipped_video_url
    compressed_video_url
    finished_video_url
    createdAt
  }
}
    `;
export type PrepareClipMutationFn = Apollo.MutationFunction<PrepareClipMutation, PrepareClipMutationVariables>;

/**
 * __usePrepareClipMutation__
 *
 * To run a mutation, you first call `usePrepareClipMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePrepareClipMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [prepareClipMutation, { data, loading, error }] = usePrepareClipMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePrepareClipMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<PrepareClipMutation, PrepareClipMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<PrepareClipMutation, PrepareClipMutationVariables>(PrepareClipDocument, options);
      }
export type PrepareClipMutationHookResult = ReturnType<typeof usePrepareClipMutation>;
export type PrepareClipMutationResult = Apollo.MutationResult<PrepareClipMutation>;
export type PrepareClipMutationOptions = Apollo.BaseMutationOptions<PrepareClipMutation, PrepareClipMutationVariables>;
export const SetCancellationReasonDocument = gql`
    mutation setCancellationReason($reason: String!, $feedback: String!) {
  setCancellationReason(reason: $reason, feedback: $feedback) {
    success
  }
}
    `;
export type SetCancellationReasonMutationFn = Apollo.MutationFunction<SetCancellationReasonMutation, SetCancellationReasonMutationVariables>;

/**
 * __useSetCancellationReasonMutation__
 *
 * To run a mutation, you first call `useSetCancellationReasonMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetCancellationReasonMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setCancellationReasonMutation, { data, loading, error }] = useSetCancellationReasonMutation({
 *   variables: {
 *      reason: // value for 'reason'
 *      feedback: // value for 'feedback'
 *   },
 * });
 */
export function useSetCancellationReasonMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SetCancellationReasonMutation, SetCancellationReasonMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SetCancellationReasonMutation, SetCancellationReasonMutationVariables>(SetCancellationReasonDocument, options);
      }
export type SetCancellationReasonMutationHookResult = ReturnType<typeof useSetCancellationReasonMutation>;
export type SetCancellationReasonMutationResult = Apollo.MutationResult<SetCancellationReasonMutation>;
export type SetCancellationReasonMutationOptions = Apollo.BaseMutationOptions<SetCancellationReasonMutation, SetCancellationReasonMutationVariables>;
export const MyFontsDocument = gql`
    query myFonts {
  myFonts {
    id
    name
    family
    file_url
    preview_black_url
    preview_white_url
    createdAt
    updatedAt
  }
}
    `;

/**
 * __useMyFontsQuery__
 *
 * To run a query within a React component, call `useMyFontsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyFontsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyFontsQuery({
 *   variables: {
 *   },
 * });
 */
export function useMyFontsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<MyFontsQuery, MyFontsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<MyFontsQuery, MyFontsQueryVariables>(MyFontsDocument, options);
      }
export function useMyFontsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<MyFontsQuery, MyFontsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<MyFontsQuery, MyFontsQueryVariables>(MyFontsDocument, options);
        }
// @ts-ignore
export function useMyFontsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<MyFontsQuery, MyFontsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<MyFontsQuery, MyFontsQueryVariables>;
export function useMyFontsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<MyFontsQuery, MyFontsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<MyFontsQuery | undefined, MyFontsQueryVariables>;
export function useMyFontsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<MyFontsQuery, MyFontsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<MyFontsQuery, MyFontsQueryVariables>(MyFontsDocument, options);
        }
export type MyFontsQueryHookResult = ReturnType<typeof useMyFontsQuery>;
export type MyFontsLazyQueryHookResult = ReturnType<typeof useMyFontsLazyQuery>;
export type MyFontsSuspenseQueryHookResult = ReturnType<typeof useMyFontsSuspenseQuery>;
export type MyFontsQueryResult = Apollo.QueryResult<MyFontsQuery, MyFontsQueryVariables>;
export const MyBrandKitsDocument = gql`
    query myBrandKits {
  myBrandKits {
    id
    name
    is_default
    is_public
    preview_video_url
    preview_poster_url
    createdAt
    updatedAt
    data {
      colors
      post_layout
      logo {
        logo_horizontal_margin
        logo_vertical_margin
        logo_image_url
        logo_opacity
        logo_position
        logo_size
      }
      title_font {
        font_id
        font_size
      }
      body_font {
        font_id
        font_size
      }
      subtitle {
        subtitle_color
        subtitle_font_id
        text_align
        subtitle_font_size
        subtitle_highlight_color
        subtitle_highlight_enabled
        highlight_box_enabled
        highlight_box_background_color
        highlight_box_border_radius
        highlight_box_padding_x
        highlight_box_padding_y
        vertical_margin_percentage
        align_items
        animation
        background_color
        background_enabled
        background_height
        background_opacity
        background_width
        horizontal_margin_percentage
        justify_content
        max_words_per_line
        shadow_color
        shadow_enabled
        shadow_size
        shadow_size
        stroke_enabled
        stroke_color
        stroke_width
        shadow_style
        shadow_offset_x
        shadow_offset_y
        shadow_spread
      }
    }
  }
}
    `;

/**
 * __useMyBrandKitsQuery__
 *
 * To run a query within a React component, call `useMyBrandKitsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyBrandKitsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyBrandKitsQuery({
 *   variables: {
 *   },
 * });
 */
export function useMyBrandKitsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<MyBrandKitsQuery, MyBrandKitsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<MyBrandKitsQuery, MyBrandKitsQueryVariables>(MyBrandKitsDocument, options);
      }
export function useMyBrandKitsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<MyBrandKitsQuery, MyBrandKitsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<MyBrandKitsQuery, MyBrandKitsQueryVariables>(MyBrandKitsDocument, options);
        }
// @ts-ignore
export function useMyBrandKitsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<MyBrandKitsQuery, MyBrandKitsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<MyBrandKitsQuery, MyBrandKitsQueryVariables>;
export function useMyBrandKitsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<MyBrandKitsQuery, MyBrandKitsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<MyBrandKitsQuery | undefined, MyBrandKitsQueryVariables>;
export function useMyBrandKitsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<MyBrandKitsQuery, MyBrandKitsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<MyBrandKitsQuery, MyBrandKitsQueryVariables>(MyBrandKitsDocument, options);
        }
export type MyBrandKitsQueryHookResult = ReturnType<typeof useMyBrandKitsQuery>;
export type MyBrandKitsLazyQueryHookResult = ReturnType<typeof useMyBrandKitsLazyQuery>;
export type MyBrandKitsSuspenseQueryHookResult = ReturnType<typeof useMyBrandKitsSuspenseQuery>;
export type MyBrandKitsQueryResult = Apollo.QueryResult<MyBrandKitsQuery, MyBrandKitsQueryVariables>;
export const MyBrandKitDocument = gql`
    query myBrandKit($id: ID!) {
  myBrandKit(id: $id) {
    id
    name
    is_default
    is_public
    createdAt
    updatedAt
    data {
      colors
      post_layout
      logo {
        logo_horizontal_margin
        logo_vertical_margin
        logo_image_url
        logo_opacity
        logo_position
        logo_size
      }
      title_font {
        font_id
        font_size
      }
      body_font {
        font_id
        font_size
      }
      subtitle {
        subtitle_color
        subtitle_font_id
        text_align
        subtitle_font_size
        subtitle_highlight_color
        subtitle_highlight_enabled
        highlight_box_enabled
        highlight_box_background_color
        highlight_box_border_radius
        highlight_box_padding_x
        highlight_box_padding_y
        vertical_margin_percentage
        align_items
        animation
        background_color
        background_enabled
        background_height
        background_opacity
        background_width
        horizontal_margin_percentage
        justify_content
        max_words_per_line
        shadow_color
        shadow_enabled
        shadow_size
        shadow_size
        stroke_enabled
        stroke_color
        stroke_width
        shadow_style
        shadow_offset_x
        shadow_offset_y
        shadow_spread
      }
    }
  }
}
    `;

/**
 * __useMyBrandKitQuery__
 *
 * To run a query within a React component, call `useMyBrandKitQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyBrandKitQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyBrandKitQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useMyBrandKitQuery(baseOptions: ApolloReactHooks.QueryHookOptions<MyBrandKitQuery, MyBrandKitQueryVariables> & ({ variables: MyBrandKitQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<MyBrandKitQuery, MyBrandKitQueryVariables>(MyBrandKitDocument, options);
      }
export function useMyBrandKitLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<MyBrandKitQuery, MyBrandKitQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<MyBrandKitQuery, MyBrandKitQueryVariables>(MyBrandKitDocument, options);
        }
// @ts-ignore
export function useMyBrandKitSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<MyBrandKitQuery, MyBrandKitQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<MyBrandKitQuery, MyBrandKitQueryVariables>;
export function useMyBrandKitSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<MyBrandKitQuery, MyBrandKitQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<MyBrandKitQuery | undefined, MyBrandKitQueryVariables>;
export function useMyBrandKitSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<MyBrandKitQuery, MyBrandKitQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<MyBrandKitQuery, MyBrandKitQueryVariables>(MyBrandKitDocument, options);
        }
export type MyBrandKitQueryHookResult = ReturnType<typeof useMyBrandKitQuery>;
export type MyBrandKitLazyQueryHookResult = ReturnType<typeof useMyBrandKitLazyQuery>;
export type MyBrandKitSuspenseQueryHookResult = ReturnType<typeof useMyBrandKitSuspenseQuery>;
export type MyBrandKitQueryResult = Apollo.QueryResult<MyBrandKitQuery, MyBrandKitQueryVariables>;
export const CreateMyBrandKitDocument = gql`
    mutation createMyBrandKit($input: MyBrandKitCreateInput!) {
  createMyBrandKit(input: $input) {
    id
    name
    is_default
    is_public
    createdAt
    updatedAt
    data {
      colors
      post_layout
      logo {
        logo_horizontal_margin
        logo_vertical_margin
        logo_image_url
        logo_opacity
        logo_position
        logo_size
      }
      title_font {
        font_id
        font_size
      }
      body_font {
        font_id
        font_size
      }
      subtitle {
        subtitle_color
        subtitle_font_id
        text_align
        subtitle_font_size
        subtitle_highlight_color
        subtitle_highlight_enabled
        highlight_box_enabled
        highlight_box_background_color
        highlight_box_border_radius
        highlight_box_padding_x
        highlight_box_padding_y
        vertical_margin_percentage
        align_items
        animation
        background_color
        background_enabled
        background_height
        background_opacity
        background_width
        horizontal_margin_percentage
        justify_content
        max_words_per_line
        shadow_color
        shadow_enabled
        shadow_size
        shadow_size
        stroke_enabled
        stroke_color
        stroke_width
        shadow_style
        shadow_offset_x
        shadow_offset_y
        shadow_spread
      }
    }
  }
}
    `;
export type CreateMyBrandKitMutationFn = Apollo.MutationFunction<CreateMyBrandKitMutation, CreateMyBrandKitMutationVariables>;

/**
 * __useCreateMyBrandKitMutation__
 *
 * To run a mutation, you first call `useCreateMyBrandKitMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMyBrandKitMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMyBrandKitMutation, { data, loading, error }] = useCreateMyBrandKitMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateMyBrandKitMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateMyBrandKitMutation, CreateMyBrandKitMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateMyBrandKitMutation, CreateMyBrandKitMutationVariables>(CreateMyBrandKitDocument, options);
      }
export type CreateMyBrandKitMutationHookResult = ReturnType<typeof useCreateMyBrandKitMutation>;
export type CreateMyBrandKitMutationResult = Apollo.MutationResult<CreateMyBrandKitMutation>;
export type CreateMyBrandKitMutationOptions = Apollo.BaseMutationOptions<CreateMyBrandKitMutation, CreateMyBrandKitMutationVariables>;
export const UpdateMyBrandKitDocument = gql`
    mutation updateMyBrandKit($id: ID!, $input: MyBrandKitUpdateInput!) {
  updateMyBrandKit(id: $id, input: $input) {
    id
    name
    is_default
    createdAt
    updatedAt
    data {
      colors
      post_layout
      logo {
        logo_horizontal_margin
        logo_vertical_margin
        logo_image_url
        logo_opacity
        logo_position
        logo_size
      }
      title_font {
        font_id
        font_size
      }
      body_font {
        font_id
        font_size
      }
      subtitle {
        subtitle_color
        subtitle_font_id
        text_align
        subtitle_font_size
        subtitle_highlight_color
        subtitle_highlight_enabled
        highlight_box_enabled
        highlight_box_background_color
        highlight_box_border_radius
        highlight_box_padding_x
        highlight_box_padding_y
        vertical_margin_percentage
        align_items
        animation
        background_color
        background_enabled
        background_height
        background_opacity
        background_width
        horizontal_margin_percentage
        justify_content
        max_words_per_line
        shadow_color
        shadow_enabled
        shadow_size
        shadow_size
        stroke_enabled
        stroke_color
        stroke_width
        shadow_style
        shadow_offset_x
        shadow_offset_y
        shadow_spread
      }
    }
  }
}
    `;
export type UpdateMyBrandKitMutationFn = Apollo.MutationFunction<UpdateMyBrandKitMutation, UpdateMyBrandKitMutationVariables>;

/**
 * __useUpdateMyBrandKitMutation__
 *
 * To run a mutation, you first call `useUpdateMyBrandKitMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMyBrandKitMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMyBrandKitMutation, { data, loading, error }] = useUpdateMyBrandKitMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateMyBrandKitMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateMyBrandKitMutation, UpdateMyBrandKitMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateMyBrandKitMutation, UpdateMyBrandKitMutationVariables>(UpdateMyBrandKitDocument, options);
      }
export type UpdateMyBrandKitMutationHookResult = ReturnType<typeof useUpdateMyBrandKitMutation>;
export type UpdateMyBrandKitMutationResult = Apollo.MutationResult<UpdateMyBrandKitMutation>;
export type UpdateMyBrandKitMutationOptions = Apollo.BaseMutationOptions<UpdateMyBrandKitMutation, UpdateMyBrandKitMutationVariables>;
export const DeleteMyBrandKitDocument = gql`
    mutation DeleteMyBrandKit($id: ID!) {
  deleteMyBrandKit(id: $id) {
    id
    name
    createdAt
    updatedAt
  }
}
    `;
export type DeleteMyBrandKitMutationFn = Apollo.MutationFunction<DeleteMyBrandKitMutation, DeleteMyBrandKitMutationVariables>;

/**
 * __useDeleteMyBrandKitMutation__
 *
 * To run a mutation, you first call `useDeleteMyBrandKitMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteMyBrandKitMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteMyBrandKitMutation, { data, loading, error }] = useDeleteMyBrandKitMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteMyBrandKitMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteMyBrandKitMutation, DeleteMyBrandKitMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteMyBrandKitMutation, DeleteMyBrandKitMutationVariables>(DeleteMyBrandKitDocument, options);
      }
export type DeleteMyBrandKitMutationHookResult = ReturnType<typeof useDeleteMyBrandKitMutation>;
export type DeleteMyBrandKitMutationResult = Apollo.MutationResult<DeleteMyBrandKitMutation>;
export type DeleteMyBrandKitMutationOptions = Apollo.BaseMutationOptions<DeleteMyBrandKitMutation, DeleteMyBrandKitMutationVariables>;
export const AdminCreateBrandKitDocument = gql`
    mutation adminCreateBrandKit($input: MyBrandKitCreateInput!) {
  adminCreateBrandKit(input: $input) {
    id
    name
    is_default
    is_public
    createdAt
    updatedAt
    data {
      colors
      post_layout
      logo {
        logo_horizontal_margin
        logo_vertical_margin
        logo_image_url
        logo_opacity
        logo_position
        logo_size
      }
      title_font {
        font_id
        font_size
      }
      body_font {
        font_id
        font_size
      }
      subtitle {
        subtitle_color
        subtitle_font_id
        text_align
        subtitle_font_size
        subtitle_highlight_color
        subtitle_highlight_enabled
        highlight_box_enabled
        highlight_box_background_color
        highlight_box_border_radius
        highlight_box_padding_x
        highlight_box_padding_y
        vertical_margin_percentage
        align_items
        animation
        background_color
        background_enabled
        background_height
        background_opacity
        background_width
        horizontal_margin_percentage
        justify_content
        max_words_per_line
        shadow_color
        shadow_enabled
        shadow_size
        stroke_enabled
        stroke_color
        stroke_width
        shadow_style
        shadow_offset_x
        shadow_offset_y
        shadow_spread
      }
    }
  }
}
    `;
export type AdminCreateBrandKitMutationFn = Apollo.MutationFunction<AdminCreateBrandKitMutation, AdminCreateBrandKitMutationVariables>;

/**
 * __useAdminCreateBrandKitMutation__
 *
 * To run a mutation, you first call `useAdminCreateBrandKitMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminCreateBrandKitMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminCreateBrandKitMutation, { data, loading, error }] = useAdminCreateBrandKitMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdminCreateBrandKitMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AdminCreateBrandKitMutation, AdminCreateBrandKitMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AdminCreateBrandKitMutation, AdminCreateBrandKitMutationVariables>(AdminCreateBrandKitDocument, options);
      }
export type AdminCreateBrandKitMutationHookResult = ReturnType<typeof useAdminCreateBrandKitMutation>;
export type AdminCreateBrandKitMutationResult = Apollo.MutationResult<AdminCreateBrandKitMutation>;
export type AdminCreateBrandKitMutationOptions = Apollo.BaseMutationOptions<AdminCreateBrandKitMutation, AdminCreateBrandKitMutationVariables>;
export const RateClipDocument = gql`
    mutation rateClip($id: ID!, $rating: String!) {
  rateClip(id: $id, rating: $rating) {
    id
    curation_rating
  }
}
    `;
export type RateClipMutationFn = Apollo.MutationFunction<RateClipMutation, RateClipMutationVariables>;

/**
 * __useRateClipMutation__
 *
 * To run a mutation, you first call `useRateClipMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRateClipMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [rateClipMutation, { data, loading, error }] = useRateClipMutation({
 *   variables: {
 *      id: // value for 'id'
 *      rating: // value for 'rating'
 *   },
 * });
 */
export function useRateClipMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<RateClipMutation, RateClipMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<RateClipMutation, RateClipMutationVariables>(RateClipDocument, options);
      }
export type RateClipMutationHookResult = ReturnType<typeof useRateClipMutation>;
export type RateClipMutationResult = Apollo.MutationResult<RateClipMutation>;
export type RateClipMutationOptions = Apollo.BaseMutationOptions<RateClipMutation, RateClipMutationVariables>;
export const UpdateClipDataDocument = gql`
    mutation updateClipData($id: ID!, $data: JSON!) {
  updateClipData(id: $id, data: $data) {
    id
    data
    dirty
  }
}
    `;
export type UpdateClipDataMutationFn = Apollo.MutationFunction<UpdateClipDataMutation, UpdateClipDataMutationVariables>;

/**
 * __useUpdateClipDataMutation__
 *
 * To run a mutation, you first call `useUpdateClipDataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateClipDataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateClipDataMutation, { data, loading, error }] = useUpdateClipDataMutation({
 *   variables: {
 *      id: // value for 'id'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateClipDataMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateClipDataMutation, UpdateClipDataMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateClipDataMutation, UpdateClipDataMutationVariables>(UpdateClipDataDocument, options);
      }
export type UpdateClipDataMutationHookResult = ReturnType<typeof useUpdateClipDataMutation>;
export type UpdateClipDataMutationResult = Apollo.MutationResult<UpdateClipDataMutation>;
export type UpdateClipDataMutationOptions = Apollo.BaseMutationOptions<UpdateClipDataMutation, UpdateClipDataMutationVariables>;
export const AddUserTagDocument = gql`
    mutation addUserTag($name: String!) {
  addUserTag(name: $name) {
    id
  }
}
    `;
export type AddUserTagMutationFn = Apollo.MutationFunction<AddUserTagMutation, AddUserTagMutationVariables>;

/**
 * __useAddUserTagMutation__
 *
 * To run a mutation, you first call `useAddUserTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddUserTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addUserTagMutation, { data, loading, error }] = useAddUserTagMutation({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useAddUserTagMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AddUserTagMutation, AddUserTagMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AddUserTagMutation, AddUserTagMutationVariables>(AddUserTagDocument, options);
      }
export type AddUserTagMutationHookResult = ReturnType<typeof useAddUserTagMutation>;
export type AddUserTagMutationResult = Apollo.MutationResult<AddUserTagMutation>;
export type AddUserTagMutationOptions = Apollo.BaseMutationOptions<AddUserTagMutation, AddUserTagMutationVariables>;
export const ValidateCouponDocument = gql`
    query validateCoupon($code: String!, $planId: ID!, $recurrency: String!) {
  validateCoupon(code: $code, planId: $planId, recurrency: $recurrency) {
    error
    valid
    coupon {
      id
      code
      cycles
      discount
      expiry_date
    }
  }
}
    `;

/**
 * __useValidateCouponQuery__
 *
 * To run a query within a React component, call `useValidateCouponQuery` and pass it any options that fit your needs.
 * When your component renders, `useValidateCouponQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useValidateCouponQuery({
 *   variables: {
 *      code: // value for 'code'
 *      planId: // value for 'planId'
 *      recurrency: // value for 'recurrency'
 *   },
 * });
 */
export function useValidateCouponQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ValidateCouponQuery, ValidateCouponQueryVariables> & ({ variables: ValidateCouponQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ValidateCouponQuery, ValidateCouponQueryVariables>(ValidateCouponDocument, options);
      }
export function useValidateCouponLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ValidateCouponQuery, ValidateCouponQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ValidateCouponQuery, ValidateCouponQueryVariables>(ValidateCouponDocument, options);
        }
// @ts-ignore
export function useValidateCouponSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ValidateCouponQuery, ValidateCouponQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ValidateCouponQuery, ValidateCouponQueryVariables>;
export function useValidateCouponSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ValidateCouponQuery, ValidateCouponQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ValidateCouponQuery | undefined, ValidateCouponQueryVariables>;
export function useValidateCouponSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ValidateCouponQuery, ValidateCouponQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ValidateCouponQuery, ValidateCouponQueryVariables>(ValidateCouponDocument, options);
        }
export type ValidateCouponQueryHookResult = ReturnType<typeof useValidateCouponQuery>;
export type ValidateCouponLazyQueryHookResult = ReturnType<typeof useValidateCouponLazyQuery>;
export type ValidateCouponSuspenseQueryHookResult = ReturnType<typeof useValidateCouponSuspenseQuery>;
export type ValidateCouponQueryResult = Apollo.QueryResult<ValidateCouponQuery, ValidateCouponQueryVariables>;
export const MyClipsByProjectIdDocument = gql`
    query MyClipsByProjectId($limit: Int, $offset: Int, $project_id: ID!, $sort: String) {
  myClips(limit: $limit, offset: $offset, project_id: $project_id, sort: $sort) {
    id
    name
    can_edit
    eta_seconds
    duration_seconds
    clip_score
    clip_order
    dirty
    clipping_status
    preparing_status
    rendering_status
    clipped_video_url
    thumbnail_url
    created_by_user
    compressed_video_url
    finished_video_url
    finished_video_thumbnail_url
    curation_rating
    data
    source_clip_id
    version_number
    createdAt
  }
}
    `;

/**
 * __useMyClipsByProjectIdQuery__
 *
 * To run a query within a React component, call `useMyClipsByProjectIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyClipsByProjectIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyClipsByProjectIdQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      project_id: // value for 'project_id'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useMyClipsByProjectIdQuery(baseOptions: ApolloReactHooks.QueryHookOptions<MyClipsByProjectIdQuery, MyClipsByProjectIdQueryVariables> & ({ variables: MyClipsByProjectIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<MyClipsByProjectIdQuery, MyClipsByProjectIdQueryVariables>(MyClipsByProjectIdDocument, options);
      }
export function useMyClipsByProjectIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<MyClipsByProjectIdQuery, MyClipsByProjectIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<MyClipsByProjectIdQuery, MyClipsByProjectIdQueryVariables>(MyClipsByProjectIdDocument, options);
        }
// @ts-ignore
export function useMyClipsByProjectIdSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<MyClipsByProjectIdQuery, MyClipsByProjectIdQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<MyClipsByProjectIdQuery, MyClipsByProjectIdQueryVariables>;
export function useMyClipsByProjectIdSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<MyClipsByProjectIdQuery, MyClipsByProjectIdQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<MyClipsByProjectIdQuery | undefined, MyClipsByProjectIdQueryVariables>;
export function useMyClipsByProjectIdSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<MyClipsByProjectIdQuery, MyClipsByProjectIdQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<MyClipsByProjectIdQuery, MyClipsByProjectIdQueryVariables>(MyClipsByProjectIdDocument, options);
        }
export type MyClipsByProjectIdQueryHookResult = ReturnType<typeof useMyClipsByProjectIdQuery>;
export type MyClipsByProjectIdLazyQueryHookResult = ReturnType<typeof useMyClipsByProjectIdLazyQuery>;
export type MyClipsByProjectIdSuspenseQueryHookResult = ReturnType<typeof useMyClipsByProjectIdSuspenseQuery>;
export type MyClipsByProjectIdQueryResult = Apollo.QueryResult<MyClipsByProjectIdQuery, MyClipsByProjectIdQueryVariables>;
export const RenderProjectClipV2Document = gql`
    mutation renderProjectClipV2($id: ID!, $input: JSON!) {
  renderProjectClipV2(id: $id, input: $input) {
    id
    name
    duration_seconds
    clipping_status
    preparing_status
    rendering_status
    clipped_video_url
    compressed_video_url
    finished_video_url
    source_clip_id
    version_number
    createdAt
  }
}
    `;
export type RenderProjectClipV2MutationFn = Apollo.MutationFunction<RenderProjectClipV2Mutation, RenderProjectClipV2MutationVariables>;

/**
 * __useRenderProjectClipV2Mutation__
 *
 * To run a mutation, you first call `useRenderProjectClipV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRenderProjectClipV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [renderProjectClipV2Mutation, { data, loading, error }] = useRenderProjectClipV2Mutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRenderProjectClipV2Mutation(baseOptions?: ApolloReactHooks.MutationHookOptions<RenderProjectClipV2Mutation, RenderProjectClipV2MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<RenderProjectClipV2Mutation, RenderProjectClipV2MutationVariables>(RenderProjectClipV2Document, options);
      }
export type RenderProjectClipV2MutationHookResult = ReturnType<typeof useRenderProjectClipV2Mutation>;
export type RenderProjectClipV2MutationResult = Apollo.MutationResult<RenderProjectClipV2Mutation>;
export type RenderProjectClipV2MutationOptions = Apollo.BaseMutationOptions<RenderProjectClipV2Mutation, RenderProjectClipV2MutationVariables>;
export const MyLibraryDocument = gql`
    query MyLibrary($id: ID!) {
  myLibrary(id: $id) {
    id
    name
    curation_status
    source_status
    failure_code
    curation_rating
    favorite
    public
    format
    language
    audio_language
    audio_track
    translation_status
    prompt
    processing_mode
    eta_seconds
    created_by_user
    created_by_user_name
    base_video_url
    compressed_base_video_url
    cut_video_url
    compressed_cut_video_url
    thumbnail_url
    duration_seconds
    clips_count
    filesize
    start_time
    end_time
    scene_detection
    scene_detection_url
    curated_clips
    speaker_layout
    post_layout
    subtitle_config
    watermark_position
    default_subtitles_enabled
    transcription
    transcription_url
    original_transcription_url
    clips {
      id
      name
      duration_seconds
      clip_start_time
      clip_end_time
      original_clip_start_time
      original_clip_end_time
      clip_score
      clip_order
      clip_summary
      clip_thumbnail
      curation_rating
      dirty
      clipping_status
      rendering_status
      thumbnail_url
      finished_video_url
      finished_video_thumbnail_url
      data
    }
    brand_kit {
      id
      name
    }
    youtube_channels {
      id
      channel_id
      name
      url
      thumbnail
      handle
      subscriber_count
      category
    }
    createdAt
  }
}
    `;

/**
 * __useMyLibraryQuery__
 *
 * To run a query within a React component, call `useMyLibraryQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyLibraryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyLibraryQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useMyLibraryQuery(baseOptions: ApolloReactHooks.QueryHookOptions<MyLibraryQuery, MyLibraryQueryVariables> & ({ variables: MyLibraryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<MyLibraryQuery, MyLibraryQueryVariables>(MyLibraryDocument, options);
      }
export function useMyLibraryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<MyLibraryQuery, MyLibraryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<MyLibraryQuery, MyLibraryQueryVariables>(MyLibraryDocument, options);
        }
// @ts-ignore
export function useMyLibrarySuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<MyLibraryQuery, MyLibraryQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<MyLibraryQuery, MyLibraryQueryVariables>;
export function useMyLibrarySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<MyLibraryQuery, MyLibraryQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<MyLibraryQuery | undefined, MyLibraryQueryVariables>;
export function useMyLibrarySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<MyLibraryQuery, MyLibraryQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<MyLibraryQuery, MyLibraryQueryVariables>(MyLibraryDocument, options);
        }
export type MyLibraryQueryHookResult = ReturnType<typeof useMyLibraryQuery>;
export type MyLibraryLazyQueryHookResult = ReturnType<typeof useMyLibraryLazyQuery>;
export type MyLibrarySuspenseQueryHookResult = ReturnType<typeof useMyLibrarySuspenseQuery>;
export type MyLibraryQueryResult = Apollo.QueryResult<MyLibraryQuery, MyLibraryQueryVariables>;
export const MyClipsByLibraryIdDocument = gql`
    query MyClipsByLibraryId($limit: Int, $offset: Int, $library_id: ID!, $sort: String) {
  myClips(limit: $limit, offset: $offset, library_id: $library_id, sort: $sort) {
    id
    name
    can_edit
    eta_seconds
    duration_seconds
    clip_score
    clip_order
    clip_start_time
    clip_end_time
    dirty
    clipping_status
    preparing_status
    rendering_status
    clipped_video_url
    thumbnail_url
    created_by_user
    compressed_video_url
    finished_video_url
    finished_video_thumbnail_url
    curation_rating
    data
    source_clip_id
    version_number
    createdAt
  }
}
    `;

/**
 * __useMyClipsByLibraryIdQuery__
 *
 * To run a query within a React component, call `useMyClipsByLibraryIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyClipsByLibraryIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyClipsByLibraryIdQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      library_id: // value for 'library_id'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useMyClipsByLibraryIdQuery(baseOptions: ApolloReactHooks.QueryHookOptions<MyClipsByLibraryIdQuery, MyClipsByLibraryIdQueryVariables> & ({ variables: MyClipsByLibraryIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<MyClipsByLibraryIdQuery, MyClipsByLibraryIdQueryVariables>(MyClipsByLibraryIdDocument, options);
      }
export function useMyClipsByLibraryIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<MyClipsByLibraryIdQuery, MyClipsByLibraryIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<MyClipsByLibraryIdQuery, MyClipsByLibraryIdQueryVariables>(MyClipsByLibraryIdDocument, options);
        }
// @ts-ignore
export function useMyClipsByLibraryIdSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<MyClipsByLibraryIdQuery, MyClipsByLibraryIdQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<MyClipsByLibraryIdQuery, MyClipsByLibraryIdQueryVariables>;
export function useMyClipsByLibraryIdSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<MyClipsByLibraryIdQuery, MyClipsByLibraryIdQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<MyClipsByLibraryIdQuery | undefined, MyClipsByLibraryIdQueryVariables>;
export function useMyClipsByLibraryIdSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<MyClipsByLibraryIdQuery, MyClipsByLibraryIdQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<MyClipsByLibraryIdQuery, MyClipsByLibraryIdQueryVariables>(MyClipsByLibraryIdDocument, options);
        }
export type MyClipsByLibraryIdQueryHookResult = ReturnType<typeof useMyClipsByLibraryIdQuery>;
export type MyClipsByLibraryIdLazyQueryHookResult = ReturnType<typeof useMyClipsByLibraryIdLazyQuery>;
export type MyClipsByLibraryIdSuspenseQueryHookResult = ReturnType<typeof useMyClipsByLibraryIdSuspenseQuery>;
export type MyClipsByLibraryIdQueryResult = Apollo.QueryResult<MyClipsByLibraryIdQuery, MyClipsByLibraryIdQueryVariables>;
export const DeleteMyClipDocument = gql`
    mutation DeleteMyClip($id: ID!) {
  deleteMyClip(id: $id) {
    id
  }
}
    `;
export type DeleteMyClipMutationFn = Apollo.MutationFunction<DeleteMyClipMutation, DeleteMyClipMutationVariables>;

/**
 * __useDeleteMyClipMutation__
 *
 * To run a mutation, you first call `useDeleteMyClipMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteMyClipMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteMyClipMutation, { data, loading, error }] = useDeleteMyClipMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteMyClipMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteMyClipMutation, DeleteMyClipMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteMyClipMutation, DeleteMyClipMutationVariables>(DeleteMyClipDocument, options);
      }
export type DeleteMyClipMutationHookResult = ReturnType<typeof useDeleteMyClipMutation>;
export type DeleteMyClipMutationResult = Apollo.MutationResult<DeleteMyClipMutation>;
export type DeleteMyClipMutationOptions = Apollo.BaseMutationOptions<DeleteMyClipMutation, DeleteMyClipMutationVariables>;
export const AdminUserDocument = gql`
    query AdminUser($id: ID!) {
  adminUser(id: $id) {
    id
    name
    email
    phone_number
    job_title
    is_admin
    provider
    confirmed
    blocked
    onboarding_objective
    profile_picture
    account_reliabilities {
      platform
      status
      score
      engagement_rate
      lifetime_views
      tracked_content
      username
    }
    subscription {
      id
      current_month_processing_seconds
      current_month_clips
      current_month_library_video_seconds
      current_month_library_exports
      current_month_library_curations
      extra_clips
      extra_seconds
      payment_provider
      payment_recurrency
      next_payment_at
      cancellation_at
      payment_count
      total_payment_value
      original_price
      discounted_price
      discount_amount
      active_coupon {
        id
        code
        type
        month_discount
        year_discount
        month_cycles
        year_cycles
      }
      plan {
        id
        name
        slug
        value
        processing_seconds
        max_clips
        max_users
        max_library_video_seconds
        max_library_exports
        max_library_curations
      }
      createdAt
      updatedAt
    }
    createdAt
    updatedAt
  }
}
    `;

/**
 * __useAdminUserQuery__
 *
 * To run a query within a React component, call `useAdminUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminUserQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAdminUserQuery(baseOptions: ApolloReactHooks.QueryHookOptions<AdminUserQuery, AdminUserQueryVariables> & ({ variables: AdminUserQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AdminUserQuery, AdminUserQueryVariables>(AdminUserDocument, options);
      }
export function useAdminUserLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AdminUserQuery, AdminUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AdminUserQuery, AdminUserQueryVariables>(AdminUserDocument, options);
        }
// @ts-ignore
export function useAdminUserSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<AdminUserQuery, AdminUserQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AdminUserQuery, AdminUserQueryVariables>;
export function useAdminUserSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AdminUserQuery, AdminUserQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AdminUserQuery | undefined, AdminUserQueryVariables>;
export function useAdminUserSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AdminUserQuery, AdminUserQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<AdminUserQuery, AdminUserQueryVariables>(AdminUserDocument, options);
        }
export type AdminUserQueryHookResult = ReturnType<typeof useAdminUserQuery>;
export type AdminUserLazyQueryHookResult = ReturnType<typeof useAdminUserLazyQuery>;
export type AdminUserSuspenseQueryHookResult = ReturnType<typeof useAdminUserSuspenseQuery>;
export type AdminUserQueryResult = Apollo.QueryResult<AdminUserQuery, AdminUserQueryVariables>;
export const AdminUsersDocument = gql`
    query AdminUsers($page: Int, $pageSize: Int, $search: String, $name: String, $email: String, $phone_number: String, $plan_slug: String, $is_partner: Boolean) {
  adminUsers(
    page: $page
    pageSize: $pageSize
    search: $search
    name: $name
    email: $email
    phone_number: $phone_number
    plan_slug: $plan_slug
    is_partner: $is_partner
  ) {
    data {
      id
      name
      email
      phone_number
      job_title
      is_admin
      blocked
      confirmed
      provider
      onboarding_objective
      utm_source
      utm_medium
      utm_campaign
      utm_term
      utm_content
      affiliate_rate_payment
      affiliate_rate_course
      affiliate_rate_cpm
      affiliate_rate_note
      cpm_leaderboard_excluded
      cpm_leaderboard_excluded_reason
      account_reliabilities {
        platform
        status
        score
        engagement_rate
        lifetime_views
        tracked_content
        username
      }
      subscription {
        id
        current_month_processing_seconds
        current_month_clips
        current_month_library_video_seconds
        current_month_library_exports
        current_month_library_curations
        extra_clips
        is_partner
        partner_expires_at
        partner_note
        ai_assistant_granted
        facebook_connections_granted
        extra_seconds
        payment_count
        total_payment_value
        plan {
          id
          name
          slug
          processing_seconds
          max_clips
          max_library_video_seconds
          max_library_exports
          max_library_curations
        }
      }
      createdAt
      updatedAt
    }
    page
    pageSize
    pageCount
    total
  }
}
    `;

/**
 * __useAdminUsersQuery__
 *
 * To run a query within a React component, call `useAdminUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminUsersQuery({
 *   variables: {
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *      search: // value for 'search'
 *      name: // value for 'name'
 *      email: // value for 'email'
 *      phone_number: // value for 'phone_number'
 *      plan_slug: // value for 'plan_slug'
 *      is_partner: // value for 'is_partner'
 *   },
 * });
 */
export function useAdminUsersQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<AdminUsersQuery, AdminUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AdminUsersQuery, AdminUsersQueryVariables>(AdminUsersDocument, options);
      }
export function useAdminUsersLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AdminUsersQuery, AdminUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AdminUsersQuery, AdminUsersQueryVariables>(AdminUsersDocument, options);
        }
// @ts-ignore
export function useAdminUsersSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<AdminUsersQuery, AdminUsersQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AdminUsersQuery, AdminUsersQueryVariables>;
export function useAdminUsersSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AdminUsersQuery, AdminUsersQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AdminUsersQuery | undefined, AdminUsersQueryVariables>;
export function useAdminUsersSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AdminUsersQuery, AdminUsersQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<AdminUsersQuery, AdminUsersQueryVariables>(AdminUsersDocument, options);
        }
export type AdminUsersQueryHookResult = ReturnType<typeof useAdminUsersQuery>;
export type AdminUsersLazyQueryHookResult = ReturnType<typeof useAdminUsersLazyQuery>;
export type AdminUsersSuspenseQueryHookResult = ReturnType<typeof useAdminUsersSuspenseQuery>;
export type AdminUsersQueryResult = Apollo.QueryResult<AdminUsersQuery, AdminUsersQueryVariables>;
export const AdminBotChatConversationsDocument = gql`
    query AdminBotChatConversations($page: Int, $pageSize: Int, $search: String, $channel: String, $linked: Boolean, $hasError: Boolean, $userId: ID, $sortBy: String, $sortOrder: String) {
  adminBotChatConversations(
    page: $page
    pageSize: $pageSize
    search: $search
    channel: $channel
    linked: $linked
    hasError: $hasError
    userId: $userId
    sortBy: $sortBy
    sortOrder: $sortOrder
  ) {
    data {
      id
      channel
      channel_user_id
      first_seen_at
      last_seen_at
      message_count
      error_count
      memory_summary
      memory_updated_at
      user {
        id
        name
        email
        phone_number
      }
    }
    total
    page
    pageSize
    pageCount
  }
}
    `;

/**
 * __useAdminBotChatConversationsQuery__
 *
 * To run a query within a React component, call `useAdminBotChatConversationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminBotChatConversationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminBotChatConversationsQuery({
 *   variables: {
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *      search: // value for 'search'
 *      channel: // value for 'channel'
 *      linked: // value for 'linked'
 *      hasError: // value for 'hasError'
 *      userId: // value for 'userId'
 *      sortBy: // value for 'sortBy'
 *      sortOrder: // value for 'sortOrder'
 *   },
 * });
 */
export function useAdminBotChatConversationsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<AdminBotChatConversationsQuery, AdminBotChatConversationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AdminBotChatConversationsQuery, AdminBotChatConversationsQueryVariables>(AdminBotChatConversationsDocument, options);
      }
export function useAdminBotChatConversationsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AdminBotChatConversationsQuery, AdminBotChatConversationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AdminBotChatConversationsQuery, AdminBotChatConversationsQueryVariables>(AdminBotChatConversationsDocument, options);
        }
// @ts-ignore
export function useAdminBotChatConversationsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<AdminBotChatConversationsQuery, AdminBotChatConversationsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AdminBotChatConversationsQuery, AdminBotChatConversationsQueryVariables>;
export function useAdminBotChatConversationsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AdminBotChatConversationsQuery, AdminBotChatConversationsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AdminBotChatConversationsQuery | undefined, AdminBotChatConversationsQueryVariables>;
export function useAdminBotChatConversationsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AdminBotChatConversationsQuery, AdminBotChatConversationsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<AdminBotChatConversationsQuery, AdminBotChatConversationsQueryVariables>(AdminBotChatConversationsDocument, options);
        }
export type AdminBotChatConversationsQueryHookResult = ReturnType<typeof useAdminBotChatConversationsQuery>;
export type AdminBotChatConversationsLazyQueryHookResult = ReturnType<typeof useAdminBotChatConversationsLazyQuery>;
export type AdminBotChatConversationsSuspenseQueryHookResult = ReturnType<typeof useAdminBotChatConversationsSuspenseQuery>;
export type AdminBotChatConversationsQueryResult = Apollo.QueryResult<AdminBotChatConversationsQuery, AdminBotChatConversationsQueryVariables>;
export const AdminBotChatConversationDocument = gql`
    query AdminBotChatConversation($id: ID!) {
  adminBotChatConversation(id: $id) {
    id
    channel
    channel_user_id
    first_seen_at
    last_seen_at
    message_count
    error_count
    memory_summary
    memory_updated_at
    user {
      id
      name
      email
      phone_number
    }
  }
}
    `;

/**
 * __useAdminBotChatConversationQuery__
 *
 * To run a query within a React component, call `useAdminBotChatConversationQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminBotChatConversationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminBotChatConversationQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAdminBotChatConversationQuery(baseOptions: ApolloReactHooks.QueryHookOptions<AdminBotChatConversationQuery, AdminBotChatConversationQueryVariables> & ({ variables: AdminBotChatConversationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AdminBotChatConversationQuery, AdminBotChatConversationQueryVariables>(AdminBotChatConversationDocument, options);
      }
export function useAdminBotChatConversationLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AdminBotChatConversationQuery, AdminBotChatConversationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AdminBotChatConversationQuery, AdminBotChatConversationQueryVariables>(AdminBotChatConversationDocument, options);
        }
// @ts-ignore
export function useAdminBotChatConversationSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<AdminBotChatConversationQuery, AdminBotChatConversationQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AdminBotChatConversationQuery, AdminBotChatConversationQueryVariables>;
export function useAdminBotChatConversationSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AdminBotChatConversationQuery, AdminBotChatConversationQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AdminBotChatConversationQuery | undefined, AdminBotChatConversationQueryVariables>;
export function useAdminBotChatConversationSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AdminBotChatConversationQuery, AdminBotChatConversationQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<AdminBotChatConversationQuery, AdminBotChatConversationQueryVariables>(AdminBotChatConversationDocument, options);
        }
export type AdminBotChatConversationQueryHookResult = ReturnType<typeof useAdminBotChatConversationQuery>;
export type AdminBotChatConversationLazyQueryHookResult = ReturnType<typeof useAdminBotChatConversationLazyQuery>;
export type AdminBotChatConversationSuspenseQueryHookResult = ReturnType<typeof useAdminBotChatConversationSuspenseQuery>;
export type AdminBotChatConversationQueryResult = Apollo.QueryResult<AdminBotChatConversationQuery, AdminBotChatConversationQueryVariables>;
export const AdminBotChatMessagesDocument = gql`
    query AdminBotChatMessages($conversationId: ID!, $page: Int, $pageSize: Int, $order: String) {
  adminBotChatMessages(
    conversationId: $conversationId
    page: $page
    pageSize: $pageSize
    order: $order
  ) {
    data {
      id
      direction
      text
      intent_kind
      intent_source
      current_flow
      error
      llm_model
      createdAt
    }
    total
    page
    pageSize
    pageCount
  }
}
    `;

/**
 * __useAdminBotChatMessagesQuery__
 *
 * To run a query within a React component, call `useAdminBotChatMessagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminBotChatMessagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminBotChatMessagesQuery({
 *   variables: {
 *      conversationId: // value for 'conversationId'
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useAdminBotChatMessagesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<AdminBotChatMessagesQuery, AdminBotChatMessagesQueryVariables> & ({ variables: AdminBotChatMessagesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AdminBotChatMessagesQuery, AdminBotChatMessagesQueryVariables>(AdminBotChatMessagesDocument, options);
      }
export function useAdminBotChatMessagesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AdminBotChatMessagesQuery, AdminBotChatMessagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AdminBotChatMessagesQuery, AdminBotChatMessagesQueryVariables>(AdminBotChatMessagesDocument, options);
        }
// @ts-ignore
export function useAdminBotChatMessagesSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<AdminBotChatMessagesQuery, AdminBotChatMessagesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AdminBotChatMessagesQuery, AdminBotChatMessagesQueryVariables>;
export function useAdminBotChatMessagesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AdminBotChatMessagesQuery, AdminBotChatMessagesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AdminBotChatMessagesQuery | undefined, AdminBotChatMessagesQueryVariables>;
export function useAdminBotChatMessagesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AdminBotChatMessagesQuery, AdminBotChatMessagesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<AdminBotChatMessagesQuery, AdminBotChatMessagesQueryVariables>(AdminBotChatMessagesDocument, options);
        }
export type AdminBotChatMessagesQueryHookResult = ReturnType<typeof useAdminBotChatMessagesQuery>;
export type AdminBotChatMessagesLazyQueryHookResult = ReturnType<typeof useAdminBotChatMessagesLazyQuery>;
export type AdminBotChatMessagesSuspenseQueryHookResult = ReturnType<typeof useAdminBotChatMessagesSuspenseQuery>;
export type AdminBotChatMessagesQueryResult = Apollo.QueryResult<AdminBotChatMessagesQuery, AdminBotChatMessagesQueryVariables>;
export const AdminProjectsDocument = gql`
    query AdminProjects($page: Int, $pageSize: Int, $search: String, $name: String, $user_id: ID, $curation_status: String, $language: String, $sortBy: String, $sortOrder: String) {
  adminProjects(
    page: $page
    pageSize: $pageSize
    search: $search
    name: $name
    user_id: $user_id
    curation_status: $curation_status
    language: $language
    sortBy: $sortBy
    sortOrder: $sortOrder
  ) {
    data {
      id
      name
      curation_status
      language
      duration_seconds
      format
      deleted
      created_by_user {
        id
        name
        email
      }
      createdAt
      updatedAt
    }
    page
    pageSize
    pageCount
    total
  }
}
    `;

/**
 * __useAdminProjectsQuery__
 *
 * To run a query within a React component, call `useAdminProjectsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminProjectsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminProjectsQuery({
 *   variables: {
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *      search: // value for 'search'
 *      name: // value for 'name'
 *      user_id: // value for 'user_id'
 *      curation_status: // value for 'curation_status'
 *      language: // value for 'language'
 *      sortBy: // value for 'sortBy'
 *      sortOrder: // value for 'sortOrder'
 *   },
 * });
 */
export function useAdminProjectsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<AdminProjectsQuery, AdminProjectsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AdminProjectsQuery, AdminProjectsQueryVariables>(AdminProjectsDocument, options);
      }
export function useAdminProjectsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AdminProjectsQuery, AdminProjectsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AdminProjectsQuery, AdminProjectsQueryVariables>(AdminProjectsDocument, options);
        }
// @ts-ignore
export function useAdminProjectsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<AdminProjectsQuery, AdminProjectsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AdminProjectsQuery, AdminProjectsQueryVariables>;
export function useAdminProjectsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AdminProjectsQuery, AdminProjectsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AdminProjectsQuery | undefined, AdminProjectsQueryVariables>;
export function useAdminProjectsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AdminProjectsQuery, AdminProjectsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<AdminProjectsQuery, AdminProjectsQueryVariables>(AdminProjectsDocument, options);
        }
export type AdminProjectsQueryHookResult = ReturnType<typeof useAdminProjectsQuery>;
export type AdminProjectsLazyQueryHookResult = ReturnType<typeof useAdminProjectsLazyQuery>;
export type AdminProjectsSuspenseQueryHookResult = ReturnType<typeof useAdminProjectsSuspenseQuery>;
export type AdminProjectsQueryResult = Apollo.QueryResult<AdminProjectsQuery, AdminProjectsQueryVariables>;
export const AdminClipsDocument = gql`
    query AdminClips($page: Int, $pageSize: Int, $search: String, $name: String, $user_id: ID, $project_id: ID, $clipping_status: String, $rendering_status: String, $sortBy: String, $sortOrder: String) {
  adminClips(
    page: $page
    pageSize: $pageSize
    search: $search
    name: $name
    user_id: $user_id
    project_id: $project_id
    clipping_status: $clipping_status
    rendering_status: $rendering_status
    sortBy: $sortBy
    sortOrder: $sortOrder
  ) {
    data {
      id
      name
      clipping_status
      preparing_status
      rendering_status
      duration_seconds
      deleted
      project {
        id
        name
      }
      clipped_video_url
      finished_video_url
      created_by_user {
        id
        name
        email
      }
      createdAt
      updatedAt
    }
    page
    pageSize
    pageCount
    total
  }
}
    `;

/**
 * __useAdminClipsQuery__
 *
 * To run a query within a React component, call `useAdminClipsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminClipsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminClipsQuery({
 *   variables: {
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *      search: // value for 'search'
 *      name: // value for 'name'
 *      user_id: // value for 'user_id'
 *      project_id: // value for 'project_id'
 *      clipping_status: // value for 'clipping_status'
 *      rendering_status: // value for 'rendering_status'
 *      sortBy: // value for 'sortBy'
 *      sortOrder: // value for 'sortOrder'
 *   },
 * });
 */
export function useAdminClipsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<AdminClipsQuery, AdminClipsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AdminClipsQuery, AdminClipsQueryVariables>(AdminClipsDocument, options);
      }
export function useAdminClipsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AdminClipsQuery, AdminClipsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AdminClipsQuery, AdminClipsQueryVariables>(AdminClipsDocument, options);
        }
// @ts-ignore
export function useAdminClipsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<AdminClipsQuery, AdminClipsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AdminClipsQuery, AdminClipsQueryVariables>;
export function useAdminClipsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AdminClipsQuery, AdminClipsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AdminClipsQuery | undefined, AdminClipsQueryVariables>;
export function useAdminClipsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AdminClipsQuery, AdminClipsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<AdminClipsQuery, AdminClipsQueryVariables>(AdminClipsDocument, options);
        }
export type AdminClipsQueryHookResult = ReturnType<typeof useAdminClipsQuery>;
export type AdminClipsLazyQueryHookResult = ReturnType<typeof useAdminClipsLazyQuery>;
export type AdminClipsSuspenseQueryHookResult = ReturnType<typeof useAdminClipsSuspenseQuery>;
export type AdminClipsQueryResult = Apollo.QueryResult<AdminClipsQuery, AdminClipsQueryVariables>;
export const AdminYouTubeDownloadsDocument = gql`
    query AdminYouTubeDownloads($page: Int, $pageSize: Int, $search: String, $video_id: String, $download_status: String, $provider: String, $language: String, $sortBy: String, $sortOrder: String) {
  adminYouTubeDownloads(
    page: $page
    pageSize: $pageSize
    search: $search
    video_id: $video_id
    download_status: $download_status
    provider: $provider
    language: $language
    sortBy: $sortBy
    sortOrder: $sortOrder
  ) {
    data {
      id
      video_id
      download_status
      provider
      language
      hash
      priority
      linked_projects_count
      createdAt
      updatedAt
    }
    page
    pageSize
    pageCount
    total
  }
}
    `;

/**
 * __useAdminYouTubeDownloadsQuery__
 *
 * To run a query within a React component, call `useAdminYouTubeDownloadsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminYouTubeDownloadsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminYouTubeDownloadsQuery({
 *   variables: {
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *      search: // value for 'search'
 *      video_id: // value for 'video_id'
 *      download_status: // value for 'download_status'
 *      provider: // value for 'provider'
 *      language: // value for 'language'
 *      sortBy: // value for 'sortBy'
 *      sortOrder: // value for 'sortOrder'
 *   },
 * });
 */
export function useAdminYouTubeDownloadsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<AdminYouTubeDownloadsQuery, AdminYouTubeDownloadsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AdminYouTubeDownloadsQuery, AdminYouTubeDownloadsQueryVariables>(AdminYouTubeDownloadsDocument, options);
      }
export function useAdminYouTubeDownloadsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AdminYouTubeDownloadsQuery, AdminYouTubeDownloadsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AdminYouTubeDownloadsQuery, AdminYouTubeDownloadsQueryVariables>(AdminYouTubeDownloadsDocument, options);
        }
// @ts-ignore
export function useAdminYouTubeDownloadsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<AdminYouTubeDownloadsQuery, AdminYouTubeDownloadsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AdminYouTubeDownloadsQuery, AdminYouTubeDownloadsQueryVariables>;
export function useAdminYouTubeDownloadsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AdminYouTubeDownloadsQuery, AdminYouTubeDownloadsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AdminYouTubeDownloadsQuery | undefined, AdminYouTubeDownloadsQueryVariables>;
export function useAdminYouTubeDownloadsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AdminYouTubeDownloadsQuery, AdminYouTubeDownloadsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<AdminYouTubeDownloadsQuery, AdminYouTubeDownloadsQueryVariables>(AdminYouTubeDownloadsDocument, options);
        }
export type AdminYouTubeDownloadsQueryHookResult = ReturnType<typeof useAdminYouTubeDownloadsQuery>;
export type AdminYouTubeDownloadsLazyQueryHookResult = ReturnType<typeof useAdminYouTubeDownloadsLazyQuery>;
export type AdminYouTubeDownloadsSuspenseQueryHookResult = ReturnType<typeof useAdminYouTubeDownloadsSuspenseQuery>;
export type AdminYouTubeDownloadsQueryResult = Apollo.QueryResult<AdminYouTubeDownloadsQuery, AdminYouTubeDownloadsQueryVariables>;
export const AdminCouponsDocument = gql`
    query AdminCoupons($page: Int, $pageSize: Int, $search: String, $code: String, $type: String, $active: Boolean) {
  adminCoupons(
    page: $page
    pageSize: $pageSize
    search: $search
    code: $code
    type: $type
    active: $active
  ) {
    data {
      id
      documentId
      code
      type
      quantity
      month_cycles
      month_discount
      year_cycles
      year_discount
      expiry_date
      createdAt
      updatedAt
      assigned_user {
        id
        name
        email
      }
    }
    page
    pageSize
    pageCount
    total
  }
}
    `;

/**
 * __useAdminCouponsQuery__
 *
 * To run a query within a React component, call `useAdminCouponsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminCouponsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminCouponsQuery({
 *   variables: {
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *      search: // value for 'search'
 *      code: // value for 'code'
 *      type: // value for 'type'
 *      active: // value for 'active'
 *   },
 * });
 */
export function useAdminCouponsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<AdminCouponsQuery, AdminCouponsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AdminCouponsQuery, AdminCouponsQueryVariables>(AdminCouponsDocument, options);
      }
export function useAdminCouponsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AdminCouponsQuery, AdminCouponsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AdminCouponsQuery, AdminCouponsQueryVariables>(AdminCouponsDocument, options);
        }
// @ts-ignore
export function useAdminCouponsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<AdminCouponsQuery, AdminCouponsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AdminCouponsQuery, AdminCouponsQueryVariables>;
export function useAdminCouponsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AdminCouponsQuery, AdminCouponsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AdminCouponsQuery | undefined, AdminCouponsQueryVariables>;
export function useAdminCouponsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AdminCouponsQuery, AdminCouponsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<AdminCouponsQuery, AdminCouponsQueryVariables>(AdminCouponsDocument, options);
        }
export type AdminCouponsQueryHookResult = ReturnType<typeof useAdminCouponsQuery>;
export type AdminCouponsLazyQueryHookResult = ReturnType<typeof useAdminCouponsLazyQuery>;
export type AdminCouponsSuspenseQueryHookResult = ReturnType<typeof useAdminCouponsSuspenseQuery>;
export type AdminCouponsQueryResult = Apollo.QueryResult<AdminCouponsQuery, AdminCouponsQueryVariables>;
export const AdminCouponDocument = gql`
    query AdminCoupon($id: ID!) {
  adminCoupon(id: $id) {
    id
    documentId
    code
    type
    quantity
    month_cycles
    month_discount
    year_cycles
    year_discount
    expiry_date
    createdAt
    updatedAt
    assigned_user {
      id
      name
      email
    }
  }
}
    `;

/**
 * __useAdminCouponQuery__
 *
 * To run a query within a React component, call `useAdminCouponQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminCouponQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminCouponQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAdminCouponQuery(baseOptions: ApolloReactHooks.QueryHookOptions<AdminCouponQuery, AdminCouponQueryVariables> & ({ variables: AdminCouponQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AdminCouponQuery, AdminCouponQueryVariables>(AdminCouponDocument, options);
      }
export function useAdminCouponLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AdminCouponQuery, AdminCouponQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AdminCouponQuery, AdminCouponQueryVariables>(AdminCouponDocument, options);
        }
// @ts-ignore
export function useAdminCouponSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<AdminCouponQuery, AdminCouponQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AdminCouponQuery, AdminCouponQueryVariables>;
export function useAdminCouponSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AdminCouponQuery, AdminCouponQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AdminCouponQuery | undefined, AdminCouponQueryVariables>;
export function useAdminCouponSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AdminCouponQuery, AdminCouponQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<AdminCouponQuery, AdminCouponQueryVariables>(AdminCouponDocument, options);
        }
export type AdminCouponQueryHookResult = ReturnType<typeof useAdminCouponQuery>;
export type AdminCouponLazyQueryHookResult = ReturnType<typeof useAdminCouponLazyQuery>;
export type AdminCouponSuspenseQueryHookResult = ReturnType<typeof useAdminCouponSuspenseQuery>;
export type AdminCouponQueryResult = Apollo.QueryResult<AdminCouponQuery, AdminCouponQueryVariables>;
export const AdminCreateCouponDocument = gql`
    mutation AdminCreateCoupon($input: AdminCouponCreateInput!) {
  adminCreateCoupon(input: $input) {
    id
    code
    type
    quantity
    month_cycles
    month_discount
    year_cycles
    year_discount
    expiry_date
    assigned_user {
      id
      name
      email
    }
  }
}
    `;
export type AdminCreateCouponMutationFn = Apollo.MutationFunction<AdminCreateCouponMutation, AdminCreateCouponMutationVariables>;

/**
 * __useAdminCreateCouponMutation__
 *
 * To run a mutation, you first call `useAdminCreateCouponMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminCreateCouponMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminCreateCouponMutation, { data, loading, error }] = useAdminCreateCouponMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdminCreateCouponMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AdminCreateCouponMutation, AdminCreateCouponMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AdminCreateCouponMutation, AdminCreateCouponMutationVariables>(AdminCreateCouponDocument, options);
      }
export type AdminCreateCouponMutationHookResult = ReturnType<typeof useAdminCreateCouponMutation>;
export type AdminCreateCouponMutationResult = Apollo.MutationResult<AdminCreateCouponMutation>;
export type AdminCreateCouponMutationOptions = Apollo.BaseMutationOptions<AdminCreateCouponMutation, AdminCreateCouponMutationVariables>;
export const AdminUpdateCouponDocument = gql`
    mutation AdminUpdateCoupon($id: ID!, $input: AdminCouponUpdateInput!) {
  adminUpdateCoupon(id: $id, input: $input) {
    id
    code
    type
    quantity
    month_cycles
    month_discount
    year_cycles
    year_discount
    expiry_date
    assigned_user {
      id
      name
      email
    }
  }
}
    `;
export type AdminUpdateCouponMutationFn = Apollo.MutationFunction<AdminUpdateCouponMutation, AdminUpdateCouponMutationVariables>;

/**
 * __useAdminUpdateCouponMutation__
 *
 * To run a mutation, you first call `useAdminUpdateCouponMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminUpdateCouponMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminUpdateCouponMutation, { data, loading, error }] = useAdminUpdateCouponMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdminUpdateCouponMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AdminUpdateCouponMutation, AdminUpdateCouponMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AdminUpdateCouponMutation, AdminUpdateCouponMutationVariables>(AdminUpdateCouponDocument, options);
      }
export type AdminUpdateCouponMutationHookResult = ReturnType<typeof useAdminUpdateCouponMutation>;
export type AdminUpdateCouponMutationResult = Apollo.MutationResult<AdminUpdateCouponMutation>;
export type AdminUpdateCouponMutationOptions = Apollo.BaseMutationOptions<AdminUpdateCouponMutation, AdminUpdateCouponMutationVariables>;
export const AdminDeleteCouponDocument = gql`
    mutation AdminDeleteCoupon($id: ID!) {
  adminDeleteCoupon(id: $id) {
    id
  }
}
    `;
export type AdminDeleteCouponMutationFn = Apollo.MutationFunction<AdminDeleteCouponMutation, AdminDeleteCouponMutationVariables>;

/**
 * __useAdminDeleteCouponMutation__
 *
 * To run a mutation, you first call `useAdminDeleteCouponMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminDeleteCouponMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminDeleteCouponMutation, { data, loading, error }] = useAdminDeleteCouponMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAdminDeleteCouponMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AdminDeleteCouponMutation, AdminDeleteCouponMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AdminDeleteCouponMutation, AdminDeleteCouponMutationVariables>(AdminDeleteCouponDocument, options);
      }
export type AdminDeleteCouponMutationHookResult = ReturnType<typeof useAdminDeleteCouponMutation>;
export type AdminDeleteCouponMutationResult = Apollo.MutationResult<AdminDeleteCouponMutation>;
export type AdminDeleteCouponMutationOptions = Apollo.BaseMutationOptions<AdminDeleteCouponMutation, AdminDeleteCouponMutationVariables>;
export const CommunityLiveSessionsDocument = gql`
    query CommunityLiveSessions {
  communityLiveSessions {
    id
    platform
    live_url
    started_at
    youtube_channel {
      id
      channel_id
      name
      thumbnail
      handle
    }
    library {
      id
      name
      duration_seconds
      format
      language
      start_time
      end_time
      base_video_url
      thumbnail_url
    }
  }
}
    `;

/**
 * __useCommunityLiveSessionsQuery__
 *
 * To run a query within a React component, call `useCommunityLiveSessionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCommunityLiveSessionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCommunityLiveSessionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useCommunityLiveSessionsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<CommunityLiveSessionsQuery, CommunityLiveSessionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<CommunityLiveSessionsQuery, CommunityLiveSessionsQueryVariables>(CommunityLiveSessionsDocument, options);
      }
export function useCommunityLiveSessionsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CommunityLiveSessionsQuery, CommunityLiveSessionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<CommunityLiveSessionsQuery, CommunityLiveSessionsQueryVariables>(CommunityLiveSessionsDocument, options);
        }
// @ts-ignore
export function useCommunityLiveSessionsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<CommunityLiveSessionsQuery, CommunityLiveSessionsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<CommunityLiveSessionsQuery, CommunityLiveSessionsQueryVariables>;
export function useCommunityLiveSessionsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<CommunityLiveSessionsQuery, CommunityLiveSessionsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<CommunityLiveSessionsQuery | undefined, CommunityLiveSessionsQueryVariables>;
export function useCommunityLiveSessionsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<CommunityLiveSessionsQuery, CommunityLiveSessionsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<CommunityLiveSessionsQuery, CommunityLiveSessionsQueryVariables>(CommunityLiveSessionsDocument, options);
        }
export type CommunityLiveSessionsQueryHookResult = ReturnType<typeof useCommunityLiveSessionsQuery>;
export type CommunityLiveSessionsLazyQueryHookResult = ReturnType<typeof useCommunityLiveSessionsLazyQuery>;
export type CommunityLiveSessionsSuspenseQueryHookResult = ReturnType<typeof useCommunityLiveSessionsSuspenseQuery>;
export type CommunityLiveSessionsQueryResult = Apollo.QueryResult<CommunityLiveSessionsQuery, CommunityLiveSessionsQueryVariables>;
export const AdminLiveWatchesDocument = gql`
    query AdminLiveWatches($page: Int, $pageSize: Int, $search: String, $platform: LiveWatchPlatform, $enabled: Boolean) {
  adminLiveWatches(
    page: $page
    pageSize: $pageSize
    search: $search
    platform: $platform
    enabled: $enabled
  ) {
    data {
      id
      kind
      platform
      platform_channel_id
      platform_login
      source_url
      enabled
      window_minutes
      retention_days
      overlap_seconds
      youtube_channel {
        id
        channel_id
        name
        thumbnail
        handle
      }
      current_session {
        id
        status
        platform_live_id
        live_url
        started_at
        ended_at
        last_error
        ingest_status
        heartbeat_at
        r2_prefix
        retention_expires_at
      }
      createdAt
    }
    page
    pageSize
    pageCount
    total
  }
}
    `;

/**
 * __useAdminLiveWatchesQuery__
 *
 * To run a query within a React component, call `useAdminLiveWatchesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminLiveWatchesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminLiveWatchesQuery({
 *   variables: {
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *      search: // value for 'search'
 *      platform: // value for 'platform'
 *      enabled: // value for 'enabled'
 *   },
 * });
 */
export function useAdminLiveWatchesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<AdminLiveWatchesQuery, AdminLiveWatchesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AdminLiveWatchesQuery, AdminLiveWatchesQueryVariables>(AdminLiveWatchesDocument, options);
      }
export function useAdminLiveWatchesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AdminLiveWatchesQuery, AdminLiveWatchesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AdminLiveWatchesQuery, AdminLiveWatchesQueryVariables>(AdminLiveWatchesDocument, options);
        }
// @ts-ignore
export function useAdminLiveWatchesSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<AdminLiveWatchesQuery, AdminLiveWatchesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AdminLiveWatchesQuery, AdminLiveWatchesQueryVariables>;
export function useAdminLiveWatchesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AdminLiveWatchesQuery, AdminLiveWatchesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AdminLiveWatchesQuery | undefined, AdminLiveWatchesQueryVariables>;
export function useAdminLiveWatchesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AdminLiveWatchesQuery, AdminLiveWatchesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<AdminLiveWatchesQuery, AdminLiveWatchesQueryVariables>(AdminLiveWatchesDocument, options);
        }
export type AdminLiveWatchesQueryHookResult = ReturnType<typeof useAdminLiveWatchesQuery>;
export type AdminLiveWatchesLazyQueryHookResult = ReturnType<typeof useAdminLiveWatchesLazyQuery>;
export type AdminLiveWatchesSuspenseQueryHookResult = ReturnType<typeof useAdminLiveWatchesSuspenseQuery>;
export type AdminLiveWatchesQueryResult = Apollo.QueryResult<AdminLiveWatchesQuery, AdminLiveWatchesQueryVariables>;
export const AdminLiveWatchDocument = gql`
    query AdminLiveWatch($id: ID!) {
  adminLiveWatch(id: $id) {
    id
    kind
    platform
    platform_channel_id
    platform_login
    source_url
    enabled
    window_minutes
    retention_days
    overlap_seconds
    youtube_channel {
      id
      channel_id
      name
      thumbnail
      handle
    }
    current_session {
      id
      status
      platform_live_id
      live_url
      started_at
      ended_at
      last_error
      ingest_status
      heartbeat_at
      r2_prefix
      retention_expires_at
    }
    createdAt
  }
}
    `;

/**
 * __useAdminLiveWatchQuery__
 *
 * To run a query within a React component, call `useAdminLiveWatchQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminLiveWatchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminLiveWatchQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAdminLiveWatchQuery(baseOptions: ApolloReactHooks.QueryHookOptions<AdminLiveWatchQuery, AdminLiveWatchQueryVariables> & ({ variables: AdminLiveWatchQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AdminLiveWatchQuery, AdminLiveWatchQueryVariables>(AdminLiveWatchDocument, options);
      }
export function useAdminLiveWatchLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AdminLiveWatchQuery, AdminLiveWatchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AdminLiveWatchQuery, AdminLiveWatchQueryVariables>(AdminLiveWatchDocument, options);
        }
// @ts-ignore
export function useAdminLiveWatchSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<AdminLiveWatchQuery, AdminLiveWatchQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AdminLiveWatchQuery, AdminLiveWatchQueryVariables>;
export function useAdminLiveWatchSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AdminLiveWatchQuery, AdminLiveWatchQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AdminLiveWatchQuery | undefined, AdminLiveWatchQueryVariables>;
export function useAdminLiveWatchSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AdminLiveWatchQuery, AdminLiveWatchQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<AdminLiveWatchQuery, AdminLiveWatchQueryVariables>(AdminLiveWatchDocument, options);
        }
export type AdminLiveWatchQueryHookResult = ReturnType<typeof useAdminLiveWatchQuery>;
export type AdminLiveWatchLazyQueryHookResult = ReturnType<typeof useAdminLiveWatchLazyQuery>;
export type AdminLiveWatchSuspenseQueryHookResult = ReturnType<typeof useAdminLiveWatchSuspenseQuery>;
export type AdminLiveWatchQueryResult = Apollo.QueryResult<AdminLiveWatchQuery, AdminLiveWatchQueryVariables>;
export const AdminLiveSessionsDocument = gql`
    query AdminLiveSessions($watchId: ID!, $page: Int, $pageSize: Int) {
  adminLiveSessions(watchId: $watchId, page: $page, pageSize: $pageSize) {
    data {
      id
      status
      platform_live_id
      live_url
      started_at
      ended_at
      last_error
      ingest_status
      heartbeat_at
      r2_prefix
      retention_expires_at
    }
    page
    pageSize
    pageCount
    total
  }
}
    `;

/**
 * __useAdminLiveSessionsQuery__
 *
 * To run a query within a React component, call `useAdminLiveSessionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminLiveSessionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminLiveSessionsQuery({
 *   variables: {
 *      watchId: // value for 'watchId'
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *   },
 * });
 */
export function useAdminLiveSessionsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<AdminLiveSessionsQuery, AdminLiveSessionsQueryVariables> & ({ variables: AdminLiveSessionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AdminLiveSessionsQuery, AdminLiveSessionsQueryVariables>(AdminLiveSessionsDocument, options);
      }
export function useAdminLiveSessionsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AdminLiveSessionsQuery, AdminLiveSessionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AdminLiveSessionsQuery, AdminLiveSessionsQueryVariables>(AdminLiveSessionsDocument, options);
        }
// @ts-ignore
export function useAdminLiveSessionsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<AdminLiveSessionsQuery, AdminLiveSessionsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AdminLiveSessionsQuery, AdminLiveSessionsQueryVariables>;
export function useAdminLiveSessionsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AdminLiveSessionsQuery, AdminLiveSessionsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AdminLiveSessionsQuery | undefined, AdminLiveSessionsQueryVariables>;
export function useAdminLiveSessionsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AdminLiveSessionsQuery, AdminLiveSessionsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<AdminLiveSessionsQuery, AdminLiveSessionsQueryVariables>(AdminLiveSessionsDocument, options);
        }
export type AdminLiveSessionsQueryHookResult = ReturnType<typeof useAdminLiveSessionsQuery>;
export type AdminLiveSessionsLazyQueryHookResult = ReturnType<typeof useAdminLiveSessionsLazyQuery>;
export type AdminLiveSessionsSuspenseQueryHookResult = ReturnType<typeof useAdminLiveSessionsSuspenseQuery>;
export type AdminLiveSessionsQueryResult = Apollo.QueryResult<AdminLiveSessionsQuery, AdminLiveSessionsQueryVariables>;
export const AdminCreateLiveWatchDocument = gql`
    mutation AdminCreateLiveWatch($input: AdminCreateLiveWatchInput!) {
  adminCreateLiveWatch(input: $input) {
    id
    kind
    platform
    platform_channel_id
    platform_login
    source_url
    enabled
    window_minutes
    retention_days
    overlap_seconds
    youtube_channel {
      id
      channel_id
      name
      thumbnail
      handle
    }
    current_session {
      id
      status
      platform_live_id
      live_url
      started_at
      ended_at
      last_error
      ingest_status
      heartbeat_at
      r2_prefix
      retention_expires_at
    }
    createdAt
  }
}
    `;
export type AdminCreateLiveWatchMutationFn = Apollo.MutationFunction<AdminCreateLiveWatchMutation, AdminCreateLiveWatchMutationVariables>;

/**
 * __useAdminCreateLiveWatchMutation__
 *
 * To run a mutation, you first call `useAdminCreateLiveWatchMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminCreateLiveWatchMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminCreateLiveWatchMutation, { data, loading, error }] = useAdminCreateLiveWatchMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdminCreateLiveWatchMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AdminCreateLiveWatchMutation, AdminCreateLiveWatchMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AdminCreateLiveWatchMutation, AdminCreateLiveWatchMutationVariables>(AdminCreateLiveWatchDocument, options);
      }
export type AdminCreateLiveWatchMutationHookResult = ReturnType<typeof useAdminCreateLiveWatchMutation>;
export type AdminCreateLiveWatchMutationResult = Apollo.MutationResult<AdminCreateLiveWatchMutation>;
export type AdminCreateLiveWatchMutationOptions = Apollo.BaseMutationOptions<AdminCreateLiveWatchMutation, AdminCreateLiveWatchMutationVariables>;
export const AdminUpdateLiveWatchDocument = gql`
    mutation AdminUpdateLiveWatch($id: ID!, $input: AdminCreateLiveWatchInput!) {
  adminUpdateLiveWatch(id: $id, input: $input) {
    id
    kind
    platform
    platform_channel_id
    platform_login
    source_url
    enabled
    window_minutes
    retention_days
    overlap_seconds
    youtube_channel {
      id
      channel_id
      name
      thumbnail
      handle
    }
    current_session {
      id
      status
      platform_live_id
      live_url
      started_at
      ended_at
      last_error
      ingest_status
      heartbeat_at
      r2_prefix
      retention_expires_at
    }
    createdAt
  }
}
    `;
export type AdminUpdateLiveWatchMutationFn = Apollo.MutationFunction<AdminUpdateLiveWatchMutation, AdminUpdateLiveWatchMutationVariables>;

/**
 * __useAdminUpdateLiveWatchMutation__
 *
 * To run a mutation, you first call `useAdminUpdateLiveWatchMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminUpdateLiveWatchMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminUpdateLiveWatchMutation, { data, loading, error }] = useAdminUpdateLiveWatchMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdminUpdateLiveWatchMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AdminUpdateLiveWatchMutation, AdminUpdateLiveWatchMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AdminUpdateLiveWatchMutation, AdminUpdateLiveWatchMutationVariables>(AdminUpdateLiveWatchDocument, options);
      }
export type AdminUpdateLiveWatchMutationHookResult = ReturnType<typeof useAdminUpdateLiveWatchMutation>;
export type AdminUpdateLiveWatchMutationResult = Apollo.MutationResult<AdminUpdateLiveWatchMutation>;
export type AdminUpdateLiveWatchMutationOptions = Apollo.BaseMutationOptions<AdminUpdateLiveWatchMutation, AdminUpdateLiveWatchMutationVariables>;
export const AdminSetLiveWatchEnabledDocument = gql`
    mutation AdminSetLiveWatchEnabled($id: ID!, $enabled: Boolean!) {
  adminSetLiveWatchEnabled(id: $id, enabled: $enabled) {
    id
    kind
    platform
    platform_channel_id
    platform_login
    source_url
    enabled
    window_minutes
    retention_days
    overlap_seconds
    youtube_channel {
      id
      channel_id
      name
      thumbnail
      handle
    }
    current_session {
      id
      status
      platform_live_id
      live_url
      started_at
      ended_at
      last_error
      ingest_status
      heartbeat_at
      r2_prefix
      retention_expires_at
    }
    createdAt
  }
}
    `;
export type AdminSetLiveWatchEnabledMutationFn = Apollo.MutationFunction<AdminSetLiveWatchEnabledMutation, AdminSetLiveWatchEnabledMutationVariables>;

/**
 * __useAdminSetLiveWatchEnabledMutation__
 *
 * To run a mutation, you first call `useAdminSetLiveWatchEnabledMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminSetLiveWatchEnabledMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminSetLiveWatchEnabledMutation, { data, loading, error }] = useAdminSetLiveWatchEnabledMutation({
 *   variables: {
 *      id: // value for 'id'
 *      enabled: // value for 'enabled'
 *   },
 * });
 */
export function useAdminSetLiveWatchEnabledMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AdminSetLiveWatchEnabledMutation, AdminSetLiveWatchEnabledMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AdminSetLiveWatchEnabledMutation, AdminSetLiveWatchEnabledMutationVariables>(AdminSetLiveWatchEnabledDocument, options);
      }
export type AdminSetLiveWatchEnabledMutationHookResult = ReturnType<typeof useAdminSetLiveWatchEnabledMutation>;
export type AdminSetLiveWatchEnabledMutationResult = Apollo.MutationResult<AdminSetLiveWatchEnabledMutation>;
export type AdminSetLiveWatchEnabledMutationOptions = Apollo.BaseMutationOptions<AdminSetLiveWatchEnabledMutation, AdminSetLiveWatchEnabledMutationVariables>;
export const AdminStopLiveSessionDocument = gql`
    mutation AdminStopLiveSession($id: ID!) {
  adminStopLiveSession(id: $id) {
    id
    status
    platform_live_id
    live_url
    started_at
    ended_at
    last_error
    ingest_status
    heartbeat_at
    r2_prefix
    retention_expires_at
  }
}
    `;
export type AdminStopLiveSessionMutationFn = Apollo.MutationFunction<AdminStopLiveSessionMutation, AdminStopLiveSessionMutationVariables>;

/**
 * __useAdminStopLiveSessionMutation__
 *
 * To run a mutation, you first call `useAdminStopLiveSessionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminStopLiveSessionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminStopLiveSessionMutation, { data, loading, error }] = useAdminStopLiveSessionMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAdminStopLiveSessionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AdminStopLiveSessionMutation, AdminStopLiveSessionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AdminStopLiveSessionMutation, AdminStopLiveSessionMutationVariables>(AdminStopLiveSessionDocument, options);
      }
export type AdminStopLiveSessionMutationHookResult = ReturnType<typeof useAdminStopLiveSessionMutation>;
export type AdminStopLiveSessionMutationResult = Apollo.MutationResult<AdminStopLiveSessionMutation>;
export type AdminStopLiveSessionMutationOptions = Apollo.BaseMutationOptions<AdminStopLiveSessionMutation, AdminStopLiveSessionMutationVariables>;
export const AdminLiveWindowsDocument = gql`
    query AdminLiveWindows($sessionId: ID!, $page: Int, $pageSize: Int) {
  adminLiveWindows(sessionId: $sessionId, page: $page, pageSize: $pageSize) {
    data {
      id
      window_start
      window_end
      status
      library_document_id
      attempt_count
      last_error
    }
    page
    pageSize
    pageCount
    total
  }
}
    `;

/**
 * __useAdminLiveWindowsQuery__
 *
 * To run a query within a React component, call `useAdminLiveWindowsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminLiveWindowsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminLiveWindowsQuery({
 *   variables: {
 *      sessionId: // value for 'sessionId'
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *   },
 * });
 */
export function useAdminLiveWindowsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<AdminLiveWindowsQuery, AdminLiveWindowsQueryVariables> & ({ variables: AdminLiveWindowsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AdminLiveWindowsQuery, AdminLiveWindowsQueryVariables>(AdminLiveWindowsDocument, options);
      }
export function useAdminLiveWindowsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AdminLiveWindowsQuery, AdminLiveWindowsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AdminLiveWindowsQuery, AdminLiveWindowsQueryVariables>(AdminLiveWindowsDocument, options);
        }
// @ts-ignore
export function useAdminLiveWindowsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<AdminLiveWindowsQuery, AdminLiveWindowsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AdminLiveWindowsQuery, AdminLiveWindowsQueryVariables>;
export function useAdminLiveWindowsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AdminLiveWindowsQuery, AdminLiveWindowsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AdminLiveWindowsQuery | undefined, AdminLiveWindowsQueryVariables>;
export function useAdminLiveWindowsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AdminLiveWindowsQuery, AdminLiveWindowsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<AdminLiveWindowsQuery, AdminLiveWindowsQueryVariables>(AdminLiveWindowsDocument, options);
        }
export type AdminLiveWindowsQueryHookResult = ReturnType<typeof useAdminLiveWindowsQuery>;
export type AdminLiveWindowsLazyQueryHookResult = ReturnType<typeof useAdminLiveWindowsLazyQuery>;
export type AdminLiveWindowsSuspenseQueryHookResult = ReturnType<typeof useAdminLiveWindowsSuspenseQuery>;
export type AdminLiveWindowsQueryResult = Apollo.QueryResult<AdminLiveWindowsQuery, AdminLiveWindowsQueryVariables>;
export const AdminYoutubeChannelsDocument = gql`
    query AdminYoutubeChannels($page: Int, $pageSize: Int, $search: String, $partnerOnly: Boolean) {
  adminYoutubeChannels(
    page: $page
    pageSize: $pageSize
    search: $search
    partnerOnly: $partnerOnly
  ) {
    data {
      id
      channel_id
      name
      url
      thumbnail
      handle
      subscriber_count
      category
      is_autoclipper_partner
    }
    total
    page
    pageSize
    pageCount
  }
}
    `;

/**
 * __useAdminYoutubeChannelsQuery__
 *
 * To run a query within a React component, call `useAdminYoutubeChannelsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminYoutubeChannelsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminYoutubeChannelsQuery({
 *   variables: {
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *      search: // value for 'search'
 *      partnerOnly: // value for 'partnerOnly'
 *   },
 * });
 */
export function useAdminYoutubeChannelsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<AdminYoutubeChannelsQuery, AdminYoutubeChannelsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AdminYoutubeChannelsQuery, AdminYoutubeChannelsQueryVariables>(AdminYoutubeChannelsDocument, options);
      }
export function useAdminYoutubeChannelsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AdminYoutubeChannelsQuery, AdminYoutubeChannelsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AdminYoutubeChannelsQuery, AdminYoutubeChannelsQueryVariables>(AdminYoutubeChannelsDocument, options);
        }
// @ts-ignore
export function useAdminYoutubeChannelsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<AdminYoutubeChannelsQuery, AdminYoutubeChannelsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AdminYoutubeChannelsQuery, AdminYoutubeChannelsQueryVariables>;
export function useAdminYoutubeChannelsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AdminYoutubeChannelsQuery, AdminYoutubeChannelsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AdminYoutubeChannelsQuery | undefined, AdminYoutubeChannelsQueryVariables>;
export function useAdminYoutubeChannelsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AdminYoutubeChannelsQuery, AdminYoutubeChannelsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<AdminYoutubeChannelsQuery, AdminYoutubeChannelsQueryVariables>(AdminYoutubeChannelsDocument, options);
        }
export type AdminYoutubeChannelsQueryHookResult = ReturnType<typeof useAdminYoutubeChannelsQuery>;
export type AdminYoutubeChannelsLazyQueryHookResult = ReturnType<typeof useAdminYoutubeChannelsLazyQuery>;
export type AdminYoutubeChannelsSuspenseQueryHookResult = ReturnType<typeof useAdminYoutubeChannelsSuspenseQuery>;
export type AdminYoutubeChannelsQueryResult = Apollo.QueryResult<AdminYoutubeChannelsQuery, AdminYoutubeChannelsQueryVariables>;
export const AdminUpdateYoutubeChannelDocument = gql`
    mutation AdminUpdateYoutubeChannel($id: ID!, $is_autoclipper_partner: Boolean!) {
  adminUpdateYoutubeChannel(
    id: $id
    is_autoclipper_partner: $is_autoclipper_partner
  ) {
    id
    channel_id
    name
    is_autoclipper_partner
  }
}
    `;
export type AdminUpdateYoutubeChannelMutationFn = Apollo.MutationFunction<AdminUpdateYoutubeChannelMutation, AdminUpdateYoutubeChannelMutationVariables>;

/**
 * __useAdminUpdateYoutubeChannelMutation__
 *
 * To run a mutation, you first call `useAdminUpdateYoutubeChannelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminUpdateYoutubeChannelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminUpdateYoutubeChannelMutation, { data, loading, error }] = useAdminUpdateYoutubeChannelMutation({
 *   variables: {
 *      id: // value for 'id'
 *      is_autoclipper_partner: // value for 'is_autoclipper_partner'
 *   },
 * });
 */
export function useAdminUpdateYoutubeChannelMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AdminUpdateYoutubeChannelMutation, AdminUpdateYoutubeChannelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AdminUpdateYoutubeChannelMutation, AdminUpdateYoutubeChannelMutationVariables>(AdminUpdateYoutubeChannelDocument, options);
      }
export type AdminUpdateYoutubeChannelMutationHookResult = ReturnType<typeof useAdminUpdateYoutubeChannelMutation>;
export type AdminUpdateYoutubeChannelMutationResult = Apollo.MutationResult<AdminUpdateYoutubeChannelMutation>;
export type AdminUpdateYoutubeChannelMutationOptions = Apollo.BaseMutationOptions<AdminUpdateYoutubeChannelMutation, AdminUpdateYoutubeChannelMutationVariables>;
export const AdminImportDriveToChannelDocument = gql`
    mutation AdminImportDriveToChannel($channelId: ID!, $urls: [String!]!) {
  adminImportDriveToChannel(channelId: $channelId, urls: $urls) {
    input
    status
    fileId
    fileName
    downloadId
    error
  }
}
    `;
export type AdminImportDriveToChannelMutationFn = Apollo.MutationFunction<AdminImportDriveToChannelMutation, AdminImportDriveToChannelMutationVariables>;

/**
 * __useAdminImportDriveToChannelMutation__
 *
 * To run a mutation, you first call `useAdminImportDriveToChannelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminImportDriveToChannelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminImportDriveToChannelMutation, { data, loading, error }] = useAdminImportDriveToChannelMutation({
 *   variables: {
 *      channelId: // value for 'channelId'
 *      urls: // value for 'urls'
 *   },
 * });
 */
export function useAdminImportDriveToChannelMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AdminImportDriveToChannelMutation, AdminImportDriveToChannelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AdminImportDriveToChannelMutation, AdminImportDriveToChannelMutationVariables>(AdminImportDriveToChannelDocument, options);
      }
export type AdminImportDriveToChannelMutationHookResult = ReturnType<typeof useAdminImportDriveToChannelMutation>;
export type AdminImportDriveToChannelMutationResult = Apollo.MutationResult<AdminImportDriveToChannelMutation>;
export type AdminImportDriveToChannelMutationOptions = Apollo.BaseMutationOptions<AdminImportDriveToChannelMutation, AdminImportDriveToChannelMutationVariables>;
export const AdminPlansDocument = gql`
    query AdminPlans {
  adminPlans {
    id
    name
    slug
    processing_seconds
    max_clips
    max_library_video_seconds
    max_library_exports
    max_library_curations
    value
    order
  }
}
    `;

/**
 * __useAdminPlansQuery__
 *
 * To run a query within a React component, call `useAdminPlansQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminPlansQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminPlansQuery({
 *   variables: {
 *   },
 * });
 */
export function useAdminPlansQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<AdminPlansQuery, AdminPlansQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AdminPlansQuery, AdminPlansQueryVariables>(AdminPlansDocument, options);
      }
export function useAdminPlansLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AdminPlansQuery, AdminPlansQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AdminPlansQuery, AdminPlansQueryVariables>(AdminPlansDocument, options);
        }
// @ts-ignore
export function useAdminPlansSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<AdminPlansQuery, AdminPlansQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AdminPlansQuery, AdminPlansQueryVariables>;
export function useAdminPlansSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AdminPlansQuery, AdminPlansQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AdminPlansQuery | undefined, AdminPlansQueryVariables>;
export function useAdminPlansSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AdminPlansQuery, AdminPlansQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<AdminPlansQuery, AdminPlansQueryVariables>(AdminPlansDocument, options);
        }
export type AdminPlansQueryHookResult = ReturnType<typeof useAdminPlansQuery>;
export type AdminPlansLazyQueryHookResult = ReturnType<typeof useAdminPlansLazyQuery>;
export type AdminPlansSuspenseQueryHookResult = ReturnType<typeof useAdminPlansSuspenseQuery>;
export type AdminPlansQueryResult = Apollo.QueryResult<AdminPlansQuery, AdminPlansQueryVariables>;
export const ApplyRenewalCouponDocument = gql`
    mutation ApplyRenewalCoupon($code: String!) {
  applyRenewalCoupon(code: $code) {
    code
    type
    discount
    cycles
    renewal_price_cents
    pix_order_regenerated
  }
}
    `;
export type ApplyRenewalCouponMutationFn = Apollo.MutationFunction<ApplyRenewalCouponMutation, ApplyRenewalCouponMutationVariables>;

/**
 * __useApplyRenewalCouponMutation__
 *
 * To run a mutation, you first call `useApplyRenewalCouponMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApplyRenewalCouponMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [applyRenewalCouponMutation, { data, loading, error }] = useApplyRenewalCouponMutation({
 *   variables: {
 *      code: // value for 'code'
 *   },
 * });
 */
export function useApplyRenewalCouponMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ApplyRenewalCouponMutation, ApplyRenewalCouponMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ApplyRenewalCouponMutation, ApplyRenewalCouponMutationVariables>(ApplyRenewalCouponDocument, options);
      }
export type ApplyRenewalCouponMutationHookResult = ReturnType<typeof useApplyRenewalCouponMutation>;
export type ApplyRenewalCouponMutationResult = Apollo.MutationResult<ApplyRenewalCouponMutation>;
export type ApplyRenewalCouponMutationOptions = Apollo.BaseMutationOptions<ApplyRenewalCouponMutation, ApplyRenewalCouponMutationVariables>;
export const CreatePixRenewalOrderDocument = gql`
    mutation CreatePixRenewalOrder($resetNow: Boolean) {
  createPixRenewalOrder(resetNow: $resetNow) {
    id
    amount
    status
    pix_code
    pix_qr_code_url
    expires_at
  }
}
    `;
export type CreatePixRenewalOrderMutationFn = Apollo.MutationFunction<CreatePixRenewalOrderMutation, CreatePixRenewalOrderMutationVariables>;

/**
 * __useCreatePixRenewalOrderMutation__
 *
 * To run a mutation, you first call `useCreatePixRenewalOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePixRenewalOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPixRenewalOrderMutation, { data, loading, error }] = useCreatePixRenewalOrderMutation({
 *   variables: {
 *      resetNow: // value for 'resetNow'
 *   },
 * });
 */
export function useCreatePixRenewalOrderMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreatePixRenewalOrderMutation, CreatePixRenewalOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreatePixRenewalOrderMutation, CreatePixRenewalOrderMutationVariables>(CreatePixRenewalOrderDocument, options);
      }
export type CreatePixRenewalOrderMutationHookResult = ReturnType<typeof useCreatePixRenewalOrderMutation>;
export type CreatePixRenewalOrderMutationResult = Apollo.MutationResult<CreatePixRenewalOrderMutation>;
export type CreatePixRenewalOrderMutationOptions = Apollo.BaseMutationOptions<CreatePixRenewalOrderMutation, CreatePixRenewalOrderMutationVariables>;
export const StartRenewedCycleNowDocument = gql`
    mutation StartRenewedCycleNow {
  startRenewedCycleNow
}
    `;
export type StartRenewedCycleNowMutationFn = Apollo.MutationFunction<StartRenewedCycleNowMutation, StartRenewedCycleNowMutationVariables>;

/**
 * __useStartRenewedCycleNowMutation__
 *
 * To run a mutation, you first call `useStartRenewedCycleNowMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartRenewedCycleNowMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startRenewedCycleNowMutation, { data, loading, error }] = useStartRenewedCycleNowMutation({
 *   variables: {
 *   },
 * });
 */
export function useStartRenewedCycleNowMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<StartRenewedCycleNowMutation, StartRenewedCycleNowMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<StartRenewedCycleNowMutation, StartRenewedCycleNowMutationVariables>(StartRenewedCycleNowDocument, options);
      }
export type StartRenewedCycleNowMutationHookResult = ReturnType<typeof useStartRenewedCycleNowMutation>;
export type StartRenewedCycleNowMutationResult = Apollo.MutationResult<StartRenewedCycleNowMutation>;
export type StartRenewedCycleNowMutationOptions = Apollo.BaseMutationOptions<StartRenewedCycleNowMutation, StartRenewedCycleNowMutationVariables>;
export const AdminStatsDocument = gql`
    query AdminStats($startDate: String, $endDate: String) {
  adminStats(startDate: $startDate, endDate: $endDate) {
    planCustomerCounts {
      plan_id
      plan_name
      plan_slug
      customer_count
    }
    users {
      total
      admins
      blocked
      confirmed
      timeSeries {
        date
        total
        success
        failure
      }
      utmTimeSeries {
        date
        utm_source
        count
      }
    }
    projects {
      total
      success
      processing
      queued
      failure
      timeSeries {
        date
        total
        success
        failure
      }
    }
    libraryProjects {
      total
      success
      processing
      queued
      failure
      timeSeries {
        date
        total
        success
        failure
      }
    }
    clips {
      total
      success
      processing
      queued
      failure
      timeSeries {
        date
        total
        success
        failure
      }
    }
    youtubeDownloads {
      total
      success
      processing
      queued
      failure
      timeSeries {
        date
        total
        success
        failure
      }
    }
  }
}
    `;

/**
 * __useAdminStatsQuery__
 *
 * To run a query within a React component, call `useAdminStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminStatsQuery({
 *   variables: {
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
export function useAdminStatsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<AdminStatsQuery, AdminStatsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AdminStatsQuery, AdminStatsQueryVariables>(AdminStatsDocument, options);
      }
export function useAdminStatsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AdminStatsQuery, AdminStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AdminStatsQuery, AdminStatsQueryVariables>(AdminStatsDocument, options);
        }
// @ts-ignore
export function useAdminStatsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<AdminStatsQuery, AdminStatsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AdminStatsQuery, AdminStatsQueryVariables>;
export function useAdminStatsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AdminStatsQuery, AdminStatsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AdminStatsQuery | undefined, AdminStatsQueryVariables>;
export function useAdminStatsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AdminStatsQuery, AdminStatsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<AdminStatsQuery, AdminStatsQueryVariables>(AdminStatsDocument, options);
        }
export type AdminStatsQueryHookResult = ReturnType<typeof useAdminStatsQuery>;
export type AdminStatsLazyQueryHookResult = ReturnType<typeof useAdminStatsLazyQuery>;
export type AdminStatsSuspenseQueryHookResult = ReturnType<typeof useAdminStatsSuspenseQuery>;
export type AdminStatsQueryResult = Apollo.QueryResult<AdminStatsQuery, AdminStatsQueryVariables>;
export const AdminFunnelStatsDocument = gql`
    query AdminFunnelStats {
  adminFunnelStats {
    own_brand {
      label
      count
    }
    other_channels {
      label
      count
    }
  }
}
    `;

/**
 * __useAdminFunnelStatsQuery__
 *
 * To run a query within a React component, call `useAdminFunnelStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminFunnelStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminFunnelStatsQuery({
 *   variables: {
 *   },
 * });
 */
export function useAdminFunnelStatsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<AdminFunnelStatsQuery, AdminFunnelStatsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AdminFunnelStatsQuery, AdminFunnelStatsQueryVariables>(AdminFunnelStatsDocument, options);
      }
export function useAdminFunnelStatsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AdminFunnelStatsQuery, AdminFunnelStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AdminFunnelStatsQuery, AdminFunnelStatsQueryVariables>(AdminFunnelStatsDocument, options);
        }
// @ts-ignore
export function useAdminFunnelStatsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<AdminFunnelStatsQuery, AdminFunnelStatsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AdminFunnelStatsQuery, AdminFunnelStatsQueryVariables>;
export function useAdminFunnelStatsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AdminFunnelStatsQuery, AdminFunnelStatsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AdminFunnelStatsQuery | undefined, AdminFunnelStatsQueryVariables>;
export function useAdminFunnelStatsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AdminFunnelStatsQuery, AdminFunnelStatsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<AdminFunnelStatsQuery, AdminFunnelStatsQueryVariables>(AdminFunnelStatsDocument, options);
        }
export type AdminFunnelStatsQueryHookResult = ReturnType<typeof useAdminFunnelStatsQuery>;
export type AdminFunnelStatsLazyQueryHookResult = ReturnType<typeof useAdminFunnelStatsLazyQuery>;
export type AdminFunnelStatsSuspenseQueryHookResult = ReturnType<typeof useAdminFunnelStatsSuspenseQuery>;
export type AdminFunnelStatsQueryResult = Apollo.QueryResult<AdminFunnelStatsQuery, AdminFunnelStatsQueryVariables>;
export const AdminResultsDashboardDocument = gql`
    query AdminResultsDashboard($startDate: String, $endDate: String) {
  adminResultsDashboard(startDate: $startDate, endDate: $endDate) {
    dateRange {
      startDate
      endDate
      days
      capped
    }
    conversion {
      totalFree
      totalPaid
      rate
    }
    funnelCreator {
      label
      count
      pct
    }
    funnelClipper {
      label
      count
      pct
    }
    sourcesCreator {
      key
      label
      count
      pct
    }
    sourcesClipper {
      key
      label
      count
      pct
    }
    retentionCreator {
      period
      pct
      retained
      cohort
    }
    retentionClipper {
      period
      pct
      retained
      cohort
    }
    campaigns {
      enrolled
      submitted
      approved
      earningsCents
      clipperToPaidPct
      subscriberToCampaignPct
    }
    nwc {
      total
      paidPct
      campaignPct
      retentionD1
      retentionD7
      retentionD30
      organicRetentionD1
      organicRetentionD7
      organicRetentionD30
    }
    activity {
      date
      users
      clips
    }
  }
}
    `;

/**
 * __useAdminResultsDashboardQuery__
 *
 * To run a query within a React component, call `useAdminResultsDashboardQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminResultsDashboardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminResultsDashboardQuery({
 *   variables: {
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
export function useAdminResultsDashboardQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<AdminResultsDashboardQuery, AdminResultsDashboardQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AdminResultsDashboardQuery, AdminResultsDashboardQueryVariables>(AdminResultsDashboardDocument, options);
      }
export function useAdminResultsDashboardLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AdminResultsDashboardQuery, AdminResultsDashboardQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AdminResultsDashboardQuery, AdminResultsDashboardQueryVariables>(AdminResultsDashboardDocument, options);
        }
// @ts-ignore
export function useAdminResultsDashboardSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<AdminResultsDashboardQuery, AdminResultsDashboardQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AdminResultsDashboardQuery, AdminResultsDashboardQueryVariables>;
export function useAdminResultsDashboardSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AdminResultsDashboardQuery, AdminResultsDashboardQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AdminResultsDashboardQuery | undefined, AdminResultsDashboardQueryVariables>;
export function useAdminResultsDashboardSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AdminResultsDashboardQuery, AdminResultsDashboardQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<AdminResultsDashboardQuery, AdminResultsDashboardQueryVariables>(AdminResultsDashboardDocument, options);
        }
export type AdminResultsDashboardQueryHookResult = ReturnType<typeof useAdminResultsDashboardQuery>;
export type AdminResultsDashboardLazyQueryHookResult = ReturnType<typeof useAdminResultsDashboardLazyQuery>;
export type AdminResultsDashboardSuspenseQueryHookResult = ReturnType<typeof useAdminResultsDashboardSuspenseQuery>;
export type AdminResultsDashboardQueryResult = Apollo.QueryResult<AdminResultsDashboardQuery, AdminResultsDashboardQueryVariables>;
export const AdminRestoreExpiredItemsDocument = gql`
    mutation AdminRestoreExpiredItems($userId: ID!) {
  adminRestoreExpiredItems(userId: $userId) {
    restoredProjects
    restoredClips
  }
}
    `;
export type AdminRestoreExpiredItemsMutationFn = Apollo.MutationFunction<AdminRestoreExpiredItemsMutation, AdminRestoreExpiredItemsMutationVariables>;

/**
 * __useAdminRestoreExpiredItemsMutation__
 *
 * To run a mutation, you first call `useAdminRestoreExpiredItemsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminRestoreExpiredItemsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminRestoreExpiredItemsMutation, { data, loading, error }] = useAdminRestoreExpiredItemsMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useAdminRestoreExpiredItemsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AdminRestoreExpiredItemsMutation, AdminRestoreExpiredItemsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AdminRestoreExpiredItemsMutation, AdminRestoreExpiredItemsMutationVariables>(AdminRestoreExpiredItemsDocument, options);
      }
export type AdminRestoreExpiredItemsMutationHookResult = ReturnType<typeof useAdminRestoreExpiredItemsMutation>;
export type AdminRestoreExpiredItemsMutationResult = Apollo.MutationResult<AdminRestoreExpiredItemsMutation>;
export type AdminRestoreExpiredItemsMutationOptions = Apollo.BaseMutationOptions<AdminRestoreExpiredItemsMutation, AdminRestoreExpiredItemsMutationVariables>;
export const AdminRestoreExpiredProjectDocument = gql`
    mutation AdminRestoreExpiredProject($id: ID!) {
  adminRestoreExpiredProject(id: $id)
}
    `;
export type AdminRestoreExpiredProjectMutationFn = Apollo.MutationFunction<AdminRestoreExpiredProjectMutation, AdminRestoreExpiredProjectMutationVariables>;

/**
 * __useAdminRestoreExpiredProjectMutation__
 *
 * To run a mutation, you first call `useAdminRestoreExpiredProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminRestoreExpiredProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminRestoreExpiredProjectMutation, { data, loading, error }] = useAdminRestoreExpiredProjectMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAdminRestoreExpiredProjectMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AdminRestoreExpiredProjectMutation, AdminRestoreExpiredProjectMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AdminRestoreExpiredProjectMutation, AdminRestoreExpiredProjectMutationVariables>(AdminRestoreExpiredProjectDocument, options);
      }
export type AdminRestoreExpiredProjectMutationHookResult = ReturnType<typeof useAdminRestoreExpiredProjectMutation>;
export type AdminRestoreExpiredProjectMutationResult = Apollo.MutationResult<AdminRestoreExpiredProjectMutation>;
export type AdminRestoreExpiredProjectMutationOptions = Apollo.BaseMutationOptions<AdminRestoreExpiredProjectMutation, AdminRestoreExpiredProjectMutationVariables>;
export const AdminRestoreExpiredClipDocument = gql`
    mutation AdminRestoreExpiredClip($id: ID!) {
  adminRestoreExpiredClip(id: $id)
}
    `;
export type AdminRestoreExpiredClipMutationFn = Apollo.MutationFunction<AdminRestoreExpiredClipMutation, AdminRestoreExpiredClipMutationVariables>;

/**
 * __useAdminRestoreExpiredClipMutation__
 *
 * To run a mutation, you first call `useAdminRestoreExpiredClipMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminRestoreExpiredClipMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminRestoreExpiredClipMutation, { data, loading, error }] = useAdminRestoreExpiredClipMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAdminRestoreExpiredClipMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AdminRestoreExpiredClipMutation, AdminRestoreExpiredClipMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AdminRestoreExpiredClipMutation, AdminRestoreExpiredClipMutationVariables>(AdminRestoreExpiredClipDocument, options);
      }
export type AdminRestoreExpiredClipMutationHookResult = ReturnType<typeof useAdminRestoreExpiredClipMutation>;
export type AdminRestoreExpiredClipMutationResult = Apollo.MutationResult<AdminRestoreExpiredClipMutation>;
export type AdminRestoreExpiredClipMutationOptions = Apollo.BaseMutationOptions<AdminRestoreExpiredClipMutation, AdminRestoreExpiredClipMutationVariables>;
export const AdminRetryFailedProjectDocument = gql`
    mutation AdminRetryFailedProject($id: ID!) {
  adminRetryFailedProject(id: $id)
}
    `;
export type AdminRetryFailedProjectMutationFn = Apollo.MutationFunction<AdminRetryFailedProjectMutation, AdminRetryFailedProjectMutationVariables>;

/**
 * __useAdminRetryFailedProjectMutation__
 *
 * To run a mutation, you first call `useAdminRetryFailedProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminRetryFailedProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminRetryFailedProjectMutation, { data, loading, error }] = useAdminRetryFailedProjectMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAdminRetryFailedProjectMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AdminRetryFailedProjectMutation, AdminRetryFailedProjectMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AdminRetryFailedProjectMutation, AdminRetryFailedProjectMutationVariables>(AdminRetryFailedProjectDocument, options);
      }
export type AdminRetryFailedProjectMutationHookResult = ReturnType<typeof useAdminRetryFailedProjectMutation>;
export type AdminRetryFailedProjectMutationResult = Apollo.MutationResult<AdminRetryFailedProjectMutation>;
export type AdminRetryFailedProjectMutationOptions = Apollo.BaseMutationOptions<AdminRetryFailedProjectMutation, AdminRetryFailedProjectMutationVariables>;
export const AdminRetryFailedClipDocument = gql`
    mutation AdminRetryFailedClip($id: ID!) {
  adminRetryFailedClip(id: $id)
}
    `;
export type AdminRetryFailedClipMutationFn = Apollo.MutationFunction<AdminRetryFailedClipMutation, AdminRetryFailedClipMutationVariables>;

/**
 * __useAdminRetryFailedClipMutation__
 *
 * To run a mutation, you first call `useAdminRetryFailedClipMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminRetryFailedClipMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminRetryFailedClipMutation, { data, loading, error }] = useAdminRetryFailedClipMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAdminRetryFailedClipMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AdminRetryFailedClipMutation, AdminRetryFailedClipMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AdminRetryFailedClipMutation, AdminRetryFailedClipMutationVariables>(AdminRetryFailedClipDocument, options);
      }
export type AdminRetryFailedClipMutationHookResult = ReturnType<typeof useAdminRetryFailedClipMutation>;
export type AdminRetryFailedClipMutationResult = Apollo.MutationResult<AdminRetryFailedClipMutation>;
export type AdminRetryFailedClipMutationOptions = Apollo.BaseMutationOptions<AdminRetryFailedClipMutation, AdminRetryFailedClipMutationVariables>;
export const AdminFetchChannelVideosDocument = gql`
    query AdminFetchChannelVideos($channelUrl: String!) {
  adminFetchChannelVideos(channelUrl: $channelUrl) {
    id
    title
    url
    thumbnail
    duration
    publishedAt
    viewCount
    channel
  }
}
    `;

/**
 * __useAdminFetchChannelVideosQuery__
 *
 * To run a query within a React component, call `useAdminFetchChannelVideosQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminFetchChannelVideosQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminFetchChannelVideosQuery({
 *   variables: {
 *      channelUrl: // value for 'channelUrl'
 *   },
 * });
 */
export function useAdminFetchChannelVideosQuery(baseOptions: ApolloReactHooks.QueryHookOptions<AdminFetchChannelVideosQuery, AdminFetchChannelVideosQueryVariables> & ({ variables: AdminFetchChannelVideosQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AdminFetchChannelVideosQuery, AdminFetchChannelVideosQueryVariables>(AdminFetchChannelVideosDocument, options);
      }
export function useAdminFetchChannelVideosLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AdminFetchChannelVideosQuery, AdminFetchChannelVideosQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AdminFetchChannelVideosQuery, AdminFetchChannelVideosQueryVariables>(AdminFetchChannelVideosDocument, options);
        }
// @ts-ignore
export function useAdminFetchChannelVideosSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<AdminFetchChannelVideosQuery, AdminFetchChannelVideosQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AdminFetchChannelVideosQuery, AdminFetchChannelVideosQueryVariables>;
export function useAdminFetchChannelVideosSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AdminFetchChannelVideosQuery, AdminFetchChannelVideosQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AdminFetchChannelVideosQuery | undefined, AdminFetchChannelVideosQueryVariables>;
export function useAdminFetchChannelVideosSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AdminFetchChannelVideosQuery, AdminFetchChannelVideosQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<AdminFetchChannelVideosQuery, AdminFetchChannelVideosQueryVariables>(AdminFetchChannelVideosDocument, options);
        }
export type AdminFetchChannelVideosQueryHookResult = ReturnType<typeof useAdminFetchChannelVideosQuery>;
export type AdminFetchChannelVideosLazyQueryHookResult = ReturnType<typeof useAdminFetchChannelVideosLazyQuery>;
export type AdminFetchChannelVideosSuspenseQueryHookResult = ReturnType<typeof useAdminFetchChannelVideosSuspenseQuery>;
export type AdminFetchChannelVideosQueryResult = Apollo.QueryResult<AdminFetchChannelVideosQuery, AdminFetchChannelVideosQueryVariables>;
export const AdminLibrariesDocument = gql`
    query AdminLibraries($page: Int, $pageSize: Int, $search: String, $curation_status: String, $sortBy: String, $sortOrder: String) {
  adminLibraries(
    page: $page
    pageSize: $pageSize
    search: $search
    curation_status: $curation_status
    sortBy: $sortBy
    sortOrder: $sortOrder
  ) {
    data {
      id
      name
      curation_status
      language
      format
      prompt
      base_video_url
      thumbnail_url
      duration_seconds
      deleted
      created_by_user {
        id
        email
        name
      }
      createdAt
      updatedAt
    }
    total
    page
    pageSize
    pageCount
  }
}
    `;

/**
 * __useAdminLibrariesQuery__
 *
 * To run a query within a React component, call `useAdminLibrariesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminLibrariesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminLibrariesQuery({
 *   variables: {
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *      search: // value for 'search'
 *      curation_status: // value for 'curation_status'
 *      sortBy: // value for 'sortBy'
 *      sortOrder: // value for 'sortOrder'
 *   },
 * });
 */
export function useAdminLibrariesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<AdminLibrariesQuery, AdminLibrariesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AdminLibrariesQuery, AdminLibrariesQueryVariables>(AdminLibrariesDocument, options);
      }
export function useAdminLibrariesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AdminLibrariesQuery, AdminLibrariesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AdminLibrariesQuery, AdminLibrariesQueryVariables>(AdminLibrariesDocument, options);
        }
// @ts-ignore
export function useAdminLibrariesSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<AdminLibrariesQuery, AdminLibrariesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AdminLibrariesQuery, AdminLibrariesQueryVariables>;
export function useAdminLibrariesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AdminLibrariesQuery, AdminLibrariesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AdminLibrariesQuery | undefined, AdminLibrariesQueryVariables>;
export function useAdminLibrariesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AdminLibrariesQuery, AdminLibrariesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<AdminLibrariesQuery, AdminLibrariesQueryVariables>(AdminLibrariesDocument, options);
        }
export type AdminLibrariesQueryHookResult = ReturnType<typeof useAdminLibrariesQuery>;
export type AdminLibrariesLazyQueryHookResult = ReturnType<typeof useAdminLibrariesLazyQuery>;
export type AdminLibrariesSuspenseQueryHookResult = ReturnType<typeof useAdminLibrariesSuspenseQuery>;
export type AdminLibrariesQueryResult = Apollo.QueryResult<AdminLibrariesQuery, AdminLibrariesQueryVariables>;
export const AdminAddToLibraryDocument = gql`
    mutation AdminAddToLibrary($input: AdminAddToLibraryInput!) {
  adminAddToLibrary(input: $input) {
    id
    name
    curation_status
    language
    format
    prompt
    base_video_url
    thumbnail_url
    duration_seconds
    createdAt
    updatedAt
  }
}
    `;
export type AdminAddToLibraryMutationFn = Apollo.MutationFunction<AdminAddToLibraryMutation, AdminAddToLibraryMutationVariables>;

/**
 * __useAdminAddToLibraryMutation__
 *
 * To run a mutation, you first call `useAdminAddToLibraryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminAddToLibraryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminAddToLibraryMutation, { data, loading, error }] = useAdminAddToLibraryMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdminAddToLibraryMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AdminAddToLibraryMutation, AdminAddToLibraryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AdminAddToLibraryMutation, AdminAddToLibraryMutationVariables>(AdminAddToLibraryDocument, options);
      }
export type AdminAddToLibraryMutationHookResult = ReturnType<typeof useAdminAddToLibraryMutation>;
export type AdminAddToLibraryMutationResult = Apollo.MutationResult<AdminAddToLibraryMutation>;
export type AdminAddToLibraryMutationOptions = Apollo.BaseMutationOptions<AdminAddToLibraryMutation, AdminAddToLibraryMutationVariables>;
export const AdminDeleteLibraryDocument = gql`
    mutation AdminDeleteLibrary($id: ID!) {
  adminDeleteLibrary(id: $id)
}
    `;
export type AdminDeleteLibraryMutationFn = Apollo.MutationFunction<AdminDeleteLibraryMutation, AdminDeleteLibraryMutationVariables>;

/**
 * __useAdminDeleteLibraryMutation__
 *
 * To run a mutation, you first call `useAdminDeleteLibraryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminDeleteLibraryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminDeleteLibraryMutation, { data, loading, error }] = useAdminDeleteLibraryMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAdminDeleteLibraryMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AdminDeleteLibraryMutation, AdminDeleteLibraryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AdminDeleteLibraryMutation, AdminDeleteLibraryMutationVariables>(AdminDeleteLibraryDocument, options);
      }
export type AdminDeleteLibraryMutationHookResult = ReturnType<typeof useAdminDeleteLibraryMutation>;
export type AdminDeleteLibraryMutationResult = Apollo.MutationResult<AdminDeleteLibraryMutation>;
export type AdminDeleteLibraryMutationOptions = Apollo.BaseMutationOptions<AdminDeleteLibraryMutation, AdminDeleteLibraryMutationVariables>;
export const AdminRetryFailedLibraryDocument = gql`
    mutation AdminRetryFailedLibrary($id: ID!) {
  adminRetryFailedLibrary(id: $id)
}
    `;
export type AdminRetryFailedLibraryMutationFn = Apollo.MutationFunction<AdminRetryFailedLibraryMutation, AdminRetryFailedLibraryMutationVariables>;

/**
 * __useAdminRetryFailedLibraryMutation__
 *
 * To run a mutation, you first call `useAdminRetryFailedLibraryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminRetryFailedLibraryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminRetryFailedLibraryMutation, { data, loading, error }] = useAdminRetryFailedLibraryMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAdminRetryFailedLibraryMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AdminRetryFailedLibraryMutation, AdminRetryFailedLibraryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AdminRetryFailedLibraryMutation, AdminRetryFailedLibraryMutationVariables>(AdminRetryFailedLibraryDocument, options);
      }
export type AdminRetryFailedLibraryMutationHookResult = ReturnType<typeof useAdminRetryFailedLibraryMutation>;
export type AdminRetryFailedLibraryMutationResult = Apollo.MutationResult<AdminRetryFailedLibraryMutation>;
export type AdminRetryFailedLibraryMutationOptions = Apollo.BaseMutationOptions<AdminRetryFailedLibraryMutation, AdminRetryFailedLibraryMutationVariables>;
export const AdminRestoreExpiredLibraryDocument = gql`
    mutation AdminRestoreExpiredLibrary($id: ID!) {
  adminRestoreExpiredLibrary(id: $id)
}
    `;
export type AdminRestoreExpiredLibraryMutationFn = Apollo.MutationFunction<AdminRestoreExpiredLibraryMutation, AdminRestoreExpiredLibraryMutationVariables>;

/**
 * __useAdminRestoreExpiredLibraryMutation__
 *
 * To run a mutation, you first call `useAdminRestoreExpiredLibraryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminRestoreExpiredLibraryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminRestoreExpiredLibraryMutation, { data, loading, error }] = useAdminRestoreExpiredLibraryMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAdminRestoreExpiredLibraryMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AdminRestoreExpiredLibraryMutation, AdminRestoreExpiredLibraryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AdminRestoreExpiredLibraryMutation, AdminRestoreExpiredLibraryMutationVariables>(AdminRestoreExpiredLibraryDocument, options);
      }
export type AdminRestoreExpiredLibraryMutationHookResult = ReturnType<typeof useAdminRestoreExpiredLibraryMutation>;
export type AdminRestoreExpiredLibraryMutationResult = Apollo.MutationResult<AdminRestoreExpiredLibraryMutation>;
export type AdminRestoreExpiredLibraryMutationOptions = Apollo.BaseMutationOptions<AdminRestoreExpiredLibraryMutation, AdminRestoreExpiredLibraryMutationVariables>;
export const AdminImpersonateUserDocument = gql`
    mutation AdminImpersonateUser($userId: ID!) {
  adminImpersonateUser(userId: $userId) {
    jwt
  }
}
    `;
export type AdminImpersonateUserMutationFn = Apollo.MutationFunction<AdminImpersonateUserMutation, AdminImpersonateUserMutationVariables>;

/**
 * __useAdminImpersonateUserMutation__
 *
 * To run a mutation, you first call `useAdminImpersonateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminImpersonateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminImpersonateUserMutation, { data, loading, error }] = useAdminImpersonateUserMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useAdminImpersonateUserMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AdminImpersonateUserMutation, AdminImpersonateUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AdminImpersonateUserMutation, AdminImpersonateUserMutationVariables>(AdminImpersonateUserDocument, options);
      }
export type AdminImpersonateUserMutationHookResult = ReturnType<typeof useAdminImpersonateUserMutation>;
export type AdminImpersonateUserMutationResult = Apollo.MutationResult<AdminImpersonateUserMutation>;
export type AdminImpersonateUserMutationOptions = Apollo.BaseMutationOptions<AdminImpersonateUserMutation, AdminImpersonateUserMutationVariables>;
export const AdminUpdateUserSubscriptionDocument = gql`
    mutation AdminUpdateUserSubscription($userId: ID!, $input: AdminUpdateUserSubscriptionInput!) {
  adminUpdateUserSubscription(userId: $userId, input: $input) {
    id
    name
    email
    onboarding_objective
    subscription {
      id
      current_month_processing_seconds
      current_month_clips
      current_month_library_video_seconds
      current_month_library_exports
      current_month_library_curations
      extra_clips
      is_partner
      partner_expires_at
      partner_note
      extra_seconds
      plan {
        id
        name
        slug
        max_library_curations
        max_library_exports
        max_library_video_seconds
      }
    }
  }
}
    `;
export type AdminUpdateUserSubscriptionMutationFn = Apollo.MutationFunction<AdminUpdateUserSubscriptionMutation, AdminUpdateUserSubscriptionMutationVariables>;

/**
 * __useAdminUpdateUserSubscriptionMutation__
 *
 * To run a mutation, you first call `useAdminUpdateUserSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminUpdateUserSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminUpdateUserSubscriptionMutation, { data, loading, error }] = useAdminUpdateUserSubscriptionMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdminUpdateUserSubscriptionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AdminUpdateUserSubscriptionMutation, AdminUpdateUserSubscriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AdminUpdateUserSubscriptionMutation, AdminUpdateUserSubscriptionMutationVariables>(AdminUpdateUserSubscriptionDocument, options);
      }
export type AdminUpdateUserSubscriptionMutationHookResult = ReturnType<typeof useAdminUpdateUserSubscriptionMutation>;
export type AdminUpdateUserSubscriptionMutationResult = Apollo.MutationResult<AdminUpdateUserSubscriptionMutation>;
export type AdminUpdateUserSubscriptionMutationOptions = Apollo.BaseMutationOptions<AdminUpdateUserSubscriptionMutation, AdminUpdateUserSubscriptionMutationVariables>;
export const AdminSetAffiliateRatesDocument = gql`
    mutation AdminSetAffiliateRates($userId: ID!, $input: AdminAffiliateRatesInput!) {
  adminSetAffiliateRates(userId: $userId, input: $input) {
    id
    affiliate_rate_payment
    affiliate_rate_course
    affiliate_rate_cpm
    affiliate_rate_note
  }
}
    `;
export type AdminSetAffiliateRatesMutationFn = Apollo.MutationFunction<AdminSetAffiliateRatesMutation, AdminSetAffiliateRatesMutationVariables>;

/**
 * __useAdminSetAffiliateRatesMutation__
 *
 * To run a mutation, you first call `useAdminSetAffiliateRatesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminSetAffiliateRatesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminSetAffiliateRatesMutation, { data, loading, error }] = useAdminSetAffiliateRatesMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdminSetAffiliateRatesMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AdminSetAffiliateRatesMutation, AdminSetAffiliateRatesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AdminSetAffiliateRatesMutation, AdminSetAffiliateRatesMutationVariables>(AdminSetAffiliateRatesDocument, options);
      }
export type AdminSetAffiliateRatesMutationHookResult = ReturnType<typeof useAdminSetAffiliateRatesMutation>;
export type AdminSetAffiliateRatesMutationResult = Apollo.MutationResult<AdminSetAffiliateRatesMutation>;
export type AdminSetAffiliateRatesMutationOptions = Apollo.BaseMutationOptions<AdminSetAffiliateRatesMutation, AdminSetAffiliateRatesMutationVariables>;
export const AdminSetCpmLeaderboardExclusionDocument = gql`
    mutation AdminSetCpmLeaderboardExclusion($userId: ID!, $excluded: Boolean!, $reason: String) {
  adminSetCpmLeaderboardExclusion(
    userId: $userId
    excluded: $excluded
    reason: $reason
  ) {
    id
    cpm_leaderboard_excluded
    cpm_leaderboard_excluded_reason
  }
}
    `;
export type AdminSetCpmLeaderboardExclusionMutationFn = Apollo.MutationFunction<AdminSetCpmLeaderboardExclusionMutation, AdminSetCpmLeaderboardExclusionMutationVariables>;

/**
 * __useAdminSetCpmLeaderboardExclusionMutation__
 *
 * To run a mutation, you first call `useAdminSetCpmLeaderboardExclusionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminSetCpmLeaderboardExclusionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminSetCpmLeaderboardExclusionMutation, { data, loading, error }] = useAdminSetCpmLeaderboardExclusionMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      excluded: // value for 'excluded'
 *      reason: // value for 'reason'
 *   },
 * });
 */
export function useAdminSetCpmLeaderboardExclusionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AdminSetCpmLeaderboardExclusionMutation, AdminSetCpmLeaderboardExclusionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AdminSetCpmLeaderboardExclusionMutation, AdminSetCpmLeaderboardExclusionMutationVariables>(AdminSetCpmLeaderboardExclusionDocument, options);
      }
export type AdminSetCpmLeaderboardExclusionMutationHookResult = ReturnType<typeof useAdminSetCpmLeaderboardExclusionMutation>;
export type AdminSetCpmLeaderboardExclusionMutationResult = Apollo.MutationResult<AdminSetCpmLeaderboardExclusionMutation>;
export type AdminSetCpmLeaderboardExclusionMutationOptions = Apollo.BaseMutationOptions<AdminSetCpmLeaderboardExclusionMutation, AdminSetCpmLeaderboardExclusionMutationVariables>;
export const ActiveChallengeDocument = gql`
    query ActiveChallenge {
  activeChallenge {
    id
    name
    description
    start_date
    end_date
    prize_pool
    warning_message
    rules_allowed
    rules_forbidden
    rules_attention
    is_accepting_participants
    required_hashtags
    caption_examples
    prize_data
    my_participation {
      id
      user_id
      user_name
      user_email
      user_profile_picture
      disqualified
      disqualification_reason
      challenge_clips {
        id
        platform
        url
        total_views
        admin_approval
        approval_reason
        validated_hashtags
        challenge_clip_views {
          id
          date
          platform
          views
          likes
          comments
          shares
          saves
          favorites
        }
        createdAt
      }
      total_views
      createdAt
    }
    ranking {
      participation_id
      user_id
      user_name
      user_profile_picture
      total_views
      clip_count
    }
  }
}
    `;

/**
 * __useActiveChallengeQuery__
 *
 * To run a query within a React component, call `useActiveChallengeQuery` and pass it any options that fit your needs.
 * When your component renders, `useActiveChallengeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useActiveChallengeQuery({
 *   variables: {
 *   },
 * });
 */
export function useActiveChallengeQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ActiveChallengeQuery, ActiveChallengeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ActiveChallengeQuery, ActiveChallengeQueryVariables>(ActiveChallengeDocument, options);
      }
export function useActiveChallengeLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ActiveChallengeQuery, ActiveChallengeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ActiveChallengeQuery, ActiveChallengeQueryVariables>(ActiveChallengeDocument, options);
        }
// @ts-ignore
export function useActiveChallengeSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ActiveChallengeQuery, ActiveChallengeQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ActiveChallengeQuery, ActiveChallengeQueryVariables>;
export function useActiveChallengeSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ActiveChallengeQuery, ActiveChallengeQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ActiveChallengeQuery | undefined, ActiveChallengeQueryVariables>;
export function useActiveChallengeSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ActiveChallengeQuery, ActiveChallengeQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ActiveChallengeQuery, ActiveChallengeQueryVariables>(ActiveChallengeDocument, options);
        }
export type ActiveChallengeQueryHookResult = ReturnType<typeof useActiveChallengeQuery>;
export type ActiveChallengeLazyQueryHookResult = ReturnType<typeof useActiveChallengeLazyQuery>;
export type ActiveChallengeSuspenseQueryHookResult = ReturnType<typeof useActiveChallengeSuspenseQuery>;
export type ActiveChallengeQueryResult = Apollo.QueryResult<ActiveChallengeQuery, ActiveChallengeQueryVariables>;
export const GetChallengeDocument = gql`
    query GetChallenge($id: ID!) {
  challenge(id: $id) {
    id
    name
    description
    start_date
    end_date
    prize_pool
    warning_message
    rules_allowed
    rules_forbidden
    rules_attention
    is_accepting_participants
    required_hashtags
    caption_examples
    prize_data
    my_participation {
      id
      user_id
      user_name
      user_email
      user_profile_picture
      disqualified
      disqualification_reason
      challenge_clips {
        id
        platform
        url
        total_views
        admin_approval
        approval_reason
        validated_hashtags
        challenge_clip_views {
          id
          date
          platform
          views
          likes
          comments
          shares
          saves
          favorites
        }
        createdAt
      }
      total_views
      createdAt
    }
    ranking {
      participation_id
      user_id
      user_name
      user_profile_picture
      total_views
      clip_count
    }
    rankings {
      id
      name
      timezone
      is_consolidated
      admin_validated
      consolidated_at
      ranking_data
      partial_ranking {
        participation_id
        user_id
        user_name
        user_profile_picture
        total_views
        clip_count
      }
      time_until_start_seconds
      time_until_end_seconds
    }
  }
}
    `;

/**
 * __useGetChallengeQuery__
 *
 * To run a query within a React component, call `useGetChallengeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetChallengeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetChallengeQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetChallengeQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetChallengeQuery, GetChallengeQueryVariables> & ({ variables: GetChallengeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetChallengeQuery, GetChallengeQueryVariables>(GetChallengeDocument, options);
      }
export function useGetChallengeLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetChallengeQuery, GetChallengeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetChallengeQuery, GetChallengeQueryVariables>(GetChallengeDocument, options);
        }
// @ts-ignore
export function useGetChallengeSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetChallengeQuery, GetChallengeQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetChallengeQuery, GetChallengeQueryVariables>;
export function useGetChallengeSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetChallengeQuery, GetChallengeQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetChallengeQuery | undefined, GetChallengeQueryVariables>;
export function useGetChallengeSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetChallengeQuery, GetChallengeQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetChallengeQuery, GetChallengeQueryVariables>(GetChallengeDocument, options);
        }
export type GetChallengeQueryHookResult = ReturnType<typeof useGetChallengeQuery>;
export type GetChallengeLazyQueryHookResult = ReturnType<typeof useGetChallengeLazyQuery>;
export type GetChallengeSuspenseQueryHookResult = ReturnType<typeof useGetChallengeSuspenseQuery>;
export type GetChallengeQueryResult = Apollo.QueryResult<GetChallengeQuery, GetChallengeQueryVariables>;
export const JoinChallengeDocument = gql`
    mutation JoinChallenge($challengeId: ID!) {
  joinChallenge(challengeId: $challengeId) {
    id
    user_id
    challenge_clips {
      id
      platform
      url
      total_views
      createdAt
    }
    total_views
    createdAt
  }
}
    `;
export type JoinChallengeMutationFn = Apollo.MutationFunction<JoinChallengeMutation, JoinChallengeMutationVariables>;

/**
 * __useJoinChallengeMutation__
 *
 * To run a mutation, you first call `useJoinChallengeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useJoinChallengeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [joinChallengeMutation, { data, loading, error }] = useJoinChallengeMutation({
 *   variables: {
 *      challengeId: // value for 'challengeId'
 *   },
 * });
 */
export function useJoinChallengeMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<JoinChallengeMutation, JoinChallengeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<JoinChallengeMutation, JoinChallengeMutationVariables>(JoinChallengeDocument, options);
      }
export type JoinChallengeMutationHookResult = ReturnType<typeof useJoinChallengeMutation>;
export type JoinChallengeMutationResult = Apollo.MutationResult<JoinChallengeMutation>;
export type JoinChallengeMutationOptions = Apollo.BaseMutationOptions<JoinChallengeMutation, JoinChallengeMutationVariables>;
export const SubmitChallengeClipDocument = gql`
    mutation SubmitChallengeClip($input: SubmitChallengeClipInput!) {
  submitChallengeClip(input: $input) {
    id
    platform
    url
    total_views
    createdAt
  }
}
    `;
export type SubmitChallengeClipMutationFn = Apollo.MutationFunction<SubmitChallengeClipMutation, SubmitChallengeClipMutationVariables>;

/**
 * __useSubmitChallengeClipMutation__
 *
 * To run a mutation, you first call `useSubmitChallengeClipMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitChallengeClipMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitChallengeClipMutation, { data, loading, error }] = useSubmitChallengeClipMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSubmitChallengeClipMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SubmitChallengeClipMutation, SubmitChallengeClipMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SubmitChallengeClipMutation, SubmitChallengeClipMutationVariables>(SubmitChallengeClipDocument, options);
      }
export type SubmitChallengeClipMutationHookResult = ReturnType<typeof useSubmitChallengeClipMutation>;
export type SubmitChallengeClipMutationResult = Apollo.MutationResult<SubmitChallengeClipMutation>;
export type SubmitChallengeClipMutationOptions = Apollo.BaseMutationOptions<SubmitChallengeClipMutation, SubmitChallengeClipMutationVariables>;
export const ValidateChallengeClipHashtagsDocument = gql`
    mutation ValidateChallengeClipHashtags($input: ValidateChallengeClipInput!) {
  validateChallengeClipHashtags(input: $input) {
    hashtags_valid
    missing_hashtags
  }
}
    `;
export type ValidateChallengeClipHashtagsMutationFn = Apollo.MutationFunction<ValidateChallengeClipHashtagsMutation, ValidateChallengeClipHashtagsMutationVariables>;

/**
 * __useValidateChallengeClipHashtagsMutation__
 *
 * To run a mutation, you first call `useValidateChallengeClipHashtagsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useValidateChallengeClipHashtagsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [validateChallengeClipHashtagsMutation, { data, loading, error }] = useValidateChallengeClipHashtagsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useValidateChallengeClipHashtagsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ValidateChallengeClipHashtagsMutation, ValidateChallengeClipHashtagsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ValidateChallengeClipHashtagsMutation, ValidateChallengeClipHashtagsMutationVariables>(ValidateChallengeClipHashtagsDocument, options);
      }
export type ValidateChallengeClipHashtagsMutationHookResult = ReturnType<typeof useValidateChallengeClipHashtagsMutation>;
export type ValidateChallengeClipHashtagsMutationResult = Apollo.MutationResult<ValidateChallengeClipHashtagsMutation>;
export type ValidateChallengeClipHashtagsMutationOptions = Apollo.BaseMutationOptions<ValidateChallengeClipHashtagsMutation, ValidateChallengeClipHashtagsMutationVariables>;
export const AdminChallengesDocument = gql`
    query AdminChallenges($page: Int, $pageSize: Int, $search: String) {
  adminChallenges(page: $page, pageSize: $pageSize, search: $search) {
    data {
      id
      name
      description
      start_date
      end_date
      prize_pool
      warning_message
      rules_allowed
      rules_forbidden
      rules_attention
      is_accepting_participants
      required_hashtags
      caption_examples
      prize_data
      rankings {
        id
        name
        timezone
        is_consolidated
        consolidated_at
        ranking_data
      }
      participants {
        id
        user_id
        user_name
        user_email
        total_views
        clip_count
        challenge_clips {
          id
          platform
          url
          total_views
          admin_approval
          approval_reason
          validated_hashtags
          createdAt
        }
        createdAt
      }
      createdAt
      updatedAt
    }
    page
    pageSize
    pageCount
    total
  }
}
    `;

/**
 * __useAdminChallengesQuery__
 *
 * To run a query within a React component, call `useAdminChallengesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminChallengesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminChallengesQuery({
 *   variables: {
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useAdminChallengesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<AdminChallengesQuery, AdminChallengesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AdminChallengesQuery, AdminChallengesQueryVariables>(AdminChallengesDocument, options);
      }
export function useAdminChallengesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AdminChallengesQuery, AdminChallengesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AdminChallengesQuery, AdminChallengesQueryVariables>(AdminChallengesDocument, options);
        }
// @ts-ignore
export function useAdminChallengesSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<AdminChallengesQuery, AdminChallengesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AdminChallengesQuery, AdminChallengesQueryVariables>;
export function useAdminChallengesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AdminChallengesQuery, AdminChallengesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AdminChallengesQuery | undefined, AdminChallengesQueryVariables>;
export function useAdminChallengesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AdminChallengesQuery, AdminChallengesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<AdminChallengesQuery, AdminChallengesQueryVariables>(AdminChallengesDocument, options);
        }
export type AdminChallengesQueryHookResult = ReturnType<typeof useAdminChallengesQuery>;
export type AdminChallengesLazyQueryHookResult = ReturnType<typeof useAdminChallengesLazyQuery>;
export type AdminChallengesSuspenseQueryHookResult = ReturnType<typeof useAdminChallengesSuspenseQuery>;
export type AdminChallengesQueryResult = Apollo.QueryResult<AdminChallengesQuery, AdminChallengesQueryVariables>;
export const AdminChallengeDocument = gql`
    query AdminChallenge($id: ID!) {
  adminChallenge(id: $id) {
    id
    name
    description
    start_date
    end_date
    prize_pool
    warning_message
    rules_allowed
    rules_forbidden
    rules_attention
    is_accepting_participants
    required_hashtags
    caption_examples
    prize_data
    rankings {
      id
      name
      timezone
      is_consolidated
      admin_validated
      consolidated_at
      ranking_data
      partial_ranking {
        participation_id
        user_id
        user_name
        user_profile_picture
        total_views
        clip_count
      }
      start_date
      end_date
      start_snapshotted_at
      end_snapshotted_at
      time_until_start_seconds
      time_until_end_seconds
    }
    participants {
      id
      user_id
      user_name
      user_email
      total_views
      clip_count
      subscription {
        id
        current_month_processing_seconds
        current_month_clips
        current_month_library_video_seconds
        current_month_library_exports
        plan {
          id
          name
          processing_seconds
          max_clips
          max_library_video_seconds
          max_library_exports
        }
        createdAt
        updatedAt
      }
      challenge_clips {
        id
        platform
        url
        total_views
        admin_approval
        approval_reason
        validated_hashtags
        createdAt
      }
      disqualified
      disqualification_reason
      createdAt
    }
    createdAt
    updatedAt
  }
}
    `;

/**
 * __useAdminChallengeQuery__
 *
 * To run a query within a React component, call `useAdminChallengeQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminChallengeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminChallengeQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAdminChallengeQuery(baseOptions: ApolloReactHooks.QueryHookOptions<AdminChallengeQuery, AdminChallengeQueryVariables> & ({ variables: AdminChallengeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AdminChallengeQuery, AdminChallengeQueryVariables>(AdminChallengeDocument, options);
      }
export function useAdminChallengeLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AdminChallengeQuery, AdminChallengeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AdminChallengeQuery, AdminChallengeQueryVariables>(AdminChallengeDocument, options);
        }
// @ts-ignore
export function useAdminChallengeSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<AdminChallengeQuery, AdminChallengeQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AdminChallengeQuery, AdminChallengeQueryVariables>;
export function useAdminChallengeSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AdminChallengeQuery, AdminChallengeQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AdminChallengeQuery | undefined, AdminChallengeQueryVariables>;
export function useAdminChallengeSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AdminChallengeQuery, AdminChallengeQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<AdminChallengeQuery, AdminChallengeQueryVariables>(AdminChallengeDocument, options);
        }
export type AdminChallengeQueryHookResult = ReturnType<typeof useAdminChallengeQuery>;
export type AdminChallengeLazyQueryHookResult = ReturnType<typeof useAdminChallengeLazyQuery>;
export type AdminChallengeSuspenseQueryHookResult = ReturnType<typeof useAdminChallengeSuspenseQuery>;
export type AdminChallengeQueryResult = Apollo.QueryResult<AdminChallengeQuery, AdminChallengeQueryVariables>;
export const AdminCreateChallengeDocument = gql`
    mutation AdminCreateChallenge($input: AdminChallengeCreateInput!) {
  adminCreateChallenge(input: $input) {
    id
    name
    start_date
    end_date
    prize_pool
    createdAt
  }
}
    `;
export type AdminCreateChallengeMutationFn = Apollo.MutationFunction<AdminCreateChallengeMutation, AdminCreateChallengeMutationVariables>;

/**
 * __useAdminCreateChallengeMutation__
 *
 * To run a mutation, you first call `useAdminCreateChallengeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminCreateChallengeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminCreateChallengeMutation, { data, loading, error }] = useAdminCreateChallengeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdminCreateChallengeMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AdminCreateChallengeMutation, AdminCreateChallengeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AdminCreateChallengeMutation, AdminCreateChallengeMutationVariables>(AdminCreateChallengeDocument, options);
      }
export type AdminCreateChallengeMutationHookResult = ReturnType<typeof useAdminCreateChallengeMutation>;
export type AdminCreateChallengeMutationResult = Apollo.MutationResult<AdminCreateChallengeMutation>;
export type AdminCreateChallengeMutationOptions = Apollo.BaseMutationOptions<AdminCreateChallengeMutation, AdminCreateChallengeMutationVariables>;
export const AdminUpdateChallengeDocument = gql`
    mutation AdminUpdateChallenge($id: ID!, $input: AdminChallengeUpdateInput!) {
  adminUpdateChallenge(id: $id, input: $input) {
    id
    name
    start_date
    end_date
    prize_pool
    createdAt
  }
}
    `;
export type AdminUpdateChallengeMutationFn = Apollo.MutationFunction<AdminUpdateChallengeMutation, AdminUpdateChallengeMutationVariables>;

/**
 * __useAdminUpdateChallengeMutation__
 *
 * To run a mutation, you first call `useAdminUpdateChallengeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminUpdateChallengeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminUpdateChallengeMutation, { data, loading, error }] = useAdminUpdateChallengeMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdminUpdateChallengeMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AdminUpdateChallengeMutation, AdminUpdateChallengeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AdminUpdateChallengeMutation, AdminUpdateChallengeMutationVariables>(AdminUpdateChallengeDocument, options);
      }
export type AdminUpdateChallengeMutationHookResult = ReturnType<typeof useAdminUpdateChallengeMutation>;
export type AdminUpdateChallengeMutationResult = Apollo.MutationResult<AdminUpdateChallengeMutation>;
export type AdminUpdateChallengeMutationOptions = Apollo.BaseMutationOptions<AdminUpdateChallengeMutation, AdminUpdateChallengeMutationVariables>;
export const AdminDeleteChallengeDocument = gql`
    mutation AdminDeleteChallenge($id: ID!) {
  adminDeleteChallenge(id: $id)
}
    `;
export type AdminDeleteChallengeMutationFn = Apollo.MutationFunction<AdminDeleteChallengeMutation, AdminDeleteChallengeMutationVariables>;

/**
 * __useAdminDeleteChallengeMutation__
 *
 * To run a mutation, you first call `useAdminDeleteChallengeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminDeleteChallengeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminDeleteChallengeMutation, { data, loading, error }] = useAdminDeleteChallengeMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAdminDeleteChallengeMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AdminDeleteChallengeMutation, AdminDeleteChallengeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AdminDeleteChallengeMutation, AdminDeleteChallengeMutationVariables>(AdminDeleteChallengeDocument, options);
      }
export type AdminDeleteChallengeMutationHookResult = ReturnType<typeof useAdminDeleteChallengeMutation>;
export type AdminDeleteChallengeMutationResult = Apollo.MutationResult<AdminDeleteChallengeMutation>;
export type AdminDeleteChallengeMutationOptions = Apollo.BaseMutationOptions<AdminDeleteChallengeMutation, AdminDeleteChallengeMutationVariables>;
export const AdminAddChallengeParticipantDocument = gql`
    mutation AdminAddChallengeParticipant($challengeId: ID!, $email: String!, $phone: String, $name: String) {
  adminAddChallengeParticipant(
    challengeId: $challengeId
    email: $email
    phone: $phone
    name: $name
  ) {
    id
    user_id
    user_name
    user_email
    total_views
    clip_count
    challenge_clips {
      id
      platform
      url
      total_views
      admin_approval
      approval_reason
      createdAt
    }
    was_created
    createdAt
  }
}
    `;
export type AdminAddChallengeParticipantMutationFn = Apollo.MutationFunction<AdminAddChallengeParticipantMutation, AdminAddChallengeParticipantMutationVariables>;

/**
 * __useAdminAddChallengeParticipantMutation__
 *
 * To run a mutation, you first call `useAdminAddChallengeParticipantMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminAddChallengeParticipantMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminAddChallengeParticipantMutation, { data, loading, error }] = useAdminAddChallengeParticipantMutation({
 *   variables: {
 *      challengeId: // value for 'challengeId'
 *      email: // value for 'email'
 *      phone: // value for 'phone'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useAdminAddChallengeParticipantMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AdminAddChallengeParticipantMutation, AdminAddChallengeParticipantMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AdminAddChallengeParticipantMutation, AdminAddChallengeParticipantMutationVariables>(AdminAddChallengeParticipantDocument, options);
      }
export type AdminAddChallengeParticipantMutationHookResult = ReturnType<typeof useAdminAddChallengeParticipantMutation>;
export type AdminAddChallengeParticipantMutationResult = Apollo.MutationResult<AdminAddChallengeParticipantMutation>;
export type AdminAddChallengeParticipantMutationOptions = Apollo.BaseMutationOptions<AdminAddChallengeParticipantMutation, AdminAddChallengeParticipantMutationVariables>;
export const AdminRemoveChallengeParticipantDocument = gql`
    mutation AdminRemoveChallengeParticipant($challengeId: ID!, $participantId: ID!) {
  adminRemoveChallengeParticipant(
    challengeId: $challengeId
    participantId: $participantId
  )
}
    `;
export type AdminRemoveChallengeParticipantMutationFn = Apollo.MutationFunction<AdminRemoveChallengeParticipantMutation, AdminRemoveChallengeParticipantMutationVariables>;

/**
 * __useAdminRemoveChallengeParticipantMutation__
 *
 * To run a mutation, you first call `useAdminRemoveChallengeParticipantMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminRemoveChallengeParticipantMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminRemoveChallengeParticipantMutation, { data, loading, error }] = useAdminRemoveChallengeParticipantMutation({
 *   variables: {
 *      challengeId: // value for 'challengeId'
 *      participantId: // value for 'participantId'
 *   },
 * });
 */
export function useAdminRemoveChallengeParticipantMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AdminRemoveChallengeParticipantMutation, AdminRemoveChallengeParticipantMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AdminRemoveChallengeParticipantMutation, AdminRemoveChallengeParticipantMutationVariables>(AdminRemoveChallengeParticipantDocument, options);
      }
export type AdminRemoveChallengeParticipantMutationHookResult = ReturnType<typeof useAdminRemoveChallengeParticipantMutation>;
export type AdminRemoveChallengeParticipantMutationResult = Apollo.MutationResult<AdminRemoveChallengeParticipantMutation>;
export type AdminRemoveChallengeParticipantMutationOptions = Apollo.BaseMutationOptions<AdminRemoveChallengeParticipantMutation, AdminRemoveChallengeParticipantMutationVariables>;
export const AdminDisqualifyParticipantDocument = gql`
    mutation AdminDisqualifyParticipant($participantId: ID!, $disqualified: Boolean!, $reason: String) {
  adminDisqualifyParticipant(
    participantId: $participantId
    disqualified: $disqualified
    reason: $reason
  )
}
    `;
export type AdminDisqualifyParticipantMutationFn = Apollo.MutationFunction<AdminDisqualifyParticipantMutation, AdminDisqualifyParticipantMutationVariables>;

/**
 * __useAdminDisqualifyParticipantMutation__
 *
 * To run a mutation, you first call `useAdminDisqualifyParticipantMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminDisqualifyParticipantMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminDisqualifyParticipantMutation, { data, loading, error }] = useAdminDisqualifyParticipantMutation({
 *   variables: {
 *      participantId: // value for 'participantId'
 *      disqualified: // value for 'disqualified'
 *      reason: // value for 'reason'
 *   },
 * });
 */
export function useAdminDisqualifyParticipantMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AdminDisqualifyParticipantMutation, AdminDisqualifyParticipantMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AdminDisqualifyParticipantMutation, AdminDisqualifyParticipantMutationVariables>(AdminDisqualifyParticipantDocument, options);
      }
export type AdminDisqualifyParticipantMutationHookResult = ReturnType<typeof useAdminDisqualifyParticipantMutation>;
export type AdminDisqualifyParticipantMutationResult = Apollo.MutationResult<AdminDisqualifyParticipantMutation>;
export type AdminDisqualifyParticipantMutationOptions = Apollo.BaseMutationOptions<AdminDisqualifyParticipantMutation, AdminDisqualifyParticipantMutationVariables>;
export const AdminResetChallengeParticipantUsageDocument = gql`
    mutation AdminResetChallengeParticipantUsage($challengeId: ID!, $participantId: ID!) {
  adminResetChallengeParticipantUsage(
    challengeId: $challengeId
    participantId: $participantId
  )
}
    `;
export type AdminResetChallengeParticipantUsageMutationFn = Apollo.MutationFunction<AdminResetChallengeParticipantUsageMutation, AdminResetChallengeParticipantUsageMutationVariables>;

/**
 * __useAdminResetChallengeParticipantUsageMutation__
 *
 * To run a mutation, you first call `useAdminResetChallengeParticipantUsageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminResetChallengeParticipantUsageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminResetChallengeParticipantUsageMutation, { data, loading, error }] = useAdminResetChallengeParticipantUsageMutation({
 *   variables: {
 *      challengeId: // value for 'challengeId'
 *      participantId: // value for 'participantId'
 *   },
 * });
 */
export function useAdminResetChallengeParticipantUsageMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AdminResetChallengeParticipantUsageMutation, AdminResetChallengeParticipantUsageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AdminResetChallengeParticipantUsageMutation, AdminResetChallengeParticipantUsageMutationVariables>(AdminResetChallengeParticipantUsageDocument, options);
      }
export type AdminResetChallengeParticipantUsageMutationHookResult = ReturnType<typeof useAdminResetChallengeParticipantUsageMutation>;
export type AdminResetChallengeParticipantUsageMutationResult = Apollo.MutationResult<AdminResetChallengeParticipantUsageMutation>;
export type AdminResetChallengeParticipantUsageMutationOptions = Apollo.BaseMutationOptions<AdminResetChallengeParticipantUsageMutation, AdminResetChallengeParticipantUsageMutationVariables>;
export const AdminResetAllChallengeParticipantsUsageDocument = gql`
    mutation AdminResetAllChallengeParticipantsUsage($challengeId: ID!) {
  adminResetAllChallengeParticipantsUsage(challengeId: $challengeId)
}
    `;
export type AdminResetAllChallengeParticipantsUsageMutationFn = Apollo.MutationFunction<AdminResetAllChallengeParticipantsUsageMutation, AdminResetAllChallengeParticipantsUsageMutationVariables>;

/**
 * __useAdminResetAllChallengeParticipantsUsageMutation__
 *
 * To run a mutation, you first call `useAdminResetAllChallengeParticipantsUsageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminResetAllChallengeParticipantsUsageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminResetAllChallengeParticipantsUsageMutation, { data, loading, error }] = useAdminResetAllChallengeParticipantsUsageMutation({
 *   variables: {
 *      challengeId: // value for 'challengeId'
 *   },
 * });
 */
export function useAdminResetAllChallengeParticipantsUsageMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AdminResetAllChallengeParticipantsUsageMutation, AdminResetAllChallengeParticipantsUsageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AdminResetAllChallengeParticipantsUsageMutation, AdminResetAllChallengeParticipantsUsageMutationVariables>(AdminResetAllChallengeParticipantsUsageDocument, options);
      }
export type AdminResetAllChallengeParticipantsUsageMutationHookResult = ReturnType<typeof useAdminResetAllChallengeParticipantsUsageMutation>;
export type AdminResetAllChallengeParticipantsUsageMutationResult = Apollo.MutationResult<AdminResetAllChallengeParticipantsUsageMutation>;
export type AdminResetAllChallengeParticipantsUsageMutationOptions = Apollo.BaseMutationOptions<AdminResetAllChallengeParticipantsUsageMutation, AdminResetAllChallengeParticipantsUsageMutationVariables>;
export const AdminCreateChallengeRankingDocument = gql`
    mutation AdminCreateChallengeRanking($challengeId: ID!, $input: AdminChallengeRankingCreateInput!) {
  adminCreateChallengeRanking(challengeId: $challengeId, input: $input) {
    id
    name
    timezone
    is_consolidated
    admin_validated
    consolidated_at
    ranking_data
  }
}
    `;
export type AdminCreateChallengeRankingMutationFn = Apollo.MutationFunction<AdminCreateChallengeRankingMutation, AdminCreateChallengeRankingMutationVariables>;

/**
 * __useAdminCreateChallengeRankingMutation__
 *
 * To run a mutation, you first call `useAdminCreateChallengeRankingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminCreateChallengeRankingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminCreateChallengeRankingMutation, { data, loading, error }] = useAdminCreateChallengeRankingMutation({
 *   variables: {
 *      challengeId: // value for 'challengeId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdminCreateChallengeRankingMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AdminCreateChallengeRankingMutation, AdminCreateChallengeRankingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AdminCreateChallengeRankingMutation, AdminCreateChallengeRankingMutationVariables>(AdminCreateChallengeRankingDocument, options);
      }
export type AdminCreateChallengeRankingMutationHookResult = ReturnType<typeof useAdminCreateChallengeRankingMutation>;
export type AdminCreateChallengeRankingMutationResult = Apollo.MutationResult<AdminCreateChallengeRankingMutation>;
export type AdminCreateChallengeRankingMutationOptions = Apollo.BaseMutationOptions<AdminCreateChallengeRankingMutation, AdminCreateChallengeRankingMutationVariables>;
export const AdminUpdateChallengeRankingDocument = gql`
    mutation AdminUpdateChallengeRanking($id: ID!, $input: AdminChallengeRankingUpdateInput!) {
  adminUpdateChallengeRanking(id: $id, input: $input) {
    id
    name
    timezone
    is_consolidated
    admin_validated
    consolidated_at
    ranking_data
  }
}
    `;
export type AdminUpdateChallengeRankingMutationFn = Apollo.MutationFunction<AdminUpdateChallengeRankingMutation, AdminUpdateChallengeRankingMutationVariables>;

/**
 * __useAdminUpdateChallengeRankingMutation__
 *
 * To run a mutation, you first call `useAdminUpdateChallengeRankingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminUpdateChallengeRankingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminUpdateChallengeRankingMutation, { data, loading, error }] = useAdminUpdateChallengeRankingMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdminUpdateChallengeRankingMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AdminUpdateChallengeRankingMutation, AdminUpdateChallengeRankingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AdminUpdateChallengeRankingMutation, AdminUpdateChallengeRankingMutationVariables>(AdminUpdateChallengeRankingDocument, options);
      }
export type AdminUpdateChallengeRankingMutationHookResult = ReturnType<typeof useAdminUpdateChallengeRankingMutation>;
export type AdminUpdateChallengeRankingMutationResult = Apollo.MutationResult<AdminUpdateChallengeRankingMutation>;
export type AdminUpdateChallengeRankingMutationOptions = Apollo.BaseMutationOptions<AdminUpdateChallengeRankingMutation, AdminUpdateChallengeRankingMutationVariables>;
export const AdminDeleteChallengeRankingDocument = gql`
    mutation AdminDeleteChallengeRanking($id: ID!) {
  adminDeleteChallengeRanking(id: $id)
}
    `;
export type AdminDeleteChallengeRankingMutationFn = Apollo.MutationFunction<AdminDeleteChallengeRankingMutation, AdminDeleteChallengeRankingMutationVariables>;

/**
 * __useAdminDeleteChallengeRankingMutation__
 *
 * To run a mutation, you first call `useAdminDeleteChallengeRankingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminDeleteChallengeRankingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminDeleteChallengeRankingMutation, { data, loading, error }] = useAdminDeleteChallengeRankingMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAdminDeleteChallengeRankingMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AdminDeleteChallengeRankingMutation, AdminDeleteChallengeRankingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AdminDeleteChallengeRankingMutation, AdminDeleteChallengeRankingMutationVariables>(AdminDeleteChallengeRankingDocument, options);
      }
export type AdminDeleteChallengeRankingMutationHookResult = ReturnType<typeof useAdminDeleteChallengeRankingMutation>;
export type AdminDeleteChallengeRankingMutationResult = Apollo.MutationResult<AdminDeleteChallengeRankingMutation>;
export type AdminDeleteChallengeRankingMutationOptions = Apollo.BaseMutationOptions<AdminDeleteChallengeRankingMutation, AdminDeleteChallengeRankingMutationVariables>;
export const AdminValidateRankingDocument = gql`
    mutation AdminValidateRanking($id: ID!, $validated: Boolean!) {
  adminValidateRanking(id: $id, validated: $validated) {
    id
    name
    timezone
    is_consolidated
    admin_validated
    consolidated_at
    ranking_data
    start_date
    end_date
  }
}
    `;
export type AdminValidateRankingMutationFn = Apollo.MutationFunction<AdminValidateRankingMutation, AdminValidateRankingMutationVariables>;

/**
 * __useAdminValidateRankingMutation__
 *
 * To run a mutation, you first call `useAdminValidateRankingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminValidateRankingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminValidateRankingMutation, { data, loading, error }] = useAdminValidateRankingMutation({
 *   variables: {
 *      id: // value for 'id'
 *      validated: // value for 'validated'
 *   },
 * });
 */
export function useAdminValidateRankingMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AdminValidateRankingMutation, AdminValidateRankingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AdminValidateRankingMutation, AdminValidateRankingMutationVariables>(AdminValidateRankingDocument, options);
      }
export type AdminValidateRankingMutationHookResult = ReturnType<typeof useAdminValidateRankingMutation>;
export type AdminValidateRankingMutationResult = Apollo.MutationResult<AdminValidateRankingMutation>;
export type AdminValidateRankingMutationOptions = Apollo.BaseMutationOptions<AdminValidateRankingMutation, AdminValidateRankingMutationVariables>;
export const AdminChallengeClipsDocument = gql`
    query AdminChallengeClips($challengeId: ID!, $page: Int, $pageSize: Int, $search: String, $approval: String, $validated_hashtags: String) {
  adminChallengeClips(
    challengeId: $challengeId
    page: $page
    pageSize: $pageSize
    search: $search
    approval: $approval
    validated_hashtags: $validated_hashtags
  ) {
    data {
      id
      platform
      url
      total_views
      admin_approval
      approval_reason
      validated_hashtags
      participant_id
      participant_user_name
      participant_user_email
      createdAt
    }
    page
    pageSize
    pageCount
    total
  }
}
    `;

/**
 * __useAdminChallengeClipsQuery__
 *
 * To run a query within a React component, call `useAdminChallengeClipsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminChallengeClipsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminChallengeClipsQuery({
 *   variables: {
 *      challengeId: // value for 'challengeId'
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *      search: // value for 'search'
 *      approval: // value for 'approval'
 *      validated_hashtags: // value for 'validated_hashtags'
 *   },
 * });
 */
export function useAdminChallengeClipsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<AdminChallengeClipsQuery, AdminChallengeClipsQueryVariables> & ({ variables: AdminChallengeClipsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AdminChallengeClipsQuery, AdminChallengeClipsQueryVariables>(AdminChallengeClipsDocument, options);
      }
export function useAdminChallengeClipsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AdminChallengeClipsQuery, AdminChallengeClipsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AdminChallengeClipsQuery, AdminChallengeClipsQueryVariables>(AdminChallengeClipsDocument, options);
        }
// @ts-ignore
export function useAdminChallengeClipsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<AdminChallengeClipsQuery, AdminChallengeClipsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AdminChallengeClipsQuery, AdminChallengeClipsQueryVariables>;
export function useAdminChallengeClipsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AdminChallengeClipsQuery, AdminChallengeClipsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AdminChallengeClipsQuery | undefined, AdminChallengeClipsQueryVariables>;
export function useAdminChallengeClipsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AdminChallengeClipsQuery, AdminChallengeClipsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<AdminChallengeClipsQuery, AdminChallengeClipsQueryVariables>(AdminChallengeClipsDocument, options);
        }
export type AdminChallengeClipsQueryHookResult = ReturnType<typeof useAdminChallengeClipsQuery>;
export type AdminChallengeClipsLazyQueryHookResult = ReturnType<typeof useAdminChallengeClipsLazyQuery>;
export type AdminChallengeClipsSuspenseQueryHookResult = ReturnType<typeof useAdminChallengeClipsSuspenseQuery>;
export type AdminChallengeClipsQueryResult = Apollo.QueryResult<AdminChallengeClipsQuery, AdminChallengeClipsQueryVariables>;
export const AdminSetChallengeClipApprovalDocument = gql`
    mutation AdminSetChallengeClipApproval($id: ID!, $approval: String!, $reason: String) {
  adminSetChallengeClipApproval(id: $id, approval: $approval, reason: $reason)
}
    `;
export type AdminSetChallengeClipApprovalMutationFn = Apollo.MutationFunction<AdminSetChallengeClipApprovalMutation, AdminSetChallengeClipApprovalMutationVariables>;

/**
 * __useAdminSetChallengeClipApprovalMutation__
 *
 * To run a mutation, you first call `useAdminSetChallengeClipApprovalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminSetChallengeClipApprovalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminSetChallengeClipApprovalMutation, { data, loading, error }] = useAdminSetChallengeClipApprovalMutation({
 *   variables: {
 *      id: // value for 'id'
 *      approval: // value for 'approval'
 *      reason: // value for 'reason'
 *   },
 * });
 */
export function useAdminSetChallengeClipApprovalMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AdminSetChallengeClipApprovalMutation, AdminSetChallengeClipApprovalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AdminSetChallengeClipApprovalMutation, AdminSetChallengeClipApprovalMutationVariables>(AdminSetChallengeClipApprovalDocument, options);
      }
export type AdminSetChallengeClipApprovalMutationHookResult = ReturnType<typeof useAdminSetChallengeClipApprovalMutation>;
export type AdminSetChallengeClipApprovalMutationResult = Apollo.MutationResult<AdminSetChallengeClipApprovalMutation>;
export type AdminSetChallengeClipApprovalMutationOptions = Apollo.BaseMutationOptions<AdminSetChallengeClipApprovalMutation, AdminSetChallengeClipApprovalMutationVariables>;
export const AdminSetChallengeClipHashtagValidationDocument = gql`
    mutation AdminSetChallengeClipHashtagValidation($id: ID!, $validated_hashtags: String!) {
  adminSetChallengeClipHashtagValidation(
    id: $id
    validated_hashtags: $validated_hashtags
  )
}
    `;
export type AdminSetChallengeClipHashtagValidationMutationFn = Apollo.MutationFunction<AdminSetChallengeClipHashtagValidationMutation, AdminSetChallengeClipHashtagValidationMutationVariables>;

/**
 * __useAdminSetChallengeClipHashtagValidationMutation__
 *
 * To run a mutation, you first call `useAdminSetChallengeClipHashtagValidationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminSetChallengeClipHashtagValidationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminSetChallengeClipHashtagValidationMutation, { data, loading, error }] = useAdminSetChallengeClipHashtagValidationMutation({
 *   variables: {
 *      id: // value for 'id'
 *      validated_hashtags: // value for 'validated_hashtags'
 *   },
 * });
 */
export function useAdminSetChallengeClipHashtagValidationMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AdminSetChallengeClipHashtagValidationMutation, AdminSetChallengeClipHashtagValidationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AdminSetChallengeClipHashtagValidationMutation, AdminSetChallengeClipHashtagValidationMutationVariables>(AdminSetChallengeClipHashtagValidationDocument, options);
      }
export type AdminSetChallengeClipHashtagValidationMutationHookResult = ReturnType<typeof useAdminSetChallengeClipHashtagValidationMutation>;
export type AdminSetChallengeClipHashtagValidationMutationResult = Apollo.MutationResult<AdminSetChallengeClipHashtagValidationMutation>;
export type AdminSetChallengeClipHashtagValidationMutationOptions = Apollo.BaseMutationOptions<AdminSetChallengeClipHashtagValidationMutation, AdminSetChallengeClipHashtagValidationMutationVariables>;
export const AdminRankingSnapshotsDocument = gql`
    query AdminRankingSnapshots($rankingId: ID!) {
  adminRankingSnapshots(rankingId: $rankingId) {
    ranking_id
    ranking_name
    start_views {
      snapshot_view_id
      clip_id
      clip_url
      clip_platform
      participant_name
      participant_id
      views
    }
    end_views {
      snapshot_view_id
      clip_id
      clip_url
      clip_platform
      participant_name
      participant_id
      views
    }
  }
}
    `;

/**
 * __useAdminRankingSnapshotsQuery__
 *
 * To run a query within a React component, call `useAdminRankingSnapshotsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminRankingSnapshotsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminRankingSnapshotsQuery({
 *   variables: {
 *      rankingId: // value for 'rankingId'
 *   },
 * });
 */
export function useAdminRankingSnapshotsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<AdminRankingSnapshotsQuery, AdminRankingSnapshotsQueryVariables> & ({ variables: AdminRankingSnapshotsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AdminRankingSnapshotsQuery, AdminRankingSnapshotsQueryVariables>(AdminRankingSnapshotsDocument, options);
      }
export function useAdminRankingSnapshotsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AdminRankingSnapshotsQuery, AdminRankingSnapshotsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AdminRankingSnapshotsQuery, AdminRankingSnapshotsQueryVariables>(AdminRankingSnapshotsDocument, options);
        }
// @ts-ignore
export function useAdminRankingSnapshotsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<AdminRankingSnapshotsQuery, AdminRankingSnapshotsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AdminRankingSnapshotsQuery, AdminRankingSnapshotsQueryVariables>;
export function useAdminRankingSnapshotsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AdminRankingSnapshotsQuery, AdminRankingSnapshotsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AdminRankingSnapshotsQuery | undefined, AdminRankingSnapshotsQueryVariables>;
export function useAdminRankingSnapshotsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AdminRankingSnapshotsQuery, AdminRankingSnapshotsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<AdminRankingSnapshotsQuery, AdminRankingSnapshotsQueryVariables>(AdminRankingSnapshotsDocument, options);
        }
export type AdminRankingSnapshotsQueryHookResult = ReturnType<typeof useAdminRankingSnapshotsQuery>;
export type AdminRankingSnapshotsLazyQueryHookResult = ReturnType<typeof useAdminRankingSnapshotsLazyQuery>;
export type AdminRankingSnapshotsSuspenseQueryHookResult = ReturnType<typeof useAdminRankingSnapshotsSuspenseQuery>;
export type AdminRankingSnapshotsQueryResult = Apollo.QueryResult<AdminRankingSnapshotsQuery, AdminRankingSnapshotsQueryVariables>;
export const AdminPartialRankingByDateRangeDocument = gql`
    query AdminPartialRankingByDateRange($challengeId: ID!, $startDate: String, $endDate: String, $timezone: String) {
  adminPartialRankingByDateRange(
    challengeId: $challengeId
    startDate: $startDate
    endDate: $endDate
    timezone: $timezone
  ) {
    entries {
      participation_id
      user_name
      clip_count
      total_views
    }
    clips_without_views {
      clip_id
      clip_url
      participant_name
      missing
    }
    start_date_used
    end_date_used
  }
}
    `;

/**
 * __useAdminPartialRankingByDateRangeQuery__
 *
 * To run a query within a React component, call `useAdminPartialRankingByDateRangeQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminPartialRankingByDateRangeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminPartialRankingByDateRangeQuery({
 *   variables: {
 *      challengeId: // value for 'challengeId'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      timezone: // value for 'timezone'
 *   },
 * });
 */
export function useAdminPartialRankingByDateRangeQuery(baseOptions: ApolloReactHooks.QueryHookOptions<AdminPartialRankingByDateRangeQuery, AdminPartialRankingByDateRangeQueryVariables> & ({ variables: AdminPartialRankingByDateRangeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AdminPartialRankingByDateRangeQuery, AdminPartialRankingByDateRangeQueryVariables>(AdminPartialRankingByDateRangeDocument, options);
      }
export function useAdminPartialRankingByDateRangeLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AdminPartialRankingByDateRangeQuery, AdminPartialRankingByDateRangeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AdminPartialRankingByDateRangeQuery, AdminPartialRankingByDateRangeQueryVariables>(AdminPartialRankingByDateRangeDocument, options);
        }
// @ts-ignore
export function useAdminPartialRankingByDateRangeSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<AdminPartialRankingByDateRangeQuery, AdminPartialRankingByDateRangeQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AdminPartialRankingByDateRangeQuery, AdminPartialRankingByDateRangeQueryVariables>;
export function useAdminPartialRankingByDateRangeSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AdminPartialRankingByDateRangeQuery, AdminPartialRankingByDateRangeQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AdminPartialRankingByDateRangeQuery | undefined, AdminPartialRankingByDateRangeQueryVariables>;
export function useAdminPartialRankingByDateRangeSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AdminPartialRankingByDateRangeQuery, AdminPartialRankingByDateRangeQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<AdminPartialRankingByDateRangeQuery, AdminPartialRankingByDateRangeQueryVariables>(AdminPartialRankingByDateRangeDocument, options);
        }
export type AdminPartialRankingByDateRangeQueryHookResult = ReturnType<typeof useAdminPartialRankingByDateRangeQuery>;
export type AdminPartialRankingByDateRangeLazyQueryHookResult = ReturnType<typeof useAdminPartialRankingByDateRangeLazyQuery>;
export type AdminPartialRankingByDateRangeSuspenseQueryHookResult = ReturnType<typeof useAdminPartialRankingByDateRangeSuspenseQuery>;
export type AdminPartialRankingByDateRangeQueryResult = Apollo.QueryResult<AdminPartialRankingByDateRangeQuery, AdminPartialRankingByDateRangeQueryVariables>;
export const AdminChallengeViewsTimeSeriesDocument = gql`
    query AdminChallengeViewsTimeSeries($challengeId: ID!, $days: Int) {
  adminChallengeViewsTimeSeries(challengeId: $challengeId, days: $days) {
    date
    total_views
    clip_count
  }
}
    `;

/**
 * __useAdminChallengeViewsTimeSeriesQuery__
 *
 * To run a query within a React component, call `useAdminChallengeViewsTimeSeriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminChallengeViewsTimeSeriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminChallengeViewsTimeSeriesQuery({
 *   variables: {
 *      challengeId: // value for 'challengeId'
 *      days: // value for 'days'
 *   },
 * });
 */
export function useAdminChallengeViewsTimeSeriesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<AdminChallengeViewsTimeSeriesQuery, AdminChallengeViewsTimeSeriesQueryVariables> & ({ variables: AdminChallengeViewsTimeSeriesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AdminChallengeViewsTimeSeriesQuery, AdminChallengeViewsTimeSeriesQueryVariables>(AdminChallengeViewsTimeSeriesDocument, options);
      }
export function useAdminChallengeViewsTimeSeriesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AdminChallengeViewsTimeSeriesQuery, AdminChallengeViewsTimeSeriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AdminChallengeViewsTimeSeriesQuery, AdminChallengeViewsTimeSeriesQueryVariables>(AdminChallengeViewsTimeSeriesDocument, options);
        }
// @ts-ignore
export function useAdminChallengeViewsTimeSeriesSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<AdminChallengeViewsTimeSeriesQuery, AdminChallengeViewsTimeSeriesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AdminChallengeViewsTimeSeriesQuery, AdminChallengeViewsTimeSeriesQueryVariables>;
export function useAdminChallengeViewsTimeSeriesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AdminChallengeViewsTimeSeriesQuery, AdminChallengeViewsTimeSeriesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AdminChallengeViewsTimeSeriesQuery | undefined, AdminChallengeViewsTimeSeriesQueryVariables>;
export function useAdminChallengeViewsTimeSeriesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AdminChallengeViewsTimeSeriesQuery, AdminChallengeViewsTimeSeriesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<AdminChallengeViewsTimeSeriesQuery, AdminChallengeViewsTimeSeriesQueryVariables>(AdminChallengeViewsTimeSeriesDocument, options);
        }
export type AdminChallengeViewsTimeSeriesQueryHookResult = ReturnType<typeof useAdminChallengeViewsTimeSeriesQuery>;
export type AdminChallengeViewsTimeSeriesLazyQueryHookResult = ReturnType<typeof useAdminChallengeViewsTimeSeriesLazyQuery>;
export type AdminChallengeViewsTimeSeriesSuspenseQueryHookResult = ReturnType<typeof useAdminChallengeViewsTimeSeriesSuspenseQuery>;
export type AdminChallengeViewsTimeSeriesQueryResult = Apollo.QueryResult<AdminChallengeViewsTimeSeriesQuery, AdminChallengeViewsTimeSeriesQueryVariables>;
export const AdminForceStartSnapshotDocument = gql`
    mutation AdminForceStartSnapshot($rankingId: ID!) {
  adminForceStartSnapshot(rankingId: $rankingId) {
    id
    name
    start_snapshotted_at
    end_snapshotted_at
  }
}
    `;
export type AdminForceStartSnapshotMutationFn = Apollo.MutationFunction<AdminForceStartSnapshotMutation, AdminForceStartSnapshotMutationVariables>;

/**
 * __useAdminForceStartSnapshotMutation__
 *
 * To run a mutation, you first call `useAdminForceStartSnapshotMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminForceStartSnapshotMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminForceStartSnapshotMutation, { data, loading, error }] = useAdminForceStartSnapshotMutation({
 *   variables: {
 *      rankingId: // value for 'rankingId'
 *   },
 * });
 */
export function useAdminForceStartSnapshotMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AdminForceStartSnapshotMutation, AdminForceStartSnapshotMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AdminForceStartSnapshotMutation, AdminForceStartSnapshotMutationVariables>(AdminForceStartSnapshotDocument, options);
      }
export type AdminForceStartSnapshotMutationHookResult = ReturnType<typeof useAdminForceStartSnapshotMutation>;
export type AdminForceStartSnapshotMutationResult = Apollo.MutationResult<AdminForceStartSnapshotMutation>;
export type AdminForceStartSnapshotMutationOptions = Apollo.BaseMutationOptions<AdminForceStartSnapshotMutation, AdminForceStartSnapshotMutationVariables>;
export const AdminForceConsolidationDocument = gql`
    mutation AdminForceConsolidation($rankingId: ID!) {
  adminForceConsolidation(rankingId: $rankingId) {
    id
    name
    is_consolidated
    consolidated_at
    ranking_data
    start_snapshotted_at
    end_snapshotted_at
  }
}
    `;
export type AdminForceConsolidationMutationFn = Apollo.MutationFunction<AdminForceConsolidationMutation, AdminForceConsolidationMutationVariables>;

/**
 * __useAdminForceConsolidationMutation__
 *
 * To run a mutation, you first call `useAdminForceConsolidationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminForceConsolidationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminForceConsolidationMutation, { data, loading, error }] = useAdminForceConsolidationMutation({
 *   variables: {
 *      rankingId: // value for 'rankingId'
 *   },
 * });
 */
export function useAdminForceConsolidationMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AdminForceConsolidationMutation, AdminForceConsolidationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AdminForceConsolidationMutation, AdminForceConsolidationMutationVariables>(AdminForceConsolidationDocument, options);
      }
export type AdminForceConsolidationMutationHookResult = ReturnType<typeof useAdminForceConsolidationMutation>;
export type AdminForceConsolidationMutationResult = Apollo.MutationResult<AdminForceConsolidationMutation>;
export type AdminForceConsolidationMutationOptions = Apollo.BaseMutationOptions<AdminForceConsolidationMutation, AdminForceConsolidationMutationVariables>;
export const AdminUpdateSnapshotViewDocument = gql`
    mutation AdminUpdateSnapshotView($id: ID!, $views: String!) {
  adminUpdateSnapshotView(id: $id, views: $views)
}
    `;
export type AdminUpdateSnapshotViewMutationFn = Apollo.MutationFunction<AdminUpdateSnapshotViewMutation, AdminUpdateSnapshotViewMutationVariables>;

/**
 * __useAdminUpdateSnapshotViewMutation__
 *
 * To run a mutation, you first call `useAdminUpdateSnapshotViewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminUpdateSnapshotViewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminUpdateSnapshotViewMutation, { data, loading, error }] = useAdminUpdateSnapshotViewMutation({
 *   variables: {
 *      id: // value for 'id'
 *      views: // value for 'views'
 *   },
 * });
 */
export function useAdminUpdateSnapshotViewMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AdminUpdateSnapshotViewMutation, AdminUpdateSnapshotViewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AdminUpdateSnapshotViewMutation, AdminUpdateSnapshotViewMutationVariables>(AdminUpdateSnapshotViewDocument, options);
      }
export type AdminUpdateSnapshotViewMutationHookResult = ReturnType<typeof useAdminUpdateSnapshotViewMutation>;
export type AdminUpdateSnapshotViewMutationResult = Apollo.MutationResult<AdminUpdateSnapshotViewMutation>;
export type AdminUpdateSnapshotViewMutationOptions = Apollo.BaseMutationOptions<AdminUpdateSnapshotViewMutation, AdminUpdateSnapshotViewMutationVariables>;
export const AdminCreateManualClipViewDocument = gql`
    mutation AdminCreateManualClipView($clipId: ID!, $views: String!, $date: String) {
  adminCreateManualClipView(clipId: $clipId, views: $views, date: $date)
}
    `;
export type AdminCreateManualClipViewMutationFn = Apollo.MutationFunction<AdminCreateManualClipViewMutation, AdminCreateManualClipViewMutationVariables>;

/**
 * __useAdminCreateManualClipViewMutation__
 *
 * To run a mutation, you first call `useAdminCreateManualClipViewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminCreateManualClipViewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminCreateManualClipViewMutation, { data, loading, error }] = useAdminCreateManualClipViewMutation({
 *   variables: {
 *      clipId: // value for 'clipId'
 *      views: // value for 'views'
 *      date: // value for 'date'
 *   },
 * });
 */
export function useAdminCreateManualClipViewMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AdminCreateManualClipViewMutation, AdminCreateManualClipViewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AdminCreateManualClipViewMutation, AdminCreateManualClipViewMutationVariables>(AdminCreateManualClipViewDocument, options);
      }
export type AdminCreateManualClipViewMutationHookResult = ReturnType<typeof useAdminCreateManualClipViewMutation>;
export type AdminCreateManualClipViewMutationResult = Apollo.MutationResult<AdminCreateManualClipViewMutation>;
export type AdminCreateManualClipViewMutationOptions = Apollo.BaseMutationOptions<AdminCreateManualClipViewMutation, AdminCreateManualClipViewMutationVariables>;
export const AdminForceUpdateAllChallengeClipViewsDocument = gql`
    mutation AdminForceUpdateAllChallengeClipViews($challengeId: ID!) {
  adminForceUpdateAllChallengeClipViews(challengeId: $challengeId)
}
    `;
export type AdminForceUpdateAllChallengeClipViewsMutationFn = Apollo.MutationFunction<AdminForceUpdateAllChallengeClipViewsMutation, AdminForceUpdateAllChallengeClipViewsMutationVariables>;

/**
 * __useAdminForceUpdateAllChallengeClipViewsMutation__
 *
 * To run a mutation, you first call `useAdminForceUpdateAllChallengeClipViewsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminForceUpdateAllChallengeClipViewsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminForceUpdateAllChallengeClipViewsMutation, { data, loading, error }] = useAdminForceUpdateAllChallengeClipViewsMutation({
 *   variables: {
 *      challengeId: // value for 'challengeId'
 *   },
 * });
 */
export function useAdminForceUpdateAllChallengeClipViewsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AdminForceUpdateAllChallengeClipViewsMutation, AdminForceUpdateAllChallengeClipViewsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AdminForceUpdateAllChallengeClipViewsMutation, AdminForceUpdateAllChallengeClipViewsMutationVariables>(AdminForceUpdateAllChallengeClipViewsDocument, options);
      }
export type AdminForceUpdateAllChallengeClipViewsMutationHookResult = ReturnType<typeof useAdminForceUpdateAllChallengeClipViewsMutation>;
export type AdminForceUpdateAllChallengeClipViewsMutationResult = Apollo.MutationResult<AdminForceUpdateAllChallengeClipViewsMutation>;
export type AdminForceUpdateAllChallengeClipViewsMutationOptions = Apollo.BaseMutationOptions<AdminForceUpdateAllChallengeClipViewsMutation, AdminForceUpdateAllChallengeClipViewsMutationVariables>;
export const AdminSyncMissingChallengeClipViewsDocument = gql`
    mutation AdminSyncMissingChallengeClipViews($challengeId: ID!) {
  adminSyncMissingChallengeClipViews(challengeId: $challengeId)
}
    `;
export type AdminSyncMissingChallengeClipViewsMutationFn = Apollo.MutationFunction<AdminSyncMissingChallengeClipViewsMutation, AdminSyncMissingChallengeClipViewsMutationVariables>;

/**
 * __useAdminSyncMissingChallengeClipViewsMutation__
 *
 * To run a mutation, you first call `useAdminSyncMissingChallengeClipViewsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminSyncMissingChallengeClipViewsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminSyncMissingChallengeClipViewsMutation, { data, loading, error }] = useAdminSyncMissingChallengeClipViewsMutation({
 *   variables: {
 *      challengeId: // value for 'challengeId'
 *   },
 * });
 */
export function useAdminSyncMissingChallengeClipViewsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AdminSyncMissingChallengeClipViewsMutation, AdminSyncMissingChallengeClipViewsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AdminSyncMissingChallengeClipViewsMutation, AdminSyncMissingChallengeClipViewsMutationVariables>(AdminSyncMissingChallengeClipViewsDocument, options);
      }
export type AdminSyncMissingChallengeClipViewsMutationHookResult = ReturnType<typeof useAdminSyncMissingChallengeClipViewsMutation>;
export type AdminSyncMissingChallengeClipViewsMutationResult = Apollo.MutationResult<AdminSyncMissingChallengeClipViewsMutation>;
export type AdminSyncMissingChallengeClipViewsMutationOptions = Apollo.BaseMutationOptions<AdminSyncMissingChallengeClipViewsMutation, AdminSyncMissingChallengeClipViewsMutationVariables>;
export const AdminForceUpdateChallengeClipViewsDocument = gql`
    mutation AdminForceUpdateChallengeClipViews($clipIds: [ID!]!) {
  adminForceUpdateChallengeClipViews(clipIds: $clipIds)
}
    `;
export type AdminForceUpdateChallengeClipViewsMutationFn = Apollo.MutationFunction<AdminForceUpdateChallengeClipViewsMutation, AdminForceUpdateChallengeClipViewsMutationVariables>;

/**
 * __useAdminForceUpdateChallengeClipViewsMutation__
 *
 * To run a mutation, you first call `useAdminForceUpdateChallengeClipViewsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminForceUpdateChallengeClipViewsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminForceUpdateChallengeClipViewsMutation, { data, loading, error }] = useAdminForceUpdateChallengeClipViewsMutation({
 *   variables: {
 *      clipIds: // value for 'clipIds'
 *   },
 * });
 */
export function useAdminForceUpdateChallengeClipViewsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AdminForceUpdateChallengeClipViewsMutation, AdminForceUpdateChallengeClipViewsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AdminForceUpdateChallengeClipViewsMutation, AdminForceUpdateChallengeClipViewsMutationVariables>(AdminForceUpdateChallengeClipViewsDocument, options);
      }
export type AdminForceUpdateChallengeClipViewsMutationHookResult = ReturnType<typeof useAdminForceUpdateChallengeClipViewsMutation>;
export type AdminForceUpdateChallengeClipViewsMutationResult = Apollo.MutationResult<AdminForceUpdateChallengeClipViewsMutation>;
export type AdminForceUpdateChallengeClipViewsMutationOptions = Apollo.BaseMutationOptions<AdminForceUpdateChallengeClipViewsMutation, AdminForceUpdateChallengeClipViewsMutationVariables>;
export const AdminForceUpdateChallengeClipViewDocument = gql`
    mutation AdminForceUpdateChallengeClipView($clipId: ID!) {
  adminForceUpdateChallengeClipView(clipId: $clipId)
}
    `;
export type AdminForceUpdateChallengeClipViewMutationFn = Apollo.MutationFunction<AdminForceUpdateChallengeClipViewMutation, AdminForceUpdateChallengeClipViewMutationVariables>;

/**
 * __useAdminForceUpdateChallengeClipViewMutation__
 *
 * To run a mutation, you first call `useAdminForceUpdateChallengeClipViewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminForceUpdateChallengeClipViewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminForceUpdateChallengeClipViewMutation, { data, loading, error }] = useAdminForceUpdateChallengeClipViewMutation({
 *   variables: {
 *      clipId: // value for 'clipId'
 *   },
 * });
 */
export function useAdminForceUpdateChallengeClipViewMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AdminForceUpdateChallengeClipViewMutation, AdminForceUpdateChallengeClipViewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AdminForceUpdateChallengeClipViewMutation, AdminForceUpdateChallengeClipViewMutationVariables>(AdminForceUpdateChallengeClipViewDocument, options);
      }
export type AdminForceUpdateChallengeClipViewMutationHookResult = ReturnType<typeof useAdminForceUpdateChallengeClipViewMutation>;
export type AdminForceUpdateChallengeClipViewMutationResult = Apollo.MutationResult<AdminForceUpdateChallengeClipViewMutation>;
export type AdminForceUpdateChallengeClipViewMutationOptions = Apollo.BaseMutationOptions<AdminForceUpdateChallengeClipViewMutation, AdminForceUpdateChallengeClipViewMutationVariables>;
export const CommunityLibrariesWithCampaignsDocument = gql`
query CommunityLibrariesWithCampaigns($limit: Int, $offset: Int, $search: String, $channelId: ID, $channelCategory: String, $sort: String, $tagId: ID, $language: String, $campaignId: ID) {
  communityLibraries(
    limit: $limit
    offset: $offset
    search: $search
    channelId: $channelId
    channelCategory: $channelCategory
    sort: $sort
    tagId: $tagId
    language: $language
    campaignId: $campaignId
  ) {
    id
    name
    curation_status
    base_video_url
    compressed_base_video_url
    original_video_url
    cut_video_url
    format
    language
    duration_seconds
    start_time
    end_time
    thumbnail_url
    youtube_video_id
    view_count
    upload_date
    remix_count
    windowed_remix_count
    createdAt
    created_by_user_name
    youtube_channels {
      channel_id
      name
      thumbnail
    }
    active_cpm_campaigns {
      campaign_type
      ranking_config
      id
      name
      cpm_rate_cents
      cpm_platform_rates {
        platform
        cpm_rate_cents
      }
      allowed_platforms
      currency
      budget_total_cents
      budget_remaining_cents
      budget_pending_cents
      invite_only
      selected_only
      my_approved_platforms
    }
  }
}
`;

/**
 * __useCommunityLibrariesWithCampaignsQuery__
 *
 * To run a query within a React component, call `useCommunityLibrariesWithCampaignsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCommunityLibrariesWithCampaignsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCommunityLibrariesWithCampaignsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      search: // value for 'search'
 *      channelId: // value for 'channelId'
 *      channelCategory: // value for 'channelCategory'
 *      sort: // value for 'sort'
 *      tagId: // value for 'tagId'
 *      language: // value for 'language'
 *      campaignId: // value for 'campaignId'
 *   },
 * });
 */
export function useCommunityLibrariesWithCampaignsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<CommunityLibrariesWithCampaignsQuery, CommunityLibrariesWithCampaignsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<CommunityLibrariesWithCampaignsQuery, CommunityLibrariesWithCampaignsQueryVariables>(CommunityLibrariesWithCampaignsDocument, options);
      }
export function useCommunityLibrariesWithCampaignsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CommunityLibrariesWithCampaignsQuery, CommunityLibrariesWithCampaignsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<CommunityLibrariesWithCampaignsQuery, CommunityLibrariesWithCampaignsQueryVariables>(CommunityLibrariesWithCampaignsDocument, options);
        }
// @ts-ignore
export function useCommunityLibrariesWithCampaignsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<CommunityLibrariesWithCampaignsQuery, CommunityLibrariesWithCampaignsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<CommunityLibrariesWithCampaignsQuery, CommunityLibrariesWithCampaignsQueryVariables>;
export function useCommunityLibrariesWithCampaignsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<CommunityLibrariesWithCampaignsQuery, CommunityLibrariesWithCampaignsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<CommunityLibrariesWithCampaignsQuery | undefined, CommunityLibrariesWithCampaignsQueryVariables>;
export function useCommunityLibrariesWithCampaignsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<CommunityLibrariesWithCampaignsQuery, CommunityLibrariesWithCampaignsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<CommunityLibrariesWithCampaignsQuery, CommunityLibrariesWithCampaignsQueryVariables>(CommunityLibrariesWithCampaignsDocument, options);
        }
export type CommunityLibrariesWithCampaignsQueryHookResult = ReturnType<typeof useCommunityLibrariesWithCampaignsQuery>;
export type CommunityLibrariesWithCampaignsLazyQueryHookResult = ReturnType<typeof useCommunityLibrariesWithCampaignsLazyQuery>;
export type CommunityLibrariesWithCampaignsSuspenseQueryHookResult = ReturnType<typeof useCommunityLibrariesWithCampaignsSuspenseQuery>;
export type CommunityLibrariesWithCampaignsQueryResult = Apollo.QueryResult<CommunityLibrariesWithCampaignsQuery, CommunityLibrariesWithCampaignsQueryVariables>;
export const MyCpmCampaignDocument = gql`
query MyCpmCampaign($id: ID!) {
  myCpmCampaign(id: $id) {
    campaign_type
    ranking_config
    id
    name
    description
    status
    start_date
    end_date
    currency
    banner_url
    categories
    cpm_rate_cents
    budget_total_cents
    budget_remaining_cents
    budget_pending_cents
    cpm_platform_rates {
      platform
      cpm_rate_cents
    }
    min_views_threshold
    min_payout_per_clipper_cents
    max_payout_per_clipper_cents
    max_payout_per_clip_cents
    view_accrual_window_hours
    required_hashtags
    required_mention
    min_clip_duration_seconds
    allowed_platforms
    rules_allowed
    rules_forbidden
    rules_attention
    rules_warning
    caption_examples
    enforced_post_layout
    requires_channel_approval
    invite_only
    selected_only
    is_selected_user
    editing_assets
    my_approved_platforms
    is_joined
    join_blocked_reason
    my_channel_requests {
      id
      platform
      submitted_url
      handle
      status
      review_reason
      reviewed_at
      createdAt
      youtube_channel {
        id
        name
        handle
        thumbnail
        subscriber_count
      }
    }
    youtube_channels {
      channel_id
      name
      thumbnail
    }
    library_projects {
      id
      name
      thumbnail_url
    }
    participating_libraries {
      id
      active_cpm_campaigns {
        id
      }
      name
      thumbnail_url
      duration_seconds
      aired_at
      view_count
      youtube_video_id
      youtube_download_id
      base_video_url
      original_video_url
      cut_video_url
      compressed_base_video_url
      format
      language
      start_time
      end_time
      youtube_channels {
        channel_id
        name
        thumbnail
      }
    }
    my_submissions {
      id
      platform
      url
      admin_approval
      validated_hashtags
      disqualified
      last_counted_views
      accumulated_payout_cents
      cpm_rate_override_cents
      last_view_sync_at
      latest_views
      payable_views
      approval_reason
      disqualification_reason
      admin_observation
      suspected_duplicate
      social_connection_id
      provider_media_id
      metrics_source
      metrics_status
      metrics_error
      disapproved_at
      pre_approval
      pre_approval_score
      pre_approval_at
      rules_check_failures
      estimated_payout_cents
      media_duration_seconds
      rules_check_missing_hashtags
      rules_check_missing_mentions
      appeal {
        id
        status
        argument
        extra_url
        evidence_image_urls
        reviewer_reply
        reviewer_images {
          url
          visibility
        }
        original_approval_reason
        createdAt
      }
      rejection_images {
        url
        visibility
      }
      createdAt
    }
    my_total_earnings_cents
  }
}
`;

/**
 * __useMyCpmCampaignQuery__
 *
 * To run a query within a React component, call `useMyCpmCampaignQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyCpmCampaignQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyCpmCampaignQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useMyCpmCampaignQuery(baseOptions: ApolloReactHooks.QueryHookOptions<MyCpmCampaignQuery, MyCpmCampaignQueryVariables> & ({ variables: MyCpmCampaignQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<MyCpmCampaignQuery, MyCpmCampaignQueryVariables>(MyCpmCampaignDocument, options);
      }
export function useMyCpmCampaignLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<MyCpmCampaignQuery, MyCpmCampaignQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<MyCpmCampaignQuery, MyCpmCampaignQueryVariables>(MyCpmCampaignDocument, options);
        }
// @ts-ignore
export function useMyCpmCampaignSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<MyCpmCampaignQuery, MyCpmCampaignQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<MyCpmCampaignQuery, MyCpmCampaignQueryVariables>;
export function useMyCpmCampaignSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<MyCpmCampaignQuery, MyCpmCampaignQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<MyCpmCampaignQuery | undefined, MyCpmCampaignQueryVariables>;
export function useMyCpmCampaignSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<MyCpmCampaignQuery, MyCpmCampaignQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<MyCpmCampaignQuery, MyCpmCampaignQueryVariables>(MyCpmCampaignDocument, options);
        }
export type MyCpmCampaignQueryHookResult = ReturnType<typeof useMyCpmCampaignQuery>;
export type MyCpmCampaignLazyQueryHookResult = ReturnType<typeof useMyCpmCampaignLazyQuery>;
export type MyCpmCampaignSuspenseQueryHookResult = ReturnType<typeof useMyCpmCampaignSuspenseQuery>;
export type MyCpmCampaignQueryResult = Apollo.QueryResult<MyCpmCampaignQuery, MyCpmCampaignQueryVariables>;
export const MySocialLinkingPlatformsDocument = gql`
    query MySocialLinkingPlatforms {
  mySocialLinkingPlatforms
}
    `;

/**
 * __useMySocialLinkingPlatformsQuery__
 *
 * To run a query within a React component, call `useMySocialLinkingPlatformsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMySocialLinkingPlatformsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMySocialLinkingPlatformsQuery({
 *   variables: {
 *   },
 * });
 */
export function useMySocialLinkingPlatformsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<MySocialLinkingPlatformsQuery, MySocialLinkingPlatformsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<MySocialLinkingPlatformsQuery, MySocialLinkingPlatformsQueryVariables>(MySocialLinkingPlatformsDocument, options);
      }
export function useMySocialLinkingPlatformsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<MySocialLinkingPlatformsQuery, MySocialLinkingPlatformsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<MySocialLinkingPlatformsQuery, MySocialLinkingPlatformsQueryVariables>(MySocialLinkingPlatformsDocument, options);
        }
// @ts-ignore
export function useMySocialLinkingPlatformsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<MySocialLinkingPlatformsQuery, MySocialLinkingPlatformsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<MySocialLinkingPlatformsQuery, MySocialLinkingPlatformsQueryVariables>;
export function useMySocialLinkingPlatformsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<MySocialLinkingPlatformsQuery, MySocialLinkingPlatformsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<MySocialLinkingPlatformsQuery | undefined, MySocialLinkingPlatformsQueryVariables>;
export function useMySocialLinkingPlatformsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<MySocialLinkingPlatformsQuery, MySocialLinkingPlatformsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<MySocialLinkingPlatformsQuery, MySocialLinkingPlatformsQueryVariables>(MySocialLinkingPlatformsDocument, options);
        }
export type MySocialLinkingPlatformsQueryHookResult = ReturnType<typeof useMySocialLinkingPlatformsQuery>;
export type MySocialLinkingPlatformsLazyQueryHookResult = ReturnType<typeof useMySocialLinkingPlatformsLazyQuery>;
export type MySocialLinkingPlatformsSuspenseQueryHookResult = ReturnType<typeof useMySocialLinkingPlatformsSuspenseQuery>;
export type MySocialLinkingPlatformsQueryResult = Apollo.QueryResult<MySocialLinkingPlatformsQuery, MySocialLinkingPlatformsQueryVariables>;
export const MySocialPostingPlatformsDocument = gql`
    query MySocialPostingPlatforms {
  mySocialPostingPlatforms
}
    `;

/**
 * __useMySocialPostingPlatformsQuery__
 *
 * To run a query within a React component, call `useMySocialPostingPlatformsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMySocialPostingPlatformsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMySocialPostingPlatformsQuery({
 *   variables: {
 *   },
 * });
 */
export function useMySocialPostingPlatformsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<MySocialPostingPlatformsQuery, MySocialPostingPlatformsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<MySocialPostingPlatformsQuery, MySocialPostingPlatformsQueryVariables>(MySocialPostingPlatformsDocument, options);
      }
export function useMySocialPostingPlatformsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<MySocialPostingPlatformsQuery, MySocialPostingPlatformsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<MySocialPostingPlatformsQuery, MySocialPostingPlatformsQueryVariables>(MySocialPostingPlatformsDocument, options);
        }
// @ts-ignore
export function useMySocialPostingPlatformsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<MySocialPostingPlatformsQuery, MySocialPostingPlatformsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<MySocialPostingPlatformsQuery, MySocialPostingPlatformsQueryVariables>;
export function useMySocialPostingPlatformsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<MySocialPostingPlatformsQuery, MySocialPostingPlatformsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<MySocialPostingPlatformsQuery | undefined, MySocialPostingPlatformsQueryVariables>;
export function useMySocialPostingPlatformsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<MySocialPostingPlatformsQuery, MySocialPostingPlatformsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<MySocialPostingPlatformsQuery, MySocialPostingPlatformsQueryVariables>(MySocialPostingPlatformsDocument, options);
        }
export type MySocialPostingPlatformsQueryHookResult = ReturnType<typeof useMySocialPostingPlatformsQuery>;
export type MySocialPostingPlatformsLazyQueryHookResult = ReturnType<typeof useMySocialPostingPlatformsLazyQuery>;
export type MySocialPostingPlatformsSuspenseQueryHookResult = ReturnType<typeof useMySocialPostingPlatformsSuspenseQuery>;
export type MySocialPostingPlatformsQueryResult = Apollo.QueryResult<MySocialPostingPlatformsQuery, MySocialPostingPlatformsQueryVariables>;
export const MySocialConnectionsDocument = gql`
    query MySocialConnections {
  mySocialConnections {
    id
    platform
    username
    display_name
    avatar_url
    status
    scopes
    access_expires_at
    last_synced_at
    createdAt
  }
}
    `;

/**
 * __useMySocialConnectionsQuery__
 *
 * To run a query within a React component, call `useMySocialConnectionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMySocialConnectionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMySocialConnectionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useMySocialConnectionsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<MySocialConnectionsQuery, MySocialConnectionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<MySocialConnectionsQuery, MySocialConnectionsQueryVariables>(MySocialConnectionsDocument, options);
      }
export function useMySocialConnectionsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<MySocialConnectionsQuery, MySocialConnectionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<MySocialConnectionsQuery, MySocialConnectionsQueryVariables>(MySocialConnectionsDocument, options);
        }
// @ts-ignore
export function useMySocialConnectionsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<MySocialConnectionsQuery, MySocialConnectionsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<MySocialConnectionsQuery, MySocialConnectionsQueryVariables>;
export function useMySocialConnectionsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<MySocialConnectionsQuery, MySocialConnectionsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<MySocialConnectionsQuery | undefined, MySocialConnectionsQueryVariables>;
export function useMySocialConnectionsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<MySocialConnectionsQuery, MySocialConnectionsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<MySocialConnectionsQuery, MySocialConnectionsQueryVariables>(MySocialConnectionsDocument, options);
        }
export type MySocialConnectionsQueryHookResult = ReturnType<typeof useMySocialConnectionsQuery>;
export type MySocialConnectionsLazyQueryHookResult = ReturnType<typeof useMySocialConnectionsLazyQuery>;
export type MySocialConnectionsSuspenseQueryHookResult = ReturnType<typeof useMySocialConnectionsSuspenseQuery>;
export type MySocialConnectionsQueryResult = Apollo.QueryResult<MySocialConnectionsQuery, MySocialConnectionsQueryVariables>;
export const ResolveMyCpmOwnedMediaDocument = gql`
    query ResolveMyCpmOwnedMedia($platform: String!, $url: String!) {
  resolveMyCpmOwnedMedia(platform: $platform, url: $url) {
    social_connection_id
    username
    provider_media_id
  }
}
    `;

/**
 * __useResolveMyCpmOwnedMediaQuery__
 *
 * To run a query within a React component, call `useResolveMyCpmOwnedMediaQuery` and pass it any options that fit your needs.
 * When your component renders, `useResolveMyCpmOwnedMediaQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useResolveMyCpmOwnedMediaQuery({
 *   variables: {
 *      platform: // value for 'platform'
 *      url: // value for 'url'
 *   },
 * });
 */
export function useResolveMyCpmOwnedMediaQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ResolveMyCpmOwnedMediaQuery, ResolveMyCpmOwnedMediaQueryVariables> & ({ variables: ResolveMyCpmOwnedMediaQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ResolveMyCpmOwnedMediaQuery, ResolveMyCpmOwnedMediaQueryVariables>(ResolveMyCpmOwnedMediaDocument, options);
      }
export function useResolveMyCpmOwnedMediaLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ResolveMyCpmOwnedMediaQuery, ResolveMyCpmOwnedMediaQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ResolveMyCpmOwnedMediaQuery, ResolveMyCpmOwnedMediaQueryVariables>(ResolveMyCpmOwnedMediaDocument, options);
        }
// @ts-ignore
export function useResolveMyCpmOwnedMediaSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ResolveMyCpmOwnedMediaQuery, ResolveMyCpmOwnedMediaQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ResolveMyCpmOwnedMediaQuery, ResolveMyCpmOwnedMediaQueryVariables>;
export function useResolveMyCpmOwnedMediaSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ResolveMyCpmOwnedMediaQuery, ResolveMyCpmOwnedMediaQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ResolveMyCpmOwnedMediaQuery | undefined, ResolveMyCpmOwnedMediaQueryVariables>;
export function useResolveMyCpmOwnedMediaSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ResolveMyCpmOwnedMediaQuery, ResolveMyCpmOwnedMediaQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ResolveMyCpmOwnedMediaQuery, ResolveMyCpmOwnedMediaQueryVariables>(ResolveMyCpmOwnedMediaDocument, options);
        }
export type ResolveMyCpmOwnedMediaQueryHookResult = ReturnType<typeof useResolveMyCpmOwnedMediaQuery>;
export type ResolveMyCpmOwnedMediaLazyQueryHookResult = ReturnType<typeof useResolveMyCpmOwnedMediaLazyQuery>;
export type ResolveMyCpmOwnedMediaSuspenseQueryHookResult = ReturnType<typeof useResolveMyCpmOwnedMediaSuspenseQuery>;
export type ResolveMyCpmOwnedMediaQueryResult = Apollo.QueryResult<ResolveMyCpmOwnedMediaQuery, ResolveMyCpmOwnedMediaQueryVariables>;
export const DisconnectMySocialConnectionDocument = gql`
    mutation DisconnectMySocialConnection($id: ID!) {
  disconnectMySocialConnection(id: $id)
}
    `;
export type DisconnectMySocialConnectionMutationFn = Apollo.MutationFunction<DisconnectMySocialConnectionMutation, DisconnectMySocialConnectionMutationVariables>;

/**
 * __useDisconnectMySocialConnectionMutation__
 *
 * To run a mutation, you first call `useDisconnectMySocialConnectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDisconnectMySocialConnectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [disconnectMySocialConnectionMutation, { data, loading, error }] = useDisconnectMySocialConnectionMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDisconnectMySocialConnectionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DisconnectMySocialConnectionMutation, DisconnectMySocialConnectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DisconnectMySocialConnectionMutation, DisconnectMySocialConnectionMutationVariables>(DisconnectMySocialConnectionDocument, options);
      }
export type DisconnectMySocialConnectionMutationHookResult = ReturnType<typeof useDisconnectMySocialConnectionMutation>;
export type DisconnectMySocialConnectionMutationResult = Apollo.MutationResult<DisconnectMySocialConnectionMutation>;
export type DisconnectMySocialConnectionMutationOptions = Apollo.BaseMutationOptions<DisconnectMySocialConnectionMutation, DisconnectMySocialConnectionMutationVariables>;
export const CreateMyCpmCampaignSubmissionDocument = gql`
    mutation CreateMyCpmCampaignSubmission($input: CreateMyCpmCampaignSubmissionInput!) {
  createMyCpmCampaignSubmission(input: $input) {
    id
    platform
    url
    admin_approval
    accumulated_payout_cents
    createdAt
  }
}
    `;
export type CreateMyCpmCampaignSubmissionMutationFn = Apollo.MutationFunction<CreateMyCpmCampaignSubmissionMutation, CreateMyCpmCampaignSubmissionMutationVariables>;

/**
 * __useCreateMyCpmCampaignSubmissionMutation__
 *
 * To run a mutation, you first call `useCreateMyCpmCampaignSubmissionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMyCpmCampaignSubmissionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMyCpmCampaignSubmissionMutation, { data, loading, error }] = useCreateMyCpmCampaignSubmissionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateMyCpmCampaignSubmissionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateMyCpmCampaignSubmissionMutation, CreateMyCpmCampaignSubmissionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateMyCpmCampaignSubmissionMutation, CreateMyCpmCampaignSubmissionMutationVariables>(CreateMyCpmCampaignSubmissionDocument, options);
      }
export type CreateMyCpmCampaignSubmissionMutationHookResult = ReturnType<typeof useCreateMyCpmCampaignSubmissionMutation>;
export type CreateMyCpmCampaignSubmissionMutationResult = Apollo.MutationResult<CreateMyCpmCampaignSubmissionMutation>;
export type CreateMyCpmCampaignSubmissionMutationOptions = Apollo.BaseMutationOptions<CreateMyCpmCampaignSubmissionMutation, CreateMyCpmCampaignSubmissionMutationVariables>;
export const DeleteMyCpmCampaignSubmissionDocument = gql`
    mutation DeleteMyCpmCampaignSubmission($id: ID!) {
  deleteMyCpmCampaignSubmission(id: $id)
}
    `;
export type DeleteMyCpmCampaignSubmissionMutationFn = Apollo.MutationFunction<DeleteMyCpmCampaignSubmissionMutation, DeleteMyCpmCampaignSubmissionMutationVariables>;

/**
 * __useDeleteMyCpmCampaignSubmissionMutation__
 *
 * To run a mutation, you first call `useDeleteMyCpmCampaignSubmissionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteMyCpmCampaignSubmissionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteMyCpmCampaignSubmissionMutation, { data, loading, error }] = useDeleteMyCpmCampaignSubmissionMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteMyCpmCampaignSubmissionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteMyCpmCampaignSubmissionMutation, DeleteMyCpmCampaignSubmissionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteMyCpmCampaignSubmissionMutation, DeleteMyCpmCampaignSubmissionMutationVariables>(DeleteMyCpmCampaignSubmissionDocument, options);
      }
export type DeleteMyCpmCampaignSubmissionMutationHookResult = ReturnType<typeof useDeleteMyCpmCampaignSubmissionMutation>;
export type DeleteMyCpmCampaignSubmissionMutationResult = Apollo.MutationResult<DeleteMyCpmCampaignSubmissionMutation>;
export type DeleteMyCpmCampaignSubmissionMutationOptions = Apollo.BaseMutationOptions<DeleteMyCpmCampaignSubmissionMutation, DeleteMyCpmCampaignSubmissionMutationVariables>;
export const CreateMyCpmCampaignSubmissionAppealDocument = gql`
    mutation CreateMyCpmCampaignSubmissionAppeal($submissionId: ID!, $argument: String!, $extraUrl: String, $evidenceImageUrls: [String!]) {
  createMyCpmCampaignSubmissionAppeal(
    submissionId: $submissionId
    argument: $argument
    extraUrl: $extraUrl
    evidenceImageUrls: $evidenceImageUrls
  ) {
    id
    status
    argument
    extra_url
    evidence_image_urls
    reviewer_reply
    reviewer_images {
      url
      visibility
    }
    createdAt
  }
}
    `;
export type CreateMyCpmCampaignSubmissionAppealMutationFn = Apollo.MutationFunction<CreateMyCpmCampaignSubmissionAppealMutation, CreateMyCpmCampaignSubmissionAppealMutationVariables>;

/**
 * __useCreateMyCpmCampaignSubmissionAppealMutation__
 *
 * To run a mutation, you first call `useCreateMyCpmCampaignSubmissionAppealMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMyCpmCampaignSubmissionAppealMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMyCpmCampaignSubmissionAppealMutation, { data, loading, error }] = useCreateMyCpmCampaignSubmissionAppealMutation({
 *   variables: {
 *      submissionId: // value for 'submissionId'
 *      argument: // value for 'argument'
 *      extraUrl: // value for 'extraUrl'
 *      evidenceImageUrls: // value for 'evidenceImageUrls'
 *   },
 * });
 */
export function useCreateMyCpmCampaignSubmissionAppealMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateMyCpmCampaignSubmissionAppealMutation, CreateMyCpmCampaignSubmissionAppealMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateMyCpmCampaignSubmissionAppealMutation, CreateMyCpmCampaignSubmissionAppealMutationVariables>(CreateMyCpmCampaignSubmissionAppealDocument, options);
      }
export type CreateMyCpmCampaignSubmissionAppealMutationHookResult = ReturnType<typeof useCreateMyCpmCampaignSubmissionAppealMutation>;
export type CreateMyCpmCampaignSubmissionAppealMutationResult = Apollo.MutationResult<CreateMyCpmCampaignSubmissionAppealMutation>;
export type CreateMyCpmCampaignSubmissionAppealMutationOptions = Apollo.BaseMutationOptions<CreateMyCpmCampaignSubmissionAppealMutation, CreateMyCpmCampaignSubmissionAppealMutationVariables>;
export const RespondToMyCpmCampaignSubmissionAppealDocument = gql`
    mutation RespondToMyCpmCampaignSubmissionAppeal($id: ID!, $argument: String!, $extraUrl: String, $evidenceImageUrls: [String!]) {
  respondToMyCpmCampaignSubmissionAppeal(
    id: $id
    argument: $argument
    extraUrl: $extraUrl
    evidenceImageUrls: $evidenceImageUrls
  ) {
    id
    status
    argument
    extra_url
    evidence_image_urls
    reviewer_reply
    reviewer_images {
      url
      visibility
    }
    createdAt
  }
}
    `;
export type RespondToMyCpmCampaignSubmissionAppealMutationFn = Apollo.MutationFunction<RespondToMyCpmCampaignSubmissionAppealMutation, RespondToMyCpmCampaignSubmissionAppealMutationVariables>;

/**
 * __useRespondToMyCpmCampaignSubmissionAppealMutation__
 *
 * To run a mutation, you first call `useRespondToMyCpmCampaignSubmissionAppealMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRespondToMyCpmCampaignSubmissionAppealMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [respondToMyCpmCampaignSubmissionAppealMutation, { data, loading, error }] = useRespondToMyCpmCampaignSubmissionAppealMutation({
 *   variables: {
 *      id: // value for 'id'
 *      argument: // value for 'argument'
 *      extraUrl: // value for 'extraUrl'
 *      evidenceImageUrls: // value for 'evidenceImageUrls'
 *   },
 * });
 */
export function useRespondToMyCpmCampaignSubmissionAppealMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<RespondToMyCpmCampaignSubmissionAppealMutation, RespondToMyCpmCampaignSubmissionAppealMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<RespondToMyCpmCampaignSubmissionAppealMutation, RespondToMyCpmCampaignSubmissionAppealMutationVariables>(RespondToMyCpmCampaignSubmissionAppealDocument, options);
      }
export type RespondToMyCpmCampaignSubmissionAppealMutationHookResult = ReturnType<typeof useRespondToMyCpmCampaignSubmissionAppealMutation>;
export type RespondToMyCpmCampaignSubmissionAppealMutationResult = Apollo.MutationResult<RespondToMyCpmCampaignSubmissionAppealMutation>;
export type RespondToMyCpmCampaignSubmissionAppealMutationOptions = Apollo.BaseMutationOptions<RespondToMyCpmCampaignSubmissionAppealMutation, RespondToMyCpmCampaignSubmissionAppealMutationVariables>;
export const JoinCpmCampaignDocument = gql`
    mutation JoinCpmCampaign($campaignId: ID!) {
  joinCpmCampaign(campaignId: $campaignId)
}
    `;
export type JoinCpmCampaignMutationFn = Apollo.MutationFunction<JoinCpmCampaignMutation, JoinCpmCampaignMutationVariables>;

/**
 * __useJoinCpmCampaignMutation__
 *
 * To run a mutation, you first call `useJoinCpmCampaignMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useJoinCpmCampaignMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [joinCpmCampaignMutation, { data, loading, error }] = useJoinCpmCampaignMutation({
 *   variables: {
 *      campaignId: // value for 'campaignId'
 *   },
 * });
 */
export function useJoinCpmCampaignMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<JoinCpmCampaignMutation, JoinCpmCampaignMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<JoinCpmCampaignMutation, JoinCpmCampaignMutationVariables>(JoinCpmCampaignDocument, options);
      }
export type JoinCpmCampaignMutationHookResult = ReturnType<typeof useJoinCpmCampaignMutation>;
export type JoinCpmCampaignMutationResult = Apollo.MutationResult<JoinCpmCampaignMutation>;
export type JoinCpmCampaignMutationOptions = Apollo.BaseMutationOptions<JoinCpmCampaignMutation, JoinCpmCampaignMutationVariables>;
export const LeaveCpmCampaignDocument = gql`
    mutation LeaveCpmCampaign($campaignId: ID!) {
  leaveCpmCampaign(campaignId: $campaignId)
}
    `;
export type LeaveCpmCampaignMutationFn = Apollo.MutationFunction<LeaveCpmCampaignMutation, LeaveCpmCampaignMutationVariables>;

/**
 * __useLeaveCpmCampaignMutation__
 *
 * To run a mutation, you first call `useLeaveCpmCampaignMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLeaveCpmCampaignMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [leaveCpmCampaignMutation, { data, loading, error }] = useLeaveCpmCampaignMutation({
 *   variables: {
 *      campaignId: // value for 'campaignId'
 *   },
 * });
 */
export function useLeaveCpmCampaignMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<LeaveCpmCampaignMutation, LeaveCpmCampaignMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<LeaveCpmCampaignMutation, LeaveCpmCampaignMutationVariables>(LeaveCpmCampaignDocument, options);
      }
export type LeaveCpmCampaignMutationHookResult = ReturnType<typeof useLeaveCpmCampaignMutation>;
export type LeaveCpmCampaignMutationResult = Apollo.MutationResult<LeaveCpmCampaignMutation>;
export type LeaveCpmCampaignMutationOptions = Apollo.BaseMutationOptions<LeaveCpmCampaignMutation, LeaveCpmCampaignMutationVariables>;
export const AdminCpmCampaignsDocument = gql`
query AdminCpmCampaigns($status: String, $limit: Int, $offset: Int) {
  adminCpmCampaigns(status: $status, limit: $limit, offset: $offset) {
    data {
      campaign_type
      ranking_config
      id
      name
      status
      currency
      cpm_rate_cents
      budget_total_cents
      cpm_platform_rates {
        platform
        cpm_rate_cents
      }
      allowed_platforms
      budget_spent_cents
      budget_stored_spent_cents
      budget_spend_drift_cents
      budget_remaining_cents
      budget_pending_cents
      submissions_count
      createdAt
      start_date
      end_date
      requires_channel_approval
      pending_channel_requests_count
    }
    total
  }
}
`;

/**
 * __useAdminCpmCampaignsQuery__
 *
 * To run a query within a React component, call `useAdminCpmCampaignsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminCpmCampaignsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminCpmCampaignsQuery({
 *   variables: {
 *      status: // value for 'status'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useAdminCpmCampaignsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<AdminCpmCampaignsQuery, AdminCpmCampaignsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AdminCpmCampaignsQuery, AdminCpmCampaignsQueryVariables>(AdminCpmCampaignsDocument, options);
      }
export function useAdminCpmCampaignsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AdminCpmCampaignsQuery, AdminCpmCampaignsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AdminCpmCampaignsQuery, AdminCpmCampaignsQueryVariables>(AdminCpmCampaignsDocument, options);
        }
// @ts-ignore
export function useAdminCpmCampaignsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<AdminCpmCampaignsQuery, AdminCpmCampaignsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AdminCpmCampaignsQuery, AdminCpmCampaignsQueryVariables>;
export function useAdminCpmCampaignsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AdminCpmCampaignsQuery, AdminCpmCampaignsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AdminCpmCampaignsQuery | undefined, AdminCpmCampaignsQueryVariables>;
export function useAdminCpmCampaignsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AdminCpmCampaignsQuery, AdminCpmCampaignsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<AdminCpmCampaignsQuery, AdminCpmCampaignsQueryVariables>(AdminCpmCampaignsDocument, options);
        }
export type AdminCpmCampaignsQueryHookResult = ReturnType<typeof useAdminCpmCampaignsQuery>;
export type AdminCpmCampaignsLazyQueryHookResult = ReturnType<typeof useAdminCpmCampaignsLazyQuery>;
export type AdminCpmCampaignsSuspenseQueryHookResult = ReturnType<typeof useAdminCpmCampaignsSuspenseQuery>;
export type AdminCpmCampaignsQueryResult = Apollo.QueryResult<AdminCpmCampaignsQuery, AdminCpmCampaignsQueryVariables>;
export const AdminCpmCampaignDocument = gql`
query AdminCpmCampaign($id: ID!) {
  adminCpmCampaign(id: $id) {
    campaign_type
    ranking_config
    id
    name
    logo_url
    banner_url
    categories
    description
    status
    start_date
    end_date
    currency
    cpm_rate_cents
    budget_total_cents
    cpm_platform_rates {
      platform
      cpm_rate_cents
    }
    budget_spent_cents
    budget_stored_spent_cents
    budget_spend_drift_cents
    budget_remaining_cents
    budget_pending_cents
    min_views_threshold
    min_payout_per_clipper_cents
    max_payout_per_clipper_cents
    max_payout_per_clip_cents
    view_accrual_window_hours
    required_hashtags
    required_mention
    min_clip_duration_seconds
    allowed_platforms
    rules_allowed
    rules_forbidden
    rules_attention
    rules_warning
    caption_examples
    requires_channel_approval
    restrict_to_listed_videos
    pre_approval_enabled
    pre_approval_min_score
    rank_min_finished_renders
    invite_only
    selected_only
    watermark_image_url
    watermark_anchor
    watermark_size_percent
    watermark_opacity_percent
    watermark_margin_x_percent
    watermark_margin_y_percent
    enforced_post_layout
    enforced_subtitle_position
    editing_assets
    allow_cpm_override
    cpm_override_mode
    cpm_override_presets_cents
    cpm_override_min_cents
    cpm_override_max_cents
    pending_channel_requests_count
    pending_appeals_count
    youtube_channels {
      id
      channel_id
      name
      thumbnail
    }
    library_projects {
      id
      name
      thumbnail_url
    }
    youtube_downloads {
      id
      video_id
      name
      thumbnail_url
      youtube_channels {
        id
        channel_id
        name
        thumbnail
      }
    }
    excluded_youtube_downloads {
      id
      video_id
      name
      thumbnail_url
    }
    campaign_admins {
      id
      email
      name
    }
    selected_users {
      id
      email
      name
    }
    submissions_count
    createdAt
    updatedAt
  }
}
`;

/**
 * __useAdminCpmCampaignQuery__
 *
 * To run a query within a React component, call `useAdminCpmCampaignQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminCpmCampaignQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminCpmCampaignQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAdminCpmCampaignQuery(baseOptions: ApolloReactHooks.QueryHookOptions<AdminCpmCampaignQuery, AdminCpmCampaignQueryVariables> & ({ variables: AdminCpmCampaignQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AdminCpmCampaignQuery, AdminCpmCampaignQueryVariables>(AdminCpmCampaignDocument, options);
      }
export function useAdminCpmCampaignLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AdminCpmCampaignQuery, AdminCpmCampaignQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AdminCpmCampaignQuery, AdminCpmCampaignQueryVariables>(AdminCpmCampaignDocument, options);
        }
// @ts-ignore
export function useAdminCpmCampaignSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<AdminCpmCampaignQuery, AdminCpmCampaignQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AdminCpmCampaignQuery, AdminCpmCampaignQueryVariables>;
export function useAdminCpmCampaignSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AdminCpmCampaignQuery, AdminCpmCampaignQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AdminCpmCampaignQuery | undefined, AdminCpmCampaignQueryVariables>;
export function useAdminCpmCampaignSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AdminCpmCampaignQuery, AdminCpmCampaignQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<AdminCpmCampaignQuery, AdminCpmCampaignQueryVariables>(AdminCpmCampaignDocument, options);
        }
export type AdminCpmCampaignQueryHookResult = ReturnType<typeof useAdminCpmCampaignQuery>;
export type AdminCpmCampaignLazyQueryHookResult = ReturnType<typeof useAdminCpmCampaignLazyQuery>;
export type AdminCpmCampaignSuspenseQueryHookResult = ReturnType<typeof useAdminCpmCampaignSuspenseQuery>;
export type AdminCpmCampaignQueryResult = Apollo.QueryResult<AdminCpmCampaignQuery, AdminCpmCampaignQueryVariables>;
export const MyAuditedCpmCampaignsDocument = gql`
query MyAuditedCpmCampaigns {
  adminCpmCampaigns(limit: 100, offset: 0) {
    data {
      campaign_type
      ranking_config
      id
      name
      description
      status
      logo_url
      banner_url
      categories
      start_date
      currency
      cpm_rate_cents
      cpm_platform_rates {
        platform
        cpm_rate_cents
      }
      allowed_platforms
      max_payout_per_clip_cents
      budget_total_cents
      budget_spent_cents
      budget_stored_spent_cents
      budget_spend_drift_cents
      budget_remaining_cents
      budget_pending_cents
      submissions_count
      pending_submissions_count
      approved_submissions_count
      disapproved_submissions_count
      pending_appeals_count
      pending_channel_requests_count
      youtube_channels {
        id
        name
        handle
        thumbnail
      }
      createdAt
    }
    total
  }
}
`;

/**
 * __useMyAuditedCpmCampaignsQuery__
 *
 * To run a query within a React component, call `useMyAuditedCpmCampaignsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyAuditedCpmCampaignsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyAuditedCpmCampaignsQuery({
 *   variables: {
 *   },
 * });
 */
export function useMyAuditedCpmCampaignsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<MyAuditedCpmCampaignsQuery, MyAuditedCpmCampaignsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<MyAuditedCpmCampaignsQuery, MyAuditedCpmCampaignsQueryVariables>(MyAuditedCpmCampaignsDocument, options);
      }
export function useMyAuditedCpmCampaignsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<MyAuditedCpmCampaignsQuery, MyAuditedCpmCampaignsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<MyAuditedCpmCampaignsQuery, MyAuditedCpmCampaignsQueryVariables>(MyAuditedCpmCampaignsDocument, options);
        }
// @ts-ignore
export function useMyAuditedCpmCampaignsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<MyAuditedCpmCampaignsQuery, MyAuditedCpmCampaignsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<MyAuditedCpmCampaignsQuery, MyAuditedCpmCampaignsQueryVariables>;
export function useMyAuditedCpmCampaignsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<MyAuditedCpmCampaignsQuery, MyAuditedCpmCampaignsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<MyAuditedCpmCampaignsQuery | undefined, MyAuditedCpmCampaignsQueryVariables>;
export function useMyAuditedCpmCampaignsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<MyAuditedCpmCampaignsQuery, MyAuditedCpmCampaignsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<MyAuditedCpmCampaignsQuery, MyAuditedCpmCampaignsQueryVariables>(MyAuditedCpmCampaignsDocument, options);
        }
export type MyAuditedCpmCampaignsQueryHookResult = ReturnType<typeof useMyAuditedCpmCampaignsQuery>;
export type MyAuditedCpmCampaignsLazyQueryHookResult = ReturnType<typeof useMyAuditedCpmCampaignsLazyQuery>;
export type MyAuditedCpmCampaignsSuspenseQueryHookResult = ReturnType<typeof useMyAuditedCpmCampaignsSuspenseQuery>;
export type MyAuditedCpmCampaignsQueryResult = Apollo.QueryResult<MyAuditedCpmCampaignsQuery, MyAuditedCpmCampaignsQueryVariables>;
export const ActiveCpmCampaignChannelsDocument = gql`
query ActiveCpmCampaignChannels {
  myCpmCampaigns(status: "active", includeInviteOnlyTeasers: true) {
    campaign_type
    ranking_config
    id
    name
    required_hashtags
    logo_url
    banner_url
    categories
    invite_only
    selected_only
    is_selected_user
    my_approved_platforms
    cpm_rate_cents
    cpm_platform_rates {
      platform
      cpm_rate_cents
    }
    allowed_platforms
    min_views_threshold
    currency
    budget_total_cents
    budget_remaining_cents
    budget_pending_cents
    youtube_channels {
      channel_id
      thumbnail
    }
  }
}
`;

/**
 * __useActiveCpmCampaignChannelsQuery__
 *
 * To run a query within a React component, call `useActiveCpmCampaignChannelsQuery` and pass it any options that fit your needs.
 * When your component renders, `useActiveCpmCampaignChannelsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useActiveCpmCampaignChannelsQuery({
 *   variables: {
 *   },
 * });
 */
export function useActiveCpmCampaignChannelsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ActiveCpmCampaignChannelsQuery, ActiveCpmCampaignChannelsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ActiveCpmCampaignChannelsQuery, ActiveCpmCampaignChannelsQueryVariables>(ActiveCpmCampaignChannelsDocument, options);
      }
export function useActiveCpmCampaignChannelsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ActiveCpmCampaignChannelsQuery, ActiveCpmCampaignChannelsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ActiveCpmCampaignChannelsQuery, ActiveCpmCampaignChannelsQueryVariables>(ActiveCpmCampaignChannelsDocument, options);
        }
// @ts-ignore
export function useActiveCpmCampaignChannelsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ActiveCpmCampaignChannelsQuery, ActiveCpmCampaignChannelsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ActiveCpmCampaignChannelsQuery, ActiveCpmCampaignChannelsQueryVariables>;
export function useActiveCpmCampaignChannelsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ActiveCpmCampaignChannelsQuery, ActiveCpmCampaignChannelsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ActiveCpmCampaignChannelsQuery | undefined, ActiveCpmCampaignChannelsQueryVariables>;
export function useActiveCpmCampaignChannelsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ActiveCpmCampaignChannelsQuery, ActiveCpmCampaignChannelsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ActiveCpmCampaignChannelsQuery, ActiveCpmCampaignChannelsQueryVariables>(ActiveCpmCampaignChannelsDocument, options);
        }
export type ActiveCpmCampaignChannelsQueryHookResult = ReturnType<typeof useActiveCpmCampaignChannelsQuery>;
export type ActiveCpmCampaignChannelsLazyQueryHookResult = ReturnType<typeof useActiveCpmCampaignChannelsLazyQuery>;
export type ActiveCpmCampaignChannelsSuspenseQueryHookResult = ReturnType<typeof useActiveCpmCampaignChannelsSuspenseQuery>;
export type ActiveCpmCampaignChannelsQueryResult = Apollo.QueryResult<ActiveCpmCampaignChannelsQuery, ActiveCpmCampaignChannelsQueryVariables>;
export const EarnPageCampaignsDocument = gql`
query EarnPageCampaigns {
  myCpmCampaigns(status: "active", includeInviteOnlyTeasers: true) {
    campaign_type
    ranking_config
    id
    name
    logo_url
    banner_url
    categories
    cpm_rate_cents
    cpm_platform_rates {
      platform
      cpm_rate_cents
    }
    allowed_platforms
    min_views_threshold
    currency
    budget_total_cents
    budget_remaining_cents
    budget_pending_cents
    required_hashtags
    invite_only
    selected_only
    is_selected_user
    my_approved_platforms
    is_joined
    join_blocked_reason
    youtube_channels {
      channel_id
      name
      thumbnail
      category
      is_autoclipper_partner
    }
  }
}
`;

/**
 * __useEarnPageCampaignsQuery__
 *
 * To run a query within a React component, call `useEarnPageCampaignsQuery` and pass it any options that fit your needs.
 * When your component renders, `useEarnPageCampaignsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEarnPageCampaignsQuery({
 *   variables: {
 *   },
 * });
 */
export function useEarnPageCampaignsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<EarnPageCampaignsQuery, EarnPageCampaignsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<EarnPageCampaignsQuery, EarnPageCampaignsQueryVariables>(EarnPageCampaignsDocument, options);
      }
export function useEarnPageCampaignsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<EarnPageCampaignsQuery, EarnPageCampaignsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<EarnPageCampaignsQuery, EarnPageCampaignsQueryVariables>(EarnPageCampaignsDocument, options);
        }
// @ts-ignore
export function useEarnPageCampaignsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<EarnPageCampaignsQuery, EarnPageCampaignsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<EarnPageCampaignsQuery, EarnPageCampaignsQueryVariables>;
export function useEarnPageCampaignsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<EarnPageCampaignsQuery, EarnPageCampaignsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<EarnPageCampaignsQuery | undefined, EarnPageCampaignsQueryVariables>;
export function useEarnPageCampaignsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<EarnPageCampaignsQuery, EarnPageCampaignsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<EarnPageCampaignsQuery, EarnPageCampaignsQueryVariables>(EarnPageCampaignsDocument, options);
        }
export type EarnPageCampaignsQueryHookResult = ReturnType<typeof useEarnPageCampaignsQuery>;
export type EarnPageCampaignsLazyQueryHookResult = ReturnType<typeof useEarnPageCampaignsLazyQuery>;
export type EarnPageCampaignsSuspenseQueryHookResult = ReturnType<typeof useEarnPageCampaignsSuspenseQuery>;
export type EarnPageCampaignsQueryResult = Apollo.QueryResult<EarnPageCampaignsQuery, EarnPageCampaignsQueryVariables>;
export const CpmClipperLeaderboardDocument = gql`
    query CpmClipperLeaderboard {
  cpmClipperLeaderboard {
    user_id
    name
    avatar_url
    total_views
    video_count
    anonymous
    views_tier_id
    families {
      id
      featured_tier_id
      badges {
        tier_id
        season_id
        season_name
      }
    }
  }
}
    `;

/**
 * __useCpmClipperLeaderboardQuery__
 *
 * To run a query within a React component, call `useCpmClipperLeaderboardQuery` and pass it any options that fit your needs.
 * When your component renders, `useCpmClipperLeaderboardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCpmClipperLeaderboardQuery({
 *   variables: {
 *   },
 * });
 */
export function useCpmClipperLeaderboardQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<CpmClipperLeaderboardQuery, CpmClipperLeaderboardQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<CpmClipperLeaderboardQuery, CpmClipperLeaderboardQueryVariables>(CpmClipperLeaderboardDocument, options);
      }
export function useCpmClipperLeaderboardLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CpmClipperLeaderboardQuery, CpmClipperLeaderboardQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<CpmClipperLeaderboardQuery, CpmClipperLeaderboardQueryVariables>(CpmClipperLeaderboardDocument, options);
        }
// @ts-ignore
export function useCpmClipperLeaderboardSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<CpmClipperLeaderboardQuery, CpmClipperLeaderboardQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<CpmClipperLeaderboardQuery, CpmClipperLeaderboardQueryVariables>;
export function useCpmClipperLeaderboardSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<CpmClipperLeaderboardQuery, CpmClipperLeaderboardQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<CpmClipperLeaderboardQuery | undefined, CpmClipperLeaderboardQueryVariables>;
export function useCpmClipperLeaderboardSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<CpmClipperLeaderboardQuery, CpmClipperLeaderboardQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<CpmClipperLeaderboardQuery, CpmClipperLeaderboardQueryVariables>(CpmClipperLeaderboardDocument, options);
        }
export type CpmClipperLeaderboardQueryHookResult = ReturnType<typeof useCpmClipperLeaderboardQuery>;
export type CpmClipperLeaderboardLazyQueryHookResult = ReturnType<typeof useCpmClipperLeaderboardLazyQuery>;
export type CpmClipperLeaderboardSuspenseQueryHookResult = ReturnType<typeof useCpmClipperLeaderboardSuspenseQuery>;
export type CpmClipperLeaderboardQueryResult = Apollo.QueryResult<CpmClipperLeaderboardQuery, CpmClipperLeaderboardQueryVariables>;
export const MyCpmLeaderboardStandingDocument = gql`
    query MyCpmLeaderboardStanding {
  myCpmLeaderboardStanding {
    rank
    total
    entries {
      rank
      is_viewer
      user_id
      name
      avatar_url
      total_views
      video_count
      anonymous
      views_tier_id
      families {
        id
        featured_tier_id
        badges {
          tier_id
          season_id
          season_name
        }
      }
    }
  }
}
    `;

/**
 * __useMyCpmLeaderboardStandingQuery__
 *
 * To run a query within a React component, call `useMyCpmLeaderboardStandingQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyCpmLeaderboardStandingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyCpmLeaderboardStandingQuery({
 *   variables: {
 *   },
 * });
 */
export function useMyCpmLeaderboardStandingQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<MyCpmLeaderboardStandingQuery, MyCpmLeaderboardStandingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<MyCpmLeaderboardStandingQuery, MyCpmLeaderboardStandingQueryVariables>(MyCpmLeaderboardStandingDocument, options);
      }
export function useMyCpmLeaderboardStandingLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<MyCpmLeaderboardStandingQuery, MyCpmLeaderboardStandingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<MyCpmLeaderboardStandingQuery, MyCpmLeaderboardStandingQueryVariables>(MyCpmLeaderboardStandingDocument, options);
        }
// @ts-ignore
export function useMyCpmLeaderboardStandingSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<MyCpmLeaderboardStandingQuery, MyCpmLeaderboardStandingQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<MyCpmLeaderboardStandingQuery, MyCpmLeaderboardStandingQueryVariables>;
export function useMyCpmLeaderboardStandingSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<MyCpmLeaderboardStandingQuery, MyCpmLeaderboardStandingQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<MyCpmLeaderboardStandingQuery | undefined, MyCpmLeaderboardStandingQueryVariables>;
export function useMyCpmLeaderboardStandingSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<MyCpmLeaderboardStandingQuery, MyCpmLeaderboardStandingQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<MyCpmLeaderboardStandingQuery, MyCpmLeaderboardStandingQueryVariables>(MyCpmLeaderboardStandingDocument, options);
        }
export type MyCpmLeaderboardStandingQueryHookResult = ReturnType<typeof useMyCpmLeaderboardStandingQuery>;
export type MyCpmLeaderboardStandingLazyQueryHookResult = ReturnType<typeof useMyCpmLeaderboardStandingLazyQuery>;
export type MyCpmLeaderboardStandingSuspenseQueryHookResult = ReturnType<typeof useMyCpmLeaderboardStandingSuspenseQuery>;
export type MyCpmLeaderboardStandingQueryResult = Apollo.QueryResult<MyCpmLeaderboardStandingQuery, MyCpmLeaderboardStandingQueryVariables>;
export const MyCpmLeaderboardViewerDocument = gql`
    query MyCpmLeaderboardViewer {
  myData {
    id
    name
    profile_picture
    onboarding_objective
  }
}
    `;

/**
 * __useMyCpmLeaderboardViewerQuery__
 *
 * To run a query within a React component, call `useMyCpmLeaderboardViewerQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyCpmLeaderboardViewerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyCpmLeaderboardViewerQuery({
 *   variables: {
 *   },
 * });
 */
export function useMyCpmLeaderboardViewerQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<MyCpmLeaderboardViewerQuery, MyCpmLeaderboardViewerQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<MyCpmLeaderboardViewerQuery, MyCpmLeaderboardViewerQueryVariables>(MyCpmLeaderboardViewerDocument, options);
      }
export function useMyCpmLeaderboardViewerLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<MyCpmLeaderboardViewerQuery, MyCpmLeaderboardViewerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<MyCpmLeaderboardViewerQuery, MyCpmLeaderboardViewerQueryVariables>(MyCpmLeaderboardViewerDocument, options);
        }
// @ts-ignore
export function useMyCpmLeaderboardViewerSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<MyCpmLeaderboardViewerQuery, MyCpmLeaderboardViewerQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<MyCpmLeaderboardViewerQuery, MyCpmLeaderboardViewerQueryVariables>;
export function useMyCpmLeaderboardViewerSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<MyCpmLeaderboardViewerQuery, MyCpmLeaderboardViewerQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<MyCpmLeaderboardViewerQuery | undefined, MyCpmLeaderboardViewerQueryVariables>;
export function useMyCpmLeaderboardViewerSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<MyCpmLeaderboardViewerQuery, MyCpmLeaderboardViewerQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<MyCpmLeaderboardViewerQuery, MyCpmLeaderboardViewerQueryVariables>(MyCpmLeaderboardViewerDocument, options);
        }
export type MyCpmLeaderboardViewerQueryHookResult = ReturnType<typeof useMyCpmLeaderboardViewerQuery>;
export type MyCpmLeaderboardViewerLazyQueryHookResult = ReturnType<typeof useMyCpmLeaderboardViewerLazyQuery>;
export type MyCpmLeaderboardViewerSuspenseQueryHookResult = ReturnType<typeof useMyCpmLeaderboardViewerSuspenseQuery>;
export type MyCpmLeaderboardViewerQueryResult = Apollo.QueryResult<MyCpmLeaderboardViewerQuery, MyCpmLeaderboardViewerQueryVariables>;
export const MyCpmLeaderboardPrivacyDocument = gql`
    query MyCpmLeaderboardPrivacy {
  myCpmLeaderboardPrivacy {
    anonymous
    can_remain_anonymous
  }
}
    `;

/**
 * __useMyCpmLeaderboardPrivacyQuery__
 *
 * To run a query within a React component, call `useMyCpmLeaderboardPrivacyQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyCpmLeaderboardPrivacyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyCpmLeaderboardPrivacyQuery({
 *   variables: {
 *   },
 * });
 */
export function useMyCpmLeaderboardPrivacyQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<MyCpmLeaderboardPrivacyQuery, MyCpmLeaderboardPrivacyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<MyCpmLeaderboardPrivacyQuery, MyCpmLeaderboardPrivacyQueryVariables>(MyCpmLeaderboardPrivacyDocument, options);
      }
export function useMyCpmLeaderboardPrivacyLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<MyCpmLeaderboardPrivacyQuery, MyCpmLeaderboardPrivacyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<MyCpmLeaderboardPrivacyQuery, MyCpmLeaderboardPrivacyQueryVariables>(MyCpmLeaderboardPrivacyDocument, options);
        }
// @ts-ignore
export function useMyCpmLeaderboardPrivacySuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<MyCpmLeaderboardPrivacyQuery, MyCpmLeaderboardPrivacyQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<MyCpmLeaderboardPrivacyQuery, MyCpmLeaderboardPrivacyQueryVariables>;
export function useMyCpmLeaderboardPrivacySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<MyCpmLeaderboardPrivacyQuery, MyCpmLeaderboardPrivacyQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<MyCpmLeaderboardPrivacyQuery | undefined, MyCpmLeaderboardPrivacyQueryVariables>;
export function useMyCpmLeaderboardPrivacySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<MyCpmLeaderboardPrivacyQuery, MyCpmLeaderboardPrivacyQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<MyCpmLeaderboardPrivacyQuery, MyCpmLeaderboardPrivacyQueryVariables>(MyCpmLeaderboardPrivacyDocument, options);
        }
export type MyCpmLeaderboardPrivacyQueryHookResult = ReturnType<typeof useMyCpmLeaderboardPrivacyQuery>;
export type MyCpmLeaderboardPrivacyLazyQueryHookResult = ReturnType<typeof useMyCpmLeaderboardPrivacyLazyQuery>;
export type MyCpmLeaderboardPrivacySuspenseQueryHookResult = ReturnType<typeof useMyCpmLeaderboardPrivacySuspenseQuery>;
export type MyCpmLeaderboardPrivacyQueryResult = Apollo.QueryResult<MyCpmLeaderboardPrivacyQuery, MyCpmLeaderboardPrivacyQueryVariables>;
export const SetMyCpmLeaderboardAnonymousDocument = gql`
    mutation SetMyCpmLeaderboardAnonymous($anonymous: Boolean!) {
  setMyCpmLeaderboardAnonymous(anonymous: $anonymous) {
    anonymous
    can_remain_anonymous
  }
}
    `;
export type SetMyCpmLeaderboardAnonymousMutationFn = Apollo.MutationFunction<SetMyCpmLeaderboardAnonymousMutation, SetMyCpmLeaderboardAnonymousMutationVariables>;

/**
 * __useSetMyCpmLeaderboardAnonymousMutation__
 *
 * To run a mutation, you first call `useSetMyCpmLeaderboardAnonymousMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetMyCpmLeaderboardAnonymousMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setMyCpmLeaderboardAnonymousMutation, { data, loading, error }] = useSetMyCpmLeaderboardAnonymousMutation({
 *   variables: {
 *      anonymous: // value for 'anonymous'
 *   },
 * });
 */
export function useSetMyCpmLeaderboardAnonymousMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SetMyCpmLeaderboardAnonymousMutation, SetMyCpmLeaderboardAnonymousMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SetMyCpmLeaderboardAnonymousMutation, SetMyCpmLeaderboardAnonymousMutationVariables>(SetMyCpmLeaderboardAnonymousDocument, options);
      }
export type SetMyCpmLeaderboardAnonymousMutationHookResult = ReturnType<typeof useSetMyCpmLeaderboardAnonymousMutation>;
export type SetMyCpmLeaderboardAnonymousMutationResult = Apollo.MutationResult<SetMyCpmLeaderboardAnonymousMutation>;
export type SetMyCpmLeaderboardAnonymousMutationOptions = Apollo.BaseMutationOptions<SetMyCpmLeaderboardAnonymousMutation, SetMyCpmLeaderboardAnonymousMutationVariables>;
export const EarnPageEndedCampaignsDocument = gql`
query EarnPageEndedCampaigns {
  myCpmCampaigns(status: "ended") {
    campaign_type
    ranking_config
    id
    name
    logo_url
    banner_url
    categories
    currency
    budget_total_cents
    budget_remaining_cents
    youtube_channels {
      channel_id
      name
      thumbnail
    }
  }
}
`;

/**
 * __useEarnPageEndedCampaignsQuery__
 *
 * To run a query within a React component, call `useEarnPageEndedCampaignsQuery` and pass it any options that fit your needs.
 * When your component renders, `useEarnPageEndedCampaignsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEarnPageEndedCampaignsQuery({
 *   variables: {
 *   },
 * });
 */
export function useEarnPageEndedCampaignsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<EarnPageEndedCampaignsQuery, EarnPageEndedCampaignsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<EarnPageEndedCampaignsQuery, EarnPageEndedCampaignsQueryVariables>(EarnPageEndedCampaignsDocument, options);
      }
export function useEarnPageEndedCampaignsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<EarnPageEndedCampaignsQuery, EarnPageEndedCampaignsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<EarnPageEndedCampaignsQuery, EarnPageEndedCampaignsQueryVariables>(EarnPageEndedCampaignsDocument, options);
        }
// @ts-ignore
export function useEarnPageEndedCampaignsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<EarnPageEndedCampaignsQuery, EarnPageEndedCampaignsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<EarnPageEndedCampaignsQuery, EarnPageEndedCampaignsQueryVariables>;
export function useEarnPageEndedCampaignsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<EarnPageEndedCampaignsQuery, EarnPageEndedCampaignsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<EarnPageEndedCampaignsQuery | undefined, EarnPageEndedCampaignsQueryVariables>;
export function useEarnPageEndedCampaignsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<EarnPageEndedCampaignsQuery, EarnPageEndedCampaignsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<EarnPageEndedCampaignsQuery, EarnPageEndedCampaignsQueryVariables>(EarnPageEndedCampaignsDocument, options);
        }
export type EarnPageEndedCampaignsQueryHookResult = ReturnType<typeof useEarnPageEndedCampaignsQuery>;
export type EarnPageEndedCampaignsLazyQueryHookResult = ReturnType<typeof useEarnPageEndedCampaignsLazyQuery>;
export type EarnPageEndedCampaignsSuspenseQueryHookResult = ReturnType<typeof useEarnPageEndedCampaignsSuspenseQuery>;
export type EarnPageEndedCampaignsQueryResult = Apollo.QueryResult<EarnPageEndedCampaignsQuery, EarnPageEndedCampaignsQueryVariables>;
export const EarnPageScheduledCampaignsDocument = gql`
query EarnPageScheduledCampaigns {
  myCpmCampaigns(status: "scheduled", includeInviteOnlyTeasers: true) {
    campaign_type
    ranking_config
    id
    name
    logo_url
    banner_url
    categories
    currency
    cpm_rate_cents
    start_date
    budget_total_cents
    youtube_channels {
      channel_id
      name
      thumbnail
    }
  }
}
`;

/**
 * __useEarnPageScheduledCampaignsQuery__
 *
 * To run a query within a React component, call `useEarnPageScheduledCampaignsQuery` and pass it any options that fit your needs.
 * When your component renders, `useEarnPageScheduledCampaignsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEarnPageScheduledCampaignsQuery({
 *   variables: {
 *   },
 * });
 */
export function useEarnPageScheduledCampaignsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<EarnPageScheduledCampaignsQuery, EarnPageScheduledCampaignsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<EarnPageScheduledCampaignsQuery, EarnPageScheduledCampaignsQueryVariables>(EarnPageScheduledCampaignsDocument, options);
      }
export function useEarnPageScheduledCampaignsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<EarnPageScheduledCampaignsQuery, EarnPageScheduledCampaignsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<EarnPageScheduledCampaignsQuery, EarnPageScheduledCampaignsQueryVariables>(EarnPageScheduledCampaignsDocument, options);
        }
// @ts-ignore
export function useEarnPageScheduledCampaignsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<EarnPageScheduledCampaignsQuery, EarnPageScheduledCampaignsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<EarnPageScheduledCampaignsQuery, EarnPageScheduledCampaignsQueryVariables>;
export function useEarnPageScheduledCampaignsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<EarnPageScheduledCampaignsQuery, EarnPageScheduledCampaignsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<EarnPageScheduledCampaignsQuery | undefined, EarnPageScheduledCampaignsQueryVariables>;
export function useEarnPageScheduledCampaignsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<EarnPageScheduledCampaignsQuery, EarnPageScheduledCampaignsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<EarnPageScheduledCampaignsQuery, EarnPageScheduledCampaignsQueryVariables>(EarnPageScheduledCampaignsDocument, options);
        }
export type EarnPageScheduledCampaignsQueryHookResult = ReturnType<typeof useEarnPageScheduledCampaignsQuery>;
export type EarnPageScheduledCampaignsLazyQueryHookResult = ReturnType<typeof useEarnPageScheduledCampaignsLazyQuery>;
export type EarnPageScheduledCampaignsSuspenseQueryHookResult = ReturnType<typeof useEarnPageScheduledCampaignsSuspenseQuery>;
export type EarnPageScheduledCampaignsQueryResult = Apollo.QueryResult<EarnPageScheduledCampaignsQuery, EarnPageScheduledCampaignsQueryVariables>;
export const CampaignChannelPickerDocument = gql`
    query CampaignChannelPicker($search: String) {
  communityChannels(search: $search) {
    id
    channel_id
    name
    thumbnail
  }
}
    `;

/**
 * __useCampaignChannelPickerQuery__
 *
 * To run a query within a React component, call `useCampaignChannelPickerQuery` and pass it any options that fit your needs.
 * When your component renders, `useCampaignChannelPickerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCampaignChannelPickerQuery({
 *   variables: {
 *      search: // value for 'search'
 *   },
 * });
 */
export function useCampaignChannelPickerQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<CampaignChannelPickerQuery, CampaignChannelPickerQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<CampaignChannelPickerQuery, CampaignChannelPickerQueryVariables>(CampaignChannelPickerDocument, options);
      }
export function useCampaignChannelPickerLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CampaignChannelPickerQuery, CampaignChannelPickerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<CampaignChannelPickerQuery, CampaignChannelPickerQueryVariables>(CampaignChannelPickerDocument, options);
        }
// @ts-ignore
export function useCampaignChannelPickerSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<CampaignChannelPickerQuery, CampaignChannelPickerQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<CampaignChannelPickerQuery, CampaignChannelPickerQueryVariables>;
export function useCampaignChannelPickerSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<CampaignChannelPickerQuery, CampaignChannelPickerQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<CampaignChannelPickerQuery | undefined, CampaignChannelPickerQueryVariables>;
export function useCampaignChannelPickerSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<CampaignChannelPickerQuery, CampaignChannelPickerQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<CampaignChannelPickerQuery, CampaignChannelPickerQueryVariables>(CampaignChannelPickerDocument, options);
        }
export type CampaignChannelPickerQueryHookResult = ReturnType<typeof useCampaignChannelPickerQuery>;
export type CampaignChannelPickerLazyQueryHookResult = ReturnType<typeof useCampaignChannelPickerLazyQuery>;
export type CampaignChannelPickerSuspenseQueryHookResult = ReturnType<typeof useCampaignChannelPickerSuspenseQuery>;
export type CampaignChannelPickerQueryResult = Apollo.QueryResult<CampaignChannelPickerQuery, CampaignChannelPickerQueryVariables>;
export const CampaignLibraryPickerDocument = gql`
    query CampaignLibraryPicker($search: String, $channelId: ID, $limit: Int) {
  communityLibraries(
    search: $search
    channelId: $channelId
    limit: $limit
    expandCampaignChannel: false
  ) {
    id
    name
    thumbnail_url
    youtube_download_id
    youtube_channels {
      channel_id
      name
    }
  }
}
    `;

/**
 * __useCampaignLibraryPickerQuery__
 *
 * To run a query within a React component, call `useCampaignLibraryPickerQuery` and pass it any options that fit your needs.
 * When your component renders, `useCampaignLibraryPickerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCampaignLibraryPickerQuery({
 *   variables: {
 *      search: // value for 'search'
 *      channelId: // value for 'channelId'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useCampaignLibraryPickerQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<CampaignLibraryPickerQuery, CampaignLibraryPickerQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<CampaignLibraryPickerQuery, CampaignLibraryPickerQueryVariables>(CampaignLibraryPickerDocument, options);
      }
export function useCampaignLibraryPickerLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CampaignLibraryPickerQuery, CampaignLibraryPickerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<CampaignLibraryPickerQuery, CampaignLibraryPickerQueryVariables>(CampaignLibraryPickerDocument, options);
        }
// @ts-ignore
export function useCampaignLibraryPickerSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<CampaignLibraryPickerQuery, CampaignLibraryPickerQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<CampaignLibraryPickerQuery, CampaignLibraryPickerQueryVariables>;
export function useCampaignLibraryPickerSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<CampaignLibraryPickerQuery, CampaignLibraryPickerQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<CampaignLibraryPickerQuery | undefined, CampaignLibraryPickerQueryVariables>;
export function useCampaignLibraryPickerSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<CampaignLibraryPickerQuery, CampaignLibraryPickerQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<CampaignLibraryPickerQuery, CampaignLibraryPickerQueryVariables>(CampaignLibraryPickerDocument, options);
        }
export type CampaignLibraryPickerQueryHookResult = ReturnType<typeof useCampaignLibraryPickerQuery>;
export type CampaignLibraryPickerLazyQueryHookResult = ReturnType<typeof useCampaignLibraryPickerLazyQuery>;
export type CampaignLibraryPickerSuspenseQueryHookResult = ReturnType<typeof useCampaignLibraryPickerSuspenseQuery>;
export type CampaignLibraryPickerQueryResult = Apollo.QueryResult<CampaignLibraryPickerQuery, CampaignLibraryPickerQueryVariables>;
export const CampaignAdminUserPickerDocument = gql`
    query CampaignAdminUserPicker($search: String, $pageSize: Int) {
  adminUsers(search: $search, pageSize: $pageSize, page: 1) {
    data {
      id
      name
      email
    }
  }
}
    `;

/**
 * __useCampaignAdminUserPickerQuery__
 *
 * To run a query within a React component, call `useCampaignAdminUserPickerQuery` and pass it any options that fit your needs.
 * When your component renders, `useCampaignAdminUserPickerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCampaignAdminUserPickerQuery({
 *   variables: {
 *      search: // value for 'search'
 *      pageSize: // value for 'pageSize'
 *   },
 * });
 */
export function useCampaignAdminUserPickerQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<CampaignAdminUserPickerQuery, CampaignAdminUserPickerQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<CampaignAdminUserPickerQuery, CampaignAdminUserPickerQueryVariables>(CampaignAdminUserPickerDocument, options);
      }
export function useCampaignAdminUserPickerLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CampaignAdminUserPickerQuery, CampaignAdminUserPickerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<CampaignAdminUserPickerQuery, CampaignAdminUserPickerQueryVariables>(CampaignAdminUserPickerDocument, options);
        }
// @ts-ignore
export function useCampaignAdminUserPickerSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<CampaignAdminUserPickerQuery, CampaignAdminUserPickerQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<CampaignAdminUserPickerQuery, CampaignAdminUserPickerQueryVariables>;
export function useCampaignAdminUserPickerSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<CampaignAdminUserPickerQuery, CampaignAdminUserPickerQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<CampaignAdminUserPickerQuery | undefined, CampaignAdminUserPickerQueryVariables>;
export function useCampaignAdminUserPickerSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<CampaignAdminUserPickerQuery, CampaignAdminUserPickerQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<CampaignAdminUserPickerQuery, CampaignAdminUserPickerQueryVariables>(CampaignAdminUserPickerDocument, options);
        }
export type CampaignAdminUserPickerQueryHookResult = ReturnType<typeof useCampaignAdminUserPickerQuery>;
export type CampaignAdminUserPickerLazyQueryHookResult = ReturnType<typeof useCampaignAdminUserPickerLazyQuery>;
export type CampaignAdminUserPickerSuspenseQueryHookResult = ReturnType<typeof useCampaignAdminUserPickerSuspenseQuery>;
export type CampaignAdminUserPickerQueryResult = Apollo.QueryResult<CampaignAdminUserPickerQuery, CampaignAdminUserPickerQueryVariables>;
export const AdminCpmCampaignSubmissionsDocument = gql`
    query AdminCpmCampaignSubmissions($campaignId: ID!, $approval: String, $search: String, $limit: Int, $offset: Int, $suspectedDuplicatesOnly: Boolean, $platform: String, $validatedHashtags: String, $pendingOlderThanHours: Int) {
  adminCpmCampaignSubmissions(
    campaignId: $campaignId
    approval: $approval
    search: $search
    limit: $limit
    offset: $offset
    suspectedDuplicatesOnly: $suspectedDuplicatesOnly
    platform: $platform
    validatedHashtags: $validatedHashtags
    pendingOlderThanHours: $pendingOlderThanHours
  ) {
    data {
      id
      platform
      url
      admin_approval
      validated_hashtags
      disqualified
      last_counted_views
      accumulated_payout_cents
      cpm_rate_override_cents
      last_view_sync_at
      latest_views
      approval_reason
      disqualification_reason
      admin_observation
      rejection_images {
        url
        visibility
      }
      user_disqualified
      user_id
      user_email
      user_name
      createdAt
      pending_appeal_id
      disapproved_at
      daily_views {
        date
        views
        likes
        comments
        shares
      }
      suspected_duplicate
      suspected_duplicate_reason
      video_hash
      canonical_url
      content_review_group_id
      content_review_group_decision
      accrual_window_ends_at
      final_accrual_views
      final_accrual_captured_at
      final_accrual_source
      account_reliability {
        status
        score
        engagement_rate
        lifetime_views
        tracked_content
        username
      }
      metrics_status
      metrics_error
      pre_approval
      pre_approval_score
      pre_approval_at
      rules_check_failures
      estimated_payout_cents
      media_duration_seconds
      pre_approval_gates
      rules_check
    }
    total
    pageCount
  }
}
    `;

/**
 * __useAdminCpmCampaignSubmissionsQuery__
 *
 * To run a query within a React component, call `useAdminCpmCampaignSubmissionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminCpmCampaignSubmissionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminCpmCampaignSubmissionsQuery({
 *   variables: {
 *      campaignId: // value for 'campaignId'
 *      approval: // value for 'approval'
 *      search: // value for 'search'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      suspectedDuplicatesOnly: // value for 'suspectedDuplicatesOnly'
 *      platform: // value for 'platform'
 *      validatedHashtags: // value for 'validatedHashtags'
 *      pendingOlderThanHours: // value for 'pendingOlderThanHours'
 *   },
 * });
 */
export function useAdminCpmCampaignSubmissionsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<AdminCpmCampaignSubmissionsQuery, AdminCpmCampaignSubmissionsQueryVariables> & ({ variables: AdminCpmCampaignSubmissionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AdminCpmCampaignSubmissionsQuery, AdminCpmCampaignSubmissionsQueryVariables>(AdminCpmCampaignSubmissionsDocument, options);
      }
export function useAdminCpmCampaignSubmissionsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AdminCpmCampaignSubmissionsQuery, AdminCpmCampaignSubmissionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AdminCpmCampaignSubmissionsQuery, AdminCpmCampaignSubmissionsQueryVariables>(AdminCpmCampaignSubmissionsDocument, options);
        }
// @ts-ignore
export function useAdminCpmCampaignSubmissionsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<AdminCpmCampaignSubmissionsQuery, AdminCpmCampaignSubmissionsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AdminCpmCampaignSubmissionsQuery, AdminCpmCampaignSubmissionsQueryVariables>;
export function useAdminCpmCampaignSubmissionsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AdminCpmCampaignSubmissionsQuery, AdminCpmCampaignSubmissionsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AdminCpmCampaignSubmissionsQuery | undefined, AdminCpmCampaignSubmissionsQueryVariables>;
export function useAdminCpmCampaignSubmissionsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AdminCpmCampaignSubmissionsQuery, AdminCpmCampaignSubmissionsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<AdminCpmCampaignSubmissionsQuery, AdminCpmCampaignSubmissionsQueryVariables>(AdminCpmCampaignSubmissionsDocument, options);
        }
export type AdminCpmCampaignSubmissionsQueryHookResult = ReturnType<typeof useAdminCpmCampaignSubmissionsQuery>;
export type AdminCpmCampaignSubmissionsLazyQueryHookResult = ReturnType<typeof useAdminCpmCampaignSubmissionsLazyQuery>;
export type AdminCpmCampaignSubmissionsSuspenseQueryHookResult = ReturnType<typeof useAdminCpmCampaignSubmissionsSuspenseQuery>;
export type AdminCpmCampaignSubmissionsQueryResult = Apollo.QueryResult<AdminCpmCampaignSubmissionsQuery, AdminCpmCampaignSubmissionsQueryVariables>;
export const AdminCpmCampaignSubmissionStatsDocument = gql`
    query AdminCpmCampaignSubmissionStats($campaignId: ID!) {
  adminCpmCampaignSubmissions(campaignId: $campaignId, limit: 1, offset: 0) {
    stats {
      total_views
      approved_views
      paid_views
      total_earnings_cents
      total_submissions
      daily_series {
        date
        total_views
        approved_paid_views
        approved_unpaid_views
        clip_count
      }
    }
  }
}
    `;

/**
 * __useAdminCpmCampaignSubmissionStatsQuery__
 *
 * To run a query within a React component, call `useAdminCpmCampaignSubmissionStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminCpmCampaignSubmissionStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminCpmCampaignSubmissionStatsQuery({
 *   variables: {
 *      campaignId: // value for 'campaignId'
 *   },
 * });
 */
export function useAdminCpmCampaignSubmissionStatsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<AdminCpmCampaignSubmissionStatsQuery, AdminCpmCampaignSubmissionStatsQueryVariables> & ({ variables: AdminCpmCampaignSubmissionStatsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AdminCpmCampaignSubmissionStatsQuery, AdminCpmCampaignSubmissionStatsQueryVariables>(AdminCpmCampaignSubmissionStatsDocument, options);
      }
export function useAdminCpmCampaignSubmissionStatsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AdminCpmCampaignSubmissionStatsQuery, AdminCpmCampaignSubmissionStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AdminCpmCampaignSubmissionStatsQuery, AdminCpmCampaignSubmissionStatsQueryVariables>(AdminCpmCampaignSubmissionStatsDocument, options);
        }
// @ts-ignore
export function useAdminCpmCampaignSubmissionStatsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<AdminCpmCampaignSubmissionStatsQuery, AdminCpmCampaignSubmissionStatsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AdminCpmCampaignSubmissionStatsQuery, AdminCpmCampaignSubmissionStatsQueryVariables>;
export function useAdminCpmCampaignSubmissionStatsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AdminCpmCampaignSubmissionStatsQuery, AdminCpmCampaignSubmissionStatsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AdminCpmCampaignSubmissionStatsQuery | undefined, AdminCpmCampaignSubmissionStatsQueryVariables>;
export function useAdminCpmCampaignSubmissionStatsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AdminCpmCampaignSubmissionStatsQuery, AdminCpmCampaignSubmissionStatsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<AdminCpmCampaignSubmissionStatsQuery, AdminCpmCampaignSubmissionStatsQueryVariables>(AdminCpmCampaignSubmissionStatsDocument, options);
        }
export type AdminCpmCampaignSubmissionStatsQueryHookResult = ReturnType<typeof useAdminCpmCampaignSubmissionStatsQuery>;
export type AdminCpmCampaignSubmissionStatsLazyQueryHookResult = ReturnType<typeof useAdminCpmCampaignSubmissionStatsLazyQuery>;
export type AdminCpmCampaignSubmissionStatsSuspenseQueryHookResult = ReturnType<typeof useAdminCpmCampaignSubmissionStatsSuspenseQuery>;
export type AdminCpmCampaignSubmissionStatsQueryResult = Apollo.QueryResult<AdminCpmCampaignSubmissionStatsQuery, AdminCpmCampaignSubmissionStatsQueryVariables>;
export const AdminCpmCampaignTopEarningClipsDocument = gql`
    query AdminCpmCampaignTopEarningClips($campaignId: ID!, $limit: Int, $offset: Int) {
  adminCpmCampaignTopEarningClips(
    campaignId: $campaignId
    limit: $limit
    offset: $offset
  ) {
    data {
      id
      platform
      url
      user_name
      user_email
      views
      earnings_cents
    }
    total
    pageCount
  }
}
    `;

/**
 * __useAdminCpmCampaignTopEarningClipsQuery__
 *
 * To run a query within a React component, call `useAdminCpmCampaignTopEarningClipsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminCpmCampaignTopEarningClipsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminCpmCampaignTopEarningClipsQuery({
 *   variables: {
 *      campaignId: // value for 'campaignId'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useAdminCpmCampaignTopEarningClipsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<AdminCpmCampaignTopEarningClipsQuery, AdminCpmCampaignTopEarningClipsQueryVariables> & ({ variables: AdminCpmCampaignTopEarningClipsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AdminCpmCampaignTopEarningClipsQuery, AdminCpmCampaignTopEarningClipsQueryVariables>(AdminCpmCampaignTopEarningClipsDocument, options);
      }
export function useAdminCpmCampaignTopEarningClipsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AdminCpmCampaignTopEarningClipsQuery, AdminCpmCampaignTopEarningClipsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AdminCpmCampaignTopEarningClipsQuery, AdminCpmCampaignTopEarningClipsQueryVariables>(AdminCpmCampaignTopEarningClipsDocument, options);
        }
// @ts-ignore
export function useAdminCpmCampaignTopEarningClipsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<AdminCpmCampaignTopEarningClipsQuery, AdminCpmCampaignTopEarningClipsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AdminCpmCampaignTopEarningClipsQuery, AdminCpmCampaignTopEarningClipsQueryVariables>;
export function useAdminCpmCampaignTopEarningClipsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AdminCpmCampaignTopEarningClipsQuery, AdminCpmCampaignTopEarningClipsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AdminCpmCampaignTopEarningClipsQuery | undefined, AdminCpmCampaignTopEarningClipsQueryVariables>;
export function useAdminCpmCampaignTopEarningClipsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AdminCpmCampaignTopEarningClipsQuery, AdminCpmCampaignTopEarningClipsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<AdminCpmCampaignTopEarningClipsQuery, AdminCpmCampaignTopEarningClipsQueryVariables>(AdminCpmCampaignTopEarningClipsDocument, options);
        }
export type AdminCpmCampaignTopEarningClipsQueryHookResult = ReturnType<typeof useAdminCpmCampaignTopEarningClipsQuery>;
export type AdminCpmCampaignTopEarningClipsLazyQueryHookResult = ReturnType<typeof useAdminCpmCampaignTopEarningClipsLazyQuery>;
export type AdminCpmCampaignTopEarningClipsSuspenseQueryHookResult = ReturnType<typeof useAdminCpmCampaignTopEarningClipsSuspenseQuery>;
export type AdminCpmCampaignTopEarningClipsQueryResult = Apollo.QueryResult<AdminCpmCampaignTopEarningClipsQuery, AdminCpmCampaignTopEarningClipsQueryVariables>;
export const AdminEnqueueCpmSubmissionMediaDownloadDocument = gql`
    mutation AdminEnqueueCpmSubmissionMediaDownload($submissionId: ID!) {
  adminEnqueueCpmSubmissionMediaDownload(submissionId: $submissionId) {
    id
    submission_id
    status
    provider
    video_url
    error
  }
}
    `;
export type AdminEnqueueCpmSubmissionMediaDownloadMutationFn = Apollo.MutationFunction<AdminEnqueueCpmSubmissionMediaDownloadMutation, AdminEnqueueCpmSubmissionMediaDownloadMutationVariables>;

/**
 * __useAdminEnqueueCpmSubmissionMediaDownloadMutation__
 *
 * To run a mutation, you first call `useAdminEnqueueCpmSubmissionMediaDownloadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminEnqueueCpmSubmissionMediaDownloadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminEnqueueCpmSubmissionMediaDownloadMutation, { data, loading, error }] = useAdminEnqueueCpmSubmissionMediaDownloadMutation({
 *   variables: {
 *      submissionId: // value for 'submissionId'
 *   },
 * });
 */
export function useAdminEnqueueCpmSubmissionMediaDownloadMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AdminEnqueueCpmSubmissionMediaDownloadMutation, AdminEnqueueCpmSubmissionMediaDownloadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AdminEnqueueCpmSubmissionMediaDownloadMutation, AdminEnqueueCpmSubmissionMediaDownloadMutationVariables>(AdminEnqueueCpmSubmissionMediaDownloadDocument, options);
      }
export type AdminEnqueueCpmSubmissionMediaDownloadMutationHookResult = ReturnType<typeof useAdminEnqueueCpmSubmissionMediaDownloadMutation>;
export type AdminEnqueueCpmSubmissionMediaDownloadMutationResult = Apollo.MutationResult<AdminEnqueueCpmSubmissionMediaDownloadMutation>;
export type AdminEnqueueCpmSubmissionMediaDownloadMutationOptions = Apollo.BaseMutationOptions<AdminEnqueueCpmSubmissionMediaDownloadMutation, AdminEnqueueCpmSubmissionMediaDownloadMutationVariables>;
export const AdminCpmSubmissionMediaDownloadDocument = gql`
    query AdminCpmSubmissionMediaDownload($submissionId: ID!) {
  adminCpmSubmissionMediaDownload(submissionId: $submissionId) {
    id
    submission_id
    status
    provider
    video_url
    error
  }
}
    `;

/**
 * __useAdminCpmSubmissionMediaDownloadQuery__
 *
 * To run a query within a React component, call `useAdminCpmSubmissionMediaDownloadQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminCpmSubmissionMediaDownloadQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminCpmSubmissionMediaDownloadQuery({
 *   variables: {
 *      submissionId: // value for 'submissionId'
 *   },
 * });
 */
export function useAdminCpmSubmissionMediaDownloadQuery(baseOptions: ApolloReactHooks.QueryHookOptions<AdminCpmSubmissionMediaDownloadQuery, AdminCpmSubmissionMediaDownloadQueryVariables> & ({ variables: AdminCpmSubmissionMediaDownloadQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AdminCpmSubmissionMediaDownloadQuery, AdminCpmSubmissionMediaDownloadQueryVariables>(AdminCpmSubmissionMediaDownloadDocument, options);
      }
export function useAdminCpmSubmissionMediaDownloadLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AdminCpmSubmissionMediaDownloadQuery, AdminCpmSubmissionMediaDownloadQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AdminCpmSubmissionMediaDownloadQuery, AdminCpmSubmissionMediaDownloadQueryVariables>(AdminCpmSubmissionMediaDownloadDocument, options);
        }
// @ts-ignore
export function useAdminCpmSubmissionMediaDownloadSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<AdminCpmSubmissionMediaDownloadQuery, AdminCpmSubmissionMediaDownloadQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AdminCpmSubmissionMediaDownloadQuery, AdminCpmSubmissionMediaDownloadQueryVariables>;
export function useAdminCpmSubmissionMediaDownloadSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AdminCpmSubmissionMediaDownloadQuery, AdminCpmSubmissionMediaDownloadQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AdminCpmSubmissionMediaDownloadQuery | undefined, AdminCpmSubmissionMediaDownloadQueryVariables>;
export function useAdminCpmSubmissionMediaDownloadSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AdminCpmSubmissionMediaDownloadQuery, AdminCpmSubmissionMediaDownloadQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<AdminCpmSubmissionMediaDownloadQuery, AdminCpmSubmissionMediaDownloadQueryVariables>(AdminCpmSubmissionMediaDownloadDocument, options);
        }
export type AdminCpmSubmissionMediaDownloadQueryHookResult = ReturnType<typeof useAdminCpmSubmissionMediaDownloadQuery>;
export type AdminCpmSubmissionMediaDownloadLazyQueryHookResult = ReturnType<typeof useAdminCpmSubmissionMediaDownloadLazyQuery>;
export type AdminCpmSubmissionMediaDownloadSuspenseQueryHookResult = ReturnType<typeof useAdminCpmSubmissionMediaDownloadSuspenseQuery>;
export type AdminCpmSubmissionMediaDownloadQueryResult = Apollo.QueryResult<AdminCpmSubmissionMediaDownloadQuery, AdminCpmSubmissionMediaDownloadQueryVariables>;
export const AdminCreateCpmCampaignDocument = gql`
    mutation AdminCreateCpmCampaign($input: AdminCpmCampaignInput!) {
  adminCreateCpmCampaign(input: $input) {
    id
    name
    logo_url
    banner_url
    categories
    status
    watermark_image_url
    watermark_anchor
    watermark_size_percent
    watermark_opacity_percent
    watermark_margin_x_percent
    watermark_margin_y_percent
    enforced_post_layout
    enforced_subtitle_position
    editing_assets
  }
}
    `;
export type AdminCreateCpmCampaignMutationFn = Apollo.MutationFunction<AdminCreateCpmCampaignMutation, AdminCreateCpmCampaignMutationVariables>;

/**
 * __useAdminCreateCpmCampaignMutation__
 *
 * To run a mutation, you first call `useAdminCreateCpmCampaignMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminCreateCpmCampaignMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminCreateCpmCampaignMutation, { data, loading, error }] = useAdminCreateCpmCampaignMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdminCreateCpmCampaignMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AdminCreateCpmCampaignMutation, AdminCreateCpmCampaignMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AdminCreateCpmCampaignMutation, AdminCreateCpmCampaignMutationVariables>(AdminCreateCpmCampaignDocument, options);
      }
export type AdminCreateCpmCampaignMutationHookResult = ReturnType<typeof useAdminCreateCpmCampaignMutation>;
export type AdminCreateCpmCampaignMutationResult = Apollo.MutationResult<AdminCreateCpmCampaignMutation>;
export type AdminCreateCpmCampaignMutationOptions = Apollo.BaseMutationOptions<AdminCreateCpmCampaignMutation, AdminCreateCpmCampaignMutationVariables>;
export const AdminUpdateCpmCampaignDocument = gql`
    mutation AdminUpdateCpmCampaign($id: ID!, $input: AdminCpmCampaignInput!) {
  adminUpdateCpmCampaign(id: $id, input: $input) {
    id
    name
    logo_url
    banner_url
    categories
    status
    watermark_image_url
    watermark_anchor
    watermark_size_percent
    watermark_opacity_percent
    watermark_margin_x_percent
    watermark_margin_y_percent
    enforced_post_layout
    enforced_subtitle_position
    editing_assets
  }
}
    `;
export type AdminUpdateCpmCampaignMutationFn = Apollo.MutationFunction<AdminUpdateCpmCampaignMutation, AdminUpdateCpmCampaignMutationVariables>;

/**
 * __useAdminUpdateCpmCampaignMutation__
 *
 * To run a mutation, you first call `useAdminUpdateCpmCampaignMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminUpdateCpmCampaignMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminUpdateCpmCampaignMutation, { data, loading, error }] = useAdminUpdateCpmCampaignMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdminUpdateCpmCampaignMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AdminUpdateCpmCampaignMutation, AdminUpdateCpmCampaignMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AdminUpdateCpmCampaignMutation, AdminUpdateCpmCampaignMutationVariables>(AdminUpdateCpmCampaignDocument, options);
      }
export type AdminUpdateCpmCampaignMutationHookResult = ReturnType<typeof useAdminUpdateCpmCampaignMutation>;
export type AdminUpdateCpmCampaignMutationResult = Apollo.MutationResult<AdminUpdateCpmCampaignMutation>;
export type AdminUpdateCpmCampaignMutationOptions = Apollo.BaseMutationOptions<AdminUpdateCpmCampaignMutation, AdminUpdateCpmCampaignMutationVariables>;
export const AdminDeleteCpmCampaignDocument = gql`
    mutation AdminDeleteCpmCampaign($id: ID!, $force: Boolean) {
  adminDeleteCpmCampaign(id: $id, force: $force)
}
    `;
export type AdminDeleteCpmCampaignMutationFn = Apollo.MutationFunction<AdminDeleteCpmCampaignMutation, AdminDeleteCpmCampaignMutationVariables>;

/**
 * __useAdminDeleteCpmCampaignMutation__
 *
 * To run a mutation, you first call `useAdminDeleteCpmCampaignMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminDeleteCpmCampaignMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminDeleteCpmCampaignMutation, { data, loading, error }] = useAdminDeleteCpmCampaignMutation({
 *   variables: {
 *      id: // value for 'id'
 *      force: // value for 'force'
 *   },
 * });
 */
export function useAdminDeleteCpmCampaignMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AdminDeleteCpmCampaignMutation, AdminDeleteCpmCampaignMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AdminDeleteCpmCampaignMutation, AdminDeleteCpmCampaignMutationVariables>(AdminDeleteCpmCampaignDocument, options);
      }
export type AdminDeleteCpmCampaignMutationHookResult = ReturnType<typeof useAdminDeleteCpmCampaignMutation>;
export type AdminDeleteCpmCampaignMutationResult = Apollo.MutationResult<AdminDeleteCpmCampaignMutation>;
export type AdminDeleteCpmCampaignMutationOptions = Apollo.BaseMutationOptions<AdminDeleteCpmCampaignMutation, AdminDeleteCpmCampaignMutationVariables>;
export const AdminRecomputeCpmCampaignPayoutsDocument = gql`
    mutation AdminRecomputeCpmCampaignPayouts($campaignId: ID!) {
  adminRecomputeCpmCampaignPayouts(campaignId: $campaignId) {
    recomputed_count
    changed_count
    total_delta_cents
  }
}
    `;
export type AdminRecomputeCpmCampaignPayoutsMutationFn = Apollo.MutationFunction<AdminRecomputeCpmCampaignPayoutsMutation, AdminRecomputeCpmCampaignPayoutsMutationVariables>;

/**
 * __useAdminRecomputeCpmCampaignPayoutsMutation__
 *
 * To run a mutation, you first call `useAdminRecomputeCpmCampaignPayoutsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminRecomputeCpmCampaignPayoutsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminRecomputeCpmCampaignPayoutsMutation, { data, loading, error }] = useAdminRecomputeCpmCampaignPayoutsMutation({
 *   variables: {
 *      campaignId: // value for 'campaignId'
 *   },
 * });
 */
export function useAdminRecomputeCpmCampaignPayoutsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AdminRecomputeCpmCampaignPayoutsMutation, AdminRecomputeCpmCampaignPayoutsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AdminRecomputeCpmCampaignPayoutsMutation, AdminRecomputeCpmCampaignPayoutsMutationVariables>(AdminRecomputeCpmCampaignPayoutsDocument, options);
      }
export type AdminRecomputeCpmCampaignPayoutsMutationHookResult = ReturnType<typeof useAdminRecomputeCpmCampaignPayoutsMutation>;
export type AdminRecomputeCpmCampaignPayoutsMutationResult = Apollo.MutationResult<AdminRecomputeCpmCampaignPayoutsMutation>;
export type AdminRecomputeCpmCampaignPayoutsMutationOptions = Apollo.BaseMutationOptions<AdminRecomputeCpmCampaignPayoutsMutation, AdminRecomputeCpmCampaignPayoutsMutationVariables>;
export const AdminReviewCpmCampaignSubmissionDocument = gql`
    mutation AdminReviewCpmCampaignSubmission($id: ID!, $approval: String!, $reason: String, $images: [CpmReviewImageInput!]) {
  adminReviewCpmCampaignSubmission(
    id: $id
    approval: $approval
    reason: $reason
    images: $images
  ) {
    id
    admin_approval
    approval_reason
    rejection_images {
      url
      visibility
    }
    accumulated_payout_cents
    disqualified
    disqualification_reason
    last_counted_views
    latest_views
    pending_appeal_id
  }
}
    `;
export type AdminReviewCpmCampaignSubmissionMutationFn = Apollo.MutationFunction<AdminReviewCpmCampaignSubmissionMutation, AdminReviewCpmCampaignSubmissionMutationVariables>;

/**
 * __useAdminReviewCpmCampaignSubmissionMutation__
 *
 * To run a mutation, you first call `useAdminReviewCpmCampaignSubmissionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminReviewCpmCampaignSubmissionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminReviewCpmCampaignSubmissionMutation, { data, loading, error }] = useAdminReviewCpmCampaignSubmissionMutation({
 *   variables: {
 *      id: // value for 'id'
 *      approval: // value for 'approval'
 *      reason: // value for 'reason'
 *      images: // value for 'images'
 *   },
 * });
 */
export function useAdminReviewCpmCampaignSubmissionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AdminReviewCpmCampaignSubmissionMutation, AdminReviewCpmCampaignSubmissionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AdminReviewCpmCampaignSubmissionMutation, AdminReviewCpmCampaignSubmissionMutationVariables>(AdminReviewCpmCampaignSubmissionDocument, options);
      }
export type AdminReviewCpmCampaignSubmissionMutationHookResult = ReturnType<typeof useAdminReviewCpmCampaignSubmissionMutation>;
export type AdminReviewCpmCampaignSubmissionMutationResult = Apollo.MutationResult<AdminReviewCpmCampaignSubmissionMutation>;
export type AdminReviewCpmCampaignSubmissionMutationOptions = Apollo.BaseMutationOptions<AdminReviewCpmCampaignSubmissionMutation, AdminReviewCpmCampaignSubmissionMutationVariables>;
export const AdminLinkCpmSubmissionContentDocument = gql`
    mutation AdminLinkCpmSubmissionContent($submissionIds: [ID!]!, $reason: String) {
  adminLinkCpmSubmissionContent(submissionIds: $submissionIds, reason: $reason) {
    id
    decision
    decision_reason
    submission_ids
  }
}
    `;
export type AdminLinkCpmSubmissionContentMutationFn = Apollo.MutationFunction<AdminLinkCpmSubmissionContentMutation, AdminLinkCpmSubmissionContentMutationVariables>;

/**
 * __useAdminLinkCpmSubmissionContentMutation__
 *
 * To run a mutation, you first call `useAdminLinkCpmSubmissionContentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminLinkCpmSubmissionContentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminLinkCpmSubmissionContentMutation, { data, loading, error }] = useAdminLinkCpmSubmissionContentMutation({
 *   variables: {
 *      submissionIds: // value for 'submissionIds'
 *      reason: // value for 'reason'
 *   },
 * });
 */
export function useAdminLinkCpmSubmissionContentMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AdminLinkCpmSubmissionContentMutation, AdminLinkCpmSubmissionContentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AdminLinkCpmSubmissionContentMutation, AdminLinkCpmSubmissionContentMutationVariables>(AdminLinkCpmSubmissionContentDocument, options);
      }
export type AdminLinkCpmSubmissionContentMutationHookResult = ReturnType<typeof useAdminLinkCpmSubmissionContentMutation>;
export type AdminLinkCpmSubmissionContentMutationResult = Apollo.MutationResult<AdminLinkCpmSubmissionContentMutation>;
export type AdminLinkCpmSubmissionContentMutationOptions = Apollo.BaseMutationOptions<AdminLinkCpmSubmissionContentMutation, AdminLinkCpmSubmissionContentMutationVariables>;
export const AdminSetCpmCampaignSubmissionObservationDocument = gql`
    mutation AdminSetCpmCampaignSubmissionObservation($id: ID!, $observation: String) {
  adminSetCpmCampaignSubmissionObservation(id: $id, observation: $observation) {
    id
    admin_observation
  }
}
    `;
export type AdminSetCpmCampaignSubmissionObservationMutationFn = Apollo.MutationFunction<AdminSetCpmCampaignSubmissionObservationMutation, AdminSetCpmCampaignSubmissionObservationMutationVariables>;

/**
 * __useAdminSetCpmCampaignSubmissionObservationMutation__
 *
 * To run a mutation, you first call `useAdminSetCpmCampaignSubmissionObservationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminSetCpmCampaignSubmissionObservationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminSetCpmCampaignSubmissionObservationMutation, { data, loading, error }] = useAdminSetCpmCampaignSubmissionObservationMutation({
 *   variables: {
 *      id: // value for 'id'
 *      observation: // value for 'observation'
 *   },
 * });
 */
export function useAdminSetCpmCampaignSubmissionObservationMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AdminSetCpmCampaignSubmissionObservationMutation, AdminSetCpmCampaignSubmissionObservationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AdminSetCpmCampaignSubmissionObservationMutation, AdminSetCpmCampaignSubmissionObservationMutationVariables>(AdminSetCpmCampaignSubmissionObservationDocument, options);
      }
export type AdminSetCpmCampaignSubmissionObservationMutationHookResult = ReturnType<typeof useAdminSetCpmCampaignSubmissionObservationMutation>;
export type AdminSetCpmCampaignSubmissionObservationMutationResult = Apollo.MutationResult<AdminSetCpmCampaignSubmissionObservationMutation>;
export type AdminSetCpmCampaignSubmissionObservationMutationOptions = Apollo.BaseMutationOptions<AdminSetCpmCampaignSubmissionObservationMutation, AdminSetCpmCampaignSubmissionObservationMutationVariables>;
export const AdminSetCpmCampaignSubmissionCpmOverrideDocument = gql`
    mutation AdminSetCpmCampaignSubmissionCpmOverride($id: ID!, $cpm_rate_cents: Int) {
  adminSetCpmCampaignSubmissionCpmOverride(
    id: $id
    cpm_rate_cents: $cpm_rate_cents
  ) {
    id
    cpm_rate_override_cents
    accumulated_payout_cents
    last_counted_views
    latest_views
  }
}
    `;
export type AdminSetCpmCampaignSubmissionCpmOverrideMutationFn = Apollo.MutationFunction<AdminSetCpmCampaignSubmissionCpmOverrideMutation, AdminSetCpmCampaignSubmissionCpmOverrideMutationVariables>;

/**
 * __useAdminSetCpmCampaignSubmissionCpmOverrideMutation__
 *
 * To run a mutation, you first call `useAdminSetCpmCampaignSubmissionCpmOverrideMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminSetCpmCampaignSubmissionCpmOverrideMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminSetCpmCampaignSubmissionCpmOverrideMutation, { data, loading, error }] = useAdminSetCpmCampaignSubmissionCpmOverrideMutation({
 *   variables: {
 *      id: // value for 'id'
 *      cpm_rate_cents: // value for 'cpm_rate_cents'
 *   },
 * });
 */
export function useAdminSetCpmCampaignSubmissionCpmOverrideMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AdminSetCpmCampaignSubmissionCpmOverrideMutation, AdminSetCpmCampaignSubmissionCpmOverrideMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AdminSetCpmCampaignSubmissionCpmOverrideMutation, AdminSetCpmCampaignSubmissionCpmOverrideMutationVariables>(AdminSetCpmCampaignSubmissionCpmOverrideDocument, options);
      }
export type AdminSetCpmCampaignSubmissionCpmOverrideMutationHookResult = ReturnType<typeof useAdminSetCpmCampaignSubmissionCpmOverrideMutation>;
export type AdminSetCpmCampaignSubmissionCpmOverrideMutationResult = Apollo.MutationResult<AdminSetCpmCampaignSubmissionCpmOverrideMutation>;
export type AdminSetCpmCampaignSubmissionCpmOverrideMutationOptions = Apollo.BaseMutationOptions<AdminSetCpmCampaignSubmissionCpmOverrideMutation, AdminSetCpmCampaignSubmissionCpmOverrideMutationVariables>;
export const AdminResolveSuspectedDuplicateDocument = gql`
    mutation AdminResolveSuspectedDuplicate($id: ID!, $action: String!) {
  adminResolveSuspectedDuplicate(id: $id, action: $action) {
    id
    suspected_duplicate
    suspected_duplicate_reason
    disqualified
    disqualification_reason
    accumulated_payout_cents
  }
}
    `;
export type AdminResolveSuspectedDuplicateMutationFn = Apollo.MutationFunction<AdminResolveSuspectedDuplicateMutation, AdminResolveSuspectedDuplicateMutationVariables>;

/**
 * __useAdminResolveSuspectedDuplicateMutation__
 *
 * To run a mutation, you first call `useAdminResolveSuspectedDuplicateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminResolveSuspectedDuplicateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminResolveSuspectedDuplicateMutation, { data, loading, error }] = useAdminResolveSuspectedDuplicateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      action: // value for 'action'
 *   },
 * });
 */
export function useAdminResolveSuspectedDuplicateMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AdminResolveSuspectedDuplicateMutation, AdminResolveSuspectedDuplicateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AdminResolveSuspectedDuplicateMutation, AdminResolveSuspectedDuplicateMutationVariables>(AdminResolveSuspectedDuplicateDocument, options);
      }
export type AdminResolveSuspectedDuplicateMutationHookResult = ReturnType<typeof useAdminResolveSuspectedDuplicateMutation>;
export type AdminResolveSuspectedDuplicateMutationResult = Apollo.MutationResult<AdminResolveSuspectedDuplicateMutation>;
export type AdminResolveSuspectedDuplicateMutationOptions = Apollo.BaseMutationOptions<AdminResolveSuspectedDuplicateMutation, AdminResolveSuspectedDuplicateMutationVariables>;
export const AdminDisqualifyCpmCampaignSubmissionDocument = gql`
    mutation AdminDisqualifyCpmCampaignSubmission($id: ID!, $reason: String!) {
  adminDisqualifyCpmCampaignSubmission(id: $id, reason: $reason) {
    id
    disqualified
    disqualification_reason
  }
}
    `;
export type AdminDisqualifyCpmCampaignSubmissionMutationFn = Apollo.MutationFunction<AdminDisqualifyCpmCampaignSubmissionMutation, AdminDisqualifyCpmCampaignSubmissionMutationVariables>;

/**
 * __useAdminDisqualifyCpmCampaignSubmissionMutation__
 *
 * To run a mutation, you first call `useAdminDisqualifyCpmCampaignSubmissionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminDisqualifyCpmCampaignSubmissionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminDisqualifyCpmCampaignSubmissionMutation, { data, loading, error }] = useAdminDisqualifyCpmCampaignSubmissionMutation({
 *   variables: {
 *      id: // value for 'id'
 *      reason: // value for 'reason'
 *   },
 * });
 */
export function useAdminDisqualifyCpmCampaignSubmissionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AdminDisqualifyCpmCampaignSubmissionMutation, AdminDisqualifyCpmCampaignSubmissionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AdminDisqualifyCpmCampaignSubmissionMutation, AdminDisqualifyCpmCampaignSubmissionMutationVariables>(AdminDisqualifyCpmCampaignSubmissionDocument, options);
      }
export type AdminDisqualifyCpmCampaignSubmissionMutationHookResult = ReturnType<typeof useAdminDisqualifyCpmCampaignSubmissionMutation>;
export type AdminDisqualifyCpmCampaignSubmissionMutationResult = Apollo.MutationResult<AdminDisqualifyCpmCampaignSubmissionMutation>;
export type AdminDisqualifyCpmCampaignSubmissionMutationOptions = Apollo.BaseMutationOptions<AdminDisqualifyCpmCampaignSubmissionMutation, AdminDisqualifyCpmCampaignSubmissionMutationVariables>;
export const AdminCpmCampaignParticipantsDocument = gql`
    query AdminCpmCampaignParticipants($campaignId: ID!, $search: String, $disqualifiedOnly: Boolean, $limit: Int, $offset: Int) {
  adminCpmCampaignParticipants(
    campaignId: $campaignId
    search: $search
    disqualifiedOnly: $disqualifiedOnly
    limit: $limit
    offset: $offset
  ) {
    data {
      user_id
      user_name
      user_email
      submission_count
      approved_count
      total_views
      total_earnings_cents
      disqualified
      disqualification_reason
      disqualification_id
      first_submitted_at
    }
    total
    pageCount
  }
}
    `;

/**
 * __useAdminCpmCampaignParticipantsQuery__
 *
 * To run a query within a React component, call `useAdminCpmCampaignParticipantsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminCpmCampaignParticipantsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminCpmCampaignParticipantsQuery({
 *   variables: {
 *      campaignId: // value for 'campaignId'
 *      search: // value for 'search'
 *      disqualifiedOnly: // value for 'disqualifiedOnly'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useAdminCpmCampaignParticipantsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<AdminCpmCampaignParticipantsQuery, AdminCpmCampaignParticipantsQueryVariables> & ({ variables: AdminCpmCampaignParticipantsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AdminCpmCampaignParticipantsQuery, AdminCpmCampaignParticipantsQueryVariables>(AdminCpmCampaignParticipantsDocument, options);
      }
export function useAdminCpmCampaignParticipantsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AdminCpmCampaignParticipantsQuery, AdminCpmCampaignParticipantsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AdminCpmCampaignParticipantsQuery, AdminCpmCampaignParticipantsQueryVariables>(AdminCpmCampaignParticipantsDocument, options);
        }
// @ts-ignore
export function useAdminCpmCampaignParticipantsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<AdminCpmCampaignParticipantsQuery, AdminCpmCampaignParticipantsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AdminCpmCampaignParticipantsQuery, AdminCpmCampaignParticipantsQueryVariables>;
export function useAdminCpmCampaignParticipantsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AdminCpmCampaignParticipantsQuery, AdminCpmCampaignParticipantsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AdminCpmCampaignParticipantsQuery | undefined, AdminCpmCampaignParticipantsQueryVariables>;
export function useAdminCpmCampaignParticipantsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AdminCpmCampaignParticipantsQuery, AdminCpmCampaignParticipantsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<AdminCpmCampaignParticipantsQuery, AdminCpmCampaignParticipantsQueryVariables>(AdminCpmCampaignParticipantsDocument, options);
        }
export type AdminCpmCampaignParticipantsQueryHookResult = ReturnType<typeof useAdminCpmCampaignParticipantsQuery>;
export type AdminCpmCampaignParticipantsLazyQueryHookResult = ReturnType<typeof useAdminCpmCampaignParticipantsLazyQuery>;
export type AdminCpmCampaignParticipantsSuspenseQueryHookResult = ReturnType<typeof useAdminCpmCampaignParticipantsSuspenseQuery>;
export type AdminCpmCampaignParticipantsQueryResult = Apollo.QueryResult<AdminCpmCampaignParticipantsQuery, AdminCpmCampaignParticipantsQueryVariables>;
export const AdminDisqualifyCpmCampaignUserDocument = gql`
    mutation AdminDisqualifyCpmCampaignUser($campaignId: ID!, $userId: ID!, $reason: String!) {
  adminDisqualifyCpmCampaignUser(
    campaignId: $campaignId
    userId: $userId
    reason: $reason
  ) {
    id
    user_id
    reason
    createdAt
    reclaimed_cents
  }
}
    `;
export type AdminDisqualifyCpmCampaignUserMutationFn = Apollo.MutationFunction<AdminDisqualifyCpmCampaignUserMutation, AdminDisqualifyCpmCampaignUserMutationVariables>;

/**
 * __useAdminDisqualifyCpmCampaignUserMutation__
 *
 * To run a mutation, you first call `useAdminDisqualifyCpmCampaignUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminDisqualifyCpmCampaignUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminDisqualifyCpmCampaignUserMutation, { data, loading, error }] = useAdminDisqualifyCpmCampaignUserMutation({
 *   variables: {
 *      campaignId: // value for 'campaignId'
 *      userId: // value for 'userId'
 *      reason: // value for 'reason'
 *   },
 * });
 */
export function useAdminDisqualifyCpmCampaignUserMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AdminDisqualifyCpmCampaignUserMutation, AdminDisqualifyCpmCampaignUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AdminDisqualifyCpmCampaignUserMutation, AdminDisqualifyCpmCampaignUserMutationVariables>(AdminDisqualifyCpmCampaignUserDocument, options);
      }
export type AdminDisqualifyCpmCampaignUserMutationHookResult = ReturnType<typeof useAdminDisqualifyCpmCampaignUserMutation>;
export type AdminDisqualifyCpmCampaignUserMutationResult = Apollo.MutationResult<AdminDisqualifyCpmCampaignUserMutation>;
export type AdminDisqualifyCpmCampaignUserMutationOptions = Apollo.BaseMutationOptions<AdminDisqualifyCpmCampaignUserMutation, AdminDisqualifyCpmCampaignUserMutationVariables>;
export const AdminUndisqualifyCpmCampaignUserDocument = gql`
    mutation AdminUndisqualifyCpmCampaignUser($campaignId: ID!, $userId: ID!) {
  adminUndisqualifyCpmCampaignUser(campaignId: $campaignId, userId: $userId)
}
    `;
export type AdminUndisqualifyCpmCampaignUserMutationFn = Apollo.MutationFunction<AdminUndisqualifyCpmCampaignUserMutation, AdminUndisqualifyCpmCampaignUserMutationVariables>;

/**
 * __useAdminUndisqualifyCpmCampaignUserMutation__
 *
 * To run a mutation, you first call `useAdminUndisqualifyCpmCampaignUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminUndisqualifyCpmCampaignUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminUndisqualifyCpmCampaignUserMutation, { data, loading, error }] = useAdminUndisqualifyCpmCampaignUserMutation({
 *   variables: {
 *      campaignId: // value for 'campaignId'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useAdminUndisqualifyCpmCampaignUserMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AdminUndisqualifyCpmCampaignUserMutation, AdminUndisqualifyCpmCampaignUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AdminUndisqualifyCpmCampaignUserMutation, AdminUndisqualifyCpmCampaignUserMutationVariables>(AdminUndisqualifyCpmCampaignUserDocument, options);
      }
export type AdminUndisqualifyCpmCampaignUserMutationHookResult = ReturnType<typeof useAdminUndisqualifyCpmCampaignUserMutation>;
export type AdminUndisqualifyCpmCampaignUserMutationResult = Apollo.MutationResult<AdminUndisqualifyCpmCampaignUserMutation>;
export type AdminUndisqualifyCpmCampaignUserMutationOptions = Apollo.BaseMutationOptions<AdminUndisqualifyCpmCampaignUserMutation, AdminUndisqualifyCpmCampaignUserMutationVariables>;
export const AdminForceUpdateCpmCampaignSubmissionViewDocument = gql`
    mutation AdminForceUpdateCpmCampaignSubmissionView($id: ID!) {
  adminForceUpdateCpmCampaignSubmissionView(id: $id)
}
    `;
export type AdminForceUpdateCpmCampaignSubmissionViewMutationFn = Apollo.MutationFunction<AdminForceUpdateCpmCampaignSubmissionViewMutation, AdminForceUpdateCpmCampaignSubmissionViewMutationVariables>;

/**
 * __useAdminForceUpdateCpmCampaignSubmissionViewMutation__
 *
 * To run a mutation, you first call `useAdminForceUpdateCpmCampaignSubmissionViewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminForceUpdateCpmCampaignSubmissionViewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminForceUpdateCpmCampaignSubmissionViewMutation, { data, loading, error }] = useAdminForceUpdateCpmCampaignSubmissionViewMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAdminForceUpdateCpmCampaignSubmissionViewMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AdminForceUpdateCpmCampaignSubmissionViewMutation, AdminForceUpdateCpmCampaignSubmissionViewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AdminForceUpdateCpmCampaignSubmissionViewMutation, AdminForceUpdateCpmCampaignSubmissionViewMutationVariables>(AdminForceUpdateCpmCampaignSubmissionViewDocument, options);
      }
export type AdminForceUpdateCpmCampaignSubmissionViewMutationHookResult = ReturnType<typeof useAdminForceUpdateCpmCampaignSubmissionViewMutation>;
export type AdminForceUpdateCpmCampaignSubmissionViewMutationResult = Apollo.MutationResult<AdminForceUpdateCpmCampaignSubmissionViewMutation>;
export type AdminForceUpdateCpmCampaignSubmissionViewMutationOptions = Apollo.BaseMutationOptions<AdminForceUpdateCpmCampaignSubmissionViewMutation, AdminForceUpdateCpmCampaignSubmissionViewMutationVariables>;
export const AdminForceUpdateAllCpmCampaignSubmissionViewsDocument = gql`
    mutation AdminForceUpdateAllCpmCampaignSubmissionViews($campaignId: ID!) {
  adminForceUpdateAllCpmCampaignSubmissionViews(campaignId: $campaignId)
}
    `;
export type AdminForceUpdateAllCpmCampaignSubmissionViewsMutationFn = Apollo.MutationFunction<AdminForceUpdateAllCpmCampaignSubmissionViewsMutation, AdminForceUpdateAllCpmCampaignSubmissionViewsMutationVariables>;

/**
 * __useAdminForceUpdateAllCpmCampaignSubmissionViewsMutation__
 *
 * To run a mutation, you first call `useAdminForceUpdateAllCpmCampaignSubmissionViewsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminForceUpdateAllCpmCampaignSubmissionViewsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminForceUpdateAllCpmCampaignSubmissionViewsMutation, { data, loading, error }] = useAdminForceUpdateAllCpmCampaignSubmissionViewsMutation({
 *   variables: {
 *      campaignId: // value for 'campaignId'
 *   },
 * });
 */
export function useAdminForceUpdateAllCpmCampaignSubmissionViewsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AdminForceUpdateAllCpmCampaignSubmissionViewsMutation, AdminForceUpdateAllCpmCampaignSubmissionViewsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AdminForceUpdateAllCpmCampaignSubmissionViewsMutation, AdminForceUpdateAllCpmCampaignSubmissionViewsMutationVariables>(AdminForceUpdateAllCpmCampaignSubmissionViewsDocument, options);
      }
export type AdminForceUpdateAllCpmCampaignSubmissionViewsMutationHookResult = ReturnType<typeof useAdminForceUpdateAllCpmCampaignSubmissionViewsMutation>;
export type AdminForceUpdateAllCpmCampaignSubmissionViewsMutationResult = Apollo.MutationResult<AdminForceUpdateAllCpmCampaignSubmissionViewsMutation>;
export type AdminForceUpdateAllCpmCampaignSubmissionViewsMutationOptions = Apollo.BaseMutationOptions<AdminForceUpdateAllCpmCampaignSubmissionViewsMutation, AdminForceUpdateAllCpmCampaignSubmissionViewsMutationVariables>;
export const AdminSyncMissingCpmCampaignSubmissionViewsDocument = gql`
    mutation AdminSyncMissingCpmCampaignSubmissionViews($campaignId: ID!) {
  adminSyncMissingCpmCampaignSubmissionViews(campaignId: $campaignId)
}
    `;
export type AdminSyncMissingCpmCampaignSubmissionViewsMutationFn = Apollo.MutationFunction<AdminSyncMissingCpmCampaignSubmissionViewsMutation, AdminSyncMissingCpmCampaignSubmissionViewsMutationVariables>;

/**
 * __useAdminSyncMissingCpmCampaignSubmissionViewsMutation__
 *
 * To run a mutation, you first call `useAdminSyncMissingCpmCampaignSubmissionViewsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminSyncMissingCpmCampaignSubmissionViewsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminSyncMissingCpmCampaignSubmissionViewsMutation, { data, loading, error }] = useAdminSyncMissingCpmCampaignSubmissionViewsMutation({
 *   variables: {
 *      campaignId: // value for 'campaignId'
 *   },
 * });
 */
export function useAdminSyncMissingCpmCampaignSubmissionViewsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AdminSyncMissingCpmCampaignSubmissionViewsMutation, AdminSyncMissingCpmCampaignSubmissionViewsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AdminSyncMissingCpmCampaignSubmissionViewsMutation, AdminSyncMissingCpmCampaignSubmissionViewsMutationVariables>(AdminSyncMissingCpmCampaignSubmissionViewsDocument, options);
      }
export type AdminSyncMissingCpmCampaignSubmissionViewsMutationHookResult = ReturnType<typeof useAdminSyncMissingCpmCampaignSubmissionViewsMutation>;
export type AdminSyncMissingCpmCampaignSubmissionViewsMutationResult = Apollo.MutationResult<AdminSyncMissingCpmCampaignSubmissionViewsMutation>;
export type AdminSyncMissingCpmCampaignSubmissionViewsMutationOptions = Apollo.BaseMutationOptions<AdminSyncMissingCpmCampaignSubmissionViewsMutation, AdminSyncMissingCpmCampaignSubmissionViewsMutationVariables>;
export const AdminSetCpmCampaignSubmissionHashtagValidationDocument = gql`
    mutation AdminSetCpmCampaignSubmissionHashtagValidation($id: ID!, $validated_hashtags: String!) {
  adminSetCpmCampaignSubmissionHashtagValidation(
    id: $id
    validated_hashtags: $validated_hashtags
  )
}
    `;
export type AdminSetCpmCampaignSubmissionHashtagValidationMutationFn = Apollo.MutationFunction<AdminSetCpmCampaignSubmissionHashtagValidationMutation, AdminSetCpmCampaignSubmissionHashtagValidationMutationVariables>;

/**
 * __useAdminSetCpmCampaignSubmissionHashtagValidationMutation__
 *
 * To run a mutation, you first call `useAdminSetCpmCampaignSubmissionHashtagValidationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminSetCpmCampaignSubmissionHashtagValidationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminSetCpmCampaignSubmissionHashtagValidationMutation, { data, loading, error }] = useAdminSetCpmCampaignSubmissionHashtagValidationMutation({
 *   variables: {
 *      id: // value for 'id'
 *      validated_hashtags: // value for 'validated_hashtags'
 *   },
 * });
 */
export function useAdminSetCpmCampaignSubmissionHashtagValidationMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AdminSetCpmCampaignSubmissionHashtagValidationMutation, AdminSetCpmCampaignSubmissionHashtagValidationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AdminSetCpmCampaignSubmissionHashtagValidationMutation, AdminSetCpmCampaignSubmissionHashtagValidationMutationVariables>(AdminSetCpmCampaignSubmissionHashtagValidationDocument, options);
      }
export type AdminSetCpmCampaignSubmissionHashtagValidationMutationHookResult = ReturnType<typeof useAdminSetCpmCampaignSubmissionHashtagValidationMutation>;
export type AdminSetCpmCampaignSubmissionHashtagValidationMutationResult = Apollo.MutationResult<AdminSetCpmCampaignSubmissionHashtagValidationMutation>;
export type AdminSetCpmCampaignSubmissionHashtagValidationMutationOptions = Apollo.BaseMutationOptions<AdminSetCpmCampaignSubmissionHashtagValidationMutation, AdminSetCpmCampaignSubmissionHashtagValidationMutationVariables>;
export const AdminCpmCampaignSubmissionAppealsDocument = gql`
    query AdminCpmCampaignSubmissionAppeals($campaignId: ID!, $status: String, $limit: Int, $offset: Int) {
  adminCpmCampaignSubmissionAppeals(
    campaignId: $campaignId
    status: $status
    limit: $limit
    offset: $offset
  ) {
    data {
      id
      submission_id
      user_name
      user_email
      platform
      url
      argument
      extra_url
      evidence_image_urls
      status
      original_approval_reason
      reviewer_reply
      reviewer_images {
        url
        visibility
      }
      createdAt
      reviewed_at
    }
    total
    pageCount
  }
}
    `;

/**
 * __useAdminCpmCampaignSubmissionAppealsQuery__
 *
 * To run a query within a React component, call `useAdminCpmCampaignSubmissionAppealsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminCpmCampaignSubmissionAppealsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminCpmCampaignSubmissionAppealsQuery({
 *   variables: {
 *      campaignId: // value for 'campaignId'
 *      status: // value for 'status'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useAdminCpmCampaignSubmissionAppealsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<AdminCpmCampaignSubmissionAppealsQuery, AdminCpmCampaignSubmissionAppealsQueryVariables> & ({ variables: AdminCpmCampaignSubmissionAppealsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AdminCpmCampaignSubmissionAppealsQuery, AdminCpmCampaignSubmissionAppealsQueryVariables>(AdminCpmCampaignSubmissionAppealsDocument, options);
      }
export function useAdminCpmCampaignSubmissionAppealsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AdminCpmCampaignSubmissionAppealsQuery, AdminCpmCampaignSubmissionAppealsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AdminCpmCampaignSubmissionAppealsQuery, AdminCpmCampaignSubmissionAppealsQueryVariables>(AdminCpmCampaignSubmissionAppealsDocument, options);
        }
// @ts-ignore
export function useAdminCpmCampaignSubmissionAppealsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<AdminCpmCampaignSubmissionAppealsQuery, AdminCpmCampaignSubmissionAppealsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AdminCpmCampaignSubmissionAppealsQuery, AdminCpmCampaignSubmissionAppealsQueryVariables>;
export function useAdminCpmCampaignSubmissionAppealsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AdminCpmCampaignSubmissionAppealsQuery, AdminCpmCampaignSubmissionAppealsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AdminCpmCampaignSubmissionAppealsQuery | undefined, AdminCpmCampaignSubmissionAppealsQueryVariables>;
export function useAdminCpmCampaignSubmissionAppealsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AdminCpmCampaignSubmissionAppealsQuery, AdminCpmCampaignSubmissionAppealsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<AdminCpmCampaignSubmissionAppealsQuery, AdminCpmCampaignSubmissionAppealsQueryVariables>(AdminCpmCampaignSubmissionAppealsDocument, options);
        }
export type AdminCpmCampaignSubmissionAppealsQueryHookResult = ReturnType<typeof useAdminCpmCampaignSubmissionAppealsQuery>;
export type AdminCpmCampaignSubmissionAppealsLazyQueryHookResult = ReturnType<typeof useAdminCpmCampaignSubmissionAppealsLazyQuery>;
export type AdminCpmCampaignSubmissionAppealsSuspenseQueryHookResult = ReturnType<typeof useAdminCpmCampaignSubmissionAppealsSuspenseQuery>;
export type AdminCpmCampaignSubmissionAppealsQueryResult = Apollo.QueryResult<AdminCpmCampaignSubmissionAppealsQuery, AdminCpmCampaignSubmissionAppealsQueryVariables>;
export const AdminReviewCpmCampaignSubmissionAppealDocument = gql`
    mutation AdminReviewCpmCampaignSubmissionAppeal($id: ID!, $decision: String!, $reply: String, $images: [CpmReviewImageInput!]) {
  adminReviewCpmCampaignSubmissionAppeal(
    id: $id
    decision: $decision
    reply: $reply
    images: $images
  ) {
    id
    status
    reviewer_reply
    reviewer_images {
      url
      visibility
    }
    reviewed_at
    submission_id
  }
}
    `;
export type AdminReviewCpmCampaignSubmissionAppealMutationFn = Apollo.MutationFunction<AdminReviewCpmCampaignSubmissionAppealMutation, AdminReviewCpmCampaignSubmissionAppealMutationVariables>;

/**
 * __useAdminReviewCpmCampaignSubmissionAppealMutation__
 *
 * To run a mutation, you first call `useAdminReviewCpmCampaignSubmissionAppealMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminReviewCpmCampaignSubmissionAppealMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminReviewCpmCampaignSubmissionAppealMutation, { data, loading, error }] = useAdminReviewCpmCampaignSubmissionAppealMutation({
 *   variables: {
 *      id: // value for 'id'
 *      decision: // value for 'decision'
 *      reply: // value for 'reply'
 *      images: // value for 'images'
 *   },
 * });
 */
export function useAdminReviewCpmCampaignSubmissionAppealMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AdminReviewCpmCampaignSubmissionAppealMutation, AdminReviewCpmCampaignSubmissionAppealMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AdminReviewCpmCampaignSubmissionAppealMutation, AdminReviewCpmCampaignSubmissionAppealMutationVariables>(AdminReviewCpmCampaignSubmissionAppealDocument, options);
      }
export type AdminReviewCpmCampaignSubmissionAppealMutationHookResult = ReturnType<typeof useAdminReviewCpmCampaignSubmissionAppealMutation>;
export type AdminReviewCpmCampaignSubmissionAppealMutationResult = Apollo.MutationResult<AdminReviewCpmCampaignSubmissionAppealMutation>;
export type AdminReviewCpmCampaignSubmissionAppealMutationOptions = Apollo.BaseMutationOptions<AdminReviewCpmCampaignSubmissionAppealMutation, AdminReviewCpmCampaignSubmissionAppealMutationVariables>;
export const AdminBulkReviewCpmCampaignSubmissionsDocument = gql`
    mutation AdminBulkReviewCpmCampaignSubmissions($ids: [ID!]!) {
  adminBulkReviewCpmCampaignSubmissions(ids: $ids) {
    approved
    skipped {
      id
      code
    }
  }
}
    `;
export type AdminBulkReviewCpmCampaignSubmissionsMutationFn = Apollo.MutationFunction<AdminBulkReviewCpmCampaignSubmissionsMutation, AdminBulkReviewCpmCampaignSubmissionsMutationVariables>;

/**
 * __useAdminBulkReviewCpmCampaignSubmissionsMutation__
 *
 * To run a mutation, you first call `useAdminBulkReviewCpmCampaignSubmissionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminBulkReviewCpmCampaignSubmissionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminBulkReviewCpmCampaignSubmissionsMutation, { data, loading, error }] = useAdminBulkReviewCpmCampaignSubmissionsMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useAdminBulkReviewCpmCampaignSubmissionsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AdminBulkReviewCpmCampaignSubmissionsMutation, AdminBulkReviewCpmCampaignSubmissionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AdminBulkReviewCpmCampaignSubmissionsMutation, AdminBulkReviewCpmCampaignSubmissionsMutationVariables>(AdminBulkReviewCpmCampaignSubmissionsDocument, options);
      }
export type AdminBulkReviewCpmCampaignSubmissionsMutationHookResult = ReturnType<typeof useAdminBulkReviewCpmCampaignSubmissionsMutation>;
export type AdminBulkReviewCpmCampaignSubmissionsMutationResult = Apollo.MutationResult<AdminBulkReviewCpmCampaignSubmissionsMutation>;
export type AdminBulkReviewCpmCampaignSubmissionsMutationOptions = Apollo.BaseMutationOptions<AdminBulkReviewCpmCampaignSubmissionsMutation, AdminBulkReviewCpmCampaignSubmissionsMutationVariables>;
export const MyCpmWalletDocument = gql`
    query MyCpmWallet {
  myCpmWallet {
    total_earned_cents
    total_paid_out_cents
    pending_cents
    pending_payout_cents
    affiliate_pending_cents
    available_cents
    affiliate_earned_cents
    producer_earned_cents
    currency
    pending_kind
    per_campaign_breakdown {
      campaign_id
      campaign_name
      earned_cents
    }
  }
}
    `;

/**
 * __useMyCpmWalletQuery__
 *
 * To run a query within a React component, call `useMyCpmWalletQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyCpmWalletQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyCpmWalletQuery({
 *   variables: {
 *   },
 * });
 */
export function useMyCpmWalletQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<MyCpmWalletQuery, MyCpmWalletQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<MyCpmWalletQuery, MyCpmWalletQueryVariables>(MyCpmWalletDocument, options);
      }
export function useMyCpmWalletLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<MyCpmWalletQuery, MyCpmWalletQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<MyCpmWalletQuery, MyCpmWalletQueryVariables>(MyCpmWalletDocument, options);
        }
// @ts-ignore
export function useMyCpmWalletSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<MyCpmWalletQuery, MyCpmWalletQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<MyCpmWalletQuery, MyCpmWalletQueryVariables>;
export function useMyCpmWalletSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<MyCpmWalletQuery, MyCpmWalletQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<MyCpmWalletQuery | undefined, MyCpmWalletQueryVariables>;
export function useMyCpmWalletSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<MyCpmWalletQuery, MyCpmWalletQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<MyCpmWalletQuery, MyCpmWalletQueryVariables>(MyCpmWalletDocument, options);
        }
export type MyCpmWalletQueryHookResult = ReturnType<typeof useMyCpmWalletQuery>;
export type MyCpmWalletLazyQueryHookResult = ReturnType<typeof useMyCpmWalletLazyQuery>;
export type MyCpmWalletSuspenseQueryHookResult = ReturnType<typeof useMyCpmWalletSuspenseQuery>;
export type MyCpmWalletQueryResult = Apollo.QueryResult<MyCpmWalletQuery, MyCpmWalletQueryVariables>;
export const MyPixVerificationDocument = gql`
    query MyPixVerification {
  myPixVerification {
    id
    cpf
    status
    review_reason
    submitted_at
    reviewed_at
    createdAt
  }
}
    `;

/**
 * __useMyPixVerificationQuery__
 *
 * To run a query within a React component, call `useMyPixVerificationQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyPixVerificationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyPixVerificationQuery({
 *   variables: {
 *   },
 * });
 */
export function useMyPixVerificationQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<MyPixVerificationQuery, MyPixVerificationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<MyPixVerificationQuery, MyPixVerificationQueryVariables>(MyPixVerificationDocument, options);
      }
export function useMyPixVerificationLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<MyPixVerificationQuery, MyPixVerificationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<MyPixVerificationQuery, MyPixVerificationQueryVariables>(MyPixVerificationDocument, options);
        }
// @ts-ignore
export function useMyPixVerificationSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<MyPixVerificationQuery, MyPixVerificationQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<MyPixVerificationQuery, MyPixVerificationQueryVariables>;
export function useMyPixVerificationSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<MyPixVerificationQuery, MyPixVerificationQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<MyPixVerificationQuery | undefined, MyPixVerificationQueryVariables>;
export function useMyPixVerificationSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<MyPixVerificationQuery, MyPixVerificationQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<MyPixVerificationQuery, MyPixVerificationQueryVariables>(MyPixVerificationDocument, options);
        }
export type MyPixVerificationQueryHookResult = ReturnType<typeof useMyPixVerificationQuery>;
export type MyPixVerificationLazyQueryHookResult = ReturnType<typeof useMyPixVerificationLazyQuery>;
export type MyPixVerificationSuspenseQueryHookResult = ReturnType<typeof useMyPixVerificationSuspenseQuery>;
export type MyPixVerificationQueryResult = Apollo.QueryResult<MyPixVerificationQuery, MyPixVerificationQueryVariables>;
export const SubmitMyPixVerificationDocument = gql`
    mutation SubmitMyPixVerification($cpf: String!, $document_url: String!, $document_back_url: String) {
  submitMyPixVerification(
    cpf: $cpf
    document_url: $document_url
    document_back_url: $document_back_url
  ) {
    id
    cpf
    status
    review_reason
    submitted_at
    reviewed_at
    createdAt
  }
}
    `;
export type SubmitMyPixVerificationMutationFn = Apollo.MutationFunction<SubmitMyPixVerificationMutation, SubmitMyPixVerificationMutationVariables>;

/**
 * __useSubmitMyPixVerificationMutation__
 *
 * To run a mutation, you first call `useSubmitMyPixVerificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitMyPixVerificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitMyPixVerificationMutation, { data, loading, error }] = useSubmitMyPixVerificationMutation({
 *   variables: {
 *      cpf: // value for 'cpf'
 *      document_url: // value for 'document_url'
 *      document_back_url: // value for 'document_back_url'
 *   },
 * });
 */
export function useSubmitMyPixVerificationMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SubmitMyPixVerificationMutation, SubmitMyPixVerificationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SubmitMyPixVerificationMutation, SubmitMyPixVerificationMutationVariables>(SubmitMyPixVerificationDocument, options);
      }
export type SubmitMyPixVerificationMutationHookResult = ReturnType<typeof useSubmitMyPixVerificationMutation>;
export type SubmitMyPixVerificationMutationResult = Apollo.MutationResult<SubmitMyPixVerificationMutation>;
export type SubmitMyPixVerificationMutationOptions = Apollo.BaseMutationOptions<SubmitMyPixVerificationMutation, SubmitMyPixVerificationMutationVariables>;
export const AdminPixVerificationsDocument = gql`
    query AdminPixVerifications($status: String, $search: String, $limit: Int, $offset: Int) {
  adminPixVerifications(
    status: $status
    search: $search
    limit: $limit
    offset: $offset
  ) {
    data {
      id
      cpf
      status
      review_reason
      submitted_at
      reviewed_at
      createdAt
      document_url
      document_back_url
      user_id
      user_email
      user_name
      reviewed_by_id
      reviewed_by_name
    }
    total
    pageCount
  }
}
    `;

/**
 * __useAdminPixVerificationsQuery__
 *
 * To run a query within a React component, call `useAdminPixVerificationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminPixVerificationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminPixVerificationsQuery({
 *   variables: {
 *      status: // value for 'status'
 *      search: // value for 'search'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useAdminPixVerificationsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<AdminPixVerificationsQuery, AdminPixVerificationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AdminPixVerificationsQuery, AdminPixVerificationsQueryVariables>(AdminPixVerificationsDocument, options);
      }
export function useAdminPixVerificationsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AdminPixVerificationsQuery, AdminPixVerificationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AdminPixVerificationsQuery, AdminPixVerificationsQueryVariables>(AdminPixVerificationsDocument, options);
        }
// @ts-ignore
export function useAdminPixVerificationsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<AdminPixVerificationsQuery, AdminPixVerificationsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AdminPixVerificationsQuery, AdminPixVerificationsQueryVariables>;
export function useAdminPixVerificationsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AdminPixVerificationsQuery, AdminPixVerificationsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AdminPixVerificationsQuery | undefined, AdminPixVerificationsQueryVariables>;
export function useAdminPixVerificationsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AdminPixVerificationsQuery, AdminPixVerificationsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<AdminPixVerificationsQuery, AdminPixVerificationsQueryVariables>(AdminPixVerificationsDocument, options);
        }
export type AdminPixVerificationsQueryHookResult = ReturnType<typeof useAdminPixVerificationsQuery>;
export type AdminPixVerificationsLazyQueryHookResult = ReturnType<typeof useAdminPixVerificationsLazyQuery>;
export type AdminPixVerificationsSuspenseQueryHookResult = ReturnType<typeof useAdminPixVerificationsSuspenseQuery>;
export type AdminPixVerificationsQueryResult = Apollo.QueryResult<AdminPixVerificationsQuery, AdminPixVerificationsQueryVariables>;
export const AdminPixVerificationDocumentUrlDocument = gql`
    query AdminPixVerificationDocumentUrl($id: ID!, $side: String) {
  adminPixVerificationDocumentUrl(id: $id, side: $side)
}
    `;

/**
 * __useAdminPixVerificationDocumentUrlQuery__
 *
 * To run a query within a React component, call `useAdminPixVerificationDocumentUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminPixVerificationDocumentUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminPixVerificationDocumentUrlQuery({
 *   variables: {
 *      id: // value for 'id'
 *      side: // value for 'side'
 *   },
 * });
 */
export function useAdminPixVerificationDocumentUrlQuery(baseOptions: ApolloReactHooks.QueryHookOptions<AdminPixVerificationDocumentUrlQuery, AdminPixVerificationDocumentUrlQueryVariables> & ({ variables: AdminPixVerificationDocumentUrlQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AdminPixVerificationDocumentUrlQuery, AdminPixVerificationDocumentUrlQueryVariables>(AdminPixVerificationDocumentUrlDocument, options);
      }
export function useAdminPixVerificationDocumentUrlLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AdminPixVerificationDocumentUrlQuery, AdminPixVerificationDocumentUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AdminPixVerificationDocumentUrlQuery, AdminPixVerificationDocumentUrlQueryVariables>(AdminPixVerificationDocumentUrlDocument, options);
        }
// @ts-ignore
export function useAdminPixVerificationDocumentUrlSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<AdminPixVerificationDocumentUrlQuery, AdminPixVerificationDocumentUrlQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AdminPixVerificationDocumentUrlQuery, AdminPixVerificationDocumentUrlQueryVariables>;
export function useAdminPixVerificationDocumentUrlSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AdminPixVerificationDocumentUrlQuery, AdminPixVerificationDocumentUrlQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AdminPixVerificationDocumentUrlQuery | undefined, AdminPixVerificationDocumentUrlQueryVariables>;
export function useAdminPixVerificationDocumentUrlSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AdminPixVerificationDocumentUrlQuery, AdminPixVerificationDocumentUrlQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<AdminPixVerificationDocumentUrlQuery, AdminPixVerificationDocumentUrlQueryVariables>(AdminPixVerificationDocumentUrlDocument, options);
        }
export type AdminPixVerificationDocumentUrlQueryHookResult = ReturnType<typeof useAdminPixVerificationDocumentUrlQuery>;
export type AdminPixVerificationDocumentUrlLazyQueryHookResult = ReturnType<typeof useAdminPixVerificationDocumentUrlLazyQuery>;
export type AdminPixVerificationDocumentUrlSuspenseQueryHookResult = ReturnType<typeof useAdminPixVerificationDocumentUrlSuspenseQuery>;
export type AdminPixVerificationDocumentUrlQueryResult = Apollo.QueryResult<AdminPixVerificationDocumentUrlQuery, AdminPixVerificationDocumentUrlQueryVariables>;
export const AdminReviewPixVerificationDocument = gql`
    mutation AdminReviewPixVerification($id: ID!, $status: String!, $reason: String) {
  adminReviewPixVerification(id: $id, status: $status, reason: $reason) {
    id
    status
    review_reason
    reviewed_at
    reviewed_by_id
    reviewed_by_name
  }
}
    `;
export type AdminReviewPixVerificationMutationFn = Apollo.MutationFunction<AdminReviewPixVerificationMutation, AdminReviewPixVerificationMutationVariables>;

/**
 * __useAdminReviewPixVerificationMutation__
 *
 * To run a mutation, you first call `useAdminReviewPixVerificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminReviewPixVerificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminReviewPixVerificationMutation, { data, loading, error }] = useAdminReviewPixVerificationMutation({
 *   variables: {
 *      id: // value for 'id'
 *      status: // value for 'status'
 *      reason: // value for 'reason'
 *   },
 * });
 */
export function useAdminReviewPixVerificationMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AdminReviewPixVerificationMutation, AdminReviewPixVerificationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AdminReviewPixVerificationMutation, AdminReviewPixVerificationMutationVariables>(AdminReviewPixVerificationDocument, options);
      }
export type AdminReviewPixVerificationMutationHookResult = ReturnType<typeof useAdminReviewPixVerificationMutation>;
export type AdminReviewPixVerificationMutationResult = Apollo.MutationResult<AdminReviewPixVerificationMutation>;
export type AdminReviewPixVerificationMutationOptions = Apollo.BaseMutationOptions<AdminReviewPixVerificationMutation, AdminReviewPixVerificationMutationVariables>;
export const MyAffiliateStatusDocument = gql`
    query MyAffiliateStatus {
  myAffiliateStatus {
    ...AffiliateStatusFields
  }
}
    ${AffiliateStatusFieldsFragmentDoc}`;

/**
 * __useMyAffiliateStatusQuery__
 *
 * To run a query within a React component, call `useMyAffiliateStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyAffiliateStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyAffiliateStatusQuery({
 *   variables: {
 *   },
 * });
 */
export function useMyAffiliateStatusQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<MyAffiliateStatusQuery, MyAffiliateStatusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<MyAffiliateStatusQuery, MyAffiliateStatusQueryVariables>(MyAffiliateStatusDocument, options);
      }
export function useMyAffiliateStatusLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<MyAffiliateStatusQuery, MyAffiliateStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<MyAffiliateStatusQuery, MyAffiliateStatusQueryVariables>(MyAffiliateStatusDocument, options);
        }
// @ts-ignore
export function useMyAffiliateStatusSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<MyAffiliateStatusQuery, MyAffiliateStatusQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<MyAffiliateStatusQuery, MyAffiliateStatusQueryVariables>;
export function useMyAffiliateStatusSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<MyAffiliateStatusQuery, MyAffiliateStatusQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<MyAffiliateStatusQuery | undefined, MyAffiliateStatusQueryVariables>;
export function useMyAffiliateStatusSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<MyAffiliateStatusQuery, MyAffiliateStatusQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<MyAffiliateStatusQuery, MyAffiliateStatusQueryVariables>(MyAffiliateStatusDocument, options);
        }
export type MyAffiliateStatusQueryHookResult = ReturnType<typeof useMyAffiliateStatusQuery>;
export type MyAffiliateStatusLazyQueryHookResult = ReturnType<typeof useMyAffiliateStatusLazyQuery>;
export type MyAffiliateStatusSuspenseQueryHookResult = ReturnType<typeof useMyAffiliateStatusSuspenseQuery>;
export type MyAffiliateStatusQueryResult = Apollo.QueryResult<MyAffiliateStatusQuery, MyAffiliateStatusQueryVariables>;
export const AcceptAffiliateTermsDocument = gql`
    mutation AcceptAffiliateTerms($version: String!) {
  acceptAffiliateTerms(version: $version) {
    ...AffiliateStatusFields
  }
}
    ${AffiliateStatusFieldsFragmentDoc}`;
export type AcceptAffiliateTermsMutationFn = Apollo.MutationFunction<AcceptAffiliateTermsMutation, AcceptAffiliateTermsMutationVariables>;

/**
 * __useAcceptAffiliateTermsMutation__
 *
 * To run a mutation, you first call `useAcceptAffiliateTermsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAcceptAffiliateTermsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [acceptAffiliateTermsMutation, { data, loading, error }] = useAcceptAffiliateTermsMutation({
 *   variables: {
 *      version: // value for 'version'
 *   },
 * });
 */
export function useAcceptAffiliateTermsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AcceptAffiliateTermsMutation, AcceptAffiliateTermsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AcceptAffiliateTermsMutation, AcceptAffiliateTermsMutationVariables>(AcceptAffiliateTermsDocument, options);
      }
export type AcceptAffiliateTermsMutationHookResult = ReturnType<typeof useAcceptAffiliateTermsMutation>;
export type AcceptAffiliateTermsMutationResult = Apollo.MutationResult<AcceptAffiliateTermsMutation>;
export type AcceptAffiliateTermsMutationOptions = Apollo.BaseMutationOptions<AcceptAffiliateTermsMutation, AcceptAffiliateTermsMutationVariables>;
export const SetMyAffiliateCustomCodeDocument = gql`
    mutation SetMyAffiliateCustomCode($code: String!) {
  setMyAffiliateCustomCode(code: $code) {
    ...AffiliateStatusFields
  }
}
    ${AffiliateStatusFieldsFragmentDoc}`;
export type SetMyAffiliateCustomCodeMutationFn = Apollo.MutationFunction<SetMyAffiliateCustomCodeMutation, SetMyAffiliateCustomCodeMutationVariables>;

/**
 * __useSetMyAffiliateCustomCodeMutation__
 *
 * To run a mutation, you first call `useSetMyAffiliateCustomCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetMyAffiliateCustomCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setMyAffiliateCustomCodeMutation, { data, loading, error }] = useSetMyAffiliateCustomCodeMutation({
 *   variables: {
 *      code: // value for 'code'
 *   },
 * });
 */
export function useSetMyAffiliateCustomCodeMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SetMyAffiliateCustomCodeMutation, SetMyAffiliateCustomCodeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SetMyAffiliateCustomCodeMutation, SetMyAffiliateCustomCodeMutationVariables>(SetMyAffiliateCustomCodeDocument, options);
      }
export type SetMyAffiliateCustomCodeMutationHookResult = ReturnType<typeof useSetMyAffiliateCustomCodeMutation>;
export type SetMyAffiliateCustomCodeMutationResult = Apollo.MutationResult<SetMyAffiliateCustomCodeMutation>;
export type SetMyAffiliateCustomCodeMutationOptions = Apollo.BaseMutationOptions<SetMyAffiliateCustomCodeMutation, SetMyAffiliateCustomCodeMutationVariables>;
export const MyAffiliateReferredUserEarningsDocument = gql`
    query MyAffiliateReferredUserEarnings($userId: ID!) {
  myAffiliateReferredUserEarnings(userId: $userId) {
    id
    date
    description
    source
    payment_amount_cents
    commission_cents
    commission_rate
    status
  }
}
    `;

/**
 * __useMyAffiliateReferredUserEarningsQuery__
 *
 * To run a query within a React component, call `useMyAffiliateReferredUserEarningsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyAffiliateReferredUserEarningsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyAffiliateReferredUserEarningsQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useMyAffiliateReferredUserEarningsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<MyAffiliateReferredUserEarningsQuery, MyAffiliateReferredUserEarningsQueryVariables> & ({ variables: MyAffiliateReferredUserEarningsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<MyAffiliateReferredUserEarningsQuery, MyAffiliateReferredUserEarningsQueryVariables>(MyAffiliateReferredUserEarningsDocument, options);
      }
export function useMyAffiliateReferredUserEarningsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<MyAffiliateReferredUserEarningsQuery, MyAffiliateReferredUserEarningsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<MyAffiliateReferredUserEarningsQuery, MyAffiliateReferredUserEarningsQueryVariables>(MyAffiliateReferredUserEarningsDocument, options);
        }
// @ts-ignore
export function useMyAffiliateReferredUserEarningsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<MyAffiliateReferredUserEarningsQuery, MyAffiliateReferredUserEarningsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<MyAffiliateReferredUserEarningsQuery, MyAffiliateReferredUserEarningsQueryVariables>;
export function useMyAffiliateReferredUserEarningsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<MyAffiliateReferredUserEarningsQuery, MyAffiliateReferredUserEarningsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<MyAffiliateReferredUserEarningsQuery | undefined, MyAffiliateReferredUserEarningsQueryVariables>;
export function useMyAffiliateReferredUserEarningsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<MyAffiliateReferredUserEarningsQuery, MyAffiliateReferredUserEarningsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<MyAffiliateReferredUserEarningsQuery, MyAffiliateReferredUserEarningsQueryVariables>(MyAffiliateReferredUserEarningsDocument, options);
        }
export type MyAffiliateReferredUserEarningsQueryHookResult = ReturnType<typeof useMyAffiliateReferredUserEarningsQuery>;
export type MyAffiliateReferredUserEarningsLazyQueryHookResult = ReturnType<typeof useMyAffiliateReferredUserEarningsLazyQuery>;
export type MyAffiliateReferredUserEarningsSuspenseQueryHookResult = ReturnType<typeof useMyAffiliateReferredUserEarningsSuspenseQuery>;
export type MyAffiliateReferredUserEarningsQueryResult = Apollo.QueryResult<MyAffiliateReferredUserEarningsQuery, MyAffiliateReferredUserEarningsQueryVariables>;
export const ClaimReferralAttributionDocument = gql`
    mutation ClaimReferralAttribution($code: String!) {
  claimReferralAttribution(code: $code)
}
    `;
export type ClaimReferralAttributionMutationFn = Apollo.MutationFunction<ClaimReferralAttributionMutation, ClaimReferralAttributionMutationVariables>;

/**
 * __useClaimReferralAttributionMutation__
 *
 * To run a mutation, you first call `useClaimReferralAttributionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useClaimReferralAttributionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [claimReferralAttributionMutation, { data, loading, error }] = useClaimReferralAttributionMutation({
 *   variables: {
 *      code: // value for 'code'
 *   },
 * });
 */
export function useClaimReferralAttributionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ClaimReferralAttributionMutation, ClaimReferralAttributionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ClaimReferralAttributionMutation, ClaimReferralAttributionMutationVariables>(ClaimReferralAttributionDocument, options);
      }
export type ClaimReferralAttributionMutationHookResult = ReturnType<typeof useClaimReferralAttributionMutation>;
export type ClaimReferralAttributionMutationResult = Apollo.MutationResult<ClaimReferralAttributionMutation>;
export type ClaimReferralAttributionMutationOptions = Apollo.BaseMutationOptions<ClaimReferralAttributionMutation, ClaimReferralAttributionMutationVariables>;
export const AdminAffiliateEarningsDocument = gql`
    query AdminAffiliateEarnings($search: String, $kind: String, $limit: Int, $offset: Int) {
  adminAffiliateEarnings(
    search: $search
    kind: $kind
    limit: $limit
    offset: $offset
  ) {
    data {
      id
      kind
      course_id
      course_title
      user_id
      user_email
      user_name
      referred_user_email
      referred_user_name
      amount_cents
      commission_rate
      status
      source
      payment_date
      payment_amount_cents
      payment_provider
      reversal_note
      createdAt
    }
    total
  }
}
    `;

/**
 * __useAdminAffiliateEarningsQuery__
 *
 * To run a query within a React component, call `useAdminAffiliateEarningsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminAffiliateEarningsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminAffiliateEarningsQuery({
 *   variables: {
 *      search: // value for 'search'
 *      kind: // value for 'kind'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useAdminAffiliateEarningsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<AdminAffiliateEarningsQuery, AdminAffiliateEarningsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AdminAffiliateEarningsQuery, AdminAffiliateEarningsQueryVariables>(AdminAffiliateEarningsDocument, options);
      }
export function useAdminAffiliateEarningsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AdminAffiliateEarningsQuery, AdminAffiliateEarningsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AdminAffiliateEarningsQuery, AdminAffiliateEarningsQueryVariables>(AdminAffiliateEarningsDocument, options);
        }
// @ts-ignore
export function useAdminAffiliateEarningsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<AdminAffiliateEarningsQuery, AdminAffiliateEarningsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AdminAffiliateEarningsQuery, AdminAffiliateEarningsQueryVariables>;
export function useAdminAffiliateEarningsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AdminAffiliateEarningsQuery, AdminAffiliateEarningsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AdminAffiliateEarningsQuery | undefined, AdminAffiliateEarningsQueryVariables>;
export function useAdminAffiliateEarningsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AdminAffiliateEarningsQuery, AdminAffiliateEarningsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<AdminAffiliateEarningsQuery, AdminAffiliateEarningsQueryVariables>(AdminAffiliateEarningsDocument, options);
        }
export type AdminAffiliateEarningsQueryHookResult = ReturnType<typeof useAdminAffiliateEarningsQuery>;
export type AdminAffiliateEarningsLazyQueryHookResult = ReturnType<typeof useAdminAffiliateEarningsLazyQuery>;
export type AdminAffiliateEarningsSuspenseQueryHookResult = ReturnType<typeof useAdminAffiliateEarningsSuspenseQuery>;
export type AdminAffiliateEarningsQueryResult = Apollo.QueryResult<AdminAffiliateEarningsQuery, AdminAffiliateEarningsQueryVariables>;
export const AdminCourseRevenueSharesDocument = gql`
    query AdminCourseRevenueShares($courseId: ID, $active: Boolean) {
  adminCourseRevenueShares(courseId: $courseId, active: $active) {
    id
    course_id
    course_title
    user_id
    user_email
    user_name
    rate_percent
    active
    note
    createdAt
    updatedAt
    totals {
      accrued_cents
      pending_cents
      available_cents
      reversed_cents
    }
  }
}
    `;

/**
 * __useAdminCourseRevenueSharesQuery__
 *
 * To run a query within a React component, call `useAdminCourseRevenueSharesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminCourseRevenueSharesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminCourseRevenueSharesQuery({
 *   variables: {
 *      courseId: // value for 'courseId'
 *      active: // value for 'active'
 *   },
 * });
 */
export function useAdminCourseRevenueSharesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<AdminCourseRevenueSharesQuery, AdminCourseRevenueSharesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AdminCourseRevenueSharesQuery, AdminCourseRevenueSharesQueryVariables>(AdminCourseRevenueSharesDocument, options);
      }
export function useAdminCourseRevenueSharesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AdminCourseRevenueSharesQuery, AdminCourseRevenueSharesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AdminCourseRevenueSharesQuery, AdminCourseRevenueSharesQueryVariables>(AdminCourseRevenueSharesDocument, options);
        }
// @ts-ignore
export function useAdminCourseRevenueSharesSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<AdminCourseRevenueSharesQuery, AdminCourseRevenueSharesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AdminCourseRevenueSharesQuery, AdminCourseRevenueSharesQueryVariables>;
export function useAdminCourseRevenueSharesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AdminCourseRevenueSharesQuery, AdminCourseRevenueSharesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AdminCourseRevenueSharesQuery | undefined, AdminCourseRevenueSharesQueryVariables>;
export function useAdminCourseRevenueSharesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AdminCourseRevenueSharesQuery, AdminCourseRevenueSharesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<AdminCourseRevenueSharesQuery, AdminCourseRevenueSharesQueryVariables>(AdminCourseRevenueSharesDocument, options);
        }
export type AdminCourseRevenueSharesQueryHookResult = ReturnType<typeof useAdminCourseRevenueSharesQuery>;
export type AdminCourseRevenueSharesLazyQueryHookResult = ReturnType<typeof useAdminCourseRevenueSharesLazyQuery>;
export type AdminCourseRevenueSharesSuspenseQueryHookResult = ReturnType<typeof useAdminCourseRevenueSharesSuspenseQuery>;
export type AdminCourseRevenueSharesQueryResult = Apollo.QueryResult<AdminCourseRevenueSharesQuery, AdminCourseRevenueSharesQueryVariables>;
export const AdminUpsertCourseRevenueShareDocument = gql`
    mutation AdminUpsertCourseRevenueShare($id: ID, $input: AdminCourseRevenueShareInput!) {
  adminUpsertCourseRevenueShare(id: $id, input: $input) {
    id
    course_id
    course_title
    user_id
    user_email
    user_name
    rate_percent
    active
    note
    createdAt
    updatedAt
    totals {
      accrued_cents
      pending_cents
      available_cents
      reversed_cents
    }
  }
}
    `;
export type AdminUpsertCourseRevenueShareMutationFn = Apollo.MutationFunction<AdminUpsertCourseRevenueShareMutation, AdminUpsertCourseRevenueShareMutationVariables>;

/**
 * __useAdminUpsertCourseRevenueShareMutation__
 *
 * To run a mutation, you first call `useAdminUpsertCourseRevenueShareMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminUpsertCourseRevenueShareMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminUpsertCourseRevenueShareMutation, { data, loading, error }] = useAdminUpsertCourseRevenueShareMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdminUpsertCourseRevenueShareMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AdminUpsertCourseRevenueShareMutation, AdminUpsertCourseRevenueShareMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AdminUpsertCourseRevenueShareMutation, AdminUpsertCourseRevenueShareMutationVariables>(AdminUpsertCourseRevenueShareDocument, options);
      }
export type AdminUpsertCourseRevenueShareMutationHookResult = ReturnType<typeof useAdminUpsertCourseRevenueShareMutation>;
export type AdminUpsertCourseRevenueShareMutationResult = Apollo.MutationResult<AdminUpsertCourseRevenueShareMutation>;
export type AdminUpsertCourseRevenueShareMutationOptions = Apollo.BaseMutationOptions<AdminUpsertCourseRevenueShareMutation, AdminUpsertCourseRevenueShareMutationVariables>;
export const AdminSetCourseRevenueShareActiveDocument = gql`
    mutation AdminSetCourseRevenueShareActive($id: ID!, $active: Boolean!) {
  adminSetCourseRevenueShareActive(id: $id, active: $active) {
    id
    active
    updatedAt
  }
}
    `;
export type AdminSetCourseRevenueShareActiveMutationFn = Apollo.MutationFunction<AdminSetCourseRevenueShareActiveMutation, AdminSetCourseRevenueShareActiveMutationVariables>;

/**
 * __useAdminSetCourseRevenueShareActiveMutation__
 *
 * To run a mutation, you first call `useAdminSetCourseRevenueShareActiveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminSetCourseRevenueShareActiveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminSetCourseRevenueShareActiveMutation, { data, loading, error }] = useAdminSetCourseRevenueShareActiveMutation({
 *   variables: {
 *      id: // value for 'id'
 *      active: // value for 'active'
 *   },
 * });
 */
export function useAdminSetCourseRevenueShareActiveMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AdminSetCourseRevenueShareActiveMutation, AdminSetCourseRevenueShareActiveMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AdminSetCourseRevenueShareActiveMutation, AdminSetCourseRevenueShareActiveMutationVariables>(AdminSetCourseRevenueShareActiveDocument, options);
      }
export type AdminSetCourseRevenueShareActiveMutationHookResult = ReturnType<typeof useAdminSetCourseRevenueShareActiveMutation>;
export type AdminSetCourseRevenueShareActiveMutationResult = Apollo.MutationResult<AdminSetCourseRevenueShareActiveMutation>;
export type AdminSetCourseRevenueShareActiveMutationOptions = Apollo.BaseMutationOptions<AdminSetCourseRevenueShareActiveMutation, AdminSetCourseRevenueShareActiveMutationVariables>;
export const MyCourseRoyaltiesDocument = gql`
    query MyCourseRoyalties($limit: Int, $after: String) {
  myCourseRoyalties(limit: $limit, after: $after) {
    configurations {
      id
      course_id
      course_title
      rate_percent
      active
    }
    earnings {
      id
      course_id
      course_title
      sale_date
      gross_amount_cents
      royalty_cents
      rate_percent
      status
      releases_at
    }
    earnings_page_info {
      has_more
      next_cursor
    }
    accrued_cents
    pending_cents
    available_cents
    reversed_cents
  }
}
    `;

/**
 * __useMyCourseRoyaltiesQuery__
 *
 * To run a query within a React component, call `useMyCourseRoyaltiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyCourseRoyaltiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyCourseRoyaltiesQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useMyCourseRoyaltiesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<MyCourseRoyaltiesQuery, MyCourseRoyaltiesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<MyCourseRoyaltiesQuery, MyCourseRoyaltiesQueryVariables>(MyCourseRoyaltiesDocument, options);
      }
export function useMyCourseRoyaltiesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<MyCourseRoyaltiesQuery, MyCourseRoyaltiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<MyCourseRoyaltiesQuery, MyCourseRoyaltiesQueryVariables>(MyCourseRoyaltiesDocument, options);
        }
// @ts-ignore
export function useMyCourseRoyaltiesSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<MyCourseRoyaltiesQuery, MyCourseRoyaltiesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<MyCourseRoyaltiesQuery, MyCourseRoyaltiesQueryVariables>;
export function useMyCourseRoyaltiesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<MyCourseRoyaltiesQuery, MyCourseRoyaltiesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<MyCourseRoyaltiesQuery | undefined, MyCourseRoyaltiesQueryVariables>;
export function useMyCourseRoyaltiesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<MyCourseRoyaltiesQuery, MyCourseRoyaltiesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<MyCourseRoyaltiesQuery, MyCourseRoyaltiesQueryVariables>(MyCourseRoyaltiesDocument, options);
        }
export type MyCourseRoyaltiesQueryHookResult = ReturnType<typeof useMyCourseRoyaltiesQuery>;
export type MyCourseRoyaltiesLazyQueryHookResult = ReturnType<typeof useMyCourseRoyaltiesLazyQuery>;
export type MyCourseRoyaltiesSuspenseQueryHookResult = ReturnType<typeof useMyCourseRoyaltiesSuspenseQuery>;
export type MyCourseRoyaltiesQueryResult = Apollo.QueryResult<MyCourseRoyaltiesQuery, MyCourseRoyaltiesQueryVariables>;
export const AdminReverseAffiliateEarningDocument = gql`
    mutation AdminReverseAffiliateEarning($id: ID!, $note: String) {
  adminReverseAffiliateEarning(id: $id, note: $note)
}
    `;
export type AdminReverseAffiliateEarningMutationFn = Apollo.MutationFunction<AdminReverseAffiliateEarningMutation, AdminReverseAffiliateEarningMutationVariables>;

/**
 * __useAdminReverseAffiliateEarningMutation__
 *
 * To run a mutation, you first call `useAdminReverseAffiliateEarningMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminReverseAffiliateEarningMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminReverseAffiliateEarningMutation, { data, loading, error }] = useAdminReverseAffiliateEarningMutation({
 *   variables: {
 *      id: // value for 'id'
 *      note: // value for 'note'
 *   },
 * });
 */
export function useAdminReverseAffiliateEarningMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AdminReverseAffiliateEarningMutation, AdminReverseAffiliateEarningMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AdminReverseAffiliateEarningMutation, AdminReverseAffiliateEarningMutationVariables>(AdminReverseAffiliateEarningDocument, options);
      }
export type AdminReverseAffiliateEarningMutationHookResult = ReturnType<typeof useAdminReverseAffiliateEarningMutation>;
export type AdminReverseAffiliateEarningMutationResult = Apollo.MutationResult<AdminReverseAffiliateEarningMutation>;
export type AdminReverseAffiliateEarningMutationOptions = Apollo.BaseMutationOptions<AdminReverseAffiliateEarningMutation, AdminReverseAffiliateEarningMutationVariables>;
export const RequestCpmPayoutDocument = gql`
    mutation RequestCpmPayout($input: RequestCpmPayoutInput!) {
  requestCpmPayout(input: $input) {
    id
    status
    amount_cents
    currency
    requested_at
  }
}
    `;
export type RequestCpmPayoutMutationFn = Apollo.MutationFunction<RequestCpmPayoutMutation, RequestCpmPayoutMutationVariables>;

/**
 * __useRequestCpmPayoutMutation__
 *
 * To run a mutation, you first call `useRequestCpmPayoutMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestCpmPayoutMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestCpmPayoutMutation, { data, loading, error }] = useRequestCpmPayoutMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRequestCpmPayoutMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<RequestCpmPayoutMutation, RequestCpmPayoutMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<RequestCpmPayoutMutation, RequestCpmPayoutMutationVariables>(RequestCpmPayoutDocument, options);
      }
export type RequestCpmPayoutMutationHookResult = ReturnType<typeof useRequestCpmPayoutMutation>;
export type RequestCpmPayoutMutationResult = Apollo.MutationResult<RequestCpmPayoutMutation>;
export type RequestCpmPayoutMutationOptions = Apollo.BaseMutationOptions<RequestCpmPayoutMutation, RequestCpmPayoutMutationVariables>;
export const AdminCpmPayoutsDocument = gql`
    query AdminCpmPayouts($search: String, $userId: ID, $kind: String, $limit: Int, $offset: Int) {
  adminCpmPayouts(
    search: $search
    userId: $userId
    kind: $kind
    limit: $limit
    offset: $offset
  ) {
    data {
      id
      user_id
      user_email
      user_name
      amount_cents
      currency
      status
      note
      paid_at
      requested_at
      bank_data
      breakdown
      kind
      redemption_data
      created_by_email
      createdAt
      pix_verification_status
      pix_verification_review_reason
    }
    total
  }
}
    `;

/**
 * __useAdminCpmPayoutsQuery__
 *
 * To run a query within a React component, call `useAdminCpmPayoutsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminCpmPayoutsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminCpmPayoutsQuery({
 *   variables: {
 *      search: // value for 'search'
 *      userId: // value for 'userId'
 *      kind: // value for 'kind'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useAdminCpmPayoutsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<AdminCpmPayoutsQuery, AdminCpmPayoutsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AdminCpmPayoutsQuery, AdminCpmPayoutsQueryVariables>(AdminCpmPayoutsDocument, options);
      }
export function useAdminCpmPayoutsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AdminCpmPayoutsQuery, AdminCpmPayoutsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AdminCpmPayoutsQuery, AdminCpmPayoutsQueryVariables>(AdminCpmPayoutsDocument, options);
        }
// @ts-ignore
export function useAdminCpmPayoutsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<AdminCpmPayoutsQuery, AdminCpmPayoutsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AdminCpmPayoutsQuery, AdminCpmPayoutsQueryVariables>;
export function useAdminCpmPayoutsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AdminCpmPayoutsQuery, AdminCpmPayoutsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AdminCpmPayoutsQuery | undefined, AdminCpmPayoutsQueryVariables>;
export function useAdminCpmPayoutsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AdminCpmPayoutsQuery, AdminCpmPayoutsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<AdminCpmPayoutsQuery, AdminCpmPayoutsQueryVariables>(AdminCpmPayoutsDocument, options);
        }
export type AdminCpmPayoutsQueryHookResult = ReturnType<typeof useAdminCpmPayoutsQuery>;
export type AdminCpmPayoutsLazyQueryHookResult = ReturnType<typeof useAdminCpmPayoutsLazyQuery>;
export type AdminCpmPayoutsSuspenseQueryHookResult = ReturnType<typeof useAdminCpmPayoutsSuspenseQuery>;
export type AdminCpmPayoutsQueryResult = Apollo.QueryResult<AdminCpmPayoutsQuery, AdminCpmPayoutsQueryVariables>;
export const RedeemWalletForPlanDocument = gql`
    mutation RedeemWalletForPlan($planId: ID!, $yearly: Boolean, $remainderMethod: String, $document: JSON, $coupon: String) {
  redeemWalletForPlan(
    planId: $planId
    yearly: $yearly
    remainderMethod: $remainderMethod
    document: $document
    coupon: $coupon
  ) {
    status
    checkout
    payoutDocumentId
  }
}
    `;
export type RedeemWalletForPlanMutationFn = Apollo.MutationFunction<RedeemWalletForPlanMutation, RedeemWalletForPlanMutationVariables>;

/**
 * __useRedeemWalletForPlanMutation__
 *
 * To run a mutation, you first call `useRedeemWalletForPlanMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRedeemWalletForPlanMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [redeemWalletForPlanMutation, { data, loading, error }] = useRedeemWalletForPlanMutation({
 *   variables: {
 *      planId: // value for 'planId'
 *      yearly: // value for 'yearly'
 *      remainderMethod: // value for 'remainderMethod'
 *      document: // value for 'document'
 *      coupon: // value for 'coupon'
 *   },
 * });
 */
export function useRedeemWalletForPlanMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<RedeemWalletForPlanMutation, RedeemWalletForPlanMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<RedeemWalletForPlanMutation, RedeemWalletForPlanMutationVariables>(RedeemWalletForPlanDocument, options);
      }
export type RedeemWalletForPlanMutationHookResult = ReturnType<typeof useRedeemWalletForPlanMutation>;
export type RedeemWalletForPlanMutationResult = Apollo.MutationResult<RedeemWalletForPlanMutation>;
export type RedeemWalletForPlanMutationOptions = Apollo.BaseMutationOptions<RedeemWalletForPlanMutation, RedeemWalletForPlanMutationVariables>;
export const CancelMyWalletRedemptionHoldDocument = gql`
    mutation CancelMyWalletRedemptionHold {
  cancelMyWalletRedemptionHold
}
    `;
export type CancelMyWalletRedemptionHoldMutationFn = Apollo.MutationFunction<CancelMyWalletRedemptionHoldMutation, CancelMyWalletRedemptionHoldMutationVariables>;

/**
 * __useCancelMyWalletRedemptionHoldMutation__
 *
 * To run a mutation, you first call `useCancelMyWalletRedemptionHoldMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelMyWalletRedemptionHoldMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelMyWalletRedemptionHoldMutation, { data, loading, error }] = useCancelMyWalletRedemptionHoldMutation({
 *   variables: {
 *   },
 * });
 */
export function useCancelMyWalletRedemptionHoldMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CancelMyWalletRedemptionHoldMutation, CancelMyWalletRedemptionHoldMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CancelMyWalletRedemptionHoldMutation, CancelMyWalletRedemptionHoldMutationVariables>(CancelMyWalletRedemptionHoldDocument, options);
      }
export type CancelMyWalletRedemptionHoldMutationHookResult = ReturnType<typeof useCancelMyWalletRedemptionHoldMutation>;
export type CancelMyWalletRedemptionHoldMutationResult = Apollo.MutationResult<CancelMyWalletRedemptionHoldMutation>;
export type CancelMyWalletRedemptionHoldMutationOptions = Apollo.BaseMutationOptions<CancelMyWalletRedemptionHoldMutation, CancelMyWalletRedemptionHoldMutationVariables>;
export const RedeemWalletForExtraMinutesDocument = gql`
    mutation RedeemWalletForExtraMinutes($minutes: Int!, $remainderMethod: String, $document: JSON, $returnUrl: String) {
  redeemWalletForExtraMinutes(
    minutes: $minutes
    remainderMethod: $remainderMethod
    document: $document
    returnUrl: $returnUrl
  ) {
    status
    checkout
    payoutDocumentId
  }
}
    `;
export type RedeemWalletForExtraMinutesMutationFn = Apollo.MutationFunction<RedeemWalletForExtraMinutesMutation, RedeemWalletForExtraMinutesMutationVariables>;

/**
 * __useRedeemWalletForExtraMinutesMutation__
 *
 * To run a mutation, you first call `useRedeemWalletForExtraMinutesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRedeemWalletForExtraMinutesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [redeemWalletForExtraMinutesMutation, { data, loading, error }] = useRedeemWalletForExtraMinutesMutation({
 *   variables: {
 *      minutes: // value for 'minutes'
 *      remainderMethod: // value for 'remainderMethod'
 *      document: // value for 'document'
 *      returnUrl: // value for 'returnUrl'
 *   },
 * });
 */
export function useRedeemWalletForExtraMinutesMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<RedeemWalletForExtraMinutesMutation, RedeemWalletForExtraMinutesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<RedeemWalletForExtraMinutesMutation, RedeemWalletForExtraMinutesMutationVariables>(RedeemWalletForExtraMinutesDocument, options);
      }
export type RedeemWalletForExtraMinutesMutationHookResult = ReturnType<typeof useRedeemWalletForExtraMinutesMutation>;
export type RedeemWalletForExtraMinutesMutationResult = Apollo.MutationResult<RedeemWalletForExtraMinutesMutation>;
export type RedeemWalletForExtraMinutesMutationOptions = Apollo.BaseMutationOptions<RedeemWalletForExtraMinutesMutation, RedeemWalletForExtraMinutesMutationVariables>;
export const RenewPlanWithWalletDocument = gql`
    mutation RenewPlanWithWallet($remainderMethod: String, $document: JSON, $returnUrl: String) {
  renewPlanWithWallet(
    remainderMethod: $remainderMethod
    document: $document
    returnUrl: $returnUrl
  ) {
    status
    checkout
    payoutDocumentId
  }
}
    `;
export type RenewPlanWithWalletMutationFn = Apollo.MutationFunction<RenewPlanWithWalletMutation, RenewPlanWithWalletMutationVariables>;

/**
 * __useRenewPlanWithWalletMutation__
 *
 * To run a mutation, you first call `useRenewPlanWithWalletMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRenewPlanWithWalletMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [renewPlanWithWalletMutation, { data, loading, error }] = useRenewPlanWithWalletMutation({
 *   variables: {
 *      remainderMethod: // value for 'remainderMethod'
 *      document: // value for 'document'
 *      returnUrl: // value for 'returnUrl'
 *   },
 * });
 */
export function useRenewPlanWithWalletMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<RenewPlanWithWalletMutation, RenewPlanWithWalletMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<RenewPlanWithWalletMutation, RenewPlanWithWalletMutationVariables>(RenewPlanWithWalletDocument, options);
      }
export type RenewPlanWithWalletMutationHookResult = ReturnType<typeof useRenewPlanWithWalletMutation>;
export type RenewPlanWithWalletMutationResult = Apollo.MutationResult<RenewPlanWithWalletMutation>;
export type RenewPlanWithWalletMutationOptions = Apollo.BaseMutationOptions<RenewPlanWithWalletMutation, RenewPlanWithWalletMutationVariables>;
export const AdminApproveCpmPayoutDocument = gql`
    mutation AdminApproveCpmPayout($id: ID!) {
  adminApproveCpmPayout(id: $id) {
    id
    status
    paid_at
  }
}
    `;
export type AdminApproveCpmPayoutMutationFn = Apollo.MutationFunction<AdminApproveCpmPayoutMutation, AdminApproveCpmPayoutMutationVariables>;

/**
 * __useAdminApproveCpmPayoutMutation__
 *
 * To run a mutation, you first call `useAdminApproveCpmPayoutMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminApproveCpmPayoutMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminApproveCpmPayoutMutation, { data, loading, error }] = useAdminApproveCpmPayoutMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAdminApproveCpmPayoutMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AdminApproveCpmPayoutMutation, AdminApproveCpmPayoutMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AdminApproveCpmPayoutMutation, AdminApproveCpmPayoutMutationVariables>(AdminApproveCpmPayoutDocument, options);
      }
export type AdminApproveCpmPayoutMutationHookResult = ReturnType<typeof useAdminApproveCpmPayoutMutation>;
export type AdminApproveCpmPayoutMutationResult = Apollo.MutationResult<AdminApproveCpmPayoutMutation>;
export type AdminApproveCpmPayoutMutationOptions = Apollo.BaseMutationOptions<AdminApproveCpmPayoutMutation, AdminApproveCpmPayoutMutationVariables>;
export const AdminUserCpmWalletDocument = gql`
    query AdminUserCpmWallet($userId: ID!) {
  adminUserCpmWallet(userId: $userId) {
    user_id
    total_earned_cents
    total_paid_out_cents
    available_cents
    currency
    payouts {
      id
      amount_cents
      currency
      note
      paid_at
      created_by_email
      createdAt
    }
  }
}
    `;

/**
 * __useAdminUserCpmWalletQuery__
 *
 * To run a query within a React component, call `useAdminUserCpmWalletQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminUserCpmWalletQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminUserCpmWalletQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useAdminUserCpmWalletQuery(baseOptions: ApolloReactHooks.QueryHookOptions<AdminUserCpmWalletQuery, AdminUserCpmWalletQueryVariables> & ({ variables: AdminUserCpmWalletQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AdminUserCpmWalletQuery, AdminUserCpmWalletQueryVariables>(AdminUserCpmWalletDocument, options);
      }
export function useAdminUserCpmWalletLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AdminUserCpmWalletQuery, AdminUserCpmWalletQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AdminUserCpmWalletQuery, AdminUserCpmWalletQueryVariables>(AdminUserCpmWalletDocument, options);
        }
// @ts-ignore
export function useAdminUserCpmWalletSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<AdminUserCpmWalletQuery, AdminUserCpmWalletQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AdminUserCpmWalletQuery, AdminUserCpmWalletQueryVariables>;
export function useAdminUserCpmWalletSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AdminUserCpmWalletQuery, AdminUserCpmWalletQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AdminUserCpmWalletQuery | undefined, AdminUserCpmWalletQueryVariables>;
export function useAdminUserCpmWalletSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AdminUserCpmWalletQuery, AdminUserCpmWalletQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<AdminUserCpmWalletQuery, AdminUserCpmWalletQueryVariables>(AdminUserCpmWalletDocument, options);
        }
export type AdminUserCpmWalletQueryHookResult = ReturnType<typeof useAdminUserCpmWalletQuery>;
export type AdminUserCpmWalletLazyQueryHookResult = ReturnType<typeof useAdminUserCpmWalletLazyQuery>;
export type AdminUserCpmWalletSuspenseQueryHookResult = ReturnType<typeof useAdminUserCpmWalletSuspenseQuery>;
export type AdminUserCpmWalletQueryResult = Apollo.QueryResult<AdminUserCpmWalletQuery, AdminUserCpmWalletQueryVariables>;
export const AdminCreateCpmPayoutDocument = gql`
    mutation AdminCreateCpmPayout($input: AdminCreateCpmPayoutInput!) {
  adminCreateCpmPayout(input: $input) {
    id
    user_id
    user_email
    user_name
    amount_cents
    currency
    status
    note
    paid_at
    requested_at
    created_by_email
    createdAt
  }
}
    `;
export type AdminCreateCpmPayoutMutationFn = Apollo.MutationFunction<AdminCreateCpmPayoutMutation, AdminCreateCpmPayoutMutationVariables>;

/**
 * __useAdminCreateCpmPayoutMutation__
 *
 * To run a mutation, you first call `useAdminCreateCpmPayoutMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminCreateCpmPayoutMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminCreateCpmPayoutMutation, { data, loading, error }] = useAdminCreateCpmPayoutMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdminCreateCpmPayoutMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AdminCreateCpmPayoutMutation, AdminCreateCpmPayoutMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AdminCreateCpmPayoutMutation, AdminCreateCpmPayoutMutationVariables>(AdminCreateCpmPayoutDocument, options);
      }
export type AdminCreateCpmPayoutMutationHookResult = ReturnType<typeof useAdminCreateCpmPayoutMutation>;
export type AdminCreateCpmPayoutMutationResult = Apollo.MutationResult<AdminCreateCpmPayoutMutation>;
export type AdminCreateCpmPayoutMutationOptions = Apollo.BaseMutationOptions<AdminCreateCpmPayoutMutation, AdminCreateCpmPayoutMutationVariables>;
export const AdminDeleteCpmPayoutDocument = gql`
    mutation AdminDeleteCpmPayout($id: ID!) {
  adminDeleteCpmPayout(id: $id)
}
    `;
export type AdminDeleteCpmPayoutMutationFn = Apollo.MutationFunction<AdminDeleteCpmPayoutMutation, AdminDeleteCpmPayoutMutationVariables>;

/**
 * __useAdminDeleteCpmPayoutMutation__
 *
 * To run a mutation, you first call `useAdminDeleteCpmPayoutMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminDeleteCpmPayoutMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminDeleteCpmPayoutMutation, { data, loading, error }] = useAdminDeleteCpmPayoutMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAdminDeleteCpmPayoutMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AdminDeleteCpmPayoutMutation, AdminDeleteCpmPayoutMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AdminDeleteCpmPayoutMutation, AdminDeleteCpmPayoutMutationVariables>(AdminDeleteCpmPayoutDocument, options);
      }
export type AdminDeleteCpmPayoutMutationHookResult = ReturnType<typeof useAdminDeleteCpmPayoutMutation>;
export type AdminDeleteCpmPayoutMutationResult = Apollo.MutationResult<AdminDeleteCpmPayoutMutation>;
export type AdminDeleteCpmPayoutMutationOptions = Apollo.BaseMutationOptions<AdminDeleteCpmPayoutMutation, AdminDeleteCpmPayoutMutationVariables>;
export const AdminCpmCampaignChannelRequestsDocument = gql`
    query AdminCpmCampaignChannelRequests($campaignId: ID!, $status: String, $search: String, $limit: Int, $offset: Int) {
  adminCpmCampaignChannelRequests(
    campaignId: $campaignId
    status: $status
    search: $search
    limit: $limit
    offset: $offset
  ) {
    total
    pageCount
    data {
      id
      platform
      submitted_url
      handle
      status
      review_reason
      reviewed_at
      createdAt
      user_id
      user_email
      user_name
      reviewed_by_id
      reviewed_by_name
      youtube_channel {
        id
        name
        handle
        thumbnail
        subscriber_count
      }
    }
  }
}
    `;

/**
 * __useAdminCpmCampaignChannelRequestsQuery__
 *
 * To run a query within a React component, call `useAdminCpmCampaignChannelRequestsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminCpmCampaignChannelRequestsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminCpmCampaignChannelRequestsQuery({
 *   variables: {
 *      campaignId: // value for 'campaignId'
 *      status: // value for 'status'
 *      search: // value for 'search'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useAdminCpmCampaignChannelRequestsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<AdminCpmCampaignChannelRequestsQuery, AdminCpmCampaignChannelRequestsQueryVariables> & ({ variables: AdminCpmCampaignChannelRequestsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AdminCpmCampaignChannelRequestsQuery, AdminCpmCampaignChannelRequestsQueryVariables>(AdminCpmCampaignChannelRequestsDocument, options);
      }
export function useAdminCpmCampaignChannelRequestsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AdminCpmCampaignChannelRequestsQuery, AdminCpmCampaignChannelRequestsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AdminCpmCampaignChannelRequestsQuery, AdminCpmCampaignChannelRequestsQueryVariables>(AdminCpmCampaignChannelRequestsDocument, options);
        }
// @ts-ignore
export function useAdminCpmCampaignChannelRequestsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<AdminCpmCampaignChannelRequestsQuery, AdminCpmCampaignChannelRequestsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AdminCpmCampaignChannelRequestsQuery, AdminCpmCampaignChannelRequestsQueryVariables>;
export function useAdminCpmCampaignChannelRequestsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AdminCpmCampaignChannelRequestsQuery, AdminCpmCampaignChannelRequestsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AdminCpmCampaignChannelRequestsQuery | undefined, AdminCpmCampaignChannelRequestsQueryVariables>;
export function useAdminCpmCampaignChannelRequestsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AdminCpmCampaignChannelRequestsQuery, AdminCpmCampaignChannelRequestsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<AdminCpmCampaignChannelRequestsQuery, AdminCpmCampaignChannelRequestsQueryVariables>(AdminCpmCampaignChannelRequestsDocument, options);
        }
export type AdminCpmCampaignChannelRequestsQueryHookResult = ReturnType<typeof useAdminCpmCampaignChannelRequestsQuery>;
export type AdminCpmCampaignChannelRequestsLazyQueryHookResult = ReturnType<typeof useAdminCpmCampaignChannelRequestsLazyQuery>;
export type AdminCpmCampaignChannelRequestsSuspenseQueryHookResult = ReturnType<typeof useAdminCpmCampaignChannelRequestsSuspenseQuery>;
export type AdminCpmCampaignChannelRequestsQueryResult = Apollo.QueryResult<AdminCpmCampaignChannelRequestsQuery, AdminCpmCampaignChannelRequestsQueryVariables>;
export const CreateMyCpmCampaignChannelRequestDocument = gql`
    mutation CreateMyCpmCampaignChannelRequest($campaignId: ID!, $platform: String!, $url: String!) {
  createMyCpmCampaignChannelRequest(
    campaignId: $campaignId
    platform: $platform
    url: $url
  ) {
    id
    status
    platform
    handle
    submitted_url
  }
}
    `;
export type CreateMyCpmCampaignChannelRequestMutationFn = Apollo.MutationFunction<CreateMyCpmCampaignChannelRequestMutation, CreateMyCpmCampaignChannelRequestMutationVariables>;

/**
 * __useCreateMyCpmCampaignChannelRequestMutation__
 *
 * To run a mutation, you first call `useCreateMyCpmCampaignChannelRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMyCpmCampaignChannelRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMyCpmCampaignChannelRequestMutation, { data, loading, error }] = useCreateMyCpmCampaignChannelRequestMutation({
 *   variables: {
 *      campaignId: // value for 'campaignId'
 *      platform: // value for 'platform'
 *      url: // value for 'url'
 *   },
 * });
 */
export function useCreateMyCpmCampaignChannelRequestMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateMyCpmCampaignChannelRequestMutation, CreateMyCpmCampaignChannelRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateMyCpmCampaignChannelRequestMutation, CreateMyCpmCampaignChannelRequestMutationVariables>(CreateMyCpmCampaignChannelRequestDocument, options);
      }
export type CreateMyCpmCampaignChannelRequestMutationHookResult = ReturnType<typeof useCreateMyCpmCampaignChannelRequestMutation>;
export type CreateMyCpmCampaignChannelRequestMutationResult = Apollo.MutationResult<CreateMyCpmCampaignChannelRequestMutation>;
export type CreateMyCpmCampaignChannelRequestMutationOptions = Apollo.BaseMutationOptions<CreateMyCpmCampaignChannelRequestMutation, CreateMyCpmCampaignChannelRequestMutationVariables>;
export const DeleteMyCpmCampaignChannelRequestDocument = gql`
    mutation DeleteMyCpmCampaignChannelRequest($id: ID!) {
  deleteMyCpmCampaignChannelRequest(id: $id)
}
    `;
export type DeleteMyCpmCampaignChannelRequestMutationFn = Apollo.MutationFunction<DeleteMyCpmCampaignChannelRequestMutation, DeleteMyCpmCampaignChannelRequestMutationVariables>;

/**
 * __useDeleteMyCpmCampaignChannelRequestMutation__
 *
 * To run a mutation, you first call `useDeleteMyCpmCampaignChannelRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteMyCpmCampaignChannelRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteMyCpmCampaignChannelRequestMutation, { data, loading, error }] = useDeleteMyCpmCampaignChannelRequestMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteMyCpmCampaignChannelRequestMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteMyCpmCampaignChannelRequestMutation, DeleteMyCpmCampaignChannelRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteMyCpmCampaignChannelRequestMutation, DeleteMyCpmCampaignChannelRequestMutationVariables>(DeleteMyCpmCampaignChannelRequestDocument, options);
      }
export type DeleteMyCpmCampaignChannelRequestMutationHookResult = ReturnType<typeof useDeleteMyCpmCampaignChannelRequestMutation>;
export type DeleteMyCpmCampaignChannelRequestMutationResult = Apollo.MutationResult<DeleteMyCpmCampaignChannelRequestMutation>;
export type DeleteMyCpmCampaignChannelRequestMutationOptions = Apollo.BaseMutationOptions<DeleteMyCpmCampaignChannelRequestMutation, DeleteMyCpmCampaignChannelRequestMutationVariables>;
export const AdminReviewCpmCampaignChannelRequestDocument = gql`
    mutation AdminReviewCpmCampaignChannelRequest($id: ID!, $status: String!, $reason: String) {
  adminReviewCpmCampaignChannelRequest(id: $id, status: $status, reason: $reason) {
    id
    status
    review_reason
    reviewed_at
  }
}
    `;
export type AdminReviewCpmCampaignChannelRequestMutationFn = Apollo.MutationFunction<AdminReviewCpmCampaignChannelRequestMutation, AdminReviewCpmCampaignChannelRequestMutationVariables>;

/**
 * __useAdminReviewCpmCampaignChannelRequestMutation__
 *
 * To run a mutation, you first call `useAdminReviewCpmCampaignChannelRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminReviewCpmCampaignChannelRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminReviewCpmCampaignChannelRequestMutation, { data, loading, error }] = useAdminReviewCpmCampaignChannelRequestMutation({
 *   variables: {
 *      id: // value for 'id'
 *      status: // value for 'status'
 *      reason: // value for 'reason'
 *   },
 * });
 */
export function useAdminReviewCpmCampaignChannelRequestMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AdminReviewCpmCampaignChannelRequestMutation, AdminReviewCpmCampaignChannelRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AdminReviewCpmCampaignChannelRequestMutation, AdminReviewCpmCampaignChannelRequestMutationVariables>(AdminReviewCpmCampaignChannelRequestDocument, options);
      }
export type AdminReviewCpmCampaignChannelRequestMutationHookResult = ReturnType<typeof useAdminReviewCpmCampaignChannelRequestMutation>;
export type AdminReviewCpmCampaignChannelRequestMutationResult = Apollo.MutationResult<AdminReviewCpmCampaignChannelRequestMutation>;
export type AdminReviewCpmCampaignChannelRequestMutationOptions = Apollo.BaseMutationOptions<AdminReviewCpmCampaignChannelRequestMutation, AdminReviewCpmCampaignChannelRequestMutationVariables>;
export const AdminRevokeCpmCampaignChannelRequestDocument = gql`
    mutation AdminRevokeCpmCampaignChannelRequest($id: ID!, $reason: String!) {
  adminRevokeCpmCampaignChannelRequest(id: $id, reason: $reason) {
    id
    status
    review_reason
    reviewed_at
  }
}
    `;
export type AdminRevokeCpmCampaignChannelRequestMutationFn = Apollo.MutationFunction<AdminRevokeCpmCampaignChannelRequestMutation, AdminRevokeCpmCampaignChannelRequestMutationVariables>;

/**
 * __useAdminRevokeCpmCampaignChannelRequestMutation__
 *
 * To run a mutation, you first call `useAdminRevokeCpmCampaignChannelRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminRevokeCpmCampaignChannelRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminRevokeCpmCampaignChannelRequestMutation, { data, loading, error }] = useAdminRevokeCpmCampaignChannelRequestMutation({
 *   variables: {
 *      id: // value for 'id'
 *      reason: // value for 'reason'
 *   },
 * });
 */
export function useAdminRevokeCpmCampaignChannelRequestMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AdminRevokeCpmCampaignChannelRequestMutation, AdminRevokeCpmCampaignChannelRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AdminRevokeCpmCampaignChannelRequestMutation, AdminRevokeCpmCampaignChannelRequestMutationVariables>(AdminRevokeCpmCampaignChannelRequestDocument, options);
      }
export type AdminRevokeCpmCampaignChannelRequestMutationHookResult = ReturnType<typeof useAdminRevokeCpmCampaignChannelRequestMutation>;
export type AdminRevokeCpmCampaignChannelRequestMutationResult = Apollo.MutationResult<AdminRevokeCpmCampaignChannelRequestMutation>;
export type AdminRevokeCpmCampaignChannelRequestMutationOptions = Apollo.BaseMutationOptions<AdminRevokeCpmCampaignChannelRequestMutation, AdminRevokeCpmCampaignChannelRequestMutationVariables>;
export const AdminInviteCpmCampaignUserDocument = gql`
    mutation AdminInviteCpmCampaignUser($campaignId: ID!, $email: String!, $platform: String!, $channelUrl: String!) {
  adminInviteCpmCampaignUser(
    campaignId: $campaignId
    email: $email
    platform: $platform
    channelUrl: $channelUrl
  ) {
    id
    status
    platform
    handle
    user_email
    reviewed_at
  }
}
    `;
export type AdminInviteCpmCampaignUserMutationFn = Apollo.MutationFunction<AdminInviteCpmCampaignUserMutation, AdminInviteCpmCampaignUserMutationVariables>;

/**
 * __useAdminInviteCpmCampaignUserMutation__
 *
 * To run a mutation, you first call `useAdminInviteCpmCampaignUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminInviteCpmCampaignUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminInviteCpmCampaignUserMutation, { data, loading, error }] = useAdminInviteCpmCampaignUserMutation({
 *   variables: {
 *      campaignId: // value for 'campaignId'
 *      email: // value for 'email'
 *      platform: // value for 'platform'
 *      channelUrl: // value for 'channelUrl'
 *   },
 * });
 */
export function useAdminInviteCpmCampaignUserMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AdminInviteCpmCampaignUserMutation, AdminInviteCpmCampaignUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AdminInviteCpmCampaignUserMutation, AdminInviteCpmCampaignUserMutationVariables>(AdminInviteCpmCampaignUserDocument, options);
      }
export type AdminInviteCpmCampaignUserMutationHookResult = ReturnType<typeof useAdminInviteCpmCampaignUserMutation>;
export type AdminInviteCpmCampaignUserMutationResult = Apollo.MutationResult<AdminInviteCpmCampaignUserMutation>;
export type AdminInviteCpmCampaignUserMutationOptions = Apollo.BaseMutationOptions<AdminInviteCpmCampaignUserMutation, AdminInviteCpmCampaignUserMutationVariables>;
export const AdminEmailFlowTriggersDocument = gql`
    query AdminEmailFlowTriggers {
  adminEmailFlowTriggers {
    key
    label
    variables
  }
}
    `;

/**
 * __useAdminEmailFlowTriggersQuery__
 *
 * To run a query within a React component, call `useAdminEmailFlowTriggersQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminEmailFlowTriggersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminEmailFlowTriggersQuery({
 *   variables: {
 *   },
 * });
 */
export function useAdminEmailFlowTriggersQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<AdminEmailFlowTriggersQuery, AdminEmailFlowTriggersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AdminEmailFlowTriggersQuery, AdminEmailFlowTriggersQueryVariables>(AdminEmailFlowTriggersDocument, options);
      }
export function useAdminEmailFlowTriggersLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AdminEmailFlowTriggersQuery, AdminEmailFlowTriggersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AdminEmailFlowTriggersQuery, AdminEmailFlowTriggersQueryVariables>(AdminEmailFlowTriggersDocument, options);
        }
// @ts-ignore
export function useAdminEmailFlowTriggersSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<AdminEmailFlowTriggersQuery, AdminEmailFlowTriggersQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AdminEmailFlowTriggersQuery, AdminEmailFlowTriggersQueryVariables>;
export function useAdminEmailFlowTriggersSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AdminEmailFlowTriggersQuery, AdminEmailFlowTriggersQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AdminEmailFlowTriggersQuery | undefined, AdminEmailFlowTriggersQueryVariables>;
export function useAdminEmailFlowTriggersSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AdminEmailFlowTriggersQuery, AdminEmailFlowTriggersQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<AdminEmailFlowTriggersQuery, AdminEmailFlowTriggersQueryVariables>(AdminEmailFlowTriggersDocument, options);
        }
export type AdminEmailFlowTriggersQueryHookResult = ReturnType<typeof useAdminEmailFlowTriggersQuery>;
export type AdminEmailFlowTriggersLazyQueryHookResult = ReturnType<typeof useAdminEmailFlowTriggersLazyQuery>;
export type AdminEmailFlowTriggersSuspenseQueryHookResult = ReturnType<typeof useAdminEmailFlowTriggersSuspenseQuery>;
export type AdminEmailFlowTriggersQueryResult = Apollo.QueryResult<AdminEmailFlowTriggersQuery, AdminEmailFlowTriggersQueryVariables>;
export const AdminEmailFlowsDocument = gql`
    query AdminEmailFlows($page: Int, $pageSize: Int, $search: String) {
  adminEmailFlows(page: $page, pageSize: $pageSize, search: $search) {
    data {
      id
      name
      slug
      description
      trigger
      is_active
      is_transactional
      is_editable
      audience
      stepsCount
    }
    total
    page
    pageSize
  }
}
    `;

/**
 * __useAdminEmailFlowsQuery__
 *
 * To run a query within a React component, call `useAdminEmailFlowsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminEmailFlowsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminEmailFlowsQuery({
 *   variables: {
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useAdminEmailFlowsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<AdminEmailFlowsQuery, AdminEmailFlowsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AdminEmailFlowsQuery, AdminEmailFlowsQueryVariables>(AdminEmailFlowsDocument, options);
      }
export function useAdminEmailFlowsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AdminEmailFlowsQuery, AdminEmailFlowsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AdminEmailFlowsQuery, AdminEmailFlowsQueryVariables>(AdminEmailFlowsDocument, options);
        }
// @ts-ignore
export function useAdminEmailFlowsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<AdminEmailFlowsQuery, AdminEmailFlowsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AdminEmailFlowsQuery, AdminEmailFlowsQueryVariables>;
export function useAdminEmailFlowsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AdminEmailFlowsQuery, AdminEmailFlowsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AdminEmailFlowsQuery | undefined, AdminEmailFlowsQueryVariables>;
export function useAdminEmailFlowsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AdminEmailFlowsQuery, AdminEmailFlowsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<AdminEmailFlowsQuery, AdminEmailFlowsQueryVariables>(AdminEmailFlowsDocument, options);
        }
export type AdminEmailFlowsQueryHookResult = ReturnType<typeof useAdminEmailFlowsQuery>;
export type AdminEmailFlowsLazyQueryHookResult = ReturnType<typeof useAdminEmailFlowsLazyQuery>;
export type AdminEmailFlowsSuspenseQueryHookResult = ReturnType<typeof useAdminEmailFlowsSuspenseQuery>;
export type AdminEmailFlowsQueryResult = Apollo.QueryResult<AdminEmailFlowsQuery, AdminEmailFlowsQueryVariables>;
export const AdminEmailFlowDocument = gql`
    query AdminEmailFlow($id: ID!) {
  adminEmailFlow(id: $id) {
    id
    name
    slug
    description
    trigger
    is_active
    is_transactional
    is_editable
    audience
    stepsCount
    steps {
      id
      order
      delay_minutes
      subject_pt
      body_pt
      subject_en
      body_en
      is_active
    }
  }
}
    `;

/**
 * __useAdminEmailFlowQuery__
 *
 * To run a query within a React component, call `useAdminEmailFlowQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminEmailFlowQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminEmailFlowQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAdminEmailFlowQuery(baseOptions: ApolloReactHooks.QueryHookOptions<AdminEmailFlowQuery, AdminEmailFlowQueryVariables> & ({ variables: AdminEmailFlowQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AdminEmailFlowQuery, AdminEmailFlowQueryVariables>(AdminEmailFlowDocument, options);
      }
export function useAdminEmailFlowLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AdminEmailFlowQuery, AdminEmailFlowQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AdminEmailFlowQuery, AdminEmailFlowQueryVariables>(AdminEmailFlowDocument, options);
        }
// @ts-ignore
export function useAdminEmailFlowSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<AdminEmailFlowQuery, AdminEmailFlowQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AdminEmailFlowQuery, AdminEmailFlowQueryVariables>;
export function useAdminEmailFlowSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AdminEmailFlowQuery, AdminEmailFlowQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AdminEmailFlowQuery | undefined, AdminEmailFlowQueryVariables>;
export function useAdminEmailFlowSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AdminEmailFlowQuery, AdminEmailFlowQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<AdminEmailFlowQuery, AdminEmailFlowQueryVariables>(AdminEmailFlowDocument, options);
        }
export type AdminEmailFlowQueryHookResult = ReturnType<typeof useAdminEmailFlowQuery>;
export type AdminEmailFlowLazyQueryHookResult = ReturnType<typeof useAdminEmailFlowLazyQuery>;
export type AdminEmailFlowSuspenseQueryHookResult = ReturnType<typeof useAdminEmailFlowSuspenseQuery>;
export type AdminEmailFlowQueryResult = Apollo.QueryResult<AdminEmailFlowQuery, AdminEmailFlowQueryVariables>;
export const AdminCreateEmailFlowDocument = gql`
    mutation AdminCreateEmailFlow($input: AdminEmailFlowInput!) {
  adminCreateEmailFlow(input: $input) {
    id
    name
    slug
    trigger
    is_active
    is_transactional
    is_editable
    audience
    stepsCount
  }
}
    `;
export type AdminCreateEmailFlowMutationFn = Apollo.MutationFunction<AdminCreateEmailFlowMutation, AdminCreateEmailFlowMutationVariables>;

/**
 * __useAdminCreateEmailFlowMutation__
 *
 * To run a mutation, you first call `useAdminCreateEmailFlowMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminCreateEmailFlowMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminCreateEmailFlowMutation, { data, loading, error }] = useAdminCreateEmailFlowMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdminCreateEmailFlowMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AdminCreateEmailFlowMutation, AdminCreateEmailFlowMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AdminCreateEmailFlowMutation, AdminCreateEmailFlowMutationVariables>(AdminCreateEmailFlowDocument, options);
      }
export type AdminCreateEmailFlowMutationHookResult = ReturnType<typeof useAdminCreateEmailFlowMutation>;
export type AdminCreateEmailFlowMutationResult = Apollo.MutationResult<AdminCreateEmailFlowMutation>;
export type AdminCreateEmailFlowMutationOptions = Apollo.BaseMutationOptions<AdminCreateEmailFlowMutation, AdminCreateEmailFlowMutationVariables>;
export const AdminUpdateEmailFlowDocument = gql`
    mutation AdminUpdateEmailFlow($id: ID!, $input: AdminEmailFlowUpdateInput!) {
  adminUpdateEmailFlow(id: $id, input: $input) {
    id
    name
    slug
    description
    trigger
    is_active
    is_transactional
    is_editable
    audience
    stepsCount
  }
}
    `;
export type AdminUpdateEmailFlowMutationFn = Apollo.MutationFunction<AdminUpdateEmailFlowMutation, AdminUpdateEmailFlowMutationVariables>;

/**
 * __useAdminUpdateEmailFlowMutation__
 *
 * To run a mutation, you first call `useAdminUpdateEmailFlowMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminUpdateEmailFlowMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminUpdateEmailFlowMutation, { data, loading, error }] = useAdminUpdateEmailFlowMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdminUpdateEmailFlowMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AdminUpdateEmailFlowMutation, AdminUpdateEmailFlowMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AdminUpdateEmailFlowMutation, AdminUpdateEmailFlowMutationVariables>(AdminUpdateEmailFlowDocument, options);
      }
export type AdminUpdateEmailFlowMutationHookResult = ReturnType<typeof useAdminUpdateEmailFlowMutation>;
export type AdminUpdateEmailFlowMutationResult = Apollo.MutationResult<AdminUpdateEmailFlowMutation>;
export type AdminUpdateEmailFlowMutationOptions = Apollo.BaseMutationOptions<AdminUpdateEmailFlowMutation, AdminUpdateEmailFlowMutationVariables>;
export const AdminDeleteEmailFlowDocument = gql`
    mutation AdminDeleteEmailFlow($id: ID!) {
  adminDeleteEmailFlow(id: $id)
}
    `;
export type AdminDeleteEmailFlowMutationFn = Apollo.MutationFunction<AdminDeleteEmailFlowMutation, AdminDeleteEmailFlowMutationVariables>;

/**
 * __useAdminDeleteEmailFlowMutation__
 *
 * To run a mutation, you first call `useAdminDeleteEmailFlowMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminDeleteEmailFlowMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminDeleteEmailFlowMutation, { data, loading, error }] = useAdminDeleteEmailFlowMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAdminDeleteEmailFlowMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AdminDeleteEmailFlowMutation, AdminDeleteEmailFlowMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AdminDeleteEmailFlowMutation, AdminDeleteEmailFlowMutationVariables>(AdminDeleteEmailFlowDocument, options);
      }
export type AdminDeleteEmailFlowMutationHookResult = ReturnType<typeof useAdminDeleteEmailFlowMutation>;
export type AdminDeleteEmailFlowMutationResult = Apollo.MutationResult<AdminDeleteEmailFlowMutation>;
export type AdminDeleteEmailFlowMutationOptions = Apollo.BaseMutationOptions<AdminDeleteEmailFlowMutation, AdminDeleteEmailFlowMutationVariables>;
export const AdminUpsertEmailFlowStepDocument = gql`
    mutation AdminUpsertEmailFlowStep($input: AdminEmailFlowStepInput!) {
  adminUpsertEmailFlowStep(input: $input) {
    id
    order
    delay_minutes
    subject_pt
    body_pt
    subject_en
    body_en
    is_active
  }
}
    `;
export type AdminUpsertEmailFlowStepMutationFn = Apollo.MutationFunction<AdminUpsertEmailFlowStepMutation, AdminUpsertEmailFlowStepMutationVariables>;

/**
 * __useAdminUpsertEmailFlowStepMutation__
 *
 * To run a mutation, you first call `useAdminUpsertEmailFlowStepMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminUpsertEmailFlowStepMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminUpsertEmailFlowStepMutation, { data, loading, error }] = useAdminUpsertEmailFlowStepMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdminUpsertEmailFlowStepMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AdminUpsertEmailFlowStepMutation, AdminUpsertEmailFlowStepMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AdminUpsertEmailFlowStepMutation, AdminUpsertEmailFlowStepMutationVariables>(AdminUpsertEmailFlowStepDocument, options);
      }
export type AdminUpsertEmailFlowStepMutationHookResult = ReturnType<typeof useAdminUpsertEmailFlowStepMutation>;
export type AdminUpsertEmailFlowStepMutationResult = Apollo.MutationResult<AdminUpsertEmailFlowStepMutation>;
export type AdminUpsertEmailFlowStepMutationOptions = Apollo.BaseMutationOptions<AdminUpsertEmailFlowStepMutation, AdminUpsertEmailFlowStepMutationVariables>;
export const AdminDeleteEmailFlowStepDocument = gql`
    mutation AdminDeleteEmailFlowStep($id: ID!) {
  adminDeleteEmailFlowStep(id: $id)
}
    `;
export type AdminDeleteEmailFlowStepMutationFn = Apollo.MutationFunction<AdminDeleteEmailFlowStepMutation, AdminDeleteEmailFlowStepMutationVariables>;

/**
 * __useAdminDeleteEmailFlowStepMutation__
 *
 * To run a mutation, you first call `useAdminDeleteEmailFlowStepMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminDeleteEmailFlowStepMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminDeleteEmailFlowStepMutation, { data, loading, error }] = useAdminDeleteEmailFlowStepMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAdminDeleteEmailFlowStepMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AdminDeleteEmailFlowStepMutation, AdminDeleteEmailFlowStepMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AdminDeleteEmailFlowStepMutation, AdminDeleteEmailFlowStepMutationVariables>(AdminDeleteEmailFlowStepDocument, options);
      }
export type AdminDeleteEmailFlowStepMutationHookResult = ReturnType<typeof useAdminDeleteEmailFlowStepMutation>;
export type AdminDeleteEmailFlowStepMutationResult = Apollo.MutationResult<AdminDeleteEmailFlowStepMutation>;
export type AdminDeleteEmailFlowStepMutationOptions = Apollo.BaseMutationOptions<AdminDeleteEmailFlowStepMutation, AdminDeleteEmailFlowStepMutationVariables>;
export const AdminReorderEmailFlowStepsDocument = gql`
    mutation AdminReorderEmailFlowSteps($flowId: ID!, $stepIds: [ID!]!) {
  adminReorderEmailFlowSteps(flowId: $flowId, stepIds: $stepIds) {
    id
    order
    delay_minutes
    subject_pt
    body_pt
    subject_en
    body_en
    is_active
  }
}
    `;
export type AdminReorderEmailFlowStepsMutationFn = Apollo.MutationFunction<AdminReorderEmailFlowStepsMutation, AdminReorderEmailFlowStepsMutationVariables>;

/**
 * __useAdminReorderEmailFlowStepsMutation__
 *
 * To run a mutation, you first call `useAdminReorderEmailFlowStepsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminReorderEmailFlowStepsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminReorderEmailFlowStepsMutation, { data, loading, error }] = useAdminReorderEmailFlowStepsMutation({
 *   variables: {
 *      flowId: // value for 'flowId'
 *      stepIds: // value for 'stepIds'
 *   },
 * });
 */
export function useAdminReorderEmailFlowStepsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AdminReorderEmailFlowStepsMutation, AdminReorderEmailFlowStepsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AdminReorderEmailFlowStepsMutation, AdminReorderEmailFlowStepsMutationVariables>(AdminReorderEmailFlowStepsDocument, options);
      }
export type AdminReorderEmailFlowStepsMutationHookResult = ReturnType<typeof useAdminReorderEmailFlowStepsMutation>;
export type AdminReorderEmailFlowStepsMutationResult = Apollo.MutationResult<AdminReorderEmailFlowStepsMutation>;
export type AdminReorderEmailFlowStepsMutationOptions = Apollo.BaseMutationOptions<AdminReorderEmailFlowStepsMutation, AdminReorderEmailFlowStepsMutationVariables>;
export const AdminSendTestEmailFlowStepDocument = gql`
    mutation AdminSendTestEmailFlowStep($stepId: ID!, $locale: String!, $recipientEmail: String!) {
  adminSendTestEmailFlowStep(
    stepId: $stepId
    locale: $locale
    recipientEmail: $recipientEmail
  )
}
    `;
export type AdminSendTestEmailFlowStepMutationFn = Apollo.MutationFunction<AdminSendTestEmailFlowStepMutation, AdminSendTestEmailFlowStepMutationVariables>;

/**
 * __useAdminSendTestEmailFlowStepMutation__
 *
 * To run a mutation, you first call `useAdminSendTestEmailFlowStepMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminSendTestEmailFlowStepMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminSendTestEmailFlowStepMutation, { data, loading, error }] = useAdminSendTestEmailFlowStepMutation({
 *   variables: {
 *      stepId: // value for 'stepId'
 *      locale: // value for 'locale'
 *      recipientEmail: // value for 'recipientEmail'
 *   },
 * });
 */
export function useAdminSendTestEmailFlowStepMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AdminSendTestEmailFlowStepMutation, AdminSendTestEmailFlowStepMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AdminSendTestEmailFlowStepMutation, AdminSendTestEmailFlowStepMutationVariables>(AdminSendTestEmailFlowStepDocument, options);
      }
export type AdminSendTestEmailFlowStepMutationHookResult = ReturnType<typeof useAdminSendTestEmailFlowStepMutation>;
export type AdminSendTestEmailFlowStepMutationResult = Apollo.MutationResult<AdminSendTestEmailFlowStepMutation>;
export type AdminSendTestEmailFlowStepMutationOptions = Apollo.BaseMutationOptions<AdminSendTestEmailFlowStepMutation, AdminSendTestEmailFlowStepMutationVariables>;
export const AdminEmailFlowRunsDocument = gql`
    query AdminEmailFlowRuns($flowId: ID!, $page: Int, $pageSize: Int) {
  adminEmailFlowRuns(flowId: $flowId, page: $page, pageSize: $pageSize) {
    data {
      id
      user_email
      current_step_order
      status
      started_at
      completed_at
      sendsCount
    }
    total
    page
    pageSize
  }
}
    `;

/**
 * __useAdminEmailFlowRunsQuery__
 *
 * To run a query within a React component, call `useAdminEmailFlowRunsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminEmailFlowRunsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminEmailFlowRunsQuery({
 *   variables: {
 *      flowId: // value for 'flowId'
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *   },
 * });
 */
export function useAdminEmailFlowRunsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<AdminEmailFlowRunsQuery, AdminEmailFlowRunsQueryVariables> & ({ variables: AdminEmailFlowRunsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AdminEmailFlowRunsQuery, AdminEmailFlowRunsQueryVariables>(AdminEmailFlowRunsDocument, options);
      }
export function useAdminEmailFlowRunsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AdminEmailFlowRunsQuery, AdminEmailFlowRunsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AdminEmailFlowRunsQuery, AdminEmailFlowRunsQueryVariables>(AdminEmailFlowRunsDocument, options);
        }
// @ts-ignore
export function useAdminEmailFlowRunsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<AdminEmailFlowRunsQuery, AdminEmailFlowRunsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AdminEmailFlowRunsQuery, AdminEmailFlowRunsQueryVariables>;
export function useAdminEmailFlowRunsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AdminEmailFlowRunsQuery, AdminEmailFlowRunsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AdminEmailFlowRunsQuery | undefined, AdminEmailFlowRunsQueryVariables>;
export function useAdminEmailFlowRunsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AdminEmailFlowRunsQuery, AdminEmailFlowRunsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<AdminEmailFlowRunsQuery, AdminEmailFlowRunsQueryVariables>(AdminEmailFlowRunsDocument, options);
        }
export type AdminEmailFlowRunsQueryHookResult = ReturnType<typeof useAdminEmailFlowRunsQuery>;
export type AdminEmailFlowRunsLazyQueryHookResult = ReturnType<typeof useAdminEmailFlowRunsLazyQuery>;
export type AdminEmailFlowRunsSuspenseQueryHookResult = ReturnType<typeof useAdminEmailFlowRunsSuspenseQuery>;
export type AdminEmailFlowRunsQueryResult = Apollo.QueryResult<AdminEmailFlowRunsQuery, AdminEmailFlowRunsQueryVariables>;
export const AdminEmailFlowRunSendsDocument = gql`
    query AdminEmailFlowRunSends($runId: ID!) {
  adminEmailFlowRunSends(runId: $runId) {
    id
    step_id
    step_order
    sent_at
    success
    error
    subject_used
    language_used
    is_test
  }
}
    `;

/**
 * __useAdminEmailFlowRunSendsQuery__
 *
 * To run a query within a React component, call `useAdminEmailFlowRunSendsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminEmailFlowRunSendsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminEmailFlowRunSendsQuery({
 *   variables: {
 *      runId: // value for 'runId'
 *   },
 * });
 */
export function useAdminEmailFlowRunSendsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<AdminEmailFlowRunSendsQuery, AdminEmailFlowRunSendsQueryVariables> & ({ variables: AdminEmailFlowRunSendsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AdminEmailFlowRunSendsQuery, AdminEmailFlowRunSendsQueryVariables>(AdminEmailFlowRunSendsDocument, options);
      }
export function useAdminEmailFlowRunSendsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AdminEmailFlowRunSendsQuery, AdminEmailFlowRunSendsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AdminEmailFlowRunSendsQuery, AdminEmailFlowRunSendsQueryVariables>(AdminEmailFlowRunSendsDocument, options);
        }
// @ts-ignore
export function useAdminEmailFlowRunSendsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<AdminEmailFlowRunSendsQuery, AdminEmailFlowRunSendsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AdminEmailFlowRunSendsQuery, AdminEmailFlowRunSendsQueryVariables>;
export function useAdminEmailFlowRunSendsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AdminEmailFlowRunSendsQuery, AdminEmailFlowRunSendsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AdminEmailFlowRunSendsQuery | undefined, AdminEmailFlowRunSendsQueryVariables>;
export function useAdminEmailFlowRunSendsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AdminEmailFlowRunSendsQuery, AdminEmailFlowRunSendsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<AdminEmailFlowRunSendsQuery, AdminEmailFlowRunSendsQueryVariables>(AdminEmailFlowRunSendsDocument, options);
        }
export type AdminEmailFlowRunSendsQueryHookResult = ReturnType<typeof useAdminEmailFlowRunSendsQuery>;
export type AdminEmailFlowRunSendsLazyQueryHookResult = ReturnType<typeof useAdminEmailFlowRunSendsLazyQuery>;
export type AdminEmailFlowRunSendsSuspenseQueryHookResult = ReturnType<typeof useAdminEmailFlowRunSendsSuspenseQuery>;
export type AdminEmailFlowRunSendsQueryResult = Apollo.QueryResult<AdminEmailFlowRunSendsQuery, AdminEmailFlowRunSendsQueryVariables>;
export const EffectiveWatermarkDocument = gql`
    query EffectiveWatermark($id: ID!) {
  myProject(id: $id) {
    id
    effective_watermark {
      image_url
      anchor
      size_percent
      opacity_percent
      margin_x_percent
      margin_y_percent
    }
    effective_post_layout
    effective_subtitle_position
  }
}
    `;

/**
 * __useEffectiveWatermarkQuery__
 *
 * To run a query within a React component, call `useEffectiveWatermarkQuery` and pass it any options that fit your needs.
 * When your component renders, `useEffectiveWatermarkQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEffectiveWatermarkQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useEffectiveWatermarkQuery(baseOptions: ApolloReactHooks.QueryHookOptions<EffectiveWatermarkQuery, EffectiveWatermarkQueryVariables> & ({ variables: EffectiveWatermarkQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<EffectiveWatermarkQuery, EffectiveWatermarkQueryVariables>(EffectiveWatermarkDocument, options);
      }
export function useEffectiveWatermarkLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<EffectiveWatermarkQuery, EffectiveWatermarkQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<EffectiveWatermarkQuery, EffectiveWatermarkQueryVariables>(EffectiveWatermarkDocument, options);
        }
// @ts-ignore
export function useEffectiveWatermarkSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<EffectiveWatermarkQuery, EffectiveWatermarkQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<EffectiveWatermarkQuery, EffectiveWatermarkQueryVariables>;
export function useEffectiveWatermarkSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<EffectiveWatermarkQuery, EffectiveWatermarkQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<EffectiveWatermarkQuery | undefined, EffectiveWatermarkQueryVariables>;
export function useEffectiveWatermarkSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<EffectiveWatermarkQuery, EffectiveWatermarkQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<EffectiveWatermarkQuery, EffectiveWatermarkQueryVariables>(EffectiveWatermarkDocument, options);
        }
export type EffectiveWatermarkQueryHookResult = ReturnType<typeof useEffectiveWatermarkQuery>;
export type EffectiveWatermarkLazyQueryHookResult = ReturnType<typeof useEffectiveWatermarkLazyQuery>;
export type EffectiveWatermarkSuspenseQueryHookResult = ReturnType<typeof useEffectiveWatermarkSuspenseQuery>;
export type EffectiveWatermarkQueryResult = Apollo.QueryResult<EffectiveWatermarkQuery, EffectiveWatermarkQueryVariables>;
export const LibraryEffectiveWatermarkDocument = gql`
    query LibraryEffectiveWatermark($id: ID!) {
  myLibrary(id: $id) {
    id
    effective_watermark {
      image_url
      anchor
      size_percent
      opacity_percent
      margin_x_percent
      margin_y_percent
    }
    effective_post_layout
    effective_subtitle_position
    active_cpm_campaigns {
      id
    }
  }
}
    `;

/**
 * __useLibraryEffectiveWatermarkQuery__
 *
 * To run a query within a React component, call `useLibraryEffectiveWatermarkQuery` and pass it any options that fit your needs.
 * When your component renders, `useLibraryEffectiveWatermarkQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLibraryEffectiveWatermarkQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useLibraryEffectiveWatermarkQuery(baseOptions: ApolloReactHooks.QueryHookOptions<LibraryEffectiveWatermarkQuery, LibraryEffectiveWatermarkQueryVariables> & ({ variables: LibraryEffectiveWatermarkQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<LibraryEffectiveWatermarkQuery, LibraryEffectiveWatermarkQueryVariables>(LibraryEffectiveWatermarkDocument, options);
      }
export function useLibraryEffectiveWatermarkLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<LibraryEffectiveWatermarkQuery, LibraryEffectiveWatermarkQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<LibraryEffectiveWatermarkQuery, LibraryEffectiveWatermarkQueryVariables>(LibraryEffectiveWatermarkDocument, options);
        }
// @ts-ignore
export function useLibraryEffectiveWatermarkSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<LibraryEffectiveWatermarkQuery, LibraryEffectiveWatermarkQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<LibraryEffectiveWatermarkQuery, LibraryEffectiveWatermarkQueryVariables>;
export function useLibraryEffectiveWatermarkSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<LibraryEffectiveWatermarkQuery, LibraryEffectiveWatermarkQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<LibraryEffectiveWatermarkQuery | undefined, LibraryEffectiveWatermarkQueryVariables>;
export function useLibraryEffectiveWatermarkSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<LibraryEffectiveWatermarkQuery, LibraryEffectiveWatermarkQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<LibraryEffectiveWatermarkQuery, LibraryEffectiveWatermarkQueryVariables>(LibraryEffectiveWatermarkDocument, options);
        }
export type LibraryEffectiveWatermarkQueryHookResult = ReturnType<typeof useLibraryEffectiveWatermarkQuery>;
export type LibraryEffectiveWatermarkLazyQueryHookResult = ReturnType<typeof useLibraryEffectiveWatermarkLazyQuery>;
export type LibraryEffectiveWatermarkSuspenseQueryHookResult = ReturnType<typeof useLibraryEffectiveWatermarkSuspenseQuery>;
export type LibraryEffectiveWatermarkQueryResult = Apollo.QueryResult<LibraryEffectiveWatermarkQuery, LibraryEffectiveWatermarkQueryVariables>;
export const FillerVideosDocument = gql`
    query fillerVideos($category: String) {
  fillerVideos(category: $category) {
    id
    name
    categories
    file_url
    file_en_url
    thumbnail_url
  }
}
    `;

/**
 * __useFillerVideosQuery__
 *
 * To run a query within a React component, call `useFillerVideosQuery` and pass it any options that fit your needs.
 * When your component renders, `useFillerVideosQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFillerVideosQuery({
 *   variables: {
 *      category: // value for 'category'
 *   },
 * });
 */
export function useFillerVideosQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<FillerVideosQuery, FillerVideosQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<FillerVideosQuery, FillerVideosQueryVariables>(FillerVideosDocument, options);
      }
export function useFillerVideosLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<FillerVideosQuery, FillerVideosQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<FillerVideosQuery, FillerVideosQueryVariables>(FillerVideosDocument, options);
        }
// @ts-ignore
export function useFillerVideosSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<FillerVideosQuery, FillerVideosQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<FillerVideosQuery, FillerVideosQueryVariables>;
export function useFillerVideosSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<FillerVideosQuery, FillerVideosQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<FillerVideosQuery | undefined, FillerVideosQueryVariables>;
export function useFillerVideosSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<FillerVideosQuery, FillerVideosQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<FillerVideosQuery, FillerVideosQueryVariables>(FillerVideosDocument, options);
        }
export type FillerVideosQueryHookResult = ReturnType<typeof useFillerVideosQuery>;
export type FillerVideosLazyQueryHookResult = ReturnType<typeof useFillerVideosLazyQuery>;
export type FillerVideosSuspenseQueryHookResult = ReturnType<typeof useFillerVideosSuspenseQuery>;
export type FillerVideosQueryResult = Apollo.QueryResult<FillerVideosQuery, FillerVideosQueryVariables>;
export const FillerVideoTagsDocument = gql`
    query fillerVideoTags {
  fillerVideoTags {
    slug
    name
  }
}
    `;

/**
 * __useFillerVideoTagsQuery__
 *
 * To run a query within a React component, call `useFillerVideoTagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFillerVideoTagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFillerVideoTagsQuery({
 *   variables: {
 *   },
 * });
 */
export function useFillerVideoTagsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<FillerVideoTagsQuery, FillerVideoTagsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<FillerVideoTagsQuery, FillerVideoTagsQueryVariables>(FillerVideoTagsDocument, options);
      }
export function useFillerVideoTagsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<FillerVideoTagsQuery, FillerVideoTagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<FillerVideoTagsQuery, FillerVideoTagsQueryVariables>(FillerVideoTagsDocument, options);
        }
// @ts-ignore
export function useFillerVideoTagsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<FillerVideoTagsQuery, FillerVideoTagsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<FillerVideoTagsQuery, FillerVideoTagsQueryVariables>;
export function useFillerVideoTagsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<FillerVideoTagsQuery, FillerVideoTagsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<FillerVideoTagsQuery | undefined, FillerVideoTagsQueryVariables>;
export function useFillerVideoTagsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<FillerVideoTagsQuery, FillerVideoTagsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<FillerVideoTagsQuery, FillerVideoTagsQueryVariables>(FillerVideoTagsDocument, options);
        }
export type FillerVideoTagsQueryHookResult = ReturnType<typeof useFillerVideoTagsQuery>;
export type FillerVideoTagsLazyQueryHookResult = ReturnType<typeof useFillerVideoTagsLazyQuery>;
export type FillerVideoTagsSuspenseQueryHookResult = ReturnType<typeof useFillerVideoTagsSuspenseQuery>;
export type FillerVideoTagsQueryResult = Apollo.QueryResult<FillerVideoTagsQuery, FillerVideoTagsQueryVariables>;
export const MyUserMediaDocument = gql`
    query myUserMedia($kind: String, $folderId: ID, $search: String, $limit: Int, $offset: Int) {
  myUserMedia(
    kind: $kind
    folderId: $folderId
    search: $search
    limit: $limit
    offset: $offset
  ) {
    id
    url
    kind
    name
    width
    height
    duration
    folder_id
    createdAt
  }
}
    `;

/**
 * __useMyUserMediaQuery__
 *
 * To run a query within a React component, call `useMyUserMediaQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyUserMediaQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyUserMediaQuery({
 *   variables: {
 *      kind: // value for 'kind'
 *      folderId: // value for 'folderId'
 *      search: // value for 'search'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useMyUserMediaQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<MyUserMediaQuery, MyUserMediaQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<MyUserMediaQuery, MyUserMediaQueryVariables>(MyUserMediaDocument, options);
      }
export function useMyUserMediaLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<MyUserMediaQuery, MyUserMediaQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<MyUserMediaQuery, MyUserMediaQueryVariables>(MyUserMediaDocument, options);
        }
// @ts-ignore
export function useMyUserMediaSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<MyUserMediaQuery, MyUserMediaQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<MyUserMediaQuery, MyUserMediaQueryVariables>;
export function useMyUserMediaSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<MyUserMediaQuery, MyUserMediaQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<MyUserMediaQuery | undefined, MyUserMediaQueryVariables>;
export function useMyUserMediaSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<MyUserMediaQuery, MyUserMediaQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<MyUserMediaQuery, MyUserMediaQueryVariables>(MyUserMediaDocument, options);
        }
export type MyUserMediaQueryHookResult = ReturnType<typeof useMyUserMediaQuery>;
export type MyUserMediaLazyQueryHookResult = ReturnType<typeof useMyUserMediaLazyQuery>;
export type MyUserMediaSuspenseQueryHookResult = ReturnType<typeof useMyUserMediaSuspenseQuery>;
export type MyUserMediaQueryResult = Apollo.QueryResult<MyUserMediaQuery, MyUserMediaQueryVariables>;
export const CreateMyUserMediaDocument = gql`
    mutation createMyUserMedia($input: MyUserMediaCreateInput!) {
  createMyUserMedia(input: $input) {
    id
    url
    kind
    name
    width
    height
    duration
    folder_id
    createdAt
  }
}
    `;
export type CreateMyUserMediaMutationFn = Apollo.MutationFunction<CreateMyUserMediaMutation, CreateMyUserMediaMutationVariables>;

/**
 * __useCreateMyUserMediaMutation__
 *
 * To run a mutation, you first call `useCreateMyUserMediaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMyUserMediaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMyUserMediaMutation, { data, loading, error }] = useCreateMyUserMediaMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateMyUserMediaMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateMyUserMediaMutation, CreateMyUserMediaMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateMyUserMediaMutation, CreateMyUserMediaMutationVariables>(CreateMyUserMediaDocument, options);
      }
export type CreateMyUserMediaMutationHookResult = ReturnType<typeof useCreateMyUserMediaMutation>;
export type CreateMyUserMediaMutationResult = Apollo.MutationResult<CreateMyUserMediaMutation>;
export type CreateMyUserMediaMutationOptions = Apollo.BaseMutationOptions<CreateMyUserMediaMutation, CreateMyUserMediaMutationVariables>;
export const MyUserMediaFoldersDocument = gql`
    query myUserMediaFolders {
  myUserMediaFolders {
    id
    name
    media_count
    createdAt
  }
}
    `;

/**
 * __useMyUserMediaFoldersQuery__
 *
 * To run a query within a React component, call `useMyUserMediaFoldersQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyUserMediaFoldersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyUserMediaFoldersQuery({
 *   variables: {
 *   },
 * });
 */
export function useMyUserMediaFoldersQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<MyUserMediaFoldersQuery, MyUserMediaFoldersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<MyUserMediaFoldersQuery, MyUserMediaFoldersQueryVariables>(MyUserMediaFoldersDocument, options);
      }
export function useMyUserMediaFoldersLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<MyUserMediaFoldersQuery, MyUserMediaFoldersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<MyUserMediaFoldersQuery, MyUserMediaFoldersQueryVariables>(MyUserMediaFoldersDocument, options);
        }
// @ts-ignore
export function useMyUserMediaFoldersSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<MyUserMediaFoldersQuery, MyUserMediaFoldersQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<MyUserMediaFoldersQuery, MyUserMediaFoldersQueryVariables>;
export function useMyUserMediaFoldersSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<MyUserMediaFoldersQuery, MyUserMediaFoldersQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<MyUserMediaFoldersQuery | undefined, MyUserMediaFoldersQueryVariables>;
export function useMyUserMediaFoldersSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<MyUserMediaFoldersQuery, MyUserMediaFoldersQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<MyUserMediaFoldersQuery, MyUserMediaFoldersQueryVariables>(MyUserMediaFoldersDocument, options);
        }
export type MyUserMediaFoldersQueryHookResult = ReturnType<typeof useMyUserMediaFoldersQuery>;
export type MyUserMediaFoldersLazyQueryHookResult = ReturnType<typeof useMyUserMediaFoldersLazyQuery>;
export type MyUserMediaFoldersSuspenseQueryHookResult = ReturnType<typeof useMyUserMediaFoldersSuspenseQuery>;
export type MyUserMediaFoldersQueryResult = Apollo.QueryResult<MyUserMediaFoldersQuery, MyUserMediaFoldersQueryVariables>;
export const UpdateMyUserMediaDocument = gql`
    mutation updateMyUserMedia($id: ID!, $input: MyUserMediaUpdateInput!) {
  updateMyUserMedia(id: $id, input: $input) {
    id
    url
    kind
    name
    width
    height
    duration
    folder_id
    createdAt
  }
}
    `;
export type UpdateMyUserMediaMutationFn = Apollo.MutationFunction<UpdateMyUserMediaMutation, UpdateMyUserMediaMutationVariables>;

/**
 * __useUpdateMyUserMediaMutation__
 *
 * To run a mutation, you first call `useUpdateMyUserMediaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMyUserMediaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMyUserMediaMutation, { data, loading, error }] = useUpdateMyUserMediaMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateMyUserMediaMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateMyUserMediaMutation, UpdateMyUserMediaMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateMyUserMediaMutation, UpdateMyUserMediaMutationVariables>(UpdateMyUserMediaDocument, options);
      }
export type UpdateMyUserMediaMutationHookResult = ReturnType<typeof useUpdateMyUserMediaMutation>;
export type UpdateMyUserMediaMutationResult = Apollo.MutationResult<UpdateMyUserMediaMutation>;
export type UpdateMyUserMediaMutationOptions = Apollo.BaseMutationOptions<UpdateMyUserMediaMutation, UpdateMyUserMediaMutationVariables>;
export const DeleteMyUserMediaDocument = gql`
    mutation deleteMyUserMedia($id: ID!) {
  deleteMyUserMedia(id: $id)
}
    `;
export type DeleteMyUserMediaMutationFn = Apollo.MutationFunction<DeleteMyUserMediaMutation, DeleteMyUserMediaMutationVariables>;

/**
 * __useDeleteMyUserMediaMutation__
 *
 * To run a mutation, you first call `useDeleteMyUserMediaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteMyUserMediaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteMyUserMediaMutation, { data, loading, error }] = useDeleteMyUserMediaMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteMyUserMediaMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteMyUserMediaMutation, DeleteMyUserMediaMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteMyUserMediaMutation, DeleteMyUserMediaMutationVariables>(DeleteMyUserMediaDocument, options);
      }
export type DeleteMyUserMediaMutationHookResult = ReturnType<typeof useDeleteMyUserMediaMutation>;
export type DeleteMyUserMediaMutationResult = Apollo.MutationResult<DeleteMyUserMediaMutation>;
export type DeleteMyUserMediaMutationOptions = Apollo.BaseMutationOptions<DeleteMyUserMediaMutation, DeleteMyUserMediaMutationVariables>;
export const CreateMyUserMediaFolderDocument = gql`
    mutation createMyUserMediaFolder($name: String!) {
  createMyUserMediaFolder(name: $name) {
    id
    name
    media_count
    createdAt
  }
}
    `;
export type CreateMyUserMediaFolderMutationFn = Apollo.MutationFunction<CreateMyUserMediaFolderMutation, CreateMyUserMediaFolderMutationVariables>;

/**
 * __useCreateMyUserMediaFolderMutation__
 *
 * To run a mutation, you first call `useCreateMyUserMediaFolderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMyUserMediaFolderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMyUserMediaFolderMutation, { data, loading, error }] = useCreateMyUserMediaFolderMutation({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useCreateMyUserMediaFolderMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateMyUserMediaFolderMutation, CreateMyUserMediaFolderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateMyUserMediaFolderMutation, CreateMyUserMediaFolderMutationVariables>(CreateMyUserMediaFolderDocument, options);
      }
export type CreateMyUserMediaFolderMutationHookResult = ReturnType<typeof useCreateMyUserMediaFolderMutation>;
export type CreateMyUserMediaFolderMutationResult = Apollo.MutationResult<CreateMyUserMediaFolderMutation>;
export type CreateMyUserMediaFolderMutationOptions = Apollo.BaseMutationOptions<CreateMyUserMediaFolderMutation, CreateMyUserMediaFolderMutationVariables>;
export const UpdateMyUserMediaFolderDocument = gql`
    mutation updateMyUserMediaFolder($id: ID!, $name: String!) {
  updateMyUserMediaFolder(id: $id, name: $name) {
    id
    name
    media_count
    createdAt
  }
}
    `;
export type UpdateMyUserMediaFolderMutationFn = Apollo.MutationFunction<UpdateMyUserMediaFolderMutation, UpdateMyUserMediaFolderMutationVariables>;

/**
 * __useUpdateMyUserMediaFolderMutation__
 *
 * To run a mutation, you first call `useUpdateMyUserMediaFolderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMyUserMediaFolderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMyUserMediaFolderMutation, { data, loading, error }] = useUpdateMyUserMediaFolderMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useUpdateMyUserMediaFolderMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateMyUserMediaFolderMutation, UpdateMyUserMediaFolderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateMyUserMediaFolderMutation, UpdateMyUserMediaFolderMutationVariables>(UpdateMyUserMediaFolderDocument, options);
      }
export type UpdateMyUserMediaFolderMutationHookResult = ReturnType<typeof useUpdateMyUserMediaFolderMutation>;
export type UpdateMyUserMediaFolderMutationResult = Apollo.MutationResult<UpdateMyUserMediaFolderMutation>;
export type UpdateMyUserMediaFolderMutationOptions = Apollo.BaseMutationOptions<UpdateMyUserMediaFolderMutation, UpdateMyUserMediaFolderMutationVariables>;
export const DeleteMyUserMediaFolderDocument = gql`
    mutation deleteMyUserMediaFolder($id: ID!) {
  deleteMyUserMediaFolder(id: $id)
}
    `;
export type DeleteMyUserMediaFolderMutationFn = Apollo.MutationFunction<DeleteMyUserMediaFolderMutation, DeleteMyUserMediaFolderMutationVariables>;

/**
 * __useDeleteMyUserMediaFolderMutation__
 *
 * To run a mutation, you first call `useDeleteMyUserMediaFolderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteMyUserMediaFolderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteMyUserMediaFolderMutation, { data, loading, error }] = useDeleteMyUserMediaFolderMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteMyUserMediaFolderMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteMyUserMediaFolderMutation, DeleteMyUserMediaFolderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteMyUserMediaFolderMutation, DeleteMyUserMediaFolderMutationVariables>(DeleteMyUserMediaFolderDocument, options);
      }
export type DeleteMyUserMediaFolderMutationHookResult = ReturnType<typeof useDeleteMyUserMediaFolderMutation>;
export type DeleteMyUserMediaFolderMutationResult = Apollo.MutationResult<DeleteMyUserMediaFolderMutation>;
export type DeleteMyUserMediaFolderMutationOptions = Apollo.BaseMutationOptions<DeleteMyUserMediaFolderMutation, DeleteMyUserMediaFolderMutationVariables>;
export const StockMediaSearchDocument = gql`
    query stockMediaSearch($kind: StockMediaKind!, $query: String, $page: Int, $provider: StockMediaProvider) {
  stockMediaSearch(kind: $kind, query: $query, page: $page, provider: $provider) {
    page
    has_more
    items {
      id
      provider
      kind
      thumbnail_url
      preview_url
      file_url
      width
      height
      duration
      author
      author_url
      source_url
      download_location
    }
  }
}
    `;

/**
 * __useStockMediaSearchQuery__
 *
 * To run a query within a React component, call `useStockMediaSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useStockMediaSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStockMediaSearchQuery({
 *   variables: {
 *      kind: // value for 'kind'
 *      query: // value for 'query'
 *      page: // value for 'page'
 *      provider: // value for 'provider'
 *   },
 * });
 */
export function useStockMediaSearchQuery(baseOptions: ApolloReactHooks.QueryHookOptions<StockMediaSearchQuery, StockMediaSearchQueryVariables> & ({ variables: StockMediaSearchQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<StockMediaSearchQuery, StockMediaSearchQueryVariables>(StockMediaSearchDocument, options);
      }
export function useStockMediaSearchLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<StockMediaSearchQuery, StockMediaSearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<StockMediaSearchQuery, StockMediaSearchQueryVariables>(StockMediaSearchDocument, options);
        }
// @ts-ignore
export function useStockMediaSearchSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<StockMediaSearchQuery, StockMediaSearchQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<StockMediaSearchQuery, StockMediaSearchQueryVariables>;
export function useStockMediaSearchSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<StockMediaSearchQuery, StockMediaSearchQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<StockMediaSearchQuery | undefined, StockMediaSearchQueryVariables>;
export function useStockMediaSearchSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<StockMediaSearchQuery, StockMediaSearchQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<StockMediaSearchQuery, StockMediaSearchQueryVariables>(StockMediaSearchDocument, options);
        }
export type StockMediaSearchQueryHookResult = ReturnType<typeof useStockMediaSearchQuery>;
export type StockMediaSearchLazyQueryHookResult = ReturnType<typeof useStockMediaSearchLazyQuery>;
export type StockMediaSearchSuspenseQueryHookResult = ReturnType<typeof useStockMediaSearchSuspenseQuery>;
export type StockMediaSearchQueryResult = Apollo.QueryResult<StockMediaSearchQuery, StockMediaSearchQueryVariables>;
export const TrackStockMediaUseDocument = gql`
    mutation trackStockMediaUse($provider: StockMediaProvider!, $download_location: String!) {
  trackStockMediaUse(provider: $provider, download_location: $download_location)
}
    `;
export type TrackStockMediaUseMutationFn = Apollo.MutationFunction<TrackStockMediaUseMutation, TrackStockMediaUseMutationVariables>;

/**
 * __useTrackStockMediaUseMutation__
 *
 * To run a mutation, you first call `useTrackStockMediaUseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTrackStockMediaUseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [trackStockMediaUseMutation, { data, loading, error }] = useTrackStockMediaUseMutation({
 *   variables: {
 *      provider: // value for 'provider'
 *      download_location: // value for 'download_location'
 *   },
 * });
 */
export function useTrackStockMediaUseMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<TrackStockMediaUseMutation, TrackStockMediaUseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<TrackStockMediaUseMutation, TrackStockMediaUseMutationVariables>(TrackStockMediaUseDocument, options);
      }
export type TrackStockMediaUseMutationHookResult = ReturnType<typeof useTrackStockMediaUseMutation>;
export type TrackStockMediaUseMutationResult = Apollo.MutationResult<TrackStockMediaUseMutation>;
export type TrackStockMediaUseMutationOptions = Apollo.BaseMutationOptions<TrackStockMediaUseMutation, TrackStockMediaUseMutationVariables>;
export const MyClipMcpGrantsDocument = gql`
    query myClipMcpGrants {
  myClipMcpGrants {
    id
    label
    expires_at
    revoked_at
    last_used_at
  }
}
    `;

/**
 * __useMyClipMcpGrantsQuery__
 *
 * To run a query within a React component, call `useMyClipMcpGrantsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyClipMcpGrantsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyClipMcpGrantsQuery({
 *   variables: {
 *   },
 * });
 */
export function useMyClipMcpGrantsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<MyClipMcpGrantsQuery, MyClipMcpGrantsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<MyClipMcpGrantsQuery, MyClipMcpGrantsQueryVariables>(MyClipMcpGrantsDocument, options);
      }
export function useMyClipMcpGrantsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<MyClipMcpGrantsQuery, MyClipMcpGrantsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<MyClipMcpGrantsQuery, MyClipMcpGrantsQueryVariables>(MyClipMcpGrantsDocument, options);
        }
// @ts-ignore
export function useMyClipMcpGrantsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<MyClipMcpGrantsQuery, MyClipMcpGrantsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<MyClipMcpGrantsQuery, MyClipMcpGrantsQueryVariables>;
export function useMyClipMcpGrantsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<MyClipMcpGrantsQuery, MyClipMcpGrantsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<MyClipMcpGrantsQuery | undefined, MyClipMcpGrantsQueryVariables>;
export function useMyClipMcpGrantsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<MyClipMcpGrantsQuery, MyClipMcpGrantsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<MyClipMcpGrantsQuery, MyClipMcpGrantsQueryVariables>(MyClipMcpGrantsDocument, options);
        }
export type MyClipMcpGrantsQueryHookResult = ReturnType<typeof useMyClipMcpGrantsQuery>;
export type MyClipMcpGrantsLazyQueryHookResult = ReturnType<typeof useMyClipMcpGrantsLazyQuery>;
export type MyClipMcpGrantsSuspenseQueryHookResult = ReturnType<typeof useMyClipMcpGrantsSuspenseQuery>;
export type MyClipMcpGrantsQueryResult = Apollo.QueryResult<MyClipMcpGrantsQuery, MyClipMcpGrantsQueryVariables>;
export const RevokeMyClipMcpGrantDocument = gql`
    mutation revokeMyClipMcpGrant($id: ID!) {
  revokeMyClipMcpGrant(id: $id) {
    id
    label
    expires_at
    revoked_at
    last_used_at
  }
}
    `;
export type RevokeMyClipMcpGrantMutationFn = Apollo.MutationFunction<RevokeMyClipMcpGrantMutation, RevokeMyClipMcpGrantMutationVariables>;

/**
 * __useRevokeMyClipMcpGrantMutation__
 *
 * To run a mutation, you first call `useRevokeMyClipMcpGrantMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRevokeMyClipMcpGrantMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [revokeMyClipMcpGrantMutation, { data, loading, error }] = useRevokeMyClipMcpGrantMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRevokeMyClipMcpGrantMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<RevokeMyClipMcpGrantMutation, RevokeMyClipMcpGrantMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<RevokeMyClipMcpGrantMutation, RevokeMyClipMcpGrantMutationVariables>(RevokeMyClipMcpGrantDocument, options);
      }
export type RevokeMyClipMcpGrantMutationHookResult = ReturnType<typeof useRevokeMyClipMcpGrantMutation>;
export type RevokeMyClipMcpGrantMutationResult = Apollo.MutationResult<RevokeMyClipMcpGrantMutation>;
export type RevokeMyClipMcpGrantMutationOptions = Apollo.BaseMutationOptions<RevokeMyClipMcpGrantMutation, RevokeMyClipMcpGrantMutationVariables>;
export const AdminCampaignLiveImportDocument = gql`
    query AdminCampaignLiveImport($campaignId: ID!) {
  adminCampaignLiveImport(campaignId: $campaignId) {
    campaign_id
    enabled
    channel_id
    channel_name
    channel_thumbnail
    keywords
    format
    language
    prompt
    notify_participants
    enabled_at
    last_checked_at
    next_check_at
    last_error
    items {
      id
      video_id
      title
      aired_at
      status
      email_sent_at
      email_recipients
      updated_at
    }
  }
}
    `;

/**
 * __useAdminCampaignLiveImportQuery__
 *
 * To run a query within a React component, call `useAdminCampaignLiveImportQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminCampaignLiveImportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminCampaignLiveImportQuery({
 *   variables: {
 *      campaignId: // value for 'campaignId'
 *   },
 * });
 */
export function useAdminCampaignLiveImportQuery(baseOptions: ApolloReactHooks.QueryHookOptions<AdminCampaignLiveImportQuery, AdminCampaignLiveImportQueryVariables> & ({ variables: AdminCampaignLiveImportQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AdminCampaignLiveImportQuery, AdminCampaignLiveImportQueryVariables>(AdminCampaignLiveImportDocument, options);
      }
export function useAdminCampaignLiveImportLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AdminCampaignLiveImportQuery, AdminCampaignLiveImportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AdminCampaignLiveImportQuery, AdminCampaignLiveImportQueryVariables>(AdminCampaignLiveImportDocument, options);
        }
// @ts-ignore
export function useAdminCampaignLiveImportSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<AdminCampaignLiveImportQuery, AdminCampaignLiveImportQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AdminCampaignLiveImportQuery, AdminCampaignLiveImportQueryVariables>;
export function useAdminCampaignLiveImportSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AdminCampaignLiveImportQuery, AdminCampaignLiveImportQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AdminCampaignLiveImportQuery | undefined, AdminCampaignLiveImportQueryVariables>;
export function useAdminCampaignLiveImportSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AdminCampaignLiveImportQuery, AdminCampaignLiveImportQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<AdminCampaignLiveImportQuery, AdminCampaignLiveImportQueryVariables>(AdminCampaignLiveImportDocument, options);
        }
export type AdminCampaignLiveImportQueryHookResult = ReturnType<typeof useAdminCampaignLiveImportQuery>;
export type AdminCampaignLiveImportLazyQueryHookResult = ReturnType<typeof useAdminCampaignLiveImportLazyQuery>;
export type AdminCampaignLiveImportSuspenseQueryHookResult = ReturnType<typeof useAdminCampaignLiveImportSuspenseQuery>;
export type AdminCampaignLiveImportQueryResult = Apollo.QueryResult<AdminCampaignLiveImportQuery, AdminCampaignLiveImportQueryVariables>;
export const AdminSaveCampaignLiveImportDocument = gql`
    mutation AdminSaveCampaignLiveImport($campaignId: ID!, $input: AdminCampaignLiveImportInput!) {
  adminSaveCampaignLiveImport(campaignId: $campaignId, input: $input) {
    campaign_id
    enabled
    channel_id
    channel_name
    channel_thumbnail
    keywords
    format
    language
    prompt
    notify_participants
    enabled_at
    last_checked_at
    next_check_at
    last_error
    items {
      id
      video_id
      title
      aired_at
      status
      email_sent_at
      email_recipients
      updated_at
    }
  }
}
    `;
export type AdminSaveCampaignLiveImportMutationFn = Apollo.MutationFunction<AdminSaveCampaignLiveImportMutation, AdminSaveCampaignLiveImportMutationVariables>;

/**
 * __useAdminSaveCampaignLiveImportMutation__
 *
 * To run a mutation, you first call `useAdminSaveCampaignLiveImportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminSaveCampaignLiveImportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminSaveCampaignLiveImportMutation, { data, loading, error }] = useAdminSaveCampaignLiveImportMutation({
 *   variables: {
 *      campaignId: // value for 'campaignId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdminSaveCampaignLiveImportMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AdminSaveCampaignLiveImportMutation, AdminSaveCampaignLiveImportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AdminSaveCampaignLiveImportMutation, AdminSaveCampaignLiveImportMutationVariables>(AdminSaveCampaignLiveImportDocument, options);
      }
export type AdminSaveCampaignLiveImportMutationHookResult = ReturnType<typeof useAdminSaveCampaignLiveImportMutation>;
export type AdminSaveCampaignLiveImportMutationResult = Apollo.MutationResult<AdminSaveCampaignLiveImportMutation>;
export type AdminSaveCampaignLiveImportMutationOptions = Apollo.BaseMutationOptions<AdminSaveCampaignLiveImportMutation, AdminSaveCampaignLiveImportMutationVariables>;
export const AdminRunCampaignLiveImportDocument = gql`
    mutation AdminRunCampaignLiveImport($campaignId: ID!) {
  adminRunCampaignLiveImport(campaignId: $campaignId) {
    campaign_id
    enabled
    channel_id
    channel_name
    channel_thumbnail
    keywords
    format
    language
    prompt
    notify_participants
    enabled_at
    last_checked_at
    next_check_at
    last_error
    items {
      id
      video_id
      title
      aired_at
      status
      email_sent_at
      email_recipients
      updated_at
    }
  }
}
    `;
export type AdminRunCampaignLiveImportMutationFn = Apollo.MutationFunction<AdminRunCampaignLiveImportMutation, AdminRunCampaignLiveImportMutationVariables>;

/**
 * __useAdminRunCampaignLiveImportMutation__
 *
 * To run a mutation, you first call `useAdminRunCampaignLiveImportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminRunCampaignLiveImportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminRunCampaignLiveImportMutation, { data, loading, error }] = useAdminRunCampaignLiveImportMutation({
 *   variables: {
 *      campaignId: // value for 'campaignId'
 *   },
 * });
 */
export function useAdminRunCampaignLiveImportMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AdminRunCampaignLiveImportMutation, AdminRunCampaignLiveImportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AdminRunCampaignLiveImportMutation, AdminRunCampaignLiveImportMutationVariables>(AdminRunCampaignLiveImportDocument, options);
      }
export type AdminRunCampaignLiveImportMutationHookResult = ReturnType<typeof useAdminRunCampaignLiveImportMutation>;
export type AdminRunCampaignLiveImportMutationResult = Apollo.MutationResult<AdminRunCampaignLiveImportMutation>;
export type AdminRunCampaignLiveImportMutationOptions = Apollo.BaseMutationOptions<AdminRunCampaignLiveImportMutation, AdminRunCampaignLiveImportMutationVariables>;
export const MyClipperRankPreviewDocument = gql`
    query MyClipperRankPreview {
  myClipperRankPreview {
    views_tier_id
    season_id
    season_name
    season_title_id
  }
}
    `;

/**
 * __useMyClipperRankPreviewQuery__
 *
 * To run a query within a React component, call `useMyClipperRankPreviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyClipperRankPreviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyClipperRankPreviewQuery({
 *   variables: {
 *   },
 * });
 */
export function useMyClipperRankPreviewQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<MyClipperRankPreviewQuery, MyClipperRankPreviewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<MyClipperRankPreviewQuery, MyClipperRankPreviewQueryVariables>(MyClipperRankPreviewDocument, options);
      }
export function useMyClipperRankPreviewLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<MyClipperRankPreviewQuery, MyClipperRankPreviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<MyClipperRankPreviewQuery, MyClipperRankPreviewQueryVariables>(MyClipperRankPreviewDocument, options);
        }
// @ts-ignore
export function useMyClipperRankPreviewSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<MyClipperRankPreviewQuery, MyClipperRankPreviewQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<MyClipperRankPreviewQuery, MyClipperRankPreviewQueryVariables>;
export function useMyClipperRankPreviewSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<MyClipperRankPreviewQuery, MyClipperRankPreviewQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<MyClipperRankPreviewQuery | undefined, MyClipperRankPreviewQueryVariables>;
export function useMyClipperRankPreviewSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<MyClipperRankPreviewQuery, MyClipperRankPreviewQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<MyClipperRankPreviewQuery, MyClipperRankPreviewQueryVariables>(MyClipperRankPreviewDocument, options);
        }
export type MyClipperRankPreviewQueryHookResult = ReturnType<typeof useMyClipperRankPreviewQuery>;
export type MyClipperRankPreviewLazyQueryHookResult = ReturnType<typeof useMyClipperRankPreviewLazyQuery>;
export type MyClipperRankPreviewSuspenseQueryHookResult = ReturnType<typeof useMyClipperRankPreviewSuspenseQuery>;
export type MyClipperRankPreviewQueryResult = Apollo.QueryResult<MyClipperRankPreviewQuery, MyClipperRankPreviewQueryVariables>;
export const MyClipperRanksDocument = gql`
    query MyClipperRanks {
  myClipperRanks {
    tracks {
      id
      metric
      current_tier_id
      unlocked_tier_ids
      next_threshold
    }
    season_titles {
      season_id
      season_name
      title_id
      placement
    }
  }
}
    `;

/**
 * __useMyClipperRanksQuery__
 *
 * To run a query within a React component, call `useMyClipperRanksQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyClipperRanksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyClipperRanksQuery({
 *   variables: {
 *   },
 * });
 */
export function useMyClipperRanksQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<MyClipperRanksQuery, MyClipperRanksQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<MyClipperRanksQuery, MyClipperRanksQueryVariables>(MyClipperRanksDocument, options);
      }
export function useMyClipperRanksLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<MyClipperRanksQuery, MyClipperRanksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<MyClipperRanksQuery, MyClipperRanksQueryVariables>(MyClipperRanksDocument, options);
        }
// @ts-ignore
export function useMyClipperRanksSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<MyClipperRanksQuery, MyClipperRanksQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<MyClipperRanksQuery, MyClipperRanksQueryVariables>;
export function useMyClipperRanksSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<MyClipperRanksQuery, MyClipperRanksQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<MyClipperRanksQuery | undefined, MyClipperRanksQueryVariables>;
export function useMyClipperRanksSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<MyClipperRanksQuery, MyClipperRanksQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<MyClipperRanksQuery, MyClipperRanksQueryVariables>(MyClipperRanksDocument, options);
        }
export type MyClipperRanksQueryHookResult = ReturnType<typeof useMyClipperRanksQuery>;
export type MyClipperRanksLazyQueryHookResult = ReturnType<typeof useMyClipperRanksLazyQuery>;
export type MyClipperRanksSuspenseQueryHookResult = ReturnType<typeof useMyClipperRanksSuspenseQuery>;
export type MyClipperRanksQueryResult = Apollo.QueryResult<MyClipperRanksQuery, MyClipperRanksQueryVariables>;
export const ClipperRankHallDocument = gql`
    query ClipperRankHall($seasonId: ID, $offset: Int, $limit: Int) {
  clipperRankHall(seasonId: $seasonId, offset: $offset, limit: $limit) {
    season {
      id
      name
      status
      ends_at
      entries {
        rank
        user_id
        name
        avatar_url
        anonymous
        title_id
        views_delta
        video_count
        families {
          id
          featured_tier_id
          badges {
            tier_id
            season_id
            season_name
          }
        }
      }
    }
    clippers {
      user_id
      name
      avatar_url
      anonymous
      current_tier_ids
      lifetime_views
      video_count
      families {
        id
        featured_tier_id
        badges {
          tier_id
          season_id
          season_name
        }
      }
    }
    page_info {
      offset
      limit
      total
    }
  }
}
    `;

/**
 * __useClipperRankHallQuery__
 *
 * To run a query within a React component, call `useClipperRankHallQuery` and pass it any options that fit your needs.
 * When your component renders, `useClipperRankHallQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClipperRankHallQuery({
 *   variables: {
 *      seasonId: // value for 'seasonId'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useClipperRankHallQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ClipperRankHallQuery, ClipperRankHallQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ClipperRankHallQuery, ClipperRankHallQueryVariables>(ClipperRankHallDocument, options);
      }
export function useClipperRankHallLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ClipperRankHallQuery, ClipperRankHallQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ClipperRankHallQuery, ClipperRankHallQueryVariables>(ClipperRankHallDocument, options);
        }
// @ts-ignore
export function useClipperRankHallSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ClipperRankHallQuery, ClipperRankHallQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ClipperRankHallQuery, ClipperRankHallQueryVariables>;
export function useClipperRankHallSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ClipperRankHallQuery, ClipperRankHallQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ClipperRankHallQuery | undefined, ClipperRankHallQueryVariables>;
export function useClipperRankHallSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ClipperRankHallQuery, ClipperRankHallQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ClipperRankHallQuery, ClipperRankHallQueryVariables>(ClipperRankHallDocument, options);
        }
export type ClipperRankHallQueryHookResult = ReturnType<typeof useClipperRankHallQuery>;
export type ClipperRankHallLazyQueryHookResult = ReturnType<typeof useClipperRankHallLazyQuery>;
export type ClipperRankHallSuspenseQueryHookResult = ReturnType<typeof useClipperRankHallSuspenseQuery>;
export type ClipperRankHallQueryResult = Apollo.QueryResult<ClipperRankHallQuery, ClipperRankHallQueryVariables>;
export const ClipperRankHallViewerDocument = gql`
    query ClipperRankHallViewer {
  myData {
    id
    name
    profile_picture
  }
}
    `;

/**
 * __useClipperRankHallViewerQuery__
 *
 * To run a query within a React component, call `useClipperRankHallViewerQuery` and pass it any options that fit your needs.
 * When your component renders, `useClipperRankHallViewerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClipperRankHallViewerQuery({
 *   variables: {
 *   },
 * });
 */
export function useClipperRankHallViewerQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ClipperRankHallViewerQuery, ClipperRankHallViewerQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ClipperRankHallViewerQuery, ClipperRankHallViewerQueryVariables>(ClipperRankHallViewerDocument, options);
      }
export function useClipperRankHallViewerLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ClipperRankHallViewerQuery, ClipperRankHallViewerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ClipperRankHallViewerQuery, ClipperRankHallViewerQueryVariables>(ClipperRankHallViewerDocument, options);
        }
// @ts-ignore
export function useClipperRankHallViewerSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ClipperRankHallViewerQuery, ClipperRankHallViewerQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ClipperRankHallViewerQuery, ClipperRankHallViewerQueryVariables>;
export function useClipperRankHallViewerSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ClipperRankHallViewerQuery, ClipperRankHallViewerQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ClipperRankHallViewerQuery | undefined, ClipperRankHallViewerQueryVariables>;
export function useClipperRankHallViewerSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ClipperRankHallViewerQuery, ClipperRankHallViewerQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ClipperRankHallViewerQuery, ClipperRankHallViewerQueryVariables>(ClipperRankHallViewerDocument, options);
        }
export type ClipperRankHallViewerQueryHookResult = ReturnType<typeof useClipperRankHallViewerQuery>;
export type ClipperRankHallViewerLazyQueryHookResult = ReturnType<typeof useClipperRankHallViewerLazyQuery>;
export type ClipperRankHallViewerSuspenseQueryHookResult = ReturnType<typeof useClipperRankHallViewerSuspenseQuery>;
export type ClipperRankHallViewerQueryResult = Apollo.QueryResult<ClipperRankHallViewerQuery, ClipperRankHallViewerQueryVariables>;
export const AdminClipperSeasonsDocument = gql`
    query AdminClipperSeasons {
  adminClipperSeasons {
    id
    documentId
    name
    starts_at
    ends_at
    timezone
    status
    start_snapshotted_at
    consolidated_at
  }
}
    `;

/**
 * __useAdminClipperSeasonsQuery__
 *
 * To run a query within a React component, call `useAdminClipperSeasonsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminClipperSeasonsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminClipperSeasonsQuery({
 *   variables: {
 *   },
 * });
 */
export function useAdminClipperSeasonsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<AdminClipperSeasonsQuery, AdminClipperSeasonsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AdminClipperSeasonsQuery, AdminClipperSeasonsQueryVariables>(AdminClipperSeasonsDocument, options);
      }
export function useAdminClipperSeasonsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AdminClipperSeasonsQuery, AdminClipperSeasonsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AdminClipperSeasonsQuery, AdminClipperSeasonsQueryVariables>(AdminClipperSeasonsDocument, options);
        }
// @ts-ignore
export function useAdminClipperSeasonsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<AdminClipperSeasonsQuery, AdminClipperSeasonsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AdminClipperSeasonsQuery, AdminClipperSeasonsQueryVariables>;
export function useAdminClipperSeasonsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AdminClipperSeasonsQuery, AdminClipperSeasonsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AdminClipperSeasonsQuery | undefined, AdminClipperSeasonsQueryVariables>;
export function useAdminClipperSeasonsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AdminClipperSeasonsQuery, AdminClipperSeasonsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<AdminClipperSeasonsQuery, AdminClipperSeasonsQueryVariables>(AdminClipperSeasonsDocument, options);
        }
export type AdminClipperSeasonsQueryHookResult = ReturnType<typeof useAdminClipperSeasonsQuery>;
export type AdminClipperSeasonsLazyQueryHookResult = ReturnType<typeof useAdminClipperSeasonsLazyQuery>;
export type AdminClipperSeasonsSuspenseQueryHookResult = ReturnType<typeof useAdminClipperSeasonsSuspenseQuery>;
export type AdminClipperSeasonsQueryResult = Apollo.QueryResult<AdminClipperSeasonsQuery, AdminClipperSeasonsQueryVariables>;
export const AdminCreateClipperSeasonDocument = gql`
    mutation AdminCreateClipperSeason($name: String!, $starts_at: String!, $ends_at: String!) {
  adminCreateClipperSeason(name: $name, starts_at: $starts_at, ends_at: $ends_at) {
    id
    documentId
    name
    starts_at
    ends_at
    timezone
    status
    start_snapshotted_at
    consolidated_at
  }
}
    `;
export type AdminCreateClipperSeasonMutationFn = Apollo.MutationFunction<AdminCreateClipperSeasonMutation, AdminCreateClipperSeasonMutationVariables>;

/**
 * __useAdminCreateClipperSeasonMutation__
 *
 * To run a mutation, you first call `useAdminCreateClipperSeasonMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminCreateClipperSeasonMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminCreateClipperSeasonMutation, { data, loading, error }] = useAdminCreateClipperSeasonMutation({
 *   variables: {
 *      name: // value for 'name'
 *      starts_at: // value for 'starts_at'
 *      ends_at: // value for 'ends_at'
 *   },
 * });
 */
export function useAdminCreateClipperSeasonMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AdminCreateClipperSeasonMutation, AdminCreateClipperSeasonMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AdminCreateClipperSeasonMutation, AdminCreateClipperSeasonMutationVariables>(AdminCreateClipperSeasonDocument, options);
      }
export type AdminCreateClipperSeasonMutationHookResult = ReturnType<typeof useAdminCreateClipperSeasonMutation>;
export type AdminCreateClipperSeasonMutationResult = Apollo.MutationResult<AdminCreateClipperSeasonMutation>;
export type AdminCreateClipperSeasonMutationOptions = Apollo.BaseMutationOptions<AdminCreateClipperSeasonMutation, AdminCreateClipperSeasonMutationVariables>;
export const AdminUpdateClipperSeasonDocument = gql`
    mutation AdminUpdateClipperSeason($id: ID!, $name: String, $starts_at: String, $ends_at: String) {
  adminUpdateClipperSeason(
    id: $id
    name: $name
    starts_at: $starts_at
    ends_at: $ends_at
  ) {
    id
    documentId
    name
    starts_at
    ends_at
    timezone
    status
    start_snapshotted_at
    consolidated_at
  }
}
    `;
export type AdminUpdateClipperSeasonMutationFn = Apollo.MutationFunction<AdminUpdateClipperSeasonMutation, AdminUpdateClipperSeasonMutationVariables>;

/**
 * __useAdminUpdateClipperSeasonMutation__
 *
 * To run a mutation, you first call `useAdminUpdateClipperSeasonMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminUpdateClipperSeasonMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminUpdateClipperSeasonMutation, { data, loading, error }] = useAdminUpdateClipperSeasonMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *      starts_at: // value for 'starts_at'
 *      ends_at: // value for 'ends_at'
 *   },
 * });
 */
export function useAdminUpdateClipperSeasonMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AdminUpdateClipperSeasonMutation, AdminUpdateClipperSeasonMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AdminUpdateClipperSeasonMutation, AdminUpdateClipperSeasonMutationVariables>(AdminUpdateClipperSeasonDocument, options);
      }
export type AdminUpdateClipperSeasonMutationHookResult = ReturnType<typeof useAdminUpdateClipperSeasonMutation>;
export type AdminUpdateClipperSeasonMutationResult = Apollo.MutationResult<AdminUpdateClipperSeasonMutation>;
export type AdminUpdateClipperSeasonMutationOptions = Apollo.BaseMutationOptions<AdminUpdateClipperSeasonMutation, AdminUpdateClipperSeasonMutationVariables>;
export const AdminSnapshotClipperSeasonStartDocument = gql`
    mutation AdminSnapshotClipperSeasonStart($id: ID!) {
  adminSnapshotClipperSeasonStart(id: $id) {
    id
    documentId
    name
    starts_at
    ends_at
    timezone
    status
    start_snapshotted_at
    consolidated_at
  }
}
    `;
export type AdminSnapshotClipperSeasonStartMutationFn = Apollo.MutationFunction<AdminSnapshotClipperSeasonStartMutation, AdminSnapshotClipperSeasonStartMutationVariables>;

/**
 * __useAdminSnapshotClipperSeasonStartMutation__
 *
 * To run a mutation, you first call `useAdminSnapshotClipperSeasonStartMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminSnapshotClipperSeasonStartMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminSnapshotClipperSeasonStartMutation, { data, loading, error }] = useAdminSnapshotClipperSeasonStartMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAdminSnapshotClipperSeasonStartMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AdminSnapshotClipperSeasonStartMutation, AdminSnapshotClipperSeasonStartMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AdminSnapshotClipperSeasonStartMutation, AdminSnapshotClipperSeasonStartMutationVariables>(AdminSnapshotClipperSeasonStartDocument, options);
      }
export type AdminSnapshotClipperSeasonStartMutationHookResult = ReturnType<typeof useAdminSnapshotClipperSeasonStartMutation>;
export type AdminSnapshotClipperSeasonStartMutationResult = Apollo.MutationResult<AdminSnapshotClipperSeasonStartMutation>;
export type AdminSnapshotClipperSeasonStartMutationOptions = Apollo.BaseMutationOptions<AdminSnapshotClipperSeasonStartMutation, AdminSnapshotClipperSeasonStartMutationVariables>;
export const AdminConsolidateClipperSeasonDocument = gql`
    mutation AdminConsolidateClipperSeason($id: ID!) {
  adminConsolidateClipperSeason(id: $id) {
    id
    documentId
    name
    starts_at
    ends_at
    timezone
    status
    start_snapshotted_at
    consolidated_at
  }
}
    `;
export type AdminConsolidateClipperSeasonMutationFn = Apollo.MutationFunction<AdminConsolidateClipperSeasonMutation, AdminConsolidateClipperSeasonMutationVariables>;

/**
 * __useAdminConsolidateClipperSeasonMutation__
 *
 * To run a mutation, you first call `useAdminConsolidateClipperSeasonMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminConsolidateClipperSeasonMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminConsolidateClipperSeasonMutation, { data, loading, error }] = useAdminConsolidateClipperSeasonMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAdminConsolidateClipperSeasonMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AdminConsolidateClipperSeasonMutation, AdminConsolidateClipperSeasonMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AdminConsolidateClipperSeasonMutation, AdminConsolidateClipperSeasonMutationVariables>(AdminConsolidateClipperSeasonDocument, options);
      }
export type AdminConsolidateClipperSeasonMutationHookResult = ReturnType<typeof useAdminConsolidateClipperSeasonMutation>;
export type AdminConsolidateClipperSeasonMutationResult = Apollo.MutationResult<AdminConsolidateClipperSeasonMutation>;
export type AdminConsolidateClipperSeasonMutationOptions = Apollo.BaseMutationOptions<AdminConsolidateClipperSeasonMutation, AdminConsolidateClipperSeasonMutationVariables>;
export const MyScheduledPublishesDocument = gql`
    query MyScheduledPublishes($from: DateTime!, $to: DateTime!) {
  myScheduledPublishes(from: $from, to: $to) {
    ...PublishFields
  }
}
    ${PublishFieldsFragmentDoc}`;

/**
 * __useMyScheduledPublishesQuery__
 *
 * To run a query within a React component, call `useMyScheduledPublishesQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyScheduledPublishesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyScheduledPublishesQuery({
 *   variables: {
 *      from: // value for 'from'
 *      to: // value for 'to'
 *   },
 * });
 */
export function useMyScheduledPublishesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<MyScheduledPublishesQuery, MyScheduledPublishesQueryVariables> & ({ variables: MyScheduledPublishesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<MyScheduledPublishesQuery, MyScheduledPublishesQueryVariables>(MyScheduledPublishesDocument, options);
      }
export function useMyScheduledPublishesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<MyScheduledPublishesQuery, MyScheduledPublishesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<MyScheduledPublishesQuery, MyScheduledPublishesQueryVariables>(MyScheduledPublishesDocument, options);
        }
// @ts-ignore
export function useMyScheduledPublishesSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<MyScheduledPublishesQuery, MyScheduledPublishesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<MyScheduledPublishesQuery, MyScheduledPublishesQueryVariables>;
export function useMyScheduledPublishesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<MyScheduledPublishesQuery, MyScheduledPublishesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<MyScheduledPublishesQuery | undefined, MyScheduledPublishesQueryVariables>;
export function useMyScheduledPublishesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<MyScheduledPublishesQuery, MyScheduledPublishesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<MyScheduledPublishesQuery, MyScheduledPublishesQueryVariables>(MyScheduledPublishesDocument, options);
        }
export type MyScheduledPublishesQueryHookResult = ReturnType<typeof useMyScheduledPublishesQuery>;
export type MyScheduledPublishesLazyQueryHookResult = ReturnType<typeof useMyScheduledPublishesLazyQuery>;
export type MyScheduledPublishesSuspenseQueryHookResult = ReturnType<typeof useMyScheduledPublishesSuspenseQuery>;
export type MyScheduledPublishesQueryResult = Apollo.QueryResult<MyScheduledPublishesQuery, MyScheduledPublishesQueryVariables>;
export const MyPostableClipsDocument = gql`
    query MyPostableClips($search: String, $limit: Int, $offset: Int) {
  myPostableClips(search: $search, limit: $limit, offset: $offset) {
    id
    name
    thumbnail_url
    finished_video_url
    createdAt
  }
}
    `;

/**
 * __useMyPostableClipsQuery__
 *
 * To run a query within a React component, call `useMyPostableClipsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyPostableClipsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyPostableClipsQuery({
 *   variables: {
 *      search: // value for 'search'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useMyPostableClipsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<MyPostableClipsQuery, MyPostableClipsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<MyPostableClipsQuery, MyPostableClipsQueryVariables>(MyPostableClipsDocument, options);
      }
export function useMyPostableClipsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<MyPostableClipsQuery, MyPostableClipsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<MyPostableClipsQuery, MyPostableClipsQueryVariables>(MyPostableClipsDocument, options);
        }
// @ts-ignore
export function useMyPostableClipsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<MyPostableClipsQuery, MyPostableClipsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<MyPostableClipsQuery, MyPostableClipsQueryVariables>;
export function useMyPostableClipsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<MyPostableClipsQuery, MyPostableClipsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<MyPostableClipsQuery | undefined, MyPostableClipsQueryVariables>;
export function useMyPostableClipsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<MyPostableClipsQuery, MyPostableClipsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<MyPostableClipsQuery, MyPostableClipsQueryVariables>(MyPostableClipsDocument, options);
        }
export type MyPostableClipsQueryHookResult = ReturnType<typeof useMyPostableClipsQuery>;
export type MyPostableClipsLazyQueryHookResult = ReturnType<typeof useMyPostableClipsLazyQuery>;
export type MyPostableClipsSuspenseQueryHookResult = ReturnType<typeof useMyPostableClipsSuspenseQuery>;
export type MyPostableClipsQueryResult = Apollo.QueryResult<MyPostableClipsQuery, MyPostableClipsQueryVariables>;
export const MyClipDisplayDocument = gql`
    query MyClipDisplay($id: ID!) {
  myClip(id: $id) {
    id
    name
  }
}
    `;

/**
 * __useMyClipDisplayQuery__
 *
 * To run a query within a React component, call `useMyClipDisplayQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyClipDisplayQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyClipDisplayQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useMyClipDisplayQuery(baseOptions: ApolloReactHooks.QueryHookOptions<MyClipDisplayQuery, MyClipDisplayQueryVariables> & ({ variables: MyClipDisplayQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<MyClipDisplayQuery, MyClipDisplayQueryVariables>(MyClipDisplayDocument, options);
      }
export function useMyClipDisplayLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<MyClipDisplayQuery, MyClipDisplayQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<MyClipDisplayQuery, MyClipDisplayQueryVariables>(MyClipDisplayDocument, options);
        }
// @ts-ignore
export function useMyClipDisplaySuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<MyClipDisplayQuery, MyClipDisplayQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<MyClipDisplayQuery, MyClipDisplayQueryVariables>;
export function useMyClipDisplaySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<MyClipDisplayQuery, MyClipDisplayQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<MyClipDisplayQuery | undefined, MyClipDisplayQueryVariables>;
export function useMyClipDisplaySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<MyClipDisplayQuery, MyClipDisplayQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<MyClipDisplayQuery, MyClipDisplayQueryVariables>(MyClipDisplayDocument, options);
        }
export type MyClipDisplayQueryHookResult = ReturnType<typeof useMyClipDisplayQuery>;
export type MyClipDisplayLazyQueryHookResult = ReturnType<typeof useMyClipDisplayLazyQuery>;
export type MyClipDisplaySuspenseQueryHookResult = ReturnType<typeof useMyClipDisplaySuspenseQuery>;
export type MyClipDisplayQueryResult = Apollo.QueryResult<MyClipDisplayQuery, MyClipDisplayQueryVariables>;
export const CreateMyScheduledPublishDocument = gql`
    mutation CreateMyScheduledPublish($input: ScheduledPublishInput!) {
  createMyScheduledPublish(input: $input) {
    ...PublishFields
  }
}
    ${PublishFieldsFragmentDoc}`;
export type CreateMyScheduledPublishMutationFn = Apollo.MutationFunction<CreateMyScheduledPublishMutation, CreateMyScheduledPublishMutationVariables>;

/**
 * __useCreateMyScheduledPublishMutation__
 *
 * To run a mutation, you first call `useCreateMyScheduledPublishMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMyScheduledPublishMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMyScheduledPublishMutation, { data, loading, error }] = useCreateMyScheduledPublishMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateMyScheduledPublishMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateMyScheduledPublishMutation, CreateMyScheduledPublishMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateMyScheduledPublishMutation, CreateMyScheduledPublishMutationVariables>(CreateMyScheduledPublishDocument, options);
      }
export type CreateMyScheduledPublishMutationHookResult = ReturnType<typeof useCreateMyScheduledPublishMutation>;
export type CreateMyScheduledPublishMutationResult = Apollo.MutationResult<CreateMyScheduledPublishMutation>;
export type CreateMyScheduledPublishMutationOptions = Apollo.BaseMutationOptions<CreateMyScheduledPublishMutation, CreateMyScheduledPublishMutationVariables>;
export const UpdateMyScheduledPublishDocument = gql`
    mutation UpdateMyScheduledPublish($id: ID!, $input: ScheduledPublishInput!) {
  updateMyScheduledPublish(id: $id, input: $input) {
    ...PublishFields
  }
}
    ${PublishFieldsFragmentDoc}`;
export type UpdateMyScheduledPublishMutationFn = Apollo.MutationFunction<UpdateMyScheduledPublishMutation, UpdateMyScheduledPublishMutationVariables>;

/**
 * __useUpdateMyScheduledPublishMutation__
 *
 * To run a mutation, you first call `useUpdateMyScheduledPublishMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMyScheduledPublishMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMyScheduledPublishMutation, { data, loading, error }] = useUpdateMyScheduledPublishMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateMyScheduledPublishMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateMyScheduledPublishMutation, UpdateMyScheduledPublishMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateMyScheduledPublishMutation, UpdateMyScheduledPublishMutationVariables>(UpdateMyScheduledPublishDocument, options);
      }
export type UpdateMyScheduledPublishMutationHookResult = ReturnType<typeof useUpdateMyScheduledPublishMutation>;
export type UpdateMyScheduledPublishMutationResult = Apollo.MutationResult<UpdateMyScheduledPublishMutation>;
export type UpdateMyScheduledPublishMutationOptions = Apollo.BaseMutationOptions<UpdateMyScheduledPublishMutation, UpdateMyScheduledPublishMutationVariables>;
export const CancelMyScheduledPublishDocument = gql`
    mutation CancelMyScheduledPublish($id: ID!) {
  cancelMyScheduledPublish(id: $id)
}
    `;
export type CancelMyScheduledPublishMutationFn = Apollo.MutationFunction<CancelMyScheduledPublishMutation, CancelMyScheduledPublishMutationVariables>;

/**
 * __useCancelMyScheduledPublishMutation__
 *
 * To run a mutation, you first call `useCancelMyScheduledPublishMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelMyScheduledPublishMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelMyScheduledPublishMutation, { data, loading, error }] = useCancelMyScheduledPublishMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCancelMyScheduledPublishMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CancelMyScheduledPublishMutation, CancelMyScheduledPublishMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CancelMyScheduledPublishMutation, CancelMyScheduledPublishMutationVariables>(CancelMyScheduledPublishDocument, options);
      }
export type CancelMyScheduledPublishMutationHookResult = ReturnType<typeof useCancelMyScheduledPublishMutation>;
export type CancelMyScheduledPublishMutationResult = Apollo.MutationResult<CancelMyScheduledPublishMutation>;
export type CancelMyScheduledPublishMutationOptions = Apollo.BaseMutationOptions<CancelMyScheduledPublishMutation, CancelMyScheduledPublishMutationVariables>;
export const SocialAnalyticsConnectionsDocument = gql`
    query SocialAnalyticsConnections {
  socialAnalyticsConnections {
    id
    platform
    username
    display_name
    avatar_url
    status
    analytics_sync_status
    analytics_last_attempt_at
    analytics_last_success_at
    analytics_backfill_completed_at
    analytics_last_error_code
  }
}
    `;

/**
 * __useSocialAnalyticsConnectionsQuery__
 *
 * To run a query within a React component, call `useSocialAnalyticsConnectionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSocialAnalyticsConnectionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSocialAnalyticsConnectionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useSocialAnalyticsConnectionsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<SocialAnalyticsConnectionsQuery, SocialAnalyticsConnectionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SocialAnalyticsConnectionsQuery, SocialAnalyticsConnectionsQueryVariables>(SocialAnalyticsConnectionsDocument, options);
      }
export function useSocialAnalyticsConnectionsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SocialAnalyticsConnectionsQuery, SocialAnalyticsConnectionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SocialAnalyticsConnectionsQuery, SocialAnalyticsConnectionsQueryVariables>(SocialAnalyticsConnectionsDocument, options);
        }
// @ts-ignore
export function useSocialAnalyticsConnectionsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<SocialAnalyticsConnectionsQuery, SocialAnalyticsConnectionsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SocialAnalyticsConnectionsQuery, SocialAnalyticsConnectionsQueryVariables>;
export function useSocialAnalyticsConnectionsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SocialAnalyticsConnectionsQuery, SocialAnalyticsConnectionsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SocialAnalyticsConnectionsQuery | undefined, SocialAnalyticsConnectionsQueryVariables>;
export function useSocialAnalyticsConnectionsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SocialAnalyticsConnectionsQuery, SocialAnalyticsConnectionsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<SocialAnalyticsConnectionsQuery, SocialAnalyticsConnectionsQueryVariables>(SocialAnalyticsConnectionsDocument, options);
        }
export type SocialAnalyticsConnectionsQueryHookResult = ReturnType<typeof useSocialAnalyticsConnectionsQuery>;
export type SocialAnalyticsConnectionsLazyQueryHookResult = ReturnType<typeof useSocialAnalyticsConnectionsLazyQuery>;
export type SocialAnalyticsConnectionsSuspenseQueryHookResult = ReturnType<typeof useSocialAnalyticsConnectionsSuspenseQuery>;
export type SocialAnalyticsConnectionsQueryResult = Apollo.QueryResult<SocialAnalyticsConnectionsQuery, SocialAnalyticsConnectionsQueryVariables>;
export const SocialAnalyticsSummaryDocument = gql`
    query SocialAnalyticsSummary($range: SocialAnalyticsRange, $platforms: [String!], $socialConnectionIds: [ID!]) {
  socialAnalyticsSummary(
    range: $range
    platforms: $platforms
    socialConnectionIds: $socialConnectionIds
  ) {
    lifetime_views
    views_gained
    previous_period_views_gained
    total_likes
    total_comments
    total_shares
    engagement_rate
    tracked_content
    selected_accounts
    earliest_tracking_date
    latest_complete_sync_at
    daily {
      date
      views_gained
    }
    platform_breakdowns {
      platform
      tracked_content
      lifetime_views
    }
    account_breakdowns {
      id
      platform
      username
      display_name
      avatar_url
      tracked_content
      lifetime_views
      latest_complete_sync_at
    }
  }
}
    `;

/**
 * __useSocialAnalyticsSummaryQuery__
 *
 * To run a query within a React component, call `useSocialAnalyticsSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useSocialAnalyticsSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSocialAnalyticsSummaryQuery({
 *   variables: {
 *      range: // value for 'range'
 *      platforms: // value for 'platforms'
 *      socialConnectionIds: // value for 'socialConnectionIds'
 *   },
 * });
 */
export function useSocialAnalyticsSummaryQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<SocialAnalyticsSummaryQuery, SocialAnalyticsSummaryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SocialAnalyticsSummaryQuery, SocialAnalyticsSummaryQueryVariables>(SocialAnalyticsSummaryDocument, options);
      }
export function useSocialAnalyticsSummaryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SocialAnalyticsSummaryQuery, SocialAnalyticsSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SocialAnalyticsSummaryQuery, SocialAnalyticsSummaryQueryVariables>(SocialAnalyticsSummaryDocument, options);
        }
// @ts-ignore
export function useSocialAnalyticsSummarySuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<SocialAnalyticsSummaryQuery, SocialAnalyticsSummaryQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SocialAnalyticsSummaryQuery, SocialAnalyticsSummaryQueryVariables>;
export function useSocialAnalyticsSummarySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SocialAnalyticsSummaryQuery, SocialAnalyticsSummaryQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SocialAnalyticsSummaryQuery | undefined, SocialAnalyticsSummaryQueryVariables>;
export function useSocialAnalyticsSummarySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SocialAnalyticsSummaryQuery, SocialAnalyticsSummaryQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<SocialAnalyticsSummaryQuery, SocialAnalyticsSummaryQueryVariables>(SocialAnalyticsSummaryDocument, options);
        }
export type SocialAnalyticsSummaryQueryHookResult = ReturnType<typeof useSocialAnalyticsSummaryQuery>;
export type SocialAnalyticsSummaryLazyQueryHookResult = ReturnType<typeof useSocialAnalyticsSummaryLazyQuery>;
export type SocialAnalyticsSummarySuspenseQueryHookResult = ReturnType<typeof useSocialAnalyticsSummarySuspenseQuery>;
export type SocialAnalyticsSummaryQueryResult = Apollo.QueryResult<SocialAnalyticsSummaryQuery, SocialAnalyticsSummaryQueryVariables>;
export const SocialAnalyticsMediaDocument = gql`
    query SocialAnalyticsMedia($range: SocialAnalyticsRange, $platforms: [String!], $socialConnectionIds: [ID!], $search: String, $availability: String, $mediaTypes: [String!], $period: String, $sort: String, $direction: String, $page: Int, $pageSize: Int) {
  socialAnalyticsMedia(
    range: $range
    platforms: $platforms
    socialConnectionIds: $socialConnectionIds
    search: $search
    availability: $availability
    mediaTypes: $mediaTypes
    period: $period
    sort: $sort
    direction: $direction
    page: $page
    pageSize: $pageSize
  ) {
    data {
      id
      platform
      media_type
      canonical_url
      title
      caption
      thumbnail_url
      published_at
      availability
      views
      likes
      comments
      shares
      views_gained
      last_synced_at
      account {
        id
        platform
        username
        display_name
        avatar_url
      }
    }
    pagination {
      page
      page_size
      page_count
      total
    }
  }
}
    `;

/**
 * __useSocialAnalyticsMediaQuery__
 *
 * To run a query within a React component, call `useSocialAnalyticsMediaQuery` and pass it any options that fit your needs.
 * When your component renders, `useSocialAnalyticsMediaQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSocialAnalyticsMediaQuery({
 *   variables: {
 *      range: // value for 'range'
 *      platforms: // value for 'platforms'
 *      socialConnectionIds: // value for 'socialConnectionIds'
 *      search: // value for 'search'
 *      availability: // value for 'availability'
 *      mediaTypes: // value for 'mediaTypes'
 *      period: // value for 'period'
 *      sort: // value for 'sort'
 *      direction: // value for 'direction'
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *   },
 * });
 */
export function useSocialAnalyticsMediaQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<SocialAnalyticsMediaQuery, SocialAnalyticsMediaQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SocialAnalyticsMediaQuery, SocialAnalyticsMediaQueryVariables>(SocialAnalyticsMediaDocument, options);
      }
export function useSocialAnalyticsMediaLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SocialAnalyticsMediaQuery, SocialAnalyticsMediaQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SocialAnalyticsMediaQuery, SocialAnalyticsMediaQueryVariables>(SocialAnalyticsMediaDocument, options);
        }
// @ts-ignore
export function useSocialAnalyticsMediaSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<SocialAnalyticsMediaQuery, SocialAnalyticsMediaQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SocialAnalyticsMediaQuery, SocialAnalyticsMediaQueryVariables>;
export function useSocialAnalyticsMediaSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SocialAnalyticsMediaQuery, SocialAnalyticsMediaQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SocialAnalyticsMediaQuery | undefined, SocialAnalyticsMediaQueryVariables>;
export function useSocialAnalyticsMediaSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SocialAnalyticsMediaQuery, SocialAnalyticsMediaQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<SocialAnalyticsMediaQuery, SocialAnalyticsMediaQueryVariables>(SocialAnalyticsMediaDocument, options);
        }
export type SocialAnalyticsMediaQueryHookResult = ReturnType<typeof useSocialAnalyticsMediaQuery>;
export type SocialAnalyticsMediaLazyQueryHookResult = ReturnType<typeof useSocialAnalyticsMediaLazyQuery>;
export type SocialAnalyticsMediaSuspenseQueryHookResult = ReturnType<typeof useSocialAnalyticsMediaSuspenseQuery>;
export type SocialAnalyticsMediaQueryResult = Apollo.QueryResult<SocialAnalyticsMediaQuery, SocialAnalyticsMediaQueryVariables>;
export const SocialAnalyticsCpmSubmissionsDocument = gql`
    query SocialAnalyticsCpmSubmissions($platforms: [String!], $page: Int, $pageSize: Int) {
  socialAnalyticsCpmSubmissions(
    platforms: $platforms
    page: $page
    pageSize: $pageSize
  ) {
    data {
      id
      platform
      url
      status
      disqualified
      payout_qualified_views
      accumulated_payout_cents
      last_cpm_synced_at
      account {
        id
        platform
        username
        display_name
        avatar_url
      }
      campaign {
        id
        name
      }
    }
    pagination {
      page
      page_size
      page_count
      total
    }
  }
}
    `;

/**
 * __useSocialAnalyticsCpmSubmissionsQuery__
 *
 * To run a query within a React component, call `useSocialAnalyticsCpmSubmissionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSocialAnalyticsCpmSubmissionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSocialAnalyticsCpmSubmissionsQuery({
 *   variables: {
 *      platforms: // value for 'platforms'
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *   },
 * });
 */
export function useSocialAnalyticsCpmSubmissionsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<SocialAnalyticsCpmSubmissionsQuery, SocialAnalyticsCpmSubmissionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SocialAnalyticsCpmSubmissionsQuery, SocialAnalyticsCpmSubmissionsQueryVariables>(SocialAnalyticsCpmSubmissionsDocument, options);
      }
export function useSocialAnalyticsCpmSubmissionsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SocialAnalyticsCpmSubmissionsQuery, SocialAnalyticsCpmSubmissionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SocialAnalyticsCpmSubmissionsQuery, SocialAnalyticsCpmSubmissionsQueryVariables>(SocialAnalyticsCpmSubmissionsDocument, options);
        }
// @ts-ignore
export function useSocialAnalyticsCpmSubmissionsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<SocialAnalyticsCpmSubmissionsQuery, SocialAnalyticsCpmSubmissionsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SocialAnalyticsCpmSubmissionsQuery, SocialAnalyticsCpmSubmissionsQueryVariables>;
export function useSocialAnalyticsCpmSubmissionsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SocialAnalyticsCpmSubmissionsQuery, SocialAnalyticsCpmSubmissionsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SocialAnalyticsCpmSubmissionsQuery | undefined, SocialAnalyticsCpmSubmissionsQueryVariables>;
export function useSocialAnalyticsCpmSubmissionsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SocialAnalyticsCpmSubmissionsQuery, SocialAnalyticsCpmSubmissionsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<SocialAnalyticsCpmSubmissionsQuery, SocialAnalyticsCpmSubmissionsQueryVariables>(SocialAnalyticsCpmSubmissionsDocument, options);
        }
export type SocialAnalyticsCpmSubmissionsQueryHookResult = ReturnType<typeof useSocialAnalyticsCpmSubmissionsQuery>;
export type SocialAnalyticsCpmSubmissionsLazyQueryHookResult = ReturnType<typeof useSocialAnalyticsCpmSubmissionsLazyQuery>;
export type SocialAnalyticsCpmSubmissionsSuspenseQueryHookResult = ReturnType<typeof useSocialAnalyticsCpmSubmissionsSuspenseQuery>;
export type SocialAnalyticsCpmSubmissionsQueryResult = Apollo.QueryResult<SocialAnalyticsCpmSubmissionsQuery, SocialAnalyticsCpmSubmissionsQueryVariables>;
export const RequestSocialAnalyticsRefreshDocument = gql`
    mutation RequestSocialAnalyticsRefresh($socialConnectionIds: [ID!]) {
  requestSocialAnalyticsRefresh(socialConnectionIds: $socialConnectionIds) {
    connection_id
    status
    next_allowed_at
    error_code
  }
}
    `;
export type RequestSocialAnalyticsRefreshMutationFn = Apollo.MutationFunction<RequestSocialAnalyticsRefreshMutation, RequestSocialAnalyticsRefreshMutationVariables>;

/**
 * __useRequestSocialAnalyticsRefreshMutation__
 *
 * To run a mutation, you first call `useRequestSocialAnalyticsRefreshMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestSocialAnalyticsRefreshMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestSocialAnalyticsRefreshMutation, { data, loading, error }] = useRequestSocialAnalyticsRefreshMutation({
 *   variables: {
 *      socialConnectionIds: // value for 'socialConnectionIds'
 *   },
 * });
 */
export function useRequestSocialAnalyticsRefreshMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<RequestSocialAnalyticsRefreshMutation, RequestSocialAnalyticsRefreshMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<RequestSocialAnalyticsRefreshMutation, RequestSocialAnalyticsRefreshMutationVariables>(RequestSocialAnalyticsRefreshDocument, options);
      }
export type RequestSocialAnalyticsRefreshMutationHookResult = ReturnType<typeof useRequestSocialAnalyticsRefreshMutation>;
export type RequestSocialAnalyticsRefreshMutationResult = Apollo.MutationResult<RequestSocialAnalyticsRefreshMutation>;
export type RequestSocialAnalyticsRefreshMutationOptions = Apollo.BaseMutationOptions<RequestSocialAnalyticsRefreshMutation, RequestSocialAnalyticsRefreshMutationVariables>;
export const SocialAnalyticsInsightsDocument = gql`
    query SocialAnalyticsInsights($range: SocialAnalyticsRange, $platforms: [String!], $socialConnectionIds: [ID!], $timezone: String!) {
  socialAnalyticsInsights(
    range: $range
    platforms: $platforms
    socialConnectionIds: $socialConnectionIds
    timezone: $timezone
  ) {
    eligible_posts
    min_post_age_days
    formats {
      media_type
      posts
      median_views
    }
    hourly_slots {
      weekday
      hour
      posts
      median_views
    }
  }
}
    `;

/**
 * __useSocialAnalyticsInsightsQuery__
 *
 * To run a query within a React component, call `useSocialAnalyticsInsightsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSocialAnalyticsInsightsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSocialAnalyticsInsightsQuery({
 *   variables: {
 *      range: // value for 'range'
 *      platforms: // value for 'platforms'
 *      socialConnectionIds: // value for 'socialConnectionIds'
 *      timezone: // value for 'timezone'
 *   },
 * });
 */
export function useSocialAnalyticsInsightsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<SocialAnalyticsInsightsQuery, SocialAnalyticsInsightsQueryVariables> & ({ variables: SocialAnalyticsInsightsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SocialAnalyticsInsightsQuery, SocialAnalyticsInsightsQueryVariables>(SocialAnalyticsInsightsDocument, options);
      }
export function useSocialAnalyticsInsightsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SocialAnalyticsInsightsQuery, SocialAnalyticsInsightsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SocialAnalyticsInsightsQuery, SocialAnalyticsInsightsQueryVariables>(SocialAnalyticsInsightsDocument, options);
        }
// @ts-ignore
export function useSocialAnalyticsInsightsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<SocialAnalyticsInsightsQuery, SocialAnalyticsInsightsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SocialAnalyticsInsightsQuery, SocialAnalyticsInsightsQueryVariables>;
export function useSocialAnalyticsInsightsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SocialAnalyticsInsightsQuery, SocialAnalyticsInsightsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SocialAnalyticsInsightsQuery | undefined, SocialAnalyticsInsightsQueryVariables>;
export function useSocialAnalyticsInsightsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SocialAnalyticsInsightsQuery, SocialAnalyticsInsightsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<SocialAnalyticsInsightsQuery, SocialAnalyticsInsightsQueryVariables>(SocialAnalyticsInsightsDocument, options);
        }
export type SocialAnalyticsInsightsQueryHookResult = ReturnType<typeof useSocialAnalyticsInsightsQuery>;
export type SocialAnalyticsInsightsLazyQueryHookResult = ReturnType<typeof useSocialAnalyticsInsightsLazyQuery>;
export type SocialAnalyticsInsightsSuspenseQueryHookResult = ReturnType<typeof useSocialAnalyticsInsightsSuspenseQuery>;
export type SocialAnalyticsInsightsQueryResult = Apollo.QueryResult<SocialAnalyticsInsightsQuery, SocialAnalyticsInsightsQueryVariables>;
export const SocialAnalyticsMediaHistoryDocument = gql`
    query SocialAnalyticsMediaHistory($mediaId: ID!) {
  socialAnalyticsMediaHistory(mediaId: $mediaId) {
    date
    views
    likes
    comments
    shares
  }
}
    `;

/**
 * __useSocialAnalyticsMediaHistoryQuery__
 *
 * To run a query within a React component, call `useSocialAnalyticsMediaHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useSocialAnalyticsMediaHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSocialAnalyticsMediaHistoryQuery({
 *   variables: {
 *      mediaId: // value for 'mediaId'
 *   },
 * });
 */
export function useSocialAnalyticsMediaHistoryQuery(baseOptions: ApolloReactHooks.QueryHookOptions<SocialAnalyticsMediaHistoryQuery, SocialAnalyticsMediaHistoryQueryVariables> & ({ variables: SocialAnalyticsMediaHistoryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SocialAnalyticsMediaHistoryQuery, SocialAnalyticsMediaHistoryQueryVariables>(SocialAnalyticsMediaHistoryDocument, options);
      }
export function useSocialAnalyticsMediaHistoryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SocialAnalyticsMediaHistoryQuery, SocialAnalyticsMediaHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SocialAnalyticsMediaHistoryQuery, SocialAnalyticsMediaHistoryQueryVariables>(SocialAnalyticsMediaHistoryDocument, options);
        }
// @ts-ignore
export function useSocialAnalyticsMediaHistorySuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<SocialAnalyticsMediaHistoryQuery, SocialAnalyticsMediaHistoryQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SocialAnalyticsMediaHistoryQuery, SocialAnalyticsMediaHistoryQueryVariables>;
export function useSocialAnalyticsMediaHistorySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SocialAnalyticsMediaHistoryQuery, SocialAnalyticsMediaHistoryQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SocialAnalyticsMediaHistoryQuery | undefined, SocialAnalyticsMediaHistoryQueryVariables>;
export function useSocialAnalyticsMediaHistorySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SocialAnalyticsMediaHistoryQuery, SocialAnalyticsMediaHistoryQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<SocialAnalyticsMediaHistoryQuery, SocialAnalyticsMediaHistoryQueryVariables>(SocialAnalyticsMediaHistoryDocument, options);
        }
export type SocialAnalyticsMediaHistoryQueryHookResult = ReturnType<typeof useSocialAnalyticsMediaHistoryQuery>;
export type SocialAnalyticsMediaHistoryLazyQueryHookResult = ReturnType<typeof useSocialAnalyticsMediaHistoryLazyQuery>;
export type SocialAnalyticsMediaHistorySuspenseQueryHookResult = ReturnType<typeof useSocialAnalyticsMediaHistorySuspenseQuery>;
export type SocialAnalyticsMediaHistoryQueryResult = Apollo.QueryResult<SocialAnalyticsMediaHistoryQuery, SocialAnalyticsMediaHistoryQueryVariables>;
export const AdminSetFacebookConnectionsAccessDocument = gql`
    mutation AdminSetFacebookConnectionsAccess($userId: ID!, $enabled: Boolean!) {
  adminSetFacebookConnectionsAccess(userId: $userId, enabled: $enabled)
}
    `;
export type AdminSetFacebookConnectionsAccessMutationFn = Apollo.MutationFunction<AdminSetFacebookConnectionsAccessMutation, AdminSetFacebookConnectionsAccessMutationVariables>;

/**
 * __useAdminSetFacebookConnectionsAccessMutation__
 *
 * To run a mutation, you first call `useAdminSetFacebookConnectionsAccessMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminSetFacebookConnectionsAccessMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminSetFacebookConnectionsAccessMutation, { data, loading, error }] = useAdminSetFacebookConnectionsAccessMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      enabled: // value for 'enabled'
 *   },
 * });
 */
export function useAdminSetFacebookConnectionsAccessMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AdminSetFacebookConnectionsAccessMutation, AdminSetFacebookConnectionsAccessMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AdminSetFacebookConnectionsAccessMutation, AdminSetFacebookConnectionsAccessMutationVariables>(AdminSetFacebookConnectionsAccessDocument, options);
      }
export type AdminSetFacebookConnectionsAccessMutationHookResult = ReturnType<typeof useAdminSetFacebookConnectionsAccessMutation>;
export type AdminSetFacebookConnectionsAccessMutationResult = Apollo.MutationResult<AdminSetFacebookConnectionsAccessMutation>;
export type AdminSetFacebookConnectionsAccessMutationOptions = Apollo.BaseMutationOptions<AdminSetFacebookConnectionsAccessMutation, AdminSetFacebookConnectionsAccessMutationVariables>;
export const SoundEffectsDocument = gql`
    query SoundEffects($query: String, $category: String, $locale: String, $limit: Int) {
  soundEffects(query: $query, category: $category, locale: $locale, limit: $limit) {
    id
    category
    name
    tags
    duration
    peak_at
    url
  }
}
    `;

/**
 * __useSoundEffectsQuery__
 *
 * To run a query within a React component, call `useSoundEffectsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSoundEffectsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSoundEffectsQuery({
 *   variables: {
 *      query: // value for 'query'
 *      category: // value for 'category'
 *      locale: // value for 'locale'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useSoundEffectsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<SoundEffectsQuery, SoundEffectsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SoundEffectsQuery, SoundEffectsQueryVariables>(SoundEffectsDocument, options);
      }
export function useSoundEffectsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SoundEffectsQuery, SoundEffectsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SoundEffectsQuery, SoundEffectsQueryVariables>(SoundEffectsDocument, options);
        }
// @ts-ignore
export function useSoundEffectsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<SoundEffectsQuery, SoundEffectsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SoundEffectsQuery, SoundEffectsQueryVariables>;
export function useSoundEffectsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SoundEffectsQuery, SoundEffectsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SoundEffectsQuery | undefined, SoundEffectsQueryVariables>;
export function useSoundEffectsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SoundEffectsQuery, SoundEffectsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<SoundEffectsQuery, SoundEffectsQueryVariables>(SoundEffectsDocument, options);
        }
export type SoundEffectsQueryHookResult = ReturnType<typeof useSoundEffectsQuery>;
export type SoundEffectsLazyQueryHookResult = ReturnType<typeof useSoundEffectsLazyQuery>;
export type SoundEffectsSuspenseQueryHookResult = ReturnType<typeof useSoundEffectsSuspenseQuery>;
export type SoundEffectsQueryResult = Apollo.QueryResult<SoundEffectsQuery, SoundEffectsQueryVariables>;
export const BrowseSoundEffectsDocument = gql`
    query BrowseSoundEffects($query: String, $category: String, $region: String, $locale: String, $limit: Int, $offset: Int) {
  browseSoundEffects(
    query: $query
    category: $category
    region: $region
    locale: $locale
    limit: $limit
    offset: $offset
  ) {
    items {
      id
      category
      name
      tags
      duration
      peak_at
      url
    }
    total
    has_more
  }
}
    `;

/**
 * __useBrowseSoundEffectsQuery__
 *
 * To run a query within a React component, call `useBrowseSoundEffectsQuery` and pass it any options that fit your needs.
 * When your component renders, `useBrowseSoundEffectsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBrowseSoundEffectsQuery({
 *   variables: {
 *      query: // value for 'query'
 *      category: // value for 'category'
 *      region: // value for 'region'
 *      locale: // value for 'locale'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useBrowseSoundEffectsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<BrowseSoundEffectsQuery, BrowseSoundEffectsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<BrowseSoundEffectsQuery, BrowseSoundEffectsQueryVariables>(BrowseSoundEffectsDocument, options);
      }
export function useBrowseSoundEffectsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<BrowseSoundEffectsQuery, BrowseSoundEffectsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<BrowseSoundEffectsQuery, BrowseSoundEffectsQueryVariables>(BrowseSoundEffectsDocument, options);
        }
// @ts-ignore
export function useBrowseSoundEffectsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<BrowseSoundEffectsQuery, BrowseSoundEffectsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<BrowseSoundEffectsQuery, BrowseSoundEffectsQueryVariables>;
export function useBrowseSoundEffectsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<BrowseSoundEffectsQuery, BrowseSoundEffectsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<BrowseSoundEffectsQuery | undefined, BrowseSoundEffectsQueryVariables>;
export function useBrowseSoundEffectsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<BrowseSoundEffectsQuery, BrowseSoundEffectsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<BrowseSoundEffectsQuery, BrowseSoundEffectsQueryVariables>(BrowseSoundEffectsDocument, options);
        }
export type BrowseSoundEffectsQueryHookResult = ReturnType<typeof useBrowseSoundEffectsQuery>;
export type BrowseSoundEffectsLazyQueryHookResult = ReturnType<typeof useBrowseSoundEffectsLazyQuery>;
export type BrowseSoundEffectsSuspenseQueryHookResult = ReturnType<typeof useBrowseSoundEffectsSuspenseQuery>;
export type BrowseSoundEffectsQueryResult = Apollo.QueryResult<BrowseSoundEffectsQuery, BrowseSoundEffectsQueryVariables>;
export const TemplateSuggestionsDocument = gql`
    query TemplateSuggestions($status: String, $sort: String, $limit: Int, $offset: Int) {
  templateSuggestions(
    status: $status
    sort: $sort
    limit: $limit
    offset: $offset
  ) {
    data {
      viewer_has_voted
    }
    total
    pageCount
  }
}
    `;

/**
 * __useTemplateSuggestionsQuery__
 *
 * To run a query within a React component, call `useTemplateSuggestionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTemplateSuggestionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTemplateSuggestionsQuery({
 *   variables: {
 *      status: // value for 'status'
 *      sort: // value for 'sort'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useTemplateSuggestionsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<TemplateSuggestionsQuery, TemplateSuggestionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TemplateSuggestionsQuery, TemplateSuggestionsQueryVariables>(TemplateSuggestionsDocument, options);
      }
export function useTemplateSuggestionsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TemplateSuggestionsQuery, TemplateSuggestionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TemplateSuggestionsQuery, TemplateSuggestionsQueryVariables>(TemplateSuggestionsDocument, options);
        }
// @ts-ignore
export function useTemplateSuggestionsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<TemplateSuggestionsQuery, TemplateSuggestionsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<TemplateSuggestionsQuery, TemplateSuggestionsQueryVariables>;
export function useTemplateSuggestionsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<TemplateSuggestionsQuery, TemplateSuggestionsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<TemplateSuggestionsQuery | undefined, TemplateSuggestionsQueryVariables>;
export function useTemplateSuggestionsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<TemplateSuggestionsQuery, TemplateSuggestionsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<TemplateSuggestionsQuery, TemplateSuggestionsQueryVariables>(TemplateSuggestionsDocument, options);
        }
export type TemplateSuggestionsQueryHookResult = ReturnType<typeof useTemplateSuggestionsQuery>;
export type TemplateSuggestionsLazyQueryHookResult = ReturnType<typeof useTemplateSuggestionsLazyQuery>;
export type TemplateSuggestionsSuspenseQueryHookResult = ReturnType<typeof useTemplateSuggestionsSuspenseQuery>;
export type TemplateSuggestionsQueryResult = Apollo.QueryResult<TemplateSuggestionsQuery, TemplateSuggestionsQueryVariables>;
export const MyTemplateSuggestionsDocument = gql`
    query MyTemplateSuggestions {
  myTemplateSuggestions {
    review_reason
    reviewed_at
  }
}
    `;

/**
 * __useMyTemplateSuggestionsQuery__
 *
 * To run a query within a React component, call `useMyTemplateSuggestionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyTemplateSuggestionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyTemplateSuggestionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useMyTemplateSuggestionsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<MyTemplateSuggestionsQuery, MyTemplateSuggestionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<MyTemplateSuggestionsQuery, MyTemplateSuggestionsQueryVariables>(MyTemplateSuggestionsDocument, options);
      }
export function useMyTemplateSuggestionsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<MyTemplateSuggestionsQuery, MyTemplateSuggestionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<MyTemplateSuggestionsQuery, MyTemplateSuggestionsQueryVariables>(MyTemplateSuggestionsDocument, options);
        }
// @ts-ignore
export function useMyTemplateSuggestionsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<MyTemplateSuggestionsQuery, MyTemplateSuggestionsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<MyTemplateSuggestionsQuery, MyTemplateSuggestionsQueryVariables>;
export function useMyTemplateSuggestionsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<MyTemplateSuggestionsQuery, MyTemplateSuggestionsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<MyTemplateSuggestionsQuery | undefined, MyTemplateSuggestionsQueryVariables>;
export function useMyTemplateSuggestionsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<MyTemplateSuggestionsQuery, MyTemplateSuggestionsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<MyTemplateSuggestionsQuery, MyTemplateSuggestionsQueryVariables>(MyTemplateSuggestionsDocument, options);
        }
export type MyTemplateSuggestionsQueryHookResult = ReturnType<typeof useMyTemplateSuggestionsQuery>;
export type MyTemplateSuggestionsLazyQueryHookResult = ReturnType<typeof useMyTemplateSuggestionsLazyQuery>;
export type MyTemplateSuggestionsSuspenseQueryHookResult = ReturnType<typeof useMyTemplateSuggestionsSuspenseQuery>;
export type MyTemplateSuggestionsQueryResult = Apollo.QueryResult<MyTemplateSuggestionsQuery, MyTemplateSuggestionsQueryVariables>;
export const CreateMyTemplateSuggestionDocument = gql`
    mutation CreateMyTemplateSuggestion($input: TemplateSuggestionInput!) {
  createMyTemplateSuggestion(input: $input) {
    created {
      review_reason
      reviewed_at
    }
    duplicate {
      viewer_has_voted
    }
    duplicate_hidden
  }
}
    `;
export type CreateMyTemplateSuggestionMutationFn = Apollo.MutationFunction<CreateMyTemplateSuggestionMutation, CreateMyTemplateSuggestionMutationVariables>;

/**
 * __useCreateMyTemplateSuggestionMutation__
 *
 * To run a mutation, you first call `useCreateMyTemplateSuggestionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMyTemplateSuggestionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMyTemplateSuggestionMutation, { data, loading, error }] = useCreateMyTemplateSuggestionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateMyTemplateSuggestionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateMyTemplateSuggestionMutation, CreateMyTemplateSuggestionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateMyTemplateSuggestionMutation, CreateMyTemplateSuggestionMutationVariables>(CreateMyTemplateSuggestionDocument, options);
      }
export type CreateMyTemplateSuggestionMutationHookResult = ReturnType<typeof useCreateMyTemplateSuggestionMutation>;
export type CreateMyTemplateSuggestionMutationResult = Apollo.MutationResult<CreateMyTemplateSuggestionMutation>;
export type CreateMyTemplateSuggestionMutationOptions = Apollo.BaseMutationOptions<CreateMyTemplateSuggestionMutation, CreateMyTemplateSuggestionMutationVariables>;
export const VoteTemplateSuggestionDocument = gql`
    mutation VoteTemplateSuggestion($id: ID!) {
  voteTemplateSuggestion(id: $id) {
    viewer_has_voted
  }
}
    `;
export type VoteTemplateSuggestionMutationFn = Apollo.MutationFunction<VoteTemplateSuggestionMutation, VoteTemplateSuggestionMutationVariables>;

/**
 * __useVoteTemplateSuggestionMutation__
 *
 * To run a mutation, you first call `useVoteTemplateSuggestionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVoteTemplateSuggestionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [voteTemplateSuggestionMutation, { data, loading, error }] = useVoteTemplateSuggestionMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useVoteTemplateSuggestionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<VoteTemplateSuggestionMutation, VoteTemplateSuggestionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<VoteTemplateSuggestionMutation, VoteTemplateSuggestionMutationVariables>(VoteTemplateSuggestionDocument, options);
      }
export type VoteTemplateSuggestionMutationHookResult = ReturnType<typeof useVoteTemplateSuggestionMutation>;
export type VoteTemplateSuggestionMutationResult = Apollo.MutationResult<VoteTemplateSuggestionMutation>;
export type VoteTemplateSuggestionMutationOptions = Apollo.BaseMutationOptions<VoteTemplateSuggestionMutation, VoteTemplateSuggestionMutationVariables>;
export const UnvoteTemplateSuggestionDocument = gql`
    mutation UnvoteTemplateSuggestion($id: ID!) {
  unvoteTemplateSuggestion(id: $id) {
    viewer_has_voted
  }
}
    `;
export type UnvoteTemplateSuggestionMutationFn = Apollo.MutationFunction<UnvoteTemplateSuggestionMutation, UnvoteTemplateSuggestionMutationVariables>;

/**
 * __useUnvoteTemplateSuggestionMutation__
 *
 * To run a mutation, you first call `useUnvoteTemplateSuggestionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnvoteTemplateSuggestionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unvoteTemplateSuggestionMutation, { data, loading, error }] = useUnvoteTemplateSuggestionMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUnvoteTemplateSuggestionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UnvoteTemplateSuggestionMutation, UnvoteTemplateSuggestionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UnvoteTemplateSuggestionMutation, UnvoteTemplateSuggestionMutationVariables>(UnvoteTemplateSuggestionDocument, options);
      }
export type UnvoteTemplateSuggestionMutationHookResult = ReturnType<typeof useUnvoteTemplateSuggestionMutation>;
export type UnvoteTemplateSuggestionMutationResult = Apollo.MutationResult<UnvoteTemplateSuggestionMutation>;
export type UnvoteTemplateSuggestionMutationOptions = Apollo.BaseMutationOptions<UnvoteTemplateSuggestionMutation, UnvoteTemplateSuggestionMutationVariables>;
export const AdminTemplateSuggestionsDocument = gql`
    query AdminTemplateSuggestions($status: String, $search: String, $limit: Int, $offset: Int) {
  adminTemplateSuggestions(
    status: $status
    search: $search
    limit: $limit
    offset: $offset
  ) {
    data {
      review_reason
      reviewed_at
      user_id
      user_email
      user_name
      reviewed_by_id
      reviewed_by_name
    }
    total
    pageCount
  }
}
    `;

/**
 * __useAdminTemplateSuggestionsQuery__
 *
 * To run a query within a React component, call `useAdminTemplateSuggestionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminTemplateSuggestionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminTemplateSuggestionsQuery({
 *   variables: {
 *      status: // value for 'status'
 *      search: // value for 'search'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useAdminTemplateSuggestionsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<AdminTemplateSuggestionsQuery, AdminTemplateSuggestionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AdminTemplateSuggestionsQuery, AdminTemplateSuggestionsQueryVariables>(AdminTemplateSuggestionsDocument, options);
      }
export function useAdminTemplateSuggestionsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AdminTemplateSuggestionsQuery, AdminTemplateSuggestionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AdminTemplateSuggestionsQuery, AdminTemplateSuggestionsQueryVariables>(AdminTemplateSuggestionsDocument, options);
        }
// @ts-ignore
export function useAdminTemplateSuggestionsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<AdminTemplateSuggestionsQuery, AdminTemplateSuggestionsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AdminTemplateSuggestionsQuery, AdminTemplateSuggestionsQueryVariables>;
export function useAdminTemplateSuggestionsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AdminTemplateSuggestionsQuery, AdminTemplateSuggestionsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AdminTemplateSuggestionsQuery | undefined, AdminTemplateSuggestionsQueryVariables>;
export function useAdminTemplateSuggestionsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AdminTemplateSuggestionsQuery, AdminTemplateSuggestionsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<AdminTemplateSuggestionsQuery, AdminTemplateSuggestionsQueryVariables>(AdminTemplateSuggestionsDocument, options);
        }
export type AdminTemplateSuggestionsQueryHookResult = ReturnType<typeof useAdminTemplateSuggestionsQuery>;
export type AdminTemplateSuggestionsLazyQueryHookResult = ReturnType<typeof useAdminTemplateSuggestionsLazyQuery>;
export type AdminTemplateSuggestionsSuspenseQueryHookResult = ReturnType<typeof useAdminTemplateSuggestionsSuspenseQuery>;
export type AdminTemplateSuggestionsQueryResult = Apollo.QueryResult<AdminTemplateSuggestionsQuery, AdminTemplateSuggestionsQueryVariables>;
export const AdminReviewTemplateSuggestionDocument = gql`
    mutation AdminReviewTemplateSuggestion($id: ID!, $status: String!, $reason: String, $brandKitId: ID) {
  adminReviewTemplateSuggestion(
    id: $id
    status: $status
    reason: $reason
    brandKitId: $brandKitId
  ) {
    review_reason
    reviewed_at
    user_id
    user_email
    user_name
    reviewed_by_id
    reviewed_by_name
  }
}
    `;
export type AdminReviewTemplateSuggestionMutationFn = Apollo.MutationFunction<AdminReviewTemplateSuggestionMutation, AdminReviewTemplateSuggestionMutationVariables>;

/**
 * __useAdminReviewTemplateSuggestionMutation__
 *
 * To run a mutation, you first call `useAdminReviewTemplateSuggestionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminReviewTemplateSuggestionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminReviewTemplateSuggestionMutation, { data, loading, error }] = useAdminReviewTemplateSuggestionMutation({
 *   variables: {
 *      id: // value for 'id'
 *      status: // value for 'status'
 *      reason: // value for 'reason'
 *      brandKitId: // value for 'brandKitId'
 *   },
 * });
 */
export function useAdminReviewTemplateSuggestionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AdminReviewTemplateSuggestionMutation, AdminReviewTemplateSuggestionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AdminReviewTemplateSuggestionMutation, AdminReviewTemplateSuggestionMutationVariables>(AdminReviewTemplateSuggestionDocument, options);
      }
export type AdminReviewTemplateSuggestionMutationHookResult = ReturnType<typeof useAdminReviewTemplateSuggestionMutation>;
export type AdminReviewTemplateSuggestionMutationResult = Apollo.MutationResult<AdminReviewTemplateSuggestionMutation>;
export type AdminReviewTemplateSuggestionMutationOptions = Apollo.BaseMutationOptions<AdminReviewTemplateSuggestionMutation, AdminReviewTemplateSuggestionMutationVariables>;
export const MyViralizeQualificationDocument = gql`
    query MyViralizeQualification {
  myViralizeQualification {
    id
    motivation
    starting_difficulty
    equipment
    monthly_income
    clipper_experience
    could_earn_more
    financially_stuck
    likes_current_job
    wants_remote_mobile_work
    self_employment_outlook
    first_30_day_revenue_outlook
    completed_at
  }
}
    `;

/**
 * __useMyViralizeQualificationQuery__
 *
 * To run a query within a React component, call `useMyViralizeQualificationQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyViralizeQualificationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyViralizeQualificationQuery({
 *   variables: {
 *   },
 * });
 */
export function useMyViralizeQualificationQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<MyViralizeQualificationQuery, MyViralizeQualificationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<MyViralizeQualificationQuery, MyViralizeQualificationQueryVariables>(MyViralizeQualificationDocument, options);
      }
export function useMyViralizeQualificationLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<MyViralizeQualificationQuery, MyViralizeQualificationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<MyViralizeQualificationQuery, MyViralizeQualificationQueryVariables>(MyViralizeQualificationDocument, options);
        }
// @ts-ignore
export function useMyViralizeQualificationSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<MyViralizeQualificationQuery, MyViralizeQualificationQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<MyViralizeQualificationQuery, MyViralizeQualificationQueryVariables>;
export function useMyViralizeQualificationSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<MyViralizeQualificationQuery, MyViralizeQualificationQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<MyViralizeQualificationQuery | undefined, MyViralizeQualificationQueryVariables>;
export function useMyViralizeQualificationSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<MyViralizeQualificationQuery, MyViralizeQualificationQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<MyViralizeQualificationQuery, MyViralizeQualificationQueryVariables>(MyViralizeQualificationDocument, options);
        }
export type MyViralizeQualificationQueryHookResult = ReturnType<typeof useMyViralizeQualificationQuery>;
export type MyViralizeQualificationLazyQueryHookResult = ReturnType<typeof useMyViralizeQualificationLazyQuery>;
export type MyViralizeQualificationSuspenseQueryHookResult = ReturnType<typeof useMyViralizeQualificationSuspenseQuery>;
export type MyViralizeQualificationQueryResult = Apollo.QueryResult<MyViralizeQualificationQuery, MyViralizeQualificationQueryVariables>;
export const SaveMyViralizeQualificationAnswerDocument = gql`
    mutation SaveMyViralizeQualificationAnswer($input: SaveMyViralizeQualificationAnswerInput!) {
  saveMyViralizeQualificationAnswer(input: $input) {
    id
    motivation
    starting_difficulty
    equipment
    monthly_income
    clipper_experience
    could_earn_more
    financially_stuck
    likes_current_job
    wants_remote_mobile_work
    self_employment_outlook
    first_30_day_revenue_outlook
    completed_at
  }
}
    `;
export type SaveMyViralizeQualificationAnswerMutationFn = Apollo.MutationFunction<SaveMyViralizeQualificationAnswerMutation, SaveMyViralizeQualificationAnswerMutationVariables>;

/**
 * __useSaveMyViralizeQualificationAnswerMutation__
 *
 * To run a mutation, you first call `useSaveMyViralizeQualificationAnswerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveMyViralizeQualificationAnswerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveMyViralizeQualificationAnswerMutation, { data, loading, error }] = useSaveMyViralizeQualificationAnswerMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveMyViralizeQualificationAnswerMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SaveMyViralizeQualificationAnswerMutation, SaveMyViralizeQualificationAnswerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SaveMyViralizeQualificationAnswerMutation, SaveMyViralizeQualificationAnswerMutationVariables>(SaveMyViralizeQualificationAnswerDocument, options);
      }
export type SaveMyViralizeQualificationAnswerMutationHookResult = ReturnType<typeof useSaveMyViralizeQualificationAnswerMutation>;
export type SaveMyViralizeQualificationAnswerMutationResult = Apollo.MutationResult<SaveMyViralizeQualificationAnswerMutation>;
export type SaveMyViralizeQualificationAnswerMutationOptions = Apollo.BaseMutationOptions<SaveMyViralizeQualificationAnswerMutation, SaveMyViralizeQualificationAnswerMutationVariables>;
export const SaveMyViralizeQualificationContactDocument = gql`
    mutation SaveMyViralizeQualificationContact($name: String, $phoneDetails: CoursePurchasePhoneInput) {
  saveMyViralizeQualificationContact(name: $name, phoneDetails: $phoneDetails) {
    id
    name
    phone_number
  }
}
    `;
export type SaveMyViralizeQualificationContactMutationFn = Apollo.MutationFunction<SaveMyViralizeQualificationContactMutation, SaveMyViralizeQualificationContactMutationVariables>;

/**
 * __useSaveMyViralizeQualificationContactMutation__
 *
 * To run a mutation, you first call `useSaveMyViralizeQualificationContactMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveMyViralizeQualificationContactMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveMyViralizeQualificationContactMutation, { data, loading, error }] = useSaveMyViralizeQualificationContactMutation({
 *   variables: {
 *      name: // value for 'name'
 *      phoneDetails: // value for 'phoneDetails'
 *   },
 * });
 */
export function useSaveMyViralizeQualificationContactMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SaveMyViralizeQualificationContactMutation, SaveMyViralizeQualificationContactMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SaveMyViralizeQualificationContactMutation, SaveMyViralizeQualificationContactMutationVariables>(SaveMyViralizeQualificationContactDocument, options);
      }
export type SaveMyViralizeQualificationContactMutationHookResult = ReturnType<typeof useSaveMyViralizeQualificationContactMutation>;
export type SaveMyViralizeQualificationContactMutationResult = Apollo.MutationResult<SaveMyViralizeQualificationContactMutation>;
export type SaveMyViralizeQualificationContactMutationOptions = Apollo.BaseMutationOptions<SaveMyViralizeQualificationContactMutation, SaveMyViralizeQualificationContactMutationVariables>;
export const MyWalletMonthlyEarningsDocument = gql`
    query MyWalletMonthlyEarnings($months: Int) {
  myWalletMonthlyEarnings(months: $months) {
    currency
    months {
      month
      clips_cents
      affiliate_cents
      producer_cents
      total_cents
    }
  }
}
    `;

/**
 * __useMyWalletMonthlyEarningsQuery__
 *
 * To run a query within a React component, call `useMyWalletMonthlyEarningsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyWalletMonthlyEarningsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyWalletMonthlyEarningsQuery({
 *   variables: {
 *      months: // value for 'months'
 *   },
 * });
 */
export function useMyWalletMonthlyEarningsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<MyWalletMonthlyEarningsQuery, MyWalletMonthlyEarningsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<MyWalletMonthlyEarningsQuery, MyWalletMonthlyEarningsQueryVariables>(MyWalletMonthlyEarningsDocument, options);
      }
export function useMyWalletMonthlyEarningsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<MyWalletMonthlyEarningsQuery, MyWalletMonthlyEarningsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<MyWalletMonthlyEarningsQuery, MyWalletMonthlyEarningsQueryVariables>(MyWalletMonthlyEarningsDocument, options);
        }
// @ts-ignore
export function useMyWalletMonthlyEarningsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<MyWalletMonthlyEarningsQuery, MyWalletMonthlyEarningsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<MyWalletMonthlyEarningsQuery, MyWalletMonthlyEarningsQueryVariables>;
export function useMyWalletMonthlyEarningsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<MyWalletMonthlyEarningsQuery, MyWalletMonthlyEarningsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<MyWalletMonthlyEarningsQuery | undefined, MyWalletMonthlyEarningsQueryVariables>;
export function useMyWalletMonthlyEarningsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<MyWalletMonthlyEarningsQuery, MyWalletMonthlyEarningsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<MyWalletMonthlyEarningsQuery, MyWalletMonthlyEarningsQueryVariables>(MyWalletMonthlyEarningsDocument, options);
        }
export type MyWalletMonthlyEarningsQueryHookResult = ReturnType<typeof useMyWalletMonthlyEarningsQuery>;
export type MyWalletMonthlyEarningsLazyQueryHookResult = ReturnType<typeof useMyWalletMonthlyEarningsLazyQuery>;
export type MyWalletMonthlyEarningsSuspenseQueryHookResult = ReturnType<typeof useMyWalletMonthlyEarningsSuspenseQuery>;
export type MyWalletMonthlyEarningsQueryResult = Apollo.QueryResult<MyWalletMonthlyEarningsQuery, MyWalletMonthlyEarningsQueryVariables>;
export const MyWalletStatementDocument = gql`
    query MyWalletStatement($from: String, $to: String) {
  myWalletStatement(from: $from, to: $to) {
    from
    to
    today
    opening_balance_cents
    current_balance_cents
    first_snapshot_day
    upcoming {
      ...WalletStatementLineFields
    }
    days {
      day
      closing_balance_cents
      lines {
        ...WalletStatementLineFields
      }
    }
  }
}
    ${WalletStatementLineFieldsFragmentDoc}`;

/**
 * __useMyWalletStatementQuery__
 *
 * To run a query within a React component, call `useMyWalletStatementQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyWalletStatementQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyWalletStatementQuery({
 *   variables: {
 *      from: // value for 'from'
 *      to: // value for 'to'
 *   },
 * });
 */
export function useMyWalletStatementQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<MyWalletStatementQuery, MyWalletStatementQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<MyWalletStatementQuery, MyWalletStatementQueryVariables>(MyWalletStatementDocument, options);
      }
export function useMyWalletStatementLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<MyWalletStatementQuery, MyWalletStatementQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<MyWalletStatementQuery, MyWalletStatementQueryVariables>(MyWalletStatementDocument, options);
        }
// @ts-ignore
export function useMyWalletStatementSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<MyWalletStatementQuery, MyWalletStatementQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<MyWalletStatementQuery, MyWalletStatementQueryVariables>;
export function useMyWalletStatementSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<MyWalletStatementQuery, MyWalletStatementQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<MyWalletStatementQuery | undefined, MyWalletStatementQueryVariables>;
export function useMyWalletStatementSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<MyWalletStatementQuery, MyWalletStatementQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<MyWalletStatementQuery, MyWalletStatementQueryVariables>(MyWalletStatementDocument, options);
        }
export type MyWalletStatementQueryHookResult = ReturnType<typeof useMyWalletStatementQuery>;
export type MyWalletStatementLazyQueryHookResult = ReturnType<typeof useMyWalletStatementLazyQuery>;
export type MyWalletStatementSuspenseQueryHookResult = ReturnType<typeof useMyWalletStatementSuspenseQuery>;
export type MyWalletStatementQueryResult = Apollo.QueryResult<MyWalletStatementQuery, MyWalletStatementQueryVariables>;